webpackJsonp([89],Array(26).concat([
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EffectScope */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return computed; });
/* unused harmony export createApp */
/* unused harmony export createRef */
/* unused harmony export customRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Plugin; });
/* unused harmony export defineAsyncComponent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defineComponent; });
/* unused harmony export del */
/* unused harmony export effectScope */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCurrentInstance; });
/* unused harmony export getCurrentScope */
/* unused harmony export h */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return inject; });
/* unused harmony export isRaw */
/* unused harmony export isReactive */
/* unused harmony export isReadonly */
/* unused harmony export isRef */
/* unused harmony export markRaw */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return nextTick; });
/* unused harmony export onActivated */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return onBeforeMount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return onBeforeUnmount; });
/* unused harmony export onBeforeUpdate */
/* unused harmony export onDeactivated */
/* unused harmony export onErrorCaptured */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return onMounted; });
/* unused harmony export onScopeDispose */
/* unused harmony export onServerPrefetch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return onUnmounted; });
/* unused harmony export onUpdated */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return provide; });
/* unused harmony export proxyRefs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return reactive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return readonly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ref; });
/* unused harmony export set */
/* unused harmony export shallowReactive */
/* unused harmony export shallowReadonly */
/* unused harmony export shallowRef */
/* unused harmony export toRaw */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return toRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return toRefs; });
/* unused harmony export triggerRef */
/* unused harmony export unref */
/* unused harmony export useAttrs */
/* unused harmony export useCSSModule */
/* unused harmony export useCssModule */
/* unused harmony export useSlots */
/* unused harmony export version */
/* unused harmony export warn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return watch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return watchEffect; });
/* unused harmony export watchPostEffect */
/* unused harmony export watchSyncEffect */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

/**
 * Displays a warning message (using console.error) with a stack trace if the
 * function is called inside of active component.
 *
 * @param message warning message to be displayed
 */
function warn$1(message) {
    var _a;
    warn(message, (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy);
}

var activeEffectScope;
var effectScopeStack = [];
var EffectScopeImpl = /** @class */ (function () {
    function EffectScopeImpl(vm) {
        this.active = true;
        this.effects = [];
        this.cleanups = [];
        this.vm = vm;
    }
    EffectScopeImpl.prototype.run = function (fn) {
        if (this.active) {
            try {
                this.on();
                return fn();
            }
            finally {
                this.off();
            }
        }
        else if ((false)) {
            warn$1("cannot run an inactive effect scope.");
        }
        return;
    };
    EffectScopeImpl.prototype.on = function () {
        if (this.active) {
            effectScopeStack.push(this);
            activeEffectScope = this;
        }
    };
    EffectScopeImpl.prototype.off = function () {
        if (this.active) {
            effectScopeStack.pop();
            activeEffectScope = effectScopeStack[effectScopeStack.length - 1];
        }
    };
    EffectScopeImpl.prototype.stop = function () {
        if (this.active) {
            this.vm.$destroy();
            this.effects.forEach(function (e) { return e.stop(); });
            this.cleanups.forEach(function (cleanup) { return cleanup(); });
            this.active = false;
        }
    };
    return EffectScopeImpl;
}());
var EffectScope = /** @class */ (function (_super) {
    __extends(EffectScope, _super);
    function EffectScope(detached) {
        if (detached === void 0) { detached = false; }
        var _this = this;
        var vm = undefined;
        withCurrentInstanceTrackingDisabled(function () {
            vm = defineComponentInstance(getVueConstructor());
        });
        _this = _super.call(this, vm) || this;
        if (!detached) {
            recordEffectScope(_this);
        }
        return _this;
    }
    return EffectScope;
}(EffectScopeImpl));
function recordEffectScope(effect, scope) {
    var _a;
    scope = scope || activeEffectScope;
    if (scope && scope.active) {
        scope.effects.push(effect);
        return;
    }
    // destroy on parent component unmounted
    var vm = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy;
    vm && vm.$on('hook:destroyed', function () { return effect.stop(); });
}
function effectScope(detached) {
    return new EffectScope(detached);
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn) {
    if (activeEffectScope) {
        activeEffectScope.cleanups.push(fn);
    }
    else if ((false)) {
        warn$1("onScopeDispose() is called when there is no active effect scope" +
            " to be associated with.");
    }
}
/**
 * @internal
 **/
function getCurrentScopeVM() {
    var _a, _b;
    return ((_a = getCurrentScope()) === null || _a === void 0 ? void 0 : _a.vm) || ((_b = getCurrentInstance()) === null || _b === void 0 ? void 0 : _b.proxy);
}
/**
 * @internal
 **/
function bindCurrentScopeToVM(vm) {
    if (!vm.scope) {
        var scope_1 = new EffectScopeImpl(vm.proxy);
        vm.scope = scope_1;
        vm.proxy.$on('hook:destroyed', function () { return scope_1.stop(); });
    }
    return vm.scope;
}

var vueDependency = undefined;
try {
    var requiredVue = __webpack_require__(40);
    if (requiredVue && isVue(requiredVue)) {
        vueDependency = requiredVue;
    }
    else if (requiredVue &&
        'default' in requiredVue &&
        isVue(requiredVue.default)) {
        vueDependency = requiredVue.default;
    }
}
catch (_a) {
    // not available
}
var vueConstructor = null;
var currentInstance = null;
var currentInstanceTracking = true;
var PluginInstalledFlag = '__composition_api_installed__';
function isVue(obj) {
    return obj && isFunction(obj) && obj.name === 'Vue';
}
function isVueRegistered(Vue) {
    // resolve issue: https://github.com/vuejs/composition-api/issues/876#issue-1087619365
    return vueConstructor && hasOwn(Vue, PluginInstalledFlag);
}
function getVueConstructor() {
    if ((false)) {
        assert(vueConstructor, "must call Vue.use(VueCompositionAPI) before using any function.");
    }
    return vueConstructor;
}
// returns registered vue or `vue` dependency
function getRegisteredVueOrDefault() {
    var constructor = vueConstructor || vueDependency;
    if ((false)) {
        assert(constructor, "No vue dependency found.");
    }
    return constructor;
}
function setVueConstructor(Vue) {
    // @ts-ignore
    if (false) {
        warn('[vue-composition-api] another instance of Vue installed');
    }
    vueConstructor = Vue;
    Object.defineProperty(Vue, PluginInstalledFlag, {
        configurable: true,
        writable: true,
        value: true,
    });
}
/**
 * For `effectScope` to create instance without populate the current instance
 * @internal
 **/
function withCurrentInstanceTrackingDisabled(fn) {
    var prev = currentInstanceTracking;
    currentInstanceTracking = false;
    try {
        fn();
    }
    finally {
        currentInstanceTracking = prev;
    }
}
function setCurrentInstance(instance) {
    if (!currentInstanceTracking)
        return;
    var prev = currentInstance;
    prev === null || prev === void 0 ? void 0 : prev.scope.off();
    currentInstance = instance;
    currentInstance === null || currentInstance === void 0 ? void 0 : currentInstance.scope.on();
}
function getCurrentInstance() {
    return currentInstance;
}
var instanceMapCache = new WeakMap();
function toVue3ComponentInstance(vm) {
    if (instanceMapCache.has(vm)) {
        return instanceMapCache.get(vm);
    }
    var instance = {
        proxy: vm,
        update: vm.$forceUpdate,
        type: vm.$options,
        uid: vm._uid,
        // $emit is defined on prototype and it expected to be bound
        emit: vm.$emit.bind(vm),
        parent: null,
        root: null, // to be immediately set
    };
    bindCurrentScopeToVM(instance);
    // map vm.$props =
    var instanceProps = [
        'data',
        'props',
        'attrs',
        'refs',
        'vnode',
        'slots',
    ];
    instanceProps.forEach(function (prop) {
        proxy(instance, prop, {
            get: function () {
                return vm["$".concat(prop)];
            },
        });
    });
    proxy(instance, 'isMounted', {
        get: function () {
            // @ts-expect-error private api
            return vm._isMounted;
        },
    });
    proxy(instance, 'isUnmounted', {
        get: function () {
            // @ts-expect-error private api
            return vm._isDestroyed;
        },
    });
    proxy(instance, 'isDeactivated', {
        get: function () {
            // @ts-expect-error private api
            return vm._inactive;
        },
    });
    proxy(instance, 'emitted', {
        get: function () {
            // @ts-expect-error private api
            return vm._events;
        },
    });
    instanceMapCache.set(vm, instance);
    if (vm.$parent) {
        instance.parent = toVue3ComponentInstance(vm.$parent);
    }
    if (vm.$root) {
        instance.root = toVue3ComponentInstance(vm.$root);
    }
    return instance;
}

var toString = function (x) { return Object.prototype.toString.call(x); };
function isNative(Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
}
var hasSymbol = typeof Symbol !== 'undefined' &&
    isNative(Symbol) &&
    typeof Reflect !== 'undefined' &&
    isNative(Reflect.ownKeys);
var noopFn = function (_) { return _; };
function proxy(target, key, _a) {
    var get = _a.get, set = _a.set;
    Object.defineProperty(target, key, {
        enumerable: true,
        configurable: true,
        get: get || noopFn,
        set: set || noopFn,
    });
}
function def(obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
        value: val,
        enumerable: !!enumerable,
        writable: true,
        configurable: true,
    });
}
function hasOwn(obj, key) {
    return Object.hasOwnProperty.call(obj, key);
}
function assert(condition, msg) {
    if (!condition) {
        throw new Error("[vue-composition-api] ".concat(msg));
    }
}
function isPrimitive(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        // $flow-disable-line
        typeof value === 'symbol' ||
        typeof value === 'boolean');
}
function isArray(x) {
    return Array.isArray(x);
}
var objectToString = Object.prototype.toString;
var toTypeString = function (value) {
    return objectToString.call(value);
};
var isMap = function (val) {
    return toTypeString(val) === '[object Map]';
};
var isSet = function (val) {
    return toTypeString(val) === '[object Set]';
};
var MAX_VALID_ARRAY_LENGTH = 4294967295; // Math.pow(2, 32) - 1
function isValidArrayIndex(val) {
    var n = parseFloat(String(val));
    return (n >= 0 &&
        Math.floor(n) === n &&
        isFinite(val) &&
        n <= MAX_VALID_ARRAY_LENGTH);
}
function isObject(val) {
    return val !== null && typeof val === 'object';
}
function isPlainObject(x) {
    return toString(x) === '[object Object]';
}
function isFunction(x) {
    return typeof x === 'function';
}
function isUndef(v) {
    return v === undefined || v === null;
}
function warn(msg, vm) {
    var Vue = getRegisteredVueOrDefault();
    if (!Vue || !Vue.util)
        console.warn("[vue-composition-api] ".concat(msg));
    else
        Vue.util.warn(msg, vm);
}
function logError(err, vm, info) {
    if ((false)) {
        warn("Error in ".concat(info, ": \"").concat(err.toString(), "\""), vm);
    }
    if (typeof window !== 'undefined' && typeof console !== 'undefined') {
        console.error(err);
    }
    else {
        throw err;
    }
}
/**
 * Object.is polyfill
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 * */
function isSame(value1, value2) {
    if (value1 === value2) {
        return value1 !== 0 || 1 / value1 === 1 / value2;
    }
    else {
        return value1 !== value1 && value2 !== value2;
    }
}

function getCurrentInstanceForFn(hook, target) {
    target = target || getCurrentInstance();
    if (false) {
        warn("".concat(hook, " is called when there is no active component instance to be ") +
            "associated with. " +
            "Lifecycle injection APIs can only be used during execution of setup().");
    }
    return target;
}
function defineComponentInstance(Ctor, options) {
    if (options === void 0) { options = {}; }
    var silent = Ctor.config.silent;
    Ctor.config.silent = true;
    var vm = new Ctor(options);
    Ctor.config.silent = silent;
    return vm;
}
function isComponentInstance(obj) {
    var Vue = getVueConstructor();
    return Vue && obj instanceof Vue;
}
function createSlotProxy(vm, slotName) {
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!vm.$scopedSlots[slotName]) {
            if ((false))
                return warn("slots.".concat(slotName, "() got called outside of the \"render()\" scope"), vm);
            return;
        }
        return vm.$scopedSlots[slotName].apply(vm, args);
    });
}
function resolveSlots(slots, normalSlots) {
    var res;
    if (!slots) {
        res = {};
    }
    else if (slots._normalized) {
        // fast path 1: child component re-render only, parent did not change
        return slots._normalized;
    }
    else {
        res = {};
        for (var key in slots) {
            if (slots[key] && key[0] !== '$') {
                res[key] = true;
            }
        }
    }
    // expose normal slots on scopedSlots
    for (var key in normalSlots) {
        if (!(key in res)) {
            res[key] = true;
        }
    }
    return res;
}
var vueInternalClasses;
var getVueInternalClasses = function () {
    if (!vueInternalClasses) {
        var vm = defineComponentInstance(getVueConstructor(), {
            computed: {
                value: function () {
                    return 0;
                },
            },
        });
        // to get Watcher class
        var Watcher = vm._computedWatchers.value.constructor;
        // to get Dep class
        var Dep = vm._data.__ob__.dep.constructor;
        vueInternalClasses = {
            Watcher: Watcher,
            Dep: Dep,
        };
        vm.$destroy();
    }
    return vueInternalClasses;
};

function createSymbol(name) {
    return hasSymbol ? Symbol.for(name) : name;
}
var WatcherPreFlushQueueKey = createSymbol('composition-api.preFlushQueue');
var WatcherPostFlushQueueKey = createSymbol('composition-api.postFlushQueue');
// must be a string, symbol key is ignored in reactive
var RefKey = 'composition-api.refKey';

var accessModifiedSet = new WeakMap();
var rawSet = new WeakMap();
var readonlySet = new WeakMap();

/**
 * Set a property on an object. Adds the new property, triggers change
 * notification and intercept it's subsequent access if the property doesn't
 * already exist.
 */
function set$1(target, key, val) {
    var Vue = getVueConstructor();
    // @ts-expect-error https://github.com/vuejs/vue/pull/12132
    var _a = Vue.util, warn = _a.warn, defineReactive = _a.defineReactive;
    if (false) {
        warn("Cannot set reactive property on undefined, null, or primitive value: ".concat(target));
    }
    var ob = target.__ob__;
    function ssrMockReactivity() {
        // in SSR, there is no __ob__. Mock for reactivity check
        if (ob && isObject(val) && !hasOwn(val, '__ob__')) {
            mockReactivityDeep(val);
        }
    }
    if (isArray(target)) {
        if (isValidArrayIndex(key)) {
            target.length = Math.max(target.length, key);
            target.splice(key, 1, val);
            ssrMockReactivity();
            return val;
        }
        else if (key === 'length' && val !== target.length) {
            target.length = val;
            ob === null || ob === void 0 ? void 0 : ob.dep.notify();
            return val;
        }
    }
    if (key in target && !(key in Object.prototype)) {
        target[key] = val;
        ssrMockReactivity();
        return val;
    }
    if (target._isVue || (ob && ob.vmCount)) {
        ("production" !== 'production') &&
            warn('Avoid adding reactive properties to a Vue instance or its root $data ' +
                'at runtime - declare it upfront in the data option.');
        return val;
    }
    if (!ob) {
        target[key] = val;
        return val;
    }
    defineReactive(ob.value, key, val);
    // IMPORTANT: define access control before trigger watcher
    defineAccessControl(target, key, val);
    ssrMockReactivity();
    ob.dep.notify();
    return val;
}

var _isForceTrigger = false;
function isForceTrigger() {
    return _isForceTrigger;
}
function setForceTrigger(v) {
    _isForceTrigger = v;
}

var RefImpl = /** @class */ (function () {
    function RefImpl(_a) {
        var get = _a.get, set = _a.set;
        proxy(this, 'value', {
            get: get,
            set: set,
        });
    }
    return RefImpl;
}());
function createRef(options, isReadonly, isComputed) {
    if (isReadonly === void 0) { isReadonly = false; }
    if (isComputed === void 0) { isComputed = false; }
    var r = new RefImpl(options);
    // add effect to differentiate refs from computed
    if (isComputed)
        r.effect = true;
    // seal the ref, this could prevent ref from being observed
    // It's safe to seal the ref, since we really shouldn't extend it.
    // related issues: #79
    var sealed = Object.seal(r);
    if (isReadonly)
        readonlySet.set(sealed, true);
    return sealed;
}
function ref(raw) {
    var _a;
    if (isRef(raw)) {
        return raw;
    }
    var value = reactive((_a = {}, _a[RefKey] = raw, _a));
    return createRef({
        get: function () { return value[RefKey]; },
        set: function (v) { return (value[RefKey] = v); },
    });
}
function isRef(value) {
    return value instanceof RefImpl;
}
function unref(ref) {
    return isRef(ref) ? ref.value : ref;
}
function toRefs(obj) {
    if (false) {
        warn("toRefs() expects a reactive object but received a plain one.");
    }
    if (!isPlainObject(obj))
        return obj;
    var ret = {};
    for (var key in obj) {
        ret[key] = toRef(obj, key);
    }
    return ret;
}
function customRef(factory) {
    var version = ref(0);
    return createRef(factory(function () { return void version.value; }, function () {
        ++version.value;
    }));
}
function toRef(object, key) {
    if (!(key in object))
        set$1(object, key, undefined);
    var v = object[key];
    if (isRef(v))
        return v;
    return createRef({
        get: function () { return object[key]; },
        set: function (v) { return (object[key] = v); },
    });
}
function shallowRef(raw) {
    var _a;
    if (isRef(raw)) {
        return raw;
    }
    var value = shallowReactive((_a = {}, _a[RefKey] = raw, _a));
    return createRef({
        get: function () { return value[RefKey]; },
        set: function (v) { return (value[RefKey] = v); },
    });
}
function triggerRef(value) {
    if (!isRef(value))
        return;
    setForceTrigger(true);
    value.value = value.value;
    setForceTrigger(false);
}
function proxyRefs(objectWithRefs) {
    var _a, e_1, _b;
    if (isReactive(objectWithRefs)) {
        return objectWithRefs;
    }
    var value = reactive((_a = {}, _a[RefKey] = objectWithRefs, _a));
    def(value, RefKey, value[RefKey], false);
    var _loop_1 = function (key) {
        proxy(value, key, {
            get: function () {
                if (isRef(value[RefKey][key])) {
                    return value[RefKey][key].value;
                }
                return value[RefKey][key];
            },
            set: function (v) {
                if (isRef(value[RefKey][key])) {
                    return (value[RefKey][key].value = unref(v));
                }
                value[RefKey][key] = unref(v);
            },
        });
    };
    try {
        for (var _c = __values(Object.keys(objectWithRefs)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var key = _d.value;
            _loop_1(key);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return value;
}

var SKIPFLAG = '__v_skip';
function isRaw(obj) {
    var _a;
    return Boolean(obj &&
        hasOwn(obj, '__ob__') &&
        typeof obj.__ob__ === 'object' &&
        ((_a = obj.__ob__) === null || _a === void 0 ? void 0 : _a[SKIPFLAG]));
}
function isReactive(obj) {
    var _a;
    return Boolean(obj &&
        hasOwn(obj, '__ob__') &&
        typeof obj.__ob__ === 'object' &&
        !((_a = obj.__ob__) === null || _a === void 0 ? void 0 : _a[SKIPFLAG]));
}
/**
 * Proxing property access of target.
 * We can do unwrapping and other things here.
 */
function setupAccessControl(target) {
    if (!isPlainObject(target) ||
        isRaw(target) ||
        isArray(target) ||
        isRef(target) ||
        isComponentInstance(target) ||
        accessModifiedSet.has(target))
        return;
    accessModifiedSet.set(target, true);
    var keys = Object.keys(target);
    for (var i = 0; i < keys.length; i++) {
        defineAccessControl(target, keys[i]);
    }
}
/**
 * Auto unwrapping when access property
 */
function defineAccessControl(target, key, val) {
    if (key === '__ob__')
        return;
    if (isRaw(target[key]))
        return;
    var getter;
    var setter;
    var property = Object.getOwnPropertyDescriptor(target, key);
    if (property) {
        if (property.configurable === false) {
            return;
        }
        getter = property.get;
        setter = property.set;
        if ((!getter || setter) /* not only have getter */ &&
            arguments.length === 2) {
            val = target[key];
        }
    }
    setupAccessControl(val);
    proxy(target, key, {
        get: function getterHandler() {
            var value = getter ? getter.call(target) : val;
            // if the key is equal to RefKey, skip the unwrap logic
            if (key !== RefKey && isRef(value)) {
                return value.value;
            }
            else {
                return value;
            }
        },
        set: function setterHandler(newVal) {
            if (getter && !setter)
                return;
            // If the key is equal to RefKey, skip the unwrap logic
            // If and only if "value" is ref and "newVal" is not a ref,
            // the assignment should be proxied to "value" ref.
            if (key !== RefKey && isRef(val) && !isRef(newVal)) {
                val.value = newVal;
            }
            else if (setter) {
                setter.call(target, newVal);
                val = newVal;
            }
            else {
                val = newVal;
            }
            setupAccessControl(newVal);
        },
    });
}
function observe(obj) {
    var Vue = getRegisteredVueOrDefault();
    var observed;
    if (Vue.observable) {
        observed = Vue.observable(obj);
    }
    else {
        var vm = defineComponentInstance(Vue, {
            data: {
                $$state: obj,
            },
        });
        observed = vm._data.$$state;
    }
    // in SSR, there is no __ob__. Mock for reactivity check
    if (!hasOwn(observed, '__ob__')) {
        mockReactivityDeep(observed);
    }
    return observed;
}
/**
 * Mock __ob__ for object recursively
 */
function mockReactivityDeep(obj, seen) {
    var e_1, _a;
    if (seen === void 0) { seen = new Set(); }
    if (seen.has(obj) || hasOwn(obj, '__ob__') || !Object.isExtensible(obj))
        return;
    def(obj, '__ob__', mockObserver(obj));
    seen.add(obj);
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            var value = obj[key];
            if (!(isPlainObject(value) || isArray(value)) ||
                isRaw(value) ||
                !Object.isExtensible(value)) {
                continue;
            }
            mockReactivityDeep(value, seen);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function mockObserver(value) {
    if (value === void 0) { value = {}; }
    return {
        value: value,
        dep: {
            notify: noopFn,
            depend: noopFn,
            addSub: noopFn,
            removeSub: noopFn,
        },
    };
}
function createObserver() {
    return observe({}).__ob__;
}
function shallowReactive(obj) {
    var e_2, _a;
    if (!isObject(obj)) {
        if ((false)) {
            warn('"shallowReactive()" must be called on an object.');
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        isRaw(obj) ||
        !Object.isExtensible(obj)) {
        return obj;
    }
    var observed = observe(isArray(obj) ? [] : {});
    var ob = observed.__ob__;
    var _loop_1 = function (key) {
        var val = obj[key];
        var getter;
        var setter;
        var property = Object.getOwnPropertyDescriptor(obj, key);
        if (property) {
            if (property.configurable === false) {
                return "continue";
            }
            getter = property.get;
            setter = property.set;
        }
        proxy(observed, key, {
            get: function getterHandler() {
                var _a;
                (_a = ob.dep) === null || _a === void 0 ? void 0 : _a.depend();
                return val;
            },
            set: function setterHandler(newVal) {
                var _a;
                if (getter && !setter)
                    return;
                if (!isForceTrigger() && val === newVal)
                    return;
                if (setter) {
                    setter.call(obj, newVal);
                }
                else {
                    val = newVal;
                }
                (_a = ob.dep) === null || _a === void 0 ? void 0 : _a.notify();
            },
        });
    };
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            _loop_1(key);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return observed;
}
/**
 * Make obj reactivity
 */
function reactive(obj) {
    if (!isObject(obj)) {
        if ((false)) {
            warn('"reactive()" must be called on an object.');
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        isRaw(obj) ||
        !Object.isExtensible(obj)) {
        return obj;
    }
    var observed = observe(obj);
    setupAccessControl(observed);
    return observed;
}
/**
 * Make sure obj can't be a reactive
 */
function markRaw(obj) {
    if (!(isPlainObject(obj) || isArray(obj)) || !Object.isExtensible(obj)) {
        return obj;
    }
    // set the vue observable flag at obj
    var ob = createObserver();
    ob[SKIPFLAG] = true;
    def(obj, '__ob__', ob);
    // mark as Raw
    rawSet.set(obj, true);
    return obj;
}
function toRaw(observed) {
    var _a;
    if (isRaw(observed) || !Object.isExtensible(observed)) {
        return observed;
    }
    return ((_a = observed === null || observed === void 0 ? void 0 : observed.__ob__) === null || _a === void 0 ? void 0 : _a.value) || observed;
}

function isReadonly(obj) {
    return readonlySet.has(obj);
}
/**
 * **In @vue/composition-api, `reactive` only provides type-level readonly check**
 *
 * Creates a readonly copy of the original object. Note the returned copy is not
 * made reactive, but `readonly` can be called on an already reactive object.
 */
function readonly(target) {
    if (false) {
        warn("value cannot be made reactive: ".concat(String(target)));
    }
    else {
        readonlySet.set(target, true);
    }
    return target;
}
function shallowReadonly(obj) {
    var e_1, _a;
    if (!isObject(obj)) {
        if ((false)) {
            warn("value cannot be made reactive: ".concat(String(obj)));
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        (!Object.isExtensible(obj) && !isRef(obj))) {
        return obj;
    }
    var readonlyObj = isRef(obj)
        ? new RefImpl({})
        : isReactive(obj)
            ? observe({})
            : {};
    var source = reactive({});
    var ob = source.__ob__;
    var _loop_1 = function (key) {
        var val = obj[key];
        var getter;
        var property = Object.getOwnPropertyDescriptor(obj, key);
        if (property) {
            if (property.configurable === false && !isRef(obj)) {
                return "continue";
            }
            getter = property.get;
        }
        proxy(readonlyObj, key, {
            get: function getterHandler() {
                var value = getter ? getter.call(obj) : val;
                ob.dep.depend();
                return value;
            },
            set: function (v) {
                if ((false)) {
                    warn("Set operation on key \"".concat(key, "\" failed: target is readonly."));
                }
            },
        });
    };
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            _loop_1(key);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    readonlySet.set(readonlyObj, true);
    return readonlyObj;
}

/**
 * Delete a property and trigger change if necessary.
 */
function del(target, key) {
    var Vue = getVueConstructor();
    var warn = Vue.util.warn;
    if (false) {
        warn("Cannot delete reactive property on undefined, null, or primitive value: ".concat(target));
    }
    if (isArray(target) && isValidArrayIndex(key)) {
        target.splice(key, 1);
        return;
    }
    var ob = target.__ob__;
    if (target._isVue || (ob && ob.vmCount)) {
        ("production" !== 'production') &&
            warn('Avoid deleting properties on a Vue instance or its root $data ' +
                '- just set it to null.');
        return;
    }
    if (!hasOwn(target, key)) {
        return;
    }
    delete target[key];
    if (!ob) {
        return;
    }
    ob.dep.notify();
}

var genName = function (name) { return "on".concat(name[0].toUpperCase() + name.slice(1)); };
function createLifeCycle(lifeCyclehook) {
    return function (callback, target) {
        var instance = getCurrentInstanceForFn(genName(lifeCyclehook), target);
        return (instance &&
            injectHookOption(getVueConstructor(), instance, lifeCyclehook, callback));
    };
}
function injectHookOption(Vue, instance, hook, val) {
    var options = instance.proxy.$options;
    var mergeFn = Vue.config.optionMergeStrategies[hook];
    var wrappedHook = wrapHookCall(instance, val);
    options[hook] = mergeFn(options[hook], wrappedHook);
    return wrappedHook;
}
function wrapHookCall(instance, fn) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var prev = getCurrentInstance();
        setCurrentInstance(instance);
        try {
            return fn.apply(void 0, __spreadArray([], __read(args), false));
        }
        finally {
            setCurrentInstance(prev);
        }
    };
}
var onBeforeMount = createLifeCycle('beforeMount');
var onMounted = createLifeCycle('mounted');
var onBeforeUpdate = createLifeCycle('beforeUpdate');
var onUpdated = createLifeCycle('updated');
var onBeforeUnmount = createLifeCycle('beforeDestroy');
var onUnmounted = createLifeCycle('destroyed');
var onErrorCaptured = createLifeCycle('errorCaptured');
var onActivated = createLifeCycle('activated');
var onDeactivated = createLifeCycle('deactivated');
var onServerPrefetch = createLifeCycle('serverPrefetch');

var fallbackVM;
function flushPreQueue() {
    flushQueue(this, WatcherPreFlushQueueKey);
}
function flushPostQueue() {
    flushQueue(this, WatcherPostFlushQueueKey);
}
function hasWatchEnv(vm) {
    return vm[WatcherPreFlushQueueKey] !== undefined;
}
function installWatchEnv(vm) {
    vm[WatcherPreFlushQueueKey] = [];
    vm[WatcherPostFlushQueueKey] = [];
    vm.$on('hook:beforeUpdate', flushPreQueue);
    vm.$on('hook:updated', flushPostQueue);
}
function getWatcherOption(options) {
    return __assign({
        immediate: false,
        deep: false,
        flush: 'pre',
    }, options);
}
function getWatchEffectOption(options) {
    return __assign({
        flush: 'pre',
    }, options);
}
function getWatcherVM() {
    var vm = getCurrentScopeVM();
    if (!vm) {
        if (!fallbackVM) {
            fallbackVM = defineComponentInstance(getVueConstructor());
        }
        vm = fallbackVM;
    }
    else if (!hasWatchEnv(vm)) {
        installWatchEnv(vm);
    }
    return vm;
}
function flushQueue(vm, key) {
    var queue = vm[key];
    for (var index = 0; index < queue.length; index++) {
        queue[index]();
    }
    queue.length = 0;
}
function queueFlushJob(vm, fn, mode) {
    // flush all when beforeUpdate and updated are not fired
    var fallbackFlush = function () {
        vm.$nextTick(function () {
            if (vm[WatcherPreFlushQueueKey].length) {
                flushQueue(vm, WatcherPreFlushQueueKey);
            }
            if (vm[WatcherPostFlushQueueKey].length) {
                flushQueue(vm, WatcherPostFlushQueueKey);
            }
        });
    };
    switch (mode) {
        case 'pre':
            fallbackFlush();
            vm[WatcherPreFlushQueueKey].push(fn);
            break;
        case 'post':
            fallbackFlush();
            vm[WatcherPostFlushQueueKey].push(fn);
            break;
        default:
            assert(false, "flush must be one of [\"post\", \"pre\", \"sync\"], but got ".concat(mode));
            break;
    }
}
function createVueWatcher(vm, getter, callback, options) {
    var index = vm._watchers.length;
    // @ts-ignore: use undocumented options
    vm.$watch(getter, callback, {
        immediate: options.immediateInvokeCallback,
        deep: options.deep,
        lazy: options.noRun,
        sync: options.sync,
        before: options.before,
    });
    return vm._watchers[index];
}
// We have to monkeypatch the teardown function so Vue will run
// runCleanup() when it tears down the watcher on unmounted.
function patchWatcherTeardown(watcher, runCleanup) {
    var _teardown = watcher.teardown;
    watcher.teardown = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        _teardown.apply(watcher, args);
        runCleanup();
    };
}
function createWatcher(vm, source, cb, options) {
    var _a;
    if (false) {
        if (options.immediate !== undefined) {
            warn("watch() \"immediate\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
        if (options.deep !== undefined) {
            warn("watch() \"deep\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
    }
    var flushMode = options.flush;
    var isSync = flushMode === 'sync';
    var cleanup;
    var registerCleanup = function (fn) {
        cleanup = function () {
            try {
                fn();
            }
            catch (
            // FIXME: remove any
            error) {
                logError(error, vm, 'onCleanup()');
            }
        };
    };
    // cleanup before running getter again
    var runCleanup = function () {
        if (cleanup) {
            cleanup();
            cleanup = null;
        }
    };
    var createScheduler = function (fn) {
        if (isSync ||
            /* without a current active instance, ignore pre|post mode */ vm ===
                fallbackVM) {
            return fn;
        }
        return (function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return queueFlushJob(vm, function () {
                fn.apply(void 0, __spreadArray([], __read(args), false));
            }, flushMode);
        });
    };
    // effect watch
    if (cb === null) {
        var running_1 = false;
        var getter_1 = function () {
            // preventing the watch callback being call in the same execution
            if (running_1) {
                return;
            }
            try {
                running_1 = true;
                source(registerCleanup);
            }
            finally {
                running_1 = false;
            }
        };
        var watcher_1 = createVueWatcher(vm, getter_1, noopFn, {
            deep: options.deep || false,
            sync: isSync,
            before: runCleanup,
        });
        patchWatcherTeardown(watcher_1, runCleanup);
        // enable the watcher update
        watcher_1.lazy = false;
        var originGet = watcher_1.get.bind(watcher_1);
        // always run watchEffect
        watcher_1.get = createScheduler(originGet);
        return function () {
            watcher_1.teardown();
        };
    }
    var deep = options.deep;
    var isMultiSource = false;
    var getter;
    if (isRef(source)) {
        getter = function () { return source.value; };
    }
    else if (isReactive(source)) {
        getter = function () { return source; };
        deep = true;
    }
    else if (isArray(source)) {
        isMultiSource = true;
        getter = function () {
            return source.map(function (s) {
                if (isRef(s)) {
                    return s.value;
                }
                else if (isReactive(s)) {
                    return traverse(s);
                }
                else if (isFunction(s)) {
                    return s();
                }
                else {
                    ("production" !== 'production') &&
                        warn("Invalid watch source: ".concat(JSON.stringify(s), ".\n          A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."), vm);
                    return noopFn;
                }
            });
        };
    }
    else if (isFunction(source)) {
        getter = source;
    }
    else {
        getter = noopFn;
        ("production" !== 'production') &&
            warn("Invalid watch source: ".concat(JSON.stringify(source), ".\n      A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."), vm);
    }
    if (deep) {
        var baseGetter_1 = getter;
        getter = function () { return traverse(baseGetter_1()); };
    }
    var applyCb = function (n, o) {
        if (!deep &&
            isMultiSource &&
            n.every(function (v, i) { return isSame(v, o[i]); }))
            return;
        // cleanup before running cb again
        runCleanup();
        return cb(n, o, registerCleanup);
    };
    var callback = createScheduler(applyCb);
    if (options.immediate) {
        var originalCallback_1 = callback;
        // `shiftCallback` is used to handle the first sync effect run.
        // The subsequent callbacks will redirect to `callback`.
        var shiftCallback_1 = function (n, o) {
            shiftCallback_1 = originalCallback_1;
            // o is undefined on the first call
            return applyCb(n, isArray(n) ? [] : o);
        };
        callback = function (n, o) {
            return shiftCallback_1(n, o);
        };
    }
    // @ts-ignore: use undocumented option "sync"
    var stop = vm.$watch(getter, callback, {
        immediate: options.immediate,
        deep: deep,
        sync: isSync,
    });
    // Once again, we have to hack the watcher for proper teardown
    var watcher = vm._watchers[vm._watchers.length - 1];
    // if the return value is reactive and deep:true
    // watch for changes, this might happen when new key is added
    if (isReactive(watcher.value) && ((_a = watcher.value.__ob__) === null || _a === void 0 ? void 0 : _a.dep) && deep) {
        watcher.value.__ob__.dep.addSub({
            update: function () {
                // this will force the source to be reevaluated and the callback
                // executed if needed
                watcher.run();
            },
        });
    }
    patchWatcherTeardown(watcher, runCleanup);
    return function () {
        stop();
    };
}
function watchEffect(effect, options) {
    var opts = getWatchEffectOption(options);
    var vm = getWatcherVM();
    return createWatcher(vm, effect, null, opts);
}
function watchPostEffect(effect) {
    return watchEffect(effect, { flush: 'post' });
}
function watchSyncEffect(effect) {
    return watchEffect(effect, { flush: 'sync' });
}
// implementation
function watch(source, cb, options) {
    var callback = null;
    if (isFunction(cb)) {
        // source watch
        callback = cb;
    }
    else {
        // effect watch
        if ((false)) {
            warn("`watch(fn, options?)` signature has been moved to a separate API. " +
                "Use `watchEffect(fn, options?)` instead. `watch` now only " +
                "supports `watch(source, cb, options?) signature.");
        }
        options = cb;
        callback = null;
    }
    var opts = getWatcherOption(options);
    var vm = getWatcherVM();
    return createWatcher(vm, source, callback, opts);
}
function traverse(value, seen) {
    if (seen === void 0) { seen = new Set(); }
    if (!isObject(value) || seen.has(value) || rawSet.has(value)) {
        return value;
    }
    seen.add(value);
    if (isRef(value)) {
        traverse(value.value, seen);
    }
    else if (isArray(value)) {
        for (var i = 0; i < value.length; i++) {
            traverse(value[i], seen);
        }
    }
    else if (isSet(value) || isMap(value)) {
        value.forEach(function (v) {
            traverse(v, seen);
        });
    }
    else if (isPlainObject(value)) {
        for (var key in value) {
            traverse(value[key], seen);
        }
    }
    return value;
}

// implement
function computed(getterOrOptions) {
    var vm = getCurrentScopeVM();
    var getter;
    var setter;
    if (isFunction(getterOrOptions)) {
        getter = getterOrOptions;
    }
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    var computedSetter;
    var computedGetter;
    if (vm && !vm.$isServer) {
        var _a = getVueInternalClasses(), Watcher_1 = _a.Watcher, Dep_1 = _a.Dep;
        var watcher_1;
        computedGetter = function () {
            if (!watcher_1) {
                watcher_1 = new Watcher_1(vm, getter, noopFn, { lazy: true });
            }
            if (watcher_1.dirty) {
                watcher_1.evaluate();
            }
            if (Dep_1.target) {
                watcher_1.depend();
            }
            return watcher_1.value;
        };
        computedSetter = function (v) {
            if (false) {
                warn('Write operation failed: computed value is readonly.', vm);
                return;
            }
            if (setter) {
                setter(v);
            }
        };
    }
    else {
        // fallback
        var computedHost_1 = defineComponentInstance(getVueConstructor(), {
            computed: {
                $$state: {
                    get: getter,
                    set: setter,
                },
            },
        });
        vm && vm.$on('hook:destroyed', function () { return computedHost_1.$destroy(); });
        computedGetter = function () { return computedHost_1.$$state; };
        computedSetter = function (v) {
            if (false) {
                warn('Write operation failed: computed value is readonly.', vm);
                return;
            }
            computedHost_1.$$state = v;
        };
    }
    return createRef({
        get: computedGetter,
        set: computedSetter,
    }, !setter, true);
}

var NOT_FOUND = {};
function resolveInject(provideKey, vm) {
    var source = vm;
    while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
            return source._provided[provideKey];
        }
        source = source.$parent;
    }
    return NOT_FOUND;
}
function provide(key, value) {
    var _a;
    var vm = (_a = getCurrentInstanceForFn('provide')) === null || _a === void 0 ? void 0 : _a.proxy;
    if (!vm)
        return;
    if (!vm._provided) {
        var provideCache_1 = {};
        proxy(vm, '_provided', {
            get: function () { return provideCache_1; },
            set: function (v) { return Object.assign(provideCache_1, v); },
        });
    }
    vm._provided[key] = value;
}
function inject(key, defaultValue, treatDefaultAsFactory) {
    var _a;
    if (treatDefaultAsFactory === void 0) { treatDefaultAsFactory = false; }
    var vm = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy;
    if (!vm) {
        ("production" !== 'production') &&
            warn("inject() can only be used inside setup() or functional components.");
        return;
    }
    if (!key) {
        ("production" !== 'production') && warn("injection \"".concat(String(key), "\" not found."), vm);
        return defaultValue;
    }
    var val = resolveInject(key, vm);
    if (val !== NOT_FOUND) {
        return val;
    }
    else if (arguments.length > 1) {
        return treatDefaultAsFactory && isFunction(defaultValue)
            ? defaultValue()
            : defaultValue;
    }
    else if ((false)) {
        warn("Injection \"".concat(String(key), "\" not found."), vm);
    }
}

var EMPTY_OBJ = ( false)
    ? Object.freeze({})
    : {};
var useCssModule = function (name) {
    var _a;
    if (name === void 0) { name = '$style'; }
    var instance = getCurrentInstance();
    if (!instance) {
        ("production" !== 'production') && warn("useCssModule must be called inside setup()");
        return EMPTY_OBJ;
    }
    var mod = (_a = instance.proxy) === null || _a === void 0 ? void 0 : _a[name];
    if (!mod) {
        ("production" !== 'production') &&
            warn("Current instance does not have CSS module named \"".concat(name, "\"."));
        return EMPTY_OBJ;
    }
    return mod;
};
/**
 * @deprecated use `useCssModule` instead.
 */
var useCSSModule = useCssModule;

function createApp(rootComponent, rootProps) {
    if (rootProps === void 0) { rootProps = undefined; }
    var V = getVueConstructor();
    var mountedVM = undefined;
    var provide = {};
    var app = {
        config: V.config,
        use: V.use.bind(V),
        mixin: V.mixin.bind(V),
        component: V.component.bind(V),
        provide: function (key, value) {
            provide[key] = value;
            return this;
        },
        directive: function (name, dir) {
            if (dir) {
                V.directive(name, dir);
                return app;
            }
            else {
                return V.directive(name);
            }
        },
        mount: function (el, hydrating) {
            if (!mountedVM) {
                mountedVM = new V(__assign(__assign({ propsData: rootProps }, rootComponent), { provide: __assign(__assign({}, provide), rootComponent.provide) }));
                mountedVM.$mount(el, hydrating);
                return mountedVM;
            }
            else {
                if ((false)) {
                    warn("App has already been mounted.\n" +
                        "If you want to remount the same app, move your app creation logic " +
                        "into a factory function and create fresh app instances for each " +
                        "mount - e.g. `const createMyApp = () => createApp(App)`");
                }
                return mountedVM;
            }
        },
        unmount: function () {
            if (mountedVM) {
                mountedVM.$destroy();
                mountedVM = undefined;
            }
            else if ((false)) {
                warn("Cannot unmount an app that is not mounted.");
            }
        },
    };
    return app;
}

var nextTick = function nextTick() {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return (_a = getVueConstructor()) === null || _a === void 0 ? void 0 : _a.nextTick.apply(this, args);
};

var fallbackCreateElement;
var createElement = function createElement() {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var instance = (this === null || this === void 0 ? void 0 : this.proxy) || ((_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy);
    if (!instance) {
        ("production" !== 'production') &&
            warn('`createElement()` has been called outside of render function.');
        if (!fallbackCreateElement) {
            fallbackCreateElement = defineComponentInstance(getVueConstructor()).$createElement;
        }
        return fallbackCreateElement.apply(fallbackCreateElement, args);
    }
    return instance.$createElement.apply(instance, args);
};

function useSlots() {
    return getContext().slots;
}
function useAttrs() {
    return getContext().attrs;
}
function getContext() {
    var i = getCurrentInstance();
    if (false) {
        warn("useContext() called without active instance.");
    }
    return i.setupContext;
}

function set(vm, key, value) {
    var state = (vm.__composition_api_state__ =
        vm.__composition_api_state__ || {});
    state[key] = value;
}
function get(vm, key) {
    return (vm.__composition_api_state__ || {})[key];
}
var vmStateManager = {
    set: set,
    get: get,
};

function asVmProperty(vm, propName, propValue) {
    var props = vm.$options.props;
    if (!(propName in vm) && !(props && hasOwn(props, propName))) {
        if (isRef(propValue)) {
            proxy(vm, propName, {
                get: function () { return propValue.value; },
                set: function (val) {
                    propValue.value = val;
                },
            });
        }
        else {
            proxy(vm, propName, {
                get: function () {
                    if (isReactive(propValue)) {
                        propValue.__ob__.dep.depend();
                    }
                    return propValue;
                },
                set: function (val) {
                    propValue = val;
                },
            });
        }
        if ((false)) {
            // expose binding to Vue Devtool as a data property
            // delay this until state has been resolved to prevent repeated works
            vm.$nextTick(function () {
                if (Object.keys(vm._data).indexOf(propName) !== -1) {
                    return;
                }
                if (isRef(propValue)) {
                    proxy(vm._data, propName, {
                        get: function () { return propValue.value; },
                        set: function (val) {
                            propValue.value = val;
                        },
                    });
                }
                else {
                    proxy(vm._data, propName, {
                        get: function () { return propValue; },
                        set: function (val) {
                            propValue = val;
                        },
                    });
                }
            });
        }
    }
    else if ((false)) {
        if (props && hasOwn(props, propName)) {
            warn("The setup binding property \"".concat(propName, "\" is already declared as a prop."), vm);
        }
        else {
            warn("The setup binding property \"".concat(propName, "\" is already declared."), vm);
        }
    }
}
function updateTemplateRef(vm) {
    var rawBindings = vmStateManager.get(vm, 'rawBindings') || {};
    if (!rawBindings || !Object.keys(rawBindings).length)
        return;
    var refs = vm.$refs;
    var oldRefKeys = vmStateManager.get(vm, 'refs') || [];
    for (var index = 0; index < oldRefKeys.length; index++) {
        var key = oldRefKeys[index];
        var setupValue = rawBindings[key];
        if (!refs[key] && setupValue && isRef(setupValue)) {
            setupValue.value = null;
        }
    }
    var newKeys = Object.keys(refs);
    var validNewKeys = [];
    for (var index = 0; index < newKeys.length; index++) {
        var key = newKeys[index];
        var setupValue = rawBindings[key];
        if (refs[key] && setupValue && isRef(setupValue)) {
            setupValue.value = refs[key];
            validNewKeys.push(key);
        }
    }
    vmStateManager.set(vm, 'refs', validNewKeys);
}
function afterRender(vm) {
    var stack = [vm._vnode];
    while (stack.length) {
        var vnode = stack.pop();
        if (vnode) {
            if (vnode.context)
                updateTemplateRef(vnode.context);
            if (vnode.children) {
                for (var i = 0; i < vnode.children.length; ++i) {
                    stack.push(vnode.children[i]);
                }
            }
        }
    }
}
function updateVmAttrs(vm, ctx) {
    var e_1, _a;
    if (!vm) {
        return;
    }
    var attrBindings = vmStateManager.get(vm, 'attrBindings');
    if (!attrBindings && !ctx) {
        // fix 840
        return;
    }
    if (!attrBindings) {
        var observedData = reactive({});
        attrBindings = { ctx: ctx, data: observedData };
        vmStateManager.set(vm, 'attrBindings', attrBindings);
        proxy(ctx, 'attrs', {
            get: function () {
                return attrBindings === null || attrBindings === void 0 ? void 0 : attrBindings.data;
            },
            set: function () {
                ("production" !== 'production') &&
                    warn("Cannot assign to '$attrs' because it is a read-only property", vm);
            },
        });
    }
    var source = vm.$attrs;
    var _loop_1 = function (attr) {
        if (!hasOwn(attrBindings.data, attr)) {
            proxy(attrBindings.data, attr, {
                get: function () {
                    // to ensure it always return the latest value
                    return vm.$attrs[attr];
                },
            });
        }
    };
    try {
        for (var _b = __values(Object.keys(source)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var attr = _c.value;
            _loop_1(attr);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function resolveScopedSlots(vm, slotsProxy) {
    var parentVNode = vm.$options._parentVnode;
    if (!parentVNode)
        return;
    var prevSlots = vmStateManager.get(vm, 'slots') || [];
    var curSlots = resolveSlots(parentVNode.data.scopedSlots, vm.$slots);
    // remove staled slots
    for (var index = 0; index < prevSlots.length; index++) {
        var key = prevSlots[index];
        if (!curSlots[key]) {
            delete slotsProxy[key];
        }
    }
    // proxy fresh slots
    var slotNames = Object.keys(curSlots);
    for (var index = 0; index < slotNames.length; index++) {
        var key = slotNames[index];
        if (!slotsProxy[key]) {
            slotsProxy[key] = createSlotProxy(vm, key);
        }
    }
    vmStateManager.set(vm, 'slots', slotNames);
}
function activateCurrentInstance(instance, fn, onError) {
    var preVm = getCurrentInstance();
    setCurrentInstance(instance);
    try {
        return fn(instance);
    }
    catch (
    // FIXME: remove any
    err) {
        if (onError) {
            onError(err);
        }
        else {
            throw err;
        }
    }
    finally {
        setCurrentInstance(preVm);
    }
}

function mixin(Vue) {
    Vue.mixin({
        beforeCreate: functionApiInit,
        mounted: function () {
            afterRender(this);
        },
        beforeUpdate: function () {
            updateVmAttrs(this);
        },
        updated: function () {
            afterRender(this);
        },
    });
    /**
     * Vuex init hook, injected into each instances init hooks list.
     */
    function functionApiInit() {
        var vm = this;
        var $options = vm.$options;
        var setup = $options.setup, render = $options.render;
        if (render) {
            // keep currentInstance accessible for createElement
            $options.render = function () {
                var _this = this;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return activateCurrentInstance(toVue3ComponentInstance(vm), function () {
                    return render.apply(_this, args);
                });
            };
        }
        if (!setup) {
            return;
        }
        if (!isFunction(setup)) {
            if ((false)) {
                warn('The "setup" option should be a function that returns a object in component definitions.', vm);
            }
            return;
        }
        var data = $options.data;
        // wrapper the data option, so we can invoke setup before data get resolved
        $options.data = function wrappedData() {
            initSetup(vm, vm.$props);
            return isFunction(data)
                ? data.call(vm, vm)
                : data || {};
        };
    }
    function initSetup(vm, props) {
        if (props === void 0) { props = {}; }
        var setup = vm.$options.setup;
        var ctx = createSetupContext(vm);
        var instance = toVue3ComponentInstance(vm);
        instance.setupContext = ctx;
        // fake reactive for `toRefs(props)`
        def(props, '__ob__', createObserver());
        // resolve scopedSlots and slots to functions
        resolveScopedSlots(vm, ctx.slots);
        var binding;
        activateCurrentInstance(instance, function () {
            // make props to be fake reactive, this is for `toRefs(props)`
            binding = setup(props, ctx);
        });
        if (!binding)
            return;
        if (isFunction(binding)) {
            // keep typescript happy with the binding type.
            var bindingFunc_1 = binding;
            // keep currentInstance accessible for createElement
            vm.$options.render = function () {
                resolveScopedSlots(vm, ctx.slots);
                return activateCurrentInstance(instance, function () { return bindingFunc_1(); });
            };
            return;
        }
        else if (isObject(binding)) {
            if (isReactive(binding)) {
                binding = toRefs(binding);
            }
            vmStateManager.set(vm, 'rawBindings', binding);
            var bindingObj_1 = binding;
            Object.keys(bindingObj_1).forEach(function (name) {
                var bindingValue = bindingObj_1[name];
                if (!isRef(bindingValue)) {
                    if (!isReactive(bindingValue)) {
                        if (isFunction(bindingValue)) {
                            var copy_1 = bindingValue;
                            bindingValue = bindingValue.bind(vm);
                            Object.keys(copy_1).forEach(function (ele) {
                                bindingValue[ele] = copy_1[ele];
                            });
                        }
                        else if (!isObject(bindingValue)) {
                            bindingValue = ref(bindingValue);
                        }
                        else if (hasReactiveArrayChild(bindingValue)) {
                            // creates a custom reactive properties without make the object explicitly reactive
                            // NOTE we should try to avoid this, better implementation needed
                            customReactive(bindingValue);
                        }
                    }
                    else if (isArray(bindingValue)) {
                        bindingValue = ref(bindingValue);
                    }
                }
                asVmProperty(vm, name, bindingValue);
            });
            return;
        }
        if ((false)) {
            assert(false, "\"setup\" must return a \"Object\" or a \"Function\", got \"".concat(Object.prototype.toString
                .call(binding)
                .slice(8, -1), "\""));
        }
    }
    function customReactive(target, seen) {
        if (seen === void 0) { seen = new Set(); }
        if (seen.has(target))
            return;
        if (!isPlainObject(target) ||
            isRef(target) ||
            isReactive(target) ||
            isRaw(target))
            return;
        var Vue = getVueConstructor();
        // @ts-expect-error https://github.com/vuejs/vue/pull/12132
        var defineReactive = Vue.util.defineReactive;
        Object.keys(target).forEach(function (k) {
            var val = target[k];
            defineReactive(target, k, val);
            if (val) {
                seen.add(val);
                customReactive(val, seen);
            }
            return;
        });
    }
    function hasReactiveArrayChild(target, visited) {
        if (visited === void 0) { visited = new Map(); }
        if (visited.has(target)) {
            return visited.get(target);
        }
        visited.set(target, false);
        if (isArray(target) && isReactive(target)) {
            visited.set(target, true);
            return true;
        }
        if (!isPlainObject(target) || isRaw(target) || isRef(target)) {
            return false;
        }
        return Object.keys(target).some(function (x) {
            return hasReactiveArrayChild(target[x], visited);
        });
    }
    function createSetupContext(vm) {
        var ctx = { slots: {} };
        var propsPlain = [
            'root',
            'parent',
            'refs',
            'listeners',
            'isServer',
            'ssrContext',
        ];
        var methodReturnVoid = ['emit'];
        propsPlain.forEach(function (key) {
            var srcKey = "$".concat(key);
            proxy(ctx, key, {
                get: function () { return vm[srcKey]; },
                set: function () {
                    ("production" !== 'production') &&
                        warn("Cannot assign to '".concat(key, "' because it is a read-only property"), vm);
                },
            });
        });
        updateVmAttrs(vm, ctx);
        methodReturnVoid.forEach(function (key) {
            var srcKey = "$".concat(key);
            proxy(ctx, key, {
                get: function () {
                    return function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        var fn = vm[srcKey];
                        fn.apply(vm, args);
                    };
                },
            });
        });
        if (false) {
            ctx._vm = vm;
        }
        return ctx;
    }
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData(from, to) {
    if (!from)
        return to;
    if (!to)
        return from;
    var key;
    var toVal;
    var fromVal;
    var keys = hasSymbol ? Reflect.ownKeys(from) : Object.keys(from);
    for (var i = 0; i < keys.length; i++) {
        key = keys[i];
        // in case the object is already observed...
        if (key === '__ob__')
            continue;
        toVal = to[key];
        fromVal = from[key];
        if (!hasOwn(to, key)) {
            to[key] = fromVal;
        }
        else if (toVal !== fromVal &&
            isPlainObject(toVal) &&
            !isRef(toVal) &&
            isPlainObject(fromVal) &&
            !isRef(fromVal)) {
            mergeData(fromVal, toVal);
        }
    }
    return to;
}
function install(Vue) {
    if (isVueRegistered(Vue)) {
        if ((false)) {
            warn('[vue-composition-api] already installed. Vue.use(VueCompositionAPI) should be called only once.');
        }
        return;
    }
    if ((false)) {
        if (Vue.version) {
            if (Vue.version[0] !== '2' || Vue.version[1] !== '.') {
                warn("[vue-composition-api] only works with Vue 2, v".concat(Vue.version, " found."));
            }
        }
        else {
            warn('[vue-composition-api] no Vue version found');
        }
    }
    Vue.config.optionMergeStrategies.setup = function (parent, child) {
        return function mergedSetupFn(props, context) {
            return mergeData(isFunction(parent) ? parent(props, context) || {} : undefined, isFunction(child) ? child(props, context) || {} : undefined);
        };
    };
    setVueConstructor(Vue);
    mixin(Vue);
}
var Plugin = {
    install: function (Vue) { return install(Vue); },
};

// implementation, close to no-op
function defineComponent(options) {
    return options;
}

function defineAsyncComponent(source) {
    if (isFunction(source)) {
        source = { loader: source };
    }
    var loader = source.loader, loadingComponent = source.loadingComponent, errorComponent = source.errorComponent, _a = source.delay, delay = _a === void 0 ? 200 : _a, timeout = source.timeout, // undefined = never times out
    _b = source.suspensible, // undefined = never times out
    suspensible = _b === void 0 ? false : _b, // in Vue 3 default is true
    userOnError = source.onError;
    if (false) {
        warn("The suspensiblbe option for async components is not supported in Vue2. It is ignored.");
    }
    var pendingRequest = null;
    var retries = 0;
    var retry = function () {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function () {
        var thisRequest;
        return (pendingRequest ||
            (thisRequest = pendingRequest =
                loader()
                    .catch(function (err) {
                    err = err instanceof Error ? err : new Error(String(err));
                    if (userOnError) {
                        return new Promise(function (resolve, reject) {
                            var userRetry = function () { return resolve(retry()); };
                            var userFail = function () { return reject(err); };
                            userOnError(err, userRetry, userFail, retries + 1);
                        });
                    }
                    else {
                        throw err;
                    }
                })
                    .then(function (comp) {
                    if (thisRequest !== pendingRequest && pendingRequest) {
                        return pendingRequest;
                    }
                    if (false) {
                        warn("Async component loader resolved to undefined. " +
                            "If you are using retry(), make sure to return its return value.");
                    }
                    // interop module default
                    if (comp &&
                        (comp.__esModule || comp[Symbol.toStringTag] === 'Module')) {
                        comp = comp.default;
                    }
                    if (false) {
                        throw new Error("Invalid async component load result: ".concat(comp));
                    }
                    return comp;
                })));
    };
    return function () {
        var component = load();
        return {
            component: component,
            delay: delay,
            timeout: timeout,
            error: errorComponent,
            loading: loadingComponent,
        };
    };
}

var version = "1.7.2";
// auto install when using CDN
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(Plugin);
}




/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addNamespace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);

function addNamespace(namespace, types) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.reduce(types, function (typeObj, typeValue, typeName) {
    typeObj[typeName] = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.reduce(typeValue, function (obj, v, k) {
      obj[k] = namespace + v;
      return obj;
    }, {});
    return typeObj;
  }, {});
}

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ClientLambdaApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CustomClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ClientErAdminData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientBackGroundTasks; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var onRequest = function onRequest(config) {
  config.headers.Authorization = "Bearer ".concat(localStorage.accessToken);
  return config;
};
var onResponse = function onResponse(response) {
  return response;
};
var onErrorResponse = function onErrorResponse(error) {
  if (error.response === undefined) return Promise.reject('Ooops, algo anduvo mal por favor reintetar');else {
    // Don't handle 403 errors here - let global interceptor in App.vue handle them
    if (error.response.status === 403) {
      return Promise.reject(error);
    }
    return Promise.reject(error.response);
  }
};
var onErrorRequest = function onErrorRequest() {};
var ClientApiPrototype = function ClientApiPrototype(url) {
  var axiosInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    baseURL: url
  });
  axiosInstance.interceptors.request.use(onRequest, onErrorRequest);
  axiosInstance.interceptors.response.use(onResponse, onErrorResponse);
  return axiosInstance;
};
var ClientLambdaApi = ClientApiPrototype("https://api.expertoretail.com/v1");
var ClientErAdminData = ClientApiPrototype("https://4xjrts6rn8.execute-api.sa-east-1.amazonaws.com/production/v1");
var ClientBackGroundTasks = ClientApiPrototype("https://backgroundtasks.expertoretail.com/v1");
var CustomClient = __WEBPACK_IMPORTED_MODULE_0_axios___default.a;


/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sales; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return general; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return productAdmin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_client_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);




var sales = {
  salesTwoRanges: function salesTwoRanges(payload) {
    return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/sales-two-ranges/', {
      parameters: payload.parameters
    }, {
      needTokenValidation: true
    }).then(function (response) {
      if (response.status !== 200) {
        throw new Error('Error al obtener el status de venta');
      }
      return response.data;
    });
  },
  salesStatus: function salesStatus() {
    return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get('/sales-status/').then(function (response) {
      if (response.status !== 200) {
        throw new Error('Error al obtener el status de venta');
      }
      return response.data;
    });
  },
  pivotSales: function pivotSales(parameters, pivotParameters) {
    return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/pivot-sales/', {
      parameters: parameters.parameters,
      pivotParameters: parameters.pivotParameters
    }, {
      needTokenValidation: true
    }).then(function (response) {
      if (response.status === 204) {
        throw new Error('No hay datos para la opción seleccionada');
      } else if (response.status !== 200) {
        throw new Error('Error en request pivot-sales');
      }
      return response.data;
    });
  },
  dimFilter: function dimFilter(parameters) {
    return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/dimension-filter/', {
      parameters: parameters.parameters
    }, {
      needTokenValidation: true
    }).then(function (response) {
      if (response.status === 204) {
        throw new Error('No hay datos para la opción seleccionada');
      } else if (response.status !== 200) {
        throw new Error('Error en request pivot-sales');
      }
      return response.data;
    });
  },
  salesGrowthDashboardIndicator: function salesGrowthDashboardIndicator(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/sales-growth-dashboard-indicator/', {
              parameters: payload
            });
          case 1:
            response = _context.sent;
            if (!(response.status !== 200)) {
              _context.next = 2;
              break;
            }
            throw new Error('Error al obtener los indicadores del dashboard');
          case 2:
            return _context.abrupt("return", response.data);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  desktopDashboard: function desktopDashboard(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
      var response, _response$data, sales_growth_dashboard_indicators, sell_out_chart, store_growth, wm_product_count, stock_break_count, news_feed_indicators;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/desktop-dashboard/', {
              parameters: payload
            });
          case 1:
            response = _context2.sent;
            if (!(response.status !== 200)) {
              _context2.next = 2;
              break;
            }
            throw new Error('Error al obtener los datos del dashboard');
          case 2:
            _response$data = response.data, sales_growth_dashboard_indicators = _response$data.sales_growth_dashboard_indicators, sell_out_chart = _response$data.sell_out_chart, store_growth = _response$data.store_growth, wm_product_count = _response$data.wm_product_count, stock_break_count = _response$data.stock_break_count, news_feed_indicators = _response$data.news_feed_indicators;
            return _context2.abrupt("return", {
              salesGrowthDashboardIndicators: sales_growth_dashboard_indicators,
              sellOutChart: sell_out_chart,
              storeGrowth: store_growth,
              wmProductCount: wm_product_count.aggregation.product_count || 0,
              stockBreakCount: stock_break_count.aggregation.stock_break_status || 0,
              newsFeedIndicators: news_feed_indicators
            });
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
};
var general = {
  downloadGridToXlsx: function downloadGridToXlsx(parameters) {
    var download = __webpack_require__(115);
    return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/download-grid-data-to-xlsx/', {
      parameters: parameters.parameters
    }, {
      responseType: 'blob'
    }).then(function (response) {
      if (response.status !== 200) {
        throw new Error('Error al obtener excel con los datos de la grilla');
      }
      var ext = '.xlsx';
      var finalFileName = 'datos_grilla' + ext;
      download(response.data, finalFileName);
    });
  },
  getDesktopParameterConfig: function getDesktopParameterConfig() {
    var timeZoneOffsetMs = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc().local().format('YYYY-MM-DD');
    return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/desktop-parameter-config/?clientDatetime=".concat(timeZoneOffsetMs)).then(function (response) {
      if (response.status !== 200) {
        throw new Error('Error al obtener los parametros por defecto');
      }
      return response.data;
    });
  },
  dwJobResultStatus: function dwJobResultStatus() {
    return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get('dw-job-result-status').then(function (response) {
      if (response.status !== 200) {
        throw new Error('Error al consultar estado del trabajo DW');
      }
      return response.data;
    });
  }
};
var productAdmin = {
  getProductMasterStatus: function getProductMasterStatus() {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3() {
      var productMasterStatus;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 1;
            return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get('/poll-product-master-status/');
          case 1:
            productMasterStatus = _context3.sent;
            return _context3.abrupt("return", productMasterStatus.data);
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  downloadProductMapLegacy: function downloadProductMapLegacy(fileName) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee4() {
      var download, xlsResponse;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            download = __webpack_require__(115);
            _context4.next = 1;
            return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get('/generate-product-master-legacy/', {
              responseType: 'blob'
            });
          case 1:
            xlsResponse = _context4.sent;
            download(xlsResponse.data, "".concat(fileName, ".xlsx"));
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  updatePriceMaster: function updatePriceMaster(file, priceType, buildType) {
    var formData = new FormData();
    formData.append('file', file);
    return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post("/update-product-price?price_type=".concat(priceType, "&build_type=").concat(buildType), formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(function (response) {
      if (response.status !== 200) {
        throw new Error('Error al subir el maestro de productos');
      }
      return response.data;
    });
  }
};

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_GeneralUtils__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_DimensionUtils__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_GeneralValidator__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_FilterObjectParameterBuilder__ = __webpack_require__(971);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__mixins_GeneralUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__mixins_DimensionUtils__["a"]; });
/* unused harmony reexport GeneralValidator */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__mixins_FilterObjectParameterBuilder__["a"]; });






/***/ }),
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return newsFeedList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return newsFeedMetrics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return postNewContentToFeed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getHashtags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addPostHashtags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return removePostHashtag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getPostComments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getMentionableUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return updateComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return deleteComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return deletePost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deleteCheckInOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getHashtagDashboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getExecutionFocusRuleTypes; });
/* unused harmony export createExecutionFocusRuleType */
/* unused harmony export updateExecutionFocusRuleType */
/* unused harmony export deleteExecutionFocusRuleType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getExecutionFocusList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getExecutionFocus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createExecutionFocus; });
/* unused harmony export updateExecutionFocus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deactivateExecutionFocus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return deleteExecutionFocus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getExecutionFocusVisits; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getExecutionFocusVisit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getExecutionFocusVisitPhoto; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_client_js__ = __webpack_require__(39);



var newsFeedList = function newsFeedList(page) {
  var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
  var filters = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var params = new URLSearchParams({
    page: page,
    per_page: perPage,
    include_check_ins: true
  });
  if (search) params.append('search', search);
  if (filters.hashtag_id) params.append('hashtag_id', filters.hashtag_id);
  if (filters.from_date) params.append('from_date', filters.from_date);
  if (filters.to_date) params.append('to_date', filters.to_date);
  return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/news-feed-list?".concat(params.toString())).then(function (response) {
    if (response.status !== 200) throw new Error('Error al obtener el listado del feed');
    return response.data;
  });
};
var newsFeedMetrics = function newsFeedMetrics() {
  return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get('/news-feed/news-feed-metrics').then(function (response) {
    if (response.status !== 200) throw new Error('Error al obtener las métricas del feed');
    return response.data;
  });
};
var postNewContentToFeed = /*#__PURE__*/function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee(payload) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/post-new-content-to-feed/', payload, {
            needTokenValidation: true
          });
        case 1:
          response = _context.sent;
          if (!(response.data && response.data.status === 'ERROR')) {
            _context.next = 2;
            break;
          }
          throw new Error(response.data.description || 'Error al subir el contenido al feed');
        case 2:
          if (!(response.status !== 201)) {
            _context.next = 3;
            break;
          }
          throw new Error('Error al subir el contenido al feed');
        case 3:
          return _context.abrupt("return", response.data);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function postNewContentToFeed(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getHashtags = function getHashtags() {
  var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var params = search ? "?search=".concat(encodeURIComponent(search)) : '';
  return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/news-feed/hashtags".concat(params)).then(function (response) {
    if (response.status !== 200) throw new Error('Error al obtener los hashtags');
    return response.data;
  });
};
var addPostHashtags = function addPostHashtags(postId, hashtagIds) {
  return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post("/news-feed/".concat(postId, "/hashtags"), {
    hashtag_ids: hashtagIds
  }).then(function (response) {
    if (response.status !== 200 && response.status !== 201) throw new Error('Error al agregar hashtags');
    return response.data;
  });
};
var removePostHashtag = function removePostHashtag(postId, hashtagId) {
  return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */]["delete"]("/news-feed/".concat(postId, "/hashtags/").concat(hashtagId)).then(function (response) {
    if (response.status !== 200 && response.status !== 204) throw new Error('Error al quitar el hashtag');
    return response.data;
  });
};
var getPostComments = function getPostComments(postId) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
  return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/news-feed/".concat(postId, "/comments?page=").concat(page, "&per_page=").concat(perPage)).then(function (response) {
    if (response.status !== 200) throw new Error('Error al obtener los comentarios');
    return response.data;
  });
};
var getMentionableUsers = function getMentionableUsers() {
  var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var params = search ? "?search=".concat(encodeURIComponent(search)) : '';
  return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/news-feed/mentionable-users".concat(params)).then(function (response) {
    if (response.status !== 200) throw new Error('Error al obtener usuarios mencionables');
    return response.data;
  });
};
var createComment = function createComment(postId, content) {
  var mentionedUserIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var body = {
    content: content
  };
  if (mentionedUserIds.length > 0) body.mentioned_user_ids = mentionedUserIds;
  return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post("/news-feed/".concat(postId, "/comments"), body).then(function (response) {
    if (response.status !== 201) throw new Error('Error al crear el comentario');
    return response.data;
  });
};
var updateComment = function updateComment(commentId, content) {
  var mentionedUserIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var body = {
    content: content
  };
  if (mentionedUserIds !== undefined) body.mentioned_user_ids = mentionedUserIds;
  return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].put("/news-feed/comments/".concat(commentId), body).then(function (response) {
    if (response.status !== 200) throw new Error('Error al editar el comentario');
    return response.data;
  });
};
var deleteComment = function deleteComment(commentId) {
  return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */]["delete"]("/news-feed/comments/".concat(commentId)).then(function (response) {
    if (response.status !== 200) throw new Error('Error al eliminar el comentario');
    return response.data;
  });
};
var deletePost = /*#__PURE__*/function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2(postId) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */]["delete"]("/news-feed/".concat(postId));
        case 1:
          response = _context2.sent;
          if (!(response.status === 403)) {
            _context2.next = 2;
            break;
          }
          throw new Error('No tienes permiso para eliminar esta publicación');
        case 2:
          if (!(response.status === 404)) {
            _context2.next = 3;
            break;
          }
          throw new Error('La publicación no existe o ya fue eliminada');
        case 3:
          if (!(response.status !== 200)) {
            _context2.next = 4;
            break;
          }
          throw new Error('Error al eliminar la publicación');
        case 4:
          return _context2.abrupt("return", response.data);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function deletePost(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var deleteCheckInOut = /*#__PURE__*/function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3(checkInId, target) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */]["delete"]("/user-store-check-in-out/".concat(checkInId, "?target=").concat(target));
        case 1:
          response = _context3.sent;
          if (!(response.status === 400)) {
            _context3.next = 2;
            break;
          }
          throw new Error('Parámetro target inválido o ausente');
        case 2:
          if (!(response.status === 401)) {
            _context3.next = 3;
            break;
          }
          throw new Error('No autorizado');
        case 3:
          if (!(response.status !== 200)) {
            _context3.next = 4;
            break;
          }
          throw new Error('Error al eliminar el registro');
        case 4:
          return _context3.abrupt("return", response.data);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function deleteCheckInOut(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();
var getHashtagDashboard = function getHashtagDashboard(startDate, endDate) {
  var params = new URLSearchParams();
  if (startDate) params.append('start_date', startDate);
  if (endDate) params.append('end_date', endDate);
  var query = params.toString();
  return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/news-feed/hashtags/dashboard".concat(query ? '?' + query : '')).then(function (response) {
    if (response.status !== 200) throw new Error('Error al obtener el dashboard de hashtags');
    return response.data;
  });
};
var getExecutionFocusRuleTypes = function getExecutionFocusRuleTypes() {
  return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get('/execution-focus/rule-types').then(function (response) {
    if (response.status !== 200) throw new Error('Error al obtener los tipos de verificación');
    return response.data;
  });
};
var createExecutionFocusRuleType = function createExecutionFocusRuleType(payload) {
  return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/execution-focus/rule-types', payload).then(function (response) {
    if (response.status !== 201) throw new Error('Error al crear el tipo de verificación');
    return response.data;
  });
};
var updateExecutionFocusRuleType = function updateExecutionFocusRuleType(id, payload) {
  return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].put("/execution-focus/rule-types/".concat(id), payload).then(function (response) {
    if (response.status !== 200) throw new Error('Error al actualizar el tipo de verificación');
    return response.data;
  });
};
var deleteExecutionFocusRuleType = function deleteExecutionFocusRuleType(id) {
  return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */]["delete"]("/execution-focus/rule-types/".concat(id)).then(function (response) {
    if (response.status !== 200) throw new Error('Error al desactivar el tipo de verificación');
    return response.data;
  });
};
var getExecutionFocusList = function getExecutionFocusList() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = new URLSearchParams();
  if (filters.active !== undefined && filters.active !== null) params.append('active', filters.active);
  if (filters.start_date) params.append('start_date', filters.start_date);
  if (filters.end_date) params.append('end_date', filters.end_date);
  var query = params.toString();
  return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/execution-focus".concat(query ? '?' + query : '')).then(function (response) {
    if (response.status !== 200) throw new Error('Error al obtener los focos de ejecución');
    return response.data;
  });
};
var getExecutionFocus = function getExecutionFocus(focusId) {
  return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/execution-focus/".concat(focusId)).then(function (response) {
    if (response.status !== 200) throw new Error('Error al obtener el foco de ejecución');
    return response.data;
  });
};
var createExecutionFocus = function createExecutionFocus(payload) {
  return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/execution-focus', payload).then(function (response) {
    if (response.status !== 201) throw new Error('Error al crear el foco de ejecución');
    return response.data;
  });
};
var updateExecutionFocus = function updateExecutionFocus(focusId, payload) {
  return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].put("/execution-focus/".concat(focusId), payload).then(function (response) {
    if (response.status !== 200) throw new Error('Error al actualizar el foco de ejecución');
    return response.data;
  });
};
var deactivateExecutionFocus = /*#__PURE__*/function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee4(focusId) {
    var response, _err$data, status, msg, _t;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].patch("/execution-focus/".concat(focusId, "/deactivate"), {});
        case 1:
          response = _context4.sent;
          if (!(response.status !== 200 && response.status !== 204)) {
            _context4.next = 2;
            break;
          }
          throw new Error('Error al desactivar el foco de ejecución');
        case 2:
          return _context4.abrupt("return", response.data);
        case 3:
          _context4.prev = 3;
          _t = _context4["catch"](0);
          status = _t === null || _t === void 0 ? void 0 : _t.status;
          if (!(status === 404)) {
            _context4.next = 4;
            break;
          }
          throw new Error('No se encontró el foco de ejecución.');
        case 4:
          msg = _t === null || _t === void 0 || (_err$data = _t.data) === null || _err$data === void 0 ? void 0 : _err$data.message;
          if (!(typeof msg === 'string' && msg.trim())) {
            _context4.next = 5;
            break;
          }
          throw new Error(msg);
        case 5:
          if (!(_t instanceof Error && _t.message)) {
            _context4.next = 6;
            break;
          }
          throw _t;
        case 6:
          throw new Error('Error al desactivar el foco de ejecución');
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 3]]);
  }));
  return function deactivateExecutionFocus(_x5) {
    return _ref4.apply(this, arguments);
  };
}();
var deleteExecutionFocus = /*#__PURE__*/function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee5(focusId) {
    var response, _err$data2, status, msg, _t2;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */]["delete"]("/execution-focus/".concat(focusId));
        case 1:
          response = _context5.sent;
          if (!(response.status !== 200)) {
            _context5.next = 2;
            break;
          }
          throw new Error('Error al eliminar el foco de ejecución');
        case 2:
          return _context5.abrupt("return", response.data);
        case 3:
          _context5.prev = 3;
          _t2 = _context5["catch"](0);
          status = _t2 === null || _t2 === void 0 ? void 0 : _t2.status;
          if (!(status === 404)) {
            _context5.next = 4;
            break;
          }
          throw new Error('No se encontró el foco de ejecución.');
        case 4:
          if (!(status === 403)) {
            _context5.next = 5;
            break;
          }
          throw new Error('No tienes permiso para eliminar este foco.');
        case 5:
          msg = _t2 === null || _t2 === void 0 || (_err$data2 = _t2.data) === null || _err$data2 === void 0 ? void 0 : _err$data2.message;
          if (!(typeof msg === 'string' && msg.trim())) {
            _context5.next = 6;
            break;
          }
          throw new Error(msg);
        case 6:
          if (!(_t2 instanceof Error && _t2.message)) {
            _context5.next = 7;
            break;
          }
          throw _t2;
        case 7:
          throw new Error('Error al eliminar el foco de ejecución');
        case 8:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 3]]);
  }));
  return function deleteExecutionFocus(_x6) {
    return _ref5.apply(this, arguments);
  };
}();
var getExecutionFocusVisits = function getExecutionFocusVisits(focusId) {
  return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/execution-focus/".concat(focusId, "/visits")).then(function (response) {
    if (response.status !== 200) throw new Error('Error al obtener las visitas');
    return response.data;
  });
};
var getExecutionFocusVisit = function getExecutionFocusVisit(visitId) {
  return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/execution-focus/visit/".concat(visitId)).then(function (response) {
    if (response.status !== 200) throw new Error('Error al obtener la visita');
    return response.data;
  });
};
var getExecutionFocusVisitPhoto = function getExecutionFocusVisitPhoto(visitId, ruleTypeId) {
  return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/execution-focus/visit/".concat(visitId, "/photo/").concat(ruleTypeId)).then(function (response) {
    if (response.status !== 200) throw new Error('Error al obtener la foto');
    return response.data;
  });
};

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NAMESPACE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_utils_NamespaceHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(40);

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var NAMESPACE = 'filters/';
var _types = {
  getters: {
    HAS_SELECTED_FILTERS: 'GETTER_HAS_SELECTED_FILTERS',
    STORE_FILTERS: 'GETTER_STORE_FILTERS',
    PRODUCT_FILTERS: 'GETTER_PRODUCT_FILTERS',
    HIERARCHY_BY_FILTER: 'GETTER_HIERARCHY_BY_FILTER'
  },
  actions: {
    SET_SELECTED_FILTERS: 'SET_SELECTED_FILTERS',
    RESET_SELECTED_FILTERS: 'RESET_SELECTED_FILTERS',
    REMOVE_SELECTED_FILTER_IN_CASCADE: 'REMOVE_SELECTED_FILTER_IN_CASCADE'
  },
  mutations: {
    SELECTED_STORE_FILTERS: 'MUTATE_SELECTED_STORE_FILTERS',
    SELECTED_PRODUCT_FILTERS: 'MUTATE_SELECTED_PRODUCT_FILTERS',
    ADD_SELECTED_FILTER: 'MUTATE_ADD_SELECTED_FILTER',
    REMOVE_SELECTED_FILTER: 'MUTATE_REMOVE_SELECTED_FILTER',
    PUSH_ASYNC_PRODUCT_TO_POOL: 'PUSH_ASYNC_PRODUCT_TO_POOL'
  }
};
var Types = Object(__WEBPACK_IMPORTED_MODULE_1__app_shared_utils_NamespaceHelper__["a" /* addNamespace */])(NAMESPACE, _types);
var Filters = {
  namespaced: true,
  state: function state() {
    return {
      selectedStoreFilters: {},
      selectedProductFilters: {},
      asyncProductPool: []
    };
  },
  getters: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, _types.getters.HAS_SELECTED_FILTERS, function (state) {
    var filters = _objectSpread(_objectSpread({}, state.selectedStoreFilters), state.selectedProductFilters);
    for (var filter in filters) {
      if (filters[filter].length > 0) return true;
    }
    return false;
  }), _types.getters.STORE_FILTERS, function (state, getters, rootState, rootGetters) {
    return rootGetters.storeFilters;
  }), _types.getters.PRODUCT_FILTERS, function (state, getters, rootState, rootGetters) {
    return rootGetters.productCategoryFilters;
  }), _types.getters.HIERARCHY_BY_FILTER, function (state, getters) {
    return function (filter) {
      var getterName;
      if (filter.keyFieldType === 'store') getterName = _types.getters.STORE_FILTERS;else if (filter.keyFieldType === 'product') getterName = _types.getters.PRODUCT_FILTERS;else throw Error("Tipo de filtro ".concat(filter.keyFieldType, " no implementado"));
      return getters[getterName].find(function (hierarchy) {
        return hierarchy.levelList.map(function (level) {
          return level.id;
        }).includes(filter.keyField);
      });
    };
  }),
  actions: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, _types.actions.SET_SELECTED_FILTERS, function (_ref, _ref2) {
    var commit = _ref.commit;
    var _ref2$productFilters = _ref2.productFilters,
      productFilters = _ref2$productFilters === void 0 ? {} : _ref2$productFilters,
      _ref2$storeFilters = _ref2.storeFilters,
      storeFilters = _ref2$storeFilters === void 0 ? {} : _ref2$storeFilters,
      _ref2$asyncProductPoo = _ref2.asyncProductPool,
      asyncProductPool = _ref2$asyncProductPoo === void 0 ? {} : _ref2$asyncProductPoo;
    commit(_types.mutations.SELECTED_STORE_FILTERS, storeFilters);
    commit(_types.mutations.SELECTED_PRODUCT_FILTERS, productFilters);
    commit(_types.mutations.PUSH_ASYNC_PRODUCT_TO_POOL, asyncProductPool);
  }), _types.actions.RESET_SELECTED_FILTERS, function (_ref3) {
    var commit = _ref3.commit;
    commit(_types.mutations.SELECTED_STORE_FILTERS, {});
    commit(_types.mutations.SELECTED_PRODUCT_FILTERS, {});
  }), _types.actions.REMOVE_SELECTED_FILTER_IN_CASCADE, function (_ref4, filter) {
    var commit = _ref4.commit,
      getters = _ref4.getters,
      dispatch = _ref4.dispatch;
    commit(_types.mutations.REMOVE_SELECTED_FILTER, filter);
    var targetHierarchy = getters[_types.getters.HIERARCHY_BY_FILTER](filter);
    if (!targetHierarchy) return;
    var childLevelId = targetHierarchy.levelList.find(function (x) {
      return x.id === filter.keyField;
    }).options[0].child_level_id;
    var hasChild = childLevelId !== 'None' && childLevelId !== null;
    if (hasChild) {
      dispatch(_types.actions.REMOVE_SELECTED_FILTER_IN_CASCADE, _objectSpread(_objectSpread({}, filter), {}, {
        keyField: childLevelId
      }));
    }
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, _types.mutations.SELECTED_STORE_FILTERS, function (state, selectedStoreFilters) {
    state.selectedStoreFilters = selectedStoreFilters;
  }), _types.mutations.SELECTED_PRODUCT_FILTERS, function (state, selectedProductFilters) {
    state.selectedProductFilters = selectedProductFilters;
  }), _types.mutations.PUSH_ASYNC_PRODUCT_TO_POOL, function (state, selectedAsyncProduct) {
    state.asyncProductPool = state.asyncProductPool.concat(selectedAsyncProduct);
  }), _types.mutations.ADD_SELECTED_FILTER, function (state, filter) {
    if (filter.keyFieldType === 'store') __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.selectedStoreFilters, filter.keyField, filter.value);
    if (filter.keyFieldType === 'product') __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.selectedProductFilters, filter.keyField, filter.value);
  }), _types.mutations.REMOVE_SELECTED_FILTER, function (state, filter) {
    if (filter.keyFieldType === 'store') state.selectedStoreFilters[filter.keyField] = [];
    if (filter.keyFieldType === 'product') state.selectedProductFilters[filter.keyField] = [];
  })
};
/* harmony default export */ __webpack_exports__["b"] = (Filters);

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpertoRetailLoader_vue__ = __webpack_require__(435);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e699aea_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpertoRetailLoader_vue__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(822)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e699aea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpertoRetailLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e699aea_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpertoRetailLoader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e699aea_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpertoRetailLoader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseModal_vue__ = __webpack_require__(609);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a7c6934_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseModal_vue__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(950)
  __webpack_require__(951)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a7c6934"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a7c6934_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a7c6934_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initialState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_mobile__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_excelMassiveDownload__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_dashCustomCards__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_accumulatedSales__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_agGridPivot__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_storeGrowth__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_usersAdmin__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_priceAudition__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_gridMetricSystemWideOneMetric__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_productWm__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_dimensionFilterQuickAccess__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_filterRequestObject__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_generalKeyKpiAnalysis__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_sellOutDashboardCard__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__app_massive_download_MassiveDownloadState__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__app_sales_analysis_store_Index__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__app_store_growth_store_Index__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__app_stock_break_store_Index__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__app_weekly_sales_store_Index__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__app_daily_sales_store_Index__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__app_admin_store_Index__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__app_monthly_sales_store_Index__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__app_workspaces_store_Index__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__app_product_follow_up_store_Index__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__app_sellout_dashboard_store_Index__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__getters__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__actions__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__mutations__ = __webpack_require__(931);


















//Estados de la nueva arquitectura!















var initialState = function initialState() {
  return {
    metric: null,
    selectedMetricOption: null,
    globalFilters: '',
    routingFromInit: false,
    selectedView: '',
    selectedWeek: {
      index: '',
      category: '',
      year: 0
    },
    appAvailableHeight: 500,
    desktopParameterConfig: null,
    selectedRangeOption: 'dynamicRanges'
  };
};
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  strict: "production" !== 'production',
  // process.env.NODE_ENV !== 'production',
  getters: __WEBPACK_IMPORTED_MODULE_28__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_29__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_30__mutations__["a" /* default */],
  modules: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({
    mobile: __WEBPACK_IMPORTED_MODULE_3__modules_mobile__["a" /* default */],
    excelMassiveDownload: __WEBPACK_IMPORTED_MODULE_4__modules_excelMassiveDownload__["a" /* default */],
    dashCustomCards: __WEBPACK_IMPORTED_MODULE_5__modules_dashCustomCards__["a" /* default */],
    accumulatedSales: __WEBPACK_IMPORTED_MODULE_6__modules_accumulatedSales__["a" /* default */],
    agGridPivot: __WEBPACK_IMPORTED_MODULE_7__modules_agGridPivot__["a" /* default */],
    storeGrowth: __WEBPACK_IMPORTED_MODULE_8__modules_storeGrowth__["a" /* default */],
    usersAdmin: __WEBPACK_IMPORTED_MODULE_9__modules_usersAdmin__["a" /* default */],
    priceAudition: __WEBPACK_IMPORTED_MODULE_10__modules_priceAudition__["a" /* default */],
    gridMetricSystemWideOneMetric: __WEBPACK_IMPORTED_MODULE_11__modules_gridMetricSystemWideOneMetric__["a" /* default */],
    productWm: __WEBPACK_IMPORTED_MODULE_12__modules_productWm__["a" /* default */],
    stockBreak: __WEBPACK_IMPORTED_MODULE_20__app_stock_break_store_Index__["c" /* default */],
    dimensionFilterQuickAccess: __WEBPACK_IMPORTED_MODULE_13__modules_dimensionFilterQuickAccess__["a" /* default */],
    filterRequestObject: __WEBPACK_IMPORTED_MODULE_14__modules_filterRequestObject__["a" /* default */],
    generalKeyKpiAnalysis: __WEBPACK_IMPORTED_MODULE_15__modules_generalKeyKpiAnalysis__["a" /* default */],
    sellOutDashboardCard: __WEBPACK_IMPORTED_MODULE_16__modules_sellOutDashboardCard__["a" /* default */],
    massiveDownload: __WEBPACK_IMPORTED_MODULE_17__app_massive_download_MassiveDownloadState__["w" /* default */],
    'salesAnalysis': __WEBPACK_IMPORTED_MODULE_18__app_sales_analysis_store_Index__["b" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_19__app_store_growth_store_Index__["a" /* NAMESPACE */], __WEBPACK_IMPORTED_MODULE_19__app_store_growth_store_Index__["c" /* default */]), __WEBPACK_IMPORTED_MODULE_20__app_stock_break_store_Index__["a" /* NAMESPACE */], __WEBPACK_IMPORTED_MODULE_20__app_stock_break_store_Index__["c" /* default */]), __WEBPACK_IMPORTED_MODULE_21__app_weekly_sales_store_Index__["a" /* NAMESPACE */], __WEBPACK_IMPORTED_MODULE_21__app_weekly_sales_store_Index__["c" /* default */]), __WEBPACK_IMPORTED_MODULE_22__app_daily_sales_store_Index__["a" /* NAMESPACE */], __WEBPACK_IMPORTED_MODULE_22__app_daily_sales_store_Index__["b" /* default */]), __WEBPACK_IMPORTED_MODULE_23__app_admin_store_Index__["a" /* NAMESPACE */], __WEBPACK_IMPORTED_MODULE_23__app_admin_store_Index__["b" /* default */]), __WEBPACK_IMPORTED_MODULE_24__app_monthly_sales_store_Index__["a" /* NAMESPACE */], __WEBPACK_IMPORTED_MODULE_24__app_monthly_sales_store_Index__["c" /* default */]), __WEBPACK_IMPORTED_MODULE_25__app_workspaces_store_Index__["a" /* NAMESPACE */], __WEBPACK_IMPORTED_MODULE_25__app_workspaces_store_Index__["b" /* default */]), __WEBPACK_IMPORTED_MODULE_26__app_product_follow_up_store_Index__["a" /* NAMESPACE */], __WEBPACK_IMPORTED_MODULE_26__app_product_follow_up_store_Index__["c" /* default */]), __WEBPACK_IMPORTED_MODULE_27__app_sellout_dashboard_store_Index__["a" /* NAMESPACE */], __WEBPACK_IMPORTED_MODULE_27__app_sellout_dashboard_store_Index__["b" /* default */]),
  state: initialState()
});
if (false) {
  module.hot.accept(['@/app/sales_analysis/store/Index', '@/app/store_growth/store/Index', '@/app/stock_break/store/Index', '@/app/admin/store/Index', '@/app/daily_sales/store/Index'], function () {
    // require the updated modules
    // have to add .default here due to babel 6 module output
    var salesAnalysisModule = require('@/app/sales_analysis/store/Index')["default"];
    var storeGrowthModule = require('@/app/store_growth/store/Index')["default"];
    var stockBreakModule = require('@/app/stock_break/store/Index')["default"];
    var weeklySalesModule = require('@/app/weekly_sales/store/Index')["default"];
    var dailySalesModule = require('@/app/daily_sales/store/Index')["default"];
    var adminModule = require('@/app/admin/store/Index')["default"];
    var monthlySalesModule = require('@/app/monthly_sales/store/Index')["default"];
    // swap in the new modules and mutations
    store.hotUpdate({
      modules: {
        'salesAnalysis': salesAnalysisModule,
        'storeGrowth': storeGrowthModule,
        'stockBreak': stockBreakModule,
        'weeklySales': weeklySalesModule,
        'dailySales': dailySalesModule,
        'admin': adminModule,
        'monthlySales': monthlySalesModule
      }
    });
  });
}
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getInitConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getLongGrid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getWideGrid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return downloadLongGridToExcel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return downloadWideGridToExcel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDateGranularityConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getSalesComparative; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_client_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_sales_analysis_models_InitConfig_js__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_sales_analysis_models_SalesAnalysisAgGrid_js__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_models_OneDimensionStrategy__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_sales_analysis_models_TwoDimensionStrategy__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_models_PayloadParametersBuilder__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_sales_analysis_models_PivotParameters__ = __webpack_require__(863);










var getInitConfig = /*#__PURE__*/function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
    var initConfig;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return __WEBPACK_IMPORTED_MODULE_3__api_client_js__["c" /* ClientLambdaApi */].get('/so-analysis-parameter-config/');
        case 1:
          initConfig = _context.sent;
          return _context.abrupt("return", new __WEBPACK_IMPORTED_MODULE_4__app_sales_analysis_models_InitConfig_js__["a" /* default */](initConfig.data));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getInitConfig() {
    return _ref.apply(this, arguments);
  };
}();
var getLongGrid = /*#__PURE__*/function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2(_ref2) {
    var metrics, factTableName, dimension, strategyFilter, filters, calculatedField, longGridPayload, longGrid;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          metrics = _ref2.metrics, factTableName = _ref2.factTableName, dimension = _ref2.dimension, strategyFilter = _ref2.strategyFilter, filters = _ref2.filters, calculatedField = _ref2.calculatedField;
          longGridPayload = buildLongGridParameters({
            metrics: metrics,
            factTableName: factTableName,
            dimension: dimension,
            strategyFilter: strategyFilter,
            filters: filters,
            calculatedField: calculatedField
          });
          _context2.next = 1;
          return __WEBPACK_IMPORTED_MODULE_3__api_client_js__["c" /* ClientLambdaApi */].post('/long-grid-data/', longGridPayload);
        case 1:
          longGrid = _context2.sent;
          return _context2.abrupt("return", new __WEBPACK_IMPORTED_MODULE_5__app_sales_analysis_models_SalesAnalysisAgGrid_js__["a" /* default */](longGrid.data));
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getLongGrid(_x) {
    return _ref3.apply(this, arguments);
  };
}();
var downloadLongGridToExcel = /*#__PURE__*/function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3(_ref4) {
    var metrics, factTableName, dimension, strategyFilter, filters, calculatedField, longGridPayload;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          metrics = _ref4.metrics, factTableName = _ref4.factTableName, dimension = _ref4.dimension, strategyFilter = _ref4.strategyFilter, filters = _ref4.filters, calculatedField = _ref4.calculatedField;
          longGridPayload = buildLongGridParameters({
            metrics: metrics,
            factTableName: factTableName,
            dimension: dimension,
            strategyFilter: strategyFilter,
            filters: filters,
            calculatedField: calculatedField
          });
          _context3.next = 1;
          return downloadGridToExcel('long_grid', longGridPayload);
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function downloadLongGridToExcel(_x2) {
    return _ref5.apply(this, arguments);
  };
}();
var getWideGrid = /*#__PURE__*/function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee4(_ref6) {
    var metrics, factTableName, productDimension, storeDimension, productStrategyFilter, storeStrategyFilter, filters, wideGridPayload, wideGrid;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          metrics = _ref6.metrics, factTableName = _ref6.factTableName, productDimension = _ref6.productDimension, storeDimension = _ref6.storeDimension, productStrategyFilter = _ref6.productStrategyFilter, storeStrategyFilter = _ref6.storeStrategyFilter, filters = _ref6.filters;
          wideGridPayload = buildWideGridPayload({
            metrics: metrics,
            factTableName: factTableName,
            productDimension: productDimension,
            storeDimension: storeDimension,
            productStrategyFilter: productStrategyFilter,
            storeStrategyFilter: storeStrategyFilter,
            filters: filters
          });
          _context4.next = 1;
          return __WEBPACK_IMPORTED_MODULE_3__api_client_js__["c" /* ClientLambdaApi */].post('/wide-grid-data/', wideGridPayload);
        case 1:
          wideGrid = _context4.sent;
          return _context4.abrupt("return", new __WEBPACK_IMPORTED_MODULE_5__app_sales_analysis_models_SalesAnalysisAgGrid_js__["a" /* default */](wideGrid.data));
        case 2:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getWideGrid(_x3) {
    return _ref7.apply(this, arguments);
  };
}();
var downloadWideGridToExcel = /*#__PURE__*/function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee5(_ref8) {
    var metrics, factTableName, productDimension, storeDimension, productStrategyFilter, storeStrategyFilter, filters, wideGridPayload;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          metrics = _ref8.metrics, factTableName = _ref8.factTableName, productDimension = _ref8.productDimension, storeDimension = _ref8.storeDimension, productStrategyFilter = _ref8.productStrategyFilter, storeStrategyFilter = _ref8.storeStrategyFilter, filters = _ref8.filters;
          wideGridPayload = buildWideGridPayload({
            metrics: metrics,
            factTableName: factTableName,
            productDimension: productDimension,
            storeDimension: storeDimension,
            productStrategyFilter: productStrategyFilter,
            storeStrategyFilter: storeStrategyFilter,
            filters: filters
          });
          _context5.next = 1;
          return downloadGridToExcel('wide_grid', wideGridPayload);
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function downloadWideGridToExcel(_x4) {
    return _ref9.apply(this, arguments);
  };
}();
var downloadGridToExcel = /*#__PURE__*/function () {
  var _ref0 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee6(type, parameters) {
    var blobCsvFile;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 1;
          return __WEBPACK_IMPORTED_MODULE_3__api_client_js__["c" /* ClientLambdaApi */].post("/download-grid-data-to-xlsx/?grid=".concat(type), parameters, {
            responseType: 'blob'
          });
        case 1:
          blobCsvFile = _context6.sent;
          Object(__WEBPACK_IMPORTED_MODULE_2_file_saver__["saveAs"])(blobCsvFile.data, "".concat(type, ".xlsx"));
        case 2:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function downloadGridToExcel(_x5, _x6) {
    return _ref0.apply(this, arguments);
  };
}();
var buildLongGridParameters = function buildLongGridParameters(_ref1) {
  var metrics = _ref1.metrics,
    factTableName = _ref1.factTableName,
    dimension = _ref1.dimension,
    strategyFilter = _ref1.strategyFilter,
    filters = _ref1.filters,
    calculatedField = _ref1.calculatedField;
  var oneDimensionStrategy = new __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_models_OneDimensionStrategy__["a" /* default */](dimension, strategyFilter);
  var payloadParametersBuilder = new __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_models_PayloadParametersBuilder__["a" /* default */]({
    metrics: metrics,
    factTableName: factTableName,
    filters: filters
  });
  var parameters = payloadParametersBuilder.build(oneDimensionStrategy);
  parameters.calculated_field = calculatedField;
  return {
    parameters: parameters
  };
};
var buildWideGridParameters = function buildWideGridParameters(_ref10) {
  var metrics = _ref10.metrics,
    factTableName = _ref10.factTableName,
    productDimension = _ref10.productDimension,
    storeDimension = _ref10.storeDimension,
    productStrategyFilter = _ref10.productStrategyFilter,
    storeStrategyFilter = _ref10.storeStrategyFilter,
    filters = _ref10.filters;
  var productStrategy = new __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_models_OneDimensionStrategy__["a" /* default */](productDimension, productStrategyFilter);
  var storeStrategy = new __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_models_OneDimensionStrategy__["a" /* default */](storeDimension, storeStrategyFilter);
  var twoDimensionStrategy = new __WEBPACK_IMPORTED_MODULE_7__app_sales_analysis_models_TwoDimensionStrategy__["a" /* default */]({
    productStrategy: productStrategy,
    storeStrategy: storeStrategy
  });
  var payloadParametersBuilder = new __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_models_PayloadParametersBuilder__["a" /* default */]({
    metrics: metrics,
    factTableName: factTableName,
    filters: filters
  });
  var wideGridParameters = payloadParametersBuilder.build(twoDimensionStrategy);
  return wideGridParameters;
};
var buildWideGridPivotParameters = function buildWideGridPivotParameters(wideGridParameters) {
  var indexDim = wideGridParameters.product_dimensions[0];
  var column = wideGridParameters.store_dimensions[0];
  return new __WEBPACK_IMPORTED_MODULE_9__app_sales_analysis_models_PivotParameters__["a" /* default */](indexDim, column);
};
var buildWideGridPayload = function buildWideGridPayload(_ref11) {
  var metrics = _ref11.metrics,
    factTableName = _ref11.factTableName,
    productDimension = _ref11.productDimension,
    storeDimension = _ref11.storeDimension,
    productStrategyFilter = _ref11.productStrategyFilter,
    storeStrategyFilter = _ref11.storeStrategyFilter,
    filters = _ref11.filters;
  var parameters = buildWideGridParameters({
    metrics: metrics,
    factTableName: factTableName,
    productDimension: productDimension,
    storeDimension: storeDimension,
    productStrategyFilter: productStrategyFilter,
    storeStrategyFilter: storeStrategyFilter,
    filters: filters
  });
  var pivotParameters = buildWideGridPivotParameters(parameters);
  return {
    parameters: parameters,
    pivotParameters: pivotParameters
  };
};
var getDateGranularityConfig = /*#__PURE__*/function () {
  var _ref12 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee7(factTableName) {
    var dateGranularityConfig;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 1;
          return __WEBPACK_IMPORTED_MODULE_3__api_client_js__["c" /* ClientLambdaApi */].get("/date-agg-report-config/?fact_table=".concat(factTableName));
        case 1:
          dateGranularityConfig = _context7.sent;
          return _context7.abrupt("return", dateGranularityConfig.data);
        case 2:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function getDateGranularityConfig(_x7) {
    return _ref12.apply(this, arguments);
  };
}();
var getSalesComparative = /*#__PURE__*/function () {
  var _ref13 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee8(parameters) {
    var salesComparative;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 1;
          return __WEBPACK_IMPORTED_MODULE_3__api_client_js__["c" /* ClientLambdaApi */].post('/sales-comparative', {
            parameters: parameters
          });
        case 1:
          salesComparative = _context8.sent;
          return _context8.abrupt("return", salesComparative.data);
        case 2:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function getSalesComparative(_x8) {
    return _ref13.apply(this, arguments);
  };
}();


/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return storeListParameters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return storeDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return productParameters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return newStockParameters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WmProductParameters; });
var storeListParameters = {
  'parameters': {
    'store_filters': {
      'retail_id': [],
      'store_id': [],
      'comuna_id': [],
      'region_id': [],
      'store_type_id': [1],
      'mall_id': [],
      'distribution_type_id': [],
      'retail_type_id': []
    },
    'product_filters': {
      'product_map_id': [],
      'product_id': [],
      'product_category_hlev1_id': [],
      'product_category_hlev2_id': [],
      'product_category_hlev3_id': [],
      'product_category_hlev4_id': []
    },
    'store_dimensions': ['retail_name', 'retail_store_code', 'retail_store_name', 'region', 'comuna', 'mall', 'store_id'],
    'product_dimensions': [],
    'metrics': {
      'normal': ['quantity_sold', 'real_sales_cost', 'real_sales_amount', 'stock_quantity', 'real_stock_pvp_amount'],
      'var': []
    },
    'fact': {
      'type': 'table',
      'name': 'dw_this_month'
    },
    'sort': {
      'field': 'quantity_sold',
      'dir': 'desc'
    },
    'limit': 0,
    'offset': 0
  }
};
var storeDetail = {
  'parameters': {
    'store_filters': {
      'retail_id': [],
      'store_id': [],
      'comuna_id': [],
      'region_id': [],
      'store_type_id': [],
      'mall_id': [],
      'distribution_type_id': [],
      'retail_type_id': []
    },
    'product_filters': {
      'product_map_id': [],
      'product_id': [],
      'product_category_hlev1_id': [],
      'product_category_hlev2_id': [],
      'product_category_hlev3_id': [],
      'product_category_hlev4_id': []
    },
    'store_dimensions': ['retail_name', 'store_id', 'retail_store_code', 'retail_store_name', 'region', 'comuna', 'mall'],
    'product_dimensions': [],
    'metrics': {
      'normal': ['quantity_sold', 'real_sales_cost', 'real_sales_amount', 'stock_quantity', 'real_stock_pvp_amount', 'stock_quantity_wm', 'new_stock_delta_quantity'],
      'var': []
    },
    'fact': {
      'type': 'table',
      'name': 'dw_this_month'
    },
    'sort': {
      'field': 'quantity_sold',
      'dir': 'desc'
    },
    'limit': 0,
    'offset': 0
  }
};
var productParameters = {
  'parameters': {
    'store_filters': {
      'retail_id': [],
      'store_id': [],
      'comuna_id': [],
      'region_id': [],
      'store_type_id': [],
      'mall_id': [],
      'distribution_type_id': [],
      'retail_type_id': []
    },
    'product_filters': {
      'product_map_id': [],
      'product_id': [],
      'product_category_hlev1_id': [],
      'product_category_hlev2_id': [],
      'product_category_hlev3_id': [],
      'product_category_hlev4_id': []
    },
    'store_dimensions': [],
    'product_dimensions': ['product_map_id', 'retail_product_code', 'retail_product_description', 'vendor_product_code', 'vendor_product_description'],
    'metrics': {
      'normal': ['quantity_sold', 'real_sales_cost', 'real_sales_amount', 'stock_quantity', 'real_stock_pvp_amount'],
      'var': []
    },
    'fact': {
      'type': 'table',
      'name': 'dw_this_month'
    },
    'sort': {
      'field': 'quantity_sold',
      'dir': 'desc'
    },
    'limit': 0,
    'offset': 0
  }
};
var newStockParameters = {
  'parameters': {
    'store_filters': {
      'retail_id': [],
      'store_id': [],
      'comuna_id': [],
      'region_id': [],
      'store_type_id': [],
      'mall_id': [],
      'distribution_type_id': [],
      'retail_type_id': []
    },
    'product_filters': {
      'product_map_id': [],
      'product_id': [],
      'product_category_hlev1_id': [],
      'product_category_hlev2_id': [],
      'product_category_hlev3_id': [],
      'product_category_hlev4_id': []
    },
    'store_dimensions': [],
    'product_dimensions': ['product_map_id', 'retail_product_code', 'retail_product_description', 'vendor_product_code', 'vendor_product_description'],
    'metrics': {
      'normal': ['delta'],
      'var': []
    },
    'fact': {
      'type': 'table',
      'name': 'dw_new_stock'
    },
    'sort': {
      'field': 'delta',
      'dir': 'desc'
    },
    'limit': 0,
    'offset': 0
  }
};
var WmProductParameters = {
  'parameters': {
    'store_filters': {
      'retail_id': [],
      'store_id': [],
      'comuna_id': [],
      'region_id': [],
      'store_type_id': [],
      'mall_id': [],
      'distribution_type_id': [],
      'retail_type_id': []
    },
    'product_filters': {
      'product_map_id': [],
      'product_id': [],
      'product_category_hlev1_id': [],
      'product_category_hlev2_id': [],
      'product_category_hlev3_id': [],
      'product_category_hlev4_id': []
    },
    'store_dimensions': [],
    'product_dimensions': ['product_map_id', 'retail_product_code', 'retail_product_description', 'vendor_product_code', 'vendor_product_description'],
    'metrics': {
      'normal': ['quantity_sold_1', 'stock_quantity', 'real_stock_pvp_amount'],
      'var': []
    },
    'fact': {
      'type': 'table',
      'name': 'dw_product_wm'
    },
    'sort': {
      'field': 'stock_quantity',
      'dir': 'desc'
    },
    'limit': 0,
    'offset': 0
  }
};


/***/ }),
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return salesTwoRanges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return downloadGridToXlsx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pivotSales; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getLongGrid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return downloadFile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_client_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_models_AgGrid_js__ = __webpack_require__(868);




var getLongGrid = /*#__PURE__*/function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee(longGridPayload) {
    var longGrid;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/long-grid-data/', longGridPayload);
        case 1:
          longGrid = _context.sent;
          return _context.abrupt("return", new __WEBPACK_IMPORTED_MODULE_3__app_shared_models_AgGrid_js__["a" /* default */](longGrid.data));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getLongGrid(_x) {
    return _ref.apply(this, arguments);
  };
}();
var salesTwoRanges = /*#__PURE__*/function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2(payload) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/sales-two-ranges/', {
            parameters: payload.parameters
          });
        case 1:
          response = _context2.sent;
          if (!(response.status !== 200)) {
            _context2.next = 2;
            break;
          }
          throw new Error('Error al obtener el status de venta');
        case 2:
          return _context2.abrupt("return", response.data);
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function salesTwoRanges(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var downloadGridToXlsx = /*#__PURE__*/function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3(payload) {
    var data, downloadGridPromise, _t;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          data = {
            parameters: payload.parameters
          };
          _context3.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/download-grid-data-to-xlsx/', data, {
            responseType: 'blob'
          });
        case 1:
          downloadGridPromise = _context3.sent;
          _context3.prev = 2;
          downloadFile(downloadGridPromise, 'datos_grilla.xlsx');
          _context3.next = 4;
          break;
        case 3:
          _context3.prev = 3;
          _t = _context3["catch"](2);
          throw new Error('Error al descargar el excel');
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[2, 3]]);
  }));
  return function downloadGridToXlsx(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
var downloadFile = /*#__PURE__*/function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee4(downloadPromise, filename) {
    var download, response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          download = __webpack_require__(115);
          _context4.next = 1;
          return downloadPromise;
        case 1:
          response = _context4.sent;
          if (!(response.status !== 200)) {
            _context4.next = 2;
            break;
          }
          throw new Error('Error al descargar el archivo');
        case 2:
          download(response.data, filename);
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function downloadFile(_x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();
var pivotSales = /*#__PURE__*/function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee5(parameters) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/pivot-sales/', {
            parameters: parameters.parameters,
            pivotParameters: parameters.pivotParameters
          });
        case 1:
          response = _context5.sent;
          if (!(response.status === 204)) {
            _context5.next = 2;
            break;
          }
          throw new Error('No hay datos para la opción seleccionada');
        case 2:
          if (!(response.status !== 200)) {
            _context5.next = 3;
            break;
          }
          throw new Error('Error en request pivot-sales');
        case 3:
          return _context5.abrupt("return", response.data);
        case 4:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function pivotSales(_x6) {
    return _ref5.apply(this, arguments);
  };
}();


/***/ }),
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reportParameters; });
var productWmGridParameters = {
  'parameters': {
    'store_filters': {
      'retail_id': []
    },
    'product_dimensions': ['vendor_product'],
    'store_dimensions': ['retail_store_name'],
    'metrics': {
      'normal': ['stock_quantity'],
      'var': []
    },
    'fact': {
      'type': 'table',
      'name': 'dw_product_wm'
    },
    'custom_response': 3,
    'limit': 0,
    'offset': 0
  },
  'pivotParameters': {
    'index_dim': ['vendor_product'],
    'column': 'retail_store_name'
  }
};
var stockBreakGridParameters = {
  'parameters': {
    'store_filters': {
      'retail_id': ['']
    },
    'product_dimensions': ['vendor_product'],
    'store_dimensions': ['retail_store_name'],
    'metrics': {
      'normal': ['stock_break_status'],
      'var': []
    },
    'fact': {
      'type': 'table',
      'name': 'dw_stock_break'
    },
    'limit': 0,
    'offset': 0
  },
  'pivotParameters': {
    'index_dim': ['vendor_product'],
    'column': 'retail_store_name'
  }
};
var priceAuditionGridParameters = {
  'parameters': {
    'store_filters': {
      'retail_id': ['10100']
    },
    'product_filters': {
      'attr_3_id': []
    },
    'product_dimensions': ['vendor_product'],
    'store_dimensions': ['retail_store_name'],
    'metrics': {
      'normal': ['not_ok_vs_b2b'],
      'var': []
    },
    'fact': {
      'type': 'table',
      'name': 'dw_price_audition'
    },
    'date_filters': {
      'date': {
        'operator': 'BT',
        'value': []
      }
    },
    'custom_response': 3,
    'limit': 0,
    'offset': 0
  },
  'pivotParameters': {
    'index_dim': ['vendor_product'],
    'column': 'retail_store_name'
  }
};
//
var productWmRetailSelector = {
  'parameters': {
    'store_dimensions': ['retail_id', 'retail_name'],
    'metrics': {
      'normal': ['product_count'],
      'var': []
    },
    'fact': {
      'type': 'table',
      'name': 'dw_product_wm'
    },
    'sort': {
      'field': 'product_count',
      'dir': 'desc'
    },
    'limit': 0,
    'offset': 0
  }
};
//
var stockBreakRetailSelector = {
  'parameters': {
    'store_dimensions': ['retail_name', 'retail_id'],
    'metrics': {
      'normal': ['stock_break_status'],
      'var': []
    },
    'fact': {
      'type': 'table',
      'name': 'dw_stock_break'
    },
    'sort': {
      'field': 'stock_break_status',
      'dir': 'DESC'
    },
    'limit': 0,
    'offset': 0
  }
};
//
var priceAuditionRetailSelector = {
  'parameters': {
    'store_dimensions': ['retail_id', 'retail_name'],
    'metrics': {
      'normal': ['not_ok_vs_b2b'],
      'var': []
    },
    'fact': {
      'type': 'table',
      'name': 'dw_price_audition'
    },
    'sort': {
      'field': 'not_ok_vs_b2b',
      'dir': 'desc'
    },
    'limit': 0,
    'offset': 0
  }
};
//
var productWmDimensionFilter = {
  'parameters': {
    'store_filters': {
      'retail_id': []
    },
    'product_dimensions': ['attr_3'],
    'store_dimensions': [],
    'metrics': {
      'normal': ['product_count'],
      'var': []
    },
    'fact': {
      'type': 'table',
      'name': 'dw_product_wm'
    },
    'sort': {
      'field': 'product_count',
      'dir': 'desc'
    },
    'limit': 0,
    'offset': 0
  }
};
//
var stockBreakDimensionFilter = {
  'parameters': {
    'store_filters': {
      'retail_id': []
    },
    'product_dimensions': [],
    'store_dimensions': [],
    'metrics': {
      'normal': ['stock_break_status'],
      'var': []
    },
    'fact': {
      'type': 'table',
      'name': 'dw_stock_break'
    },
    'sort': {
      'field': 'stock_break_status',
      'dir': 'desc'
    },
    'limit': 0,
    'offset': 0
  }
};
//
var priceAuditionDimensionFilter = {
  'parameters': {
    'store_filters': {
      'retail_id': []
    },
    'product_dimensions': [],
    'store_dimensions': [],
    'metrics': {
      'normal': ['not_ok_vs_b2b'],
      'var': []
    },
    'fact': {
      'type': 'table',
      'name': 'dw_price_audition'
    },
    'sort': {
      'field': 'not_ok_vs_b2b',
      'dir': 'desc'
    },
    'limit': 0,
    'offset': 0
  }
};
var productWmProductSelector = {
  'parameters': {
    'store_filters': {
      'retail_id': []
    },
    'product_dimensions': ['vendor_product', 'product_id', 'vendor_product_code'],
    'metrics': {
      'normal': ['stock_quantity'],
      'var': []
    },
    'fact': {
      'type': 'table',
      'name': 'dw_product_wm'
    },
    'sort': {
      'field': 'stock_quantity',
      'dir': 'desc'
    },
    'limit': 2,
    'offset': 0
  }
};
var stockBreakProductSelector = {
  'parameters': {
    'store_filters': {
      'retail_id': []
    },
    'product_dimensions': ['vendor_product', 'product_id', 'vendor_product_code'],
    'metrics': {
      'normal': ['stock_break_status'],
      'var': []
    },
    'fact': {
      'type': 'table',
      'name': 'dw_stock_break'
    },
    'sort': {
      'field': 'stock_break_status',
      'dir': 'desc'
    },
    'limit': 0,
    'offset': 0
  }
};
var priceAuditionProductSelector = {
  'parameters': {
    'store_filters': {
      'retail_id': []
    },
    'product_dimensions': ['vendor_product', 'product_id', 'vendor_product_code'],
    'metrics': {
      'normal': ['not_ok_vs_b2b'],
      'var': []
    },
    'fact': {
      'type': 'table',
      'name': 'dw_price_audition'
    },
    'sort': {
      'field': 'not_ok_vs_b2b',
      'dir': 'desc'
    },
    'limit': 0,
    'offset': 0
  }
};
// ********************************************************************************************************************
//                                                Excel Download Parameters
// ********************************************************************************************************************
var productWmExcelParameters = {
  'parameters': {
    'store_filters': {
      'retail_id': []
    },
    'product_dimensions': ['vendor_product_code', 'vendor_product_description'],
    'store_dimensions': ['retail_name', 'retail_store_code', 'retail_store_name'],
    'metrics': {
      'normal': ['week_1', 'week_2', 'week_3', 'week_4', 'stock_quantity'],
      'var': []
    },
    'fact': {
      'type': 'table',
      'name': 'dw_product_wm'
    },
    'custom_response': 3,
    'limit': 0,
    'offset': 0
  }
};
var stockBreakExcelParameters = {
  'parameters': {
    'store_filters': {
      'retail_id': []
    },
    'product_dimensions': ['vendor_product_code', 'vendor_product_description'],
    'store_dimensions': ['retail_name', 'retail_store_code', 'retail_store_name'],
    'metrics': {
      'normal': ['week_1', 'week_2', 'week_3', 'week_4', 'week_avg', 'woi', 'transfer_quantity', 'stock_quantity', 'stock_break_status', 'first_suggested', 'final_suggested', 'retail_suggested_condition'],
      'var': []
    },
    'fact': {
      'type': 'table',
      'name': 'dw_stock_break'
    },
    'custom_response': 3,
    'limit': 0,
    'offset': 0
  }
};
var priceAuditionExcelParameters = {
  'parameters': {
    'store_filters': {
      'retail_id': []
    },
    'product_dimensions': ['vendor_product'],
    'store_dimensions': ['retail_store_name'],
    'metrics': {
      'normal': ['stock_quantity'],
      'var': []
    },
    'fact': {
      'type': 'table',
      'name': 'dw_product_wm'
    },
    'custom_response': 3,
    'limit': 0,
    'offset': 0
  }
};

// ********************************************************************************************************************
//                                                Report Parameters
// ********************************************************************************************************************

var reportParameters = {
  productWm: {
    headerComponent: 'ProductWmHeader',
    headerName: 'Productos sin movimiento',
    retailListComponent: 'ProductWmRetailList',
    atCellClickedGoToView: '',
    excelParameters: productWmExcelParameters,
    chipTooltip: function chipTooltip(tooltipMsg) {
      var description = tooltipMsg.description;
      var metric = tooltipMsg.metric;
      return "Para ".concat(description, " tienes ").concat(metric, " productos sin movimiento entre todas las tiendas con stock");
    },
    dashBoardIndicatorTooltip: 'Productos que en las últimas 4 semanas han ' + 'registrado bajo movimiento de ventas según parámetro por cliente',
    configMetric: 'product_wm_sens',
    headerInfo: function headerInfo(configObj) {
      var configMetric = configObj['product_wm_sens'];
      return "Seleccionando productos que en las \xFAltimas 4\n      semanas han vendido menos de ".concat(configMetric, " unidades y\n      tienen mas de ").concat(configMetric, " unidades de Inventario.");
    },
    gridCellClass: function gridCellClass(x, retailParams) {
      var condition = retailParams['product_wm_sens'];
      return x !== 0 && x > condition ? {
        color: 'white',
        backgroundColor: 'red'
      } : {
        color: 'black',
        backgroundColor: 'white'
      };
    },
    requestParameters: {
      retailSelector: productWmRetailSelector,
      grid: productWmGridParameters,
      dimensionFilter: productWmDimensionFilter,
      productSelector: productWmProductSelector
    }
  },
  stockBreak: {
    dashBoardIndicatorTooltip: 'Productos que en las últimas 4 semanas han registrado un quiebre de stock'
  },
  priceAudition: {
    headerComponent: 'PriceAuditionHeader',
    headerName: 'Audición Precios',
    retailListComponent: 'PriceAuditionRetailList',
    atCellClickedGoToView: 'PriceAuditionDetail',
    excelParameters: priceAuditionExcelParameters,
    chipTooltip: function chipTooltip(tooltipMsg) {
      var description = tooltipMsg.description;
      var metric = tooltipMsg.metric;
      return "Para ".concat(description, " tienes ").concat(metric, " precios no respetados");
    },
    dashBoardIndicatorTooltip: 'Productos cuyos precios venta a público no han sido respetados según acuerdos comerciales. ' + 'Requiere maestro de acuerdos comerciales',
    headerInfo: function headerInfo(configObj) {
      return "Seleccionando productos que tienen mas de un precio fuera del acuerdo comercial";
    },
    gridCellClass: function gridCellClass(x, retailParams) {
      var condition = 1;
      return x >= condition ? {
        color: 'white',
        backgroundColor: 'red'
      } : {
        color: 'black',
        backgroundColor: 'white'
      };
    },
    requestParameters: {
      retailSelector: priceAuditionRetailSelector,
      grid: priceAuditionGridParameters,
      dimensionFilter: priceAuditionDimensionFilter,
      productSelector: priceAuditionProductSelector
    }
  }
};


/***/ }),
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NAMESPACE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_utils_NamespaceHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_sales_analysis_Services__ = __webpack_require__(105);


function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

// import Vue from 'vue'



// const dateParse = (dateString) => {
//   return Number(dateString.split('-').join(''))
// }
var NAMESPACE = 'salesAnalysis/dateGranularity/';
var _types = {
  getters: {
    WEEKLY_PERIOD_BY_WEEK: 'WEEKLY_PERIOD_BY_WEEK',
    WEEKLY_DEFAULT_PERIOD: 'WEEKLY_DEFAULT_PERIOD',
    DAILY_EXTENDED_DEFAULT_PERIOD: 'DAILY_EXTENDED_DEFAULT_PERIOD'
  },
  actions: {
    INIT: 'INIT',
    RESET: 'RESET',
    FETCH_CONFIG: 'FETCH_CONFIG',
    FETCH_SALES_COMPARATIVE: 'FETCH_SALES_COMPARATIVE',
    FETCH_DAILY_WEEKLY_AGGREGATION_BY_WEEK: 'FETCH_DAILY_WEEKLY_AGGREGATION_BY_WEEK',
    FETCH_DAILY_EXTENDED: 'FETCH_DAILY_EXTENDED',
    SET_DAILY_WEEKLY_AGGREGATION_BY_WEEK: 'SET_DAILY_WEEKLY_AGGREGATION_BY_WEEK',
    ADD_FILTER_TO_ALL_REQUEST_PARAMETERS: 'ADD_FILTER_TO_ALL_REQUEST_PARAMETERS'
  },
  mutations: {
    SET_CONFIG: 'SET_CONFIG',
    SET_REQUEST_PARAMETERS: 'SET_REQUEST_PARAMETERS',
    ADD_WEEKLY_AGGREGATION_CHART: 'ADD_WEEKLY_AGGREGATION_CHART',
    ADD_DAILY_EXTENDED_CHART: 'ADD_DAILY_EXTENDED_CHART',
    SET_WEEKLY_AGGREGATION_CHARTS: 'SET_WEEKLY_AGGREGATION_CHARTS',
    SET_DAILY_EXTENDED_CHARTS: 'SET_DAILY_EXTENDED_CHARTS',
    SET_DAILY_EXTENDED_REQUEST_PARAMETERS: 'SET_DAILY_EXTENDED_REQUEST_PARAMETERS',
    SET_FILTER: 'SET_FILTER',
    SET_TITLE: 'SET_TITLE',
    ADD_FILTER_TO_REQUEST_PARAMETERS: 'ADD_FILTER_TO_REQUEST_PARAMETERS'
  }
};
var Types = Object(__WEBPACK_IMPORTED_MODULE_3__app_shared_utils_NamespaceHelper__["a" /* addNamespace */])(NAMESPACE, _types);
var DateGranularity = {
  namespaced: true,
  state: {
    config: null,
    filter: null,
    dailyTabWeeklyAggregationCharts: [],
    dailyTabExtendedCharts: [],
    // Workaround to persist the modal title action, because the params get lost after redirect n times look at
    // dates-granularity multiple redirections in the module routes
    title: ''
  },
  getters: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.getters.WEEKLY_PERIOD_BY_WEEK, function (state) {
    return function (week) {
      return state.config.daily_tab.weekly_aggregation.periods.find(function (period) {
        return period.week === week;
      });
    };
  }), _types.getters.WEEKLY_DEFAULT_PERIOD, function (state) {
    var periodsLength = state.config.daily_tab.weekly_aggregation.periods.length;
    return state.config.daily_tab.weekly_aggregation.periods[periodsLength - 1];
  }), _types.getters.DAILY_EXTENDED_DEFAULT_PERIOD, function (state) {
    return state.config.daily_tab.daily_extended.periods[0];
  }),
  actions: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.actions.INIT, function (_ref) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
      var dispatch, commit, config;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch = _ref.dispatch, commit = _ref.commit;
            _context.next = 1;
            return dispatch(_types.actions.FETCH_CONFIG);
          case 1:
            config = _context.sent;
            commit(_types.mutations.SET_CONFIG, config);
            _context.next = 2;
            return dispatch(_types.actions.ADD_FILTER_TO_ALL_REQUEST_PARAMETERS);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }), _types.actions.RESET, function (_ref2) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
      var commit;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref2.commit;
            commit(_types.mutations.SET_CONFIG, null);
            commit(_types.mutations.SET_WEEKLY_AGGREGATION_CHARTS, []);
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }), _types.actions.FETCH_CONFIG, function (_ref3) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3() {
      var rootState, factTableName, config;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            rootState = _ref3.rootState;
            factTableName = rootState.salesAnalysis.accumulatedSalesDateOption.fact_name;
            _context3.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_4__app_sales_analysis_Services__["c" /* getDateGranularityConfig */])(factTableName);
          case 1:
            config = _context3.sent;
            return _context3.abrupt("return", config);
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }), _types.actions.SET_DAILY_WEEKLY_AGGREGATION_BY_WEEK, function (_ref4, week) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee4() {
      var commit, getters, _getters$_types$gette, last_period, actual_period, lastPeriod, actualPeriod;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            commit = _ref4.commit, getters = _ref4.getters;
            // eslint-disable-next-line camelcase
            _getters$_types$gette = getters[_types.getters.WEEKLY_PERIOD_BY_WEEK](week), last_period = _getters$_types$gette.last_period, actual_period = _getters$_types$gette.actual_period;
            lastPeriod = {
              startDate: last_period.start_date,
              endDate: last_period.end_date
            };
            actualPeriod = {
              startDate: actual_period.start_date,
              endDate: actual_period.end_date
            };
            commit(_types.mutations.SET_REQUEST_PARAMETERS, {
              lastPeriod: lastPeriod,
              actualPeriod: actualPeriod
            });
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  }), _types.actions.FETCH_DAILY_WEEKLY_AGGREGATION_BY_WEEK, function (_ref5, week) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee6() {
      var commit, dispatch, state, requestParameters;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            commit = _ref5.commit, dispatch = _ref5.dispatch, state = _ref5.state;
            commit(_types.mutations.SET_WEEKLY_AGGREGATION_CHARTS, []);
            dispatch(_types.actions.SET_DAILY_WEEKLY_AGGREGATION_BY_WEEK, week);
            requestParameters = state.config.daily_tab.weekly_aggregation.request_parameters;
            requestParameters.forEach(/*#__PURE__*/function () {
              var _ref6 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee5(requestParameter) {
                var chartOptions;
                return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.next = 1;
                      return dispatch(_types.actions.FETCH_SALES_COMPARATIVE, requestParameter.parameters);
                    case 1:
                      chartOptions = _context5.sent;
                      commit(_types.mutations.ADD_WEEKLY_AGGREGATION_CHART, {
                        options: chartOptions,
                        name: requestParameter.name
                      });
                    case 2:
                    case "end":
                      return _context5.stop();
                  }
                }, _callee5);
              }));
              return function (_x) {
                return _ref6.apply(this, arguments);
              };
            }());
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  }), _types.actions.FETCH_DAILY_EXTENDED, function (_ref7) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee8() {
      var commit, dispatch, state, getters, _getters$_types$gette2, lastPeriod, actualPeriod, requestParameters;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            commit = _ref7.commit, dispatch = _ref7.dispatch, state = _ref7.state, getters = _ref7.getters;
            commit(_types.mutations.SET_DAILY_EXTENDED_CHARTS, []);
            // eslint-disable-next-line camelcase
            _getters$_types$gette2 = getters[_types.getters.DAILY_EXTENDED_DEFAULT_PERIOD], lastPeriod = _getters$_types$gette2.last_period, actualPeriod = _getters$_types$gette2.actual_period;
            commit(_types.mutations.SET_DAILY_EXTENDED_REQUEST_PARAMETERS, {
              lastPeriod: lastPeriod,
              actualPeriod: actualPeriod
            });
            requestParameters = state.config.daily_tab.daily_extended.request_parameters;
            requestParameters.forEach(/*#__PURE__*/function () {
              var _ref8 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee7(requestParameter) {
                var chartOptions;
                return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context7) {
                  while (1) switch (_context7.prev = _context7.next) {
                    case 0:
                      _context7.next = 1;
                      return dispatch(_types.actions.FETCH_SALES_COMPARATIVE, requestParameter.parameters);
                    case 1:
                      chartOptions = _context7.sent;
                      commit(_types.mutations.ADD_DAILY_EXTENDED_CHART, {
                        options: chartOptions,
                        name: requestParameter.name
                      });
                    case 2:
                    case "end":
                      return _context7.stop();
                  }
                }, _callee7);
              }));
              return function (_x2) {
                return _ref8.apply(this, arguments);
              };
            }());
          case 1:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }))();
  }), _types.actions.FETCH_SALES_COMPARATIVE, function (_ref9, payloadParameters) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee9() {
      var commit, salesComparativeByWeek;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            commit = _ref9.commit;
            _context9.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_4__app_sales_analysis_Services__["f" /* getSalesComparative */])(payloadParameters);
          case 1:
            salesComparativeByWeek = _context9.sent;
            return _context9.abrupt("return", salesComparativeByWeek);
          case 2:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }))();
  }), _types.actions.ADD_FILTER_TO_ALL_REQUEST_PARAMETERS, function (_ref0) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee0() {
      var commit, state, weeklyAggregationRequestParameters, dailyExtendedRequestParameters;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            commit = _ref0.commit, state = _ref0.state;
            weeklyAggregationRequestParameters = state.config.daily_tab.weekly_aggregation.request_parameters;
            commit(_types.mutations.ADD_FILTER_TO_REQUEST_PARAMETERS, weeklyAggregationRequestParameters);
            dailyExtendedRequestParameters = state.config.daily_tab.daily_extended.request_parameters;
            commit(_types.mutations.ADD_FILTER_TO_REQUEST_PARAMETERS, dailyExtendedRequestParameters);
          case 1:
          case "end":
            return _context0.stop();
        }
      }, _callee0);
    }))();
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.mutations.SET_CONFIG, function (state, config) {
    state.config = config;
  }), _types.mutations.SET_FILTER, function (state, filterObject) {
    state.filter = filterObject;
  }), _types.mutations.SET_TITLE, function (state, title) {
    state.title = title;
  }), _types.mutations.ADD_WEEKLY_AGGREGATION_CHART, function (state, _ref1) {
    var options = _ref1.options,
      name = _ref1.name;
    state.dailyTabWeeklyAggregationCharts.push({
      options: options,
      name: name
    });
  }), _types.mutations.ADD_DAILY_EXTENDED_CHART, function (state, _ref10) {
    var options = _ref10.options,
      name = _ref10.name;
    state.dailyTabExtendedCharts.push({
      options: options,
      name: name
    });
  }), _types.mutations.SET_WEEKLY_AGGREGATION_CHARTS, function (state, dailyTabWeeklyAggregationCharts) {
    state.dailyTabWeeklyAggregationCharts = dailyTabWeeklyAggregationCharts;
  }), _types.mutations.SET_DAILY_EXTENDED_CHARTS, function (state, dailyTabExtendedCharts) {
    state.dailyTabExtendedCharts = dailyTabExtendedCharts;
  }), _types.mutations.SET_REQUEST_PARAMETERS, function (state, _ref11) {
    var lastPeriod = _ref11.lastPeriod,
      actualPeriod = _ref11.actualPeriod;
    var requestParameters = state.config.daily_tab.weekly_aggregation.request_parameters;
    requestParameters.forEach(function (requestParameter) {
      requestParameter.parameters.comparative_date_filters[0].date_from.value = [lastPeriod.startDate, lastPeriod.endDate];
      requestParameter.parameters.comparative_date_filters[1].date_from.value = [actualPeriod.startDate, actualPeriod.endDate];
    });
  }), _types.mutations.SET_DAILY_EXTENDED_REQUEST_PARAMETERS, function (state, _ref12) {
    var lastPeriod = _ref12.lastPeriod,
      actualPeriod = _ref12.actualPeriod;
    var requestParameters = state.config.daily_tab.daily_extended.request_parameters;
    requestParameters.forEach(function (requestParameter) {
      requestParameter.parameters.comparative_date_filters[0].date_from.value = [lastPeriod.start_date, lastPeriod.end_date];
      requestParameter.parameters.comparative_date_filters[1].date_from.value = [actualPeriod.start_date, actualPeriod.end_date];
    });
  }), _types.mutations.ADD_FILTER_TO_REQUEST_PARAMETERS, function (state, requestParameters) {
    requestParameters.forEach(function (requestParameter) {
      requestParameter.parameters = _objectSpread(_objectSpread({}, requestParameter.parameters), state.filter);
    });
  })
};
/* harmony default export */ __webpack_exports__["b"] = (DateGranularity);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NAMESPACE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_store_modules_Filters__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_utils_NamespaceHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LongGrid__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WideGrid__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DateGranularity__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_Services__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_sales_analysis_models_Dimension__ = __webpack_require__(575);










var NAMESPACE = 'salesAnalysis/';
var _types = {
  getters: {
    DIMENSION_BY_ID: 'GETTER_DIMENSION_BY_ID',
    DIMENSIONS: 'GETTER_DIMENSIONS',
    DEFAULT_DIMENSIONS: 'GETTER_DEFAULT_DIMENSIONS',
    HAS_SELECTED_FILTERS: 'GETTER_HAS_SELECTED_FILTERS'
  },
  actions: {
    INIT_MODULE: 'INIT',
    FETCH_INIT_CONFIG: 'FETCH_INIT_CONFIG',
    APPLY_FILTERS: 'APPLY_FILTERS',
    RESET_FILTERS: 'RESET_FILTERS',
    RESET: 'RESET'
  },
  mutations: {
    ACCUMULATED_SALES_DATE_OPTION: 'ACCUMULATED_SALES_DATE_OPTION',
    SET_DIMENSIONS: 'SET_DIMENSIONS',
    SET_DEFAULT_DIMENSIONS: 'SET_DEFAULT_DIMENSIONS'
  }
};
var Types = Object(__WEBPACK_IMPORTED_MODULE_4__app_shared_utils_NamespaceHelper__["a" /* addNamespace */])(NAMESPACE, _types);
var Index = {
  namespaced: true,
  state: {
    accumulatedSalesDateOption: null,
    dimensions: null,
    defaultDimensions: null
  },
  getters: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.getters.DIMENSION_BY_ID, function (state) {
    return function (dimensionId) {
      return state.dimensions.find(function (dimension) {
        return dimension.id === dimensionId;
      });
    };
  }), _types.getters.DIMENSIONS, function (state) {
    return state.dimensions;
  }), _types.getters.DEFAULT_DIMENSIONS, function (state) {
    return state.defaultDimensions;
  }), _types.getters.HAS_SELECTED_FILTERS, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE + __WEBPACK_IMPORTED_MODULE_3__app_shared_store_modules_Filters__["a" /* Types */].getters.HAS_SELECTED_FILTERS];
  }),
  actions: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.actions.INIT_MODULE, function (_ref, _ref2) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
      var dispatch, commit, accumulatedSalesDateOption, defaultDimensions, dimensions;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch = _ref.dispatch, commit = _ref.commit;
            accumulatedSalesDateOption = _ref2.accumulatedSalesDateOption, defaultDimensions = _ref2.defaultDimensions, dimensions = _ref2.dimensions;
            commit(_types.mutations.ACCUMULATED_SALES_DATE_OPTION, accumulatedSalesDateOption);
            commit(_types.mutations.SET_DEFAULT_DIMENSIONS, defaultDimensions);
            commit(_types.mutations.SET_DIMENSIONS, dimensions.map(function (dimension) {
              return new __WEBPACK_IMPORTED_MODULE_9__app_sales_analysis_models_Dimension__["a" /* default */](dimension);
            }));
            _context.next = 1;
            return dispatch(_types.actions.FETCH_INIT_CONFIG);
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }), _types.actions.FETCH_INIT_CONFIG, function (_ref3) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
      var dispatch, commit, _yield$getInitConfig, longGrid, wideGrid;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dispatch = _ref3.dispatch, commit = _ref3.commit;
            _context2.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_Services__["d" /* getInitConfig */])();
          case 1:
            _yield$getInitConfig = _context2.sent;
            longGrid = _yield$getInitConfig.longGrid;
            wideGrid = _yield$getInitConfig.wideGrid;
            dispatch(__WEBPACK_IMPORTED_MODULE_5__LongGrid__["a" /* Types */].actions.INIT, longGrid, {
              root: true
            });
            dispatch(__WEBPACK_IMPORTED_MODULE_6__WideGrid__["a" /* Types */].actions.INIT, wideGrid, {
              root: true
            });
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }), _types.actions.RESET_FILTERS, function (_ref4) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3() {
      var dispatch;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            dispatch = _ref4.dispatch;
            dispatch(NAMESPACE + __WEBPACK_IMPORTED_MODULE_3__app_shared_store_modules_Filters__["a" /* Types */].actions.RESET_SELECTED_FILTERS, null, {
              root: true
            });
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }), _types.actions.APPLY_FILTERS, function (_ref5, _ref6) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee4() {
      var dispatch, storeFilters, productFilters;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            dispatch = _ref5.dispatch;
            storeFilters = _ref6.storeFilters, productFilters = _ref6.productFilters;
            dispatch(NAMESPACE + __WEBPACK_IMPORTED_MODULE_3__app_shared_store_modules_Filters__["a" /* Types */].actions.SET_SELECTED_FILTERS, {
              storeFilters: storeFilters,
              productFilters: productFilters
            }, {
              root: true
            });
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  }), _types.actions.RESET, function (_ref7) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee5() {
      var dispatch;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            dispatch = _ref7.dispatch;
            dispatch(__WEBPACK_IMPORTED_MODULE_5__LongGrid__["a" /* Types */].actions.RESET, __WEBPACK_IMPORTED_MODULE_5__LongGrid__["b" /* default */], {
              root: true
            });
            dispatch(__WEBPACK_IMPORTED_MODULE_6__WideGrid__["a" /* Types */].actions.RESET, __WEBPACK_IMPORTED_MODULE_6__WideGrid__["b" /* default */], {
              root: true
            });
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.mutations.ACCUMULATED_SALES_DATE_OPTION, function (state, accumulatedSalesDateOption) {
    state.accumulatedSalesDateOption = accumulatedSalesDateOption;
  }), _types.mutations.SET_DIMENSIONS, function (state, dimensions) {
    state.dimensions = dimensions;
  }), _types.mutations.SET_DEFAULT_DIMENSIONS, function (state, defaultDimensions) {
    state.defaultDimensions = defaultDimensions;
  }),
  modules: {
    longGrid: __WEBPACK_IMPORTED_MODULE_5__LongGrid__["b" /* default */],
    wideGrid: __WEBPACK_IMPORTED_MODULE_6__WideGrid__["b" /* default */],
    filters: __WEBPACK_IMPORTED_MODULE_3__app_shared_store_modules_Filters__["b" /* default */],
    dateGranularity: __WEBPACK_IMPORTED_MODULE_7__DateGranularity__["b" /* default */]
  }
};
/* harmony default export */ __webpack_exports__["b"] = (Index);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMESPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_utils_NamespaceHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StoresWithoutGrowth__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StoresWithoutGrowthDetail__ = __webpack_require__(714);






var NAMESPACE = 'storeGrowth';
var INTERNAL_NAMESPACE = NAMESPACE + '/';
var _types = {
  getters: {
    METRICS: 'GETTER_METRICS',
    SORT_FIELD: 'GETTER_SORT_FIELD'
  },
  actions: {
    INIT_MODULE: 'INIT'
  },
  mutations: {
    SET_MAIN_METRIC: 'SET_MAIN_METRIC',
    SET_ACCUMULATED_SALES_DATE_OPTION: 'SET_ACCUMULATED_SALES_DATE_OPTION'
  }
};
var UNIT_METRICS = {
  normal: ['quantity_sold_1', 'quantity_sold_2', 'stock_quantity'],
  "var": ['quantity_sold']
};
var PESOS_METRICS = {
  normal: ['real_sales_amount_1', 'real_sales_amount_2', 'stock_quantity'],
  "var": ['real_sales_amount']
};
var Types = Object(__WEBPACK_IMPORTED_MODULE_3__app_shared_utils_NamespaceHelper__["a" /* addNamespace */])(INTERNAL_NAMESPACE, _types);
var Index = {
  namespaced: true,
  state: {
    mainMetric: null,
    accumulatedSalesDateOption: null
  },
  getters: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.getters.METRICS, function (state) {
    if (state.mainMetric === 'UNITS') return UNIT_METRICS;
    if (state.mainMetric === 'PESOS') return PESOS_METRICS;else throw Error('métrica no implementada');
  }), _types.getters.SORT_FIELD, function (state, getters) {
    var metricsNormalLength = getters[_types.getters.METRICS].normal.length;
    var sortField = getters[_types.getters.METRICS].normal[metricsNormalLength - 1];
    return sortField;
  }),
  actions: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.actions.INIT_MODULE, function (_ref, _ref2) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
      var commit, mainMetric, accumulatedSalesDateOption;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            mainMetric = _ref2.mainMetric, accumulatedSalesDateOption = _ref2.accumulatedSalesDateOption;
            commit(_types.mutations.SET_MAIN_METRIC, mainMetric);
            commit(_types.mutations.SET_ACCUMULATED_SALES_DATE_OPTION, accumulatedSalesDateOption);
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.mutations.SET_MAIN_METRIC, function (state, mainMetric) {
    state.mainMetric = mainMetric;
  }), _types.mutations.SET_ACCUMULATED_SALES_DATE_OPTION, function (state, accumulatedSalesDateOption) {
    state.accumulatedSalesDateOption = accumulatedSalesDateOption;
  }),
  modules: {
    storesWithoutGrowth: __WEBPACK_IMPORTED_MODULE_4__StoresWithoutGrowth__["b" /* default */],
    storesWithoutGrowthDetail: __WEBPACK_IMPORTED_MODULE_5__StoresWithoutGrowthDetail__["b" /* default */]
  }
};
/* harmony default export */ __webpack_exports__["c"] = (Index);

/***/ }),
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_authentication_ClientTermsServices__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_authentication_models_ClientTermsModel__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Full__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__expertoRetail_views_Mobile__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__expertoRetail_atoms_ExpertoRetailMobileStoreDetail__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__expertoRetail_atoms_ExpertoRetailMobileProductList__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__expertoRetail_atoms_ExpertoRetailMobileWmProductList__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expertoRetail_atoms_ExpertoRetailMobileNewStockProductList__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__app_news_feed_Routes__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__expertoRetail_views_GeneralKeyKpiAnalysis__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__app_massive_download_MassiveDownloadRoutes__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__app_sales_analysis_Routes__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__app_store_growth_Routes__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__app_stock_break_Routes__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__app_weekly_sales_Routes__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__app_admin_Routes__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__app_authentication_Routes__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__app_monthly_sales_Routes__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__app_daily_sales_Routes__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__app_workspaces_Routes__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__app_activations_Routes__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__app_purchase_orders_Routes__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__app_product_follow_up_Routes__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__app_merchants_Routes__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__app_sell_in_proposal_Routes__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__app_sellout_dashboard_Routes__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__app_product_master_Routes__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__app_user_api_Routes__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__app_price_campaign_Routes__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__app_physical_stock_counts_Routes__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__app_route_planning_Routes__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_pages_Page404__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_pages_UnderMaintenance__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__store_index__ = __webpack_require__(99);








// Containers


// Views
// Legacy dashboard kept for reference but route now uses the new module
// import Dashboard from '@/expertoRetail/views/Dashboard'









//Rutas para la nueva arquitectura!






















// Views - Pages



__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);
var termsCheckedThisSession = false;
var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return {
      y: 0
    };
  },
  routes: [].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_21__app_authentication_Routes__["a" /* default */]), [{
    path: '/',
    redirect: '/login',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_7__containers_Full__["a" /* default */],
    props: true,
    children: [{
      path: 'dashboard',
      component: function component() {
        return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 1400));
      },
      children: [{
        path: '',
        name: 'Dashboard',
        component: function component() {
          return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1401));
        }
      }, {
        path: 'preset/:presetIndex',
        name: 'DashboardGrid',
        component: function component() {
          return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1402));
        },
        props: true
      }]
    }, {
      path: 'mobile',
      name: 'Mobile',
      component: __WEBPACK_IMPORTED_MODULE_8__expertoRetail_views_Mobile__["a" /* default */],
      props: true
    }, {
      path: 'store_detail',
      name: 'StoreDetail',
      component: __WEBPACK_IMPORTED_MODULE_9__expertoRetail_atoms_ExpertoRetailMobileStoreDetail__["a" /* default */],
      props: true
    }, {
      path: 'product_detail',
      name: 'ProductDetail',
      component: __WEBPACK_IMPORTED_MODULE_10__expertoRetail_atoms_ExpertoRetailMobileProductList__["a" /* default */],
      props: true
    }, {
      path: 'wm_product_List',
      name: 'WmProductList',
      component: __WEBPACK_IMPORTED_MODULE_11__expertoRetail_atoms_ExpertoRetailMobileWmProductList__["a" /* default */],
      props: true
    }, {
      path: 'new_stock_product_list',
      name: 'NewStockProductList',
      component: __WEBPACK_IMPORTED_MODULE_12__expertoRetail_atoms_ExpertoRetailMobileNewStockProductList__["a" /* default */],
      props: true
    }].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_13__app_news_feed_Routes__["a" /* default */]), [{
      path: 'general_key_kpi_analysis',
      name: 'GeneralKeyKpiAnalysis',
      component: __WEBPACK_IMPORTED_MODULE_14__expertoRetail_views_GeneralKeyKpiAnalysis__["a" /* default */],
      props: true
    }], __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_15__app_massive_download_MassiveDownloadRoutes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_16__app_sales_analysis_Routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_17__app_store_growth_Routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_18__app_stock_break_Routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_19__app_weekly_sales_Routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_20__app_admin_Routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_22__app_monthly_sales_Routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_23__app_daily_sales_Routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_24__app_workspaces_Routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_25__app_activations_Routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_26__app_purchase_orders_Routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_27__app_product_follow_up_Routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_28__app_merchants_Routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_29__app_sell_in_proposal_Routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_30__app_sellout_dashboard_Routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_31__app_product_master_Routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_32__app_user_api_Routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_33__app_price_campaign_Routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_34__app_physical_stock_counts_Routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_35__app_route_planning_Routes__["a" /* default */]))
  }, {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    meta: {
      noNeedDefaultData: true
    },
    component: {
      render: function render(c) {
        return c('router-view');
      }
    },
    children: [{
      path: '404',
      name: 'Page404',
      component: __WEBPACK_IMPORTED_MODULE_36__views_pages_Page404__["a" /* default */]
    }, {
      path: 'under-maintenance',
      name: 'UnderMaintenance',
      component: __WEBPACK_IMPORTED_MODULE_37__views_pages_UnderMaintenance__["a" /* default */]
    }]
  }])
});
router.beforeEach(/*#__PURE__*/function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    var termsData, termsModel, _t;
    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(!to.matched.some(function (record) {
            return record.meta.noNeedDefaultData;
          }) && !__WEBPACK_IMPORTED_MODULE_38__store_index__["a" /* default */].getters.isConfigLoaded && !__WEBPACK_IMPORTED_MODULE_38__store_index__["a" /* default */].getters.isLoggedIn)) {
            _context.next = 1;
            break;
          }
          next({
            name: 'Login'
          });
          return _context.abrupt("return");
        case 1:
          if (!(to.name === 'clientTermsAcceptance' || to.name === 'login' || to.name === 'Login')) {
            _context.next = 2;
            break;
          }
          next();
          return _context.abrupt("return");
        case 2:
          if (!(__WEBPACK_IMPORTED_MODULE_38__store_index__["a" /* default */].getters.isLoggedIn && __WEBPACK_IMPORTED_MODULE_38__store_index__["a" /* default */].getters.isConfigLoaded && !termsCheckedThisSession)) {
            _context.next = 7;
            break;
          }
          _context.prev = 3;
          _context.next = 4;
          return Object(__WEBPACK_IMPORTED_MODULE_5__app_authentication_ClientTermsServices__["b" /* checkClientTermsAcceptance */])();
        case 4:
          termsData = _context.sent;
          termsModel = new __WEBPACK_IMPORTED_MODULE_6__app_authentication_models_ClientTermsModel__["a" /* default */](termsData);
          termsCheckedThisSession = true;
          if (!termsModel.needsAcceptance) {
            _context.next = 5;
            break;
          }
          next({
            name: 'clientTermsAcceptance'
          });
          return _context.abrupt("return");
        case 5:
          _context.next = 7;
          break;
        case 6:
          _context.prev = 6;
          _t = _context["catch"](3);
          console.error(_t);
        case 7:
          next();
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 6]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WebSocketMessageHandler__ = __webpack_require__(221);



var WebSocketService = /*#__PURE__*/function () {
  function WebSocketService() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, WebSocketService);
    this.socket = null;
    this.userId = null;
    this.pingInterval = null;
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 5;
    this.reconnectDelay = 3000; // 3 seconds
    this.isConnecting = false;
    this.listeners = {
      open: [],
      message: [],
      close: [],
      error: []
    };
  }

  /**
   * Connect to WebSocket with user ID
   * @param {number} userId - The user ID to connect with
   */
  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(WebSocketService, [{
    key: "connect",
    value: function connect(userId) {
      if (this.isConnecting || this.socket && this.socket.readyState === WebSocket.OPEN) {
        return;
      }
      this.userId = userId;
      this.isConnecting = true;
      var wsUrl = "wss://9b25k9zc60.execute-api.sa-east-1.amazonaws.com/production/?user_id=".concat(userId, "&device=DESKTOP");
      try {
        this.socket = new WebSocket(wsUrl);
        this.setupEventListeners();
      } catch (error) {
        console.error('WebSocket connection error:', error);
        this.isConnecting = false;
      }
    }

    /**
     * Setup WebSocket event listeners
     */
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this = this;
      if (!this.socket) return;
      this.socket.onopen = function (event) {
        _this.isConnecting = false;
        _this.reconnectAttempts = 0;
        _this.startPing();
        _this.emit('open', event);
      };
      this.socket.onmessage = function (event) {
        // Process message through the message handler
        __WEBPACK_IMPORTED_MODULE_2__WebSocketMessageHandler__["a" /* default */].processMessage(event);

        // Also emit the raw message event for backward compatibility
        _this.emit('message', event);
      };
      this.socket.onclose = function (event) {
        _this.isConnecting = false;
        _this.stopPing();
        _this.emit('close', event);

        // Attempt to reconnect if not closed intentionally
        if (event.code !== 1000 && _this.reconnectAttempts < _this.maxReconnectAttempts) {
          _this.attemptReconnect();
        }
      };
      this.socket.onerror = function (error) {
        console.error('WebSocket error:', error);
        _this.isConnecting = false;
        _this.emit('error', error);
      };
    }

    /**
     * Start ping interval to keep connection alive (every 7 minutes)
     */
  }, {
    key: "startPing",
    value: function startPing() {
      var _this2 = this;
      this.stopPing(); // Clear any existing interval

      // Ping every 7 minutes (420000ms)
      this.pingInterval = setInterval(function () {
        if (_this2.socket && _this2.socket.readyState === WebSocket.OPEN) {
          _this2.send({
            type: 'ping',
            timestamp: Date.now()
          });
        }
      }, 420000); // 7 minutes
    }

    /**
     * Stop ping interval
     */
  }, {
    key: "stopPing",
    value: function stopPing() {
      if (this.pingInterval) {
        clearInterval(this.pingInterval);
        this.pingInterval = null;
      }
    }

    /**
     * Attempt to reconnect to WebSocket
     */
  }, {
    key: "attemptReconnect",
    value: function attemptReconnect() {
      var _this3 = this;
      if (this.reconnectAttempts >= this.maxReconnectAttempts) {
        return;
      }
      this.reconnectAttempts++;
      setTimeout(function () {
        if (_this3.userId) {
          _this3.connect(_this3.userId);
        }
      }, this.reconnectDelay * this.reconnectAttempts);
    }

    /**
     * Send message through WebSocket
     * @param {Object|String} message - Message to send
     */
  }, {
    key: "send",
    value: function send(message) {
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        var messageString = typeof message === 'string' ? message : JSON.stringify(message);
        this.socket.send(messageString);
      } else {
        console.warn('WebSocket is not connected. Cannot send message:', message);
      }
    }

    /**
     * Disconnect WebSocket
     */
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.stopPing();
      if (this.socket) {
        this.socket.close(1000, 'Client disconnecting');
        this.socket = null;
      }
      this.userId = null;
      this.reconnectAttempts = 0;
      this.isConnecting = false;
    }

    /**
     * Add event listener
     * @param {string} event - Event type (open, message, close, error)
     * @param {function} callback - Callback function
     */
  }, {
    key: "on",
    value: function on(event, callback) {
      if (this.listeners[event]) {
        this.listeners[event].push(callback);
      }
    }

    /**
     * Remove event listener
     * @param {string} event - Event type
     * @param {function} callback - Callback function to remove
     */
  }, {
    key: "off",
    value: function off(event, callback) {
      if (this.listeners[event]) {
        var index = this.listeners[event].indexOf(callback);
        if (index > -1) {
          this.listeners[event].splice(index, 1);
        }
      }
    }

    /**
     * Emit event to all listeners
     * @param {string} event - Event type
     * @param {any} data - Event data
     */
  }, {
    key: "emit",
    value: function emit(event, data) {
      if (this.listeners[event]) {
        this.listeners[event].forEach(function (callback) {
          try {
            callback(data);
          } catch (error) {
            console.error("Error in WebSocket ".concat(event, " listener:"), error);
          }
        });
      }
    }

    /**
     * Get current connection state
     * @returns {string} Connection state
     */
  }, {
    key: "getState",
    value: function getState() {
      if (!this.socket) return 'CLOSED';
      switch (this.socket.readyState) {
        case WebSocket.CONNECTING:
          return 'CONNECTING';
        case WebSocket.OPEN:
          return 'OPEN';
        case WebSocket.CLOSING:
          return 'CLOSING';
        case WebSocket.CLOSED:
          return 'CLOSED';
        default:
          return 'UNKNOWN';
      }
    }

    /**
     * Check if WebSocket is connected
     * @returns {boolean} True if connected
     */
  }, {
    key: "isConnected",
    value: function isConnected() {
      return this.socket && this.socket.readyState === WebSocket.OPEN;
    }
  }]);
}(); // Create and export a single instance
var webSocketService = new WebSocketService();
/* harmony default export */ __webpack_exports__["a"] = (webSocketService);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(99);


/**
 * WebSocket Message Handler Service
 * Handles different types of WebSocket messages and routes them to appropriate handlers
 */



var WebSocketMessageHandler = /*#__PURE__*/function () {
  function WebSocketMessageHandler() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, WebSocketMessageHandler);
    this.messageHandlers = new Map();
    this.eventListeners = new Map();

    // Register default message handlers
    this.registerHandler('DW_ETL_JOB', this.handleDwEtlJob.bind(this));
    this.registerHandler('FORCE_LOGOUT', this.handleForceLogout.bind(this));
    // Add more message types here as needed
    // this.registerHandler('NOTIFICATION', this.handleNotification.bind(this))
    // this.registerHandler('USER_UPDATE', this.handleUserUpdate.bind(this))
  }

  /**
   * Register a message handler for a specific message type
   * @param {string} messageType - The type of message to handle
   * @param {function} handler - The handler function
   */
  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(WebSocketMessageHandler, [{
    key: "registerHandler",
    value: function registerHandler(messageType, handler) {
      this.messageHandlers.set(messageType, handler);
    }

    /**
     * Process incoming WebSocket message
     * @param {MessageEvent} event - WebSocket message event
     */
  }, {
    key: "processMessage",
    value: function processMessage(event) {
      try {
        var message = JSON.parse(event.data);
        if (!message.type) {
          console.warn('WebSocket message missing type field:', message);
          return;
        }
        var handler = this.messageHandlers.get(message.type);
        if (handler) {
          handler(message);
        } else {
          console.warn("No handler registered for message type: ".concat(message.type));
        }

        // Emit generic message event for components that want to listen to all messages
        this.emit('message', {
          type: message.type,
          data: message
        });
      } catch (error) {
        console.error('Error processing WebSocket message:', error);
      }
    }

    /**
     * Handle DW_ETL_JOB messages
     * @param {Object} message - The message object
     */
  }, {
    key: "handleDwEtlJob",
    value: function handleDwEtlJob(message) {
      var status = message.status,
        progress = message.progress,
        error = message.error,
        client_id = message.client_id,
        schema = message.schema;

      // Create event data for components to listen to
      var eventData = {
        status: status,
        progress: progress || null,
        error: error || null,
        clientId: client_id,
        schema: schema,
        isWorking: status === 'WORKING',
        isDone: status === 'DONE',
        hasError: status === 'DONE_WITH_ERROR'
      };

      // Emit specific ETL job event
      this.emit('dwEtlJobUpdate', eventData);
    }

    /**
     * Handle notification messages (placeholder for future implementation)
     * @param {Object} message - The message object
     */
  }, {
    key: "handleNotification",
    value: function handleNotification(message) {
      this.emit('notification', message);
    }

    /**
     * Handle user update messages (placeholder for future implementation)
     * @param {Object} message - The message object
     */
  }, {
    key: "handleUserUpdate",
    value: function handleUserUpdate(message) {
      this.emit('userUpdate', message);
    }

    /**
     * Add event listener for specific message types or events
     * @param {string} event - Event name
     * @param {function} callback - Callback function
     */
  }, {
    key: "on",
    value: function on(event, callback) {
      if (!this.eventListeners.has(event)) {
        this.eventListeners.set(event, []);
      }
      this.eventListeners.get(event).push(callback);
    }

    /**
     * Remove event listener
     * @param {string} event - Event name
     * @param {function} callback - Callback function to remove
     */
  }, {
    key: "off",
    value: function off(event, callback) {
      if (this.eventListeners.has(event)) {
        var listeners = this.eventListeners.get(event);
        var index = listeners.indexOf(callback);
        if (index > -1) {
          listeners.splice(index, 1);
        }
      }
    }

    /**
     * Emit event to all listeners
     * @param {string} event - Event name
     * @param {any} data - Event data
     */
  }, {
    key: "emit",
    value: function emit(event, data) {
      if (this.eventListeners.has(event)) {
        this.eventListeners.get(event).forEach(function (callback) {
          try {
            callback(data);
          } catch (error) {
            console.error("Error in ".concat(event, " listener:"), error);
          }
        });
      }
    }

    /**
     * Get current ETL job status (if available)
     * @returns {Object|null} Current ETL job status
     */
  }, {
    key: "getCurrentEtlStatus",
    value: function getCurrentEtlStatus() {
      return this.currentEtlStatus || null;
    }

    /**
     * Clear all event listeners
     */
  }, {
    key: "clearListeners",
    value: function clearListeners() {
      this.eventListeners.clear();
    }

    /**
     * Handle FORCE_LOGOUT messages
     * @param {Object} message - The message object with type, reason_id, and description
     */
  }, {
    key: "handleForceLogout",
    value: function handleForceLogout(message) {
      this.emit('forceLogout', {
        type: message.type,
        description: message.description
      });

      // Store the logout reason for the login page
      if (message.description) {
        sessionStorage.setItem('force_logout_reason', message.description);
      }

      // Clear authentication state using the proper store namespace
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('login/LOGOUT');

      // Redirect to login page
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/login')["catch"](function () {
        // Fallback if router push fails
        window.location.href = '/login';
      });
    }
  }]);
}(); // Create and export a single instance
var webSocketMessageHandler = new WebSocketMessageHandler();
/* harmony default export */ __webpack_exports__["a"] = (webSocketMessageHandler);

/***/ }),
/* 222 */,
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NAMESPACE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_sales_analysis_models_BreadCrumbItem__ = __webpack_require__(864);


var NAMESPACE = 'breadCrumb/';
var _types = {
  getters: {
    LAST_ITEM: 'LAST_ITEM',
    DIMENSION_IDS_IN_BREADCRUMB: 'DIMENSION_IDS_IN_BREADCRUMB',
    DIMENSION_IDS_IN_FILTERS: 'DIMENSION_IDS_IN_FILTERS',
    DIMENSION_TO_FILTER: 'DIMENSION_TO_FILTER',
    FIRST_ITEM: 'FIRST_ITEM'
  },
  actions: {},
  mutations: {
    RESET: 'RESET',
    PUSH_ITEM: 'PUSH_ITEM',
    REMOVE_ITEM: 'REMOVE_ITEM'
  }
};
var Types = _types;
var BreadCrumb = {
  namespaced: true,
  state: function state() {
    return {
      items: []
    };
  },
  getters: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, _types.getters.DIMENSION_IDS_IN_BREADCRUMB, function (state) {
    return state.items.map(function (item) {
      return item.dimension.id;
    });
  }), _types.getters.LAST_ITEM, function (state) {
    return state.items.length > 0 ? state.items[state.items.length - 1] : {};
  }), _types.getters.FIRST_ITEM, function (state) {
    return state.items.length > 0 ? state.items[0] : {};
  }), _types.getters.DIMENSION_TO_FILTER, function (state, getters) {
    return getters[_types.getters.LAST_ITEM].dimension;
  }), _types.getters.FILTERS, function (state) {
    return state.items.filter(function (item) {
      return item.filter;
    }).map(function (item) {
      return item.filter;
    });
  }), _types.getters.DIMENSION_IDS_IN_FILTERS, function (state, getters) {
    return getters[_types.getters.FILTERS].map(function (filterItem) {
      return filterItem.keyField;
    });
  }),
  actions: {},
  mutations: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, _types.mutations.PUSH_ITEM, function (state, _ref) {
    var dimension = _ref.dimension,
      filter = _ref.filter,
      text = _ref.text;
    var breadCrumbItem = new __WEBPACK_IMPORTED_MODULE_1__app_sales_analysis_models_BreadCrumbItem__["a" /* default */]({
      dimension: dimension,
      filter: filter,
      text: text
    });
    state.items.push(breadCrumbItem);
  }), _types.mutations.REMOVE_ITEM, function (state, item) {
    var itemIndex = state.items.indexOf(item);
    state.items.splice(itemIndex, 1);
  }), _types.mutations.RESET, function (state) {
    state.items = [];
  }),
  modules: {}
};
/* harmony default export */ __webpack_exports__["b"] = (BreadCrumb);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_store_modules_Filters__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_BreadCrumb__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_shared_models_Filter__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_shared_models_OneDimensionStrategy__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_shared_models_PayloadParametersBuilder__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_shared_Services__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_shared_utils_NamespaceHelper__ = __webpack_require__(31);


var _actions;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }








var buildFilter = function buildFilter(params, currentDimension) {
  var key = currentDimension.key,
    type = currentDimension.type;
  var value = [params.data[key]];
  return new __WEBPACK_IMPORTED_MODULE_5__app_shared_models_Filter__["a" /* default */]({
    key: key,
    type: type,
    value: value
  });
};
var buildLongGridParameters = function buildLongGridParameters(_ref) {
  var metrics = _ref.metrics,
    factTableName = _ref.factTableName,
    dimension = _ref.dimension,
    strategyFilter = _ref.strategyFilter,
    filters = _ref.filters,
    calculatedField = _ref.calculatedField,
    dateFilters = _ref.dateFilters;
  var oneDimensionStrategy = new __WEBPACK_IMPORTED_MODULE_6__app_shared_models_OneDimensionStrategy__["a" /* default */](dimension, strategyFilter);
  var payloadParametersBuilder = new __WEBPACK_IMPORTED_MODULE_7__app_shared_models_PayloadParametersBuilder__["a" /* default */]({
    metrics: metrics,
    factTableName: factTableName,
    filters: filters
  });
  var parameters = payloadParametersBuilder.build(oneDimensionStrategy);
  parameters.calculated_field = calculatedField;
  parameters.date_filters = dateFilters;
  return {
    parameters: parameters
  };
};
var downloadLongGridToXlsx = /*#__PURE__*/function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee(parameters) {
    var longGridParamaters;
    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          longGridParamaters = buildLongGridParameters(parameters);
          _context.next = 1;
          return Object(__WEBPACK_IMPORTED_MODULE_8__app_shared_Services__["b" /* downloadGridToXlsx */])(longGridParamaters);
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function downloadLongGridToXlsx(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var NAMESPACE = 'longGrid/';
var BREADCRUMB_MODULE_NAME = 'breadCrumb';
var NAMESPACE_BREADCRUMB = BREADCRUMB_MODULE_NAME + '/';
var _types = {
  getters: {
    PIVOTED_FILTERS: 'GETTER_PIVOTED_FILTERS',
    BASE_DIMENSION: 'BASE_DIMENSION',
    DIMENSION_BY_ID: 'DIMENSION_BY_ID',
    PIVOT_DIMENSIONS: 'PIVOT_DIMENSIONS',
    PIVOTED_FILTER_DIMENSION_IDS: 'PIVOTED_FILTER_DIMENSION_IDS'
  },
  actions: {
    INIT: 'INIT',
    INIT_BREADCRUMB: 'INIT_BREADCRUMB',
    INIT_LONG_GRID: 'INIT_LONG_GRID',
    INIT_FILTERS: 'INIT_FILTERS',
    CHANGE_BASE_DIMENSION: 'CHANGE_BASE_DIMENSION',
    FETCH_LONG_GRID: 'FETCH_LONG_GRID',
    PUSH_BREADCRUMB_ITEM: 'PUSH_BREADCRUMB_ITEM',
    POP_UNTIL_BREADCRUMB: 'POP_UNTIL_BREADCRUMB',
    CHANGE_PIVOT: 'CHANGE_PIVOT',
    APPLY_FILTERS: 'APPLY_FILTERS',
    DOWNLOAD_GRID_TO_EXCEL: 'DOWNLOAD_GRID_TO_EXCEL',
    RESET: 'RESET'
  },
  mutations: {
    SET_DEFAULT_PARAMETERS: 'SET_DEFAULT_PARAMETERS',
    SET_DIMENSIONS: 'SET_DIMENSIONS',
    SET_LONG_GRID: 'SET_LONG_GRID'
  }
};
var Types = Object(__WEBPACK_IMPORTED_MODULE_9__app_shared_utils_NamespaceHelper__["a" /* addNamespace */])(NAMESPACE, _types);
var LongGrid = {
  namespaced: true,
  state: function state() {
    return {
      grid: null,
      dimensions: null
    };
  },
  getters: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, _types.getters.DIMENSION_BY_ID, function (state) {
    return function (dimensionId) {
      return state.dimensions.find(function (dimension) {
        return dimension.id === dimensionId;
      });
    };
  }), _types.getters.PIVOT_DIMENSIONS, function (state, getters, rootState, rootGetters) {
    var dimensionIdsInBreadCrumb = getters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_BreadCrumb__["a" /* Types */].getters.DIMENSION_IDS_IN_BREADCRUMB];
    var dimensionsToPivot = function dimensionsToPivot(dimension) {
      return !dimensionIdsInBreadCrumb.includes(dimension.id);
    };
    return state.dimensions.filter(dimensionsToPivot);
  }), _types.getters.PIVOTED_FILTERS, function (state) {
    return state.breadCrumb.items.filter(function (breadcrumbItem) {
      return breadcrumbItem.filter;
    }).map(function (breadcrumbItem) {
      return breadcrumbItem.filter;
    });
  }), _types.getters.PIVOTED_FILTER_DIMENSION_IDS, function (state, getters) {
    return getters[_types.getters.PIVOTED_FILTERS].map(function (pivotedFilter) {
      return pivotedFilter.keyField;
    });
  }), _types.getters.DIMENSION_TO_FILTER, function (state, getters) {
    return getters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_BreadCrumb__["a" /* Types */].getters.DIMENSION_TO_FILTER];
  }), _types.getters.BASE_DIMENSION, function (state, getters) {
    return getters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_BreadCrumb__["a" /* Types */].getters.FIRST_ITEM].dimension;
  }),
  actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_actions, _types.actions.INIT, function (_ref3, _ref4) {
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
      var commit, dispatch, dimensions, defaultDimension, defaultParameters, filters;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref3.commit, dispatch = _ref3.dispatch;
            dimensions = _ref4.dimensions, defaultDimension = _ref4.defaultDimension, defaultParameters = _ref4.defaultParameters, filters = _ref4.filters;
            commit(_types.mutations.SET_DIMENSIONS, dimensions);
            commit(_types.mutations.SET_DEFAULT_PARAMETERS, defaultParameters);
            dispatch(_types.actions.INIT_BREADCRUMB, defaultDimension);
            dispatch(_types.actions.INIT_FILTERS, filters);
            _context2.next = 1;
            return dispatch(_types.actions.INIT_LONG_GRID, defaultDimension);
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }), _types.actions.INIT_FILTERS, function (_ref5, filters) {
    var dispatch = _ref5.dispatch;
    var storeFilters = _objectSpread({}, filters.selectedStoreFilters);
    var productFilters = _objectSpread({}, filters.selectedProductFilters);
    dispatch(__WEBPACK_IMPORTED_MODULE_3__app_shared_store_modules_Filters__["a" /* Types */].actions.SET_SELECTED_FILTERS, {
      storeFilters: storeFilters,
      productFilters: productFilters
    });
  }), _types.actions.INIT_BREADCRUMB, function (_ref6, dimension) {
    var dispatch = _ref6.dispatch,
      commit = _ref6.commit,
      state = _ref6.state,
      getters = _ref6.getters;
    commit(NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_BreadCrumb__["a" /* Types */].mutations.RESET, null);
    var breadCrumbItemText = dimension.value;
    commit(NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_BreadCrumb__["a" /* Types */].mutations.PUSH_ITEM, {
      dimension: dimension,
      filter: undefined,
      text: breadCrumbItemText
    });
  }), _types.actions.INIT_LONG_GRID, function (_ref7, dimension) {
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3() {
      var state, dispatch;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            state = _ref7.state, dispatch = _ref7.dispatch;
            _context3.next = 1;
            return dispatch(_types.actions.FETCH_LONG_GRID, {
              dimension: dimension
            });
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }), _types.actions.FETCH_LONG_GRID, function (_ref8, _ref9) {
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee4() {
      var state, commit, dimension, filter, metrics, filters, calculatedField, factTableName, dateFilters, longGridPayload, longGrid;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            state = _ref8.state, commit = _ref8.commit;
            dimension = _ref9.dimension, filter = _ref9.filter;
            commit(_types.mutations.SET_LONG_GRID, null);
            metrics = state.metrics, filters = state.filters, calculatedField = state.calculatedField, factTableName = state.factTableName, dateFilters = state.dateFilters;
            longGridPayload = buildLongGridParameters({
              metrics: metrics,
              factTableName: factTableName,
              dimension: dimension,
              strategyFilter: filter,
              filters: filters,
              calculatedField: calculatedField,
              dateFilters: dateFilters
            });
            _context4.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_8__app_shared_Services__["c" /* getLongGrid */])(longGridPayload);
          case 1:
            longGrid = _context4.sent;
            commit(_types.mutations.SET_LONG_GRID, longGrid);
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  }), _types.actions.APPLY_FILTERS, function (_ref0, _ref1) {
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee5() {
      var state, dispatch, getters, storeFilters, productFilters, breadCrumbItem;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            state = _ref0.state, dispatch = _ref0.dispatch, getters = _ref0.getters;
            storeFilters = _ref1.storeFilters, productFilters = _ref1.productFilters;
            dispatch(__WEBPACK_IMPORTED_MODULE_3__app_shared_store_modules_Filters__["a" /* Types */].actions.SET_SELECTED_FILTERS, {
              storeFilters: storeFilters,
              productFilters: productFilters
            });
            breadCrumbItem = getters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_BreadCrumb__["a" /* Types */].getters.LAST_ITEM];
            _context5.next = 1;
            return dispatch(_types.actions.FETCH_LONG_GRID, breadCrumbItem);
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  }), _types.actions.CHANGE_BASE_DIMENSION, function (_ref10, dimensionId) {
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee6() {
      var dispatch, getters, dimension, pivotedFilters;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            dispatch = _ref10.dispatch, getters = _ref10.getters;
            dimension = getters[_types.getters.DIMENSION_BY_ID](dimensionId);
            pivotedFilters = getters[_types.getters.PIVOTED_FILTERS];
            pivotedFilters.forEach(function (pivotedFilter) {
              dispatch(__WEBPACK_IMPORTED_MODULE_3__app_shared_store_modules_Filters__["a" /* Types */].actions.REMOVE_SELECTED_FILTER_IN_CASCADE, pivotedFilter);
            });
            dispatch(_types.actions.INIT_BREADCRUMB, dimension);
            _context6.next = 1;
            return dispatch(_types.actions.INIT_LONG_GRID, dimension);
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  }), _types.actions.CHANGE_PIVOT, function (_ref11, _ref12) {
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee7() {
      var getters, commit, dispatch, params, option, dimension, dimensionToFilter, pivotedDimensionCellValue, breadCrumbItemText, filter;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            getters = _ref11.getters, commit = _ref11.commit, dispatch = _ref11.dispatch;
            params = _ref12.params, option = _ref12.option;
            dimension = getters[_types.getters.DIMENSION_BY_ID](option.id);
            dimensionToFilter = getters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_BreadCrumb__["a" /* Types */].getters.DIMENSION_TO_FILTER];
            pivotedDimensionCellValue = params.data[dimensionToFilter.id];
            breadCrumbItemText = "".concat(dimension.value, " en ").concat(pivotedDimensionCellValue);
            filter = buildFilter(params, dimensionToFilter);
            _context7.next = 1;
            return dispatch(_types.actions.PUSH_BREADCRUMB_ITEM, {
              dimension: dimension,
              filter: filter,
              breadCrumbItemText: breadCrumbItemText
            });
          case 1:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }))();
  }), _types.actions.PUSH_BREADCRUMB_ITEM, function (_ref13, _ref14) {
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee8() {
      var commit, dispatch, dimension, filter, breadCrumbItemText;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            commit = _ref13.commit, dispatch = _ref13.dispatch;
            dimension = _ref14.dimension, filter = _ref14.filter, breadCrumbItemText = _ref14.breadCrumbItemText;
            _context8.next = 1;
            return dispatch(_types.actions.FETCH_LONG_GRID, {
              dimension: dimension,
              filter: filter
            });
          case 1:
            commit(NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_BreadCrumb__["a" /* Types */].mutations.PUSH_ITEM, {
              dimension: dimension,
              filter: filter,
              text: breadCrumbItemText
            });
            commit(__WEBPACK_IMPORTED_MODULE_3__app_shared_store_modules_Filters__["a" /* Types */].mutations.ADD_SELECTED_FILTER, filter);
          case 2:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }))();
  }), _types.actions.POP_UNTIL_BREADCRUMB, function (_ref15, breadCrumbItem) {
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee9() {
      var state, commit, dispatch, getters, lastBreadCrumbItem;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            state = _ref15.state, commit = _ref15.commit, dispatch = _ref15.dispatch, getters = _ref15.getters;
            if (!(getters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_BreadCrumb__["a" /* Types */].getters.LAST_ITEM] === breadCrumbItem)) {
              _context9.next = 1;
              break;
            }
            return _context9.abrupt("return");
          case 1:
            while (getters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_BreadCrumb__["a" /* Types */].getters.LAST_ITEM] !== breadCrumbItem) {
              lastBreadCrumbItem = getters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_BreadCrumb__["a" /* Types */].getters.LAST_ITEM];
              commit(NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_BreadCrumb__["a" /* Types */].mutations.REMOVE_ITEM, lastBreadCrumbItem);
              dispatch(__WEBPACK_IMPORTED_MODULE_3__app_shared_store_modules_Filters__["a" /* Types */].actions.REMOVE_SELECTED_FILTER_IN_CASCADE, lastBreadCrumbItem.filter);
            }
            _context9.next = 2;
            return dispatch(_types.actions.FETCH_LONG_GRID, breadCrumbItem);
          case 2:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_actions, _types.actions.DOWNLOAD_GRID_TO_EXCEL, function (_ref16) {
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee0() {
      var state, getters, metrics, filters, calculatedField, factTableName, dateFilters, _getters2, dimension, strategyFilter;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            state = _ref16.state, getters = _ref16.getters;
            metrics = state.metrics, filters = state.filters, calculatedField = state.calculatedField, factTableName = state.factTableName, dateFilters = state.dateFilters;
            _getters2 = getters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_BreadCrumb__["a" /* Types */].getters.LAST_ITEM], dimension = _getters2.dimension, strategyFilter = _getters2.filter;
            _context0.next = 1;
            return downloadLongGridToXlsx({
              metrics: metrics,
              dimension: dimension,
              factTableName: factTableName,
              strategyFilter: strategyFilter,
              filters: filters,
              calculatedField: calculatedField,
              dateFilters: dateFilters
            });
          case 1:
          case "end":
            return _context0.stop();
        }
      }, _callee0);
    }))();
  }), _types.actions.RESET, function (_ref17) {
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee1() {
      var commit;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context1) {
        while (1) switch (_context1.prev = _context1.next) {
          case 0:
            commit = _ref17.commit;
            commit(NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_BreadCrumb__["a" /* Types */].mutations.RESET, null);
            commit(_types.mutations.SET_LONG_GRID, null);
          case 1:
          case "end":
            return _context1.stop();
        }
      }, _callee1);
    }))();
  })),
  mutations: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, _types.mutations.SET_DEFAULT_PARAMETERS, function (state, _ref18) {
    var metrics = _ref18.metrics,
      dateFilters = _ref18.dateFilters,
      factTableName = _ref18.factTableName,
      calculatedField = _ref18.calculatedField;
    state.metrics = metrics;
    state.calculatedField = calculatedField;
    state.dateFilters = dateFilters;
    state.factTableName = factTableName;
  }), _types.mutations.SET_LONG_GRID, function (state, longGrid) {
    state.grid = longGrid;
  }), _types.mutations.SET_DIMENSIONS, function (state, dimensions) {
    state.dimensions = dimensions;
  }),
  modules: {
    filters: __WEBPACK_IMPORTED_MODULE_3__app_shared_store_modules_Filters__["b" /* default */],
    breadCrumb: __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_BreadCrumb__["b" /* default */]
  }
};
/* harmony default export */ __webpack_exports__["b"] = (LongGrid);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dimension; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);


/* eslint-disable camelcase */
var Dimension = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function Dimension(_ref) {
  var dim_key = _ref.dim_key,
    description = _ref.description,
    dimension = _ref.dimension,
    selected = _ref.selected,
    dim_value = _ref.dim_value;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Dimension);
  this.id = dim_value;
  this.value = description;
  this.type = dimension;
  this.selected = selected;
  this.key = dim_key;
});


/***/ }),
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SalesAnalysisColumnDefinitionFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SalesAnalysisColumnDefinitionFactory = /*#__PURE__*/function () {
  function SalesAnalysisColumnDefinitionFactory() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, SalesAnalysisColumnDefinitionFactory);
  }
  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(SalesAnalysisColumnDefinitionFactory, null, [{
    key: "create",
    value: function create(columnDef) {
      if (columnDef.formatType) {
        return _objectSpread(_objectSpread({}, columnDef), {}, {
          cellRendererFramework: 'AgGridCellFormatter'
        });
      } else if (columnDef.children) {
        return _objectSpread(_objectSpread({}, columnDef), {}, {
          children: columnDef.children.map(function (child) {
            return SalesAnalysisColumnDefinitionFactory.create(child);
          })
        });
      } else {
        return columnDef;
      }
    }
  }]);
}();


/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRootUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return grantRootUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return revokeRootUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_client__ = __webpack_require__(39);




/**
 * Get list of all users with root access
 * @returns {Promise} Root users list
 */
var getRootUsers = /*#__PURE__*/function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
    var response, _t;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client__["c" /* ClientLambdaApi */].get('/admin/root-users');
        case 1:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 2:
          _context.prev = 2;
          _t = _context["catch"](0);
          console.error('Error fetching root users:', _t);
          throw _t;
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 2]]);
  }));
  return function getRootUsers() {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Otorga acceso root (administrador de plataforma) a un usuario existente.
 * @param {number|string} userId - ID numérico en auth_user
 * @returns {Promise<object>} Cuerpo de respuesta de la API
 */
var grantRootUser = /*#__PURE__*/function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2(userId) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client__["c" /* ClientLambdaApi */].post("/admin/root-users/".concat(userId));
        case 1:
          response = _context2.sent;
          return _context2.abrupt("return", response.data);
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function grantRootUser(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Revoca acceso root a un usuario.
 * @param {number|string} userId - ID numérico en auth_user
 * @returns {Promise<object>} Cuerpo de respuesta de la API
 */
var revokeRootUser = /*#__PURE__*/function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3(userId) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client__["c" /* ClientLambdaApi */]["delete"]("/admin/root-users/".concat(userId));
        case 1:
          response = _context3.sent;
          return _context3.abrupt("return", response.data);
        case 2:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function revokeRootUser(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shared_services_rootUsersService__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_client__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_components_ImpersonationAlert_vue__ = __webpack_require__(810);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    ImpersonationAlert: __WEBPACK_IMPORTED_MODULE_4__app_shared_components_ImpersonationAlert_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showPermissionAlert: false,
      permissionAction: 'realizar esta acción'
    };
  },
  created: function created() {
    var _this = this;
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
      var vm, handle403Error, apiClients;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            // Setup global 403 interceptor function
            vm = _this;
            handle403Error = /*#__PURE__*/function () {
              var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee(error) {
                var _vm$$route, routeToActionMap, currentPath;
                return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      if (error.response && error.response.status === 403) {
                        // Map the current route to a user-friendly action
                        routeToActionMap = {
                          '/admin/users-management': 'gestionar usuarios',
                          '/admin/users-management/user': 'editar usuario',
                          '/admin/users-management/create': 'crear usuario',
                          '/admin/users': 'gestionar usuarios',
                          '/admin/roles': 'gestionar roles',
                          '/admin/permissions': 'gestionar permisos'
                        };
                        currentPath = ((_vm$$route = vm.$route) === null || _vm$$route === void 0 ? void 0 : _vm$$route.path) || window.location.pathname;
                        vm.permissionAction = routeToActionMap[currentPath] || 'realizar esta acción';

                        // Root users are already loaded in store via getters

                        vm.showPermissionAlert = true;

                        // Auto-hide after 10 seconds
                        setTimeout(function () {
                          vm.showPermissionAlert = false;
                        }, 10000);
                      }
                      return _context.abrupt("return", Promise.reject(error));
                    case 1:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function handle403Error(_x) {
                return _ref.apply(this, arguments);
              };
            }(); // Add interceptor to all API clients
            apiClients = [__WEBPACK_IMPORTED_MODULE_3__api_client__["c" /* ClientLambdaApi */], __WEBPACK_IMPORTED_MODULE_3__api_client__["b" /* ClientErAdminData */], __WEBPACK_IMPORTED_MODULE_3__api_client__["a" /* ClientBackGroundTasks */]];
            apiClients.forEach(function (client, index) {
              client.interceptors.response.use(function (response) {
                return response;
              }, handle403Error);
            });
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  methods: {
    hidePermissionAlert: function hidePermissionAlert() {
      this.showPermissionAlert = false;
    },
    copyEmail: function copyEmail(email) {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _t;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return navigator.clipboard.writeText(email);
            case 1:
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t = _context3["catch"](0);
              // Fallback for older browsers
              _this2.fallbackCopyEmail(email);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 2]]);
      }))();
    },
    fallbackCopyEmail: function fallbackCopyEmail(email) {
      // Fallback method for older browsers
      var textArea = document.createElement('textarea');
      textArea.value = email;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
      } catch (error) {
        // Fallback copy failed
      }
      document.body.removeChild(textArea);
    }
  },
  computed: {
    rootUsers: function rootUsers() {
      return this.$store.getters.rootUsers || [];
    },
    filteredRootUsers: function filteredRootUsers() {
      if (!this.rootUsers || !this.rootUsers.root_users) {
        return [];
      }
      // Filter out users with root_type "DOMAIN_BASED"
      return this.rootUsers.root_users.filter(function (user) {
        return user.root_type !== 'DOMAIN_BASED';
      });
    }
  }
});

/***/ }),
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ImpersonationAlert',
  data: function data() {
    return {
      showAlert: false,
      impersonatedUser: {
        name: '',
        surname: '',
        email: ''
      },
      processing: false
    };
  },
  mounted: function mounted() {
    this.startWatching();
  },
  beforeDestroy: function beforeDestroy() {
    this.stopWatching();
  },
  methods: {
    startWatching: function startWatching() {
      var _this = this;
      this.checkImpersonationStatus();
      // Check for changes every second to detect new impersonation sessions
      this.checkInterval = setInterval(function () {
        _this.checkImpersonationStatus();
      }, 1000);
    },
    stopWatching: function stopWatching() {
      if (this.checkInterval) {
        clearInterval(this.checkInterval);
      }
    },
    checkImpersonationStatus: function checkImpersonationStatus() {
      var impersonationData = localStorage.getItem('impersonationData');
      if (impersonationData) {
        try {
          var data = JSON.parse(impersonationData);
          this.impersonatedUser = data.impersonatedUser;
          this.showAlert = true;
        } catch (error) {
          console.error('Error parsing impersonation data:', error);
          this.clearImpersonationData();
        }
      } else {
        this.showAlert = false;
        this.impersonatedUser = {
          name: '',
          surname: '',
          email: ''
        };
      }
    },
    stopImpersonation: function stopImpersonation() {
      var _this2 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var impersonationData, data, _t;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _this2.processing = true;

              // Get the original token from stored data
              impersonationData = localStorage.getItem('impersonationData');
              if (!impersonationData) {
                _context.next = 2;
                break;
              }
              data = JSON.parse(impersonationData); // Restore the original access token
              localStorage.setItem('accessToken', data.originalToken);

              // Clear impersonation data
              _this2.clearImpersonationData();

              // Reload desktop parameter config to restore admin's original data
              _context.next = 1;
              return _this2.$store.dispatch('fetchDesktopParameterConfig');
            case 1:
              // Show success message
              _this2.$bvToast.toast('La suplantación se ha detenido correctamente', {
                title: 'Suplantación Detenida',
                variant: 'success',
                solid: true,
                autoHideDelay: 3000
              });

              // Route back to user management
              _this2.$router.push({
                name: 'usersManagement'
              });
            case 2:
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](0);
              console.error('Error stopping impersonation:', _t);
              _this2.$bvToast.toast('Error al detener la suplantación', {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000
              });
            case 4:
              _context.prev = 4;
              _this2.processing = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 3, 4, 5]]);
      }))();
    },
    clearImpersonationData: function clearImpersonationData() {
      localStorage.removeItem('impersonationData');
      this.showAlert = false;
      this.impersonatedUser = {
        name: '',
        surname: '',
        email: ''
      };
    }
  }
});

/***/ }),
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__expertoRetail_atoms_ExpertoRetailLoader__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_nav_bar_BaseHeader__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_WebSocketService__ = __webpack_require__(220);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_2__expertoRetail_atoms_ExpertoRetailLoader__["a" /* default */],
    BaseHeader: __WEBPACK_IMPORTED_MODULE_3__app_nav_bar_BaseHeader__["a" /* default */]
  },
  data: function data() {
    return {
      initialDataLoading: true
    };
  },
  computed: {
    configLoaded: function configLoaded() {
      return this.$store.getters.isConfigLoaded;
    },
    loadingText: function loadingText() {
      return !this.configLoaded ? 'Cargando Configuraciones' : 'Cargando status de venta';
    },
    userInfo: function userInfo() {
      return this.$store.getters.userInfo || {};
    }
  },
  mounted: function mounted() {
    var _this = this;
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.getAvailableSize();
            _context.next = 1;
            return _this.$store.dispatch('fetchDesktopParameterConfig');
          case 1:
            // Connect to WebSocket after config is loaded and userInfo is available
            if (_this.userInfo && _this.userInfo.id) {
              __WEBPACK_IMPORTED_MODULE_4__services_WebSocketService__["a" /* default */].connect(_this.userInfo.id);
            }
            _this.initialDataLoading = false;
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventHub.$off('dashboard-is-ready');
  },
  methods: {
    getAvailableSize: function getAvailableSize() {
      var viewPort = window.innerHeight;
      var headerHeight = 41;
      this.$store.commit('commit_appAvailableHeight', viewPort - headerHeight);
    }
  }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ExpertoRetailLoader',
  props: {
    color: {
      type: String,
      "default": function _default() {
        return '#290A99';
      }
    }
  }
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeaderDropdownAccntCustom_vue__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HeaderDropdownTradeMarketing_vue__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HeaderDropdownCommercial_vue__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DwStatusButton_vue__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SalesStatusModal_vue__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_WebSocketMessageHandler__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_api_ExpertoRetail__ = __webpack_require__(47);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BaseHeader',
  components: {
    HeaderDropdownAccntCustom: __WEBPACK_IMPORTED_MODULE_2__HeaderDropdownAccntCustom_vue__["a" /* default */],
    HeaderDropdownTradeMarketing: __WEBPACK_IMPORTED_MODULE_3__HeaderDropdownTradeMarketing_vue__["a" /* default */],
    HeaderDropdownCommercial: __WEBPACK_IMPORTED_MODULE_4__HeaderDropdownCommercial_vue__["a" /* default */],
    DwStatusButton: __WEBPACK_IMPORTED_MODULE_5__components_DwStatusButton_vue__["a" /* default */],
    SalesStatusModal: __WEBPACK_IMPORTED_MODULE_6__components_SalesStatusModal_vue__["a" /* default */]
  },
  data: function data() {
    return {
      lastDwUpdate: null,
      dwJobLoading: false,
      dwJobProgress: 0,
      dwJobError: null,
      isNavCollapsed: false,
      dwStatusInterval: null,
      showSalesStatusModal: false
    };
  },
  computed: {
    isAdmin: function isAdmin() {
      return this.$store.getters.isAdmin;
    },
    activeWorkspace: function activeWorkspace() {
      return this.$store.state.desktopParameterConfig ? this.$store.state.desktopParameterConfig.activeWorkspace : null;
    },
    activeWorkspaceTooltip: function activeWorkspaceTooltip() {
      return this.activeWorkspace ? "Escenario Activado: ".concat(this.activeWorkspace.name) : '';
    },
    workspaceLoaded: function workspaceLoaded() {
      return this.activeWorkspace !== null;
    },
    contractModules: function contractModules() {
      return this.$store.getters.contractModules;
    },
    userModules: function userModules() {
      return this.$store.getters.userModules || [];
    }
  },
  watch: {
    dwJobLoading: function dwJobLoading(newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.$bvToast.toast('El proceso de actualización del Data Warehouse ha comenzado. Esta actualización puede incorporar nuevas ventas, modificaciones en productos o mapeos, así como ajustes en precios. Revisa el estado de carga para conocer cuándo finaliza el proceso.', {
          title: 'Actualización del Data Warehouse',
          variant: 'info',
          solid: true,
          autoHideDelay: 8000,
          toaster: 'b-toaster-top-right'
        });
      }
    },
    '$route.name': function $routeName(newRoute) {
      if (newRoute === 'clientTermsAcceptance') {
        this.showSalesStatusModal = false;
      }
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_7__services_WebSocketMessageHandler__["a" /* default */].on('dwEtlJobUpdate', this.handleEtlJobUpdate);
    this.fetchInitialDwStatus();
    this.startDwStatusCheck();
    if (this.$route.name !== 'clientTermsAcceptance' && !sessionStorage.getItem('salesStatusShown')) {
      this.showSalesStatusModal = true;
      sessionStorage.setItem('salesStatusShown', '1');
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_7__services_WebSocketMessageHandler__["a" /* default */].off('dwEtlJobUpdate', this.handleEtlJobUpdate);
    this.stopDwStatusCheck();
  },
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    mobileSidebarToggle: function mobileSidebarToggle() {
      this.isNavCollapsed = !this.isNavCollapsed;
    },
    goTo: function goTo(view) {
      this.$router.push({
        name: view
      });
    },
    handleCreateReport: function handleCreateReport() {
      // Navigate to sellout dashboard where users can create reports
      if (this.$router) {
        this.$router.push('/sellout_dashboard');
      } else {
        // Fallback to window location if router is not available
        window.location.href = '/sellout_dashboard';
      }
    },
    fetchInitialDwStatus: function fetchInitialDwStatus() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var dwStatusArr, latest, _t;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return __WEBPACK_IMPORTED_MODULE_8__services_api_ExpertoRetail__["a" /* general */].dwJobResultStatus();
            case 1:
              dwStatusArr = _context.sent;
              if (Array.isArray(dwStatusArr) && dwStatusArr.length > 0) {
                // Get the latest finished_at (in case there are multiple)
                latest = dwStatusArr.reduce(function (a, b) {
                  return a.finished_at > b.finished_at ? a : b;
                });
                if (latest.finished_at) {
                  _this.lastDwUpdate = _this.$moment(Number(latest.finished_at)).local().format('ddd D MMM YYYY H:mm');
                }
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.warn('No se pudo obtener el estado inicial del Data Warehouse:', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 2]]);
      }))();
    },
    handleEtlJobUpdate: function handleEtlJobUpdate(eventData) {
      var _this2 = this;
      var progress = eventData.progress,
        error = eventData.error,
        isWorking = eventData.isWorking,
        isDone = eventData.isDone,
        hasError = eventData.hasError,
        finishedAt = eventData.finished_at;
      this.dwJobLoading = isWorking;
      if (progress !== null) {
        this.dwJobProgress = progress;
      }
      this.dwJobError = hasError ? error : null;
      if (isWorking && !this.dwJobLoading) {
        this.$bvToast.toast('El proceso de actualización del Data Warehouse ha comenzado via WebSocket. Recibirás actualizaciones en tiempo real del progreso.', {
          title: 'Actualización del Data Warehouse Iniciada',
          variant: 'info',
          solid: true,
          autoHideDelay: 5000,
          toaster: 'b-toaster-top-right'
        });
      } else if (isDone) {
        this.dwJobProgress = 100;
        this.$bvToast.toast('La actualización del Data Warehouse se ha completado exitosamente. Los nuevos datos ya están disponibles.', {
          title: 'Actualización Completada',
          variant: 'success',
          solid: true,
          autoHideDelay: 5000,
          toaster: 'b-toaster-top-right'
        });
        setTimeout(function () {
          _this2.dwJobProgress = 0;
        }, 3000);
      } else if (hasError) {
        this.$bvToast.toast("Error durante la actualizaci\xF3n: ".concat(error), {
          title: 'Error en Actualización',
          variant: 'danger',
          solid: true,
          autoHideDelay: 8000,
          toaster: 'b-toaster-top-right'
        });
        setTimeout(function () {
          _this2.dwJobProgress = 0;
        }, 3000);
      }
      if (isDone || hasError) {
        if (finishedAt) {
          this.lastDwUpdate = this.$moment(Number(finishedAt)).local().format('ddd D MMM YYYY H:mm');
        } else {
          this.lastDwUpdate = this.$moment().local().format('ddd D MMM YYYY H:mm');
        }
      }
    },
    startDwStatusCheck: function startDwStatusCheck() {
      this.dwStatusInterval = setInterval(this.fetchInitialDwStatus, 300000); // 5 minutes
    },
    stopDwStatusCheck: function stopDwStatusCheck() {
      if (this.dwStatusInterval) {
        clearInterval(this.dwStatusInterval);
        this.dwStatusInterval = null;
      }
    },
    refreshDwStatus: function refreshDwStatus() {
      var _this3 = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var dwStatus, _t2;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.dwJobLoading = true;
              _this3.dwJobProgress = 0;
              _this3.dwJobError = null;
              _context2.prev = 1;
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_8__services_api_ExpertoRetail__["a" /* general */].dwJobResultStatus();
            case 2:
              dwStatus = _context2.sent;
              if (dwStatus && dwStatus.last_update) {
                _this3.lastDwUpdate = _this3.$moment(dwStatus.last_update).local().format('ddd D MMM YYYY h:mm A z');
              }
              _context2.next = 4;
              break;
            case 3:
              _context2.prev = 3;
              _t2 = _context2["catch"](1);
              console.warn('Error al actualizar el estado del Data Warehouse:', _t2);
              _this3.dwJobError = _t2.message || 'Error desconocido';
            case 4:
              _context2.prev = 4;
              _this3.dwJobLoading = false;
              return _context2.finish(4);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1, 3, 4, 5]]);
      }))();
    },
    handleModalReset: function handleModalReset() {
      // Silent refresh without toast
      this.fetchInitialDwStatus();
    }
  }
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_WebSocketService__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_authentication_compositions_UseAuthentication__ = __webpack_require__(726);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { user } from '@/services/api/ExpertoRetail'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HeaderUserInfo',
  setup: function setup() {
    var _useAuthentication = Object(__WEBPACK_IMPORTED_MODULE_3__app_authentication_compositions_UseAuthentication__["a" /* default */])(),
      authLogout = _useAuthentication.logout;
    return {
      authLogout: authLogout
    };
  },
  computed: {
    appVersion: function appVersion() {
      return "v3.55.0" || 'dev';
    },
    userInfo: function userInfo() {
      return this.$store.getters.userInfo || {};
    },
    userInitials: function userInitials() {
      if (!this.userInfo || !this.userInfo.name) return 'U';
      var names = this.userInfo.name.trim().split(' ');
      if (names.length === 1) {
        return names[0].charAt(0).toUpperCase();
      }

      // Take first letter of first name and first letter of last name
      return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
    }
  },
  methods: {
    navigateToApi: function navigateToApi() {
      this.$router.push({
        name: 'UserApiIndex'
      });
    },
    logout: function logout() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // Disconnect WebSocket before logout
              __WEBPACK_IMPORTED_MODULE_2__services_WebSocketService__["a" /* default */].disconnect();

              // Use new composition API logout (calls backend + clears localStorage and WebSocket)
              _context.next = 1;
              return _this.authLogout();
            case 1:
              // Clear other app state (keep existing store mutations for other modules)
              _this.$store.commit('reset_app');

              // Only commit filter reset if the mutation exists (it's namespaced)
              try {
                _this.$store.commit('filterRequestObject/commit_filterPane_resetState');
              } catch (error) {
                console.warn('⚠️ Filter pane reset mutation not found:', error.message);
              }

              // Navigate to login
              _this.$router.push({
                name: 'login'
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
});

/***/ }),
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_massive_download_models_RequiredSelection__ = __webpack_require__(851);



var MassiveDownload = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function MassiveDownload(_ref) {
  var requiredSelection = _ref.requiredSelection,
    columnSelection = _ref.columnSelection,
    filterSelection = _ref.filterSelection;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, MassiveDownload);
  this.requiredSelection = new __WEBPACK_IMPORTED_MODULE_2__app_massive_download_models_RequiredSelection__["a" /* default */](requiredSelection);
  this.columnSelection = columnSelection;
  this.filterSelection = filterSelection;
});
/* harmony default export */ __webpack_exports__["a"] = (MassiveDownload);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dimension; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);


/* eslint-disable camelcase */
var Dimension = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function Dimension(_ref) {
  var dim_key = _ref.dim_key,
    description = _ref.description,
    dimension = _ref.dimension,
    selected = _ref.selected,
    dim_value = _ref.dim_value;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Dimension);
  this.id = dim_value;
  this.value = description;
  this.type = dimension;
  this.selected = selected;
  this.key = dim_key;
});


/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLongGrid; });
/* unused harmony export getWideGrid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStoresWithinRadius; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_client_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_AgGrid_js__ = __webpack_require__(865);




var getLongGrid = /*#__PURE__*/function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee(longGridPayload) {
    var longGrid;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/long-grid-data/', longGridPayload);
        case 1:
          longGrid = _context.sent;
          return _context.abrupt("return", new __WEBPACK_IMPORTED_MODULE_3__models_AgGrid_js__["a" /* default */](longGrid.data));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getLongGrid(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getWideGrid = /*#__PURE__*/function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2(wideGridPayload) {
    var wideGrid;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/wide-grid-data/', wideGridPayload);
        case 1:
          wideGrid = _context2.sent;
          return _context2.abrupt("return", new __WEBPACK_IMPORTED_MODULE_3__models_AgGrid_js__["a" /* default */](wideGrid.data));
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getWideGrid(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var getStoresWithinRadius = /*#__PURE__*/function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3(storeId, radius) {
    var storesWithinRadius;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/store/".concat(storeId, "/stores-around/").concat(radius));
        case 1:
          storesWithinRadius = _context3.sent;
          return _context3.abrupt("return", storesWithinRadius.data.map(function (store) {
            return store.store_id;
          }));
        case 2:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getStoresWithinRadius(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();


/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMESPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_utils_NamespaceHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_Filters__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_weekly_sales_store_WeeklyComparative__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_weekly_sales_store_WeeklyDetail__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_shared_models_Dimension__ = __webpack_require__(225);








var NAMESPACE = 'weeklySales';
var INTERNAL_NAMESPACE = NAMESPACE + '/';
var _types = {
  getters: {
    SORT_FIELD: 'GETTER_SORT_FIELD',
    DIMENSION_BY_ID: 'DIMENSION_BY_ID',
    METRIC_OPTIONS: 'METRIC_OPTIONS'
  },
  actions: {
    INIT: 'INIT',
    CHANGE_METRIC: 'CHANGE_METRIC',
    SAVE_FILTERS: 'SAVE_FILTERS',
    RESET: 'RESET'
  },
  mutations: {
    SET_DIMENSIONS: 'SET_DIMENSIONS',
    SET_METRIC: 'SET_METRIC'
  }
};
var Types = Object(__WEBPACK_IMPORTED_MODULE_3__app_shared_utils_NamespaceHelper__["a" /* addNamespace */])(INTERNAL_NAMESPACE, _types);
var Index = {
  namespaced: true,
  state: {
    dimensions: null,
    metric: null
  },
  getters: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.getters.SORT_FIELD, function (state, getters) {
    var metricsNormalLength = getters[_types.getters.METRICS].normal.length;
    var sortField = getters[_types.getters.METRICS].normal[metricsNormalLength - 1];
    return sortField;
  }), _types.getters.DIMENSION_BY_ID, function (state) {
    return function (dimensionId) {
      return state.dimensions.find(function (dimension) {
        return dimension.id === dimensionId;
      });
    };
  }), _types.getters.METRIC_OPTIONS, function (_) {
    return [{
      caption: 'U',
      value: 'quantity_sold',
      name: 'UNITS',
      tooltip: 'Unidades'
    }, {
      caption: '$',
      value: 'real_sales_amount',
      name: 'PESOS',
      tooltip: 'Pesos'
    }];
  }), _types.getters.METRIC, function (state, getters) {
    return getters[_types.getters.METRIC_OPTIONS].find(function (metricOption) {
      return metricOption.name === state.metricName;
    });
  }),
  actions: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.actions.INIT, function (_ref, _ref2) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
      var commit, dataDimensions, metric;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            dataDimensions = _ref2.dataDimensions, metric = _ref2.metric;
            commit(_types.mutations.SET_DIMENSIONS, dataDimensions.map(function (dimension) {
              return new __WEBPACK_IMPORTED_MODULE_7__app_shared_models_Dimension__["a" /* default */](dimension);
            }));
            commit(_types.mutations.SET_METRIC, metric);
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }), _types.actions.CHANGE_METRIC, function (_ref3, metric) {
    var commit = _ref3.commit;
    commit(_types.mutations.SET_METRIC, metric);
  }), _types.actions.SAVE_FILTERS, function (_ref4, _ref5) {
    var dispatch = _ref4.dispatch;
    var storeFilters = _ref5.storeFilters,
      productFilters = _ref5.productFilters;
    dispatch(INTERNAL_NAMESPACE + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_Filters__["a" /* Types */].actions.SET_SELECTED_FILTERS, {
      storeFilters: storeFilters,
      productFilters: productFilters
    }, {
      root: true
    });
  }), _types.actions.RESET, function (_ref6) {
    var dispatch = _ref6.dispatch;
    dispatch(INTERNAL_NAMESPACE + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_Filters__["a" /* Types */].actions.RESET_SELECTED_FILTERS, null, {
      root: true
    });
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.mutations.SET_DIMENSIONS, function (state, dimensions) {
    state.dimensions = dimensions;
  }), _types.mutations.SET_METRIC, function (state, metric) {
    state.metric = metric;
  }),
  modules: {
    filters: __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_Filters__["b" /* default */],
    weeklyComparative: __WEBPACK_IMPORTED_MODULE_5__app_weekly_sales_store_WeeklyComparative__["a" /* default */],
    weeklyDetail: __WEBPACK_IMPORTED_MODULE_6__app_weekly_sales_store_WeeklyDetail__["a" /* default */]
  }
};
/* harmony default export */ __webpack_exports__["c"] = (Index);

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NAMESPACE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_models_BreadCrumbItem__ = __webpack_require__(871);


var NAMESPACE = 'breadCrumb/';
var _types = {
  getters: {
    LAST_ITEM: 'LAST_ITEM',
    DIMENSION_IDS_IN_BREADCRUMB: 'DIMENSION_IDS_IN_BREADCRUMB',
    DIMENSION_IDS_IN_FILTERS: 'DIMENSION_IDS_IN_FILTERS',
    DIMENSION_TO_FILTER: 'DIMENSION_TO_FILTER',
    FIRST_ITEM: 'FIRST_ITEM'
  },
  actions: {},
  mutations: {
    RESET: 'RESET',
    PUSH_ITEM: 'PUSH_ITEM',
    REMOVE_ITEM: 'REMOVE_ITEM'
  }
};
var Types = _types;
var BreadCrumb = {
  namespaced: true,
  state: function state() {
    return {
      items: []
    };
  },
  getters: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, _types.getters.DIMENSION_IDS_IN_BREADCRUMB, function (state) {
    return state.items.map(function (item) {
      return item.dimension.id;
    });
  }), _types.getters.LAST_ITEM, function (state) {
    return state.items.length > 0 ? state.items[state.items.length - 1] : {};
  }), _types.getters.FIRST_ITEM, function (state) {
    return state.items.length > 0 ? state.items[0] : {};
  }), _types.getters.DIMENSION_TO_FILTER, function (state, getters) {
    return getters[_types.getters.LAST_ITEM].dimension;
  }), _types.getters.FILTERS, function (state) {
    return state.items.filter(function (item) {
      return item.filter;
    }).map(function (item) {
      return item.filter;
    });
  }), _types.getters.DIMENSION_IDS_IN_FILTERS, function (state, getters) {
    return getters[_types.getters.FILTERS].map(function (filterItem) {
      return filterItem.keyField;
    });
  }),
  actions: {},
  mutations: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, _types.mutations.PUSH_ITEM, function (state, _ref) {
    var dimension = _ref.dimension,
      filter = _ref.filter,
      text = _ref.text;
    var breadCrumbItem = new __WEBPACK_IMPORTED_MODULE_1__app_shared_models_BreadCrumbItem__["a" /* default */]({
      dimension: dimension,
      filter: filter,
      text: text
    });
    state.items.push(breadCrumbItem);
  }), _types.mutations.REMOVE_ITEM, function (state, item) {
    var itemIndex = state.items.indexOf(item);
    state.items.splice(itemIndex, 1);
  }), _types.mutations.RESET, function (state) {
    state.items = [];
  }),
  modules: {}
};
/* harmony default export */ __webpack_exports__["b"] = (BreadCrumb);

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OneDimensionStrategy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);


var OneDimensionStrategy = /*#__PURE__*/function () {
  function OneDimensionStrategy(dimension, filter) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, OneDimensionStrategy);
    this.dimension = dimension;
    this.filter = filter;
    this.storeFilters = {};
    this.productFilters = {};
  }
  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(OneDimensionStrategy, [{
    key: "_buildDimensions",
    value: function _buildDimensions() {
      var selectedDimensionIds = [this.dimension.id];
      if (this.dimension.type === 'store') this.storeDimensions = selectedDimensionIds;
      if (this.dimension.type === 'product') this.productDimensions = selectedDimensionIds;
    }
  }, {
    key: "_buildFilter",
    value: function _buildFilter() {
      var filterIds = this.filter.value;
      if (this.filter.keyFieldType === 'store') this.storeFilters[this.filter.keyField] = filterIds;
      if (this.filter.keyFieldType === 'product') this.productFilters[this.filter.keyField] = filterIds;
    }
  }, {
    key: "build",
    value: function build() {
      if (!('dimension' in this)) {
        throw new Error('Falta la dimensión');
      }
      if (this.filter) {
        this._buildFilter();
      }
      this._buildDimensions();
      return this;
    }
  }]);
}();


/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PayloadParametersBuilder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_models_PayloadParameters__ = __webpack_require__(873);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var Fact = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(function Fact(factName) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'table';
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Fact);
  this.type = type;
  this.name = factName;
});
var PayloadParametersBuilder = /*#__PURE__*/function () {
  function PayloadParametersBuilder(_ref) {
    var metrics = _ref.metrics,
      factTableName = _ref.factTableName,
      filters = _ref.filters,
      dateFilters = _ref.dateFilters,
      dateDimensions = _ref.dateDimensions,
      _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? 0 : _ref$limit,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset,
      _ref$pivot = _ref.pivot,
      pivot = _ref$pivot === void 0 ? '' : _ref$pivot;
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, PayloadParametersBuilder);
    this.limit = limit;
    this.offset = offset;
    this.fact = new Fact(factTableName);
    this.metrics = metrics;
    this.storeFilters = _objectSpread({}, filters.selectedStoreFilters);
    this.productFilters = _objectSpread({}, filters.selectedProductFilters);
    this.pivot = pivot;
    this.dateFilters = dateFilters;
    this.dateDimensions = dateDimensions;
  }
  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(PayloadParametersBuilder, [{
    key: "_buildSorting",
    value: function _buildSorting() {
      var defaultSortField = this.metrics.normal[0];
      this.sort = {
        field: defaultSortField,
        dir: 'DESC'
      };
    }
  }, {
    key: "_buildFilters",
    value: function _buildFilters(payloadParametersByStrategy) {
      var storeFilterField = Object.keys(payloadParametersByStrategy.storeFilters)[0];
      var productFilterField = Object.keys(payloadParametersByStrategy.productFilters)[0];
      this.storeFilters[storeFilterField] = payloadParametersByStrategy.storeFilters[storeFilterField];
      this.productFilters[productFilterField] = payloadParametersByStrategy.productFilters[productFilterField];
    }
  }, {
    key: "build",
    value: function build(strategyBuilder) {
      if (!('metrics' in this)) {
        throw new Error('Faltan las metricas');
      }
      this._buildSorting();
      var payloadParametersByStrategy = strategyBuilder.build();
      this._buildFilters(payloadParametersByStrategy);
      var payloadParameters = new __WEBPACK_IMPORTED_MODULE_3__app_shared_models_PayloadParameters__["a" /* default */](_objectSpread(_objectSpread({}, payloadParametersByStrategy), this));
      return payloadParameters;
    }
  }]);
}();


/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Role; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);


/* eslint-disable camelcase */
var Role = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function Role(_ref) {
  var role_id = _ref.role_id,
    role_name = _ref.role_name;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Role);
  this.id = role_id || '';
  this.name = role_name || '';
});


/***/ }),
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compositions_DropdownTradeMarketing__ = __webpack_require__(940);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HeaderDropdownTradeMarketing',
  props: {
    data: {
      type: Array,
      "default": function _default() {
        return [];
      }
    }
  },
  setup: function setup(props, context) {
    var _dropdownTradeMarketi = Object(__WEBPACK_IMPORTED_MODULE_0__compositions_DropdownTradeMarketing__["a" /* default */])(props, context),
      filteredUserModules = _dropdownTradeMarketi.filteredUserModules;
    return {
      filteredUserModules: filteredUserModules
    };
  }
});

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compositions_DropdownCommercial__ = __webpack_require__(943);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HeaderDropdownCommercial',
  props: {
    data: {
      type: Array,
      "default": function _default() {
        return [];
      }
    }
  },
  setup: function setup(props, context) {
    var _dropdownCommercialCo = Object(__WEBPACK_IMPORTED_MODULE_0__compositions_DropdownCommercial__["a" /* default */])(props, context),
      filteredUserModules = _dropdownCommercialCo.filteredUserModules;
    return {
      filteredUserModules: filteredUserModules
    };
  }
});

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_composition_api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_ExpertoRetail__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_WebSocketMessageHandler__ = __webpack_require__(221);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DwStatusButton',
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
      root = _ref.root;
    var lastDwUpdate = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(null);
    var dwJobLoading = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(false);
    var dwJobProgress = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(0);
    var dwStatusInterval = null;
    var $moment = root.$moment;
    var dwStatusTooltip = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      if (dwJobLoading.value) {
        return 'Estado de carga de datos - Actualizando...';
      }
      if (lastDwUpdate.value) {
        return "Estado de carga de datos\n\n\xDAltima actualizaci\xF3n:\n".concat(lastDwUpdate.value);
      }
      return 'Estado de carga de datos';
    });
    var dwStatusDateText = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      if (lastDwUpdate.value && !dwJobLoading.value) {
        var lastUpdate = $moment(lastDwUpdate.value, 'ddd D MMM YYYY H:mm');
        return lastUpdate.format('DD/MM HH:mm');
      }
      return null;
    });
    function fetchInitialDwStatus() {
      return _fetchInitialDwStatus.apply(this, arguments);
    }
    function _fetchInitialDwStatus() {
      _fetchInitialDwStatus = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var dwStatusArr, latest, _t;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return __WEBPACK_IMPORTED_MODULE_3__services_api_ExpertoRetail__["a" /* general */].dwJobResultStatus();
            case 1:
              dwStatusArr = _context.sent;
              if (Array.isArray(dwStatusArr) && dwStatusArr.length > 0) {
                latest = dwStatusArr.reduce(function (a, b) {
                  return a.finished_at > b.finished_at ? a : b;
                });
                if (latest.finished_at) {
                  lastDwUpdate.value = $moment(Number(latest.finished_at)).local().format('ddd D MMM YYYY H:mm');
                }
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 2]]);
      }));
      return _fetchInitialDwStatus.apply(this, arguments);
    }
    function handleEtlJobUpdate(eventData) {
      var progress = eventData.progress,
        isWorking = eventData.isWorking,
        isDone = eventData.isDone,
        hasError = eventData.hasError,
        finishedAt = eventData.finished_at;
      dwJobLoading.value = isWorking;
      if (progress !== null) {
        dwJobProgress.value = progress;
      }
      if (isDone || hasError) {
        if (finishedAt) {
          lastDwUpdate.value = $moment(Number(finishedAt)).local().format('ddd D MMM YYYY H:mm');
        } else {
          lastDwUpdate.value = $moment().local().format('ddd D MMM YYYY H:mm');
        }
      }
    }
    function startDwStatusCheck() {
      dwStatusInterval = setInterval(fetchInitialDwStatus, 300000); // 5 minutes
    }
    function stopDwStatusCheck() {
      if (dwStatusInterval) {
        clearInterval(dwStatusInterval);
        dwStatusInterval = null;
      }
    }
    Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["i" /* onMounted */])(function () {
      __WEBPACK_IMPORTED_MODULE_4__services_WebSocketMessageHandler__["a" /* default */].on('dwEtlJobUpdate', handleEtlJobUpdate);
      fetchInitialDwStatus();
      startDwStatusCheck();
    });
    Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["h" /* onBeforeUnmount */])(function () {
      __WEBPACK_IMPORTED_MODULE_4__services_WebSocketMessageHandler__["a" /* default */].off('dwEtlJobUpdate', handleEtlJobUpdate);
      stopDwStatusCheck();
    });
    return {
      dwStatusTooltip: dwStatusTooltip,
      dwStatusDateText: dwStatusDateText,
      dwJobLoading: dwJobLoading,
      dwJobProgress: dwJobProgress
    };
  }
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_ExpertoRetail__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_components_BaseModal_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_models_SalesStatus_js__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__ = __webpack_require__(271);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SalesStatusModal',
  components: {
    BaseModal: __WEBPACK_IMPORTED_MODULE_3__app_shared_components_BaseModal_vue__["a" /* default */],
    BTable: __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__["a" /* BTable */]
  },
  props: {
    show: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      salesStatusLoading: false,
      salesStatus: null,
      salesStatusFields: [{
        key: 'retailName',
        label: 'Cadena',
        "class": 'retail-col'
      }, {
        key: 'formattedLastSales',
        label: 'Última venta',
        "class": 'last-sale-col'
      }, {
        key: 'connectionStatus',
        label: 'Estado conexión',
        tdClass: function tdClass(row) {
          return row.connectionStatusClass;
        },
        "class": 'connection-col'
      }, {
        key: 'unmappedProductsCount',
        label: 'Productos no mapeados',
        "class": 'unmapped-products-col'
      }, {
        key: 'incidentDescription',
        label: 'Incidencias',
        "class": 'incidents-col'
      }]
    };
  },
  computed: {
    userRole: function userRole() {
      var _this$$store$getters$;
      return ((_this$$store$getters$ = this.$store.getters.userInfo) === null || _this$$store$getters$ === void 0 ? void 0 : _this$$store$getters$.role) || null;
    },
    userInfo: function userInfo() {
      return this.$store.getters.userInfo || {};
    },
    isAdmin: function isAdmin() {
      return this.$store.getters.isAdmin;
    },
    normalizedSalesStatus: function normalizedSalesStatus() {
      if (!this.salesStatus) return [];
      return __WEBPACK_IMPORTED_MODULE_4__app_shared_models_SalesStatus_js__["a" /* default */].fromArray(this.salesStatus);
    }
  },
  watch: {
    show: function show(val) {
      if (val) {
        this.getSalesStatus();
      }
    }
  },
  methods: {
    resetModalData: function resetModalData() {
      this.salesStatus = null;
      this.$emit('reset');
    },
    getSalesStatus: function getSalesStatus() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var _t;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.salesStatusLoading = true;
              _context.prev = 1;
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__services_api_ExpertoRetail__["d" /* sales */].salesStatus();
            case 2:
              _this.salesStatus = _context.sent;
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              console.error(_t);
            case 4:
              _this.salesStatusLoading = false;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 3]]);
      }))();
    },
    goToB2BCredentials: function goToB2BCredentials() {
      this.$router.push({
        name: 'B2BCredentialUpdate'
      });
      this.$emit('hide');
    },
    goToProductMaster: function goToProductMaster() {
      this.$router.push({
        name: 'ProductMaster'
      });
      this.$emit('hide');
    },
    goToLoadStatus: function goToLoadStatus() {
      this.$router.push({
        name: 'loadStatus'
      });
      this.$emit('hide');
    }
  }
});

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BaseModal',
  props: {
    // Modal visibility
    show: {
      type: Boolean,
      "default": false
    },
    // Modal configuration
    title: {
      type: String,
      "default": ''
    },
    size: {
      type: String,
      "default": 'md'
    },
    centered: {
      type: Boolean,
      "default": true
    },
    hideHeaderClose: {
      type: Boolean,
      "default": false
    },
    // Button configuration
    showCancel: {
      type: Boolean,
      "default": true
    },
    showConfirm: {
      type: Boolean,
      "default": true
    },
    cancelText: {
      type: String,
      "default": 'Cancelar'
    },
    confirmText: {
      type: String,
      "default": 'Confirmar'
    },
    confirmVariant: {
      type: String,
      "default": 'primary'
    },
    confirmDisabled: {
      type: Boolean,
      "default": false
    },
    bodyClass: {
      type: String,
      "default": ''
    },
    // Processing state
    processing: {
      type: Boolean,
      "default": false
    },
    processingText: {
      type: String,
      "default": 'Procesando...'
    }
  },
  computed: {
    modalVisible: {
      get: function get() {
        return this.show;
      },
      set: function set(value) {
        this.$emit('update:show', value);
      }
    }
  },
  methods: {
    cancelAction: function cancelAction() {
      this.$emit('cancel');
      this.$emit('update:show', false);
    },
    confirmAction: function confirmAction() {
      this.$emit('confirm');
    },
    onModalHidden: function onModalHidden() {
      this.$emit('hidden');
      this.$emit('update:show', false);
    }
  }
});

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__expertoRetail_organisms_ExpertoRetailMobileDashboard__ = __webpack_require__(959);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mobile',
  props: [],
  components: {
    Stores: __WEBPACK_IMPORTED_MODULE_0__expertoRetail_organisms_ExpertoRetailMobileDashboard__["a" /* default */]
  },
  data: function data() {
    return {
      textFilter: ''
    };
  }
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__expertoRetail_atoms_ExpertoRetailMobileStoreList__ = __webpack_require__(961);
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mobile',
  props: [],
  components: {
    StoreList: __WEBPACK_IMPORTED_MODULE_0__expertoRetail_atoms_ExpertoRetailMobileStoreList__["a" /* default */]
  },
  data: function data() {
    return {
      textFilter: '',
      storeList: {
        data: []
      }
    };
  },
  methods: {}
});

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__expertoRetail_atoms_ExpertoRetailLoader__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expertoRetail_defaultPayloads_organismsMobile__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_ExpertoRetail__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mobile-store-list',
  props: {
    // data: {
    //   type: Array,
    //   required: true,
    //   default: 0
    // }
  },
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_0__expertoRetail_atoms_ExpertoRetailLoader__["a" /* default */]
  },
  data: function data() {
    return {
      storeList: {
        data: {}
      },
      textFilter: '',
      // selected: 'retail_store_name',
      loading: false
    };
  },
  created: function created() {
    this.storeListRequest(__WEBPACK_IMPORTED_MODULE_1__expertoRetail_defaultPayloads_organismsMobile__["e" /* storeListParameters */]);
  },
  methods: {
    goToStore: function goToStore(id) {
      // this.$router.push({name: 'StoreDetail', params: {store_id: id}})
      this.$router.push({
        name: 'StoreDetail'
      });
      this.$store.commit('commit_store_id', id); // centraliza el store_id en vuex
    },
    storeListRequest: function storeListRequest(parameters) {
      var _this = this;
      this.loading = true;
      return new Promise(function (resolve, reject) {
        var vm = _this;
        __WEBPACK_IMPORTED_MODULE_2__services_api_ExpertoRetail__["d" /* sales */].salesTwoRanges(parameters).then(function (response) {
          _this.storeList.data = response.data;
          resolve();
        })["catch"](function (error) {
          reject(error);
        })["finally"](function () {
          vm.loading = false;
        });
      });
    }
  },
  computed: {
    filteredData: function filteredData() {
      // If there is no filter text, just return everyone
      if (!this.textFilter) return this.storeList.data;

      // Convert the search text to lower case
      var searchText = this.textFilter.toLowerCase();
      return this.storeList.data.filter(function (p) {
        return p.retail_store_name.toLowerCase().includes(searchText) || p.retail_name.toLowerCase().includes(searchText);
      });
    }
  }
});

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expertoRetail_defaultPayloads_organismsMobile__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_ExpertoRetail__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__expertoRetail_atoms_ExpertoRetailLoader__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_index__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__expertoRetail_atoms_Mobile_MobileFilter__ = __webpack_require__(972);

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mobile-store-detail',
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_3__expertoRetail_atoms_ExpertoRetailLoader__["a" /* default */],
    MobileFilters: __WEBPACK_IMPORTED_MODULE_5__expertoRetail_atoms_Mobile_MobileFilter__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_index__["c" /* GeneralUtils */]],
  data: function data() {
    return {
      storeDetail: {
        data: {}
      },
      checkingIn: false,
      checkedIn: false,
      checkedOut: false,
      store_id: this.$store.state.mobile.store_id,
      loading: false,
      activities: false,
      userPosition: {
        userPosition: {}
      },
      videoElement: {},
      canvasElement: '',
      front: true,
      navError: ''
    };
  },
  created: function created() {
    this.storeListRequest();
    if (this.userInfo.id === undefined) {
      this.$router.push('/');
    }
    this.$eventHub.$on('load-data-after-mobile-filter', this.storeListRequest);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventHub.$off('load-data-after-mobile-filter');
  },
  computed: {
    vuexMobileFilters: function vuexMobileFilters() {
      return this.$store.state.mobile.mobileFilters;
    },
    userInfo: function userInfo() {
      return this.$store.getters.userInfo;
    }
  },
  mounted: function mounted() {},
  methods: {
    storeListRequest: function storeListRequest() {
      var _this = this;
      var filterCopy = this.$_generalUtils_deepJsonCopy(this.vuexMobileFilters);
      __WEBPACK_IMPORTED_MODULE_1__expertoRetail_defaultPayloads_organismsMobile__["d" /* storeDetail */].parameters = _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__expertoRetail_defaultPayloads_organismsMobile__["d" /* storeDetail */].parameters), filterCopy);
      __WEBPACK_IMPORTED_MODULE_1__expertoRetail_defaultPayloads_organismsMobile__["d" /* storeDetail */].parameters.store_filters.store_id = [];
      __WEBPACK_IMPORTED_MODULE_1__expertoRetail_defaultPayloads_organismsMobile__["d" /* storeDetail */].parameters.store_filters.store_id.push(this.store_id.toString());
      this.loading = true;
      return new Promise(function (resolve, reject) {
        var vm = _this;
        __WEBPACK_IMPORTED_MODULE_2__services_api_ExpertoRetail__["d" /* sales */].salesTwoRanges(__WEBPACK_IMPORTED_MODULE_1__expertoRetail_defaultPayloads_organismsMobile__["d" /* storeDetail */]).then(function (response) {
          if (response.data[0] === undefined) {
            alert('No existen datos para el filtro seleccionado');
          } else {
            vm.storeDetail.data = response.data[0];
          }
          resolve();
        })["catch"](function (error) {
          reject(error);
        })["finally"](function () {
          vm.loading = false;
        });
      });
    },
    filterModal: function filterModal() {
      this.$eventHub.$emit('mobile-product-filter');
      this.$refs.FilterModalRef.hide();
    },
    addFilter: function addFilter(id) {
      __WEBPACK_IMPORTED_MODULE_1__expertoRetail_defaultPayloads_organismsMobile__["d" /* storeDetail */].parameters.store_filters.store_id = [];
      __WEBPACK_IMPORTED_MODULE_1__expertoRetail_defaultPayloads_organismsMobile__["d" /* storeDetail */].parameters.store_filters.store_id.push(id.toString());
      this.storeListRequest(__WEBPACK_IMPORTED_MODULE_1__expertoRetail_defaultPayloads_organismsMobile__["d" /* storeDetail */]);
    },
    goTo: function goTo(view) {
      this.$router.push({
        name: view
      });
    },
    showActivities: function showActivities() {
      var wmProduct = this.storeDetail.data.stock_quantity_wm;
      var newStock = this.storeDetail.data.new_stock_delta_quantity;
      if (wmProduct >= 1 || newStock >= 1) {
        this.activities = true;
      }
    },
    checkIn: function checkIn(position) {
      var userPosition = {};
      var coordinate = '(' + position.coords.longitude + ', ' + position.coords.latitude + ')';
      var d = new Date();
      var n = d.getTime();
      userPosition.user_id = this.userInfo.id;
      userPosition.store_id = this.store_id;
      userPosition.coordinate = coordinate;
      userPosition.latitude = position.coords.latitude;
      userPosition.longitude = position.coords.longitude;
      userPosition.checked_at = n;
      this.userPosition.userPosition = userPosition;
      this.userPostCheckIn(this.userPosition);
    },
    userPostCheckIn: function userPostCheckIn(parameters) {
      var _this2 = this;
      this.checkingIn = true;
      return new Promise(function (resolve, reject) {
        var vm = _this2;
        __WEBPACK_IMPORTED_MODULE_2__services_api_ExpertoRetail__["mobile"].userCheckIn(parameters).then(function () {
          vm.checkedIn = true;
          resolve(alert('Te has chequeado correctamente en tienda'));
        })["catch"](function (error) {
          reject(error);
          alert('No se ha podido enviar tu posición. Verifica que el gps de tu dispositivo esté encendido y prueba nuevamente');
        })["finally"](function () {
          vm.checkingIn = false;
        });
      });
    },
    getPosition: function getPosition() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.checkIn);
      } else {
        alert('Tu dispositivo no puede enviar la posición');
      }
    },
    pushToform: function pushToform(form) {
      this.$router.push({
        name: form
      });
    }
  }
});

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);


function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Crea un rango de números, similar a lo que hace python
    $_generalUtils_range: function $_generalUtils_range(start, end) {
      return Array(end - start + 1).fill().map(function (_, i) {
        return i + start;
      });
    },
    /* Inicio Sección fechas */
    // Se hizo necesario crear el formatting por los problemas que presenta js con las fechas al pasarla
    // a formato UTC, ejemplo el clásico detalle que resta un día a la fecha local
    $_generalUtils_YYYMMDDFormattingDate: function $_generalUtils_YYYMMDDFormattingDate() {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      // Aca solucionamos el otro problema de js que parte con el mes en 0
      var currentMonth = date.getMonth() + 1;
      var month = currentMonth < 10 ? '0' + currentMonth : currentMonth;
      var year = date.getFullYear();
      return "".concat(year).concat(month).concat(day);
    },
    $_generalUtils_getFirstMonthDayOnDate: function $_generalUtils_getFirstMonthDayOnDate() {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
      var formattedDate = this.$_generalUtils_YYYMMDDFormattingDate(date);
      return formattedDate.slice(0, 6) + '01';
    },
    $_generalUtils_getFirstYearDayOnDate: function $_generalUtils_getFirstYearDayOnDate() {
      var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date().getFullYear();
      if (typeof year !== 'number') {
        year = new Date().getFullYear();
      }
      return year.toString() + '0101';
    },
    $_generalUtils_getLastDayOfMonthOnDate: function $_generalUtils_getLastDayOfMonthOnDate(year, month) {
      var date = {};
      if (typeof year === 'number' && typeof month === 'number') {
        date = new Date(year, month, 0);
      } else {
        var currentYear = new Date().currentYear;
        date = new Date(currentYear, 12, 0);
      }
      return this.$_generalUtils_YYYMMDDFormattingDate(date);
    },
    $_generalUtils_getMonths: function $_generalUtils_getMonths() {
      var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'english';
      if (language === 'english') {
        return months;
      } else {
        throw new Error('Idioma no soportado');
      }
    },
    $_generalUtils_monthsMapper: function $_generalUtils_monthsMapper(objectToMap, dimension) {
      var totalColumnFlag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(objectToMap) === 'object') {
        /* Obtiene todos los atributos del objeto para comparar con el array de meses, si no hace match con ninguno quiere decir que no era siquiera un objeto de meses */
        var objectKeys = Object.keys(objectToMap);
        if (months.filter(function (x) {
          return objectKeys.includes(x);
        }).length > 0 && objectKeys.includes(dimension.dim_value) && objectKeys.includes(dimension.dim_key)) {
          var _mappedObject;
          var mappedObject = (_mappedObject = {}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_mappedObject, dimension.dim_key, objectToMap[dimension.dim_key]), dimension.dim_value, objectToMap[dimension.dim_value]), 'Enero', objectToMap.January ? objectToMap.January : 0), 'Febrero', objectToMap.February ? objectToMap.February : 0), 'Marzo', objectToMap.March ? objectToMap.March : 0), 'Abril', objectToMap.April ? objectToMap.April : 0), 'Mayo', objectToMap.May ? objectToMap.May : 0), 'Junio', objectToMap.June ? objectToMap.June : 0), 'Julio', objectToMap.July ? objectToMap.July : 0), 'Augosto', objectToMap.August ? objectToMap.August : 0), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_mappedObject, 'Septiembre', objectToMap.September ? objectToMap.September : 0), 'Octubre', objectToMap.October ? objectToMap.October : 0), 'Noviembre', objectToMap.November ? objectToMap.November : 0), 'Deciembre', objectToMap.December ? objectToMap.December : 0));
          /* Solo en caso de que se requiera crear un columna que tenga la suma de todas las otras columnas que sean de tipo number */
          if (totalColumnFlag) {
            var totalColumn = 0;
            for (var prop in objectToMap) {
              if (objectToMap.hasOwnProperty(prop) && typeof objectToMap[prop] === 'number') {
                totalColumn += objectToMap[prop];
              }
            }
            mappedObject = _objectSpread(_objectSpread({}, mappedObject), {}, {
              'Total': totalColumn
            });
          }
          return mappedObject;
        } else {
          throw Error('Objeto no corresponde a un objeto de meses');
        }
      } else {
        throw new Error('Parámetro no es un objeto');
      }
    },
    /* Fin Sección fechas */
    /* Sección Objetos   */
    $_generalUtils_deepJsonCopy: function $_generalUtils_deepJsonCopy(Object) {
      return JSON.parse(JSON.stringify(Object));
    }
  }
});

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dimensionData: this.$store.getters.dataPivotDimensions
    };
  },
  created: function created() {},
  methods: {
    $_dimensionUtils_getDimensionByAttribute: function $_dimensionUtils_getDimensionByAttribute(attribute, value) {
      var dimension;
      if (attribute && value) {
        dimension = this.$store.getters.dataPivotDimensions.find(function (x) {
          return x[attribute] === value;
        });
      }
      return dimension;
    },
    $_dimensionUtils_getDimensionParameter: function $_dimensionUtils_getDimensionParameter(value) {
      // Receives a value and returns the dimensions (value $ key) of stores and products
      // i: retail_name
      // o: {store_dimensions: [retail_name, retail_id], product_dimensions: []}
      var dim = this.dimensionData.filter(function (x) {
        return x.dim_value === value;
      })[0].dimension;
      var dimKey = this.dimensionData.filter(function (x) {
        return x.dim_value === value;
      })[0].dim_key;
      if (dim === 'store') {
        return {
          store_dimensions: [value, dimKey],
          product_dimensions: []
        };
      } else if (dim === 'product') {
        return {
          store_dimensions: [],
          product_dimensions: [value, dimKey]
        };
      }
    },
    $_dimensionUtils_getDimensionParameterOnlyValue: function $_dimensionUtils_getDimensionParameterOnlyValue(value) {
      // Receives a value and returns the dimensions (value) of stores and products
      // i: retail_name
      // o: {store_dimensions: [retail_name], product_dimensions: []}
      var dim = this.dimensionData.filter(function (x) {
        return x.dim_value === value;
      })[0].dimension;
      if (dim === 'store') {
        return {
          store_dimensions: [value],
          product_dimensions: []
        };
      } else if (dim === 'product') {
        return {
          store_dimensions: [],
          product_dimensions: [value]
        };
      }
    },
    $_dimensionUtils_getDimensionParameterComplete: function $_dimensionUtils_getDimensionParameterComplete(obj) {
      // Receives the complete parameter object and returns the dimensions of stores and products
      // ie: {store_dimensions: [], product_dimensions: [value1, value2]}
      if (obj.parameters.store_dimensions.length > 0) {
        var value = obj.parameters.store_dimensions[0];
        var dimValue = this.dimensionData.filter(function (x) {
          return x.dim_value === value;
        })[0].dim_value;
        var dimKey = this.dimensionData.filter(function (x) {
          return x.dim_value === value;
        })[0].dim_key;
        return {
          store_dimensions: [dimValue, dimKey],
          product_dimensions: []
        };
      } else if (obj.parameters.product_dimensions.length > 0) {
        var _value = obj.parameters.product_dimensions[0];
        var _dimValue = this.dimensionData.filter(function (x) {
          return x.dim_value === _value;
        })[0].dim_value;
        var _dimKey = this.dimensionData.filter(function (x) {
          return x.dim_value === _value;
        })[0].dim_key;
        return {
          store_dimensions: [],
          product_dimensions: [_dimValue, _dimKey]
        };
      }
    },
    $_dimensionUtils_getDimFromDimensionParameterComplete: function $_dimensionUtils_getDimFromDimensionParameterComplete(obj) {
      // Receives the complete parameter object and returns the main dim value
      // ie return: retail_name
      if (obj.parameters.store_dimensions.length > 0) {
        return obj.parameters.store_dimensions[0];
      } else if (obj.parameters.product_dimensions.length > 0) {
        return obj.parameters.product_dimensions[0];
      }
    },
    $_dimensionUtils_getDimFromDimension: function $_dimensionUtils_getDimFromDimension(obj) {
      // Receives the dimension parameter object and returns the main dim value
      // ie receives: {store_dimensions: [], product_dimensions: [value1, value2]}
      // ie return: retail_name
      if (obj.store_dimensions.length > 0) {
        return obj.store_dimensions[0];
      } else if (obj.product_dimensions.length > 0) {
        return obj.product_dimensions[0];
      }
    },
    $_dimensionUtils_gridParameterBuilder: function $_dimensionUtils_gridParameterBuilder(obj) {
      // TODO
    }
  }
});

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Valida que un array de items tenga la estructura necesaria para ser considerada una estructura Map
    // para este contexto
    // Ejemplo estructura válida {key: 1, value: '2015'}
    // Ejemplo estructura inválida {key: 2, name: '2015'  }
    $_generalValidator_keyValueMapArrayValidator: function $_generalValidator_keyValueMapArrayValidator(items) {
      return items.every(function (x) {
        return Object.keys(x).includes('key') && Object.keys(x).includes('value');
      });
    }
  }
});

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    $_filterObjectParameterBuilder_mergeFilterInstanceWithDimensionFilter: function $_filterObjectParameterBuilder_mergeFilterInstanceWithDimensionFilter(parameters, dimFilter) {
      // receives single value filter obj: {filter_type: 'product_filters', 'field': 'hlev_id', 'id': 2345753}
      if (typeof dimFilter === 'undefined') {
        throw new Error('El objeto dim filter es undefined');
      }
      var testArray = parameters.parameters[dimFilter['metadata']['filterType']][dimFilter['metadata']['field']].includes(dimFilter['metadata']['id']);
      if (testArray) {
        return parameters;
      } else {
        parameters.parameters[dimFilter['metadata']['filterType']][dimFilter['metadata']['field']].push(dimFilter['metadata']['id']);
        return parameters;
      }
    },
    $_filterObjectParameterBuilder_filterByFilterInstance: function $_filterObjectParameterBuilder_filterByFilterInstance(obj, filterObjectInstance) {
      // receives list of values for filter obj: {filter_type: 'product_filters', 'field': 'hlev_id', 'id': [2345753]}
      // if item already exists, it is not been included
      var testArray = filterObjectInstance[obj['filter_type']][obj['field']].includes(obj['id']);
      if (testArray) {
        return filterObjectInstance;
      } else {
        filterObjectInstance[obj['filter_type']][obj['field']].push(obj['id']);
        return filterObjectInstance;
      }
    },
    $_filterObjectParameterBuilder_removeFilterItem: function $_filterObjectParameterBuilder_removeFilterItem(obj, filterObjectInstance) {
      this.$lodash.remove(filterObjectInstance[obj['filter_type']][obj['field']], function (e) {
        return e === obj['id'];
      });
      return filterObjectInstance;
    },
    // $_filterObjectParameterBuilder_clearChildObject (selection, filterObjectInstance) {
    //   // let filterType = 'store_filters'
    //   // let removeFrom = filterObjectInstance[filterType][level]
    //   // filterObjectInstance[filterType][level] = this.$lodash.difference(removeFrom, itemsToRemove)
    //   return filterObjectInstance
    // },
    $_filterObjectParameterBuilder_clearSelectorsGivenRemovedOption: function $_filterObjectParameterBuilder_clearSelectorsGivenRemovedOption(removedObj, filterOptionsObject, filterOptionsObjectRendered) {
      // First get all options from parent to child and build and object with it: optionsToRemove
      var classId = removedObj['class_id'];
      var data = filterOptionsObject;
      var removedOption = removedObj['id'];
      var removedLevel = removedObj['field'];
      // let filterType = removedObj['filter_type']
      var levelsInClass = data.find(function (x) {
        return x.id === classId;
      }).levelList.map(function (x) {
        return x.id;
      });
      var optionsToRemove = {};

      // delete where first level has no parents.
      var a = levelsInClass.indexOf(removedLevel);
      var levelsToRemove = null;
      if (a !== 0) {
        levelsToRemove = levelsInClass.slice(a);
      } else {
        levelsToRemove = levelsInClass;
      }
      if (levelsToRemove.length > 1) {
        // set initial object
        optionsToRemove[removedLevel] = [removedOption];
        levelsToRemove.forEach(function (i, index) {
          // Get options just for child levels, from selected level wich is the 'removedLevel'
          if (i !== removedLevel) {
            optionsToRemove[i] = data[0]['levelList'].find(function (x) {
              return x.id === i;
            })['options'].filter(function (x) {
              return x.parent_id === removedOption;
            }).map(function (x) {
              return x.id;
            });
            var parentLevel = levelsToRemove[index - 1];
            var parentOptions = optionsToRemove[parentLevel];
            parentOptions.forEach(function (p) {
              optionsToRemove[i].push(data[0]['levelList'].find(function (x) {
                return x.id === i;
              })['options'].filter(function (x) {
                return x.parent_id === p;
              }).map(function (x) {
                return x.id;
              })[0]);
            });
          }
        });
        // Second, for every level, remove from 'selectedValue' the options collected in 'optionsToRemove'
        var levelList = filterOptionsObjectRendered.find(function (x) {
          return x.id === classId;
        })['levelList'];
        levelsToRemove.forEach(function (i) {
          var level = levelList.filter(function (x) {
            return x.id === i;
          });
          var itemsToRemove = optionsToRemove[i];
          var t = level[0]['selectedValue'];
          var o = level[0]['options'];
          itemsToRemove.forEach(function (r) {
            var indexToRemove = t.findIndex(function (v) {
              return v.id === r;
            });
            if (indexToRemove > -1) {
              levelList.find(function (x) {
                return x.id === i;
              })['selectedValue'].splice(indexToRemove, 1);
            }
            if (r !== removedOption) {
              var indexToRemoveOpt = o.findIndex(function (v) {
                return v.id === r;
              });
              if (indexToRemoveOpt > -1) {
                levelList.find(function (x) {
                  return x.id === i;
                })['options'].splice(indexToRemoveOpt, 1);
              }
            }
          });
        });
        return filterOptionsObjectRendered;
      } else {
        return filterOptionsObjectRendered;
      }
    },
    $_filterObjectParameterBuilder_setInitRenderObject: function $_filterObjectParameterBuilder_setInitRenderObject(initRenderObject) {
      //  select classes which contains more than one level and clean the child's so user dont see options in the child selects
      var classList = initRenderObject.filter(function (x) {
        return x.levelList.length > 1;
      });
      // iter in class list, and splice key levelList to leave just one item
      classList.forEach(function (i) {
        var idLevelList = i['levelList'].map(function (x) {
          return x.id;
        });
        idLevelList.shift();
        idLevelList.forEach(function (t) {
          i['levelList'].find(function (x) {
            return x.id === t;
          })['options'] = [];
        });
      });
      return initRenderObject;
    },
    $_filterObjectParameterBuilder_checkIfObjectContainsSelections: function $_filterObjectParameterBuilder_checkIfObjectContainsSelections(filterOptionsObjectRendered) {
      var count = 0;
      var a = filterOptionsObjectRendered;
      a.forEach(function (i) {
        i['levelList'].forEach(function (t) {
          var c = 0;
          c = t['selectedValue'].length;
          if (c > 0) {
            count = count + 1;
          }
        });
      });
      if (count > 0) {
        return true;
      } else {
        return false;
      }
    },
    $_filterObjectParameterBuilder_buildFilterObject: function $_filterObjectParameterBuilder_buildFilterObject(renderObject, filterType, vuexFilterObjectActiveInstance) {
      // Build object filter base on selected option from select component,
      // where then this object is commited into vuex and available for request parameters
      var filterObject = vuexFilterObjectActiveInstance;
      renderObject.forEach(function (i) {
        var levelList = i['levelList'];
        levelList.forEach(function (t) {
          var selectedIdList = t['selectedValue'].map(function (x) {
            return x.id;
          });
          filterObject[filterType][t['id']] = selectedIdList;
        });
      });
      return filterObject;
    },
    $_filterObjectParameterBuilder_setChildOptions: function $_filterObjectParameterBuilder_setChildOptions(selection, renderObject, originalCategoryObject) {
      // Set child options when selectors are in Hierarchy
      var childLevelId = selection['child_level_id'];
      var levelId = selection['field'];
      var selectedId = selection['id'];
      var classId = selection['class_id'];
      if (childLevelId !== 'None') {
        var childLevelOpt = originalCategoryObject.find(function (x) {
          return x.id === classId;
        })['levelList'].find(function (x) {
          return x.id === childLevelId;
        })['options'];
        var childSelectedOpt = childLevelOpt.filter(function (x) {
          return x['parent_id'] === selectedId;
        });
        var childOptArray = renderObject.find(function (x) {
          return x.id === classId;
        })['levelList'].find(function (x) {
          return x.id === childLevelId;
        })['options'];
        childOptArray = [].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(childOptArray), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(childSelectedOpt));
        renderObject.find(function (x) {
          return x.id === classId;
        })['levelList'].find(function (x) {
          return x.id === childLevelId;
        })['options'] = childOptArray;
      }
      renderObject.find(function (x) {
        return x.id === classId;
      })['levelList'].find(function (x) {
        return x.id === levelId;
      })['selectedValue'].push(selection);
      return renderObject;
    }
  }
});

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expertoRetail_constants_payload__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_index__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'v-select': __WEBPACK_IMPORTED_MODULE_0_vue_select___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_index__["c" /* GeneralUtils */]],
  data: function data() {
    return {
      showFilters: false,
      groupFilters: [],
      filter: {
        selected: []
      },
      payload: {
        parameters: {
          store_filters: this.$_generalUtils_deepJsonCopy(__WEBPACK_IMPORTED_MODULE_1__expertoRetail_constants_payload__["a" /* parameters */].store_filters),
          product_filters: this.$_generalUtils_deepJsonCopy(__WEBPACK_IMPORTED_MODULE_1__expertoRetail_constants_payload__["a" /* parameters */].product_filters)
        }
      }
    };
  },
  created: function created() {
    this.$eventHub.$on('mobile-product-filter', this.getFilters);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventHub.$off('mobile-product-filter');
  },
  beforeMount: function beforeMount() {
    // Se cargan los filtros por defecto en el payload
    if (this.vuexMobileFilters) {
      this.filters = this.vuexMobileFilters;
    }
    var headers = this.getHeaders();
    for (var i = 0; i < headers.length; i++) {
      var groupFilter = {};
      groupFilter.name = headers[i];
      groupFilter.filters = this.getFiltersData(headers[i]);
      this.groupFilters.push(groupFilter);
    }
  },
  computed: {
    vuexMobileFilters: function vuexMobileFilters() {
      return this.$store.state.mobile.mobileFilters;
    }
  },
  methods: {
    getDependentData: function getDependentData(fatherName, parentsId) {
      var productCategoryFilter = this.$store.getters.productCategoryFilters.find(function (productCategoryFilter) {
        return productCategoryFilter.levelList.find(function (level) {
          return level.id === fatherName;
        });
      });
      if (productCategoryFilter === undefined) {
        return;
      }
      var element = JSON.parse(JSON.stringify(productCategoryFilter.levelList.find(function (level) {
        return level.id === fatherName;
      })));
      var data = element.options.filter(function (x) {
        return parentsId.includes(x.parent_id);
      });
      var filtroStore = this.groupFilters.filter(function (a) {
        return a.filters.some(function (b) {
          return b.id === fatherName;
        });
      })[0].filters.filter(function (c) {
        return c.id === fatherName;
      })[0];
      filtroStore.data = data;
    },
    getProductCategory2: function getProductCategory2(event) {
      this.getDependentData('product_category_hlev2_id', event.map(function (x) {
        return x.id;
      }));
    },
    getProductCategory3: function getProductCategory3(event) {
      this.getDependentData('product_category_hlev3_id', event.map(function (x) {
        return x.id;
      }));
    },
    getHeaders: function getHeaders() {
      return this.$store.getters.productCategoryFilters.map(function (productCategoryFilter) {
        return productCategoryFilter["class"];
      });
    },
    getFiltersData: function getFiltersData(head) {
      var vm = this;
      var elements = JSON.parse(JSON.stringify(this.$store.getters.productCategoryFilters.find(function (productCategoryFilter) {
        return productCategoryFilter["class"] === head;
      })));
      elements = elements.levelList.map(function (levelItem) {
        // Inicialmente el filtro va a venir vacío en caso que no tenga filtros ya seteados
        var selectedData = [];
        /* Veo a que categoría pertenece el filtro, si es a filtro de tienda o de producto
          en ambos casos el proceso es ir a buscar el filtro a  store_filters o product_filters
          según corresponda con su respectivo nombre (retail_id, retail_name, etc..) 
          y finalmente seleccionar todos los match que tenga el filtro con la data que llega por
          cada filtro a través del defaultConfigParameter */
        levelItem.data = levelItem.options;
        if (vm.filters.store_filters && Object.keys(vm.filters.store_filters).includes(levelItem.id)) {
          selectedData = levelItem.options.filter(function (x) {
            return vm.filters.store_filters[levelItem.id].includes(x.id);
          });
        } else if (vm.filters.product_filters) {
          selectedData = levelItem.options.filter(function (x) {
            return vm.filters.product_filters[levelItem.id].includes(x.id);
          });
        }
        levelItem.visible = true;
        // Finalmente se setea la data por defecto
        levelItem.selected = selectedData;
        return levelItem;
      });
      if (elements.findIndex(function (x) {
        return x.id === 'store_id';
      }) > -1) {
        elements.filter(function (a) {
          return a.id === 'store_id';
        })[0].data = [];
      }
      if (elements.findIndex(function (x) {
        return x.id === 'product_category_hlev2_id';
      }) > -1) {
        elements.filter(function (a) {
          return a.id === 'product_category_hlev2_id';
        })[0].data = [];
      }
      if (elements.findIndex(function (x) {
        return x.id === 'product_category_hlev3_id';
      }) > -1) {
        elements.filter(function (a) {
          return a.id === 'product_category_hlev3_id';
        })[0].data = [];
      }
      return elements;
    },
    // Método para armar el payload de los filtros
    getFilters: function getFilters() {
      var _this = this;
      // Con esto obtengo todos los atributos de los filtros por tienda y por productos
      var storeFiltersKeys = Object.keys(this.payload.parameters.store_filters);
      var productFiltersKeys = Object.keys(this.payload.parameters.product_filters);
      for (var i = 0; i < this.groupFilters.length; i++) {
        var _loop = function _loop() {
          var filter = _this.groupFilters[i].filters[j];
          // Si el parameterKey del filtro está dentro de los filtros de tienda, lo agrego al payload correspondiente
          if (storeFiltersKeys.find(function (x) {
            return x === filter.id;
          })) {
            _this.payload.parameters.store_filters[filter.id] = filter.selected.map(function (x) {
              return x.id;
            });
            // Sino, si el parameterKey del filtro está dentro de los filtros de producto, lo agrego al payload correspondiente
          } else if (productFiltersKeys.find(function (x) {
            return x === filter.id;
          })) {
            _this.payload.parameters.product_filters[filter.id] = filter.selected.map(function (x) {
              return x.id;
            });
          }
        };
        for (var j = 0; j < this.groupFilters[i].filters.length; j++) {
          _loop();
        }
      }
      this.$store.commit('commit_newFilters', this.payload.parameters);
      this.$eventHub.$emit('load-data-after-mobile-filter');
    }
  }
});

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expertoRetail_defaultPayloads_organismsMobile__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_ExpertoRetail__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__expertoRetail_atoms_ExpertoRetailLoader__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_index__ = __webpack_require__(48);

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'store-detail',
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_3__expertoRetail_atoms_ExpertoRetailLoader__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_index__["c" /* GeneralUtils */]],
  data: function data() {
    return {
      textFilter: '',
      productDetail: {
        data: {}
      },
      loading: false,
      user_id: this.userInfo.id
    };
  },
  created: function created() {
    this.storeListRequest();
    if (this.user_id === undefined) {
      this.$router.push('/');
    }
  },
  computed: {
    filteredProducts: function filteredProducts() {
      // If there is no filter text, just return everyone
      if (!this.textFilter) return this.productDetail.data;

      // Convert the search text to lower case
      var searchText = this.textFilter.toLowerCase();

      // Use the standard javascript filter method of arrays
      // to return only people whose first name or last name
      // includes the search text
      return this.productDetail.data.filter(function (p) {
        // if IE support is required and not pre-compiling,
        // use indexOf instead of includes
        return p.vendor_product_description.toLowerCase().includes(searchText) || p.retail_product_description.toLowerCase().includes(searchText) || p.retail_product_code.toLowerCase().includes(searchText) || p.vendor_product_code.toLowerCase().includes(searchText);
      });
    },
    vuexMobileFilters: function vuexMobileFilters() {
      return this.$store.state.mobile.mobileFilters;
    },
    vuexStoreId: function vuexStoreId() {
      return this.$store.state.mobile.store_id;
    },
    userInfo: function userInfo() {
      return this.$store.getters.userInfo;
    }
  },
  methods: {
    storeListRequest: function storeListRequest() {
      var _this = this;
      this.loading = true;
      var filterCopy = this.$_generalUtils_deepJsonCopy(this.vuexMobileFilters);
      __WEBPACK_IMPORTED_MODULE_1__expertoRetail_defaultPayloads_organismsMobile__["c" /* productParameters */].parameters = _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__expertoRetail_defaultPayloads_organismsMobile__["c" /* productParameters */].parameters), filterCopy);
      __WEBPACK_IMPORTED_MODULE_1__expertoRetail_defaultPayloads_organismsMobile__["c" /* productParameters */].parameters.store_filters.store_id = [];
      __WEBPACK_IMPORTED_MODULE_1__expertoRetail_defaultPayloads_organismsMobile__["c" /* productParameters */].parameters.store_filters.store_id.push(this.vuexStoreId.toString());
      return new Promise(function (resolve, reject) {
        var vm = _this;
        __WEBPACK_IMPORTED_MODULE_2__services_api_ExpertoRetail__["d" /* sales */].salesTwoRanges(__WEBPACK_IMPORTED_MODULE_1__expertoRetail_defaultPayloads_organismsMobile__["c" /* productParameters */]).then(function (response) {
          vm.productDetail.data = response.data;
          resolve();
        })["catch"](function (error) {
          reject(error);
        })["finally"](function () {
          vm.loading = false;
        });
      });
    }
  }
});

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__expertoRetail_defaultPayloads_organismsMobile__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_ExpertoRetail__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__expertoRetail_atoms_ExpertoRetailLoader__ = __webpack_require__(80);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wm-product-list',
  props: {},
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_2__expertoRetail_atoms_ExpertoRetailLoader__["a" /* default */]
  },
  data: function data() {
    return {
      data: {},
      store_id: this.$store.state.mobile.store_id,
      loading: false
    };
  },
  created: function created() {
    this.addFilter(this.store_id);
  },
  methods: {
    storeListRequest: function storeListRequest(parameters) {
      var _this = this;
      this.loading = true;
      return new Promise(function (resolve, reject) {
        var vm = _this;
        __WEBPACK_IMPORTED_MODULE_1__services_api_ExpertoRetail__["d" /* sales */].salesTwoRanges(parameters).then(function (response) {
          vm.data = response.data;
          resolve();
        })["catch"](function (error) {
          reject(error);
        })["finally"](function () {
          vm.loading = false;
        });
      });
    },
    addFilter: function addFilter(id) {
      __WEBPACK_IMPORTED_MODULE_0__expertoRetail_defaultPayloads_organismsMobile__["a" /* WmProductParameters */].parameters.store_filters.store_id = [];
      __WEBPACK_IMPORTED_MODULE_0__expertoRetail_defaultPayloads_organismsMobile__["a" /* WmProductParameters */].parameters.store_filters.store_id.push(id.toString());
      this.storeListRequest(__WEBPACK_IMPORTED_MODULE_0__expertoRetail_defaultPayloads_organismsMobile__["a" /* WmProductParameters */]);
    }
  }
});

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__expertoRetail_defaultPayloads_organismsMobile__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_ExpertoRetail__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__expertoRetail_atoms_ExpertoRetailLoader__ = __webpack_require__(80);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'new-stock-product-list',
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_2__expertoRetail_atoms_ExpertoRetailLoader__["a" /* default */]
  },
  data: function data() {
    return {
      productDetail: {
        data: {}
      },
      store_id: this.$store.state.mobile.store_id,
      loading: false
    };
  },
  created: function created() {
    this.addFilter(this.store_id);
  },
  methods: {
    Request: function Request(parameters) {
      var _this = this;
      this.loading = true;
      return new Promise(function (resolve, reject) {
        var vm = _this;
        __WEBPACK_IMPORTED_MODULE_1__services_api_ExpertoRetail__["d" /* sales */].salesTwoRanges(parameters).then(function (response) {
          vm.productDetail.data = response.data;
          resolve();
        })["catch"](function (error) {
          reject(error);
        })["finally"](function () {
          vm.loading = false;
        });
      });
    },
    addFilter: function addFilter(id) {
      __WEBPACK_IMPORTED_MODULE_0__expertoRetail_defaultPayloads_organismsMobile__["b" /* newStockParameters */].parameters.store_filters.store_id = [];
      __WEBPACK_IMPORTED_MODULE_0__expertoRetail_defaultPayloads_organismsMobile__["b" /* newStockParameters */].parameters.store_filters.store_id.push(id.toString());
      this.Request(__WEBPACK_IMPORTED_MODULE_0__expertoRetail_defaultPayloads_organismsMobile__["b" /* newStockParameters */]);
    }
  }
});

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_composition_api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Services__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_NewsFeedPost__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NewsCard__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CheckEventCard__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ExportablePpt__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_FieldInsightsPanel__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_HashtagsDashboard__ = __webpack_require__(1018);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NewsFeed',
  components: {
    NewsCard: __WEBPACK_IMPORTED_MODULE_6__components_NewsCard__["a" /* default */],
    CheckEventCard: __WEBPACK_IMPORTED_MODULE_7__components_CheckEventCard__["a" /* default */],
    ExportablePpt: __WEBPACK_IMPORTED_MODULE_8__components_ExportablePpt__["a" /* default */],
    FieldInsightsPanel: __WEBPACK_IMPORTED_MODULE_9__components_FieldInsightsPanel__["a" /* default */],
    HashtagsDashboard: __WEBPACK_IMPORTED_MODULE_10__components_HashtagsDashboard__["a" /* default */]
  },
  setup: function setup(props, context) {
    var loading = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(false);
    var loadingMore = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(false);
    var newsFeedList = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])([]);
    var currentPage = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(1);
    var perPage = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(20);
    var totalRows = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(0);
    var hasMore = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(true);
    var sentinel = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(null);
    var searchQuery = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])('');
    var activeHashtag = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(null);
    var dashboardRefreshKey = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(0);
    var viewMode = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])('list');
    var observer = null;
    var searchTimer = null;
    var fetch = /*#__PURE__*/function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee(page) {
        var search,
          filters,
          rawResult,
          result,
          _args = arguments;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              search = _args.length > 1 && _args[1] !== undefined ? _args[1] : '';
              filters = activeHashtag.value ? {
                hashtag_id: activeHashtag.value.id
              } : {};
              _context.next = 1;
              return Object(__WEBPACK_IMPORTED_MODULE_4__Services__["s" /* newsFeedList */])(page, search, perPage.value, filters);
            case 1:
              rawResult = _context.sent;
              result = rawResult.map(function (post) {
                return new __WEBPACK_IMPORTED_MODULE_5__models_NewsFeedPost__["a" /* default */](post);
              });
              if (result.length > 0) {
                totalRows.value = result[0].total;
                perPage.value = result[0].per_page;
                currentPage.value = page;
                hasMore.value = newsFeedList.value.length + result.length < totalRows.value;
              } else {
                hasMore.value = false;
              }
              return _context.abrupt("return", result);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function fetch(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var initialLoad = /*#__PURE__*/function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              loading.value = true;
              _context2.prev = 1;
              _context2.next = 2;
              return fetch(1, searchQuery.value);
            case 2:
              newsFeedList.value = _context2.sent;
            case 3:
              _context2.prev = 3;
              loading.value = false;
              return _context2.finish(3);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1,, 3, 4]]);
      }));
      return function initialLoad() {
        return _ref2.apply(this, arguments);
      };
    }();
    var loadMore = /*#__PURE__*/function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(loadingMore.value || !hasMore.value)) {
                _context3.next = 1;
                break;
              }
              return _context3.abrupt("return");
            case 1:
              loadingMore.value = true;
              _context3.prev = 2;
              _context3.next = 3;
              return fetch(currentPage.value + 1, searchQuery.value);
            case 3:
              result = _context3.sent;
              newsFeedList.value = [].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(newsFeedList.value), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(result));
            case 4:
              _context3.prev = 4;
              loadingMore.value = false;
              return _context3.finish(4);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[2,, 4, 5]]);
      }));
      return function loadMore() {
        return _ref3.apply(this, arguments);
      };
    }();
    var setupObserver = function setupObserver() {
      observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) loadMore();
      }, {
        rootMargin: '200px'
      });
      if (sentinel.value) observer.observe(sentinel.value);
    };
    var resetAndLoad = /*#__PURE__*/function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (observer) observer.disconnect();
              newsFeedList.value = [];
              hasMore.value = true;
              _context4.next = 1;
              return initialLoad();
            case 1:
              context.root.$nextTick(setupObserver);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function resetAndLoad() {
        return _ref4.apply(this, arguments);
      };
    }();
    var onSearch = function onSearch() {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
        return resetAndLoad();
      }, 450);
    };
    var clearSearch = function clearSearch() {
      searchQuery.value = '';
      resetAndLoad();
    };
    var goToUpload = function goToUpload() {
      return context.root.$router.push({
        name: 'UploadImagesFeed'
      });
    };
    var goToExecutions = function goToExecutions() {
      return context.root.$router.push('/execution_focus');
    };
    var refreshList = function refreshList() {
      return resetAndLoad();
    };
    var onHashtagAdded = function onHashtagAdded() {
      dashboardRefreshKey.value++;
    };
    var onHashtagFilter = function onHashtagFilter(hashtag) {
      activeHashtag.value = hashtag;
      resetAndLoad();
    };
    var clearHashtagFilter = function clearHashtagFilter() {
      activeHashtag.value = null;
      resetAndLoad();
    };
    var onPostDeleted = function onPostDeleted(postId) {
      var post = newsFeedList.value.find(function (p) {
        return p.id === postId;
      });
      if (post) {
        var userInfo = context.root.$store.getters.userInfo || {};
        post.is_deleted = true;
        post.deleted_by_name = userInfo.name || 'Usuario';
      }
    };
    var onCheckInDeleted = function onCheckInDeleted(checkInId) {
      var userInfo = context.root.$store.getters.userInfo || {};
      newsFeedList.value.forEach(function (post) {
        if (post.id === checkInId || post.check_in_id === checkInId) {
          post.is_deleted = true;
          post.deleted_by_name = userInfo.name || 'Usuario';
        }
      });
    };
    Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["i" /* onMounted */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 1;
            return initialLoad();
          case 1:
            context.root.$nextTick(setupObserver);
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    })));
    Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["j" /* onUnmounted */])(function () {
      if (observer) observer.disconnect();
      clearTimeout(searchTimer);
    });
    return {
      loading: loading,
      loadingMore: loadingMore,
      newsFeedList: newsFeedList,
      hasMore: hasMore,
      sentinel: sentinel,
      searchQuery: searchQuery,
      activeHashtag: activeHashtag,
      dashboardRefreshKey: dashboardRefreshKey,
      viewMode: viewMode,
      onSearch: onSearch,
      clearSearch: clearSearch,
      goToUpload: goToUpload,
      goToExecutions: goToExecutions,
      refreshList: refreshList,
      onPostDeleted: onPostDeleted,
      onCheckInDeleted: onCheckInDeleted,
      onHashtagFilter: onHashtagFilter,
      clearHashtagFilter: clearHashtagFilter,
      onHashtagAdded: onHashtagAdded
    };
  }
});

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_composition_api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FeedDeleteButton_vue__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PostComments_vue__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PostHashtags_vue__ = __webpack_require__(998);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NewsCard',
  components: {
    FeedDeleteButton: __WEBPACK_IMPORTED_MODULE_4__FeedDeleteButton_vue__["a" /* default */],
    PostComments: __WEBPACK_IMPORTED_MODULE_5__PostComments_vue__["a" /* default */],
    PostHashtags: __WEBPACK_IMPORTED_MODULE_6__PostHashtags_vue__["a" /* default */]
  },
  props: {
    content: {
      type: Object,
      required: true
    },
    viewMode: {
      type: String,
      "default": 'list'
    }
  },
  setup: function setup(props, context) {
    var deleting = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(false);
    var showComments = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(false);
    var isRowMode = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      return props.viewMode === 'row';
    });
    var captionSegments = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      var _props$content$conten;
      var caption = (_props$content$conten = props.content.content) === null || _props$content$conten === void 0 ? void 0 : _props$content$conten.caption;
      if (!caption) return [];
      var hashtagMap = Object.fromEntries((props.content.hashtags || []).map(function (h) {
        return [h.name.toLowerCase(), h];
      }));
      var mentionMap = Object.fromEntries((props.content.mentions || []).map(function (m) {
        return [m.name.trim().split(' ')[0].toLowerCase(), m];
      }));
      var segments = [];
      var regex = /(#\w+|@\w+)/g;
      var lastIndex = 0;
      var match;
      while ((match = regex.exec(caption)) !== null) {
        if (match.index > lastIndex) {
          segments.push({
            type: 'text',
            value: caption.slice(lastIndex, match.index)
          });
        }
        var token = match[0];
        var word = token.slice(1).toLowerCase();
        if (token.startsWith('#')) {
          var ht = hashtagMap[word];
          segments.push(ht ? {
            type: 'hashtag',
            hashtag: ht,
            raw: token
          } : {
            type: 'text',
            value: token
          });
        } else {
          var mention = mentionMap[word];
          segments.push(mention ? {
            type: 'mention',
            name: mention.name.trim()
          } : {
            type: 'text',
            value: token
          });
        }
        lastIndex = match.index + token.length;
      }
      if (lastIndex < caption.length) {
        segments.push({
          type: 'text',
          value: caption.slice(lastIndex)
        });
      }
      return segments;
    });
    var imgList = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      var _props$content$conten2;
      return ((_props$content$conten2 = props.content.content) === null || _props$content$conten2 === void 0 ? void 0 : _props$content$conten2.img_list) || [];
    });
    var hasImages = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      return imgList.value.length > 0;
    });
    var carouselIndex = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(0);
    var prevImage = function prevImage(total) {
      carouselIndex.value = (carouselIndex.value - 1 + total) % total;
    };
    var nextImage = function nextImage(total) {
      carouselIndex.value = (carouselIndex.value + 1) % total;
    };
    var canDelete = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      return !props.content.is_deleted;
    });
    var getAvatarText = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      return props.content.name.split(' ').map(function (n) {
        return n[0];
      }).join('');
    });
    var latestCommentInitials = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      var name = props.content.latest_comment_author || '';
      return name.split(' ').map(function (n) {
        return n[0];
      }).join('').substring(0, 2).toUpperCase();
    });
    var formattedDate = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      return context.root.$moment(props.content.created_at).format('D MMMM YYYY, h:mm:ss a');
    });
    var toggleComments = function toggleComments() {
      showComments.value = !showComments.value;
    };
    var handleDelete = /*#__PURE__*/function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var _t;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              deleting.value = true;
              _context.prev = 1;
              _context.next = 2;
              return Object(__WEBPACK_IMPORTED_MODULE_3__Services__["h" /* deletePost */])(props.content.id);
            case 2:
              context.emit('deleted', props.content.id);
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
            case 4:
              _context.prev = 4;
              deleting.value = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }));
      return function handleDelete() {
        return _ref.apply(this, arguments);
      };
    }();
    return {
      deleting: deleting,
      showComments: showComments,
      isRowMode: isRowMode,
      captionSegments: captionSegments,
      hasImages: hasImages,
      imgList: imgList,
      carouselIndex: carouselIndex,
      prevImage: prevImage,
      nextImage: nextImage,
      canDelete: canDelete,
      getAvatarText: getAvatarText,
      latestCommentInitials: latestCommentInitials,
      formattedDate: formattedDate,
      toggleComments: toggleComments,
      handleDelete: handleDelete
    };
  }
});

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeedDeleteButton_vue__ = __webpack_require__(625);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2aa60bbf_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeedDeleteButton_vue__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(992)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2aa60bbf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeedDeleteButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2aa60bbf_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeedDeleteButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2aa60bbf_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeedDeleteButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_components_BaseModal_vue__ = __webpack_require__(88);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FeedDeleteButton',
  components: {
    BaseModal: __WEBPACK_IMPORTED_MODULE_1__app_shared_components_BaseModal_vue__["a" /* default */]
  },
  props: {
    postType: {
      type: String,
      "default": 'post' // 'post' | 'check_in' | 'check_out'
    },
    storeName: {
      type: String,
      "default": ''
    },
    deleting: {
      type: Boolean,
      "default": false
    }
  },
  setup: function setup(props, context) {
    var showModal = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["n" /* ref */])(false);
    var buttonTitle = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.postType === 'post' ? 'Eliminar publicación' : 'Eliminar registro';
    });
    var modalTitle = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      if (props.postType === 'check_in') return 'Eliminar entrada a tienda';
      if (props.postType === 'check_out') return 'Eliminar registro de visita';
      return 'Eliminar publicación';
    });
    var bodyText = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var store = props.storeName || 'esta tienda';
      if (props.postType === 'check_out') {
        return "\xBFQu\xE9 deseas eliminar de la visita a ".concat(store, "?");
      }
      if (props.postType === 'check_in') {
        return "\xBFConfirmas que deseas eliminar la entrada a ".concat(store, "? Esta acci\xF3n no se puede deshacer.");
      }
      return '¿Estás seguro que deseas eliminar esta publicación? Esta acción no se puede deshacer.';
    });
    var confirmLabel = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.postType === 'check_in' ? 'Eliminar entrada' : 'Eliminar';
    });
    var confirm = function confirm(target) {
      showModal.value = false;
      context.emit('delete', target);
    };
    return {
      showModal: showModal,
      buttonTitle: buttonTitle,
      modalTitle: modalTitle,
      bodyText: bodyText,
      confirmLabel: confirmLabel,
      confirm: confirm
    };
  }
});

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_composition_api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Services__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_MentionableUser__ = __webpack_require__(996);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var MENTION_DEBOUNCE_MS = 250;
var escapeHtml = function escapeHtml(str) {
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PostComments',
  props: {
    postId: {
      type: Number,
      required: true
    }
  },
  setup: function setup(props, context) {
    var comments = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])([]);
    var loading = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(true);
    var loadingMore = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(false);
    var hasMore = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(false);
    var currentPage = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(1);
    var newCommentText = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])('');
    var submitting = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(false);
    var editingId = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(null);
    var editContent = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])('');
    var savingEdit = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(false);

    // --- Mention state: new comment ---
    var mentionQuery = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(null);
    var mentionStartIndex = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(0);
    var mentionResults = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])([]);
    var mentionLoading = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(false);
    var mentionHighlightIndex = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(0);
    var newCommentMentionedIds = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])([]);
    var mentionDebounceTimer = null;

    // --- Mention state: edit ---
    var editMentionQuery = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(null);
    var editMentionStartIndex = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(0);
    var editMentionResults = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])([]);
    var editMentionLoading = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(false);
    var editMentionHighlightIndex = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(0);
    var editMentionedIds = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(null);
    var editMentionDebounceTimer = null;
    var showMentionDropdown = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["a" /* computed */])(function () {
      return mentionQuery.value !== null;
    });
    var showEditMentionDropdown = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["a" /* computed */])(function () {
      return editMentionQuery.value !== null;
    });
    var userInfo = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["a" /* computed */])(function () {
      return context.root.$store.getters.userInfo || {};
    });
    var rootUsers = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["a" /* computed */])(function () {
      return context.root.$store.getters.rootUsers || [];
    });
    var currentUserInitials = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["a" /* computed */])(function () {
      var name = userInfo.value.name || 'U';
      return name.split(' ').map(function (n) {
        return n[0];
      }).join('').substring(0, 2).toUpperCase();
    });
    var getInitials = function getInitials() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return name.split(' ').map(function (n) {
        return n[0];
      }).join('').substring(0, 2).toUpperCase();
    };
    var formatTime = function formatTime(ts) {
      return context.root.$moment(ts).fromNow();
    };
    var canManage = function canManage(comment) {
      var uid = userInfo.value.id;
      var email = userInfo.value.email;
      var permissions = userInfo.value.permissions || [];
      return comment.user_id === uid || rootUsers.value.includes(email) || permissions.includes('DELETE_ANY_NEWS_FEED_POST');
    };
    var renderMentions = function renderMentions(text) {
      if (!text) return '';
      return escapeHtml(text).replace(/@(\S+)/g, '<span class="mention-tag">@$1</span>');
    };

    // ── Mention detection ────────────────────────────────────────────────────

    var detectMentionAtCursor = function detectMentionAtCursor(text, cursorPos) {
      var textBefore = text.substring(0, cursorPos);
      // Match @word at the end of the text before cursor (supports accented chars)
      var match = textBefore.match(/@([\w\u00C0-\u017F]*)$/);
      if (!match) return null;
      return {
        query: match[1],
        startIndex: cursorPos - match[0].length
      };
    };
    var fetchMentions = /*#__PURE__*/function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee(query, isEdit) {
        var raw, results, _t;
        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (isEdit) editMentionLoading.value = true;else mentionLoading.value = true;
              _context.next = 1;
              return Object(__WEBPACK_IMPORTED_MODULE_5__Services__["q" /* getMentionableUsers */])(query);
            case 1:
              raw = _context.sent;
              results = raw.map(function (u) {
                return new __WEBPACK_IMPORTED_MODULE_6__models_MentionableUser__["a" /* default */](u);
              });
              if (isEdit) {
                editMentionResults.value = results;
                editMentionHighlightIndex.value = 0;
              } else {
                mentionResults.value = results;
                mentionHighlightIndex.value = 0;
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
            case 3:
              _context.prev = 3;
              if (isEdit) editMentionLoading.value = false;else mentionLoading.value = false;
              return _context.finish(3);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 2, 3, 4]]);
      }));
      return function fetchMentions(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
    var scheduleFetch = function scheduleFetch(query, isEdit) {
      if (isEdit) {
        clearTimeout(editMentionDebounceTimer);
        editMentionDebounceTimer = setTimeout(function () {
          return fetchMentions(query, true);
        }, MENTION_DEBOUNCE_MS);
      } else {
        clearTimeout(mentionDebounceTimer);
        mentionDebounceTimer = setTimeout(function () {
          return fetchMentions(query, false);
        }, MENTION_DEBOUNCE_MS);
      }
    };
    var closeMentionDropdown = function closeMentionDropdown() {
      mentionQuery.value = null;
      mentionResults.value = [];
    };
    var closeEditMentionDropdown = function closeEditMentionDropdown() {
      editMentionQuery.value = null;
      editMentionResults.value = [];
    };

    // ── New comment handlers ──────────────────────────────────────────────────

    var onNewCommentInput = function onNewCommentInput(event) {
      var el = event.target;
      // Auto-resize
      el.style.height = 'auto';
      el.style.height = el.scrollHeight + 'px';
      var detected = detectMentionAtCursor(el.value, el.selectionStart);
      if (detected) {
        mentionQuery.value = detected.query;
        mentionStartIndex.value = detected.startIndex;
        scheduleFetch(detected.query, false);
      } else {
        closeMentionDropdown();
      }
    };
    var onNewCommentBlur = function onNewCommentBlur() {
      setTimeout(closeMentionDropdown, 150);
    };
    var selectMention = function selectMention(user) {
      var insertText = "@".concat(user.name, " ");
      var before = newCommentText.value.substring(0, mentionStartIndex.value);
      var after = newCommentText.value.substring(mentionStartIndex.value + 1 + mentionQuery.value.length);
      newCommentText.value = before + insertText + after;
      if (!newCommentMentionedIds.value.includes(user.id)) {
        newCommentMentionedIds.value = [].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(newCommentMentionedIds.value), [user.id]);
      }
      closeMentionDropdown();
      context.root.$nextTick(function () {
        var el = context.root.$refs.commentInput;
        if (el) {
          el.focus();
          var pos = before.length + insertText.length;
          el.setSelectionRange(pos, pos);
          el.style.height = 'auto';
          el.style.height = el.scrollHeight + 'px';
        }
      });
    };
    var onNewCommentKeydown = function onNewCommentKeydown(event) {
      if (showMentionDropdown.value) {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          mentionHighlightIndex.value = Math.min(mentionHighlightIndex.value + 1, mentionResults.value.length - 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          mentionHighlightIndex.value = Math.max(mentionHighlightIndex.value - 1, 0);
        } else if (event.key === 'Enter' || event.key === 'Tab') {
          event.preventDefault();
          var user = mentionResults.value[mentionHighlightIndex.value];
          if (user) selectMention(user);
        } else if (event.key === 'Escape') {
          event.preventDefault();
          closeMentionDropdown();
        }
      } else if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        submitComment();
      }
    };

    // ── Edit handlers ─────────────────────────────────────────────────────────

    var onEditInput = function onEditInput(event) {
      var el = event.target;
      var detected = detectMentionAtCursor(el.value, el.selectionStart);
      if (detected) {
        editMentionQuery.value = detected.query;
        editMentionStartIndex.value = detected.startIndex;
        scheduleFetch(detected.query, true);
      } else {
        closeEditMentionDropdown();
      }
    };
    var onEditBlur = function onEditBlur() {
      setTimeout(closeEditMentionDropdown, 150);
    };
    var selectEditMention = function selectEditMention(user) {
      var insertText = "@".concat(user.name, " ");
      var before = editContent.value.substring(0, editMentionStartIndex.value);
      var after = editContent.value.substring(editMentionStartIndex.value + 1 + editMentionQuery.value.length);
      editContent.value = before + insertText + after;
      if (editMentionedIds.value === null) editMentionedIds.value = [];
      if (!editMentionedIds.value.includes(user.id)) {
        editMentionedIds.value = [].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(editMentionedIds.value), [user.id]);
      }
      closeEditMentionDropdown();
      context.root.$nextTick(function () {
        var ref = context.root.$refs.editTextarea;
        var el = Array.isArray(ref) ? ref[0] : ref;
        if (el) {
          el.focus();
          var pos = before.length + insertText.length;
          el.setSelectionRange(pos, pos);
        }
      });
    };
    var onEditKeydown = function onEditKeydown(event, comment) {
      if (showEditMentionDropdown.value) {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          editMentionHighlightIndex.value = Math.min(editMentionHighlightIndex.value + 1, editMentionResults.value.length - 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          editMentionHighlightIndex.value = Math.max(editMentionHighlightIndex.value - 1, 0);
        } else if (event.key === 'Enter' || event.key === 'Tab') {
          event.preventDefault();
          var user = editMentionResults.value[editMentionHighlightIndex.value];
          if (user) selectEditMention(user);
        } else if (event.key === 'Escape') {
          event.preventDefault();
          closeEditMentionDropdown();
        }
      } else if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        confirmEdit(comment);
      } else if (event.key === 'Escape') {
        cancelEdit();
      }
    };

    // ── API actions ───────────────────────────────────────────────────────────

    var fetchPage = /*#__PURE__*/function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee2(page) {
        var result, total;
        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return Object(__WEBPACK_IMPORTED_MODULE_5__Services__["r" /* getPostComments */])(props.postId, page);
            case 1:
              result = _context2.sent;
              if (result.length > 0) {
                total = result[0].total;
                hasMore.value = comments.value.length + result.length < total;
                currentPage.value = page;
              } else {
                hasMore.value = false;
              }
              return _context2.abrupt("return", result);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function fetchPage(_x3) {
        return _ref2.apply(this, arguments);
      };
    }();
    var loadMore = /*#__PURE__*/function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee3() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              loadingMore.value = true;
              _context3.prev = 1;
              _context3.next = 2;
              return fetchPage(currentPage.value + 1);
            case 2:
              result = _context3.sent;
              comments.value = [].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(comments.value), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(result));
            case 3:
              _context3.prev = 3;
              loadingMore.value = false;
              return _context3.finish(3);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1,, 3, 4]]);
      }));
      return function loadMore() {
        return _ref3.apply(this, arguments);
      };
    }();
    var submitComment = /*#__PURE__*/function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee4() {
        var text, created;
        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              text = newCommentText.value.trim();
              if (!(!text || submitting.value)) {
                _context4.next = 1;
                break;
              }
              return _context4.abrupt("return");
            case 1:
              submitting.value = true;
              _context4.prev = 2;
              _context4.next = 3;
              return Object(__WEBPACK_IMPORTED_MODULE_5__Services__["b" /* createComment */])(props.postId, text, newCommentMentionedIds.value);
            case 3:
              created = _context4.sent;
              comments.value.push(_objectSpread(_objectSpread({}, created), {}, {
                author_name: userInfo.value.name || '',
                is_deleted: false
              }));
              newCommentText.value = '';
              newCommentMentionedIds.value = [];
              context.root.$nextTick(function () {
                var el = context.root.$refs.commentInput;
                if (el) el.style.height = 'auto';
              });
            case 4:
              _context4.prev = 4;
              submitting.value = false;
              return _context4.finish(4);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[2,, 4, 5]]);
      }));
      return function submitComment() {
        return _ref4.apply(this, arguments);
      };
    }();
    var startEdit = function startEdit(comment) {
      editingId.value = comment.id;
      editContent.value = comment.content;
      editMentionedIds.value = null;
      closeEditMentionDropdown();
    };
    var cancelEdit = function cancelEdit() {
      editingId.value = null;
      editContent.value = '';
      editMentionedIds.value = null;
      closeEditMentionDropdown();
    };
    var confirmEdit = /*#__PURE__*/function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee5(comment) {
        var text, target, _t2;
        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              text = editContent.value.trim();
              if (!(!text || savingEdit.value)) {
                _context5.next = 1;
                break;
              }
              return _context5.abrupt("return");
            case 1:
              savingEdit.value = true;
              _context5.prev = 2;
              _context5.next = 3;
              return Object(__WEBPACK_IMPORTED_MODULE_5__Services__["w" /* updateComment */])(comment.id, text, editMentionedIds.value !== null ? editMentionedIds.value : undefined);
            case 3:
              target = comments.value.find(function (c) {
                return c.id === comment.id;
              });
              if (target) {
                target.content = text;
                target.edited_at = new Date().toISOString();
              }
              cancelEdit();
              _context5.next = 5;
              break;
            case 4:
              _context5.prev = 4;
              _t2 = _context5["catch"](2);
              cancelEdit();
            case 5:
              _context5.prev = 5;
              savingEdit.value = false;
              return _context5.finish(5);
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[2, 4, 5, 6]]);
      }));
      return function confirmEdit(_x4) {
        return _ref5.apply(this, arguments);
      };
    }();
    var handleDelete = /*#__PURE__*/function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee6(comment) {
        var target, _t3;
        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 1;
              return Object(__WEBPACK_IMPORTED_MODULE_5__Services__["f" /* deleteComment */])(comment.id);
            case 1:
              target = comments.value.find(function (c) {
                return c.id === comment.id;
              });
              if (target) {
                target.is_deleted = true;
                target.content = null;
              }
              _context6.next = 3;
              break;
            case 2:
              _context6.prev = 2;
              _t3 = _context6["catch"](0);
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[0, 2]]);
      }));
      return function handleDelete(_x5) {
        return _ref6.apply(this, arguments);
      };
    }();
    Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["i" /* onMounted */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee7() {
      var _t4;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 1;
            return fetchPage(1);
          case 1:
            comments.value = _context7.sent;
            _context7.next = 3;
            break;
          case 2:
            _context7.prev = 2;
            _t4 = _context7["catch"](0);
          case 3:
            _context7.prev = 3;
            loading.value = false;
            return _context7.finish(3);
          case 4:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[0, 2, 3, 4]]);
    })));
    return {
      comments: comments,
      loading: loading,
      loadingMore: loadingMore,
      hasMore: hasMore,
      newCommentText: newCommentText,
      submitting: submitting,
      editingId: editingId,
      editContent: editContent,
      savingEdit: savingEdit,
      showMentionDropdown: showMentionDropdown,
      showEditMentionDropdown: showEditMentionDropdown,
      mentionResults: mentionResults,
      mentionLoading: mentionLoading,
      mentionHighlightIndex: mentionHighlightIndex,
      editMentionResults: editMentionResults,
      editMentionLoading: editMentionLoading,
      editMentionHighlightIndex: editMentionHighlightIndex,
      currentUserInitials: currentUserInitials,
      getInitials: getInitials,
      formatTime: formatTime,
      canManage: canManage,
      renderMentions: renderMentions,
      loadMore: loadMore,
      submitComment: submitComment,
      startEdit: startEdit,
      cancelEdit: cancelEdit,
      confirmEdit: confirmEdit,
      handleDelete: handleDelete,
      onNewCommentInput: onNewCommentInput,
      onNewCommentKeydown: onNewCommentKeydown,
      onNewCommentBlur: onNewCommentBlur,
      selectMention: selectMention,
      onEditInput: onEditInput,
      onEditKeydown: onEditKeydown,
      onEditBlur: onEditBlur,
      selectEditMention: selectEditMention
    };
  }
});

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_composition_api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services__ = __webpack_require__(50);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PostHashtags',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  setup: function setup(props, context) {
    var showPicker = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(false);
    var searchText = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])('');
    var allTags = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])([]);
    var loadingTags = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(false);
    var container = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(null);
    var searchInput = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(null);
    var pickerStyle = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])({});
    var badgeStyle = function badgeStyle(color) {
      return {
        backgroundColor: color + '18',
        color: color,
        border: "1px solid ".concat(color, "40")
      };
    };
    var filteredAvailable = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      var current = new Set((props.content.hashtags || []).map(function (t) {
        return t.id;
      }));
      return allTags.value.filter(function (t) {
        return !current.has(t.id) && (searchText.value === '' || t.label.toLowerCase().includes(searchText.value.toLowerCase()));
      });
    });
    var calcPickerPosition = function calcPickerPosition() {
      if (!container.value) return;
      var rect = container.value.getBoundingClientRect();
      var spaceBelow = window.innerHeight - rect.bottom;
      var pickerHeight = 260;
      if (spaceBelow >= pickerHeight) {
        pickerStyle.value = {
          position: 'fixed',
          top: "".concat(rect.bottom + 4, "px"),
          left: "".concat(rect.left, "px"),
          zIndex: 9999
        };
      } else {
        pickerStyle.value = {
          position: 'fixed',
          bottom: "".concat(window.innerHeight - rect.top + 4, "px"),
          left: "".concat(rect.left, "px"),
          zIndex: 9999
        };
      }
    };
    var fetchTags = /*#__PURE__*/function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var _t;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(allTags.value.length > 0)) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              loadingTags.value = true;
              _context.prev = 2;
              _context.next = 3;
              return Object(__WEBPACK_IMPORTED_MODULE_3__Services__["p" /* getHashtags */])();
            case 3:
              allTags.value = _context.sent;
              _context.next = 5;
              break;
            case 4:
              _context.prev = 4;
              _t = _context["catch"](2);
            case 5:
              _context.prev = 5;
              loadingTags.value = false;
              return _context.finish(5);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 4, 5, 6]]);
      }));
      return function fetchTags() {
        return _ref.apply(this, arguments);
      };
    }();
    var openPicker = /*#__PURE__*/function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              calcPickerPosition();
              showPicker.value = true;
              searchText.value = '';
              _context2.next = 1;
              return fetchTags();
            case 1:
              context.root.$nextTick(function () {
                if (searchInput.value) searchInput.value.focus();
              });
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function openPicker() {
        return _ref2.apply(this, arguments);
      };
    }();
    var closePicker = function closePicker() {
      showPicker.value = false;
    };
    var onSearchInput = /*#__PURE__*/function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _t2;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              loadingTags.value = true;
              _context3.prev = 1;
              _context3.next = 2;
              return Object(__WEBPACK_IMPORTED_MODULE_3__Services__["p" /* getHashtags */])(searchText.value);
            case 2:
              allTags.value = _context3.sent;
              _context3.next = 4;
              break;
            case 3:
              _context3.prev = 3;
              _t2 = _context3["catch"](1);
            case 4:
              _context3.prev = 4;
              loadingTags.value = false;
              return _context3.finish(4);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 3, 4, 5]]);
      }));
      return function onSearchInput() {
        return _ref3.apply(this, arguments);
      };
    }();
    var addTag = /*#__PURE__*/function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee4(tag) {
        var _t3;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 1;
              return Object(__WEBPACK_IMPORTED_MODULE_3__Services__["a" /* addPostHashtags */])(props.content.id, [tag.id]);
            case 1:
              if (!props.content.hashtags) props.content.hashtags = [];
              props.content.hashtags.push(tag);
              context.emit('hashtag-added');
              closePicker();
              _context4.next = 3;
              break;
            case 2:
              _context4.prev = 2;
              _t3 = _context4["catch"](0);
              closePicker();
              context.root.$bvToast.toast('No se pudo agregar la etiqueta. Intenta nuevamente.', {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 3000
              });
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 2]]);
      }));
      return function addTag(_x) {
        return _ref4.apply(this, arguments);
      };
    }();
    var removeTag = /*#__PURE__*/function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee5(tag) {
        var idx, _t4;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 1;
              return Object(__WEBPACK_IMPORTED_MODULE_3__Services__["v" /* removePostHashtag */])(props.content.id, tag.id);
            case 1:
              idx = props.content.hashtags.findIndex(function (t) {
                return t.id === tag.id;
              });
              if (idx !== -1) props.content.hashtags.splice(idx, 1);
              context.emit('hashtag-added');
              _context5.next = 3;
              break;
            case 2:
              _context5.prev = 2;
              _t4 = _context5["catch"](0);
              context.root.$bvToast.toast('No se pudo quitar la etiqueta. Intenta nuevamente.', {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 3000
              });
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[0, 2]]);
      }));
      return function removeTag(_x2) {
        return _ref5.apply(this, arguments);
      };
    }();
    var onClickOutside = function onClickOutside(e) {
      var inContainer = container.value && container.value.contains(e.target);
      var inPicker = !!e.target.closest('.tag-picker');
      if (!inContainer && !inPicker) closePicker();
    };
    Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["i" /* onMounted */])(function () {
      return document.addEventListener('click', onClickOutside);
    });
    Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["h" /* onBeforeUnmount */])(function () {
      return document.removeEventListener('click', onClickOutside);
    });
    return {
      showPicker: showPicker,
      searchText: searchText,
      allTags: allTags,
      loadingTags: loadingTags,
      container: container,
      searchInput: searchInput,
      pickerStyle: pickerStyle,
      badgeStyle: badgeStyle,
      filteredAvailable: filteredAvailable,
      openPicker: openPicker,
      onSearchInput: onSearchInput,
      addTag: addTag,
      removeTag: removeTag
    };
  }
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_composition_api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FeedDeleteButton_vue__ = __webpack_require__(624);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CheckEventCard',
  components: {
    FeedDeleteButton: __WEBPACK_IMPORTED_MODULE_4__FeedDeleteButton_vue__["a" /* default */]
  },
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  setup: function setup(props, context) {
    var isMounted = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(false);
    var showFullscreen = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(false);
    var deleting = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(false);
    var localDeleted = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(false);
    Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["i" /* onMounted */])(function () {
      isMounted.value = true;
    });
    var avatarText = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      return props.content.name.split(' ').map(function (n) {
        return n[0];
      }).join('').substring(0, 2).toUpperCase();
    });
    var formattedDate = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      return context.root.$moment(props.content.created_at).format('D MMMM YYYY, h:mm a');
    });
    var checkedInTime = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      return props.content.checked_in_at ? context.root.$moment(props.content.checked_in_at).format('h:mm a') : null;
    });
    var cardClass = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      return props.content.isCheckIn ? 'check-in-card' : 'check-out-card';
    });
    var badgeClass = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      return props.content.isCheckIn ? 'badge-check-in' : 'badge-check-out';
    });
    var badgeIcon = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      return props.content.isCheckIn ? 'fa fa-sign-in' : 'fa fa-flag-checkered';
    });
    var badgeLabel = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      return props.content.isCheckIn ? 'Entrada a tienda' : 'Visita completada';
    });
    var mapCenter = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      return {
        lat: props.content.latitude,
        lng: props.content.longitude
      };
    });
    var mapOptions = {
      zoomControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      disableDefaultUi: true
    };
    var mapOptionsFullscreen = {
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: true,
      rotateControl: false,
      fullscreenControl: false
    };
    var handleDelete = /*#__PURE__*/function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee(target) {
        var _props$content$check_;
        var checkInId, _t;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              deleting.value = true;
              localDeleted.value = true;
              checkInId = (_props$content$check_ = props.content.check_in_id) !== null && _props$content$check_ !== void 0 ? _props$content$check_ : props.content.id;
              _context.prev = 1;
              _context.next = 2;
              return Object(__WEBPACK_IMPORTED_MODULE_3__Services__["e" /* deleteCheckInOut */])(checkInId, target);
            case 2:
              if (target === 'check_out') {
                context.emit('deleted', props.content.id);
              } else {
                context.emit('check-in-deleted', checkInId);
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              localDeleted.value = false;
            case 4:
              _context.prev = 4;
              deleting.value = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }));
      return function handleDelete(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    return {
      isMounted: isMounted,
      showFullscreen: showFullscreen,
      deleting: deleting,
      localDeleted: localDeleted,
      avatarText: avatarText,
      formattedDate: formattedDate,
      checkedInTime: checkedInTime,
      cardClass: cardClass,
      badgeClass: badgeClass,
      badgeIcon: badgeIcon,
      badgeLabel: badgeLabel,
      mapCenter: mapCenter,
      mapOptions: mapOptions,
      mapOptionsFullscreen: mapOptionsFullscreen,
      handleDelete: handleDelete
    };
  }
});

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_composition_api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_components_BaseModal_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_shared_components_ExecutorRunButton_vue__ = __webpack_require__(738);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var MONTHS = [{
  value: 1,
  label: 'Enero'
}, {
  value: 2,
  label: 'Febrero'
}, {
  value: 3,
  label: 'Marzo'
}, {
  value: 4,
  label: 'Abril'
}, {
  value: 5,
  label: 'Mayo'
}, {
  value: 6,
  label: 'Junio'
}, {
  value: 7,
  label: 'Julio'
}, {
  value: 8,
  label: 'Agosto'
}, {
  value: 9,
  label: 'Septiembre'
}, {
  value: 10,
  label: 'Octubre'
}, {
  value: 11,
  label: 'Noviembre'
}, {
  value: 12,
  label: 'Diciembre'
}];
var currentYear = __WEBPACK_IMPORTED_MODULE_3_moment___default()().year();
var YEARS = Array.from({
  length: currentYear - 2022
}, function (_, i) {
  return 2023 + i;
});
var daysInMonth = function daysInMonth(year, month) {
  return __WEBPACK_IMPORTED_MODULE_3_moment___default()("".concat(year, "-").concat(month), 'YYYY-M').daysInMonth();
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ExportablePpt',
  components: {
    BaseModal: __WEBPACK_IMPORTED_MODULE_4__app_shared_components_BaseModal_vue__["a" /* default */],
    ExecutorRunButton: __WEBPACK_IMPORTED_MODULE_5__app_shared_components_ExecutorRunButton_vue__["a" /* default */]
  },
  setup: function setup(props, context) {
    var executorBtn = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(null);
    var executorXlsxBtn = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(null);
    var showDateRangeModal = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(false);
    var pptPayload = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])({});
    var dateError = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])('');
    var exportType = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])('pptx');
    var selectedOrder = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])('created_at_descending');
    var sortOrderOptions = [{
      value: 'created_at_descending',
      text: 'Fecha descendiente'
    }, {
      value: 'created_at_ascending',
      text: 'Fecha ascendente'
    }, {
      value: 'retail',
      text: 'Retail'
    }, {
      value: 'store',
      text: 'Tienda'
    }];
    var prevMonday = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'weeks').startOf('isoWeek');
    var prevSunday = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'weeks').endOf('isoWeek');
    var fromYear = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(prevMonday.year());
    var fromMonth = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(prevMonday.month() + 1);
    var fromDay = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(prevMonday.date());
    var toYear = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(prevSunday.year());
    var toMonth = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(prevSunday.month() + 1);
    var toDay = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(prevSunday.date());
    var fromDaysInMonth = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      var n = daysInMonth(fromYear.value, fromMonth.value);
      return Array.from({
        length: n
      }, function (_, i) {
        return i + 1;
      });
    });
    var toDaysInMonth = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      var n = daysInMonth(toYear.value, toMonth.value);
      return Array.from({
        length: n
      }, function (_, i) {
        return i + 1;
      });
    });

    // Clamp day when month/year changes and current day exceeds new max
    Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["q" /* watch */])(fromDaysInMonth, function (days) {
      if (fromDay.value > days.length) fromDay.value = days.length;
    });
    Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["q" /* watch */])(toDaysInMonth, function (days) {
      if (toDay.value > days.length) toDay.value = days.length;
    });
    var onDatesConfirmed = /*#__PURE__*/function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var start, end;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              start = __WEBPACK_IMPORTED_MODULE_3_moment___default()("".concat(fromYear.value, "-").concat(fromMonth.value, "-").concat(fromDay.value), 'YYYY-M-D');
              end = __WEBPACK_IMPORTED_MODULE_3_moment___default()("".concat(toYear.value, "-").concat(toMonth.value, "-").concat(toDay.value), 'YYYY-M-D');
              if (!end.isBefore(start)) {
                _context.next = 1;
                break;
              }
              dateError.value = 'La fecha "Hasta" no puede ser anterior a "Desde"';
              return _context.abrupt("return");
            case 1:
              dateError.value = '';
              showDateRangeModal.value = false;
              pptPayload.value = {
                start_date: start.format('YYYY-MM-DD'),
                end_date: end.format('YYYY-MM-DD'),
                order_by: selectedOrder.value
              };
              _context.next = 2;
              return context.root.$nextTick();
            case 2:
              if (exportType.value === 'xlsx') {
                if (executorXlsxBtn.value) executorXlsxBtn.value.handleClick();
              } else {
                if (executorBtn.value) executorBtn.value.handleClick();
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function onDatesConfirmed() {
        return _ref.apply(this, arguments);
      };
    }();
    return {
      executorBtn: executorBtn,
      executorXlsxBtn: executorXlsxBtn,
      exportType: exportType,
      showDateRangeModal: showDateRangeModal,
      pptPayload: pptPayload,
      dateError: dateError,
      years: YEARS,
      months: MONTHS,
      selectedOrder: selectedOrder,
      sortOrderOptions: sortOrderOptions,
      fromYear: fromYear,
      fromMonth: fromMonth,
      fromDay: fromDay,
      toYear: toYear,
      toMonth: toMonth,
      toDay: toDay,
      fromDaysInMonth: fromDaysInMonth,
      toDaysInMonth: toDaysInMonth,
      onDatesConfirmed: onDatesConfirmed
    };
  }
});

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_composition_api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_components_BaseModal_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ExecutorProgressFloat_vue__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_executorRunsService__ = __webpack_require__(718);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ExecutorRunButton',
  components: {
    BaseModal: __WEBPACK_IMPORTED_MODULE_3__app_shared_components_BaseModal_vue__["a" /* default */],
    ExecutorProgressFloat: __WEBPACK_IMPORTED_MODULE_4__components_ExecutorProgressFloat_vue__["a" /* default */]
  },
  props: {
    executorName: {
      type: String,
      required: true
    },
    requestPayload: {
      type: Object,
      required: true
    },
    icon: {
      type: String,
      "default": 'fa-download'
    },
    tooltip: {
      type: String,
      "default": 'Descargar'
    }
  },
  setup: function setup(props) {
    var status = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])('idle'); // idle | pending | working | done | error
    var showModal = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(false);
    var currentRun = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(null);
    var errorMessage = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])('');
    var now = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(Date.now());
    var countdown = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(0);
    var cancelPoll = null;
    var clockTimer = null;
    var countdownInterval = null;
    var startClock = function startClock() {
      clockTimer = setInterval(function () {
        now.value = Date.now();
      }, 1000);
    };
    var stopClock = function stopClock() {
      if (clockTimer) {
        clearInterval(clockTimer);
        clockTimer = null;
      }
    };
    var isRunning = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      return status.value === 'pending' || status.value === 'working';
    });
    var stages = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      var progress = currentRun.value && currentRun.value.progress;
      return progress && progress.stages || [];
    });
    var overallPct = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      var progress = currentRun.value && currentRun.value.progress;
      return progress && progress.overall_pct || 0;
    });
    var floatTitle = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      if (status.value === 'pending') return 'En cola...';
      var active = stages.value.find(function (s) {
        return s.start_ts !== null && s.end_ts === null;
      });
      return active ? active.stage_name : props.tooltip || 'Procesando...';
    });
    var isStageActive = function isStageActive(stage) {
      return stage.start_ts !== null && stage.end_ts === null && !(currentRun.value && currentRun.value.status === 'ERROR');
    };
    var isStageCompleted = function isStageCompleted(stage) {
      return stage.end_ts !== null;
    };
    var isStageError = function isStageError(stage) {
      return currentRun.value && currentRun.value.status === 'ERROR' && stage.start_ts !== null && stage.end_ts === null;
    };
    var stageIcon = function stageIcon(stage) {
      if (isStageError(stage)) return 'fa fa-times-circle text-danger';
      if (isStageCompleted(stage)) return 'fa fa-check-circle text-success';
      return 'fa fa-circle-o text-muted';
    };
    var elapsed = function elapsed(stage) {
      if (!stage.start_ts) return '';
      var endMs = stage.end_ts ? new Date(stage.end_ts).getTime() : now.value;
      var diffMs = endMs - new Date(stage.start_ts).getTime();
      if (diffMs < 1000) return "".concat(diffMs, "ms");
      var diffS = Math.floor(diffMs / 1000);
      if (diffS < 60) return "".concat(diffS, "s");
      return "".concat(Math.floor(diffS / 60), "m ").concat(diffS % 60, "s");
    };
    var triggerDownload = function triggerDownload(run) {
      if (!run.result || !run.result.download_url) return;
      var a = document.createElement('a');
      a.href = run.result.download_url;
      a.download = run.result.filename || 'download';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };
    var clearCountdown = function clearCountdown() {
      if (countdownInterval) {
        clearInterval(countdownInterval);
        countdownInterval = null;
      }
    };
    var resetState = function resetState() {
      clearCountdown();
      status.value = 'idle';
      showModal.value = false;
      currentRun.value = null;
      errorMessage.value = '';
      countdown.value = 0;
    };
    var scheduleReset = function scheduleReset() {
      countdown.value = 10;
      countdownInterval = setInterval(function () {
        countdown.value -= 1;
        if (countdown.value <= 0) resetState();
      }, 1000);
    };
    var cancelRun = function cancelRun() {
      if (cancelPoll) {
        cancelPoll();
        cancelPoll = null;
      }
      stopClock();
      clearCountdown();
      status.value = 'idle';
      currentRun.value = null;
      errorMessage.value = '';
      countdown.value = 0;
    };
    var handleModalHidden = function handleModalHidden() {
      if (status.value === 'done') resetState();
    };
    var startRun = /*#__PURE__*/function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var _yield$createRun, runId, _pollUntilDone, promise, cancel, finalRun, _t;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              status.value = 'pending';
              showModal.value = true;
              currentRun.value = null;
              errorMessage.value = '';
              _context.prev = 1;
              _context.next = 2;
              return Object(__WEBPACK_IMPORTED_MODULE_5__services_executorRunsService__["a" /* createRun */])(props.executorName, props.requestPayload);
            case 2:
              _yield$createRun = _context.sent;
              runId = _yield$createRun.run_id;
              status.value = 'working';
              startClock();
              _pollUntilDone = Object(__WEBPACK_IMPORTED_MODULE_5__services_executorRunsService__["c" /* pollUntilDone */])(runId, {
                onProgress: function onProgress(run) {
                  currentRun.value = run;
                }
              }), promise = _pollUntilDone.promise, cancel = _pollUntilDone.cancel;
              cancelPoll = cancel;
              _context.next = 3;
              return promise;
            case 3:
              finalRun = _context.sent;
              cancelPoll = null;
              currentRun.value = finalRun;
              if (finalRun.status === 'DONE') {
                status.value = 'done';
                triggerDownload(finalRun);
              } else {
                status.value = 'error';
                errorMessage.value = finalRun.error_message || 'Ocurrió un error inesperado.';
              }
              _context.next = 6;
              break;
            case 4:
              _context.prev = 4;
              _t = _context["catch"](1);
              if (!(_t && _t.message === 'cancelled')) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              status.value = 'error';
              errorMessage.value = _t && _t.message === 'timeout' ? 'El proceso superó el tiempo máximo de espera (15 min). Por favor reintenta.' : 'Ocurrió un error inesperado. Por favor reintenta.';
            case 6:
              _context.prev = 6;
              stopClock();
              if (status.value === 'done') scheduleReset();
              return _context.finish(6);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 4, 6, 7]]);
      }));
      return function startRun() {
        return _ref.apply(this, arguments);
      };
    }();
    var handleClick = function handleClick() {
      if (status.value === 'error') {
        status.value = 'idle';
        currentRun.value = null;
        errorMessage.value = '';
      }
      if (status.value === 'pending' || status.value === 'working') {
        showModal.value = true;
        return;
      }
      startRun();
    };
    Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["h" /* onBeforeUnmount */])(function () {
      if (cancelPoll) {
        cancelPoll();
        cancelPoll = null;
      }
      stopClock();
      clearCountdown();
    });
    return {
      status: status,
      showModal: showModal,
      currentRun: currentRun,
      errorMessage: errorMessage,
      isRunning: isRunning,
      stages: stages,
      overallPct: overallPct,
      floatTitle: floatTitle,
      countdown: countdown,
      isStageActive: isStageActive,
      stageIcon: stageIcon,
      elapsed: elapsed,
      handleClick: handleClick,
      cancelRun: cancelRun,
      handleModalHidden: handleModalHidden
    };
  }
});

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ExecutorProgressFloat',
  props: {
    visible: {
      type: Boolean,
      "default": false
    },
    title: {
      type: String,
      "default": 'Procesando...'
    },
    pct: {
      type: Number,
      "default": 0
    },
    running: {
      type: Boolean,
      "default": true
    },
    variant: {
      type: String,
      "default": 'primary'
    }
  }
});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_composition_api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shared_components_BaseModal_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__compositions_useFieldInsights__ = __webpack_require__(1015);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var AVATAR_COLORS = ['#4299e1', '#48bb78', '#ed8936', '#9f7aea', '#f56565', '#38b2ac', '#ed64a6', '#667eea'];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FieldInsightsPanel',
  components: {
    BaseModal: __WEBPACK_IMPORTED_MODULE_2__app_shared_components_BaseModal_vue__["a" /* default */]
  },
  setup: function setup() {
    var userSearchQuery = Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["n" /* ref */])('');
    var _useFieldInsights = Object(__WEBPACK_IMPORTED_MODULE_3__compositions_useFieldInsights__["a" /* useFieldInsights */])(),
      users = _useFieldInsights.users,
      selectedUser = _useFieldInsights.selectedUser,
      selectedInsights = _useFieldInsights.selectedInsights,
      loadingUsers = _useFieldInsights.loadingUsers,
      errorUsers = _useFieldInsights.errorUsers,
      fetchUsers = _useFieldInsights.fetchUsers,
      selectUser = _useFieldInsights.selectUser,
      clearSelection = _useFieldInsights.clearSelection;
    var filteredUsers = Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["a" /* computed */])(function () {
      var q = userSearchQuery.value.trim().toLowerCase();
      if (!q) return users.value;
      return users.value.filter(function (u) {
        return (u.name || '').toLowerCase().includes(q);
      });
    });
    fetchUsers();
    return {
      userSearchQuery: userSearchQuery,
      filteredUsers: filteredUsers,
      users: users,
      selectedUser: selectedUser,
      selectedInsights: selectedInsights,
      loadingUsers: loadingUsers,
      errorUsers: errorUsers,
      selectUser: selectUser,
      clearSelection: clearSelection
    };
  },
  data: function data() {
    return {
      showRouteMapModal: false,
      routeMapModalTitle: '',
      routeMapStores: [],
      routeMapMounted: false
    };
  },
  computed: {
    routeMapCenter: function routeMapCenter() {
      var list = this.routeMapStores;
      if (!list.length) return {
        lat: -33.4489,
        lng: -70.6693
      };
      var lat = list.reduce(function (a, s) {
        return a + s.latitude;
      }, 0) / list.length;
      var lng = list.reduce(function (a, s) {
        return a + s.longitude;
      }, 0) / list.length;
      return {
        lat: lat,
        lng: lng
      };
    },
    routeMapZoom: function routeMapZoom() {
      var n = this.routeMapStores.length;
      if (n <= 1) return 13;
      if (n <= 4) return 12;
      return 11;
    },
    routeMapOptions: function routeMapOptions() {
      return {
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true,
        gestureHandling: 'greedy'
      };
    },
    monthProgressPct: function monthProgressPct() {
      var s = this.selectedInsights;
      if (!s || !s.monthlyGoal) return 0;
      return Math.min(100, Math.round(s.visitedThisMonth / s.monthlyGoal * 100));
    },
    monthProgressClass: function monthProgressClass() {
      var p = this.monthProgressPct;
      if (p >= 90) return 'fill--green';
      if (p >= 60) return 'fill--blue';
      return 'fill--amber';
    },
    routeDaysWithLabels: function routeDaysWithLabels() {
      var _this = this;
      var s = this.selectedInsights;
      if (!s || !s.routes) return [];
      return s.routes.map(function (r) {
        return {
          label: _this.$moment().add(r.offset, 'day').format('dddd D [de] MMMM'),
          stores: r.stores
        };
      });
    }
  },
  watch: {
    showRouteMapModal: function showRouteMapModal(open) {
      var _this2 = this;
      if (open) {
        this.$nextTick(function () {
          setTimeout(function () {
            _this2.routeMapMounted = true;
          }, 200);
        });
      } else {
        this.routeMapMounted = false;
      }
    }
  },
  methods: {
    openRouteMap: function openRouteMap(day) {
      this.routeMapModalTitle = "Ruta \xB7 ".concat(day.label);
      this.routeMapStores = day.stores && day.stores.length ? __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(day.stores) : [];
      this.showRouteMapModal = true;
    },
    initials: function initials(name) {
      if (!name) return '?';
      return name.trim().split(' ').slice(0, 2).map(function (p) {
        return p[0];
      }).join('').toUpperCase();
    },
    avatarStyle: function avatarStyle(name) {
      var idx = (name || '').charCodeAt(0) % AVATAR_COLORS.length;
      return {
        background: AVATAR_COLORS[idx]
      };
    }
  }
});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_composition_api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Services__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_HashtagDashboard__ = __webpack_require__(1023);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HashtagsDashboard',
  props: {
    selectedHashtagId: {
      type: Number,
      "default": null
    },
    refreshTrigger: {
      type: Number,
      "default": 0
    }
  },
  setup: function setup(props, context) {
    var loading = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(false);
    var expanded = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(true);
    var dashboard = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(null);
    var formattedPeriod = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["a" /* computed */])(function () {
      if (!dashboard.value) return '';
      var fmt = function fmt(d) {
        var _d$split = d.split('-'),
          _d$split2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_d$split, 3),
          y = _d$split2[0],
          m = _d$split2[1],
          day = _d$split2[2];
        return "".concat(day, "/").concat(m, "/").concat(y);
      };
      return "".concat(fmt(dashboard.value.startDate), " \u2013 ").concat(fmt(dashboard.value.endDate));
    });
    var toggleExpanded = function toggleExpanded() {
      expanded.value = !expanded.value;
    };
    var fetchDashboard = /*#__PURE__*/function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var raw, _t;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.prev = 1;
              _context.next = 2;
              return Object(__WEBPACK_IMPORTED_MODULE_4__Services__["o" /* getHashtagDashboard */])();
            case 2:
              raw = _context.sent;
              dashboard.value = new __WEBPACK_IMPORTED_MODULE_5__models_HashtagDashboard__["a" /* default */](raw);
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              dashboard.value = null;
            case 4:
              _context.prev = 4;
              loading.value = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }));
      return function fetchDashboard() {
        return _ref.apply(this, arguments);
      };
    }();
    var getChartOptions = function getChartOptions(hashtag) {
      return {
        chart: {
          type: 'area',
          sparkline: {
            enabled: true
          },
          height: 38,
          animations: {
            enabled: false
          },
          toolbar: {
            show: false
          }
        },
        stroke: {
          curve: 'smooth',
          width: 1.5
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.35,
            opacityTo: 0,
            stops: [0, 100]
          }
        },
        colors: [hashtag.color],
        xaxis: {
          categories: hashtag.trendCategories
        },
        tooltip: {
          enabled: true,
          fixed: {
            enabled: false
          },
          x: {
            formatter: function formatter(val, opts) {
              var cat = hashtag.trendCategories[opts.dataPointIndex];
              if (!cat) return '';
              var _cat$split = cat.split('-'),
                _cat$split2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_cat$split, 3),
                m = _cat$split2[1],
                d = _cat$split2[2];
              return "".concat(d, "/").concat(m);
            }
          },
          y: {
            title: {
              formatter: function formatter() {
                return '';
              }
            }
          }
        },
        grid: {
          show: false
        },
        markers: {
          size: 0
        }
      };
    };
    var selectHashtag = function selectHashtag(hashtag) {
      var isDeselecting = hashtag.id === props.selectedHashtagId;
      context.emit('filter', isDeselecting ? null : hashtag);
    };
    Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["q" /* watch */])(function () {
      return props.refreshTrigger;
    }, function (val, oldVal) {
      if (val !== oldVal) fetchDashboard();
    });
    Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["i" /* onMounted */])(fetchDashboard);
    return {
      loading: loading,
      expanded: expanded,
      dashboard: dashboard,
      formattedPeriod: formattedPeriod,
      toggleExpanded: toggleExpanded,
      getChartOptions: getChartOptions,
      selectHashtag: selectHashtag
    };
  }
});

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_composition_api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_components_PageHeader__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_UploadImages__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_StoreSelector__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CategorySelector__ = __webpack_require__(1036);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UploadImagesFeed',
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_4__app_shared_components_PageHeader__["a" /* default */],
    UploadImages: __WEBPACK_IMPORTED_MODULE_5__components_UploadImages__["a" /* default */],
    StoreSelector: __WEBPACK_IMPORTED_MODULE_6__components_StoreSelector__["a" /* default */],
    CategorySelector: __WEBPACK_IMPORTED_MODULE_7__components_CategorySelector__["a" /* default */]
  },
  setup: function setup(props, context) {
    var uploadData = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])({
      caption: '',
      images: []
    });
    var processing = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(false);
    var route = context.root.$route;
    var store = context.root.$store;
    var storeIdFromRoute = route.params.storeId || route.query.storeId;
    var categoryIdFromRoute = route.params.categoryId || route.query.categoryId;
    var storeId = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(storeIdFromRoute || (store.state.mobile && store.state.mobile.store_id ? store.state.mobile.store_id.toString() : null));
    var categoryId = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(categoryIdFromRoute || null);
    var canSubmit = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      return uploadData.value.images.length > 0 && storeId.value && categoryId.value && !processing.value;
    });
    var makeToast = function makeToast(body, title) {
      var variant = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'danger';
      context.root.$bvToast.toast(body, {
        title: title,
        autoHideDelay: 5000,
        appendToast: false,
        solid: true,
        variant: variant
      });
    };
    var goBack = function goBack() {
      context.root.$router.go(-1);
    };
    var handleSubmit = /*#__PURE__*/function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var imgList, cleanPayload, errorMessage, _t;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (canSubmit.value) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              if (!(!storeId.value || !categoryId.value)) {
                _context.next = 2;
                break;
              }
              makeToast('Por favor ingresa el ID de tienda y categoría', 'Error');
              return _context.abrupt("return");
            case 2:
              processing.value = true;
              _context.prev = 3;
              imgList = (uploadData.value.images || []).map(function (img) {
                var base64String = '';
                if (typeof img === 'string') {
                  base64String = img;
                } else if (img && img.base64) {
                  base64String = img.base64;
                } else {
                  base64String = String(img);
                }
                var mimeType = 'image/jpeg';
                var base64Data = base64String;
                if (base64String.startsWith('data:')) {
                  var matches = base64String.match(/^data:([^;]+);base64,(.+)$/);
                  if (matches && matches.length === 3) {
                    mimeType = matches[1];
                    base64Data = matches[2];
                  }
                }
                return {
                  mime: mimeType,
                  img: base64Data
                };
              });
              cleanPayload = JSON.parse(JSON.stringify({
                feedData: {
                  storeId: parseInt(storeId.value),
                  categoryId: parseInt(categoryId.value),
                  content: {
                    caption: uploadData.value.caption || '',
                    imgList: imgList
                  }
                }
              }));
              _context.next = 4;
              return Object(__WEBPACK_IMPORTED_MODULE_3__Services__["u" /* postNewContentToFeed */])(cleanPayload);
            case 4:
              makeToast('Imágenes subidas exitosamente', 'Éxito', 'success');
              setTimeout(function () {
                context.root.$router.push({
                  name: 'StorePublicationContent'
                });
              }, 1500);
              _context.next = 6;
              break;
            case 5:
              _context.prev = 5;
              _t = _context["catch"](3);
              errorMessage = _t.message || 'Error al subir las imágenes';
              makeToast(errorMessage, 'Error');
            case 6:
              _context.prev = 6;
              processing.value = false;
              return _context.finish(6);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 5, 6, 7]]);
      }));
      return function handleSubmit() {
        return _ref.apply(this, arguments);
      };
    }();
    return {
      uploadData: uploadData,
      processing: processing,
      canSubmit: canSubmit,
      goBack: goBack,
      handleSubmit: handleSubmit,
      storeId: storeId,
      categoryId: categoryId,
      storeIdFromRoute: storeIdFromRoute,
      categoryIdFromRoute: categoryIdFromRoute
    };
  }
});

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    popOverPlacement: {
      type: String,
      "default": 'right'
    }
  }
});

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(26);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UploadImages',
  props: {
    value: {
      type: Object,
      "default": function _default() {
        return {
          caption: '',
          images: []
        };
      }
    }
  },
  setup: function setup(props, context) {
    var fileInput = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["n" /* ref */])(null);
    var caption = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["n" /* ref */])(props.value ? props.value.caption : '');
    var images = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["n" /* ref */])([]);
    var errorMessage = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["n" /* ref */])('');
    if (props.value && props.value.images && Array.isArray(props.value.images) && props.value.images.length > 0) {
      if (typeof props.value.images[0] === 'string') {
        images.value = props.value.images.map(function (base64) {
          return {
            preview: base64,
            base64: base64
          };
        });
      } else {
        images.value = props.value.images;
      }
    }
    var captionDebounceTimer = null;
    var imagesDebounceTimer = null;
    var emitUpdate = function emitUpdate() {
      var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var doEmit = function doEmit() {
        var imageData = images.value.map(function (img) {
          return img.base64 || img;
        });
        context.emit('input', {
          caption: caption.value,
          images: imageData
        });
      };
      if (immediate) {
        doEmit();
      } else {
        context.root.$nextTick(doEmit);
      }
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["q" /* watch */])(caption, function () {
      if (captionDebounceTimer) clearTimeout(captionDebounceTimer);
      captionDebounceTimer = setTimeout(function () {
        return emitUpdate();
      }, 300);
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["q" /* watch */])(function () {
      return images.value.length;
    }, function () {
      if (imagesDebounceTimer) clearTimeout(imagesDebounceTimer);
      imagesDebounceTimer = setTimeout(function () {
        return emitUpdate(true);
      }, 100);
    });
    var triggerFileInput = function triggerFileInput() {
      if (fileInput.value) fileInput.value.click();
    };
    var handleFileSelect = function handleFileSelect(event) {
      errorMessage.value = '';
      var files = Array.from(event.target.files || []);
      if (files.length === 0) return;
      var maxSize = 10 * 1024 * 1024;
      var validFiles = [];
      for (var _i = 0, _files = files; _i < _files.length; _i++) {
        var file = _files[_i];
        if (!file.type.startsWith('image/')) {
          errorMessage.value = 'Solo se permiten archivos de imagen';
          continue;
        }
        if (file.size > maxSize) {
          errorMessage.value = "La imagen ".concat(file.name, " es demasiado grande. M\xE1ximo 10MB");
          continue;
        }
        validFiles.push(file);
      }
      if (validFiles.length === 0) return;
      validFiles.forEach(function (file) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var base64 = e.target.result;
          images.value.push({
            file: file,
            preview: base64,
            base64: base64
          });
        };
        reader.readAsDataURL(file);
      });
      if (fileInput.value) fileInput.value.value = '';
    };
    var removeImage = function removeImage(index) {
      images.value.splice(index, 1);
    };
    return {
      fileInput: fileInput,
      caption: caption,
      images: images,
      errorMessage: errorMessage,
      triggerFileInput: triggerFileInput,
      handleFileSelect: handleFileSelect,
      removeImage: removeImage
    };
  }
});

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'StoreSelector',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a
  },
  props: {
    value: {
      type: [Number, String],
      "default": null
    },
    label: {
      type: String,
      "default": 'Tienda:'
    },
    inputId: {
      type: String,
      "default": 'store-selector'
    }
  },
  setup: function setup(props, context) {
    var store = context.root.$store;
    var selectedStore = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["n" /* ref */])(null);
    var storeOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var storeFilters = store.getters.storeFilters;
      if (!storeFilters || !Array.isArray(storeFilters)) return [];
      var _iterator = _createForOfIteratorHelper(storeFilters),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var filterGroup = _step.value;
          if (filterGroup.levelList && Array.isArray(filterGroup.levelList)) {
            var storeLevel = filterGroup.levelList.find(function (level) {
              return level.id === 'store_id';
            });
            if (storeLevel && storeLevel.options) return storeLevel.options;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return [];
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["q" /* watch */])(function () {
      return props.value;
    }, function (newValue) {
      if (newValue && storeOptions.value.length > 0) {
        var foundStoreOption = storeOptions.value.find(function (option) {
          return option.id === Number(newValue);
        });
        if (foundStoreOption) selectedStore.value = foundStoreOption;
      } else {
        selectedStore.value = null;
      }
    }, {
      immediate: true
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["q" /* watch */])(storeOptions, function (newOptions) {
      if (props.value && newOptions.length > 0) {
        var foundStore = newOptions.find(function (option) {
          return option.id === Number(props.value);
        });
        if (foundStore) selectedStore.value = foundStore;
      }
    });
    var handleStoreChange = function handleStoreChange(selected) {
      context.emit('input', selected ? selected.id : null);
    };
    return {
      selectedStore: selectedStore,
      storeOptions: storeOptions,
      handleStoreChange: handleStoreChange
    };
  }
});

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CategorySelector',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a
  },
  props: {
    value: {
      type: [Number, String],
      "default": null
    },
    label: {
      type: String,
      "default": 'ID de Categoría:'
    },
    inputId: {
      type: String,
      "default": 'category-selector'
    }
  },
  setup: function setup(props, context) {
    var store = context.root.$store;
    var selectedCategory = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["n" /* ref */])(null);
    var categoryOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var feedCategories = store.getters.feedCategories;
      if (!feedCategories || !Array.isArray(feedCategories)) return [];
      return feedCategories;
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["q" /* watch */])(function () {
      return props.value;
    }, function (newValue) {
      if (newValue && categoryOptions.value.length > 0) {
        var foundCategory = categoryOptions.value.find(function (option) {
          return option.id === Number(newValue);
        });
        if (foundCategory) selectedCategory.value = foundCategory;
      } else {
        selectedCategory.value = null;
      }
    }, {
      immediate: true
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["q" /* watch */])(categoryOptions, function (newOptions) {
      if (props.value && newOptions.length > 0) {
        var foundCategory = newOptions.find(function (option) {
          return option.id === Number(props.value);
        });
        if (foundCategory) selectedCategory.value = foundCategory;
      }
    });
    var handleCategoryChange = function handleCategoryChange(selected) {
      context.emit('input', selected ? selected.id : null);
    };
    return {
      selectedCategory: selectedCategory,
      categoryOptions: categoryOptions,
      handleCategoryChange: handleCategoryChange
    };
  }
});

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_composition_api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_components_BaseModal_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Services__ = __webpack_require__(50);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ExecutionFocusList',
  components: {
    BaseModal: __WEBPACK_IMPORTED_MODULE_4__app_shared_components_BaseModal_vue__["a" /* default */]
  },
  setup: function setup(_, context) {
    var loading = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(false);
    var error = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(null);
    var items = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])([]);
    var deactivating = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(false);
    var deleting = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(false);
    var showDeactivateModal = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(false);
    var showDeleteModal = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(false);
    var focusToDeactivate = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(null);
    var focusToDelete = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(null);
    var actionBusy = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["a" /* computed */])(function () {
      return deactivating.value || deleting.value;
    });
    var filters = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])({
      active: null,
      start_date: '',
      end_date: ''
    });
    var fields = [{
      key: 'name',
      label: 'Nombre',
      sortable: true
    }, {
      key: 'description',
      label: 'Descripción',
      sortable: false
    }, {
      key: 'start_date',
      label: 'Inicio',
      sortable: true
    }, {
      key: 'end_date',
      label: 'Fin',
      sortable: true
    }, {
      key: 'active',
      label: 'Estado',
      sortable: true
    }, {
      key: 'actions',
      label: '',
      thStyle: {
        width: '150px'
      }
    }];
    var hasActiveFilters = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["a" /* computed */])(function () {
      return filters.value.active !== null || !!filters.value.start_date || !!filters.value.end_date;
    });
    var load = /*#__PURE__*/function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var f, params, _t;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              error.value = null;
              _context.prev = 1;
              f = filters.value;
              params = {};
              if (f.active !== null) params.active = f.active;
              if (f.start_date) params.start_date = f.start_date;
              if (f.end_date) params.end_date = f.end_date;
              _context.next = 2;
              return Object(__WEBPACK_IMPORTED_MODULE_5__Services__["j" /* getExecutionFocusList */])(params);
            case 2:
              items.value = _context.sent;
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              error.value = _t.message || 'Error al cargar las ejecuciones';
            case 4:
              _context.prev = 4;
              loading.value = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }));
      return function load() {
        return _ref.apply(this, arguments);
      };
    }();
    var setActiveFilter = function setActiveFilter(value) {
      filters.value.active = value;
      load();
    };
    var clearFilters = function clearFilters() {
      filters.value = {
        active: null,
        start_date: '',
        end_date: ''
      };
      load();
    };
    var formatDate = function formatDate(dateStr) {
      if (!dateStr) return '—';
      var _dateStr$split = dateStr.split('-'),
        _dateStr$split2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_dateStr$split, 3),
        y = _dateStr$split2[0],
        m = _dateStr$split2[1],
        d = _dateStr$split2[2];
      return "".concat(d, "/").concat(m, "/").concat(y);
    };
    var goBack = function goBack() {
      return context.root.$router.go(-1);
    };
    var goToCreate = function goToCreate() {
      return context.root.$router.push({
        name: 'CreateExecutionFocus'
      });
    };
    var goToEdit = function goToEdit(id) {
      return context.root.$router.push({
        name: 'CreateExecutionFocus',
        params: {
          id: id
        }
      });
    };
    var goToResults = function goToResults(id) {
      return context.root.$router.push({
        name: 'ExecutionFocusDashboard',
        params: {
          id: id
        }
      });
    };
    var makeToast = function makeToast(body, title) {
      var variant = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'danger';
      context.root.$bvToast.toast(body, {
        title: title,
        autoHideDelay: 5000,
        appendToast: false,
        solid: true,
        variant: variant
      });
    };
    var openDeactivateModal = function openDeactivateModal(item) {
      focusToDeactivate.value = item;
      showDeactivateModal.value = true;
    };
    var handleDeactivate = /*#__PURE__*/function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var text, _t2;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!focusToDeactivate.value || deactivating.value)) {
                _context2.next = 1;
                break;
              }
              return _context2.abrupt("return");
            case 1:
              deactivating.value = true;
              _context2.prev = 2;
              _context2.next = 3;
              return Object(__WEBPACK_IMPORTED_MODULE_5__Services__["d" /* deactivateExecutionFocus */])(focusToDeactivate.value.id);
            case 3:
              showDeactivateModal.value = false;
              focusToDeactivate.value = null;
              makeToast('La ejecución se desactivó correctamente.', 'Éxito', 'success');
              _context2.next = 4;
              return load();
            case 4:
              _context2.next = 6;
              break;
            case 5:
              _context2.prev = 5;
              _t2 = _context2["catch"](2);
              text = _t2 && _t2.message || _t2 && _t2.data && _t2.data.message || 'No se pudo desactivar la ejecución.';
              makeToast(text, 'Error');
            case 6:
              _context2.prev = 6;
              deactivating.value = false;
              return _context2.finish(6);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[2, 5, 6, 7]]);
      }));
      return function handleDeactivate() {
        return _ref2.apply(this, arguments);
      };
    }();
    var openDeleteModal = function openDeleteModal(item) {
      focusToDelete.value = item;
      showDeleteModal.value = true;
    };
    var handleDelete = /*#__PURE__*/function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3() {
        var text, _t3;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(!focusToDelete.value || deleting.value)) {
                _context3.next = 1;
                break;
              }
              return _context3.abrupt("return");
            case 1:
              deleting.value = true;
              _context3.prev = 2;
              _context3.next = 3;
              return Object(__WEBPACK_IMPORTED_MODULE_5__Services__["g" /* deleteExecutionFocus */])(focusToDelete.value.id);
            case 3:
              showDeleteModal.value = false;
              focusToDelete.value = null;
              makeToast('La ejecución se eliminó correctamente.', 'Éxito', 'success');
              _context3.next = 4;
              return load();
            case 4:
              _context3.next = 6;
              break;
            case 5:
              _context3.prev = 5;
              _t3 = _context3["catch"](2);
              text = _t3 && _t3.message || _t3 && _t3.data && _t3.data.message || 'No se pudo eliminar la ejecución.';
              makeToast(text, 'Error');
            case 6:
              _context3.prev = 6;
              deleting.value = false;
              return _context3.finish(6);
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[2, 5, 6, 7]]);
      }));
      return function handleDelete() {
        return _ref3.apply(this, arguments);
      };
    }();
    Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["i" /* onMounted */])(load);
    return {
      loading: loading,
      error: error,
      items: items,
      deactivating: deactivating,
      deleting: deleting,
      actionBusy: actionBusy,
      showDeactivateModal: showDeactivateModal,
      showDeleteModal: showDeleteModal,
      focusToDeactivate: focusToDeactivate,
      focusToDelete: focusToDelete,
      filters: filters,
      fields: fields,
      hasActiveFilters: hasActiveFilters,
      load: load,
      setActiveFilter: setActiveFilter,
      clearFilters: clearFilters,
      formatDate: formatDate,
      goBack: goBack,
      goToCreate: goToCreate,
      goToEdit: goToEdit,
      goToResults: goToResults,
      openDeactivateModal: openDeactivateModal,
      handleDeactivate: handleDeactivate,
      openDeleteModal: openDeleteModal,
      handleDelete: handleDelete
    };
  }
});

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_composition_api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Services__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_ExecutionFocusRuleType__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_product_master_Services__ = __webpack_require__(731);




function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





function makeRule() {
  return {
    rule_type_id: null,
    is_required: true,
    allow_comment: false,
    question_label: ''
  };
}
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CreateExecutionFocus',
  setup: function setup(_, context) {
    var processing = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(false);
    var currentStep = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(0);
    var submitted0 = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(false);
    var submitted2 = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(false);
    var storeIdInput = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(null);
    var storeDuplicateError = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(false);
    var globalSearchQuery = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])('');
    var globalSearchResults = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])([]);
    var globalSearchLoading = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(false);
    var dropdownOpen = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(false);
    var globalSearchTimer = null;
    var steps = [{
      label: 'Info General'
    }, {
      label: 'Tiendas'
    }, {
      label: 'Productos'
    }, {
      label: 'Revisión'
    }];
    var form = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])({
      name: '',
      description: '',
      start_date: '',
      end_date: '',
      active: true,
      store_ids: [],
      products: []
    });
    var ruleTypes = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])([]);
    var ruleTypesLoading = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["n" /* ref */])(false);
    var ruleCodeOptions = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["a" /* computed */])(function () {
      return ruleTypes.value.map(function (rt) {
        return {
          value: rt.id,
          text: rt.name
        };
      });
    });
    var ruleLabelMap = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["a" /* computed */])(function () {
      return Object.fromEntries(ruleTypes.value.map(function (rt) {
        return [rt.id, rt.name];
      }));
    });

    // Validaciones
    var endDateError = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["a" /* computed */])(function () {
      return !!(form.value.end_date && form.value.start_date && form.value.end_date <= form.value.start_date);
    });
    var productDuplicateIdError = Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["a" /* computed */])(function () {
      var ids = form.value.products.map(function (p) {
        return p.product_id;
      }).filter(Boolean);
      return ids.length !== new Set(ids).size;
    });
    var productDuplicateRuleError = function productDuplicateRuleError(pIdx) {
      var rules = form.value.products[pIdx].rules.map(function (r) {
        return r.rule_type_id;
      }).filter(Boolean);
      return rules.length !== new Set(rules).size;
    };

    // Stepper
    var goToStep = function goToStep(i) {
      currentStep.value = i;
    };
    var nextStep = function nextStep() {
      if (currentStep.value === 0) {
        submitted0.value = true;
        if (!form.value.name.trim() || !form.value.start_date || endDateError.value) return;
      }
      if (currentStep.value === 2) {
        submitted2.value = true;
        for (var pIdx = 0; pIdx < form.value.products.length; pIdx++) {
          if (productDuplicateRuleError(pIdx)) return;
          var _iterator = _createForOfIteratorHelper(form.value.products[pIdx].rules),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var rule = _step.value;
              if (!rule.rule_type_id) return;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        if (productDuplicateIdError.value) return;
      }
      currentStep.value++;
    };
    var prevStep = function prevStep() {
      currentStep.value--;
    };

    // Tiendas
    var addStoreId = function addStoreId() {
      storeDuplicateError.value = false;
      var id = Number(storeIdInput.value);
      if (!id) return;
      if (form.value.store_ids.includes(id)) {
        storeDuplicateError.value = true;
        return;
      }
      form.value.store_ids.push(id);
      storeIdInput.value = null;
    };
    var removeStoreId = function removeStoreId(id) {
      form.value.store_ids = form.value.store_ids.filter(function (s) {
        return s !== id;
      });
    };

    // Productos
    var onProductSearchInput = function onProductSearchInput() {
      dropdownOpen.value = true;
      clearTimeout(globalSearchTimer);
      if (globalSearchQuery.value.length < 2) {
        globalSearchResults.value = [];
        return;
      }
      globalSearchLoading.value = true;
      globalSearchTimer = setTimeout(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee() {
        var results, _t;
        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return Object(__WEBPACK_IMPORTED_MODULE_7__app_product_master_Services__["e" /* searchProducts */])(globalSearchQuery.value);
            case 1:
              results = _context.sent;
              globalSearchResults.value = Array.isArray(results) ? results : [];
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              globalSearchResults.value = [];
            case 3:
              _context.prev = 3;
              globalSearchLoading.value = false;
              return _context.finish(3);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 2, 3, 4]]);
      })), 350);
    };
    var closeDropdownSoon = function closeDropdownSoon() {
      return setTimeout(function () {
        dropdownOpen.value = false;
      }, 200);
    };
    var addProduct = function addProduct(prod) {
      if (form.value.products.some(function (p) {
        return p.product_id === prod.product_id;
      })) return;
      form.value.products.push({
        product_id: prod.product_id,
        product_name: prod.description || prod.business_key,
        rules: []
      });
      globalSearchQuery.value = '';
      globalSearchResults.value = [];
      dropdownOpen.value = false;
    };
    var removeProduct = function removeProduct(pIdx) {
      form.value.products.splice(pIdx, 1);
    };

    // Reglas
    var addRule = function addRule(pIdx) {
      return form.value.products[pIdx].rules.push(makeRule());
    };
    var removeRule = function removeRule(pIdx, rIdx) {
      return form.value.products[pIdx].rules.splice(rIdx, 1);
    };

    // Helpers
    var onRuleTypeChange = function onRuleTypeChange(pIdx, rIdx) {
      var rule = form.value.products[pIdx].rules[rIdx];
      var rt = ruleTypes.value.find(function (t) {
        return t.id === rule.rule_type_id;
      });
      if (rt && rt.description) rule.question_label = rt.description;
    };
    var ruleLabel = function ruleLabel(code) {
      return ruleLabelMap.value[code] || code;
    };
    var formatDate = function formatDate(d) {
      if (!d) return '—';
      var _d$split = d.split('-'),
        _d$split2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_d$split, 3),
        y = _d$split2[0],
        m = _d$split2[1],
        day = _d$split2[2];
      return "".concat(day, "/").concat(m, "/").concat(y);
    };

    // Submit
    var buildPayload = function buildPayload() {
      return {
        name: form.value.name.trim(),
        active: form.value.active,
        start_date: form.value.start_date,
        description: form.value.description.trim() || null,
        end_date: form.value.end_date || null,
        store_ids: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(new Set(form.value.store_ids)),
        products: form.value.products.map(function (p, pIdx) {
          return {
            product_id: p.product_id,
            sort_order: pIdx + 1,
            rules: p.rules.map(function (r, rIdx) {
              return {
                rule_type_id: r.rule_type_id,
                is_required: r.is_required,
                allow_comment: r.allow_comment,
                question_label: r.question_label.trim() || null,
                sort_order: rIdx + 1
              };
            })
          };
        })
      };
    };
    var makeToast = function makeToast(body, title) {
      var variant = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'danger';
      context.root.$bvToast.toast(body, {
        title: title,
        autoHideDelay: 5000,
        appendToast: false,
        solid: true,
        variant: variant
      });
    };
    var handleSubmit = /*#__PURE__*/function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result, _t2;
        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!processing.value) {
                _context2.next = 1;
                break;
              }
              return _context2.abrupt("return");
            case 1:
              processing.value = true;
              _context2.prev = 2;
              _context2.next = 3;
              return Object(__WEBPACK_IMPORTED_MODULE_5__Services__["c" /* createExecutionFocus */])(buildPayload());
            case 3:
              result = _context2.sent;
              makeToast("Ejecuci\xF3n creada correctamente (ID: ".concat(result.id, ")"), 'Éxito', 'success');
              setTimeout(function () {
                context.root.$router.push({
                  name: 'ExecutionFocusList'
                });
              }, 1200);
              _context2.next = 5;
              break;
            case 4:
              _context2.prev = 4;
              _t2 = _context2["catch"](2);
              makeToast(_t2.message || 'Error al crear la ejecución', 'Error');
            case 5:
              _context2.prev = 5;
              processing.value = false;
              return _context2.finish(5);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[2, 4, 5, 6]]);
      }));
      return function handleSubmit() {
        return _ref2.apply(this, arguments);
      };
    }();
    var goBack = function goBack() {
      return context.root.$router.go(-1);
    };
    Object(__WEBPACK_IMPORTED_MODULE_4__vue_composition_api__["i" /* onMounted */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee3() {
      var raw, _t3;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            ruleTypesLoading.value = true;
            _context3.prev = 1;
            _context3.next = 2;
            return Object(__WEBPACK_IMPORTED_MODULE_5__Services__["k" /* getExecutionFocusRuleTypes */])();
          case 2:
            raw = _context3.sent;
            ruleTypes.value = Array.isArray(raw) ? raw.map(function (r) {
              return new __WEBPACK_IMPORTED_MODULE_6__models_ExecutionFocusRuleType__["a" /* default */](r);
            }) : [];
            _context3.next = 4;
            break;
          case 3:
            _context3.prev = 3;
            _t3 = _context3["catch"](1);
            makeToast('No se pudieron cargar los tipos de verificación', 'Error');
          case 4:
            _context3.prev = 4;
            ruleTypesLoading.value = false;
            return _context3.finish(4);
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 3, 4, 5]]);
    })));
    return {
      form: form,
      processing: processing,
      currentStep: currentStep,
      steps: steps,
      submitted0: submitted0,
      submitted2: submitted2,
      storeIdInput: storeIdInput,
      storeDuplicateError: storeDuplicateError,
      globalSearchQuery: globalSearchQuery,
      globalSearchResults: globalSearchResults,
      globalSearchLoading: globalSearchLoading,
      dropdownOpen: dropdownOpen,
      ruleTypesLoading: ruleTypesLoading,
      ruleCodeOptions: ruleCodeOptions,
      endDateError: endDateError,
      productDuplicateIdError: productDuplicateIdError,
      productDuplicateRuleError: productDuplicateRuleError,
      ruleLabel: ruleLabel,
      formatDate: formatDate,
      goToStep: goToStep,
      nextStep: nextStep,
      prevStep: prevStep,
      addStoreId: addStoreId,
      removeStoreId: removeStoreId,
      addProduct: addProduct,
      removeProduct: removeProduct,
      onProductSearchInput: onProductSearchInput,
      closeDropdownSoon: closeDropdownSoon,
      addRule: addRule,
      removeRule: removeRule,
      onRuleTypeChange: onRuleTypeChange,
      handleSubmit: handleSubmit,
      goBack: goBack
    };
  }
});

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_composition_api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Services__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_ExecutionFocusVisit__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_ExecutionFocusVisitDetail__ = __webpack_require__(1050);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ExecutionFocusDashboard',
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  setup: function setup(props, context) {
    var loading = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(false);
    var error = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(null);
    var focusName = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])('');
    var visits = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])([]);
    var ruleMap = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])({});
    var selectedVisit = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(null);
    var detail = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(null);
    var detailLoading = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])(false);
    var photoUrls = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])({});
    var photoLoading = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["n" /* ref */])({});
    var fields = [{
      key: 'store',
      label: 'Tienda',
      sortable: false
    }, {
      key: 'user',
      label: 'Usuario',
      sortable: false
    }, {
      key: 'product',
      label: 'Producto',
      sortable: false
    }, {
      key: 'submitted_at',
      label: 'Fecha',
      sortable: true
    }, {
      key: 'detail',
      label: '',
      thStyle: {
        width: '40px'
      }
    }];
    var ruleMeta = Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["a" /* computed */])(function () {
      return function (ruleTypeId) {
        return ruleMap.value[ruleTypeId] || {
          name: "Regla ".concat(ruleTypeId),
          inputType: 'text'
        };
      };
    });
    var load = /*#__PURE__*/function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var _yield$Promise$all, _yield$Promise$all2, focusData, visitsData, map, _t;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              error.value = null;
              _context.prev = 1;
              _context.next = 2;
              return Promise.all([Object(__WEBPACK_IMPORTED_MODULE_4__Services__["i" /* getExecutionFocus */])(props.id), Object(__WEBPACK_IMPORTED_MODULE_4__Services__["n" /* getExecutionFocusVisits */])(props.id)]);
            case 2:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_yield$Promise$all, 2);
              focusData = _yield$Promise$all2[0];
              visitsData = _yield$Promise$all2[1];
              focusName.value = focusData.name || '';
              map = {};
              if (Array.isArray(focusData.products)) {
                focusData.products.forEach(function (p) {
                  if (Array.isArray(p.rules)) {
                    p.rules.forEach(function (r) {
                      map[r.rule_type_id] = {
                        name: r.rule_name || r.question_label || "Regla ".concat(r.rule_type_id),
                        inputType: r.input_type
                      };
                    });
                  }
                });
              }
              ruleMap.value = map;
              visits.value = Array.isArray(visitsData) ? visitsData.map(function (v) {
                return new __WEBPACK_IMPORTED_MODULE_5__models_ExecutionFocusVisit__["a" /* default */](v);
              }) : [];
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              error.value = _t.message || 'Error al cargar los resultados';
            case 4:
              _context.prev = 4;
              loading.value = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }));
      return function load() {
        return _ref.apply(this, arguments);
      };
    }();
    var openVisit = /*#__PURE__*/function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2(visit) {
        var raw, _t2;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              selectedVisit.value = visit;
              detail.value = null;
              photoUrls.value = {};
              photoLoading.value = {};
              detailLoading.value = true;
              _context2.prev = 1;
              _context2.next = 2;
              return Object(__WEBPACK_IMPORTED_MODULE_4__Services__["l" /* getExecutionFocusVisit */])(visit.visitId);
            case 2:
              raw = _context2.sent;
              detail.value = new __WEBPACK_IMPORTED_MODULE_6__models_ExecutionFocusVisitDetail__["a" /* default */](raw);
              _context2.next = 4;
              break;
            case 3:
              _context2.prev = 3;
              _t2 = _context2["catch"](1);
              detail.value = null;
            case 4:
              _context2.prev = 4;
              detailLoading.value = false;
              return _context2.finish(4);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1, 3, 4, 5]]);
      }));
      return function openVisit(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    var closePanel = function closePanel() {
      selectedVisit.value = null;
      detail.value = null;
      photoUrls.value = {};
      photoLoading.value = {};
    };
    var loadPhoto = /*#__PURE__*/function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3(ruleTypeId) {
        var data, _t3;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(photoLoading.value[ruleTypeId] || !detail.value)) {
                _context3.next = 1;
                break;
              }
              return _context3.abrupt("return");
            case 1:
              context.root.$set(photoLoading.value, ruleTypeId, true);
              _context3.prev = 2;
              _context3.next = 3;
              return Object(__WEBPACK_IMPORTED_MODULE_4__Services__["m" /* getExecutionFocusVisitPhoto */])(detail.value.visitId, ruleTypeId);
            case 3:
              data = _context3.sent;
              context.root.$set(photoUrls.value, ruleTypeId, data.url);
              _context3.next = 5;
              break;
            case 4:
              _context3.prev = 4;
              _t3 = _context3["catch"](2);
            case 5:
              _context3.prev = 5;
              context.root.$set(photoLoading.value, ruleTypeId, false);
              return _context3.finish(5);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[2, 4, 5, 6]]);
      }));
      return function loadPhoto(_x2) {
        return _ref3.apply(this, arguments);
      };
    }();
    var formatDatetime = function formatDatetime(dt) {
      if (!dt) return '—';
      var d = new Date(dt);
      if (isNaN(d.getTime())) return dt;
      return d.toLocaleString('es-CL', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    };
    var goBack = function goBack() {
      return context.root.$router.go(-1);
    };
    Object(__WEBPACK_IMPORTED_MODULE_3__vue_composition_api__["i" /* onMounted */])(load);
    return {
      loading: loading,
      error: error,
      focusName: focusName,
      visits: visits,
      fields: fields,
      selectedVisit: selectedVisit,
      detail: detail,
      detailLoading: detailLoading,
      photoUrls: photoUrls,
      photoLoading: photoLoading,
      ruleMeta: ruleMeta,
      load: load,
      openVisit: openVisit,
      closePanel: closePanel,
      loadPhoto: loadPhoto,
      formatDatetime: formatDatetime,
      goBack: goBack
    };
  }
});

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_index__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_GridSystems_GridMetricSystemWideOneMetric__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DimensionFilterQuickAccess_DimensionFilterQuickAccess__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_GeneralKeyKpiAnalysis_RetailListSelector__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__expertoRetail_library_requestParameters_generalKeyApiAnalysisRequestParameters__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_GeneralKeyKpiAnalysis_ProductWmHeader__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_GeneralKeyKpiAnalysis_PriceAuditionHeader__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FilterPane_FilterPane__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_api_ExpertoRetail__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atoms_ExpertoRetailLoader__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_GeneralKeyKpiAnalysis_Header__ = __webpack_require__(1094);

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GeneralKeyKpiAnalysis',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_index__["c" /* GeneralUtils */], __WEBPACK_IMPORTED_MODULE_1__mixins_index__["a" /* DimensionUtils */], __WEBPACK_IMPORTED_MODULE_1__mixins_index__["b" /* FilterObjectParameterBuilder */]],
  components: {
    GridMetricSystemWideOneMetric: __WEBPACK_IMPORTED_MODULE_2__components_GridSystems_GridMetricSystemWideOneMetric__["a" /* default */],
    DimensionFilter: __WEBPACK_IMPORTED_MODULE_3__components_DimensionFilterQuickAccess_DimensionFilterQuickAccess__["a" /* default */],
    RetailListSelector: __WEBPACK_IMPORTED_MODULE_4__components_GeneralKeyKpiAnalysis_RetailListSelector__["a" /* default */],
    ProductWmHeader: __WEBPACK_IMPORTED_MODULE_6__components_GeneralKeyKpiAnalysis_ProductWmHeader__["a" /* default */],
    PriceAuditionHeader: __WEBPACK_IMPORTED_MODULE_7__components_GeneralKeyKpiAnalysis_PriceAuditionHeader__["a" /* default */],
    FilterPane: __WEBPACK_IMPORTED_MODULE_8__components_FilterPane_FilterPane__["a" /* default */],
    ExpertoRetailLoader: __WEBPACK_IMPORTED_MODULE_10__atoms_ExpertoRetailLoader__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_11__components_GeneralKeyKpiAnalysis_Header__["a" /* default */]
  },
  data: function data() {
    return {
      isLoading: false,
      headerInfo: '',
      headerTitle: ''
    };
  },
  created: function created() {
    this.$eventHub.$on('grid-metric-wide-one-metric-is-ready', this.initLoad);
    this.$eventHub.$on('index-filter-new-selection', this.atIndexDimFilterChangeLoad);
    this.$eventHub.$on('filter-pane-filter-update', this.initLoad);
    // this.$store.commit('commit_filterPane_resetState')
    this.commitGridCellClass();
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventHub.$off('grid-metric-wide-one-metric-is-ready');
    this.$eventHub.$off('index-filter-new-selection');
    this.$eventHub.$off('filter-pane-filter-update', function () {});
  },
  watch: {
    vuexGlobalFilters: function vuexGlobalFilters() {
      this.buildParameters();
    },
    conditionValue: function conditionValue(val) {
      this.$store.commit('commit_gridMetricSystemWideOneMetric_cellCondition', val);
    },
    gridCellClicked: function gridCellClicked() {
      this.goToClickedCellView();
    },
    vuexSelectedRetail: function vuexSelectedRetail(id) {
      var configParams = this.$store.getters.clientBusinessParameters.find(function (x) {
        return x.retail_id === id;
      });
      this.headerInfo = __WEBPACK_IMPORTED_MODULE_5__expertoRetail_library_requestParameters_generalKeyApiAnalysisRequestParameters__["a" /* reportParameters */][this.vuexSelectedReport].headerInfo(configParams);
      this.commitRetailMetricConditions(id);
      this.atRetailChangeLoad();
    }
  },
  computed: {
    vuexGlobalFilters: function vuexGlobalFilters() {
      return this.$store.state.globalFilters;
    },
    vuexSelectedRetail: function vuexSelectedRetail() {
      return this.$_generalUtils_deepJsonCopy(this.$store.state.generalKeyKpiAnalysis.selectedRetail);
    },
    vuexSelectedReport: function vuexSelectedReport() {
      return this.$_generalUtils_deepJsonCopy(this.$store.state.generalKeyKpiAnalysis.selectedReport);
    },
    headerComponent: function headerComponent() {
      return __WEBPACK_IMPORTED_MODULE_5__expertoRetail_library_requestParameters_generalKeyApiAnalysisRequestParameters__["a" /* reportParameters */][this.vuexSelectedReport].headerComponent;
    },
    gridCellClicked: function gridCellClicked() {
      return this.$_generalUtils_deepJsonCopy(this.$store.state.gridMetricSystemWideOneMetric.cellClicked);
    },
    vuexAvailableHeight: function vuexAvailableHeight() {
      return this.$_generalUtils_deepJsonCopy(this.$store.state.appAvailableHeight - 96);
    },
    retailBusinessParameters: function retailBusinessParameters() {
      return this.$_generalUtils_deepJsonCopy(this.$store.getters.clientBusinessParameters);
    },
    vuexFilterObjectActiveInstance: function vuexFilterObjectActiveInstance() {
      return this.$_generalUtils_deepJsonCopy(this.$store.state.filterRequestObject.activeFilterObjectInstance);
    },
    vuexSelectedIndexDimFilter: function vuexSelectedIndexDimFilter() {
      return this.$_generalUtils_deepJsonCopy(this.$store.state.dimensionFilterQuickAccess.selectedIndexItem);
    },
    vuexClientDimensionFilter: function vuexClientDimensionFilter() {
      var dim = this.$store.state.desktopParameterConfig.dimensionFilter.dimValue;
      return this.$_generalUtils_deepJsonCopy(dim);
    },
    childHeaderTitle: function childHeaderTitle() {
      return __WEBPACK_IMPORTED_MODULE_5__expertoRetail_library_requestParameters_generalKeyApiAnalysisRequestParameters__["a" /* reportParameters */][this.vuexSelectedReport].headerName;
    },
    childExcelParameters: function childExcelParameters() {
      return __WEBPACK_IMPORTED_MODULE_5__expertoRetail_library_requestParameters_generalKeyApiAnalysisRequestParameters__["a" /* reportParameters */][this.vuexSelectedReport].excelParameters;
    }
  },
  methods: {
    goToClickedCellView: function goToClickedCellView() {
      var view = __WEBPACK_IMPORTED_MODULE_5__expertoRetail_library_requestParameters_generalKeyApiAnalysisRequestParameters__["a" /* reportParameters */][this.vuexSelectedReport].atCellClickedGoToView;
      this.$router.push({
        'name': view
      });
    },
    commitGridCellClass: function commitGridCellClass() {
      var cellClass = __WEBPACK_IMPORTED_MODULE_5__expertoRetail_library_requestParameters_generalKeyApiAnalysisRequestParameters__["a" /* reportParameters */][this.vuexSelectedReport].gridCellClass;
      this.$store.commit('commit_gridMetricSystemWideOneMetric_cellCondition', cellClass);
    },
    commitRetailMetricConditions: function commitRetailMetricConditions(id) {
      var selectedRetailConfigParam = this.retailBusinessParameters.find(function (x) {
        return x.retail_id === id;
      });
      this.$store.commit('commit_genKeyKpiAnalysis_selectedRetailBusinessParameters', selectedRetailConfigParam);
    },
    defaultParameterBuild: function defaultParameterBuild(reportParams) {
      var a = this.$_generalUtils_deepJsonCopy(this.vuexFilterObjectActiveInstance);
      if (Object.keys(a).length === 0 || a === undefined || a === null) {
        this.isLoading = false;
        throw new Error('vuexFilterObjectActiveInstance cant be empty');
      }
      var parameters = __WEBPACK_IMPORTED_MODULE_5__expertoRetail_library_requestParameters_generalKeyApiAnalysisRequestParameters__["a" /* reportParameters */][this.vuexSelectedReport].requestParameters[reportParams];
      parameters.parameters = _objectSpread(_objectSpread({}, parameters.parameters), a);
      return parameters;
    },
    setRetailSelectorActiveItem: function setRetailSelectorActiveItem(response) {
      // let a = this.vuexSelectedRetail
      var retailId = response.data[0]['retail_id'];
      this.$store.commit('commit_genKeyKpiAnalysis_selectedRetail', retailId);
      var configParams = this.$store.getters.clientBusinessParameters.find(function (x) {
        return x.retail_id === retailId;
      });
      this.headerInfo = __WEBPACK_IMPORTED_MODULE_5__expertoRetail_library_requestParameters_generalKeyApiAnalysisRequestParameters__["a" /* reportParameters */][this.vuexSelectedReport].headerInfo(configParams);
    },
    setDimensionFilterActiveItem: function setDimensionFilterActiveItem(response) {
      var a = this.vuexSelectedIndexDimFilter;
      var firstItem = response[0]['metadata'];
      if (a === undefined || a === null) {
        this.$store.commit('commit_dimensionFilterQuickAccess_selectedIndexItem', firstItem);
      }
    },
    toggleFilterPane: function toggleFilterPane() {
      this.$root.$emit('bv::toggle::collapse', 'filter-pane-collapse');
    },
    showModal: function showModal() {
      this.$root.$emit('bv::show::modal', 'modal-gkka');
    },
    hideModal: function hideModal() {
      this.$root.$emit('bv::hide::modal', 'modal-gkka');
    },
    openFilterPaneForUser: function openFilterPaneForUser() {
      this.toggleFilterPane();
      this.hideModal();
    },
    initLoad: function initLoad() {
      var _this = this;
      this.isLoading = true;
      this.retailSelectorFetchData().then(this.dimensionFilterFetchData, this.chainError).then(this.gridFetchData)["finally"](function () {
        _this.isLoading = false;
      });
    },
    atRetailChangeLoad: function atRetailChangeLoad() {
      var _this2 = this;
      this.isLoading = true;
      this.dimensionFilterFetchData().then(this.gridFetchData, this.chainError)["finally"](function () {
        _this2.isLoading = false;
      });
    },
    atIndexDimFilterChangeLoad: function atIndexDimFilterChangeLoad() {
      var _this3 = this;
      this.isLoading = true;
      this.gridFetchData()["finally"](function () {
        _this3.isLoading = false;
      });
    },
    chainError: function chainError(mth) {
      this.$store.commit('commit_dimensionFilterQuickAccess_selectedIndexItem', []);
      this.$store.commit('commit_genKeyKpiAnalysis_gridData', {
        'data': []
      });
      this.isLoading = false;
      this.showModal();
    },
    retailSelectorFetchData: function retailSelectorFetchData() {
      var _this4 = this;
      // Default parameter build
      var fn = 'retailSelector';
      var parameters = this.$_generalUtils_deepJsonCopy(this.defaultParameterBuild(fn));
      this.loading = true;
      return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_9__services_api_ExpertoRetail__["d" /* sales */].salesTwoRanges(parameters).then(function (response) {
          var a = response;
          _this4.$store.commit('commit_genKeyKpiAnalysis_retailListSelectorData', a);
          _this4.setRetailSelectorActiveItem(a);
          resolve(true);
        })["catch"](function () {
          _this4.chainError();
          throw new Error('Retail selector');
        });
      });
    },
    dimensionFilterFetchData: function dimensionFilterFetchData() {
      var _this5 = this;
      // Default parameter build
      var fn = 'dimensionFilter';
      var parameters = this.$_generalUtils_deepJsonCopy(this.defaultParameterBuild(fn));

      // Custom parameter
      parameters.parameters.product_dimensions = [this.vuexClientDimensionFilter];
      var a = this.vuexSelectedRetail;
      if (a === undefined || a === null) {
        throw new Error('selected retail not define');
      } else {
        parameters.parameters.store_filters.retail_id = [a];
        return new Promise(function (resolve, reject) {
          __WEBPACK_IMPORTED_MODULE_9__services_api_ExpertoRetail__["d" /* sales */].dimFilter(parameters).then(function (response) {
            _this5.$store.commit('commit_genKeyKpiAnalysis_dimensionFilterData', response);
            _this5.setDimensionFilterActiveItem(response);
            resolve(true);
          })["catch"](function () {
            _this5.chainError('dimfilter data');
            throw new Error();
          })["finally"](function () {});
        });
      }
    },
    gridFetchData: function gridFetchData() {
      var _this6 = this;
      // Default parameter build
      var fn = 'grid';
      var parameters = this.$_generalUtils_deepJsonCopy(this.defaultParameterBuild(fn));

      // Custom parameter
      parameters.parameters.store_filters.retail_id = [this.vuexSelectedRetail];
      var a = this.vuexSelectedIndexDimFilter;
      parameters = this.$_filterObjectParameterBuilder_mergeFilterInstanceWithDimensionFilter(parameters, a);
      return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_9__services_api_ExpertoRetail__["d" /* sales */].pivotSales(parameters, parameters).then(function (response) {
          _this6.$store.commit('commit_genKeyKpiAnalysis_gridData', response);
          _this6.$eventHub.$emit('grid-metric-wide-one-metric-fetch-data');
          _this6.isLoading = false;
          resolve();
        })["catch"](function (e) {
          _this6.chainError();
          throw new Error(e);
        })["finally"](function () {});
      });
    }
  }
});

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ag_grid_vue__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_index__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// *****************************************************************************************************************
//                                                  IMPORTS
// *****************************************************************************************************************
// import {sales} from '../../../services/api/ExpertoRetail'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  // *****************************************************************************************************************
  //                                                 MIXINS
  // *****************************************************************************************************************
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_index__["c" /* GeneralUtils */]],
  // *****************************************************************************************************************
  //                                                  PROPS
  // *****************************************************************************************************************
  props: {
    gridClass: {
      type: String,
      "default": 'ag-theme-balham'
    },
    gridHeight: {
      type: Number,
      "default": 585
    }
  },
  // *****************************************************************************************************************
  //                                                  COMPONENTS
  // *****************************************************************************************************************
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_0_ag_grid_vue__["AgGridVue"]
  },
  data: function data() {
    return {
      loading: false,
      selected: this.selectedRetail,
      retailList: [],
      rowData: {},
      updateStoreView: false,
      loadList: [],
      colDefs: [],
      headerHeight: 130,
      gridOptions: {
        singleClickEdit: true,
        paginationPageSize: 30,
        rowData: [],
        columnDefs: [],
        pagination: true,
        enableColResize: true,
        rowSelection: 'mutiple',
        stopEditingWhenGridLosesFocus: true
      },
      cellCondition: null
    };
  },
  // *****************************************************************************************************************
  //                                                HOOKS
  // *****************************************************************************************************************
  created: function created() {
    this.cellCondition = this.vuexCellCondition;
    this.$eventHub.$on('grid-metric-wide-one-metric-fetch-data', this.setGrid);
    this.$eventHub.$on('grid-metric-wide-one-metric-set-to-no-rows', this.setGridToNoRows);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventHub.$off('grid-metric-wide-one-metric-fetch-data');
    this.$eventHub.$off('grid-metric-wide-one-metric-set-to-no-rows');
  },
  watch: {
    vuexGridData: function vuexGridData() {
      this.setGrid();
    },
    vuexCellCondition: function vuexCellCondition(val) {
      this.setGrid();
    }
  },
  computed: {
    vuexAvailableHeight: function vuexAvailableHeight() {
      return this.$store.state.appAvailableHeight - 40;
    },
    vuexCellCondition: function vuexCellCondition() {
      return this.$store.state.gridMetricSystemWideOneMetric.cellCondition;
    },
    vuexSelectedRetailBusinessParameters: function vuexSelectedRetailBusinessParameters() {
      return this.$store.state.generalKeyKpiAnalysis.selectedRetailBusinessParameters;
    },
    vuexGridData: function vuexGridData() {
      return this.$_generalUtils_deepJsonCopy(this.$store.state.generalKeyKpiAnalysis.gridData);
    }
  },
  // *****************************************************************************************************************
  //                                                METHODS
  // *****************************************************************************************************************
  methods: {
    autoSizeAll: function autoSizeAll() {
      var allColumnIds = [];
      this.gridOptions.columnApi.getAllColumns().forEach(function (column) {
        allColumnIds.push(column.colId);
      });
      this.gridOptions.columnApi.autoSizeColumns(allColumnIds);
    },
    cellClassDecider: function cellClassDecider(params) {
      var x = parseFloat(params.value);
      return this.$store.state.gridMetricSystemWideOneMetric.cellCondition(x, this.vuexSelectedRetailBusinessParameters);
    },
    onCellDoubleClicked: function onCellDoubleClicked(params) {
      var cellClicked = {
        'column': params.colDef,
        'row': params.node.data
      };
      this.commitCellClicked(cellClicked);
      // this.goTo()
    },
    buildColumnColorCondition: function buildColumnColorCondition(columns) {
      var _this = this;
      var colDefs = [];
      columns.forEach(function (i) {
        i.cellStyle = i.isColumn ? _this.cellClassDecider : null;
        i.width = i.isColumn ? 38 : 220;
        i.pinned = i.isColumn ? null : 'left';
        colDefs.push(i);
      });
      return colDefs;
    },
    gridIsReady: function gridIsReady(params) {
      this.$eventHub.$emit('grid-metric-wide-one-metric-is-ready');
    },
    onBtnExportDataAsCsv: function onBtnExportDataAsCsv() {
      this.gridOptions.api.exportDataAsCsv();
    },
    setGrid: function setGrid() {
      var data = this.vuexGridData;
      if (data !== []) {
        this.gridOptions.api.showLoadingOverlay();
        this.gridOptions.api.setRowData(data['data']);
        this.gridOptions.columnDefs = this.buildColumnColorCondition(data['column_definition']);
        this.gridOptions.api.setColumnDefs(this.gridOptions.columnDefs);
        this.gridOptions.api.hideOverlay();
      }
    },
    setGridToNoRows: function setGridToNoRows() {
      this.rowData = [];
      this.setGrid();
    },
    // ********************************************** VUEX COMMITS ***************************************************
    commitCellClicked: function commitCellClicked(cellClicked) {
      this.$store.commit('commit_gridMetricSystemWideOneMetric_cellClicked', cellClicked);
    } // ********************************************** REQUESTS *******************************************************
  }
});

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_index__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__IndexFilter__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__library_requestParameters_generalKeyApiAnalysisRequestParameters__ = __webpack_require__(145);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DimensionFilter',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_index__["a" /* DimensionUtils */], __WEBPACK_IMPORTED_MODULE_0__mixins_index__["c" /* GeneralUtils */]],
  components: {
    IndexFilter: __WEBPACK_IMPORTED_MODULE_1__IndexFilter__["a" /* default */]
  },
  data: function data() {
    return {
      indexDescription: '',
      indexMetric: '',
      indexFirstListItem: {},
      tooltipMsg: ''
    };
  },
  created: function created() {
    this.$eventHub.$on('dimension-filter-fetch-data', this.fetchData);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventHub.$off('dimension-filter-fetch-data');
  },
  watch: {
    vuexSelectedIndexItem: function vuexSelectedIndexItem(obj) {
      this.setTooltip(obj);
    }
  },
  computed: {
    vuexRetailSelected: function vuexRetailSelected() {
      return this.$store.state.generalKeyKpiAnalysis.selectedRetail;
    },
    vuexReportParameters: function vuexReportParameters() {
      return this.$store.state.generalKeyKpiAnalysis.reportParameters;
    },
    vuexSelectedReport: function vuexSelectedReport() {
      return this.$store.state.generalKeyKpiAnalysis.selectedReport;
    },
    vuexSelectedIndexItem: function vuexSelectedIndexItem() {
      return this.$store.state.dimensionFilterQuickAccess.selectedIndexItem;
    },
    gettersDefaultDimensionFilter: function gettersDefaultDimensionFilter() {
      return this.$store.getters.dimensionFilter;
    },
    vuexFilterObjectActiveInstance: function vuexFilterObjectActiveInstance() {
      var filterCopy = this.$store.state.filterRequestObject.activeFilterObjectInstance;
      return this.$_generalUtils_deepJsonCopy(filterCopy);
    },
    dimensionFilterData: function dimensionFilterData() {
      return this.$_generalUtils_deepJsonCopy(this.$store.state.generalKeyKpiAnalysis.dimensionFilterData);
    }
  },
  methods: {
    setTooltip: function setTooltip(obj) {
      this.indexDescription = this.vuexSelectedIndexItem.description;
      this.indexMetric = this.vuexSelectedIndexItem.metric;
      var tooltipObj = {
        description: obj.description,
        metric: this.$_numberNumeralFormat_2(obj.metric)
      };
      this.tooltipMsg = __WEBPACK_IMPORTED_MODULE_2__library_requestParameters_generalKeyApiAnalysisRequestParameters__["a" /* reportParameters */][this.vuexSelectedReport].chipTooltip(tooltipObj);
    }
  }
});

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_index__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__IndexFilterChip__ = __webpack_require__(1067);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// *****************************************************************************************************************
//                                                  IMPORTS
// *****************************************************************************************************************


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IndexFilter',
  // *****************************************************************************************************************
  //                                                 MIXINS
  // *****************************************************************************************************************
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_index__["c" /* GeneralUtils */], __WEBPACK_IMPORTED_MODULE_0__mixins_index__["a" /* DimensionUtils */], __WEBPACK_IMPORTED_MODULE_0__mixins_index__["b" /* FilterObjectParameterBuilder */]],
  // *****************************************************************************************************************
  //                                                  PROPS
  // *****************************************************************************************************************
  props: ['filterList'],
  // *****************************************************************************************************************
  //                                                  COMPONENTS
  // *****************************************************************************************************************
  components: {
    IndexFilterChip: __WEBPACK_IMPORTED_MODULE_1__IndexFilterChip__["a" /* default */]
  },
  data: function data() {
    return {
      dynClass: 'bg-light',
      selectedItem: 0
    };
  },
  // *****************************************************************************************************************
  //                                                HOOKS
  // *****************************************************************************************************************
  created: function created() {},
  watch: {
    filterList: function filterList(item) {
      this.setFirstItem(item);
    }
  },
  computed: {
    vuexSelectedReport: function vuexSelectedReport() {
      return this.$store.state.generalKeyKpiAnalysis.selectedReport;
    },
    vuexFilterObjectActiveInstance: function vuexFilterObjectActiveInstance() {
      return this.$_generalUtils_deepJsonCopy(this.$store.state.filterRequestObject.activeFilterObjectInstance);
    },
    vuexSelectedRetail: function vuexSelectedRetail() {
      return this.$store.state.generalKeyKpiAnalysis.selectedRetail;
    }
  },
  // *****************************************************************************************************************
  //                                                METHODS
  // *****************************************************************************************************************
  methods: {
    // ********************************************** VUEX COMMITS ***************************************************
    setFirstItem: function setFirstItem(item) {
      this.$store.commit('commit_dimensionFilterQuickAccess_selectedIndexItem', item[0]);
    },
    commitSelectedItem: function commitSelectedItem(itemMetaData, item) {
      this.$store.commit('commit_dimensionFilterQuickAccess_selectedIndexItem', item);
      this.$eventHub.$emit('index-filter-new-selection');
      this.$root.$emit('bv::toggle::collapse', 'dim-filter-index-collapse');
    },
    commitRequestParameters: function commitRequestParameters(parameters) {
      this.$store.commit('commit_gridMetricSystemWideOneMetric_requestParams', this.$_generalUtils_deepJsonCopy(parameters));
      this.$eventHub.$emit('grid-metric-wide-one-metric-fetch-data');
    } // ********************************************** REQUESTS *******************************************************
  }
});

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__library_requestParameters_generalKeyApiAnalysisRequestParameters__ = __webpack_require__(145);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// *****************************************************************************************************************
//                                                  IMPORTS
// *****************************************************************************************************************
// import { } from '../../expertoRetail/defaultPayloads/organismStockBreak'
// import { sales } from '../../services/api/ExpertoRetail'
// import { DimensionUtils, GeneralUtils } from '@/mixins/index'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IndexFilterChip',
  // *****************************************************************************************************************
  //                                                 MIXINS
  // *****************************************************************************************************************
  mixins: [],
  // *****************************************************************************************************************
  //                                                  PROPS
  // *****************************************************************************************************************
  props: {
    id: {
      required: true,
      "default": 0
    },
    description: {
      required: true,
      "default": 'some desc'
    },
    metric: {
      required: true,
      "default": 0
    },
    metricName: {
      required: true,
      "default": 'Metric'
    },
    selectedItem: {
      required: false,
      "default": 0
    }
  },
  // *****************************************************************************************************************
  //                                                  COMPONENTS
  // *****************************************************************************************************************
  components: {},
  data: function data() {
    return {
      dynClass: 'bg-primary',
      tooltipMsg: ''
    };
  },
  // *****************************************************************************************************************
  //                                                HOOKS
  // *****************************************************************************************************************
  created: function created() {
    this.setTooltip();
  },
  watch: {},
  computed: {
    vuexSelectedIndexItem: function vuexSelectedIndexItem() {
      return this.$store.state.dimensionFilterQuickAccess.selectedIndexItem['id'];
    },
    vuexSelectedReport: function vuexSelectedReport() {
      return this.$store.state.generalKeyKpiAnalysis.selectedReport;
    }
  },
  // *****************************************************************************************************************
  //                                                METHODS
  // *****************************************************************************************************************
  methods: {
    setTooltip: function setTooltip() {
      var tooltipObj = {
        description: this.description,
        metric: this.$_numberNumeralFormat_2(this.metric)
      };
      this.tooltipMsg = __WEBPACK_IMPORTED_MODULE_0__library_requestParameters_generalKeyApiAnalysisRequestParameters__["a" /* reportParameters */][this.vuexSelectedReport].chipTooltip(tooltipObj);
    } // ********************************************** VUEX COMMITS ***************************************************
    // ********************************************** REQUESTS *******************************************************
  }
});

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_index__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductWmRetailList__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StockBreakRetailList__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PriceAuditionRetailList__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__library_requestParameters_generalKeyApiAnalysisRequestParameters__ = __webpack_require__(145);
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_index__["a" /* DimensionUtils */], __WEBPACK_IMPORTED_MODULE_0__mixins_index__["c" /* GeneralUtils */]],
  components: {
    ProductWmRetailList: __WEBPACK_IMPORTED_MODULE_1__ProductWmRetailList__["a" /* default */],
    StockBreakRetailList: __WEBPACK_IMPORTED_MODULE_2__StockBreakRetailList__["a" /* default */],
    PriceAuditionRetailList: __WEBPACK_IMPORTED_MODULE_3__PriceAuditionRetailList__["a" /* default */]
  },
  data: function data() {
    return {
      activeItem: null,
      filterMerge: {}
    };
  },
  created: function created() {
    this.style = "height: ".concat(this.vuexAvailableHeight, "px; overflow: scroll; overflow-x:hidden;");
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventHub.$off('grid-metric-wide-one-metric-is-ready');
  },
  watch: {},
  computed: {
    vuexAvailableHeight: function vuexAvailableHeight() {
      return this.$store.state.appAvailableHeight - 50;
    },
    vuexSelectedReport: function vuexSelectedReport() {
      return this.$store.state.generalKeyKpiAnalysis.selectedReport;
    },
    retailListComponent: function retailListComponent() {
      return this.$_generalUtils_deepJsonCopy(__WEBPACK_IMPORTED_MODULE_4__library_requestParameters_generalKeyApiAnalysisRequestParameters__["a" /* reportParameters */][this.vuexSelectedReport].retailListComponent);
    },
    vuexRetailListData: function vuexRetailListData() {
      // Todo create mixin to copy and evaluate computed data from vuex
      var a = this.$_generalUtils_deepJsonCopy(this.$store.state.generalKeyKpiAnalysis.retailListSelectorData);
      if (a === undefined || a === null) {
        return [];
      } else {
        return a['data'];
      }
    },
    vuexSelectedRetail: function vuexSelectedRetail() {
      return this.$_generalUtils_deepJsonCopy(this.$store.state.generalKeyKpiAnalysis.selectedRetail);
    }
  }
});

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// *****************************************************************************************************************
//                                                  IMPORTS
// *****************************************************************************************************************
// import { } from '../../expertoRetail/defaultPayloads/organismStockBreak'
// import { sales } from '../../services/api/ExpertoRetail'
// import { DimensionUtils, GeneralUtils } from '@/mixins/index'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  // *****************************************************************************************************************
  //                                                 MIXINS
  // *****************************************************************************************************************
  mixins: [],
  // *****************************************************************************************************************
  //                                                  PROPS
  // *****************************************************************************************************************
  props: ['activeItem', 'listData'],
  // *****************************************************************************************************************
  //                                                  COMPONENTS
  // *****************************************************************************************************************
  components: {},
  data: function data() {
    return {
      activeListItem: 0
    };
  },
  // *****************************************************************************************************************
  //                                                HOOKS
  // *****************************************************************************************************************
  created: function created() {
    this.style = "height: ".concat(this.vuexAvailableHeight, "px; overflow: scroll; overflow-x:hidden;");
  },
  watch: {
    activeItem: function activeItem(id) {
      this.setItem(id);
    }
  },
  computed: {
    vuexAvailableHeight: function vuexAvailableHeight() {
      return this.$store.state.appAvailableHeight - 66;
    }
  },
  // *****************************************************************************************************************
  //                                                METHODS
  // *****************************************************************************************************************
  methods: {
    getIdFilter: function getIdFilter(id) {
      this.activeListItem = id;
      this.$store.commit('commit_genKeyKpiAnalysis_selectedRetail', id);
      // this.$eventHub.$emit('dimension-filter-fetch-data')
    },
    setItem: function setItem(id) {
      this.activeListItem = id;
    }
  }
});

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  props: ['activeItem', 'listData'],
  components: {},
  data: function data() {
    return {
      activeListItem: 0
    };
  },
  created: function created() {
    this.style = "height: ".concat(this.vuexAvailableHeight, "px; overflow: scroll; overflow-x:hidden;");
  },
  watch: {
    activeItem: function activeItem(id) {
      this.setItem(id);
    }
  },
  computed: {
    vuexAvailableHeight: function vuexAvailableHeight() {
      return this.$store.state.appAvailableHeight - 66;
    }
  },
  methods: {
    getIdFilter: function getIdFilter(id) {
      this.activeListItem = id;
      this.$store.commit('commit_genKeyKpiAnalysis_selectedRetail', id);
    },
    setItem: function setItem(id) {
      this.activeListItem = id;
    }
  }
});

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// *****************************************************************************************************************
//                                                  IMPORTS
// *****************************************************************************************************************
// import { } from '../../expertoRetail/defaultPayloads/organismStockBreak'
// import { sales } from '../../services/api/ExpertoRetail'
// import { DimensionUtils, GeneralUtils } from '@/mixins/index'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  // *****************************************************************************************************************
  //                                                 MIXINS
  // *****************************************************************************************************************
  mixins: [],
  // *****************************************************************************************************************
  //                                                  PROPS
  // *****************************************************************************************************************
  props: ['activeItem', 'listData'],
  // *****************************************************************************************************************
  //                                                  COMPONENTS
  // *****************************************************************************************************************
  components: {},
  data: function data() {
    return {
      activeListItem: 0
    };
  },
  // *****************************************************************************************************************
  //                                                HOOKS
  // *****************************************************************************************************************
  created: function created() {
    this.style = "height: ".concat(this.vuexAvailableHeight, "px; overflow: scroll; overflow-x:hidden;");
  },
  watch: {
    activeItem: function activeItem(id) {
      this.setItem(id);
    }
  },
  computed: {
    vuexAvailableHeight: function vuexAvailableHeight() {
      return this.$store.state.appAvailableHeight - 66;
    }
  },
  // *****************************************************************************************************************
  //                                                METHODS
  // *****************************************************************************************************************
  methods: {
    getIdFilter: function getIdFilter(id) {
      this.activeListItem = id;
      this.$store.commit('commit_genKeyKpiAnalysis_selectedRetail', id);
      // this.$eventHub.$emit('dimension-filter-fetch-data')
    },
    setItem: function setItem(id) {
      this.activeListItem = id;
    }
  }
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// *****************************************************************************************************************
//                                                  IMPORTS
// *****************************************************************************************************************
/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  // *****************************************************************************************************************
  //                                                 MIXINS
  // *****************************************************************************************************************
  mixins: [],
  // *****************************************************************************************************************
  //                                                  PROPS
  // *****************************************************************************************************************
  props: ['headerInfo'],
  // *****************************************************************************************************************
  //                                                  COMPONENTS
  // *****************************************************************************************************************
  components: {},
  data: function data() {
    return {
      conditionValue: 0
    };
  },
  // *****************************************************************************************************************
  //                                                HOOKS
  // *****************************************************************************************************************
  created: function created() {},
  watch: {},
  computed: {},
  // *****************************************************************************************************************
  //                                                METHODS
  // *****************************************************************************************************************
  methods: {
    // ********************************************** VUEX COMMITS ***************************************************
    // ********************************************** REQUESTS *******************************************************
  }
});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

// *****************************************************************************************************************
//                                                  IMPORTS
// *****************************************************************************************************************
/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  // *****************************************************************************************************************
  //                                                 MIXINS
  // *****************************************************************************************************************
  mixins: [],
  // *****************************************************************************************************************
  //                                                  PROPS
  // *****************************************************************************************************************
  props: ['headerInfo'],
  // *****************************************************************************************************************
  //                                                  COMPONENTS
  // *****************************************************************************************************************
  components: {},
  data: function data() {
    return {
      conditionValue: 0
    };
  },
  // *****************************************************************************************************************
  //                                                HOOKS
  // *****************************************************************************************************************
  created: function created() {},
  watch: {},
  computed: {
    vuexReportParameters: function vuexReportParameters() {
      return this.$store.state.generalKeyKpiAnalysis.reportParameters;
    },
    vuexSelectedReport: function vuexSelectedReport() {
      return this.$store.state.generalKeyKpiAnalysis.selectedReport;
    }
  },
  // *****************************************************************************************************************
  //                                                METHODS
  // *****************************************************************************************************************
  methods: {
    // ********************************************** VUEX COMMITS ***************************************************
    // ********************************************** REQUESTS *******************************************************
  }
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_index__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FilterSelectorLogic__ = __webpack_require__(1090);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// *****************************************************************************************************************
//                                                  IMPORTS
// *****************************************************************************************************************


/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  // *****************************************************************************************************************
  //                                                 MIXINS
  // *****************************************************************************************************************
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_index__["b" /* FilterObjectParameterBuilder */], __WEBPACK_IMPORTED_MODULE_0__mixins_index__["c" /* GeneralUtils */]],
  // *****************************************************************************************************************
  //                                                  PROPS
  // *****************************************************************************************************************
  props: {
    height: {
      "default": 100
    }
  },
  // *****************************************************************************************************************
  //                                                  COMPONENTS
  // *****************************************************************************************************************
  components: {
    FilterSelectorLogic: __WEBPACK_IMPORTED_MODULE_1__FilterSelectorLogic__["a" /* default */]
  },
  data: function data() {
    return {
      style: null
    };
  },
  // *****************************************************************************************************************
  //                                                HOOKS
  // *****************************************************************************************************************
  created: function created() {},
  mounted: function mounted() {
    var val = this.height;
    this.style = "overflow: auto; height: ".concat(val, "px");
  },
  computed: {
    originalProductFilters: function originalProductFilters() {
      return this.$_generalUtils_deepJsonCopy(this.$store.getters.productCategoryFilters);
    },
    originalStoreFilters: function originalStoreFilters() {
      return this.$_generalUtils_deepJsonCopy(this.$store.getters.storeFilters);
    }
  },
  // *****************************************************************************************************************
  //                                                METHODS
  // *****************************************************************************************************************
  methods: {
    emitReloadData: function emitReloadData() {
      this.$eventHub.$emit('filter-pane-filter-update');
      this.$emit('filter-pane-updated');
    },
    resetFilters: function resetFilters() {
      this.$refs.filterSelectorLogicP.reset();
      this.$refs.filterSelectorLogicS.reset();
    }
  }
});

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_index__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// *****************************************************************************************************************
//                                                  IMPORTS
// *****************************************************************************************************************


/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  // *****************************************************************************************************************
  //                                                 MIXINS
  // *****************************************************************************************************************
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_index__["b" /* FilterObjectParameterBuilder */], __WEBPACK_IMPORTED_MODULE_0__mixins_index__["c" /* GeneralUtils */]],
  // *****************************************************************************************************************
  //                                                  PROPS
  // *****************************************************************************************************************
  props: {
    height: {
      "default": 100
    },
    filterType: {},
    filterTypeName: {},
    filterData: {}
  },
  // *****************************************************************************************************************
  //                                                  COMPONENTS
  // *****************************************************************************************************************
  components: {
    MultiSelect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a
  },
  data: function data() {
    return {
      // productCategoryFilters: {},
      filtersRenderObject: [],
      style: null
    };
  },
  // *****************************************************************************************************************
  //                                                HOOKS
  // *****************************************************************************************************************
  created: function created() {
    this.setInitRenderObject();
  },
  watch: {},
  computed: {
    vuexFilterObjectActiveInstance: function vuexFilterObjectActiveInstance() {
      return this.$_generalUtils_deepJsonCopy(this.$store.state.filterRequestObject.activeFilterObjectInstance);
    },
    originalFilters: function originalFilters() {
      return this.$_generalUtils_deepJsonCopy(this.filterData);
    },
    vuexFilterRenderObject: function vuexFilterRenderObject() {
      return this.$store.state.filterRequestObject.selectedOptions;
    },
    vuexIsSelectedFilters: function vuexIsSelectedFilters() {
      return this.$store.state.filterRequestObject.isSelectedFilters;
    }
  },
  // *****************************************************************************************************************
  //                                                METHODS
  // *****************************************************************************************************************
  methods: {
    setInitRenderObject: function setInitRenderObject() {
      var vuexUpdatedFilterRenderObject = this.$_generalUtils_deepJsonCopy(this.vuexFilterRenderObject[this.filterType]);
      var a = this.$_generalUtils_deepJsonCopy(this.vuexIsSelectedFilters['store_filters']);
      var b = this.$_generalUtils_deepJsonCopy(this.vuexIsSelectedFilters['product_filters']);
      // let keepFilterCondition = this.$_generalUtils_deepJsonCopy(this.vuexIsSelectedFilters[this.filterType])
      // if keep condition is true, filters from previous views are keeped. Otherwise, the filter vuex store
      // will be reset and set the original filter settings
      if (a || b) {
        if (vuexUpdatedFilterRenderObject.length !== 0) {
          this.filtersRenderObject = vuexUpdatedFilterRenderObject;
          this.buildFilterObject();
        } else {
          this.reset();
        }
      } else {
        this.reset();
      }
    },
    reset: function reset() {
      // this.$store.commit('commit_filterPane_resetState')
      var vuexOriginalFilterRenderObject = this.$_generalUtils_deepJsonCopy(this.originalFilters);
      this.filtersRenderObject = this.$_filterObjectParameterBuilder_setInitRenderObject(vuexOriginalFilterRenderObject);
      this.buildFilterObject();
      this.setIsSelectedFilters();
      this.commitSelectedOptions();
    },
    emitReloadData: function emitReloadData() {
      this.$eventHub.$emit('filter-pane-filter-update');
    },
    buildFilterObject: function buildFilterObject() {
      // Will build up the filter object given the selected options from selectors in UI
      var vuexFilterObjectActiveInstanceCopy = this.$_generalUtils_deepJsonCopy(this.vuexFilterObjectActiveInstance);
      var filter = this.$_filterObjectParameterBuilder_buildFilterObject(this.filtersRenderObject, this.filterType, vuexFilterObjectActiveInstanceCopy);
      this.$store.commit('filterRequestObject/commit_filterRequestObject_activeFilterObjectInstance', filter);
    },
    dropdownClose: function dropdownClose() {
      this.buildFilterObject();
      this.setIsSelectedFilters();
    },
    setOptions: function setOptions(selection) {
      // Set options for selector with child levels.
      var originalFilters = this.$_generalUtils_deepJsonCopy(this.originalFilters);
      var renderObject = this.$_generalUtils_deepJsonCopy(this.filtersRenderObject);
      var b = this.$_filterObjectParameterBuilder_setChildOptions(selection, renderObject, originalFilters);
      this.filtersRenderObject = b;
      this.commitSelectedOptions();
      this.setIsSelectedFilters();
    },
    removeChildOptions: function removeChildOptions(selection) {
      // Clean Selectors for single and nested selectors Parent -> child:
      var cleanObjects = this.$_filterObjectParameterBuilder_clearSelectorsGivenRemovedOption(selection, this.$_generalUtils_deepJsonCopy(this.originalFilters), this.$_generalUtils_deepJsonCopy(this.filtersRenderObject));
      this.filtersRenderObject = cleanObjects;
      this.buildFilterObject();
      this.setIsSelectedFilters();
    },
    setIsSelectedFilters: function setIsSelectedFilters() {
      var a = this.$_filterObjectParameterBuilder_checkIfObjectContainsSelections(this.filtersRenderObject);
      var payload = {
        'filterType': this.filterType,
        'value': a
      };
      if (a) {
        this.$store.commit('filterRequestObject/commit_filterRequestObject_isSelectedFilters', payload);
      } else {
        this.$store.commit('filterRequestObject/commit_filterRequestObject_isSelectedFilters', payload);
      }
    },
    commitSelectedOptions: function commitSelectedOptions() {
      var payload = {
        'filtersRenderObject': this.filtersRenderObject,
        'filterType': this.filterType
      };
      this.$store.commit('filterRequestObject/commit_filterRequestObject_selectedOptions', payload);
    }
  }
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExcelDownload_ServerDataToExcel__ = __webpack_require__(1096);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// *****************************************************************************************************************
//                                                  IMPORTS
// *****************************************************************************************************************

/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  // *****************************************************************************************************************
  //                                                 MIXINS
  // *****************************************************************************************************************
  mixins: [],
  // *****************************************************************************************************************
  //                                                  PROPS
  // *****************************************************************************************************************
  props: {
    headerTitle: {
      "default": 'Sin Título'
    },
    headerInfo: {
      "default": 'Sin Info'
    },
    excelParameters: {
      "default": function _default() {}
    }
  },
  // *****************************************************************************************************************
  //                                                  COMPONENTS
  // *****************************************************************************************************************
  components: {
    ServerDataToExcel: __WEBPACK_IMPORTED_MODULE_0__ExcelDownload_ServerDataToExcel__["a" /* default */]
  },
  data: function data() {
    return {};
  },
  // *****************************************************************************************************************
  //                                                HOOKS
  // *****************************************************************************************************************
  created: function created() {},
  watch: {},
  computed: {
    propsExcelParameters: function propsExcelParameters() {
      return this.excelParameters;
    },
    propsHeaderTitle: function propsHeaderTitle() {
      return this.headerTitle;
    },
    propsHeaderInfo: function propsHeaderInfo() {
      return this.headerInfo;
    }
  },
  // *****************************************************************************************************************
  //                                                METHODS
  // *****************************************************************************************************************
  methods: {}
});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_ExpertoRetail__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_index__ = __webpack_require__(48);
//
//
//
//
//
//
//

// *****************************************************************************************************************
//                                                  IMPORTS
// *****************************************************************************************************************
// import { } from '../../expertoRetail/defaultPayloads/organismStockBreak'


// import { DimensionUtils, GeneralUtils } from '@/mixins/index'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  // *****************************************************************************************************************
  //                                                 MIXINS
  // *****************************************************************************************************************
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_index__["c" /* GeneralUtils */], __WEBPACK_IMPORTED_MODULE_1__mixins_index__["a" /* DimensionUtils */]],
  // *****************************************************************************************************************
  //                                                  PROPS
  // *****************************************************************************************************************
  props: ['parameters'],
  // *****************************************************************************************************************
  //                                                  COMPONENTS
  // *****************************************************************************************************************
  components: {},
  data: function data() {
    return {};
  },
  // *****************************************************************************************************************
  //                                                HOOKS
  // *****************************************************************************************************************
  created: function created() {},
  watch: {},
  computed: {
    propParameters: function propParameters() {
      return this.parameters;
    }
  },
  // *****************************************************************************************************************
  //                                                METHODS
  // *****************************************************************************************************************
  methods: {
    // ********************************************** VUEX COMMITS ***************************************************
    // ********************************************** REQUESTS *******************************************************
    downloadFile: function downloadFile() {
      var _this = this;
      var parameters = this.propParameters;
      this.loading = true;
      return new Promise(function (resolve, reject) {
        var vm = _this;
        __WEBPACK_IMPORTED_MODULE_0__services_api_ExpertoRetail__["a" /* general */].downloadGridToXlsx(parameters).then(function (response) {
          resolve();
        })["catch"](function (error) {
          reject(error);
        })["finally"](function () {
          vm.loading = false;
        });
      });
    }
  }
});

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TheExpertoRetailLoader',
  props: {
    loading: {
      type: Boolean,
      "default": true
    },
    color: {
      type: String,
      "default": '#290A99'
    },
    size: {
      type: String,
      "default": '12px'
    },
    margin: {
      type: String,
      "default": '2px'
    },
    radius: {
      type: String,
      "default": '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        width: this.size,
        height: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-pulseStretchDelay',
        animationDuration: '0.75s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
        animationFillMode: 'both'
      },
      spinnerDelay1: {
        animationDelay: '0.12s'
      },
      spinnerDelay2: {
        animationDelay: '0.24s'
      },
      spinnerDelay3: {
        animationDelay: '0.36s'
      }
    };
  }
});

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page404'
});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page404'
});

/***/ }),
/* 660 */,
/* 661 */,
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PulseLoader',
  props: {
    loading: {
      type: Boolean,
      "default": true
    },
    color: {
      type: String,
      "default": '#5dc596'
    },
    size: {
      type: String,
      "default": '15px'
    },
    margin: {
      type: String,
      "default": '2px'
    },
    radius: {
      type: String,
      "default": '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        width: this.size,
        height: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-pulseStretchDelay',
        animationDuration: '0.75s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
        animationFillMode: 'both'
      },
      spinnerDelay1: {
        animationDelay: '0.12s'
      },
      spinnerDelay2: {
        animationDelay: '0.24s'
      },
      spinnerDelay3: {
        animationDelay: '0.36s'
      }
    };
  }
});

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_numeral__);

__WEBPACK_IMPORTED_MODULE_0_numeral___default.a.register('locale', 'ch', {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  abbreviations: {
    thousand: 'K',
    million: 'M',
    billion: 'MM',
    trillion: 'T'
  },
  ordinal: function ordinal(number) {
    return number === 1 ? 'er' : 'ème';
  },
  currency: {
    symbol: '$'
  }
});
__WEBPACK_IMPORTED_MODULE_0_numeral___default.a.register('locale', 'pe', {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  abbreviations: {
    thousand: 'K',
    million: 'M',
    billion: 'MM',
    trillion: 'T'
  },
  ordinal: function ordinal(number) {
    return number === 1 ? 'er' : 'ème';
  },
  currency: {
    symbol: 'S/'
  }
});
__WEBPACK_IMPORTED_MODULE_0_numeral___default.a.register('locale', 'mx', {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  abbreviations: {
    thousand: 'K',
    million: 'M',
    billion: 'MM',
    trillion: 'T'
  },
  ordinal: function ordinal(number) {
    return number === 1 ? 'er' : 'ème';
  },
  currency: {
    symbol: '$'
  }
});
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_numeral___default.a);

/***/ }),
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_sales_analysis_store_Index__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_sales_analysis_store_DateGranularity__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_Filters__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_sales_analysis_Services__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_shared_utils_NamespaceHelper__ = __webpack_require__(31);


var _actions, _getters;

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var STORE_BREADCRUMB_MODULE_NAME = 'storeBreadCrumb';
var PRODUCT_BREADCRUMB_MODULE_NAME = 'productBreadCrumb';
var NAMESPACE = 'salesAnalysis/wideGrid/';
var NAMESPACE_STORE_BREADCRUMB = NAMESPACE + STORE_BREADCRUMB_MODULE_NAME + '/';
var NAMESPACE_PRODUCT_BREADCRUMB = NAMESPACE + PRODUCT_BREADCRUMB_MODULE_NAME + '/';
var _types = {
  getters: {
    STORE_DIMENSIONS: 'GETTER_STORE_DIMENSIONS',
    PRODUCT_DIMENSIONS: 'GETTER_PRODUCT_DIMENSIONS',
    STORE_DEFAULT_DIMENSION: 'GETTER_STORE_DEFAULT_DIMENSION',
    PRODUCT_DEFAULT_DIMENSION: 'GETTER_PRODUCT_DEFAULT_DIMENSION',
    PIVOT_PRODUCT_DIMENSIONS: 'GETTER_PIVOT_PRODUCT_DIMENSIONS',
    PIVOT_STORE_DIMENSIONS: 'GETTER_PIVOT_STORE_DIMENSIONS',
    HAS_SELECTED_FILTERS: 'GETTER_HAS_SELECTED_FILTERS',
    PRODUCT_DIMENSION_TO_FILTER: 'GETTER_PRODUCT_DIMENSION_TO_FILTER',
    STORE_DIMENSION_TO_FILTER: 'GETTER_STORE_DIMENSION_TO_FILTER',
    PIVOTED_PRODUCT_FILTER_DIMENSION_IDS: 'GETTER_PIVOTED_PRODUCT_FILTER_DIMENSION_IDS',
    PIVOTED_STORE_FILTER_DIMENSION_IDS: 'GETTER_PIVOTED_STORE_FILTER_DIMENSION_IDS',
    BASE_STORE_DIMENSION: 'GETTER_BASE_STORE_DIMENSION',
    BASE_PRODUCT_DIMENSION: 'GETTER_BASE_PRODUCT_DIMENSION',
    METRIC_OPTION: 'GETTER_METRIC_OPTION',
    METRIC_OPTIONS: 'GETTER_METRIC_OPTIONS',
    LAST_PRODUCT_BREADCRUMB_ITEM: 'LAST_PRODUCT_BREADCRUMB_ITEM',
    LAST_STORE_BREADCRUMB_ITEM: 'LAST_STORE_BREADCRUMB_ITEM',
    CREATE_FILTER_OBJECT: 'CREATE_FILTER_OBJECT'
  },
  actions: {
    INIT: 'INIT',
    INIT_FILTERS: 'INIT_FILTERS',
    INIT_DIMENSIONS: 'INIT_DIMENSIONS',
    INIT_PRODUCT_DIMENSION: 'INIT_PRODUCT_DIMENSION',
    INIT_STORE_DIMENSION: 'INIT_STORE_DIMENSION',
    INIT_PRODUCT_BREADCRUMB: 'INIT_PRODUCT_BREADCRUMB',
    INIT_STORE_BREADCRUMB: 'INIT_STORE_BREADCRUMB',
    INIT_WIDE_GRID: 'INIT_WIDE_GRID',
    CHANGE_BASE_PRODUCT_DIMENSION: 'CHANGE_BASE_PRODUCT_DIMENSION',
    CHANGE_BASE_STORE_DIMENSION: 'CHANGE_BASE_STORE_DIMENSION',
    PIVOT_PRODUCT: 'PIVOT_PRODUCT',
    PIVOT_STORE: 'PIVOT_STORE',
    APPLY_FILTERS: 'APPLY_FILTERS',
    POP_UNTIL_STORE_BREADCRUMB: 'POP_UNTIL_STORE_BREADCRUMB',
    POP_UNTIL_PRODUCT_BREADCRUMB: 'POP_UNTIL_PRODUCT_BREADCRUMB',
    DOWNLOAD_EXCEL: 'DOWNLOAD_EXCEL',
    PUSH_BREADCRUMB_PRODUCT_ITEM: 'PUSH_BREADCRUMB_PRODUCT_ITEM',
    PUSH_BREADCRUMB_STORE_ITEM: 'PUSH_BREADCRUMB_STORE_ITEM',
    FETCH_WIDE_GRID: 'FETCH_WIDE_GRID',
    RESET: 'RESET',
    REMOVE_PIVOTED_FILTERS: 'REMOVE_PIVOTED_FILTERS',
    CHANGE_METRIC_OPTION: 'CHANGE_METRIC_OPTION',
    SET_INIT_DATA_DATE_GRANULARITY: 'SET_INIT_DATA_DATE_GRANULARITY'
  },
  mutations: {
    SET_METRIC_OPTIONS: 'SET_METRIC_OPTIONS',
    SET_METRIC_OPTION_KEY: 'SET_METRIC_OPTION_KEY',
    SET_GRID: 'SET_GRID'
  }
};
var Types = Object(__WEBPACK_IMPORTED_MODULE_8__app_shared_utils_NamespaceHelper__["a" /* addNamespace */])(NAMESPACE, _types);
var WideGrid = {
  namespaced: true,
  state: {
    grid: null,
    metricOptions: null,
    metricOptionKey: null
  },
  mutations: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.mutations.SET_METRIC_OPTIONS, function (state, metricOptions) {
    state.metricOptions = metricOptions;
  }), _types.mutations.SET_METRIC_OPTION_KEY, function (state, metricOptionKey) {
    state.metricOptionKey = metricOptionKey;
  }), _types.mutations.SET_GRID, function (state, wideGrid) {
    state.grid = wideGrid;
  }),
  actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_actions, _types.actions.INIT, function (_ref, _ref2) {
    var commit = _ref.commit,
      dispatch = _ref.dispatch;
    var defaultParameters = _ref2.defaultParameters,
      metricOptions = _ref2.metricOptions,
      defaultMetric = _ref2.defaultMetric;
    commit(_types.mutations.SET_METRIC_OPTIONS, metricOptions);
    commit(_types.mutations.SET_METRIC_OPTION_KEY, defaultMetric);
    dispatch(_types.actions.INIT_FILTERS);
    dispatch(_types.actions.INIT_DIMENSIONS);
    dispatch(_types.actions.INIT_WIDE_GRID);
  }), _types.actions.INIT_FILTERS, function (_ref3) {
    var dispatch = _ref3.dispatch,
      rootState = _ref3.rootState;
    var storeFilters = _objectSpread({}, rootState.salesAnalysis.filters.selectedStoreFilters);
    var productFilters = _objectSpread({}, rootState.salesAnalysis.filters.selectedProductFilters);
    dispatch(NAMESPACE + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_Filters__["a" /* Types */].actions.SET_SELECTED_FILTERS, {
      storeFilters: storeFilters,
      productFilters: productFilters
    }, {
      root: true
    });
  }), _types.actions.INIT_DIMENSIONS, function (_ref4) {
    var dispatch = _ref4.dispatch;
    dispatch(_types.actions.INIT_PRODUCT_DIMENSION);
    dispatch(_types.actions.INIT_STORE_DIMENSION);
  }), _types.actions.INIT_PRODUCT_DIMENSION, function (_ref5) {
    var getters = _ref5.getters,
      dispatch = _ref5.dispatch;
    var productDefaultDimension = getters[_types.getters.PRODUCT_DEFAULT_DIMENSION];
    dispatch(_types.actions.INIT_PRODUCT_BREADCRUMB, productDefaultDimension);
  }), _types.actions.INIT_STORE_DIMENSION, function (_ref6) {
    var getters = _ref6.getters,
      dispatch = _ref6.dispatch;
    var storeDefaultDimension = getters[_types.getters.STORE_DEFAULT_DIMENSION];
    dispatch(_types.actions.INIT_STORE_BREADCRUMB, storeDefaultDimension);
  }), _types.actions.CHANGE_BASE_PRODUCT_DIMENSION, function (_ref7, dimensionId) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
      var dispatch, rootGetters, productDimension, storeDimension, pivotedProductFilters;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch = _ref7.dispatch, rootGetters = _ref7.rootGetters;
            productDimension = rootGetters[__WEBPACK_IMPORTED_MODULE_3__app_sales_analysis_store_Index__["a" /* Types */].getters.DIMENSION_BY_ID](dimensionId);
            storeDimension = rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_TO_FILTER];
            pivotedProductFilters = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.FILTERS];
            dispatch(_types.actions.REMOVE_PIVOTED_FILTERS, pivotedProductFilters);
            _context.next = 1;
            return dispatch(_types.actions.FETCH_WIDE_GRID, {
              productDimension: productDimension,
              storeDimension: storeDimension
            });
          case 1:
            dispatch(_types.actions.INIT_PRODUCT_BREADCRUMB, productDimension);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }), _types.actions.CHANGE_BASE_STORE_DIMENSION, function (_ref8, dimensionId) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
      var dispatch, rootGetters, storeDimension, productDimension, pivotedStoreFilters;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dispatch = _ref8.dispatch, rootGetters = _ref8.rootGetters;
            storeDimension = rootGetters[__WEBPACK_IMPORTED_MODULE_3__app_sales_analysis_store_Index__["a" /* Types */].getters.DIMENSION_BY_ID](dimensionId);
            productDimension = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_TO_FILTER];
            pivotedStoreFilters = rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.FILTERS];
            dispatch(_types.actions.REMOVE_PIVOTED_FILTERS, pivotedStoreFilters);
            _context2.next = 1;
            return dispatch(_types.actions.FETCH_WIDE_GRID, {
              productDimension: productDimension,
              storeDimension: storeDimension
            });
          case 1:
            dispatch(_types.actions.INIT_STORE_BREADCRUMB, storeDimension);
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }), _types.actions.INIT_PRODUCT_BREADCRUMB, function (_ref9, dimension) {
    var commit = _ref9.commit,
      dispatch = _ref9.dispatch;
    commit(NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].mutations.RESET, null, {
      root: true
    });
    dispatch(_types.actions.PUSH_BREADCRUMB_PRODUCT_ITEM, {
      dimension: dimension,
      filter: undefined,
      breadCrumbItemText: dimension.value
    });
  }), _types.actions.INIT_STORE_BREADCRUMB, function (_ref0, dimension) {
    var commit = _ref0.commit,
      dispatch = _ref0.dispatch;
    commit(NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].mutations.RESET, null, {
      root: true
    });
    dispatch(_types.actions.PUSH_BREADCRUMB_STORE_ITEM, {
      dimension: dimension,
      filter: undefined,
      breadCrumbItemText: dimension.value
    });
  }), _types.actions.PUSH_BREADCRUMB_PRODUCT_ITEM, function (_ref1, _ref10) {
    var commit = _ref1.commit;
    var dimension = _ref10.dimension,
      filter = _ref10.filter,
      breadCrumbItemText = _ref10.breadCrumbItemText;
    commit(NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].mutations.PUSH_ITEM, {
      dimension: dimension,
      filter: filter,
      text: breadCrumbItemText
    }, {
      root: true
    });
    if (filter) commit(__WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_Filters__["a" /* Types */].mutations.ADD_SELECTED_FILTER, filter);
  }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_actions, _types.actions.PUSH_BREADCRUMB_STORE_ITEM, function (_ref11, _ref12) {
    var commit = _ref11.commit;
    var dimension = _ref12.dimension,
      filter = _ref12.filter,
      breadCrumbItemText = _ref12.breadCrumbItemText;
    commit(NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].mutations.PUSH_ITEM, {
      dimension: dimension,
      filter: filter,
      text: breadCrumbItemText
    }, {
      root: true
    });
    if (filter) commit(__WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_Filters__["a" /* Types */].mutations.ADD_SELECTED_FILTER, filter);
  }), _types.actions.INIT_WIDE_GRID, function (_ref13) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3() {
      var dispatch, rootGetters, productDimension, storeDimension;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            dispatch = _ref13.dispatch, rootGetters = _ref13.rootGetters;
            productDimension = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_TO_FILTER];
            storeDimension = rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_TO_FILTER];
            _context3.next = 1;
            return dispatch(_types.actions.FETCH_WIDE_GRID, {
              productDimension: productDimension,
              storeDimension: storeDimension
            });
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }), _types.actions.FETCH_WIDE_GRID, function (_ref14, _ref15) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee4() {
      var commit, state, rootState, getters, productDimension, storeDimension, productStrategyFilter, storeStrategyFilter, filters, metrics, factTableName, wideGrid;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            commit = _ref14.commit, state = _ref14.state, rootState = _ref14.rootState, getters = _ref14.getters;
            productDimension = _ref15.productDimension, storeDimension = _ref15.storeDimension, productStrategyFilter = _ref15.productStrategyFilter, storeStrategyFilter = _ref15.storeStrategyFilter;
            filters = state.filters;
            metrics = getters[_types.getters.METRIC_OPTION];
            factTableName = rootState.salesAnalysis.accumulatedSalesDateOption.fact_name;
            commit(_types.mutations.SET_GRID, null);
            _context4.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_7__app_sales_analysis_Services__["g" /* getWideGrid */])({
              metrics: metrics,
              productDimension: productDimension,
              storeDimension: storeDimension,
              factTableName: factTableName,
              productStrategyFilter: productStrategyFilter,
              storeStrategyFilter: storeStrategyFilter,
              filters: filters
            });
          case 1:
            wideGrid = _context4.sent;
            commit(_types.mutations.SET_GRID, wideGrid);
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  }), _types.actions.PIVOT_PRODUCT, function (_ref16, _ref17) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee5() {
      var dispatch, rootGetters, pivotedDimensionId, filter, pivotedDimensionCellValue, productDimension, breadCrumbItemText, storeDimension, productStrategyFilter;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            dispatch = _ref16.dispatch, rootGetters = _ref16.rootGetters;
            pivotedDimensionId = _ref17.pivotedDimensionId, filter = _ref17.filter, pivotedDimensionCellValue = _ref17.pivotedDimensionCellValue;
            productDimension = rootGetters[__WEBPACK_IMPORTED_MODULE_3__app_sales_analysis_store_Index__["a" /* Types */].getters.DIMENSION_BY_ID](pivotedDimensionId);
            breadCrumbItemText = "".concat(productDimension.value, " en ").concat(pivotedDimensionCellValue);
            storeDimension = rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_TO_FILTER];
            productStrategyFilter = filter;
            _context5.next = 1;
            return dispatch(_types.actions.FETCH_WIDE_GRID, {
              productDimension: productDimension,
              productStrategyFilter: productStrategyFilter,
              storeDimension: storeDimension
            });
          case 1:
            dispatch(_types.actions.PUSH_BREADCRUMB_PRODUCT_ITEM, {
              dimension: productDimension,
              filter: filter,
              breadCrumbItemText: breadCrumbItemText
            });
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  }), _types.actions.PIVOT_STORE, function (_ref18, _ref19) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee6() {
      var dispatch, rootGetters, pivotedDimensionId, filter, pivotedDimensionCellValue, storeDimension, breadCrumbItemText, productDimension, storeStrategyFilter;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            dispatch = _ref18.dispatch, rootGetters = _ref18.rootGetters;
            pivotedDimensionId = _ref19.pivotedDimensionId, filter = _ref19.filter, pivotedDimensionCellValue = _ref19.pivotedDimensionCellValue;
            storeDimension = rootGetters[__WEBPACK_IMPORTED_MODULE_3__app_sales_analysis_store_Index__["a" /* Types */].getters.DIMENSION_BY_ID](pivotedDimensionId);
            breadCrumbItemText = "".concat(storeDimension.value, " en ").concat(pivotedDimensionCellValue);
            productDimension = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_TO_FILTER];
            storeStrategyFilter = filter;
            _context6.next = 1;
            return dispatch(_types.actions.FETCH_WIDE_GRID, {
              productDimension: productDimension,
              storeStrategyFilter: storeStrategyFilter,
              storeDimension: storeDimension
            });
          case 1:
            dispatch(_types.actions.PUSH_BREADCRUMB_STORE_ITEM, {
              dimension: storeDimension,
              filter: filter,
              breadCrumbItemText: breadCrumbItemText
            });
          case 2:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  }), _types.actions.APPLY_FILTERS, function (_ref20, _ref21) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee7() {
      var dispatch, rootGetters, storeFilters, productFilters, _rootGetters, productDimension, productStrategyFilter, _rootGetters2, storeDimension, storeStrategyFilter;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            dispatch = _ref20.dispatch, rootGetters = _ref20.rootGetters;
            storeFilters = _ref21.storeFilters, productFilters = _ref21.productFilters;
            _rootGetters = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM], productDimension = _rootGetters.dimension, productStrategyFilter = _rootGetters.filter;
            _rootGetters2 = rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM], storeDimension = _rootGetters2.dimension, storeStrategyFilter = _rootGetters2.filter;
            dispatch(NAMESPACE + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_Filters__["a" /* Types */].actions.SET_SELECTED_FILTERS, {
              storeFilters: storeFilters,
              productFilters: productFilters
            }, {
              root: true
            });
            _context7.next = 1;
            return dispatch(_types.actions.FETCH_WIDE_GRID, {
              productDimension: productDimension,
              storeDimension: storeDimension,
              productStrategyFilter: productStrategyFilter,
              storeStrategyFilter: storeStrategyFilter
            });
          case 1:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }))();
  }), _types.actions.POP_UNTIL_STORE_BREADCRUMB, function (_ref22, breadCrumbItem) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee8() {
      var commit, dispatch, rootGetters, lastBreadCrumbStoreItem, storeDimension, storeStrategyFilter, _rootGetters3, productDimension, productStrategyFilter;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            commit = _ref22.commit, dispatch = _ref22.dispatch, rootGetters = _ref22.rootGetters;
            if (!(rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM] === breadCrumbItem)) {
              _context8.next = 1;
              break;
            }
            return _context8.abrupt("return");
          case 1:
            while (rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM] !== breadCrumbItem) {
              lastBreadCrumbStoreItem = rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM];
              commit(NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].mutations.REMOVE_ITEM, lastBreadCrumbStoreItem, {
                root: true
              });
              dispatch(NAMESPACE + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_Filters__["a" /* Types */].actions.REMOVE_SELECTED_FILTER_IN_CASCADE, lastBreadCrumbStoreItem.filter, {
                root: true
              });
            }
            storeDimension = breadCrumbItem.dimension, storeStrategyFilter = breadCrumbItem.filter;
            _rootGetters3 = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM], productDimension = _rootGetters3.dimension, productStrategyFilter = _rootGetters3.filter;
            _context8.next = 2;
            return dispatch(_types.actions.FETCH_WIDE_GRID, {
              storeDimension: storeDimension,
              storeStrategyFilter: storeStrategyFilter,
              productDimension: productDimension,
              productStrategyFilter: productStrategyFilter
            });
          case 2:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }))();
  }), _types.actions.POP_UNTIL_PRODUCT_BREADCRUMB, function (_ref23, breadCrumbItem) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee9() {
      var commit, dispatch, rootGetters, lastBreadCrumbProductItem, _rootGetters4, storeDimension, storeStrategyFilter, productDimension, productStrategyFilter;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            commit = _ref23.commit, dispatch = _ref23.dispatch, rootGetters = _ref23.rootGetters;
            if (!(rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM] === breadCrumbItem)) {
              _context9.next = 1;
              break;
            }
            return _context9.abrupt("return");
          case 1:
            while (rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM] !== breadCrumbItem) {
              lastBreadCrumbProductItem = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM];
              commit(NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].mutations.REMOVE_ITEM, lastBreadCrumbProductItem, {
                root: true
              });
              dispatch(NAMESPACE + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_Filters__["a" /* Types */].actions.REMOVE_SELECTED_FILTER_IN_CASCADE, lastBreadCrumbProductItem.filter, {
                root: true
              });
            }
            _rootGetters4 = rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM], storeDimension = _rootGetters4.dimension, storeStrategyFilter = _rootGetters4.filter;
            productDimension = breadCrumbItem.dimension, productStrategyFilter = breadCrumbItem.filter;
            _context9.next = 2;
            return dispatch(_types.actions.FETCH_WIDE_GRID, {
              storeDimension: storeDimension,
              storeStrategyFilter: storeStrategyFilter,
              productDimension: productDimension,
              productStrategyFilter: productStrategyFilter
            });
          case 2:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }))();
  }), _types.actions.DOWNLOAD_EXCEL, function (_ref24) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee0() {
      var state, getters, rootState, rootGetters, filters, metrics, factTableName, _rootGetters5, storeDimension, storeStrategyFilter, _rootGetters6, productDimension, productStrategyFilter;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            state = _ref24.state, getters = _ref24.getters, rootState = _ref24.rootState, rootGetters = _ref24.rootGetters;
            filters = state.filters;
            metrics = getters[_types.getters.METRIC_OPTION];
            factTableName = rootState.salesAnalysis.accumulatedSalesDateOption.fact_name;
            _rootGetters5 = rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM], storeDimension = _rootGetters5.dimension, storeStrategyFilter = _rootGetters5.filter;
            _rootGetters6 = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM], productDimension = _rootGetters6.dimension, productStrategyFilter = _rootGetters6.filter;
            _context0.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_7__app_sales_analysis_Services__["b" /* downloadWideGridToExcel */])({
              metrics: metrics,
              filters: filters,
              factTableName: factTableName,
              storeDimension: storeDimension,
              storeStrategyFilter: storeStrategyFilter,
              productDimension: productDimension,
              productStrategyFilter: productStrategyFilter
            });
          case 1:
          case "end":
            return _context0.stop();
        }
      }, _callee0);
    }))();
  }), _types.actions.RESET, function (_ref25) {
    var commit = _ref25.commit;
    commit(NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].mutations.RESET, null, {
      root: true
    });
    commit(NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].mutations.RESET, null, {
      root: true
    });
    commit(_types.mutations.SET_GRID, null);
  }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_actions, _types.actions.REMOVE_PIVOTED_FILTERS, function (_ref26, pivotedFilters) {
    var dispatch = _ref26.dispatch;
    pivotedFilters.forEach(function (pivotedFilter) {
      dispatch(NAMESPACE + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_Filters__["a" /* Types */].actions.REMOVE_SELECTED_FILTER_IN_CASCADE, pivotedFilter, {
        root: true
      });
    });
  }), _types.actions.CHANGE_METRIC_OPTION, function (_ref27, metricOptionKey) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee1() {
      var commit, dispatch;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context1) {
        while (1) switch (_context1.prev = _context1.next) {
          case 0:
            commit = _ref27.commit, dispatch = _ref27.dispatch;
            commit(_types.mutations.SET_METRIC_OPTION_KEY, metricOptionKey);
            _context1.next = 1;
            return dispatch(_types.actions.INIT_WIDE_GRID);
          case 1:
          case "end":
            return _context1.stop();
        }
      }, _callee1);
    }))();
  }), _types.actions.SET_INIT_DATA_DATE_GRANULARITY, function (_ref28, _ref29) {
    var commit = _ref28.commit,
      getters = _ref28.getters;
    var productFilter = _ref29.productFilter,
      storeFilter = _ref29.storeFilter,
      productText = _ref29.productText,
      storeText = _ref29.storeText;
    var title = "Apertura de fechas para ".concat(productText, " en ").concat(storeText);
    var productFilterObject = productFilter ? getters[_types.getters.CREATE_FILTER_OBJECT](productFilter) : {};
    var storeFilterObject = getters[_types.getters.CREATE_FILTER_OBJECT](storeFilter);
    var filterObject = _objectSpread(_objectSpread({}, productFilterObject), storeFilterObject);
    commit(__WEBPACK_IMPORTED_MODULE_4__app_sales_analysis_store_DateGranularity__["a" /* Types */].mutations.SET_TITLE, title, {
      root: true
    });
    commit(__WEBPACK_IMPORTED_MODULE_4__app_sales_analysis_store_DateGranularity__["a" /* Types */].mutations.SET_FILTER, filterObject, {
      root: true
    });
  })),
  getters: (_getters = {}, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_getters, _types.getters.STORE_DIMENSIONS, function (state, getters, rootState, rootGetters) {
    return rootGetters[__WEBPACK_IMPORTED_MODULE_3__app_sales_analysis_store_Index__["a" /* Types */].getters.DIMENSIONS].filter(function (dimension) {
      return dimension.type === 'store';
    });
  }), _types.getters.STORE_DEFAULT_DIMENSION, function (state, getters) {
    var storeDimensions = getters[_types.getters.STORE_DIMENSIONS];
    return storeDimensions.find(function (dimension) {
      return dimension.selected;
    }) || storeDimensions[0];
  }), _types.getters.PRODUCT_DIMENSIONS, function (state, getters, rootState, rootGetters) {
    return rootGetters[__WEBPACK_IMPORTED_MODULE_3__app_sales_analysis_store_Index__["a" /* Types */].getters.DIMENSIONS].filter(function (dimension) {
      return dimension.type === 'product';
    });
  }), _types.getters.PRODUCT_DEFAULT_DIMENSION, function (state, getters) {
    var productDimensions = getters[_types.getters.PRODUCT_DIMENSIONS];
    return productDimensions.find(function (dimension) {
      return dimension.selected;
    }) || productDimensions[0];
  }), _types.getters.HAS_SELECTED_FILTERS, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_Filters__["a" /* Types */].getters.HAS_SELECTED_FILTERS];
  }), _types.getters.PIVOT_PRODUCT_DIMENSIONS, function (state, getters, rootState, rootGetters) {
    var dimensionIdsInProductBreadCrumb = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_IDS_IN_BREADCRUMB];
    var dimensionsToPivot = function dimensionsToPivot(dimension) {
      return !dimensionIdsInProductBreadCrumb.includes(dimension.id);
    };
    return getters[_types.getters.PRODUCT_DIMENSIONS].filter(dimensionsToPivot);
  }), _types.getters.PIVOT_STORE_DIMENSIONS, function (state, getters, rootState, rootGetters) {
    var dimensionIdsInStoreBreadCrumb = rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_IDS_IN_BREADCRUMB];
    var dimensionsToPivot = function dimensionsToPivot(dimension) {
      return !dimensionIdsInStoreBreadCrumb.includes(dimension.id);
    };
    return getters[_types.getters.STORE_DIMENSIONS].filter(dimensionsToPivot);
  }), _types.getters.PRODUCT_DIMENSION_TO_FILTER, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_TO_FILTER];
  }), _types.getters.STORE_DIMENSION_TO_FILTER, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_TO_FILTER];
  }), _types.getters.PIVOTED_PRODUCT_FILTER_DIMENSION_IDS, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_IDS_IN_FILTERS];
  }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_getters, _types.getters.PIVOTED_STORE_FILTER_DIMENSION_IDS, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_IDS_IN_FILTERS];
  }), _types.getters.BASE_PRODUCT_DIMENSION, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.FIRST_ITEM].dimension;
  }), _types.getters.BASE_STORE_DIMENSION, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.FIRST_ITEM].dimension;
  }), _types.getters.METRIC_OPTION, function (state) {
    return state.metricOptions[state.metricOptionKey].parameters;
  }), _types.getters.METRIC_OPTIONS, function (state) {
    return Object.entries(state.metricOptions).map(function (metricOption) {
      return {
        key: metricOption[0],
        name: metricOption[1].name,
        tooltip: metricOption[1].tooltip
      };
    });
  }), _types.getters.LAST_PRODUCT_BREADCRUMB_ITEM, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM];
  }), _types.getters.LAST_STORE_BREADCRUMB_ITEM, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM];
  }), _types.getters.CREATE_FILTER_OBJECT, function (state) {
    return function (filter) {
      var filterAttribute = "".concat(filter.keyFieldType, "_filters");
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, filterAttribute, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, filter.keyField, filter.value));
    };
  })),
  modules: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({
    filters: __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_Filters__["b" /* default */]
  }, STORE_BREADCRUMB_MODULE_NAME, __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["b" /* default */]), PRODUCT_BREADCRUMB_MODULE_NAME, __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["b" /* default */])
};
/* harmony default export */ __webpack_exports__["b"] = (WideGrid);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_store_growth_store_Index__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_store_growth_Services__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_sales_analysis_Services__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_shared_store_modules_Filters__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_shared_utils_NamespaceHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_sales_analysis_models_Dimension__ = __webpack_require__(575);


var _actions, _getters;








var NAMESPACE = 'storeGrowth/storesWithoutGrowthDetail/';
var STORE_BREADCRUMB_MODULE_NAME = 'storeBreadCrumb';
var PRODUCT_BREADCRUMB_MODULE_NAME = 'productBreadCrumb';
var NAMESPACE_STORE_BREADCRUMB = NAMESPACE + STORE_BREADCRUMB_MODULE_NAME + '/';
var NAMESPACE_PRODUCT_BREADCRUMB = NAMESPACE + PRODUCT_BREADCRUMB_MODULE_NAME + '/';
var _types = {
  getters: {
    DIMENSIONS: 'GETTER_DIMENSIONS',
    DIMENSION_BY_ID: 'GETTER_DIMENSION_BY_ID',
    STORE_DIMENSIONS: 'GETTER_STORE_DIMENSIONS',
    PRODUCT_DIMENSIONS: 'GETTER_PRODUCT_DIMENSIONS',
    STORE_DEFAULT_DIMENSION: 'GETTER_STORE_DEFAULT_DIMENSION',
    PRODUCT_DEFAULT_DIMENSION: 'GETTER_PRODUCT_DEFAULT_DIMENSION',
    PIVOT_PRODUCT_DIMENSIONS: 'GETTER_PIVOT_PRODUCT_DIMENSIONS',
    PIVOT_STORE_DIMENSIONS: 'GETTER_PIVOT_STORE_DIMENSIONS',
    PRODUCT_DIMENSION_TO_FILTER: 'GETTER_PRODUCT_DIMENSION_TO_FILTER',
    STORE_DIMENSION_TO_FILTER: 'GETTER_STORE_DIMENSION_TO_FILTER',
    PIVOTED_PRODUCT_FILTER_DIMENSION_IDS: 'GETTER_PIVOTED_PRODUCT_FILTER_DIMENSION_IDS',
    PIVOTED_STORE_FILTER_DIMENSION_IDS: 'GETTER_PIVOTED_STORE_FILTER_DIMENSION_IDS',
    BASE_STORE_DIMENSION: 'GETTER_BASE_STORE_DIMENSION',
    BASE_PRODUCT_DIMENSION: 'GETTER_BASE_PRODUCT_DIMENSION',
    LAST_PRODUCT_BREADCRUMB_ITEM: 'LAST_PRODUCT_BREADCRUMB_ITEM',
    LAST_STORE_BREADCRUMB_ITEM: 'LAST_STORE_BREADCRUMB_ITEM',
    CREATE_FILTER_OBJECT: 'CREATE_FILTER_OBJECT'
  },
  actions: {
    INIT: 'INIT',
    DEFAULT_FILTERS: 'DEFAULT_FILTERS',
    INIT_DIMENSIONS: 'INIT_DIMENSIONS',
    INIT_PRODUCT_DIMENSION: 'INIT_PRODUCT_DIMENSION',
    INIT_STORE_DIMENSION: 'INIT_STORE_DIMENSION',
    INIT_PRODUCT_BREADCRUMB: 'INIT_PRODUCT_BREADCRUMB',
    INIT_STORE_BREADCRUMB: 'INIT_STORE_BREADCRUMB',
    INIT_STORES_WITHOUT_GROWTH_DETAIL_GRID: 'INIT_STORES_WITHOUT_GROWTH_DETAIL_GRID',
    CHANGE_BASE_PRODUCT_DIMENSION: 'CHANGE_BASE_PRODUCT_DIMENSION',
    CHANGE_BASE_STORE_DIMENSION: 'CHANGE_BASE_STORE_DIMENSION',
    PIVOT_PRODUCT: 'PIVOT_PRODUCT',
    PIVOT_STORE: 'PIVOT_STORE',
    POP_UNTIL_STORE_BREADCRUMB: 'POP_UNTIL_STORE_BREADCRUMB',
    POP_UNTIL_PRODUCT_BREADCRUMB: 'POP_UNTIL_PRODUCT_BREADCRUMB',
    DOWNLOAD_EXCEL: 'DOWNLOAD_EXCEL',
    PUSH_BREADCRUMB_PRODUCT_ITEM: 'PUSH_BREADCRUMB_PRODUCT_ITEM',
    PUSH_BREADCRUMB_STORE_ITEM: 'PUSH_BREADCRUMB_STORE_ITEM',
    RESET: 'RESET',
    REMOVE_PIVOTED_FILTERS: 'REMOVE_PIVOTED_FILTERS',
    FETCH_STORES_WITHOUT_GROWTH_DETAIL_GRID: 'FETCH_STORES_WITHOUT_GROWTH_DETAIL_GRID',
    FETCH_STORES_WITHIN_RADIUS: 'FETCH_STORES_WITHIN_RADIUS'
  },
  mutations: {
    SET_GRID: 'SET_GRID',
    SET_STORE_IDS: 'SET_STORE_IDS'
  }
};
var Types = Object(__WEBPACK_IMPORTED_MODULE_7__app_shared_utils_NamespaceHelper__["a" /* addNamespace */])(NAMESPACE, _types);
var StoresWithoutGrowthDetail = {
  namespaced: true,
  state: {
    grid: null,
    storeIds: null
  },
  mutations: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.mutations.SET_GRID, function (state, wideGrid) {
    state.grid = wideGrid;
  }), _types.mutations.SET_STORE_IDS, function (state, storeIds) {
    state.storeIds = storeIds;
  }),
  actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_actions, _types.actions.FETCH_STORES_WITHIN_RADIUS, function (_ref, _ref2) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
      var commit, storeId, _ref2$radius, radius, storeIds;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            storeId = _ref2.storeId, _ref2$radius = _ref2.radius, radius = _ref2$radius === void 0 ? 1000 : _ref2$radius;
            _context.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_4__app_store_growth_Services__["b" /* getStoresWithinRadius */])(storeId, radius);
          case 1:
            storeIds = _context.sent;
            commit(_types.mutations.SET_STORE_IDS, storeIds);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }), _types.actions.INIT, function (_ref3, storeId) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
      var commit, dispatch;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref3.commit, dispatch = _ref3.dispatch;
            _context2.next = 1;
            return dispatch(_types.actions.FETCH_STORES_WITHIN_RADIUS, {
              storeId: storeId
            });
          case 1:
            dispatch(_types.actions.DEFAULT_FILTERS);
            dispatch(_types.actions.INIT_DIMENSIONS);
            _context2.next = 2;
            return dispatch(_types.actions.INIT_STORES_WITHOUT_GROWTH_DETAIL_GRID);
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }), _types.actions.DEFAULT_FILTERS, function (_ref4) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3() {
      var dispatch, state, storeIds, storeFilters;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            dispatch = _ref4.dispatch, state = _ref4.state;
            storeIds = state.storeIds;
            storeFilters = {
              store_type_id: [1],
              store_id: storeIds
            };
            dispatch(NAMESPACE + __WEBPACK_IMPORTED_MODULE_6__app_shared_store_modules_Filters__["a" /* Types */].actions.SET_SELECTED_FILTERS, {
              storeFilters: storeFilters
            }, {
              root: true
            });
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }), _types.actions.INIT_DIMENSIONS, function (_ref5) {
    var dispatch = _ref5.dispatch;
    dispatch(_types.actions.INIT_PRODUCT_DIMENSION);
    dispatch(_types.actions.INIT_STORE_DIMENSION);
  }), _types.actions.INIT_PRODUCT_DIMENSION, function (_ref6) {
    var getters = _ref6.getters,
      dispatch = _ref6.dispatch;
    var productDefaultDimension = getters[_types.getters.PRODUCT_DEFAULT_DIMENSION];
    dispatch(_types.actions.INIT_PRODUCT_BREADCRUMB, productDefaultDimension);
  }), _types.actions.INIT_STORE_DIMENSION, function (_ref7) {
    var getters = _ref7.getters,
      dispatch = _ref7.dispatch;
    // const storeDefaultDimension = getters[_types.getters.STORE_DEFAULT_DIMENSION]
    var storeDefaultDimension = getters[_types.getters.STORE_DIMENSIONS].find(function (store) {
      return store.key === 'store_id';
    });
    dispatch(_types.actions.INIT_STORE_BREADCRUMB, storeDefaultDimension);
  }), _types.actions.CHANGE_BASE_PRODUCT_DIMENSION, function (_ref8, dimensionId) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee4() {
      var dispatch, getters, rootGetters, productDimension, storeDimension, pivotedProductFilters;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            dispatch = _ref8.dispatch, getters = _ref8.getters, rootGetters = _ref8.rootGetters;
            productDimension = getters[_types.getters.DIMENSION_BY_ID](dimensionId);
            storeDimension = rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_TO_FILTER];
            pivotedProductFilters = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.FILTERS];
            dispatch(_types.actions.REMOVE_PIVOTED_FILTERS, pivotedProductFilters);
            _context4.next = 1;
            return dispatch(_types.actions.FETCH_STORES_WITHOUT_GROWTH_DETAIL_GRID, {
              productDimension: productDimension,
              storeDimension: storeDimension
            });
          case 1:
            dispatch(_types.actions.INIT_PRODUCT_BREADCRUMB, productDimension);
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  }), _types.actions.CHANGE_BASE_STORE_DIMENSION, function (_ref9, dimensionId) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee5() {
      var dispatch, getters, rootGetters, storeDimension, productDimension, pivotedStoreFilters;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            dispatch = _ref9.dispatch, getters = _ref9.getters, rootGetters = _ref9.rootGetters;
            storeDimension = getters[_types.getters.DIMENSION_BY_ID](dimensionId);
            productDimension = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_TO_FILTER];
            pivotedStoreFilters = rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.FILTERS];
            dispatch(_types.actions.REMOVE_PIVOTED_FILTERS, pivotedStoreFilters);
            _context5.next = 1;
            return dispatch(_types.actions.FETCH_STORES_WITHOUT_GROWTH_DETAIL_GRID, {
              productDimension: productDimension,
              storeDimension: storeDimension
            });
          case 1:
            dispatch(_types.actions.INIT_STORE_BREADCRUMB, storeDimension);
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  }), _types.actions.INIT_PRODUCT_BREADCRUMB, function (_ref0, dimension) {
    var commit = _ref0.commit,
      dispatch = _ref0.dispatch;
    commit(NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].mutations.RESET, null, {
      root: true
    });
    dispatch(_types.actions.PUSH_BREADCRUMB_PRODUCT_ITEM, {
      dimension: dimension,
      filter: undefined,
      breadCrumbItemText: dimension.value
    });
  }), _types.actions.INIT_STORE_BREADCRUMB, function (_ref1, dimension) {
    var commit = _ref1.commit,
      dispatch = _ref1.dispatch;
    commit(NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].mutations.RESET, null, {
      root: true
    });
    dispatch(_types.actions.PUSH_BREADCRUMB_STORE_ITEM, {
      dimension: dimension,
      filter: undefined,
      breadCrumbItemText: dimension.value
    });
  }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_actions, _types.actions.PUSH_BREADCRUMB_PRODUCT_ITEM, function (_ref10, _ref11) {
    var commit = _ref10.commit;
    var dimension = _ref11.dimension,
      filter = _ref11.filter,
      breadCrumbItemText = _ref11.breadCrumbItemText;
    commit(NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].mutations.PUSH_ITEM, {
      dimension: dimension,
      filter: filter,
      text: breadCrumbItemText
    }, {
      root: true
    });
    if (filter) commit(NAMESPACE + __WEBPACK_IMPORTED_MODULE_6__app_shared_store_modules_Filters__["a" /* Types */].mutations.ADD_SELECTED_FILTER, filter, {
      root: true
    });
  }), _types.actions.PUSH_BREADCRUMB_STORE_ITEM, function (_ref12, _ref13) {
    var commit = _ref12.commit;
    var dimension = _ref13.dimension,
      filter = _ref13.filter,
      breadCrumbItemText = _ref13.breadCrumbItemText;
    commit(NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].mutations.PUSH_ITEM, {
      dimension: dimension,
      filter: filter,
      text: breadCrumbItemText
    }, {
      root: true
    });
    if (filter) commit(NAMESPACE + __WEBPACK_IMPORTED_MODULE_6__app_shared_store_modules_Filters__["a" /* Types */].mutations.ADD_SELECTED_FILTER, filter, {
      root: true
    });
  }), _types.actions.INIT_STORES_WITHOUT_GROWTH_DETAIL_GRID, function (_ref14) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee6() {
      var dispatch, rootGetters, productDimension, storeDimension;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            dispatch = _ref14.dispatch, rootGetters = _ref14.rootGetters;
            productDimension = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_TO_FILTER];
            storeDimension = rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_TO_FILTER];
            _context6.next = 1;
            return dispatch(_types.actions.FETCH_STORES_WITHOUT_GROWTH_DETAIL_GRID, {
              productDimension: productDimension,
              storeDimension: storeDimension
            });
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  }), _types.actions.FETCH_STORES_WITHOUT_GROWTH_DETAIL_GRID, function (_ref15, _ref16) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee7() {
      var commit, state, rootState, dispatch, rootGetters, productDimension, storeDimension, productStrategyFilter, storeStrategyFilter, filters, metrics, factTableName, wideGrid;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            commit = _ref15.commit, state = _ref15.state, rootState = _ref15.rootState, dispatch = _ref15.dispatch, rootGetters = _ref15.rootGetters;
            productDimension = _ref16.productDimension, storeDimension = _ref16.storeDimension, productStrategyFilter = _ref16.productStrategyFilter, storeStrategyFilter = _ref16.storeStrategyFilter;
            dispatch(_types.actions.DEFAULT_FILTERS);
            filters = state.filters;
            metrics = rootGetters[__WEBPACK_IMPORTED_MODULE_3__app_store_growth_store_Index__["b" /* Types */].getters.METRICS];
            factTableName = rootState.storeGrowth.accumulatedSalesDateOption.fact_name;
            commit(_types.mutations.SET_GRID, null);
            _context7.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_5__app_sales_analysis_Services__["g" /* getWideGrid */])({
              metrics: metrics,
              productDimension: productDimension,
              storeDimension: storeDimension,
              factTableName: factTableName,
              productStrategyFilter: productStrategyFilter,
              storeStrategyFilter: storeStrategyFilter,
              filters: filters
            });
          case 1:
            wideGrid = _context7.sent;
            commit(_types.mutations.SET_GRID, wideGrid);
          case 2:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }))();
  }), _types.actions.PIVOT_PRODUCT, function (_ref17, _ref18) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee8() {
      var dispatch, getters, rootGetters, pivotedDimensionId, filter, pivotedDimensionCellValue, productDimension, breadCrumbItemText, storeDimension, productStrategyFilter;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            dispatch = _ref17.dispatch, getters = _ref17.getters, rootGetters = _ref17.rootGetters;
            pivotedDimensionId = _ref18.pivotedDimensionId, filter = _ref18.filter, pivotedDimensionCellValue = _ref18.pivotedDimensionCellValue;
            productDimension = getters[_types.getters.DIMENSION_BY_ID](pivotedDimensionId);
            breadCrumbItemText = "".concat(productDimension.value, " en ").concat(pivotedDimensionCellValue);
            storeDimension = rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_TO_FILTER];
            productStrategyFilter = filter;
            _context8.next = 1;
            return dispatch(_types.actions.FETCH_STORES_WITHOUT_GROWTH_DETAIL_GRID, {
              productDimension: productDimension,
              productStrategyFilter: productStrategyFilter,
              storeDimension: storeDimension
            });
          case 1:
            dispatch(_types.actions.PUSH_BREADCRUMB_PRODUCT_ITEM, {
              dimension: productDimension,
              filter: filter,
              breadCrumbItemText: breadCrumbItemText
            });
          case 2:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }))();
  }), _types.actions.PIVOT_STORE, function (_ref19, _ref20) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee9() {
      var dispatch, getters, rootGetters, pivotedDimensionId, filter, pivotedDimensionCellValue, storeDimension, breadCrumbItemText, productDimension, storeStrategyFilter;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            dispatch = _ref19.dispatch, getters = _ref19.getters, rootGetters = _ref19.rootGetters;
            pivotedDimensionId = _ref20.pivotedDimensionId, filter = _ref20.filter, pivotedDimensionCellValue = _ref20.pivotedDimensionCellValue;
            storeDimension = getters[_types.getters.DIMENSION_BY_ID](pivotedDimensionId);
            breadCrumbItemText = "".concat(storeDimension.value, " en ").concat(pivotedDimensionCellValue);
            productDimension = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_TO_FILTER];
            storeStrategyFilter = filter;
            _context9.next = 1;
            return dispatch(_types.actions.FETCH_STORES_WITHOUT_GROWTH_DETAIL_GRID, {
              productDimension: productDimension,
              storeStrategyFilter: storeStrategyFilter,
              storeDimension: storeDimension
            });
          case 1:
            dispatch(_types.actions.PUSH_BREADCRUMB_STORE_ITEM, {
              dimension: storeDimension,
              filter: filter,
              breadCrumbItemText: breadCrumbItemText
            });
          case 2:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }))();
  }), _types.actions.POP_UNTIL_STORE_BREADCRUMB, function (_ref21, breadCrumbItem) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee0() {
      var commit, dispatch, rootGetters, lastBreadCrumbStoreItem, storeDimension, storeStrategyFilter, _rootGetters, productDimension, productStrategyFilter;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            commit = _ref21.commit, dispatch = _ref21.dispatch, rootGetters = _ref21.rootGetters;
            if (!(rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM] === breadCrumbItem)) {
              _context0.next = 1;
              break;
            }
            return _context0.abrupt("return");
          case 1:
            while (rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM] !== breadCrumbItem) {
              lastBreadCrumbStoreItem = rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM];
              commit(NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].mutations.REMOVE_ITEM, lastBreadCrumbStoreItem, {
                root: true
              });
              dispatch(NAMESPACE + __WEBPACK_IMPORTED_MODULE_6__app_shared_store_modules_Filters__["a" /* Types */].actions.REMOVE_SELECTED_FILTER_IN_CASCADE, lastBreadCrumbStoreItem.filter, {
                root: true
              });
            }
            storeDimension = breadCrumbItem.dimension, storeStrategyFilter = breadCrumbItem.filter;
            _rootGetters = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM], productDimension = _rootGetters.dimension, productStrategyFilter = _rootGetters.filter;
            _context0.next = 2;
            return dispatch(_types.actions.FETCH_STORES_WITHOUT_GROWTH_DETAIL_GRID, {
              storeDimension: storeDimension,
              storeStrategyFilter: storeStrategyFilter,
              productDimension: productDimension,
              productStrategyFilter: productStrategyFilter
            });
          case 2:
          case "end":
            return _context0.stop();
        }
      }, _callee0);
    }))();
  }), _types.actions.POP_UNTIL_PRODUCT_BREADCRUMB, function (_ref22, breadCrumbItem) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee1() {
      var commit, dispatch, rootGetters, lastBreadCrumbProductItem, _rootGetters2, storeDimension, storeStrategyFilter, productDimension, productStrategyFilter;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context1) {
        while (1) switch (_context1.prev = _context1.next) {
          case 0:
            commit = _ref22.commit, dispatch = _ref22.dispatch, rootGetters = _ref22.rootGetters;
            if (!(rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM] === breadCrumbItem)) {
              _context1.next = 1;
              break;
            }
            return _context1.abrupt("return");
          case 1:
            while (rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM] !== breadCrumbItem) {
              lastBreadCrumbProductItem = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM];
              commit(NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].mutations.REMOVE_ITEM, lastBreadCrumbProductItem, {
                root: true
              });
              dispatch(NAMESPACE + __WEBPACK_IMPORTED_MODULE_6__app_shared_store_modules_Filters__["a" /* Types */].actions.REMOVE_SELECTED_FILTER_IN_CASCADE, lastBreadCrumbProductItem.filter, {
                root: true
              });
            }
            _rootGetters2 = rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM], storeDimension = _rootGetters2.dimension, storeStrategyFilter = _rootGetters2.filter;
            productDimension = breadCrumbItem.dimension, productStrategyFilter = breadCrumbItem.filter;
            _context1.next = 2;
            return dispatch(_types.actions.FETCH_STORES_WITHOUT_GROWTH_DETAIL_GRID, {
              storeDimension: storeDimension,
              storeStrategyFilter: storeStrategyFilter,
              productDimension: productDimension,
              productStrategyFilter: productStrategyFilter
            });
          case 2:
          case "end":
            return _context1.stop();
        }
      }, _callee1);
    }))();
  }), _types.actions.RESET, function (_ref23) {
    var commit = _ref23.commit;
    commit(NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].mutations.RESET, null, {
      root: true
    });
    commit(NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].mutations.RESET, null, {
      root: true
    });
    commit(_types.mutations.SET_GRID, null);
  }), _types.actions.REMOVE_PIVOTED_FILTERS, function (_ref24, pivotedFilters) {
    var dispatch = _ref24.dispatch;
    pivotedFilters.forEach(function (pivotedFilter) {
      dispatch(NAMESPACE + __WEBPACK_IMPORTED_MODULE_6__app_shared_store_modules_Filters__["a" /* Types */].actions.REMOVE_SELECTED_FILTER_IN_CASCADE, pivotedFilter, {
        root: true
      });
    });
  }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_actions, _types.actions.DOWNLOAD_EXCEL, function (_ref25) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee10() {
      var state, getters, rootState, rootGetters, filters, metrics, factTableName, _rootGetters3, storeDimension, storeStrategyFilter, _rootGetters4, productDimension, productStrategyFilter;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            state = _ref25.state, getters = _ref25.getters, rootState = _ref25.rootState, rootGetters = _ref25.rootGetters;
            filters = state.filters;
            metrics = rootGetters[__WEBPACK_IMPORTED_MODULE_3__app_store_growth_store_Index__["b" /* Types */].getters.METRICS];
            factTableName = rootState.storeGrowth.accumulatedSalesDateOption.fact_name;
            _rootGetters3 = rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM], storeDimension = _rootGetters3.dimension, storeStrategyFilter = _rootGetters3.filter;
            _rootGetters4 = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM], productDimension = _rootGetters4.dimension, productStrategyFilter = _rootGetters4.filter;
            _context10.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_5__app_sales_analysis_Services__["b" /* downloadWideGridToExcel */])({
              metrics: metrics,
              filters: filters,
              factTableName: factTableName,
              storeDimension: storeDimension,
              storeStrategyFilter: storeStrategyFilter,
              productDimension: productDimension,
              productStrategyFilter: productStrategyFilter
            });
          case 1:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }))();
  })),
  getters: (_getters = {}, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_getters, _types.getters.DIMENSIONS, function (state, getters, rootState, rootGetters) {
    return rootGetters.dataDimensions.map(function (dimension) {
      return new __WEBPACK_IMPORTED_MODULE_9__app_sales_analysis_models_Dimension__["a" /* default */](dimension);
    });
  }), _types.getters.DIMENSION_BY_ID, function (state, getters) {
    return function (dimensionId) {
      return getters[_types.getters.DIMENSIONS].find(function (dimension) {
        return dimension.id === dimensionId;
      });
    };
  }), _types.getters.STORE_DIMENSIONS, function (state, getters) {
    return getters[_types.getters.DIMENSIONS].filter(function (dimension) {
      return dimension.type === 'store';
    });
  }), _types.getters.STORE_DEFAULT_DIMENSION, function (state, getters) {
    var storeDimensions = getters[_types.getters.STORE_DIMENSIONS];
    return storeDimensions.find(function (dimension) {
      return dimension.selected;
    }) || storeDimensions[0];
  }), _types.getters.PRODUCT_DIMENSIONS, function (state, getters) {
    return getters[_types.getters.DIMENSIONS].filter(function (dimension) {
      return dimension.type === 'product';
    });
  }), _types.getters.PRODUCT_DEFAULT_DIMENSION, function (state, getters) {
    var productDimensions = getters[_types.getters.PRODUCT_DIMENSIONS];
    return productDimensions.find(function (dimension) {
      return dimension.selected;
    }) || productDimensions[0];
  }), _types.getters.PIVOT_PRODUCT_DIMENSIONS, function (state, getters, rootState, rootGetters) {
    var dimensionIdsInProductBreadCrumb = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_IDS_IN_BREADCRUMB];
    var dimensionsToPivot = function dimensionsToPivot(dimension) {
      return !dimensionIdsInProductBreadCrumb.includes(dimension.id);
    };
    return getters[_types.getters.PRODUCT_DIMENSIONS].filter(dimensionsToPivot);
  }), _types.getters.PIVOT_STORE_DIMENSIONS, function (state, getters, rootState, rootGetters) {
    var dimensionIdsInStoreBreadCrumb = rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_IDS_IN_BREADCRUMB];
    var dimensionsToPivot = function dimensionsToPivot(dimension) {
      return !dimensionIdsInStoreBreadCrumb.includes(dimension.id);
    };
    return getters[_types.getters.STORE_DIMENSIONS].filter(dimensionsToPivot);
  }), _types.getters.PRODUCT_DIMENSION_TO_FILTER, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_TO_FILTER];
  }), _types.getters.STORE_DIMENSION_TO_FILTER, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_TO_FILTER];
  }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_getters, _types.getters.PIVOTED_PRODUCT_FILTER_DIMENSION_IDS, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_IDS_IN_FILTERS];
  }), _types.getters.PIVOTED_STORE_FILTER_DIMENSION_IDS, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_IDS_IN_FILTERS];
  }), _types.getters.BASE_PRODUCT_DIMENSION, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.FIRST_ITEM].dimension;
  }), _types.getters.BASE_STORE_DIMENSION, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.FIRST_ITEM].dimension;
  }), _types.getters.LAST_PRODUCT_BREADCRUMB_ITEM, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM];
  }), _types.getters.LAST_STORE_BREADCRUMB_ITEM, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE_STORE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM];
  }), _types.getters.CREATE_FILTER_OBJECT, function (state) {
    return function (filter) {
      var filterAttribute = "".concat(filter.keyFieldType, "_filters");
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, filterAttribute, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, filter.keyField, filter.value));
    };
  })),
  modules: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({
    filters: __WEBPACK_IMPORTED_MODULE_6__app_shared_store_modules_Filters__["b" /* default */]
  }, STORE_BREADCRUMB_MODULE_NAME, __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["b" /* default */]), PRODUCT_BREADCRUMB_MODULE_NAME, __WEBPACK_IMPORTED_MODULE_8__app_sales_analysis_store_BreadCrumb__["b" /* default */])
};
/* harmony default export */ __webpack_exports__["b"] = (StoresWithoutGrowthDetail);

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseLoader_vue__ = __webpack_require__(657);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cca158e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseLoader_vue__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1117)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cca158e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseLoader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cca158e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseLoader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MUTATE_GRANULARITY */
/* unused harmony export MUTATE_DATE_RANGE */
/* unused harmony export MUTATE_DATE_FROM */
/* unused harmony export MUTATE_DATE_TO */
/* unused harmony export MUTATE_FILTERS */
/* unused harmony export MUTATE_RESET_FILTERS */
/* unused harmony export MUTATE_DYNAMIC_DATE */
/* unused harmony export MUTATE_INIT_DYNAMIC_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return MUTATE_STORE_PRODUCT_DIMENSION_SELECTED_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ACTION_SET_GRANULARITY; });
/* unused harmony export ACTION_SET_DATE_RANGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ACTION_SET_DATE_FROM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ACTION_SET_DATE_TO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ACTION_SET_DYNAMIC_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ACTION_SET_INIT_DYNAMIC_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GETTER_DYNAMIC_DATE_SELECTED; });
/* unused harmony export MUTATE_PRODUCT_DIMENSION_SELECTED_IDS */
/* unused harmony export MUTATE_STORE_DIMENSION_SELECTED_IDS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ACTION_SET_PRODUCT_DIMENSION_SELECTED_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ACTION_SET_STORE_DIMENSION_SELECTED_IDS; });
/* unused harmony export MUTATE_USER_CONFIG_LIST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ACTION_GENERATE_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ACTION_SAVE_USER_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTION_FETCH_USER_CONFIG_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_FETCH_JOB_LIST; });
/* unused harmony export MUTATE_INIT_MASSIVE_DOWNLOAD */
/* unused harmony export MUTATE_USER_CONFIG */
/* unused harmony export MUTATE_JOB_LIST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ACTION_SET_DEFAULT_PARAMETERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ACTION_SET_USER_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GETTER_DYNAMIC_DATE_SELECTED_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GETTER_DYNAMIC_DATE_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GETTER_PRODUCT_DIMENSION_SELECTED_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return GETTER_STORE_DIMENSION_SELECTED_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return GETTER_STORE_PRODUCT_DIMENSION_SELECTED_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GETTER_GRANULARITY_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GETTER_DYNAMIC_DATE_MAP_ID; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_massive_download_services_MassiveDownloadService__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_massive_download_models_MassiveDownloadPost__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_massive_download_models_MassiveDownloadPostSaveUserConfig__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_massive_download_models_MassiveDownloadConfig__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_shared_utils_Option__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_massive_download_models_MassiveDownload__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_massive_download_models_MassiveDownloadJob__ = __webpack_require__(853);


var _mutations, _actions;

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







var NAMESPACE = 'massiveDownload/';
// Required Selection
var MUTATE_GRANULARITY = NAMESPACE + 'MUTATE_GRANULARITY';
var MUTATE_DATE_RANGE = NAMESPACE + 'MUTATE_DATE_RANGE';
var MUTATE_DATE_FROM = NAMESPACE + 'MUTATE_DATE_FROM';
var MUTATE_DATE_TO = NAMESPACE + 'MUTATE_DATE_TO';
var MUTATE_FILTERS = NAMESPACE + 'MUTATE_FILTERS';
var MUTATE_RESET_FILTERS = NAMESPACE + 'MUTATE_RESET_FILTERS';
var MUTATE_DYNAMIC_DATE = NAMESPACE + 'MUTATE_DYNAMIC_DATE';
var MUTATE_INIT_DYNAMIC_DATE = NAMESPACE + 'MUTATE_INIT_DYNAMIC_DATE';
var MUTATE_STORE_PRODUCT_DIMENSION_SELECTED_IDS = NAMESPACE + 'MUTATE_STORE_PRODUCT_DIMENSION_SELECTED_IDS';
var ACTION_SET_GRANULARITY = NAMESPACE + 'SET_GRANULARITY';
var ACTION_SET_DATE_RANGE = NAMESPACE + 'SET_DATE_RANGE';
var ACTION_SET_DATE_FROM = NAMESPACE + 'SET_DATE_FROM';
var ACTION_SET_DATE_TO = NAMESPACE + 'SET_DATE_TO';
var ACTION_SET_DYNAMIC_DATE = NAMESPACE + 'SET_DYNAMIC_DATE';
var ACTION_SET_INIT_DYNAMIC_DATE = NAMESPACE + 'SET_INIT_DYNAMIC_DATE';
var GETTER_DYNAMIC_DATE_SELECTED = NAMESPACE + 'GETTER_DYNAMIC_DATE_SELECTED';
// Column Selection
var MUTATE_PRODUCT_DIMENSION_SELECTED_IDS = NAMESPACE + 'MUTATE_PRODUCT_DIMENSION_SELECTED_IDS';
var MUTATE_STORE_DIMENSION_SELECTED_IDS = NAMESPACE + 'MUTATE_STORE_DIMENSION_SELECTED_IDS';
var ACTION_SET_PRODUCT_DIMENSION_SELECTED_IDS = NAMESPACE + 'SET_PRODUCT_DIMENSION_SELECTED_IDS';
var ACTION_SET_STORE_DIMENSION_SELECTED_IDS = NAMESPACE + 'SET_STORE_DIMENSION_SELECTED_IDS';
// Module
var MUTATE_USER_CONFIG_LIST = NAMESPACE + 'MUTATE_USER_CONFIG_LIST';
var ACTION_GENERATE_REPORT = NAMESPACE + 'GENERATE_REPORT';
var ACTION_SAVE_USER_CONFIG = NAMESPACE + 'SAVE_USER_CONFIG';
var ACTION_FETCH_USER_CONFIG_LIST = NAMESPACE + 'FETCH_USER_CONFIG_LIST';
var ACTION_FETCH_JOB_LIST = NAMESPACE + 'FETCH_JOB_LIST';
var MUTATE_INIT_MASSIVE_DOWNLOAD = NAMESPACE + 'MUTATE_MASSIVE_DOWNLOAD';
var MUTATE_USER_CONFIG = NAMESPACE + 'MUTATE_USER_CONFIG';
var MUTATE_JOB_LIST = NAMESPACE + 'MUTATE_JOB_LIST';
var ACTION_SET_DEFAULT_PARAMETERS = NAMESPACE + 'SET_DEFAULT_PARAMETERS';
var ACTION_SET_USER_CONFIG = NAMESPACE + 'SET_USER_CONFIG';
var GETTER_DYNAMIC_DATE_SELECTED_ID = NAMESPACE + 'GETTER_DYNAMIC_DATE_SELECTED_ID';
var GETTER_DYNAMIC_DATE_BY_ID = NAMESPACE + 'GETTER_DYNAMIC_DATE_BY_ID';
var GETTER_PRODUCT_DIMENSION_SELECTED_IDS = NAMESPACE + 'GETTER_PRODUCT_DIMENSION_SELECTED_IDS';
var GETTER_STORE_DIMENSION_SELECTED_IDS = NAMESPACE + 'GETTER_STORE_DIMENSION_SELECTED_IDS';
var GETTER_STORE_PRODUCT_DIMENSION_SELECTED_IDS = NAMESPACE + 'GETTER_STORE_PRODUCT_DIMENSION_SELECTED_IDS';
var GETTER_GRANULARITY_BY_ID = NAMESPACE + 'GETTER_GRANULARITY_BY_ID';
var GETTER_DYNAMIC_DATE_MAP_ID = NAMESPACE + 'GETTER_DYNAMIC_DATE_MAP_ID';
var MassiveDownloadState = {
  state: {
    jobList: null,
    userConfigList: null,
    defaultRequiredSelection: null,
    defaultColumnSelection: null,
    selectedGranularity: null,
    selectedDateFrom: null,
    selectedDateTo: null,
    selectedProductDimensionIds: [],
    selectedStoreDimensionIds: [],
    selectedStoreProductDimensionIds: [],
    selectedProductFilters: {},
    selectedStoreFilters: {},
    dynamicDateMapId: new Map()
  },
  getters: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, GETTER_DYNAMIC_DATE_SELECTED, function (state) {
    return state.dynamicDateMapId.get(state.selectedGranularity.id);
  }), GETTER_DYNAMIC_DATE_SELECTED_ID, function (state) {
    return function (granularityId) {
      var filteredOptions = state.defaultRequiredSelection.dateSelection.dynamicDate.options.filter(function (option) {
        return option.granularity === granularityId;
      });
      return Object(__WEBPACK_IMPORTED_MODULE_7__app_shared_utils_Option__["b" /* getSelectedOptionId */])(filteredOptions);
    };
  }), GETTER_DYNAMIC_DATE_BY_ID, function (state) {
    return function (id) {
      return state.defaultRequiredSelection.dateSelection.dynamicDate.options.find(function (option) {
        return option.id === id;
      });
    };
  }), GETTER_PRODUCT_DIMENSION_SELECTED_IDS, function (state) {
    return state.defaultColumnSelection.productDimensions.options.filter(function (productDimensionOption) {
      return productDimensionOption.selected;
    }).map(function (productDimensionOption) {
      return productDimensionOption.value;
    });
  }), GETTER_STORE_DIMENSION_SELECTED_IDS, function (state) {
    return state.defaultColumnSelection.storeDimensions.options.filter(function (storeDimensionOption) {
      return storeDimensionOption.selected;
    }).map(function (storeDimensionOption) {
      return storeDimensionOption.value;
    });
  }), GETTER_STORE_PRODUCT_DIMENSION_SELECTED_IDS, function (state) {
    return state.defaultColumnSelection.storeProductDimensions.options.filter(function (storeProductDimension) {
      return storeProductDimension.selected;
    }).map(function (storeProductDimension) {
      return storeProductDimension.value;
    });
  }), GETTER_GRANULARITY_BY_ID, function (state) {
    return function (id) {
      return state.defaultRequiredSelection.granularity.options.find(function (option) {
        return option.id === id;
      });
    };
  }), GETTER_DYNAMIC_DATE_MAP_ID, function (state) {
    var dynamicDateMapId = new Map();
    state.defaultRequiredSelection.dateSelection.dynamicDate.options.filter(function (option) {
      return option.selected;
    }).forEach(function (option) {
      return dynamicDateMapId.set(option.granularity, option.id);
    });
    return dynamicDateMapId;
  }),
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_mutations, MUTATE_GRANULARITY, function (state, granularity) {
    state.selectedGranularity = granularity;
  }), MUTATE_DYNAMIC_DATE, function (state, _ref) {
    var dynamicDateId = _ref.dynamicDateId;
    state.dynamicDateMapId.set(state.selectedGranularity.id, dynamicDateId);
  }), MUTATE_INIT_DYNAMIC_DATE, function (state, dynamicDateMapId) {
    state.dynamicDateMapId = dynamicDateMapId;
  }), MUTATE_DATE_RANGE, function (state, _ref2) {
    var from = _ref2.from,
      to = _ref2.to;
    state.selectedDateFrom = from;
    state.selectedDateTo = to;
  }), MUTATE_DATE_FROM, function (state, _ref3) {
    var dateFrom = _ref3.dateFrom;
    state.selectedDateFrom = dateFrom;
  }), MUTATE_DATE_TO, function (state, _ref4) {
    var dateTo = _ref4.dateTo;
    state.selectedDateTo = dateTo;
  }), MUTATE_PRODUCT_DIMENSION_SELECTED_IDS, function (state, _ref5) {
    var productDimensionIds = _ref5.productDimensionIds;
    state.selectedProductDimensionIds = productDimensionIds;
  }), MUTATE_STORE_DIMENSION_SELECTED_IDS, function (state, _ref6) {
    var storeDimensionIds = _ref6.storeDimensionIds;
    state.selectedStoreDimensionIds = storeDimensionIds;
  }), MUTATE_STORE_PRODUCT_DIMENSION_SELECTED_IDS, function (state, storeProductDimensionIds) {
    state.selectedStoreProductDimensionIds = storeProductDimensionIds;
  }), MUTATE_FILTERS, function (state, _ref7) {
    var productFilters = _ref7.productFilters,
      storeFilters = _ref7.storeFilters;
    state.selectedProductFilters = productFilters;
    state.selectedStoreFilters = storeFilters;
  }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_mutations, MUTATE_RESET_FILTERS, function (state) {
    state.selectedProductFilters = {};
    state.selectedStoreFilters = {};
  }), MUTATE_USER_CONFIG_LIST, function (state, userConfigList) {
    state.userConfigList = userConfigList;
  }), MUTATE_INIT_MASSIVE_DOWNLOAD, function (state, defaultParameters) {
    state.defaultRequiredSelection = defaultParameters.requiredSelection;
    state.defaultColumnSelection = defaultParameters.columnSelection;
  }), MUTATE_USER_CONFIG, function (state, userConfigParameters) {
    state.defaultRequiredSelection.dateSelection.dynamicDate.options.map(function (option, index) {
      userConfigParameters.requiredSelection.dateSelection.dynamicDate.options.splice(index, 1, _objectSpread(_objectSpread({}, userConfigParameters.requiredSelection.dateSelection.dynamicDate.options[index]), {}, {
        from: option.from,
        to: option.to
      }));
    });
    var userConfig = new __WEBPACK_IMPORTED_MODULE_8__app_massive_download_models_MassiveDownload__["a" /* default */](_objectSpread({}, userConfigParameters));
    state.defaultRequiredSelection = userConfig.requiredSelection;
    state.defaultColumnSelection = userConfig.columnSelection;
    state.selectedProductFilters = userConfig.filterSelection.productFilters;
    state.selectedStoreFilters = userConfig.filterSelection.storeFilters;
  }), MUTATE_JOB_LIST, function (state, jobList) {
    state.jobList = jobList;
  })),
  actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_actions, ACTION_SET_GRANULARITY, function (_ref8, granularity) {
    var commit = _ref8.commit;
    commit(MUTATE_GRANULARITY, granularity);
  }), ACTION_SET_DYNAMIC_DATE, function (_ref9, dynamicDateId) {
    var commit = _ref9.commit;
    commit(MUTATE_DYNAMIC_DATE, {
      dynamicDateId: dynamicDateId
    });
  }), ACTION_SET_INIT_DYNAMIC_DATE, function (_ref0, dynamicDateMapId) {
    var commit = _ref0.commit;
    commit(MUTATE_INIT_DYNAMIC_DATE, dynamicDateMapId);
  }), ACTION_SET_DATE_RANGE, function (_ref1, _ref10) {
    var commit = _ref1.commit;
    var from = _ref10.from,
      to = _ref10.to;
    commit(MUTATE_DATE_RANGE, {
      from: from,
      to: to
    });
  }), ACTION_SET_DATE_FROM, function (_ref11, dateFrom) {
    var commit = _ref11.commit;
    commit(MUTATE_DATE_FROM, {
      dateFrom: dateFrom
    });
  }), ACTION_SET_DATE_TO, function (_ref12, dateTo) {
    var commit = _ref12.commit;
    commit(MUTATE_DATE_TO, {
      dateTo: dateTo
    });
  }), ACTION_SET_PRODUCT_DIMENSION_SELECTED_IDS, function (_ref13, productDimensionIds) {
    var commit = _ref13.commit;
    commit(MUTATE_PRODUCT_DIMENSION_SELECTED_IDS, {
      productDimensionIds: productDimensionIds
    });
  }), ACTION_SET_STORE_DIMENSION_SELECTED_IDS, function (_ref14, storeDimensionIds) {
    var commit = _ref14.commit;
    commit(MUTATE_STORE_DIMENSION_SELECTED_IDS, {
      storeDimensionIds: storeDimensionIds
    });
  }), ACTION_GENERATE_REPORT, function (_ref15, _ref16) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
      var commit, state, stock, productFilters, storeFilters, massiveDownloadPost;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref15.commit, state = _ref15.state;
            stock = _ref16.stock, productFilters = _ref16.productFilters, storeFilters = _ref16.storeFilters;
            commit(MUTATE_FILTERS, {
              productFilters: productFilters,
              storeFilters: storeFilters
            });
            massiveDownloadPost = new __WEBPACK_IMPORTED_MODULE_4__app_massive_download_models_MassiveDownloadPost__["a" /* default */](_objectSpread(_objectSpread({}, state), {}, {
              stock: stock
            }));
            _context.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_3__app_massive_download_services_MassiveDownloadService__["c" /* massiveDownloadPostParameters */])(massiveDownloadPost.parameters);
          case 1:
            commit(MUTATE_RESET_FILTERS);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }), ACTION_SAVE_USER_CONFIG, function (_ref17, _ref18) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
      var commit, state, reportName, reportDescription, defaultSelection, defaultSelectionDeepCopy, massiveDownloadPostSaveUserConfig;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref17.commit, state = _ref17.state;
            reportName = _ref18.reportName, reportDescription = _ref18.reportDescription, defaultSelection = _ref18.defaultSelection;
            defaultSelectionDeepCopy = JSON.parse(JSON.stringify(defaultSelection));
            massiveDownloadPostSaveUserConfig = new __WEBPACK_IMPORTED_MODULE_5__app_massive_download_models_MassiveDownloadPostSaveUserConfig__["a" /* default */](_objectSpread(_objectSpread({}, state), {}, {
              reportName: reportName,
              reportDescription: reportDescription,
              defaultSelectionDeepCopy: defaultSelectionDeepCopy
            }));
            _context2.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_3__app_massive_download_services_MassiveDownloadService__["d" /* massiveDownloadSaveConfig */])(massiveDownloadPostSaveUserConfig.body);
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_actions, ACTION_FETCH_USER_CONFIG_LIST, function (_ref19) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3() {
      var commit, userConfigList, massiveDownloadUserConfigList;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref19.commit;
            _context3.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_3__app_massive_download_services_MassiveDownloadService__["a" /* massiveDownloadGetConfigList */])();
          case 1:
            userConfigList = _context3.sent;
            massiveDownloadUserConfigList = userConfigList.map(function (userConfig) {
              return new __WEBPACK_IMPORTED_MODULE_6__app_massive_download_models_MassiveDownloadConfig__["a" /* default */](userConfig);
            });
            commit(MUTATE_USER_CONFIG_LIST, massiveDownloadUserConfigList);
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }), ACTION_SET_DEFAULT_PARAMETERS, function (_ref20, defaultParameters) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee4() {
      var commit, massiveDownloadDefaultParameters;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            commit = _ref20.commit;
            massiveDownloadDefaultParameters = new __WEBPACK_IMPORTED_MODULE_8__app_massive_download_models_MassiveDownload__["a" /* default */](_objectSpread({}, defaultParameters));
            commit(MUTATE_INIT_MASSIVE_DOWNLOAD, massiveDownloadDefaultParameters);
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  }), ACTION_SET_USER_CONFIG, function (_ref21, userConfigParameters) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee5() {
      var commit, userConfig;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            commit = _ref21.commit;
            userConfig = new __WEBPACK_IMPORTED_MODULE_8__app_massive_download_models_MassiveDownload__["a" /* default */](_objectSpread({}, userConfigParameters));
            commit(MUTATE_USER_CONFIG, userConfig);
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  }), ACTION_FETCH_JOB_LIST, function (_ref22) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee6() {
      var commit, jobList, massiveDownloadJobList;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            commit = _ref22.commit;
            _context6.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_3__app_massive_download_services_MassiveDownloadService__["b" /* massiveDownloadGetJobList */])();
          case 1:
            jobList = _context6.sent;
            massiveDownloadJobList = jobList.map(function (job) {
              return new __WEBPACK_IMPORTED_MODULE_9__app_massive_download_models_MassiveDownloadJob__["a" /* default */](job);
            });
            commit(MUTATE_JOB_LIST, massiveDownloadJobList);
          case 2:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  }))
};
/* harmony default export */ __webpack_exports__["w"] = (MassiveDownloadState);

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getUrlProductMasterLegacy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return downloadProductMasterLegacy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return processProductMasterLegacy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getProductMasterStatusProcess; });
/* unused harmony export getUsersManagement */
/* unused harmony export updateUserRole */
/* unused harmony export postUser */
/* unused harmony export deactivateUser */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getProductMappingGroupByRetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getSignedProductMasterPostUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return postProductMasterFile; });
/* unused harmony export getLoadStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return postCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return updateLevelName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return updateCategoryDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createProductCategoryClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getLoadSequences; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return patchLoadSequence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return downloadPriceMaster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return submitDownloadProductMasterJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return pollDownloadProductMasterJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return downloadProductMaster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getRetailConfigs; });
/* unused harmony export getRetailConfigById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return updateRetailConfig; });
/* unused harmony export getUsers */
/* unused harmony export getUserById */
/* unused harmony export createUser */
/* unused harmony export updateUser */
/* unused harmony export reactivateUser */
/* unused harmony export getAvailableRoles */
/* unused harmony export getAvailableModules */
/* unused harmony export getUserPermissions */
/* unused harmony export updateUserPermissions */
/* unused harmony export getUserNotificationPreferences */
/* unused harmony export updateUserNotificationPreferences */
/* unused harmony export getUserLoginHistory */
/* unused harmony export searchUsers */
/* unused harmony export getCadenas */
/* unused harmony export getStoresByCadena */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return initClientFileUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return uploadFileToS3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getClientFileUploadStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_client_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_Services_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_models_ClientFileUpload_js__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_admin_models_ProductMasterProcessStatus_js__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_admin_models_UsersManagement_js__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_admin_models_Role_js__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_shared_models_LoadSequence_js__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_admin_models_ProductMappingInfo_js__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_admin_models_ProductMapUrl_js__ = __webpack_require__(886);











var getUrlProductMasterLegacy = /*#__PURE__*/function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get('/generate-url-product-master-legacy/');
        case 1:
          response = _context.sent;
          if (!(response.status === 200)) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", new __WEBPACK_IMPORTED_MODULE_10__app_admin_models_ProductMapUrl_js__["a" /* default */](response.data));
        case 2:
          throw new Error('Error interno en el servidor, por favor comunícate con el administrador');
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getUrlProductMasterLegacy() {
    return _ref.apply(this, arguments);
  };
}();
var downloadProductMasterLegacy = /*#__PURE__*/function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2(url) {
    var downloadProductMasterLegacyFilePromise, _t;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["d" /* CustomClient */].get(url, {
            responseType: 'blob'
          });
        case 1:
          downloadProductMasterLegacyFilePromise = _context2.sent;
          _context2.prev = 2;
          _context2.next = 3;
          return Object(__WEBPACK_IMPORTED_MODULE_3__app_shared_Services_js__["a" /* downloadFile */])(downloadProductMasterLegacyFilePromise, 'Maestro de productos.xlsx');
        case 3:
          _context2.next = 5;
          break;
        case 4:
          _context2.prev = 4;
          _t = _context2["catch"](2);
          throw new Error('Error al obtener el maestro de productos');
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 4]]);
  }));
  return function downloadProductMasterLegacy(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var processProductMasterLegacy = /*#__PURE__*/function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3() {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get('/process-product-master-legacy');
        case 1:
          response = _context3.sent;
          if (!(response.status >= 200 && response.status <= 202)) {
            _context3.next = 2;
            break;
          }
          return _context3.abrupt("return", response.data.map(function (rawProductMasterStatus) {
            return new __WEBPACK_IMPORTED_MODULE_5__app_admin_models_ProductMasterProcessStatus_js__["a" /* default */](rawProductMasterStatus);
          }));
        case 2:
          throw new Error('Error conectándose a lambda, comuníquese con su administrador');
        case 3:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function processProductMasterLegacy() {
    return _ref3.apply(this, arguments);
  };
}();
var getProductMasterStatusProcess = /*#__PURE__*/function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee4() {
    var productMasterStatus;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get('/poll-product-master-status/');
        case 1:
          productMasterStatus = _context4.sent;
          return _context4.abrupt("return", productMasterStatus.data.map(function (rawProductMasterStatus) {
            return new __WEBPACK_IMPORTED_MODULE_5__app_admin_models_ProductMasterProcessStatus_js__["a" /* default */](rawProductMasterStatus);
          }));
        case 2:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getProductMasterStatusProcess() {
    return _ref4.apply(this, arguments);
  };
}();
var getUsersManagement = /*#__PURE__*/function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee5() {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get('/user-management?active=true');
        case 1:
          response = _context5.sent;
          if (!(response.status !== 200)) {
            _context5.next = 2;
            break;
          }
          throw new Error('Error interno en el servidor, por favor comunícate con el administrador');
        case 2:
          return _context5.abrupt("return", new __WEBPACK_IMPORTED_MODULE_6__app_admin_models_UsersManagement_js__["a" /* default */](response.data));
        case 3:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function getUsersManagement() {
    return _ref5.apply(this, arguments);
  };
}();
var updateUserRole = /*#__PURE__*/function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee6(userId, roleId) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].put("/user/".concat(userId, "/role/").concat(roleId));
        case 1:
          response = _context6.sent;
          if (!(response.status !== 200)) {
            _context6.next = 2;
            break;
          }
          throw new Error('Error interno en el servidor, por favor comunícate con el administrador');
        case 2:
          if (!(roleId !== response.data.role_id)) {
            _context6.next = 3;
            break;
          }
          throw new Error('Error el rol no se ha actualizado correctamente, por favor intente nuevamente');
        case 3:
          return _context6.abrupt("return", new __WEBPACK_IMPORTED_MODULE_7__app_admin_models_Role_js__["a" /* default */](response.data));
        case 4:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function updateUserRole(_x2, _x3) {
    return _ref6.apply(this, arguments);
  };
}();
var postUser = /*#__PURE__*/function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee7(user) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/users', {
            user: user
          });
        case 1:
          response = _context7.sent;
          if (!(response.status !== 201)) {
            _context7.next = 2;
            break;
          }
          throw new Error('Error interno en el servidor, por favor comunícate con el administrador');
        case 2:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function postUser(_x4) {
    return _ref7.apply(this, arguments);
  };
}();
var deactivateUser = /*#__PURE__*/function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee8(userId) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].put("/admin/users/".concat(userId, "/deactivate"));
        case 1:
          response = _context8.sent;
          if (!(response.status !== 200)) {
            _context8.next = 2;
            break;
          }
          throw new Error('Error al desactivar el usuario');
        case 2:
          return _context8.abrupt("return", response.data);
        case 3:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function deactivateUser(_x5) {
    return _ref8.apply(this, arguments);
  };
}();
var getProductMappingGroupByRetail = /*#__PURE__*/function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee9() {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get('/product-map-retail-list');
        case 1:
          response = _context9.sent;
          if (!(response.status !== 200)) {
            _context9.next = 2;
            break;
          }
          throw new Error('Error interno en el servidor, por favor comunícate con el administrador');
        case 2:
          return _context9.abrupt("return", response.data.map(function (rawProductMappingInfo) {
            return new __WEBPACK_IMPORTED_MODULE_9__app_admin_models_ProductMappingInfo_js__["a" /* default */](rawProductMappingInfo);
          }));
        case 3:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function getProductMappingGroupByRetail() {
    return _ref9.apply(this, arguments);
  };
}();
var getSignedProductMasterPostUrl = /*#__PURE__*/function () {
  var _ref0 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee0() {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context0) {
      while (1) switch (_context0.prev = _context0.next) {
        case 0:
          _context0.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get('/sign-product-master-post-url');
        case 1:
          response = _context0.sent;
          if (!(response.status !== 200)) {
            _context0.next = 2;
            break;
          }
          throw new Error('Error al firmar la URL de subir productos');
        case 2:
          return _context0.abrupt("return", response.data);
        case 3:
        case "end":
          return _context0.stop();
      }
    }, _callee0);
  }));
  return function getSignedProductMasterPostUrl() {
    return _ref0.apply(this, arguments);
  };
}();
var postProductMasterFile = /*#__PURE__*/function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee1(xlsxProductMasterFile, _ref1) {
    var fields, url, form, response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context1) {
      while (1) switch (_context1.prev = _context1.next) {
        case 0:
          fields = _ref1.fields, url = _ref1.url;
          form = new FormData();
          Object.keys(fields).forEach(function (key) {
            form.append(key, fields[key]);
          });
          form.append('file', xlsxProductMasterFile);
          _context1.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["d" /* CustomClient */].post(url, form, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
        case 1:
          response = _context1.sent;
          if (!(response.status > 204)) {
            _context1.next = 2;
            break;
          }
          throw new Error('Error intentando subir el archivo, por favor comunícate con el administrador');
        case 2:
        case "end":
          return _context1.stop();
      }
    }, _callee1);
  }));
  return function postProductMasterFile(_x6, _x7) {
    return _ref10.apply(this, arguments);
  };
}();
var getLoadStatus = /*#__PURE__*/function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee10(granularity, startDate, endDate, metric, fact) {
    var loadStates;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["b" /* ClientErAdminData */].get('/load-sales-status/', {
            params: {
              granularity: granularity,
              start_date: startDate,
              end_date: endDate,
              metric: metric,
              fact: fact
            }
          });
        case 1:
          loadStates = _context10.sent;
          return _context10.abrupt("return", {
            columnDefs: loadStates.data.col_definition,
            data: loadStates.data.data
          });
        case 2:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return function getLoadStatus(_x8, _x9, _x0, _x1, _x10) {
    return _ref11.apply(this, arguments);
  };
}();
var postCategory = /*#__PURE__*/function () {
  var _ref13 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee11(_ref12) {
    var name, parentCategoryId, levelId, newCategory, _t2;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          name = _ref12.name, parentCategoryId = _ref12.parentCategoryId, levelId = _ref12.levelId;
          _context11.prev = 1;
          _context11.next = 2;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/categories', {
            category: {
              name: name,
              parent_category_id: parentCategoryId,
              level_id: levelId
            }
          });
        case 2:
          newCategory = _context11.sent;
          return _context11.abrupt("return", newCategory.data);
        case 3:
          _context11.prev = 3;
          _t2 = _context11["catch"](1);
          throw Error(_t2.data.error);
        case 4:
        case "end":
          return _context11.stop();
      }
    }, _callee11, null, [[1, 3]]);
  }));
  return function postCategory(_x11) {
    return _ref13.apply(this, arguments);
  };
}();
var updateLevelName = /*#__PURE__*/function () {
  var _ref14 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee12(levelId, name) {
    var response, _error$data, _t3;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.prev = 0;
          _context12.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].put("/product-category-level/".concat(levelId, "/name"), {
            name: name
          });
        case 1:
          response = _context12.sent;
          if (!(response.status !== 200)) {
            _context12.next = 2;
            break;
          }
          throw new Error('Error al actualizar el nombre del nivel');
        case 2:
          return _context12.abrupt("return", response.data);
        case 3:
          _context12.prev = 3;
          _t3 = _context12["catch"](0);
          throw Error(((_error$data = _t3.data) === null || _error$data === void 0 ? void 0 : _error$data.error) || 'Error al actualizar el nombre del nivel');
        case 4:
        case "end":
          return _context12.stop();
      }
    }, _callee12, null, [[0, 3]]);
  }));
  return function updateLevelName(_x12, _x13) {
    return _ref14.apply(this, arguments);
  };
}();
var updateCategoryDescription = /*#__PURE__*/function () {
  var _ref15 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee13(categoryId, description) {
    var response, _error$data2, _t4;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.prev = 0;
          _context13.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].put("/product-category/".concat(categoryId, "/description"), {
            description: description
          });
        case 1:
          response = _context13.sent;
          if (!(response.status !== 200)) {
            _context13.next = 2;
            break;
          }
          throw new Error('Error al actualizar la descripción de la categoría');
        case 2:
          return _context13.abrupt("return", response.data);
        case 3:
          _context13.prev = 3;
          _t4 = _context13["catch"](0);
          throw Error(((_error$data2 = _t4.data) === null || _error$data2 === void 0 ? void 0 : _error$data2.error) || 'Error al actualizar la descripción de la categoría');
        case 4:
        case "end":
          return _context13.stop();
      }
    }, _callee13, null, [[0, 3]]);
  }));
  return function updateCategoryDescription(_x14, _x15) {
    return _ref15.apply(this, arguments);
  };
}();
var createProductCategoryClass = /*#__PURE__*/function () {
  var _ref16 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee14(className) {
    var response, _error$response, _error$response2, _error$data3, _t5;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.prev = 0;
          _context14.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/product-category-class', {
            class_name: className
          });
        case 1:
          response = _context14.sent;
          if (!(response.status !== 201)) {
            _context14.next = 2;
            break;
          }
          throw new Error('Error al crear la nueva clase');
        case 2:
          return _context14.abrupt("return", response.data);
        case 3:
          _context14.prev = 3;
          _t5 = _context14["catch"](0);
          if (!(((_error$response = _t5.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 401)) {
            _context14.next = 4;
            break;
          }
          throw Error('Sesión expirada. Por favor, inicia sesión nuevamente.');
        case 4:
          throw Error(((_error$response2 = _t5.response) === null || _error$response2 === void 0 || (_error$response2 = _error$response2.data) === null || _error$response2 === void 0 ? void 0 : _error$response2.error) || ((_error$data3 = _t5.data) === null || _error$data3 === void 0 ? void 0 : _error$data3.error) || 'Error al crear la nueva clase');
        case 5:
        case "end":
          return _context14.stop();
      }
    }, _callee14, null, [[0, 3]]);
  }));
  return function createProductCategoryClass(_x16) {
    return _ref16.apply(this, arguments);
  };
}();
var getLoadSequences = /*#__PURE__*/function () {
  var _ref17 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee15(clientId) {
    var rawLoadSequences;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/client/".concat(clientId, "/load-sequences"), {
            params: {
              need_credential: true
            }
          });
        case 1:
          rawLoadSequences = _context15.sent;
          return _context15.abrupt("return", rawLoadSequences.data.map(function (rawLoadSequence) {
            return new __WEBPACK_IMPORTED_MODULE_8__app_shared_models_LoadSequence_js__["a" /* default */](rawLoadSequence);
          }));
        case 2:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return function getLoadSequences(_x17) {
    return _ref17.apply(this, arguments);
  };
}();
var patchLoadSequence = /*#__PURE__*/function () {
  var _ref18 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee16(clientId, loadSequenceId, username, password) {
    var patchedLoadSequence;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].patch("/client/".concat(clientId, "/load-sequences/").concat(loadSequenceId), {
            username: username,
            password: password
          });
        case 1:
          patchedLoadSequence = _context16.sent;
          return _context16.abrupt("return", patchedLoadSequence);
        case 2:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return function patchLoadSequence(_x18, _x19, _x20, _x21) {
    return _ref18.apply(this, arguments);
  };
}();
var downloadPriceMaster = /*#__PURE__*/function () {
  var _ref19 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee17(fileName, priceType) {
    var download, response, ext, finalFileName;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          download = __webpack_require__(115);
          _context17.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/download-price-master/?price_type=".concat(priceType), {
            responseType: 'blob'
          });
        case 1:
          response = _context17.sent;
          ext = '.xlsx';
          finalFileName = fileName + ext;
          download(response.data, finalFileName);
        case 2:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return function downloadPriceMaster(_x22, _x23) {
    return _ref19.apply(this, arguments);
  };
}();
var submitDownloadProductMasterJob = /*#__PURE__*/function () {
  var _ref20 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee18() {
    var postSubmitDownloadProductMasterJob;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/submit-download-product-master-job');
        case 1:
          postSubmitDownloadProductMasterJob = _context18.sent;
          return _context18.abrupt("return", postSubmitDownloadProductMasterJob.data);
        case 2:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return function submitDownloadProductMasterJob() {
    return _ref20.apply(this, arguments);
  };
}();
var pollDownloadProductMasterJob = /*#__PURE__*/function () {
  var _ref21 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee19(jobId) {
    var pollDownloadProductMasterJob;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/poll-job/".concat(jobId));
        case 1:
          pollDownloadProductMasterJob = _context19.sent;
          return _context19.abrupt("return", pollDownloadProductMasterJob.data);
        case 2:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  return function pollDownloadProductMasterJob(_x24) {
    return _ref21.apply(this, arguments);
  };
}();
var downloadProductMaster = /*#__PURE__*/function () {
  var _ref22 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee20(url, name) {
    var downloadProductMasterPromise, _t6;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["d" /* CustomClient */].get(url, {
            responseType: 'blob'
          });
        case 1:
          downloadProductMasterPromise = _context20.sent;
          _context20.prev = 2;
          _context20.next = 3;
          return Object(__WEBPACK_IMPORTED_MODULE_3__app_shared_Services_js__["a" /* downloadFile */])(downloadProductMasterPromise, name);
        case 3:
          _context20.next = 5;
          break;
        case 4:
          _context20.prev = 4;
          _t6 = _context20["catch"](2);
          throw new Error('Error al obtener el maestro de productos');
        case 5:
        case "end":
          return _context20.stop();
      }
    }, _callee20, null, [[2, 4]]);
  }));
  return function downloadProductMaster(_x25, _x26) {
    return _ref22.apply(this, arguments);
  };
}();
var createProduct = /*#__PURE__*/function () {
  var _ref23 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee21(productData) {
    var response, error;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/product-master/product', productData);
        case 1:
          response = _context21.sent;
          if (!(response.data && response.data.exists)) {
            _context21.next = 2;
            break;
          }
          error = new Error('El producto ya existe');
          error.data = response.data;
          throw error;
        case 2:
          return _context21.abrupt("return", response.data);
        case 3:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return function createProduct(_x27) {
    return _ref23.apply(this, arguments);
  };
}();

// Client Business Parameter API Services
var getRetailConfigs = /*#__PURE__*/function () {
  var _ref24 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee22() {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get('/client-business-parameter/retail-configs');
        case 1:
          response = _context22.sent;
          return _context22.abrupt("return", response.data);
        case 2:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  return function getRetailConfigs() {
    return _ref24.apply(this, arguments);
  };
}();
var getRetailConfigById = /*#__PURE__*/function () {
  var _ref25 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee23(retailId) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          _context23.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/client-business-parameter/retail-configs/".concat(retailId));
        case 1:
          response = _context23.sent;
          return _context23.abrupt("return", response.data);
        case 2:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
  return function getRetailConfigById(_x28) {
    return _ref25.apply(this, arguments);
  };
}();
var updateRetailConfig = /*#__PURE__*/function () {
  var _ref26 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee24(retailId, configData) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          _context24.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].patch("/client-business-parameter/retail-configs/".concat(retailId), configData);
        case 1:
          response = _context24.sent;
          return _context24.abrupt("return", response.data);
        case 2:
        case "end":
          return _context24.stop();
      }
    }, _callee24);
  }));
  return function updateRetailConfig(_x29, _x30) {
    return _ref26.apply(this, arguments);
  };
}();

// New User Management API Services based on v1/admin endpoints
var getUsers = /*#__PURE__*/function () {
  var _ref27 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee25() {
    var activeOnly,
      page,
      perPage,
      response,
      _args25 = arguments;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          activeOnly = _args25.length > 0 && _args25[0] !== undefined ? _args25[0] : true;
          page = _args25.length > 1 && _args25[1] !== undefined ? _args25[1] : 1;
          perPage = _args25.length > 2 && _args25[2] !== undefined ? _args25[2] : 20;
          _context25.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get('/admin/users', {
            params: {
              active_only: activeOnly,
              page: page,
              per_page: perPage
            }
          });
        case 1:
          response = _context25.sent;
          if (!(response.status !== 200)) {
            _context25.next = 2;
            break;
          }
          throw new Error('Error interno en el servidor, por favor comunícate con el administrador');
        case 2:
          return _context25.abrupt("return", response.data);
        case 3:
        case "end":
          return _context25.stop();
      }
    }, _callee25);
  }));
  return function getUsers() {
    return _ref27.apply(this, arguments);
  };
}();
var getUserById = /*#__PURE__*/function () {
  var _ref28 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee26(userId) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          _context26.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/admin/users/".concat(userId));
        case 1:
          response = _context26.sent;
          if (!(response.status !== 200)) {
            _context26.next = 2;
            break;
          }
          throw new Error('Error interno en el servidor, por favor comunícate con el administrador');
        case 2:
          return _context26.abrupt("return", response.data);
        case 3:
        case "end":
          return _context26.stop();
      }
    }, _callee26);
  }));
  return function getUserById(_x31) {
    return _ref28.apply(this, arguments);
  };
}();
var createUser = /*#__PURE__*/function () {
  var _ref29 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee27(userData) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          _context27.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/admin/users', {
            user: userData
          });
        case 1:
          response = _context27.sent;
          if (!(response.status !== 201)) {
            _context27.next = 2;
            break;
          }
          throw new Error('Error interno en el servidor, por favor comunícate con el administrador');
        case 2:
          return _context27.abrupt("return", response.data);
        case 3:
        case "end":
          return _context27.stop();
      }
    }, _callee27);
  }));
  return function createUser(_x32) {
    return _ref29.apply(this, arguments);
  };
}();
var updateUser = /*#__PURE__*/function () {
  var _ref30 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee28(userId, userData) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          _context28.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].put("/admin/users/".concat(userId), {
            user: userData
          });
        case 1:
          response = _context28.sent;
          if (!(response.status !== 200)) {
            _context28.next = 2;
            break;
          }
          throw new Error('Error interno en el servidor, por favor comunícate con el administrador');
        case 2:
          return _context28.abrupt("return", response.data);
        case 3:
        case "end":
          return _context28.stop();
      }
    }, _callee28);
  }));
  return function updateUser(_x33, _x34) {
    return _ref30.apply(this, arguments);
  };
}();
var reactivateUser = /*#__PURE__*/function () {
  var _ref31 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee29(userId) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          _context29.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].put("/admin/users/".concat(userId, "/reactivate"));
        case 1:
          response = _context29.sent;
          if (!(response.status !== 200)) {
            _context29.next = 2;
            break;
          }
          throw new Error('Error interno en el servidor, por favor comunícate con el administrador');
        case 2:
          return _context29.abrupt("return", response.data);
        case 3:
        case "end":
          return _context29.stop();
      }
    }, _callee29);
  }));
  return function reactivateUser(_x35) {
    return _ref31.apply(this, arguments);
  };
}();
var getAvailableRoles = /*#__PURE__*/function () {
  var _ref32 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee30() {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          _context30.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get('/admin/users/roles');
        case 1:
          response = _context30.sent;
          if (!(response.status !== 200)) {
            _context30.next = 2;
            break;
          }
          throw new Error('Error interno en el servidor, por favor comunícate con el administrador');
        case 2:
          return _context30.abrupt("return", response.data);
        case 3:
        case "end":
          return _context30.stop();
      }
    }, _callee30);
  }));
  return function getAvailableRoles() {
    return _ref32.apply(this, arguments);
  };
}();
var getAvailableModules = /*#__PURE__*/function () {
  var _ref33 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee31() {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          _context31.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get('/admin/users/modules');
        case 1:
          response = _context31.sent;
          if (!(response.status !== 200)) {
            _context31.next = 2;
            break;
          }
          throw new Error('Error interno en el servidor, por favor comunícate con el administrador');
        case 2:
          return _context31.abrupt("return", response.data);
        case 3:
        case "end":
          return _context31.stop();
      }
    }, _callee31);
  }));
  return function getAvailableModules() {
    return _ref33.apply(this, arguments);
  };
}();
var getUserPermissions = /*#__PURE__*/function () {
  var _ref34 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee32(userId) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context32) {
      while (1) switch (_context32.prev = _context32.next) {
        case 0:
          _context32.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/admin/users/".concat(userId, "/permissions"));
        case 1:
          response = _context32.sent;
          if (!(response.status !== 200)) {
            _context32.next = 2;
            break;
          }
          throw new Error('Error interno en el servidor, por favor comunícate con el administrador');
        case 2:
          return _context32.abrupt("return", response.data);
        case 3:
        case "end":
          return _context32.stop();
      }
    }, _callee32);
  }));
  return function getUserPermissions(_x36) {
    return _ref34.apply(this, arguments);
  };
}();
var updateUserPermissions = /*#__PURE__*/function () {
  var _ref35 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee33(userId, permissions) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context33) {
      while (1) switch (_context33.prev = _context33.next) {
        case 0:
          _context33.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].put("/admin/users/".concat(userId, "/permissions"), {
            permissions: permissions
          });
        case 1:
          response = _context33.sent;
          if (!(response.status !== 200)) {
            _context33.next = 2;
            break;
          }
          throw new Error('Error interno en el servidor, por favor comunícate con el administrador');
        case 2:
          return _context33.abrupt("return", response.data);
        case 3:
        case "end":
          return _context33.stop();
      }
    }, _callee33);
  }));
  return function updateUserPermissions(_x37, _x38) {
    return _ref35.apply(this, arguments);
  };
}();
var getUserNotificationPreferences = /*#__PURE__*/function () {
  var _ref36 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee34(userId) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context34) {
      while (1) switch (_context34.prev = _context34.next) {
        case 0:
          _context34.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/admin/users/".concat(userId, "/notification-preferences"));
        case 1:
          response = _context34.sent;
          if (!(response.status !== 200)) {
            _context34.next = 2;
            break;
          }
          throw new Error('Error interno en el servidor, por favor comunícate con el administrador');
        case 2:
          return _context34.abrupt("return", response.data);
        case 3:
        case "end":
          return _context34.stop();
      }
    }, _callee34);
  }));
  return function getUserNotificationPreferences(_x39) {
    return _ref36.apply(this, arguments);
  };
}();
var updateUserNotificationPreferences = /*#__PURE__*/function () {
  var _ref37 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee35(userId, preferences) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context35) {
      while (1) switch (_context35.prev = _context35.next) {
        case 0:
          _context35.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].put("/admin/users/".concat(userId, "/notification-preferences"), preferences);
        case 1:
          response = _context35.sent;
          if (!(response.status !== 200)) {
            _context35.next = 2;
            break;
          }
          throw new Error('Error interno en el servidor, por favor comunícate con el administrador');
        case 2:
          return _context35.abrupt("return", response.data);
        case 3:
        case "end":
          return _context35.stop();
      }
    }, _callee35);
  }));
  return function updateUserNotificationPreferences(_x40, _x41) {
    return _ref37.apply(this, arguments);
  };
}();
var getUserLoginHistory = /*#__PURE__*/function () {
  var _ref38 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee36(userId) {
    var limit,
      response,
      _args36 = arguments;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context36) {
      while (1) switch (_context36.prev = _context36.next) {
        case 0:
          limit = _args36.length > 1 && _args36[1] !== undefined ? _args36[1] : 50;
          _context36.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/admin/users/".concat(userId, "/login-history"), {
            params: {
              limit: limit
            }
          });
        case 1:
          response = _context36.sent;
          if (!(response.status !== 200)) {
            _context36.next = 2;
            break;
          }
          throw new Error('Error al obtener el historial de login del usuario');
        case 2:
          return _context36.abrupt("return", response.data);
        case 3:
        case "end":
          return _context36.stop();
      }
    }, _callee36);
  }));
  return function getUserLoginHistory(_x42) {
    return _ref38.apply(this, arguments);
  };
}();

// Search users across all statuses
var searchUsers = /*#__PURE__*/function () {
  var _ref39 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee37(searchQuery) {
    var limit,
      response,
      _args37 = arguments;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context37) {
      while (1) switch (_context37.prev = _context37.next) {
        case 0:
          limit = _args37.length > 1 && _args37[1] !== undefined ? _args37[1] : 10;
          _context37.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get('/admin/users/search', {
            params: {
              q: searchQuery,
              limit: limit
            }
          });
        case 1:
          response = _context37.sent;
          return _context37.abrupt("return", response.data);
        case 2:
        case "end":
          return _context37.stop();
      }
    }, _callee37);
  }));
  return function searchUsers(_x43) {
    return _ref39.apply(this, arguments);
  };
}();

// Business Permissions API Services
var getCadenas = /*#__PURE__*/function () {
  var _ref40 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee38() {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context38) {
      while (1) switch (_context38.prev = _context38.next) {
        case 0:
          _context38.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get('/client-business-parameter/retail-configs');
        case 1:
          response = _context38.sent;
          return _context38.abrupt("return", response.data);
        case 2:
        case "end":
          return _context38.stop();
      }
    }, _callee38);
  }));
  return function getCadenas() {
    return _ref40.apply(this, arguments);
  };
}();
var getStoresByCadena = /*#__PURE__*/function () {
  var _ref41 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee39(retailId) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context39) {
      while (1) switch (_context39.prev = _context39.next) {
        case 0:
          _context39.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/stores/by-retail/".concat(retailId));
        case 1:
          response = _context39.sent;
          return _context39.abrupt("return", response.data);
        case 2:
        case "end":
          return _context39.stop();
      }
    }, _callee39);
  }));
  return function getStoresByCadena(_x44) {
    return _ref41.apply(this, arguments);
  };
}();

// ── Client File Upload ──

var initClientFileUpload = /*#__PURE__*/function () {
  var _ref42 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee40(type, filenames) {
    var parameters,
      body,
      response,
      _args40 = arguments;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context40) {
      while (1) switch (_context40.prev = _context40.next) {
        case 0:
          parameters = _args40.length > 2 && _args40[2] !== undefined ? _args40[2] : {};
          body = {
            type: type,
            files: filenames
          };
          if (Object.keys(parameters).length > 0) body.parameters = parameters;
          _context40.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/client-file-upload/init', body);
        case 1:
          response = _context40.sent;
          if (!(response.status !== 201)) {
            _context40.next = 2;
            break;
          }
          throw new Error('Error al iniciar la subida de archivos');
        case 2:
          return _context40.abrupt("return", new __WEBPACK_IMPORTED_MODULE_4__app_shared_models_ClientFileUpload_js__["a" /* default */](response.data));
        case 3:
        case "end":
          return _context40.stop();
      }
    }, _callee40);
  }));
  return function initClientFileUpload(_x45, _x46) {
    return _ref42.apply(this, arguments);
  };
}();
var uploadFileToS3 = function uploadFileToS3(presignedUrl, file) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open('PUT', presignedUrl);
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) resolve();else reject(new Error("Error al subir el archivo ".concat(file.name, " a S3")));
    };
    xhr.onerror = function () {
      return reject(new Error("Error de red al subir ".concat(file.name)));
    };
    // Blob sin tipo → el browser no agrega Content-Type header
    xhr.send(new Blob([file]));
  });
};
var getClientFileUploadStatus = /*#__PURE__*/function () {
  var _ref43 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee41(uploadId) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context41) {
      while (1) switch (_context41.prev = _context41.next) {
        case 0:
          _context41.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/client-file-upload/".concat(uploadId));
        case 1:
          response = _context41.sent;
          if (!(response.status === 404)) {
            _context41.next = 2;
            break;
          }
          throw new Error('Subida no encontrada');
        case 2:
          if (!(response.status !== 200)) {
            _context41.next = 3;
            break;
          }
          throw new Error('Error al obtener el estado de la subida');
        case 3:
          return _context41.abrupt("return", new __WEBPACK_IMPORTED_MODULE_4__app_shared_models_ClientFileUpload_js__["a" /* default */](response.data));
        case 4:
        case "end":
          return _context41.stop();
      }
    }, _callee41);
  }));
  return function getClientFileUploadStatus(_x47) {
    return _ref43.apply(this, arguments);
  };
}();


/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createRun; });
/* unused harmony export getRun */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return pollUntilDone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createRunWithUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return uploadToS3; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_client_js__ = __webpack_require__(39);



var createRun = /*#__PURE__*/function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee(executorName, requestPayload) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/executor-runs', {
            executor_name: executorName,
            request_payload: requestPayload
          });
        case 1:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function createRun(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var getRun = /*#__PURE__*/function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2(runId) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/executor-runs/".concat(runId));
        case 1:
          response = _context2.sent;
          return _context2.abrupt("return", response.data);
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getRun(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
var POLL_TIMEOUT_MS = 15 * 60 * 1000; // 15 minutes

/**
 * Polls a run until it reaches DONE or ERROR status.
 * Rejects with 'timeout' after 15 minutes or 'cancelled' if cancel() is called.
 * Returns { promise, cancel }.
 */
var pollUntilDone = function pollUntilDone(runId) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    onProgress = _ref3.onProgress,
    _ref3$intervalMs = _ref3.intervalMs,
    intervalMs = _ref3$intervalMs === void 0 ? 2000 : _ref3$intervalMs;
  var cancelled = false;
  var timerId = null;
  var timeoutId = null;
  var rejectFn = null;
  var promise = new Promise(function (resolve, reject) {
    rejectFn = reject;
    timeoutId = setTimeout(function () {
      cancelled = true;
      if (timerId) {
        clearTimeout(timerId);
        timerId = null;
      }
      reject(new Error('timeout'));
    }, POLL_TIMEOUT_MS);
    var _tick = /*#__PURE__*/function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3() {
        var run, _t;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!cancelled) {
                _context3.next = 1;
                break;
              }
              return _context3.abrupt("return");
            case 1:
              _context3.prev = 1;
              _context3.next = 2;
              return getRun(runId);
            case 2:
              run = _context3.sent;
              if (onProgress) onProgress(run);
              if (run.status === 'DONE' || run.status === 'ERROR') {
                clearTimeout(timeoutId);
                resolve(run);
              } else if (!cancelled) {
                timerId = setTimeout(_tick, intervalMs);
              }
              _context3.next = 4;
              break;
            case 3:
              _context3.prev = 3;
              _t = _context3["catch"](1);
              if (!cancelled) {
                clearTimeout(timeoutId);
                reject(_t);
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 3]]);
      }));
      return function tick() {
        return _ref4.apply(this, arguments);
      };
    }();
    _tick();
  });
  var cancel = function cancel() {
    if (cancelled) return;
    cancelled = true;
    if (timerId) {
      clearTimeout(timerId);
      timerId = null;
    }
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
    if (rejectFn) rejectFn(new Error('cancelled'));
  };
  return {
    promise: promise,
    cancel: cancel
  };
};

/**
 * Creates a run that expects a file upload via presigned S3 URL.
 * Returns { run_id, files: [{ filename, s3_key, presigned_url }] }
 */
var createRunWithUpload = /*#__PURE__*/function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee4(executorName, filenames) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/executor-runs/with-upload', {
            executor_name: executorName,
            filenames: filenames
          });
        case 1:
          response = _context4.sent;
          return _context4.abrupt("return", response.data);
        case 2:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function createRunWithUpload(_x4, _x5) {
    return _ref5.apply(this, arguments);
  };
}();

/**
 * Uploads a file to S3 using a presigned PUT URL.
 * Does NOT use ClientLambdaApi to avoid injecting Authorization headers.
 */
var uploadToS3 = /*#__PURE__*/function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee5(presignedUrl, file, contentType) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 1;
          return fetch(presignedUrl, {
            method: 'PUT',
            headers: {
              'Content-Type': contentType
            },
            body: file
          });
        case 1:
          response = _context5.sent;
          if (response.ok) {
            _context5.next = 2;
            break;
          }
          throw new Error("S3 upload failed: ".concat(response.status));
        case 2:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function uploadToS3(_x6, _x7, _x8) {
    return _ref6.apply(this, arguments);
  };
}();


/***/ }),
/* 719 */,
/* 720 */,
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageHeader_vue__ = __webpack_require__(635);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07c272a6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageHeader_vue__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1028)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07c272a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07c272a6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageHeader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07c272a6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageHeader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExecutorProgressFloat_vue__ = __webpack_require__(631);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6a9fa6e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExecutorProgressFloat_vue__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1009)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f6a9fa6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExecutorProgressFloat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6a9fa6e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExecutorProgressFloat_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6a9fa6e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExecutorProgressFloat_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMESPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_utils_NamespaceHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_stock_break_Services__ = __webpack_require__(866);


var _actions;



var NAMESPACE = 'stockBreak/';
var _types = {
  getters: {
    DEFAULT_BREAK_PRODUCT: 'DEFAULT_BREAK_PRODUCT',
    DEFAULT_RETAIL: 'DEFAULT_RETAIL',
    UNSELECTED_BREAK_PRODUCTS: 'UNSELECTED_BREAK_PRODUCTS',
    APPLIED_FILTERS_QTY: 'APPLIED_FILTERS_QTY'
  },
  actions: {
    INIT: 'INIT',
    INIT_RETAIL_LIST: 'INIT_RETAIL_LIST',
    INIT_DIMENSION_FILTER: 'INIT_DIMENSION_FILTER',
    INIT_GRID: 'INIT_GRID',
    FETCH_RETAIL_LIST: 'FETCH_RETAIL_LIST',
    FETCH_BREAK_PRODUCTS: 'FETCH_BREAK_PRODUCTS',
    FETCH_STOCK_BREAK_GRID: 'FETCH_STOCK_BREAK_GRID',
    FETCH_RETAIL_STORE_LIST: 'FETCH_RETAIL_STORE_LIST',
    DOWNLOAD_STOCK_BREAK_TO_XLSX: 'DOWNLOAD_STOCK_BREAK_TO_XLSX',
    CHANGE_RETAIL: 'CHANGE_RETAIL',
    CHANGE_BREAK_PRODUCT: 'CHANGE_BREAK_PRODUCT',
    APPLY_STORE_FILTERS: 'APPLY_STORE_FILTERS'
  },
  mutations: {
    SET_RETAIL_LIST: 'SET_RETAIL_LIST',
    TOGGLE_GRID: 'TOGGLE_GRID',
    SET_BREAK_PRODUCTS: 'SET_BREAK_PRODUCTS',
    SET_GRID: 'SET_GRID',
    SET_SELECTED_RETAIL: 'SET_SELECTED_RETAIL',
    SET_SELECTED_BREAK_PRODUCT: 'SET_SELECTED_BREAK_PRODUCT',
    SET_CLIENT_DIMENSION_FILTER_KEY: 'SET_CLIENT_DIMENSION_FILTER_KEY',
    SET_STORE_FILTERS: 'SET_STORE_FILTERS',
    RESET_STATE: 'RESET_STATE'
  }
};
var Types = Object(__WEBPACK_IMPORTED_MODULE_3__app_shared_utils_NamespaceHelper__["a" /* addNamespace */])(NAMESPACE, _types);
var initState = function initState() {
  return {
    retailList: null,
    breakProducts: null,
    grid: null,
    selectedBreakProduct: null,
    selectedRetail: null,
    clientDimensionFilterKey: null,
    downloadingGrid: false,
    appliedStoreFilters: []
  };
};
var Index = {
  namespaced: true,
  state: initState(),
  getters: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.getters.DEFAULT_RETAIL, function (state) {
    return state.retailList[0];
  }), _types.getters.DEFAULT_BREAK_PRODUCT, function (state) {
    return state.breakProducts ? state.breakProducts[0] : undefined;
  }), _types.getters.UNSELECTED_BREAK_PRODUCTS, function (state) {
    return state.breakProducts.filter(function (breakProduct) {
      return breakProduct.id !== state.selectedBreakProduct.id;
    });
  }), _types.getters.APPLIED_FILTERS_QTY, function (state) {
    return state.appliedStoreFilters.length;
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.mutations.SET_BREAK_PRODUCTS, function (state, breakProducts) {
    state.breakProducts = breakProducts;
  }), _types.mutations.SET_RETAIL_LIST, function (state, retailList) {
    state.retailList = retailList;
  }), _types.mutations.SET_SELECTED_RETAIL, function (state, selectedRetail) {
    state.selectedRetail = selectedRetail;
  }), _types.mutations.SET_SELECTED_BREAK_PRODUCT, function (state, selectedBreakProduct) {
    state.selectedBreakProduct = selectedBreakProduct;
  }), _types.mutations.SET_GRID, function (state, grid) {
    state.grid = grid;
  }), _types.mutations.SET_CLIENT_DIMENSION_FILTER_KEY, function (state, clientDimensionFilterKey) {
    state.clientDimensionFilterKey = clientDimensionFilterKey;
  }), _types.mutations.SET_STORE_FILTERS, function (state, storeFilters) {
    state.appliedStoreFilters = storeFilters;
  }), _types.mutations.TOGGLE_GRID, function (state) {
    state.downloadingGrid = !state.downloadingGrid;
  }), _types.mutations.RESET_STATE, function (state) {
    Object.assign(state, initState());
  }),
  actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_actions, _types.actions.INIT, function (_ref, clientDimensionFilterKey) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
      var dispatch, commit;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch = _ref.dispatch, commit = _ref.commit;
            commit(_types.mutations.SET_CLIENT_DIMENSION_FILTER_KEY, clientDimensionFilterKey);
            _context.next = 1;
            return dispatch(_types.actions.INIT_RETAIL_LIST);
          case 1:
            _context.next = 2;
            return dispatch(_types.actions.INIT_DIMENSION_FILTER);
          case 2:
            _context.next = 3;
            return dispatch(_types.actions.INIT_GRID);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }), _types.actions.INIT_RETAIL_LIST, function (_ref2) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
      var dispatch, getters, commit, defaultRetail;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dispatch = _ref2.dispatch, getters = _ref2.getters, commit = _ref2.commit;
            _context2.next = 1;
            return dispatch(_types.actions.FETCH_RETAIL_LIST);
          case 1:
            defaultRetail = getters[_types.getters.DEFAULT_RETAIL];
            commit(_types.mutations.SET_SELECTED_RETAIL, defaultRetail);
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }), _types.actions.INIT_DIMENSION_FILTER, function (_ref3) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3() {
      var state, dispatch, getters, commit, selectedRetail, clientDimensionFilterKey, defaultBreakProduct;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            state = _ref3.state, dispatch = _ref3.dispatch, getters = _ref3.getters, commit = _ref3.commit;
            selectedRetail = state.selectedRetail, clientDimensionFilterKey = state.clientDimensionFilterKey;
            _context3.next = 1;
            return dispatch(_types.actions.FETCH_BREAK_PRODUCTS, {
              retailId: selectedRetail.retail_id,
              clientDimensionFilterKey: clientDimensionFilterKey
            });
          case 1:
            defaultBreakProduct = getters[_types.getters.DEFAULT_BREAK_PRODUCT];
            commit(_types.mutations.SET_SELECTED_BREAK_PRODUCT, defaultBreakProduct);
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }), _types.actions.INIT_GRID, function (_ref4) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee4() {
      var dispatch, state, _state$selectedBreakP, productMetadata, productFilterFieldValue;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            dispatch = _ref4.dispatch, state = _ref4.state;
            _state$selectedBreakP = state.selectedBreakProduct, productMetadata = _state$selectedBreakP.metadata, productFilterFieldValue = _state$selectedBreakP.id;
            _context4.next = 1;
            return dispatch(_types.actions.FETCH_STOCK_BREAK_GRID, {
              productFilterFieldKey: productMetadata.field,
              productFilterFieldValue: productFilterFieldValue
            });
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  }), _types.actions.FETCH_RETAIL_LIST, function (_ref5) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee5() {
      var commit, retailList;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            commit = _ref5.commit;
            _context5.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_4__app_stock_break_Services__["c" /* getRetailList */])();
          case 1:
            retailList = _context5.sent;
            commit(_types.mutations.SET_RETAIL_LIST, retailList);
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  }), _types.actions.FETCH_BREAK_PRODUCTS, function (_ref6, _ref7) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee6() {
      var commit, retailId, clientDimensionFilterKey, breakProducts;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            commit = _ref6.commit;
            retailId = _ref7.retailId, clientDimensionFilterKey = _ref7.clientDimensionFilterKey;
            _context6.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_4__app_stock_break_Services__["b" /* getBreakProductsByRetailId */])(retailId, clientDimensionFilterKey);
          case 1:
            breakProducts = _context6.sent;
            commit(_types.mutations.SET_BREAK_PRODUCTS, breakProducts);
          case 2:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  }), _types.actions.FETCH_STOCK_BREAK_GRID, function (_ref8, _ref9) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee7() {
      var state, commit, productFilterFieldKey, productFilterFieldValue, _ref9$storeIds, storeIds, stockBreakGrid;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            state = _ref8.state, commit = _ref8.commit;
            productFilterFieldKey = _ref9.productFilterFieldKey, productFilterFieldValue = _ref9.productFilterFieldValue, _ref9$storeIds = _ref9.storeIds, storeIds = _ref9$storeIds === void 0 ? [] : _ref9$storeIds;
            commit(_types.mutations.TOGGLE_GRID);
            _context7.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_4__app_stock_break_Services__["e" /* getStockBreakGrid */])(state.selectedRetail.retail_id, productFilterFieldKey, productFilterFieldValue, storeIds);
          case 1:
            stockBreakGrid = _context7.sent;
            commit(_types.mutations.SET_GRID, stockBreakGrid);
            commit(_types.mutations.TOGGLE_GRID);
          case 2:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }))();
  }), _types.actions.FETCH_RETAIL_STORE_LIST, function (_ref0) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee8() {
      var state, retailStoreList;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            state = _ref0.state;
            _context8.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_4__app_stock_break_Services__["d" /* getRetailStoreList */])(state.selectedRetail.retail_id);
          case 1:
            retailStoreList = _context8.sent;
            return _context8.abrupt("return", retailStoreList);
          case 2:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }))();
  }), _types.actions.DOWNLOAD_STOCK_BREAK_TO_XLSX, function (_) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_4__app_stock_break_Services__["a" /* downloadStockBreakToXlsx */])();
          case 1:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }))();
  }), _types.actions.CHANGE_RETAIL, function (_ref1, retail) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee0() {
      var commit, dispatch;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            commit = _ref1.commit, dispatch = _ref1.dispatch;
            commit(_types.mutations.SET_SELECTED_RETAIL, retail);
            _context0.next = 1;
            return dispatch(_types.actions.INIT_DIMENSION_FILTER);
          case 1:
            _context0.next = 2;
            return dispatch(_types.actions.INIT_GRID);
          case 2:
          case "end":
            return _context0.stop();
        }
      }, _callee0);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_actions, _types.actions.CHANGE_BREAK_PRODUCT, function (_ref10, breakProduct) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee1() {
      var commit, dispatch;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context1) {
        while (1) switch (_context1.prev = _context1.next) {
          case 0:
            commit = _ref10.commit, dispatch = _ref10.dispatch;
            commit(_types.mutations.SET_SELECTED_BREAK_PRODUCT, breakProduct);
            _context1.next = 1;
            return dispatch(_types.actions.INIT_GRID);
          case 1:
          case "end":
            return _context1.stop();
        }
      }, _callee1);
    }))();
  }), _types.actions.APPLY_STORE_FILTERS, function (_ref11, selectedStores) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee10() {
      var state, dispatch, commit, _state$selectedBreakP2, productMetadata, productFilterFieldValue, storeIds;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            state = _ref11.state, dispatch = _ref11.dispatch, commit = _ref11.commit;
            commit(_types.mutations.SET_STORE_FILTERS, selectedStores);
            _state$selectedBreakP2 = state.selectedBreakProduct, productMetadata = _state$selectedBreakP2.metadata, productFilterFieldValue = _state$selectedBreakP2.id;
            storeIds = selectedStores.map(function (store) {
              return store.store_id;
            });
            _context10.next = 1;
            return dispatch(_types.actions.FETCH_STOCK_BREAK_GRID, {
              productFilterFieldKey: productMetadata.field,
              productFilterFieldValue: productFilterFieldValue,
              storeIds: storeIds
            });
          case 1:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }))();
  }))
};
/* harmony default export */ __webpack_exports__["c"] = (Index);

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getGoogleOAuthUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return googleOAuthTokenValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getMicrosoftOAuthUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return microsoftOAuthTokenValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return requestPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return putPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return updateRegion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return samlLoginByEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_client_js__ = __webpack_require__(39);



var login = /*#__PURE__*/function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee(email, password) {
    var authResponse;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/api-token-auth/', {
            email: email,
            password: password
          });
        case 1:
          authResponse = _context.sent;
          return _context.abrupt("return", authResponse.data);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function login(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var getGoogleOAuthUrl = /*#__PURE__*/function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
    var isProduction, redirectUri, oauthResponse;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          // Determine redirect URI based on environment
          isProduction = "production" === 'production';
          if (isProduction) {
            // Production URL - adjust this to your actual production domain
            redirectUri = "".concat(window.location.origin, "/auth/google-callback");
          } else {
            // Development URL
            redirectUri = "".concat(window.location.origin, "/auth/google-callback");
          }
          _context2.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('google-oauth/auth-url', {
            redirect_uri: redirectUri,
            state: Math.random().toString(36).substring(2, 15),
            // Generate random state for CSRF protection
            scopes: ['openid', 'email', 'profile']
          });
        case 1:
          oauthResponse = _context2.sent;
          return _context2.abrupt("return", oauthResponse.data);
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getGoogleOAuthUrl() {
    return _ref2.apply(this, arguments);
  };
}();
var requestPassword = /*#__PURE__*/function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3(email) {
    var resetPasswordResponse;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/request-new-password/".concat(email));
        case 1:
          resetPasswordResponse = _context3.sent;
          return _context3.abrupt("return", resetPasswordResponse.data);
        case 2:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function requestPassword(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
var putPassword = /*#__PURE__*/function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee4(password, token) {
    var updatePasswordResponse;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].put('/update-password/', {
            token: token,
            password: password
          });
        case 1:
          updatePasswordResponse = _context4.sent;
          return _context4.abrupt("return", updatePasswordResponse.data);
        case 2:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function putPassword(_x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();
var updateRegion = /*#__PURE__*/function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee5(regionId) {
    var updateRegionResponse;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].put("/selected-region/".concat(regionId));
        case 1:
          updateRegionResponse = _context5.sent;
          return _context5.abrupt("return", updateRegionResponse.data);
        case 2:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function updateRegion(_x6) {
    return _ref5.apply(this, arguments);
  };
}();
var googleOAuthTokenValidation = /*#__PURE__*/function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee6(authorizationCode) {
    var isProduction, redirectUri, authResponse;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          // Determine redirect URI based on environment (same logic as getGoogleOAuthUrl)
          isProduction = "production" === 'production';
          if (isProduction) {
            redirectUri = "".concat(window.location.origin, "/auth/google-callback");
          } else {
            redirectUri = "".concat(window.location.origin, "/auth/google-callback");
          }
          _context6.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/google-oauth', {
            code: authorizationCode,
            redirect_uri: redirectUri,
            device: 'desktop'
          });
        case 1:
          authResponse = _context6.sent;
          return _context6.abrupt("return", authResponse.data);
        case 2:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function googleOAuthTokenValidation(_x7) {
    return _ref6.apply(this, arguments);
  };
}();
var getMicrosoftOAuthUrl = /*#__PURE__*/function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee7() {
    var isProduction, redirectUri, oauthResponse;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          // Determine redirect URI based on environment
          isProduction = "production" === 'production';
          if (isProduction) {
            // Production URL - adjust this to your actual production domain
            redirectUri = "".concat(window.location.origin, "/auth/microsoft-callback");
          } else {
            // Development URL
            redirectUri = "".concat(window.location.origin, "/auth/microsoft-callback");
          }
          _context7.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('microsoft-oauth/auth-url', {
            redirect_uri: redirectUri,
            state: Math.random().toString(36).substring(2, 15) // Generate random state for CSRF protection
          });
        case 1:
          oauthResponse = _context7.sent;
          return _context7.abrupt("return", oauthResponse.data);
        case 2:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function getMicrosoftOAuthUrl() {
    return _ref7.apply(this, arguments);
  };
}();
var microsoftOAuthTokenValidation = /*#__PURE__*/function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee8(authorizationCode) {
    var isProduction, redirectUri, authResponse;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          // Determine redirect URI based on environment (same logic as getMicrosoftOAuthUrl)
          isProduction = "production" === 'production';
          if (isProduction) {
            redirectUri = "".concat(window.location.origin, "/auth/microsoft-callback");
          } else {
            redirectUri = "".concat(window.location.origin, "/auth/microsoft-callback");
          }
          _context8.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/microsoft-oauth', {
            code: authorizationCode,
            redirect_uri: redirectUri,
            device: 'desktop'
          });
        case 1:
          authResponse = _context8.sent;
          return _context8.abrupt("return", authResponse.data);
        case 2:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function microsoftOAuthTokenValidation(_x8) {
    return _ref8.apply(this, arguments);
  };
}();
var samlLoginByEmail = /*#__PURE__*/function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee9(email) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/saml/login-by-email', {
            email: email
          });
        case 1:
          response = _context9.sent;
          return _context9.abrupt("return", response.data);
        case 2:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function samlLoginByEmail(_x9) {
    return _ref9.apply(this, arguments);
  };
}();
var logout = /*#__PURE__*/function () {
  var _ref0 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee0() {
    var logoutResponse;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context0) {
      while (1) switch (_context0.prev = _context0.next) {
        case 0:
          _context0.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/api-token-logout/');
        case 1:
          logoutResponse = _context0.sent;
          return _context0.abrupt("return", logoutResponse.data);
        case 2:
        case "end":
          return _context0.stop();
      }
    }, _callee0);
  }));
  return function logout() {
    return _ref0.apply(this, arguments);
  };
}();


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_utils_NamespaceHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_admin_Services__ = __webpack_require__(717);


function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



var NAMESPACE = 'admin/category/';
var _types = {
  getters: {
    GET_PRODUCT_CATEGORIES: 'GET_PRODUCT_CATEGORIES'
  },
  actions: {
    ADD_CATEGORY: 'ADD_CATEGORY',
    UPDATE_LEVEL_NAME: 'UPDATE_LEVEL_NAME',
    CREATE_CLASS: 'CREATE_CLASS'
  },
  mutations: {
    ADD_CATEGORY: 'ADD_CATEGORY',
    UPDATE_LEVEL_NAME: 'UPDATE_LEVEL_NAME',
    ADD_CLASS: 'ADD_CLASS'
  }
};
var Types = Object(__WEBPACK_IMPORTED_MODULE_3__app_shared_utils_NamespaceHelper__["a" /* addNamespace */])(NAMESPACE, _types);
var Category = {
  namespaced: true,
  getters: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.getters.GET_PRODUCT_CATEGORIES, function (state, getters, rootState) {
    var _rootState$desktopPar;
    return (_rootState$desktopPar = rootState.desktopParameterConfig) === null || _rootState$desktopPar === void 0 ? void 0 : _rootState$desktopPar.productCategoryFilters;
  }),
  actions: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.actions.ADD_CATEGORY, function (_ref, category) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
      var commit, rootState, newCategory;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit, rootState = _ref.rootState;
            _context.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_4__app_admin_Services__["p" /* postCategory */])(category);
          case 1:
            newCategory = _context.sent;
            commit(_types.mutations.ADD_CATEGORY, {
              rootState: rootState,
              newCategory: newCategory,
              levelId: category.levelId
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }), _types.actions.UPDATE_LEVEL_NAME, function (_ref2, _ref3) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
      var commit, rootState, levelId, name;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref2.commit, rootState = _ref2.rootState;
            levelId = _ref3.levelId, name = _ref3.name;
            _context2.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_4__app_admin_Services__["u" /* updateLevelName */])(levelId, name);
          case 1:
            commit(_types.mutations.UPDATE_LEVEL_NAME, {
              rootState: rootState,
              levelId: levelId,
              newName: name
            });
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }), _types.actions.CREATE_CLASS, function (_ref4, className) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3() {
      var commit, rootState, response;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref4.commit, rootState = _ref4.rootState;
            _context3.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_4__app_admin_Services__["b" /* createProductCategoryClass */])(className);
          case 1:
            response = _context3.sent;
            commit(_types.mutations.ADD_CLASS, {
              rootState: rootState,
              classData: response
            });
            return _context3.abrupt("return", response);
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.mutations.ADD_CATEGORY, function (_, _ref5) {
    var rootState = _ref5.rootState,
      newCategory = _ref5.newCategory,
      levelId = _ref5.levelId;
    var classTarget = rootState.desktopParameterConfig.productCategoryFilters.find(function (_class) {
      return _class.id === newCategory.class_id;
    });
    var levelTarget = classTarget.levelList.find(function (level) {
      return level.levelId === levelId;
    });
    levelTarget.options.push(_objectSpread({}, newCategory));
  }), _types.mutations.UPDATE_LEVEL_NAME, function (_, _ref6) {
    var rootState = _ref6.rootState,
      levelId = _ref6.levelId,
      newName = _ref6.newName;
    var allClasses = rootState.desktopParameterConfig.productCategoryFilters;
    var _iterator = _createForOfIteratorHelper(allClasses),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var classData = _step.value;
        var level = classData.levelList.find(function (level) {
          return level.id === levelId;
        });
        if (level) {
          level.description = newName;
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }), _types.mutations.ADD_CLASS, function (_, _ref7) {
    var rootState = _ref7.rootState,
      classData = _ref7.classData;
    // Create the new class structure based on the API response
    var newClass = {
      id: classData.class_id,
      "class": classData.class_name,
      levelList: [{
        id: classData.level_id,
        levelId: classData.level_id,
        description: classData.level_name,
        options: []
      }]
    };

    // Add the new class to the productCategoryFilters array
    if (!rootState.desktopParameterConfig) {
      rootState.desktopParameterConfig = {};
    }
    if (!rootState.desktopParameterConfig.productCategoryFilters) {
      rootState.desktopParameterConfig.productCategoryFilters = [];
    }
    rootState.desktopParameterConfig.productCategoryFilters.push(newClass);
  })
};
/* harmony default export */ __webpack_exports__["b"] = (Category);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useAuthentication;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_composition_api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_authentication_Services__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_exceptions_ServerIsDown__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_WebSocketService__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_authentication_compositions_UsePostLoginInit__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_authentication_compositions_UseDeviceDetection__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sentry_vue__ = __webpack_require__(139);











function useAuthentication() {
  var isLoading = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(false);
  var loginErrorMessage = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(null);
  var forceLogoutMessage = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(null);
  var auth = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["l" /* reactive */])({
    email: '',
    password: ''
  });
  var isThereErrorLoginMessage = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
    return loginErrorMessage.value !== null;
  });
  var isThereForceLogoutMessage = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
    return forceLogoutMessage.value !== null;
  });

  // Initialize post-login composition
  var _usePostLoginInit = Object(__WEBPACK_IMPORTED_MODULE_8__app_authentication_compositions_UsePostLoginInit__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */]),
    performPostLoginInit = _usePostLoginInit.performPostLoginInit;
  var _useDeviceDetection = Object(__WEBPACK_IMPORTED_MODULE_9__app_authentication_compositions_UseDeviceDetection__["a" /* default */])(),
    isMobile = _useDeviceDetection.isMobile,
    isDesktop = _useDeviceDetection.isDesktop;

  // ✅ CENTRALIZED LOGIN COMPLETION - SINGLE SOURCE OF TRUTH
  var completeLogin = /*#__PURE__*/function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee(authResponse) {
      var loginType,
        deviceInfo,
        currentIsMobile,
        currentIsDesktop,
        initResult,
        _args = arguments,
        _t;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            loginType = _args.length > 1 && _args[1] !== undefined ? _args[1] : 'normal';
            deviceInfo = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
            _context.prev = 1;
            // Use provided device info or get from composition scope
            currentIsMobile = deviceInfo.isMobile || isMobile.value;
            currentIsDesktop = deviceInfo.isDesktop || isDesktop.value; // Perform complete post-login initialization
            _context.next = 2;
            return performPostLoginInit(currentIsMobile, currentIsDesktop);
          case 2:
            initResult = _context.sent;
            if (!(initResult.shouldShowMobileWelcome && loginType === 'normal')) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", {
              shouldShowMobileWelcome: true
            });
          case 3:
            if (authResponse.regions && authResponse.regions.length) {
              // Handle region selection if needed
              __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({
                name: 'regionSelection',
                params: {
                  regions: authResponse.regions
                }
              });
            } else if (initResult.routeTo && currentIsDesktop) {
              // Route to user's default view
              __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({
                name: initResult.routeTo
              });
            } else {
              // Fallback to Dashboard
              __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({
                name: 'Dashboard'
              });
            }
          case 4:
            return _context.abrupt("return", {
              success: true,
              shouldShowMobileWelcome: false
            });
          case 5:
            _context.prev = 5;
            _t = _context["catch"](1);
            console.error('❌ Error during centralized login completion:', _t);

            // Fallback routing if initialization fails
            if (authResponse.regions && authResponse.regions.length) {
              __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({
                name: 'regionSelection',
                params: {
                  regions: authResponse.regions
                }
              });
            } else {
              __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({
                name: 'Dashboard'
              });
            }
            throw _t;
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 5]]);
    }));
    return function completeLogin(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  // Alias for regular login to match Login.vue expectations
  var login = /*#__PURE__*/function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2(email, password) {
      var response, _responseError$respon, _responseError$respon2, status, errorData, _t2;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            isLoading.value = true;
            loginErrorMessage.value = null;
            _context2.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_3__app_authentication_Services__["d" /* login */])(email.toLowerCase().trim(), String(password));
          case 1:
            response = _context2.sent;
            // Store auth token and connect websocket
            localStorage.setItem('accessToken', response.access_token);
            if (response.user_id) {
              __WEBPACK_IMPORTED_MODULE_5__services_WebSocketService__["a" /* default */].connect(response.user_id);
            }
            return _context2.abrupt("return", response);
          case 2:
            _context2.prev = 2;
            _t2 = _context2["catch"](0);
            // Handle different error structures from api-client.js
            // For 403 errors: the full axios error object is rejected
            // For other errors: only error.response is rejected
            status = _t2.status || ((_responseError$respon = _t2.response) === null || _responseError$respon === void 0 ? void 0 : _responseError$respon.status);
            errorData = _t2.data || ((_responseError$respon2 = _t2.response) === null || _responseError$respon2 === void 0 ? void 0 : _responseError$respon2.data); // Check if this is a server down error (no status at all)
            if (status) {
              _context2.next = 3;
              break;
            }
            throw new __WEBPACK_IMPORTED_MODULE_4__app_shared_exceptions_ServerIsDown__["a" /* default */]('Servidor fuera de servicio');
          case 3:
            throw new Error((errorData === null || errorData === void 0 ? void 0 : errorData.error) || 'Error al iniciar sesión');
          case 4:
            _context2.prev = 4;
            isLoading.value = false;
            return _context2.finish(4);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 2, 4, 5]]);
    }));
    return function login(_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  // Legacy method for backwards compatibility
  var performLogin = /*#__PURE__*/function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3(store, router) {
      var response, _responseError$respon3, _responseError$respon4, status, errorData, _t3;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            isLoading.value = true;
            loginErrorMessage.value = null;
            _context3.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_3__app_authentication_Services__["d" /* login */])(auth.email.toLowerCase().trim(), String(auth.password));
          case 1:
            response = _context3.sent;
            // Store auth token and connect websocket
            localStorage.setItem('accessToken', response.access_token);
            if (response.user_id) {
              __WEBPACK_IMPORTED_MODULE_5__services_WebSocketService__["a" /* default */].connect(response.user_id);
            }
            return _context3.abrupt("return", response);
          case 2:
            _context3.prev = 2;
            _t3 = _context3["catch"](0);
            // Handle different error structures from api-client.js
            // For 403 errors: the full axios error object is rejected
            // For other errors: only error.response is rejected
            status = _t3.status || ((_responseError$respon3 = _t3.response) === null || _responseError$respon3 === void 0 ? void 0 : _responseError$respon3.status);
            errorData = _t3.data || ((_responseError$respon4 = _t3.response) === null || _responseError$respon4 === void 0 ? void 0 : _responseError$respon4.data); // Check if this is a server down error (no status at all)
            if (status) {
              _context3.next = 3;
              break;
            }
            throw new __WEBPACK_IMPORTED_MODULE_4__app_shared_exceptions_ServerIsDown__["a" /* default */]('Servidor fuera de servicio');
          case 3:
            throw new Error((errorData === null || errorData === void 0 ? void 0 : errorData.error) || 'Error al iniciar sesión');
          case 4:
            _context3.prev = 4;
            isLoading.value = false;
            return _context3.finish(4);
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 2, 4, 5]]);
    }));
    return function performLogin(_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();

  // Helper function to handle OAuth errors (Google and Microsoft)
  var handleOAuthError = function handleOAuthError(responseError) {
    var _responseError$respon5, _responseError$respon6, _responseError$respon7;
    // Check if this is a server down error (no status at all)
    if (!responseError.status && !((_responseError$respon5 = responseError.response) !== null && _responseError$respon5 !== void 0 && _responseError$respon5.status) && !responseError.data) {
      throw new __WEBPACK_IMPORTED_MODULE_4__app_shared_exceptions_ServerIsDown__["a" /* default */]('Servidor fuera de servicio');
    }

    // Get status code and error data
    var statusCode = ((_responseError$respon6 = responseError.response) === null || _responseError$respon6 === void 0 ? void 0 : _responseError$respon6.status) || responseError.status;
    var errorData = responseError.data || ((_responseError$respon7 = responseError.response) === null || _responseError$respon7 === void 0 ? void 0 : _responseError$respon7.data);

    // Handle 403 - Show error message from API
    if (statusCode === 403) {
      var error = new Error((errorData === null || errorData === void 0 ? void 0 : errorData.error) || 'Error de autenticación');
      error.response = responseError.response;
      error.status = statusCode;
      throw error;
    }

    // Handle 400 - Show error message from API
    if (statusCode === 400) {
      var _error = new Error((errorData === null || errorData === void 0 ? void 0 : errorData.error) || 'Error de solicitud');
      _error.response = responseError.response;
      _error.status = statusCode;
      throw _error;
    }

    // For all other errors, throw the original error
    throw responseError;
  };

  // Google OAuth flow
  var startGoogleLogin = /*#__PURE__*/function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee4() {
      var response, _t4;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            isLoading.value = true;
            loginErrorMessage.value = null;
            _context4.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_3__app_authentication_Services__["a" /* getGoogleOAuthUrl */])();
          case 1:
            response = _context4.sent;
            if (!(response && response.auth_url)) {
              _context4.next = 2;
              break;
            }
            // Redirect to Google OAuth URL
            window.location.href = response.auth_url;
            _context4.next = 3;
            break;
          case 2:
            throw new Error('No auth URL received from backend');
          case 3:
            _context4.next = 5;
            break;
          case 4:
            _context4.prev = 4;
            _t4 = _context4["catch"](0);
            handleLoginError(_t4);
            isLoading.value = false;
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 4]]);
    }));
    return function startGoogleLogin() {
      return _ref4.apply(this, arguments);
    };
  }();

  // Handle Google OAuth callback
  var processGoogleCallback = /*#__PURE__*/function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee5(authorizationCode) {
      var response, _t5;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_3__app_authentication_Services__["c" /* googleOAuthTokenValidation */])(authorizationCode);
          case 1:
            response = _context5.sent;
            // Store auth token and connect websocket
            localStorage.setItem('accessToken', response.access_token);
            if (response.user_id) {
              __WEBPACK_IMPORTED_MODULE_5__services_WebSocketService__["a" /* default */].connect(response.user_id);
            }
            return _context5.abrupt("return", response);
          case 2:
            _context5.prev = 2;
            _t5 = _context5["catch"](0);
            handleOAuthError(_t5);
          case 3:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[0, 2]]);
    }));
    return function processGoogleCallback(_x6) {
      return _ref5.apply(this, arguments);
    };
  }();

  // Microsoft OAuth flow
  var startMicrosoftLogin = /*#__PURE__*/function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee6() {
      var response, _t6;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            isLoading.value = true;
            loginErrorMessage.value = null;
            _context6.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_3__app_authentication_Services__["b" /* getMicrosoftOAuthUrl */])();
          case 1:
            response = _context6.sent;
            if (!(response && response.auth_url)) {
              _context6.next = 2;
              break;
            }
            // Redirect to Microsoft OAuth URL
            window.location.href = response.auth_url;
            _context6.next = 3;
            break;
          case 2:
            throw new Error('No auth URL received from backend');
          case 3:
            _context6.next = 5;
            break;
          case 4:
            _context6.prev = 4;
            _t6 = _context6["catch"](0);
            handleLoginError(_t6);
            isLoading.value = false;
          case 5:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[0, 4]]);
    }));
    return function startMicrosoftLogin() {
      return _ref6.apply(this, arguments);
    };
  }();

  // Handle Microsoft OAuth callback
  var processMicrosoftCallback = /*#__PURE__*/function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee7(authorizationCode) {
      var response, _t7;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_3__app_authentication_Services__["f" /* microsoftOAuthTokenValidation */])(authorizationCode);
          case 1:
            response = _context7.sent;
            // Store auth token and connect websocket
            localStorage.setItem('accessToken', response.access_token);
            if (response.user_id) {
              __WEBPACK_IMPORTED_MODULE_5__services_WebSocketService__["a" /* default */].connect(response.user_id);
            }
            return _context7.abrupt("return", response);
          case 2:
            _context7.prev = 2;
            _t7 = _context7["catch"](0);
            handleOAuthError(_t7);
          case 3:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[0, 2]]);
    }));
    return function processMicrosoftCallback(_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
  var handleLoginError = function handleLoginError(error) {
    if (error.name === 'ServerIsDown') {
      loginErrorMessage.value = 'Servidor fuera de servicio';
    } else {
      loginErrorMessage.value = error.message || 'Error al iniciar sesión';
    }
  };
  var logout = /*#__PURE__*/function () {
    var _ref8 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee8() {
      var _t8;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_3__app_authentication_Services__["e" /* logout */])();
          case 1:
            _context8.next = 3;
            break;
          case 2:
            _context8.prev = 2;
            _t8 = _context8["catch"](0);
            // Even if backend logout fails, continue with frontend cleanup
            console.warn('⚠️ Backend logout failed, continuing with frontend cleanup:', _t8.message);
          case 3:
            // Clear frontend authentication state
            localStorage.setItem('accessToken', '');
            __WEBPACK_IMPORTED_MODULE_5__services_WebSocketService__["a" /* default */].disconnect();

            // Limpiar usuario de Sentry
            __WEBPACK_IMPORTED_MODULE_10__sentry_vue__["setUser"](null);
          case 4:
          case "end":
            return _context8.stop();
        }
      }, _callee8, null, [[0, 2]]);
    }));
    return function logout() {
      return _ref8.apply(this, arguments);
    };
  }();
  var clearForceLogoutMessage = function clearForceLogoutMessage() {
    forceLogoutMessage.value = null;
  };
  var clearLoginError = function clearLoginError() {
    loginErrorMessage.value = null;
  };

  // Check for force logout message from sessionStorage
  var checkForceLogoutMessage = function checkForceLogoutMessage() {
    var forceLogoutReason = sessionStorage.getItem('force_logout_reason');
    if (forceLogoutReason) {
      forceLogoutMessage.value = forceLogoutReason;
      sessionStorage.removeItem('force_logout_reason');
    }
  };
  var isLoggedIn = function isLoggedIn() {
    return !!localStorage.getItem('accessToken');
  };
  return {
    // State
    isLoading: isLoading,
    loginErrorMessage: loginErrorMessage,
    errorMessage: loginErrorMessage,
    // Alias for Login.vue compatibility
    forceLogoutMessage: forceLogoutMessage,
    auth: auth,
    isThereErrorLoginMessage: isThereErrorLoginMessage,
    isThereForceLogoutMessage: isThereForceLogoutMessage,
    // Methods
    login: login,
    performLogin: performLogin,
    startGoogleLogin: startGoogleLogin,
    processGoogleCallback: processGoogleCallback,
    startMicrosoftLogin: startMicrosoftLogin,
    processMicrosoftCallback: processMicrosoftCallback,
    handleLoginError: handleLoginError,
    logout: logout,
    clearForceLogoutMessage: clearForceLogoutMessage,
    clearLoginError: clearLoginError,
    checkForceLogoutMessage: checkForceLogoutMessage,
    isLoggedIn: isLoggedIn,
    // Centralized completion method
    completeLogin: completeLogin
  };
}

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useDeviceDetection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(26);

function useDeviceDetection() {
  var screenWidth = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["n" /* ref */])(window.screen.width);
  var isMobile = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return screenWidth.value <= 480;
  });
  var isDesktop = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return !isMobile.value;
  });
  var updateScreenWidth = function updateScreenWidth() {
    screenWidth.value = window.screen.width;
  };

  // Listen for screen size changes (optional, for dynamic updates)
  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
    window.addEventListener('resize', updateScreenWidth);
  });
  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["j" /* onUnmounted */])(function () {
    window.removeEventListener('resize', updateScreenWidth);
  });
  return {
    isMobile: isMobile,
    isDesktop: isDesktop,
    screenWidth: screenWidth
  };
}

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMESPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_utils_NamespaceHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_LongGrid__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_shared_models_Dimension__ = __webpack_require__(225);






var NAMESPACE = 'monthlySales';
var INTERNAL_NAMESPACE = NAMESPACE + '/';
var metricsNormalCurrentYear = ['quantity_sold_2', 'quantity_sold_1', 'real_sales_amount_2', 'real_sales_amount_1', 'real_sales_cost_2', 'real_sales_cost_1'];
var buildMonthlySalesParameters = function buildMonthlySalesParameters(month) {
  return {
    calculatedField: ['COALESCE((SUM(real_sales_amount_1) - SUM(real_sales_cost_1)) / NULLIF(SUM(real_sales_amount_1),0), 0) as mg_1', 'COALESCE((SUM(real_sales_amount_2) - SUM(real_sales_cost_2)) / NULLIF(SUM(real_sales_amount_2),0), 0) as mg_2'],
    factTableName: 'dw_monthly_sales_comparative',
    metrics: {
      normal: metricsNormalCurrentYear,
      "var": ['quantity_sold', 'real_sales_amount', 'real_sales_cost']
    },
    dateFilters: {
      month: {
        operator: 'BT',
        value: [month, month]
      }
    }
  };
};
var _types = {
  getters: {
    BASE_DIMENSION: 'BASE_DIMENSION',
    PIVOT_DIMENSIONS: 'PIVOT_DIMENSIONS'
  },
  actions: {
    INIT: 'INIT',
    CHANGE_BASE_DIMENSION: 'CHANGE_BASE_DIMENSION',
    CHANGE_PIVOT: 'CHANGE_PIVOT',
    INIT_LONG_GRID: 'INIT_LONG_GRID',
    APPLY_FILTERS: 'APPLY_FILTERS',
    POP_UNTIL_BREADCRUMB: 'POP_UNTIL_BREADCRUMB',
    DOWNLOAD_GRID_TO_EXCEL: 'DOWNLOAD_GRID_TO_EXCEL',
    RESET: 'RESET'
  },
  mutations: {
    SET_DIMENSIONS: 'SET_DIMENSIONS',
    SET_METRIC: 'SET_METRIC'
  }
};
var Types = Object(__WEBPACK_IMPORTED_MODULE_3__app_shared_utils_NamespaceHelper__["a" /* addNamespace */])(INTERNAL_NAMESPACE, _types);
var Index = {
  namespaced: true,
  state: {
    dimensions: null,
    metric: null
  },
  getters: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.getters.BASE_DIMENSION, function (state, getters) {
    return getters[__WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_LongGrid__["a" /* Types */].getters.BASE_DIMENSION];
  }), _types.getters.PIVOT_DIMENSIONS, function (state, getters) {
    return getters[__WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_LongGrid__["a" /* Types */].getters.PIVOT_DIMENSIONS];
  }),
  actions: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.actions.INIT, function (_ref, _ref2) {
    var commit = _ref.commit;
    var dataDimensions = _ref2.dataDimensions,
      metric = _ref2.metric;
    var dimensions = dataDimensions.map(function (dimension) {
      return new __WEBPACK_IMPORTED_MODULE_5__app_shared_models_Dimension__["a" /* default */](dimension);
    });
    commit(_types.mutations.SET_DIMENSIONS, dimensions);
  }), _types.actions.INIT_LONG_GRID, function (_ref3, month) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
      var dispatch, state, defaultDimension;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch = _ref3.dispatch, state = _ref3.state;
            defaultDimension = state.dimensions[0];
            _context.next = 1;
            return dispatch(__WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_LongGrid__["a" /* Types */].actions.INIT, {
              dimensions: state.dimensions,
              defaultDimension: defaultDimension,
              defaultParameters: buildMonthlySalesParameters(month),
              filters: state.longGrid.filters
            });
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }), _types.actions.CHANGE_BASE_DIMENSION, function (_ref4, dimensionId) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
      var dispatch;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dispatch = _ref4.dispatch;
            _context2.next = 1;
            return dispatch(__WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_LongGrid__["a" /* Types */].actions.CHANGE_BASE_DIMENSION, dimensionId);
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }), _types.actions.CHANGE_PIVOT, function (_ref5, _ref6) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3() {
      var dispatch, rootState, params, option;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            dispatch = _ref5.dispatch, rootState = _ref5.rootState;
            params = _ref6.params, option = _ref6.option;
            _context3.next = 1;
            return dispatch(__WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_LongGrid__["a" /* Types */].actions.CHANGE_PIVOT, {
              params: params,
              option: option
            });
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }), _types.actions.APPLY_FILTERS, function (_ref7, _ref8) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee4() {
      var dispatch, storeFilters, productFilters, asyncProductPool;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            dispatch = _ref7.dispatch;
            storeFilters = _ref8.storeFilters, productFilters = _ref8.productFilters, asyncProductPool = _ref8.asyncProductPool;
            _context4.next = 1;
            return dispatch(__WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_LongGrid__["a" /* Types */].actions.APPLY_FILTERS, {
              storeFilters: storeFilters,
              productFilters: productFilters,
              asyncProductPool: asyncProductPool
            });
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  }), _types.actions.POP_UNTIL_BREADCRUMB, function (_ref9, breadCrumbItem) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee5() {
      var dispatch;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            dispatch = _ref9.dispatch;
            _context5.next = 1;
            return dispatch(__WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_LongGrid__["a" /* Types */].actions.POP_UNTIL_BREADCRUMB, breadCrumbItem);
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  }), _types.actions.DOWNLOAD_GRID_TO_EXCEL, function (_ref0) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee6() {
      var dispatch;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            dispatch = _ref0.dispatch;
            _context6.next = 1;
            return dispatch(__WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_LongGrid__["a" /* Types */].actions.DOWNLOAD_GRID_TO_EXCEL);
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  }), _types.actions.RESET, function (_ref1) {
    var dispatch = _ref1.dispatch;
    dispatch(__WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_LongGrid__["a" /* Types */].actions.RESET);
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.mutations.SET_DIMENSIONS, function (state, dimensions) {
    state.dimensions = dimensions;
  }), _types.mutations.SET_METRIC, function (state, metric) {
    state.metric = metric;
  }),
  modules: {
    longGrid: __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_LongGrid__["b" /* default */]
  }
};
/* harmony default export */ __webpack_exports__["c"] = (Index);

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMESPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_utils_NamespaceHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_Filters__ = __webpack_require__(55);





var NAMESPACE = 'productFollowUp';
var INTERNAL_NAMESPACE = NAMESPACE + '/';
var _types = {
  actions: {
    APPLY_FILTERS: 'APPLY_FILTERS',
    RESET: 'RESET'
  }
};
var Types = Object(__WEBPACK_IMPORTED_MODULE_3__app_shared_utils_NamespaceHelper__["a" /* addNamespace */])(INTERNAL_NAMESPACE, _types);
var Index = {
  namespaced: true,
  state: {},
  getters: {},
  actions: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, _types.actions.APPLY_FILTERS, function (_ref, _ref2) {
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
      var dispatch, storeFilters, productFilters, asyncProductPool;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch = _ref.dispatch;
            storeFilters = _ref2.storeFilters, productFilters = _ref2.productFilters, asyncProductPool = _ref2.asyncProductPool;
            _context.next = 1;
            return dispatch(INTERNAL_NAMESPACE + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_Filters__["a" /* Types */].actions.SET_SELECTED_FILTERS, {
              storeFilters: storeFilters,
              productFilters: productFilters,
              asyncProductPool: asyncProductPool
            }, {
              root: true
            });
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }), _types.actions.RESET, function (_ref3) {
    var dispatch = _ref3.dispatch;
    dispatch(INTERNAL_NAMESPACE + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_Filters__["a" /* Types */].actions.RESET_SELECTED_FILTERS, null, {
      root: true
    });
  }),
  mutations: {},
  modules: {
    filters: __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_Filters__["b" /* default */]
  }
};
/* harmony default export */ __webpack_exports__["c"] = (Index);

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = usePostLoginInit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_composition_api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);




function usePostLoginInit(store, router) {
  // Computed values from store
  var userInfo = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
    return store.getters.userInfo;
  });
  var regionConfig = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
    return store.getters.regionConfig;
  });
  var defaultMetric = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
    return store.getters.defaultMetric;
  });
  var userDefaultInitView = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
    return store.getters.userDefaultInitView;
  });
  var userRole = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
    var _userInfo$value;
    return (_userInfo$value = userInfo.value) === null || _userInfo$value === void 0 ? void 0 : _userInfo$value.role;
  });
  var isBasicUser = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
    return userRole.value && ['Partner', 'Api Account'].includes(userRole.value);
  });
  var defaultView = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
    return isBasicUser.value ? 'MassiveDownload' : 'Dashboard';
  });

  // Set up regional currency formatting
  var setRegionCurrency = function setRegionCurrency() {
    var _regionConfig$value;
    if (!((_regionConfig$value = regionConfig.value) !== null && _regionConfig$value !== void 0 && (_regionConfig$value = _regionConfig$value.config) !== null && _regionConfig$value !== void 0 && _regionConfig$value.currency)) {
      console.warn('Region config or currency not available, defaulting to "ch"');
      __WEBPACK_IMPORTED_MODULE_3_numeral___default.a.locale('ch');
      return;
    }
    var regionCurrency = regionConfig.value.config.currency;
    if (regionCurrency === 'ch') {
      __WEBPACK_IMPORTED_MODULE_3_numeral___default.a.locale('ch');
    } else if (regionCurrency === 'pe') {
      __WEBPACK_IMPORTED_MODULE_3_numeral___default.a.locale('pe');
    } else if (regionCurrency === 'mx') {
      __WEBPACK_IMPORTED_MODULE_3_numeral___default.a.locale('mx');
    } else {
      __WEBPACK_IMPORTED_MODULE_3_numeral___default.a.locale('ch');
    }
  };

  // Initialize default metric in store
  var initializeDefaultMetric = function initializeDefaultMetric() {
    if (defaultMetric.value) {
      store.commit('commit_mainMetric', defaultMetric.value);
    }
  };

  // Determine where to route user after login based on device and role
  var getPostLoginRoute = function getPostLoginRoute(isMobile, isDesktop) {
    if (isMobile) {
      // For mobile, show welcome screen with options
      return null; // Don't auto-route, let user choose
    } else if (isDesktop) {
      // For desktop, route directly to user's default view
      return userDefaultInitView.value;
    }
    return null;
  };

  // Complete post-login initialization
  var performPostLoginInit = /*#__PURE__*/function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee(isMobile, isDesktop) {
      var route, _t;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            if (store.getters.isConfigLoaded) {
              _context.next = 1;
              break;
            }
            _context.next = 1;
            return store.dispatch('fetchDesktopParameterConfig');
          case 1:
            // Initialize currency formatting
            setRegionCurrency();

            // Initialize default metric
            initializeDefaultMetric();

            // Determine routing
            route = getPostLoginRoute(isMobile, isDesktop);
            if (route && isDesktop) {
              router.push({
                name: route
              });
            }
            return _context.abrupt("return", {
              shouldShowMobileWelcome: isMobile,
              routeTo: route
            });
          case 2:
            _context.prev = 2;
            _t = _context["catch"](0);
            console.error('Error during post-login initialization:', _t);
            throw _t;
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 2]]);
    }));
    return function performPostLoginInit(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    // Computed properties
    userInfo: userInfo,
    regionConfig: regionConfig,
    defaultMetric: defaultMetric,
    userDefaultInitView: userDefaultInitView,
    userRole: userRole,
    isBasicUser: isBasicUser,
    defaultView: defaultView,
    // Methods
    setRegionCurrency: setRegionCurrency,
    initializeDefaultMetric: initializeDefaultMetric,
    getPostLoginRoute: getPostLoginRoute,
    performPostLoginInit: performPostLoginInit
  };
}

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClientProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getProductMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getKeyMetrics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateProductMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return searchProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getProductMapSuggestions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_client_js__ = __webpack_require__(39);



var getClientProducts = /*#__PURE__*/function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
    var _ref2,
      _ref2$sortBy,
      sortBy,
      _ref2$sortDir,
      sortDir,
      _ref2$search,
      search,
      _ref2$page,
      page,
      _ref2$pageSize,
      pageSize,
      params,
      clientProducts,
      _args = arguments;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref2$sortBy = _ref2.sortBy, sortBy = _ref2$sortBy === void 0 ? null : _ref2$sortBy, _ref2$sortDir = _ref2.sortDir, sortDir = _ref2$sortDir === void 0 ? null : _ref2$sortDir, _ref2$search = _ref2.search, search = _ref2$search === void 0 ? null : _ref2$search, _ref2$page = _ref2.page, page = _ref2$page === void 0 ? 1 : _ref2$page, _ref2$pageSize = _ref2.pageSize, pageSize = _ref2$pageSize === void 0 ? 50 : _ref2$pageSize;
          params = new URLSearchParams();
          params.set('page', page);
          params.set('pageSize', pageSize);
          if (sortBy) params.set('sortBy', sortBy);
          if (sortDir) params.set('sortDir', sortDir);
          if (search) params.set('search', search);
          _context.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/product-master/detail/client-products?".concat(params.toString()));
        case 1:
          clientProducts = _context.sent;
          return _context.abrupt("return", clientProducts.data);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getClientProducts() {
    return _ref.apply(this, arguments);
  };
}();
var getProductMap = /*#__PURE__*/function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2(retailId) {
    var _ref4,
      _ref4$sortBy,
      sortBy,
      _ref4$sortDir,
      sortDir,
      _ref4$search,
      search,
      _ref4$page,
      page,
      _ref4$pageSize,
      pageSize,
      params,
      productMap,
      _args2 = arguments;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _ref4 = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {}, _ref4$sortBy = _ref4.sortBy, sortBy = _ref4$sortBy === void 0 ? null : _ref4$sortBy, _ref4$sortDir = _ref4.sortDir, sortDir = _ref4$sortDir === void 0 ? null : _ref4$sortDir, _ref4$search = _ref4.search, search = _ref4$search === void 0 ? null : _ref4$search, _ref4$page = _ref4.page, page = _ref4$page === void 0 ? 1 : _ref4$page, _ref4$pageSize = _ref4.pageSize, pageSize = _ref4$pageSize === void 0 ? 50 : _ref4$pageSize;
          params = new URLSearchParams();
          params.set('page', page);
          params.set('pageSize', pageSize);
          if (sortBy) params.set('sortBy', sortBy);
          if (sortDir) params.set('sortDir', sortDir);
          if (search) params.set('search', search);
          _context2.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/product-master/detail/product-map/".concat(retailId, "?").concat(params.toString()));
        case 1:
          productMap = _context2.sent;
          return _context2.abrupt("return", productMap.data);
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getProductMap(_x) {
    return _ref3.apply(this, arguments);
  };
}();
var getKeyMetrics = /*#__PURE__*/function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3() {
    var keyMetrics;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get('/product-master/key-metrics');
        case 1:
          keyMetrics = _context3.sent;
          return _context3.abrupt("return", keyMetrics.data);
        case 2:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getKeyMetrics() {
    return _ref5.apply(this, arguments);
  };
}();
var updateProductMap = /*#__PURE__*/function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee4(productMapId, productId) {
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].patch('/product-master/product-map', {
            productMapId: productMapId,
            productId: productId
          });
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function updateProductMap(_x2, _x3) {
    return _ref6.apply(this, arguments);
  };
}();
var searchProducts = /*#__PURE__*/function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee5(searchQuery) {
    var searchProducts;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("/product-master/client-products/search?searchQuery=".concat(searchQuery));
        case 1:
          searchProducts = _context5.sent;
          return _context5.abrupt("return", searchProducts.data);
        case 2:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function searchProducts(_x4) {
    return _ref7.apply(this, arguments);
  };
}();
var getProductMapSuggestions = /*#__PURE__*/function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee6(searchQuery) {
    var searchParams, searchProducts;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          searchParams = encodeURIComponent(searchQuery);
          _context6.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get("product-master/product-map/search-suggestion?searchDescription=".concat(searchParams));
        case 1:
          searchProducts = _context6.sent;
          return _context6.abrupt("return", searchProducts.data);
        case 2:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function getProductMapSuggestions(_x5) {
    return _ref8.apply(this, arguments);
  };
}();


/***/ }),
/* 732 */,
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkClientTermsAcceptance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return acceptClientTerms; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_client_js__ = __webpack_require__(39);



var checkClientTermsAcceptance = /*#__PURE__*/function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get('/admin/client-terms/check');
        case 1:
          response = _context.sent;
          if (!(response.status !== 200)) {
            _context.next = 2;
            break;
          }
          throw new Error('Error al verificar la aceptación de términos');
        case 2:
          return _context.abrupt("return", response.data);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function checkClientTermsAcceptance() {
    return _ref.apply(this, arguments);
  };
}();
var acceptClientTerms = /*#__PURE__*/function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
    var termsVersion,
      response,
      _args2 = arguments;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          termsVersion = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '1.0';
          _context2.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/admin/client-terms', {
            terms_version: termsVersion
          });
        case 1:
          response = _context2.sent;
          if (!(response.status !== 200 && response.status !== 201)) {
            _context2.next = 2;
            break;
          }
          throw new Error('Error al aceptar los términos del servicio');
        case 2:
          return _context2.abrupt("return", response.data);
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function acceptClientTerms() {
    return _ref2.apply(this, arguments);
  };
}();


/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSelectedOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSelectedOptionId; });
var getSelectedOption = function getSelectedOption(options) {
  if (!Array.isArray(options)) {
    throw new TypeError('Parametro no es un array');
  }
  if (options.length === 0) {
    throw new RangeError('Array sin elementos');
  }
  return options.find(function (option) {
    return option.selected;
  });
};
var getSelectedOptionId = function getSelectedOptionId(options) {
  var selectedOption = getSelectedOption(options);
  return selectedOption !== undefined ? selectedOption.id : null;
};


/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_sales_analysis_store_Index__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_sales_analysis_store_DateGranularity__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_Filters__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_sales_analysis_Services__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_shared_utils_NamespaceHelper__ = __webpack_require__(31);


var _actions;

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var BREADCRUMB_MODULE_NAME = 'breadCrumb';
var NAMESPACE = 'salesAnalysis/longGrid/';
var NAMESPACE_BREADCRUMB = NAMESPACE + BREADCRUMB_MODULE_NAME + '/';
var _types = {
  getters: {
    PIVOT_DIMENSIONS: 'GETTER_PIVOT_DIMENSIONS',
    DIMENSION_TO_FILTER: 'GETTER_DIMENSION_TO_FILTER',
    DEFAULT_DIMENSION: 'GETTER_DEFAULT_DIMENSION',
    PIVOTED_FILTERS: 'GETTER_PIVOTED_FILTERS',
    PIVOTED_FILTER_DIMENSION_IDS: 'GETTER_PIVOTED_FILTER_DIMENSION_IDS',
    HAS_SELECTED_FILTERS: 'GETTER_HAS_SELECTED_FILTERS',
    BASE_DIMENSION: 'BASE_DIMENSION',
    LAST_BREADCRUMB_ITEM: 'LAST_BREADCRUMB_ITEM',
    CREATE_FILTER_OBJECT: 'CREATE_FILTER_OBJECT'
  },
  actions: {
    INIT: 'INIT',
    INIT_BREADCRUMB: 'INIT_BREADCRUMB',
    INIT_FILTERS: 'INIT_FILTERS',
    INIT_DIMENSION: 'INIT_DIMENSION',
    FETCH_LONG_GRID: 'FETCH_LONG_GRID',
    PUSH_BREADCRUMB_ITEM: 'PUSH_BREADCRUMB_ITEM',
    POP_UNTIL_BREADCRUMB: 'POP_UNTIL_BREADCRUMB',
    CHANGE_PIVOT: 'CHANGE_PIVOT',
    CHANGE_BASE_DIMENSION: 'CHANGE_BASE_DIMENSION',
    APPLY_FILTERS: 'APPLY_FILTERS',
    DOWNLOAD_EXCEL: 'DOWNLOAD_EXCEL',
    RESET: 'RESET',
    SET_INIT_DATA_DATE_GRANULARITY: 'SET_INIT_DATA_DATE_GRANULARITY'
  },
  mutations: {
    SET_DEFAULT_PARAMETERS: 'SET_DEFAULT_PARAMETERS',
    SET_GRID: 'SET_GRID'
  }
};
var Types = Object(__WEBPACK_IMPORTED_MODULE_8__app_shared_utils_NamespaceHelper__["a" /* addNamespace */])(NAMESPACE, _types);
var LongGrid = {
  namespaced: true,
  state: {
    grid: null,
    metrics: null
  },
  getters: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.getters.DEFAULT_DIMENSION, function (state, getters, rootState, rootGetters) {
    var defaultDimensions = rootGetters[__WEBPACK_IMPORTED_MODULE_3__app_sales_analysis_store_Index__["a" /* Types */].getters.DEFAULT_DIMENSIONS];
    var dimensiondId = defaultDimensions.product_dimensions.length > 1 ? defaultDimensions.product_dimensions[1] : defaultDimensions.store_dimensions[1];
    return rootGetters[__WEBPACK_IMPORTED_MODULE_3__app_sales_analysis_store_Index__["a" /* Types */].getters.DIMENSIONS].find(function (dimension) {
      return dimension.key === dimensiondId;
    });
  }), _types.getters.PIVOT_DIMENSIONS, function (state, getters, rootState, rootGetters) {
    var dimensionIdsInBreadCrumb = rootGetters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_IDS_IN_BREADCRUMB];
    var dimensionsToPivot = function dimensionsToPivot(dimension) {
      return !dimensionIdsInBreadCrumb.includes(dimension.id);
    };
    return rootGetters[__WEBPACK_IMPORTED_MODULE_3__app_sales_analysis_store_Index__["a" /* Types */].getters.DIMENSIONS].filter(dimensionsToPivot);
  }), _types.getters.PIVOTED_FILTERS, function (state) {
    return state.breadCrumb.items.filter(function (breadcrumbItem) {
      return breadcrumbItem.filter;
    }).map(function (breadcrumbItem) {
      return breadcrumbItem.filter;
    });
  }), _types.getters.PIVOTED_FILTER_DIMENSION_IDS, function (state, getters) {
    return getters[_types.getters.PIVOTED_FILTERS].map(function (pivotedFilter) {
      return pivotedFilter.keyField;
    });
  }), _types.getters.HAS_SELECTED_FILTERS, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_Filters__["a" /* Types */].getters.HAS_SELECTED_FILTERS];
  }), _types.getters.DIMENSION_TO_FILTER, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.DIMENSION_TO_FILTER];
  }), _types.getters.BASE_DIMENSION, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.FIRST_ITEM].dimension;
  }), _types.getters.LAST_BREADCRUMB_ITEM, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM];
  }), _types.getters.CREATE_FILTER_OBJECT, function (state) {
    return function (filter) {
      var filterAttribute = "".concat(filter.keyFieldType, "_filters");
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, filterAttribute, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, filter.keyField, filter.value));
    };
  }),
  actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_actions, _types.actions.INIT, function (_ref2, _ref3) {
    var commit = _ref2.commit,
      dispatch = _ref2.dispatch;
    var defaultParameters = _ref3.defaultParameters;
    commit(_types.mutations.SET_DEFAULT_PARAMETERS, defaultParameters);
    dispatch(_types.actions.INIT_FILTERS);
    dispatch(_types.actions.INIT_DIMENSION);
  }), _types.actions.INIT_FILTERS, function (_ref4) {
    var dispatch = _ref4.dispatch,
      rootState = _ref4.rootState;
    var storeFilters = _objectSpread({}, rootState.salesAnalysis.filters.selectedStoreFilters);
    var productFilters = _objectSpread({}, rootState.salesAnalysis.filters.selectedProductFilters);
    dispatch(NAMESPACE + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_Filters__["a" /* Types */].actions.SET_SELECTED_FILTERS, {
      storeFilters: storeFilters,
      productFilters: productFilters
    }, {
      root: true
    });
  }), _types.actions.INIT_DIMENSION, function (_ref5) {
    var dispatch = _ref5.dispatch,
      getters = _ref5.getters;
    var dimension = getters[_types.getters.DEFAULT_DIMENSION];
    dispatch(_types.actions.CHANGE_BASE_DIMENSION, dimension.id);
  }), _types.actions.FETCH_LONG_GRID, function (_ref6, _ref7) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
      var state, commit, rootState, dimension, filter, metrics, filters, calculatedField, factTableName, longGrid;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            state = _ref6.state, commit = _ref6.commit, rootState = _ref6.rootState;
            dimension = _ref7.dimension, filter = _ref7.filter;
            commit(_types.mutations.SET_GRID, null);
            metrics = state.metrics, filters = state.filters, calculatedField = state.calculatedField;
            factTableName = rootState.salesAnalysis.accumulatedSalesDateOption.fact_name;
            _context.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_7__app_sales_analysis_Services__["e" /* getLongGrid */])({
              metrics: metrics,
              dimension: dimension,
              factTableName: factTableName,
              strategyFilter: filter,
              filters: filters,
              calculatedField: calculatedField
            });
          case 1:
            longGrid = _context.sent;
            commit(_types.mutations.SET_GRID, longGrid);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }), _types.actions.INIT_BREADCRUMB, function (_ref8, dimension) {
    var dispatch = _ref8.dispatch,
      commit = _ref8.commit,
      state = _ref8.state,
      getters = _ref8.getters;
    commit(NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].mutations.RESET, null, {
      root: true
    });
    var breadCrumbItemText = dimension.value;
    dispatch(_types.actions.PUSH_BREADCRUMB_ITEM, {
      dimension: dimension,
      filter: undefined,
      breadCrumbItemText: breadCrumbItemText
    });
  }), _types.actions.PUSH_BREADCRUMB_ITEM, function (_ref9, _ref0) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
      var commit, dispatch, dimension, filter, breadCrumbItemText;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref9.commit, dispatch = _ref9.dispatch;
            dimension = _ref0.dimension, filter = _ref0.filter, breadCrumbItemText = _ref0.breadCrumbItemText;
            _context2.next = 1;
            return dispatch(_types.actions.FETCH_LONG_GRID, {
              dimension: dimension,
              filter: filter
            });
          case 1:
            commit(NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].mutations.PUSH_ITEM, {
              dimension: dimension,
              filter: filter,
              text: breadCrumbItemText
            }, {
              root: true
            });
            if (filter) commit(NAMESPACE + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_Filters__["a" /* Types */].mutations.ADD_SELECTED_FILTER, filter, {
              root: true
            });
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }), _types.actions.CHANGE_PIVOT, function (_ref1, _ref10) {
    var getters = _ref1.getters,
      dispatch = _ref1.dispatch,
      rootGetters = _ref1.rootGetters;
    var pivotedDimensionId = _ref10.pivotedDimensionId,
      pivotedDimensionCellValue = _ref10.pivotedDimensionCellValue,
      filter = _ref10.filter;
    var dimension = rootGetters[__WEBPACK_IMPORTED_MODULE_3__app_sales_analysis_store_Index__["a" /* Types */].getters.DIMENSION_BY_ID](pivotedDimensionId);
    var breadCrumbItemText = "".concat(dimension.value, " en ").concat(pivotedDimensionCellValue);
    dispatch(_types.actions.PUSH_BREADCRUMB_ITEM, {
      dimension: dimension,
      filter: filter,
      breadCrumbItemText: breadCrumbItemText
    });
  }), _types.actions.POP_UNTIL_BREADCRUMB, function (_ref11, breadCrumbItem) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3() {
      var state, commit, dispatch, rootGetters, lastBreadCrumbItem;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            state = _ref11.state, commit = _ref11.commit, dispatch = _ref11.dispatch, rootGetters = _ref11.rootGetters;
            if (!(rootGetters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM] === breadCrumbItem)) {
              _context3.next = 1;
              break;
            }
            return _context3.abrupt("return");
          case 1:
            while (rootGetters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM] !== breadCrumbItem) {
              lastBreadCrumbItem = rootGetters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM];
              commit(NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].mutations.REMOVE_ITEM, lastBreadCrumbItem, {
                root: true
              });
              dispatch(NAMESPACE + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_Filters__["a" /* Types */].actions.REMOVE_SELECTED_FILTER_IN_CASCADE, lastBreadCrumbItem.filter, {
                root: true
              });
            }
            _context3.next = 2;
            return dispatch(_types.actions.FETCH_LONG_GRID, breadCrumbItem);
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }), _types.actions.CHANGE_BASE_DIMENSION, function (_ref12, dimensionId) {
    var dispatch = _ref12.dispatch,
      rootGetters = _ref12.rootGetters,
      getters = _ref12.getters;
    var dimension = rootGetters[__WEBPACK_IMPORTED_MODULE_3__app_sales_analysis_store_Index__["a" /* Types */].getters.DIMENSION_BY_ID](dimensionId);
    var pivotedFilters = getters[_types.getters.PIVOTED_FILTERS];
    pivotedFilters.forEach(function (pivotedFilter) {
      dispatch(NAMESPACE + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_Filters__["a" /* Types */].actions.REMOVE_SELECTED_FILTER_IN_CASCADE, pivotedFilter, {
        root: true
      });
    });
    dispatch(_types.actions.INIT_BREADCRUMB, dimension);
  }), _types.actions.APPLY_FILTERS, function (_ref13, _ref14) {
    var dispatch = _ref13.dispatch,
      getters = _ref13.getters,
      rootGetters = _ref13.rootGetters;
    var storeFilters = _ref14.storeFilters,
      productFilters = _ref14.productFilters;
    dispatch(NAMESPACE + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_Filters__["a" /* Types */].actions.SET_SELECTED_FILTERS, {
      storeFilters: storeFilters,
      productFilters: productFilters
    }, {
      root: true
    });
    var breadCrumbItem = rootGetters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM];
    dispatch(_types.actions.FETCH_LONG_GRID, breadCrumbItem);
  }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_actions, _types.actions.DOWNLOAD_EXCEL, function (_ref15) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee4() {
      var state, rootState, rootGetters, metrics, filters, calculatedField, factTableName, _rootGetters, dimension, strategyFilter;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            state = _ref15.state, rootState = _ref15.rootState, rootGetters = _ref15.rootGetters;
            metrics = state.metrics, filters = state.filters, calculatedField = state.calculatedField;
            factTableName = rootState.salesAnalysis.accumulatedSalesDateOption.fact_name;
            _rootGetters = rootGetters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].getters.LAST_ITEM], dimension = _rootGetters.dimension, strategyFilter = _rootGetters.filter;
            _context4.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_7__app_sales_analysis_Services__["a" /* downloadLongGridToExcel */])({
              metrics: metrics,
              dimension: dimension,
              factTableName: factTableName,
              strategyFilter: strategyFilter,
              filters: filters,
              calculatedField: calculatedField
            });
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  }), _types.actions.RESET, function (_ref16) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee5() {
      var commit;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            commit = _ref16.commit;
            commit(NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].mutations.RESET, null, {
              root: true
            });
            commit(_types.mutations.SET_GRID, null);
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  }), _types.actions.RESET, function (_ref17) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee6() {
      var commit;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            commit = _ref17.commit;
            commit(NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["a" /* Types */].mutations.RESET, null, {
              root: true
            });
            commit(_types.mutations.SET_GRID, null);
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  }), _types.actions.SET_INIT_DATA_DATE_GRANULARITY, function (_ref18, _ref19) {
    var commit = _ref18.commit,
      getters = _ref18.getters;
    var filter = _ref19.filter,
      dimensionTextValue = _ref19.dimensionTextValue;
    var title = "Apertura de fechas ".concat(dimensionTextValue);
    var filterObject = filter ? getters[_types.getters.CREATE_FILTER_OBJECT](filter) : {};
    commit(__WEBPACK_IMPORTED_MODULE_4__app_sales_analysis_store_DateGranularity__["a" /* Types */].mutations.SET_TITLE, title, {
      root: true
    });
    commit(__WEBPACK_IMPORTED_MODULE_4__app_sales_analysis_store_DateGranularity__["a" /* Types */].mutations.SET_FILTER, filterObject, {
      root: true
    });
  })),
  mutations: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.mutations.SET_DEFAULT_PARAMETERS, function (state, defaultParameters) {
    var metrics = defaultParameters.metrics,
      calculatedField = defaultParameters.calculated_field;
    state.metrics = metrics;
    state.calculatedField = calculatedField;
  }), _types.mutations.SET_GRID, function (state, longGrid) {
    state.grid = longGrid;
  }),
  modules: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({
    filters: __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_Filters__["b" /* default */]
  }, BREADCRUMB_MODULE_NAME, __WEBPACK_IMPORTED_MODULE_6__app_sales_analysis_store_BreadCrumb__["b" /* default */])
};
/* harmony default export */ __webpack_exports__["b"] = (LongGrid);

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_store_growth_store_Index__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_store_growth_Services__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_shared_utils_NamespaceHelper__ = __webpack_require__(31);






var NAMESPACE = 'storeGrowth/storesWithoutGrowth/';
var _types = {
  getters: {
    METRICS: 'GETTER_METRICS',
    SORT_FIELD: 'GETTER_SORT_FIELD',
    HAVING_FILTERS: 'GETTER_HAVING_FILTERS',
    PAYLOAD_PARAMETERS: 'GETTER_PAYLOAD_PARAMETERS'
  },
  actions: {
    FETCH_LONG_GRID: 'FETCH_LONG_GRID'
  },
  mutations: {
    SET_DEFAULT_PARAMETERS: 'SET_DEFAULT_PARAMETERS',
    SET_GRID: 'SET_GRID'
  }
};
var Types = Object(__WEBPACK_IMPORTED_MODULE_5__app_shared_utils_NamespaceHelper__["a" /* addNamespace */])(NAMESPACE, _types);
var StoresWithoutGrowth = {
  namespaced: true,
  state: {
    metrics: null
  },
  getters: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.getters.HAVING_FILTERS, function (state, getters, rootState, rootGetters) {
    var firstNormalMetric = rootGetters[__WEBPACK_IMPORTED_MODULE_3__app_store_growth_store_Index__["b" /* Types */].getters.METRICS].normal[0];
    var secondNormalMetric = rootGetters[__WEBPACK_IMPORTED_MODULE_3__app_store_growth_store_Index__["b" /* Types */].getters.METRICS].normal[1];
    return ["sum(".concat(secondNormalMetric, ") > sum(").concat(firstNormalMetric, ")"), "sum(".concat(firstNormalMetric, ") <> 0")];
  }), _types.getters.PAYLOAD_PARAMETERS, function (state, getters, rootState, rootGetters) {
    var payload = {
      parameters: {
        store_dimensions: ['retail_name_store_name', 'store_id'],
        product_dimensions: {},
        metrics: rootGetters[__WEBPACK_IMPORTED_MODULE_3__app_store_growth_store_Index__["b" /* Types */].getters.METRICS],
        fact: {
          type: 'table',
          name: rootState.storeGrowth.accumulatedSalesDateOption.fact_name
        },
        sort: {
          field: rootGetters[__WEBPACK_IMPORTED_MODULE_3__app_store_growth_store_Index__["b" /* Types */].getters.SORT_FIELD],
          dir: 'DESC'
        },
        limit: 50,
        offset: 0,
        store_filters: {
          store_type_id: [1]
        },
        product_filters: {},
        having_filters: getters[_types.getters.HAVING_FILTERS]
      }
    };
    return payload;
  }),
  actions: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.actions.FETCH_LONG_GRID, function (_ref) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
      var getters, payload, longGrid;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            getters = _ref.getters;
            payload = getters[_types.getters.PAYLOAD_PARAMETERS];
            _context.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_4__app_store_growth_Services__["a" /* getLongGrid */])(payload);
          case 1:
            longGrid = _context.sent;
            return _context.abrupt("return", longGrid);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  })
};
/* harmony default export */ __webpack_exports__["b"] = (StoresWithoutGrowth);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);


var RegionConfigModel = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function RegionConfigModel(config) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, RegionConfigModel);
  this.tax = config.tax;
  this.dw_store = config.dw_store;
  this.currency = config.currency;
  this.currencySymbol = config.currency_symbol;
  this.decimals = config.decimals;
  this.separator = config.separator;
});
var DefaultSelloutRangesOptionModel = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function DefaultSelloutRangesOptionModel(_ref) {
  var component = _ref.component,
    id = _ref.id,
    fact_table = _ref.fact_table;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, DefaultSelloutRangesOptionModel);
  this.component = component;
  this.id = id;
  this.factTable = fact_table;
});
/* harmony default export */ __webpack_exports__["a"] = ({
  isLoggedIn: function isLoggedIn(state) {
    return !!localStorage.getItem('accessToken');
  },
  isConfigLoaded: function isConfigLoaded(state) {
    return state.desktopParameterConfig !== null;
  },
  defaultMetric: function defaultMetric(state) {
    if (!state.desktopParameterConfig || !state.desktopParameterConfig.mainMetric) {
      return 'PESOS';
    }
    return state.desktopParameterConfig.mainMetric.includes('quantity_sold') ? 'UNITS' : 'PESOS';
  },
  dataDimensions: function dataDimensions(state) {
    return state.desktopParameterConfig ? state.desktopParameterConfig.dimensions : [];
  },
  dataPivotDimensions: function dataPivotDimensions(state, getters) {
    var dimensions = getters.dataDimensions;
    return dimensions ? dimensions.filter(function (x) {
      return x.pivot === true;
    }) : [];
  },
  movableDates: function movableDates(state) {
    return state.desktopParameterConfig ? state.desktopParameterConfig.movableDate : [];
  },
  dataMetrics: function dataMetrics(state) {
    return state.desktopParameterConfig ? state.desktopParameterConfig.metrics : [];
  },
  thisYearWeekly: function thisYearWeekly(state, getters) {
    var movableDates = getters.movableDates;
    if (!movableDates) return null;
    var thisYear = movableDates.find(function (x) {
      return x.id === 'this_year_weekly';
    });
    return thisYear ? thisYear.dateRange1 : null;
  },
  lastYearWeekly: function lastYearWeekly(state, getters) {
    var movableDates = getters.movableDates;
    if (!movableDates) return null;
    var lastYear = movableDates.find(function (x) {
      return x.id === 'last_year_weekly';
    });
    return lastYear ? lastYear.dateRange1 : null;
  },
  lastLastYearWeekly: function lastLastYearWeekly(state, getters) {
    var movableDates = getters.movableDates;
    if (!movableDates) return null;
    var lastLastYear = movableDates.find(function (x) {
      return x.id === 'last_last_year_weekly';
    });
    return lastLastYear ? lastLastYear.dateRange1 : null;
  },
  weeklyCalendar: function weeklyCalendar(state) {
    return state.desktopParameterConfig ? state.desktopParameterConfig.weeklyCalendar : [];
  },
  dimensionFilter: function dimensionFilter(state) {
    return state.desktopParameterConfig ? state.desktopParameterConfig['dimensionFilter'] : null;
  },
  clientBusinessParameters: function clientBusinessParameters(state) {
    return state.desktopParameterConfig ? state.desktopParameterConfig['clientBusinessParameters'] : {};
  },
  productCategoryFilters: function productCategoryFilters(state) {
    return state.desktopParameterConfig ? state.desktopParameterConfig['productCategoryFilters'] : [];
  },
  storeFilters: function storeFilters(state) {
    return state.desktopParameterConfig ? state.desktopParameterConfig['storeFilters'] : [];
  },
  feedCategories: function feedCategories(state) {
    return state.desktopParameterConfig ? state.desktopParameterConfig['feedCategories'] : [];
  },
  accumulatedSalesDateOptions: function accumulatedSalesDateOptions(state) {
    return state.desktopParameterConfig ? state.desktopParameterConfig['accumulatedSalesDate'] : [];
  },
  userInfo: function userInfo(state) {
    return state.desktopParameterConfig ? state.desktopParameterConfig['userInfo'] : null;
  },
  regionConfig: function regionConfig(state) {
    return state.desktopParameterConfig ? state.desktopParameterConfig['regionConfig'] : null;
  },
  regionConfigModel: function regionConfigModel(state) {
    if (!state.desktopParameterConfig || !state.desktopParameterConfig['regionConfig']) {
      return null;
    }
    return new RegionConfigModel(state.desktopParameterConfig['regionConfig'].config);
  },
  contractModules: function contractModules(state) {
    return state.desktopParameterConfig ? state.desktopParameterConfig['contractModules'] : [];
  },
  accumulatedSalesDateOptionByFactName: function accumulatedSalesDateOptionByFactName(state, getters) {
    return function (factName) {
      var options = getters.accumulatedSalesDateOptions;
      if (!options) return null;
      return options.find(function (accumulatedSalesDateOption) {
        return accumulatedSalesDateOption.fact_name === factName;
      });
    };
  },
  userModules: function userModules(state) {
    return state.desktopParameterConfig ? state.desktopParameterConfig['userModules'] : [];
  },
  userDefaultInitView: function userDefaultInitView(state) {
    return state.desktopParameterConfig ? state.desktopParameterConfig['userDefaultInitView'] : 'Dashboard';
  },
  isAdmin: function isAdmin(state) {
    if (!state.desktopParameterConfig || !state.desktopParameterConfig['userModules']) {
      return false;
    }
    var modules = state.desktopParameterConfig['userModules'];
    var adminObject = modules.filter(function (x) {
      return x.id === 9;
    })[0];
    return adminObject ? adminObject.is_active : false;
  },
  defaultSelloutFact: function defaultSelloutFact(state) {
    return state.desktopParameterConfig ? state.desktopParameterConfig['defaultSelloutFact'] : null;
  },
  dynamicDates: function dynamicDates(state) {
    return state.desktopParameterConfig ? state.desktopParameterConfig.dynamicRanges : [];
  },
  defaultSelloutRangesOption: function defaultSelloutRangesOption(state) {
    if (!state.desktopParameterConfig || !state.desktopParameterConfig.defaultSelloutRangesOption) {
      return null;
    }
    return new DefaultSelloutRangesOptionModel(state.desktopParameterConfig.defaultSelloutRangesOption);
  },
  rootUsers: function rootUsers(state) {
    return state.desktopParameterConfig['rootUsers'] || [];
  },
  users: function users(state) {
    return state.desktopParameterConfig['users'] || [];
  }
});

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExecutorRunButton_vue__ = __webpack_require__(630);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49b95f42_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExecutorRunButton_vue__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1008)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49b95f42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExecutorRunButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49b95f42_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExecutorRunButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49b95f42_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExecutorRunButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_portal_vue__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_portal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_portal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sentry_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sentry_tracing__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_numeric__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_numeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_numeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_json_excel__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_spinner_src_PulseLoader_vue__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__app_shared_components_BaseLoader__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__plugin_CustomNumeral__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_viewerjs_dist_viewer_css__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_v_viewer__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_loading_overlay__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_Filters__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__app_shared_plugins_Mirage__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__vue_composition_api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_apexcharts__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue2_daterange_picker__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue2_daterange_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue2_daterange_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_moment__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_gtag__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue2_google_maps__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue2_daterange_picker_dist_vue2_daterange_picker_css__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue2_daterange_picker_dist_vue2_daterange_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vue2_daterange_picker_dist_vue2_daterange_picker_css__);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



























// Import Bootstrap an BootstrapVue CSS files (order is important)



if (false) {
  makeServer({
    environment: 'development'
  });
}

// Load Locales ('en' comes loaded by default)
__webpack_require__(222);

// Choose Locale
__WEBPACK_IMPORTED_MODULE_23_moment___default.a.locale('es');
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20__vue_composition_api__["b" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_26_vue2_google_maps__, {
  load: {
    key: "AIzaSyAmPsVI3zfFXbyVcoB1qDSpXGg6lBHGUZM",
    libraries: 'visualization'
  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["b" /* BootstrapVue */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["c" /* IconsPlugin */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_portal_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_numeric___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_v_viewer__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_vue_apexcharts___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_22_vue2_daterange_picker___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('downloadExcel', __WEBPACK_IMPORTED_MODULE_10_vue_json_excel__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('pulseLoader', __WEBPACK_IMPORTED_MODULE_11_vue_spinner_src_PulseLoader_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('ExpertoRetailLoader', __WEBPACK_IMPORTED_MODULE_12__app_shared_components_BaseLoader__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('Loading', __WEBPACK_IMPORTED_MODULE_17_vue_loading_overlay___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('apexchart', __WEBPACK_IMPORTED_MODULE_21_vue_apexcharts___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('DateRangePicker', __WEBPACK_IMPORTED_MODULE_22_vue2_daterange_picker___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24_vue_moment___default.a, {
  moment: __WEBPACK_IMPORTED_MODULE_23_moment___default.a
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_25_vue_gtag__["a" /* default */], {
  config: {
    id: 'G-FTH8CW3WQB',
    params: {
      send_page_view: false
    }
  }
});

// Inicializar Sentry
__WEBPACK_IMPORTED_MODULE_7__sentry_vue__["init"]({
  Vue: __WEBPACK_IMPORTED_MODULE_1_vue__["default"],
  dsn: 'https://fb3469f6478548e298d9976d235dd89f@o1332730.ingest.us.sentry.io/4510771407093760',
  integrations: [new __WEBPACK_IMPORTED_MODULE_8__sentry_tracing__["a" /* Integrations */].BrowserTracing({
    routingInstrumentation: __WEBPACK_IMPORTED_MODULE_7__sentry_vue__["vueRouterInstrumentation"](__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]),
    tracingOrigins: ['localhost', /^\//]
  })],
  // Performance Monitoring
  tracesSampleRate: 1.0,
  // Captura 100% de las transacciones para monitoreo de performance
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  // Capturar errores no manejados automáticamente
  beforeSend: function beforeSend(event, hint) {
    // Log para debugging (solo en desarrollo)
    if (false) {
      console.log('📤 Enviando evento a Sentry:', event);
    }
    return event;
  }
});

// Handler global para errores no capturados
if (typeof window !== 'undefined') {
  window.addEventListener('error', function (event) {
    __WEBPACK_IMPORTED_MODULE_7__sentry_vue__["captureException"](event.error || new Error(event.message));
  });
  window.addEventListener('unhandledrejection', function (event) {
    __WEBPACK_IMPORTED_MODULE_7__sentry_vue__["captureException"](event.reason);
  });
}

// Función de prueba para Sentry - disponible en consola del navegador
// Ejecuta: window.testSentryError() o window.testSentryMessage()
if (typeof window !== 'undefined') {
  window.testSentryError = function () {
    try {
      // Genera un error de prueba para verificar que Sentry lo capture
      throw new Error('Test error para verificar integración de Sentry');
    } catch (error) {
      if (typeof __WEBPACK_IMPORTED_MODULE_7__sentry_vue__ !== 'undefined' && __WEBPACK_IMPORTED_MODULE_7__sentry_vue__["captureException"]) {
        var eventId = __WEBPACK_IMPORTED_MODULE_7__sentry_vue__["captureException"](error);
        console.log('✅ Error de prueba capturado y enviado a Sentry');
        console.log('📤 Event ID:', eventId);
      } else {
        console.error('❌ Sentry no está disponible');
      }
    }
  };
  window.testSentryMessage = function () {
    if (typeof __WEBPACK_IMPORTED_MODULE_7__sentry_vue__ !== 'undefined' && __WEBPACK_IMPORTED_MODULE_7__sentry_vue__["captureMessage"]) {
      var eventId = __WEBPACK_IMPORTED_MODULE_7__sentry_vue__["captureMessage"]('Test message para verificar integración de Sentry', 'info');
      console.log('✅ Mensaje de prueba enviado a Sentry');
      console.log('📤 Event ID:', eventId);
    } else {
      console.error('❌ Sentry no está disponible');
    }
  };
  window.testSentryStatus = function () {
    console.log('🔍 Verificando estado de Sentry...');
    console.log('Sentry disponible:', typeof __WEBPACK_IMPORTED_MODULE_7__sentry_vue__ !== 'undefined');
    if (typeof __WEBPACK_IMPORTED_MODULE_7__sentry_vue__ !== 'undefined') {
      console.log('Sentry.captureException:', __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(__WEBPACK_IMPORTED_MODULE_7__sentry_vue__["captureException"]));
      console.log('Sentry.captureMessage:', __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(__WEBPACK_IMPORTED_MODULE_7__sentry_vue__["captureMessage"]));
      console.log('Sentry.getCurrentHub:', __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(__WEBPACK_IMPORTED_MODULE_7__sentry_vue__["getCurrentHub"]));
      try {
        var hub = __WEBPACK_IMPORTED_MODULE_7__sentry_vue__["getCurrentHub"]();
        var client = hub.getClient();
        if (client) {
          console.log('✅ Sentry está inicializado correctamente');
          console.log('DSN:', client.getDsn ? client.getDsn() : 'N/A');
        } else {
          console.error('❌ Sentry client no está disponible');
        }
      } catch (e) {
        console.error('❌ Error al verificar Sentry:', e);
      }
    }
  };
  window.testSentryUndefinedFunction = function () {
    try {
      // Prueba con función indefinida (como solicitaste)
      myUndefinedFunction();
    } catch (error) {
      // Verificar que Sentry esté disponible
      if (typeof __WEBPACK_IMPORTED_MODULE_7__sentry_vue__ !== 'undefined' && __WEBPACK_IMPORTED_MODULE_7__sentry_vue__["captureException"]) {
        // Capturar explícitamente el error en Sentry
        var eventId = __WEBPACK_IMPORTED_MODULE_7__sentry_vue__["captureException"](error);
        console.log('✅ Error de función indefinida capturado y enviado a Sentry');
        console.log('📤 Event ID:', eventId);
        console.log('🔍 Error details:', error);
      } else {
        console.error('❌ Sentry no está disponible o no está inicializado correctamente');
      }
      // NO re-lanzar el error para evitar "Uncaught" en consola
      // El error ya fue capturado y enviado a Sentry
    }
  };
}
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin({
  methods: {
    deepCopy: function deepCopy(obj) {
      var clone = {};
      for (var i in obj) {
        if (obj[i] != null && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(obj[i]) === 'object') {
          clone[i] = this.deepCopy(obj[i]);
        } else {
          clone[i] = obj[i];
        }
      }
      return clone;
    },
    deepCopyJsonMode: function deepCopyJsonMode(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    $_moneyNumeralFormat: function $_moneyNumeralFormat(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_13__plugin_CustomNumeral__["a" /* default */])(value).format('$ 0.00 a');
    },
    $_moneyNumeralFormatVerbose: function $_moneyNumeralFormatVerbose(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_13__plugin_CustomNumeral__["a" /* default */])(value).format('$ 0,0');
    },
    $_numberNumeralFormat: function $_numberNumeralFormat(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_13__plugin_CustomNumeral__["a" /* default */])(value).format('0.00 a');
    },
    $_numberNumeralFormatVerbose: function $_numberNumeralFormatVerbose(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_13__plugin_CustomNumeral__["a" /* default */])(value).format('0,0');
    },
    $_numberNumeralFormat_2: function $_numberNumeralFormat_2(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_13__plugin_CustomNumeral__["a" /* default */])(value).format('0,0');
    },
    $_percentageNumeralFormat: function $_percentageNumeralFormat(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_13__plugin_CustomNumeral__["a" /* default */])(value).format('0%');
    },
    $_formatMetricValue: function $_formatMetricValue(formatType, value) {
      if (formatType === 'PESOS') {
        return this.$_moneyNumeralFormat(value);
      } else if (formatType === 'UNITS') {
        return this.$_numberNumeralFormat(value);
      } else if (formatType === 'PERCENTAGE') {
        return this.$_percentageNumeralFormat(value);
      }
    },
    $_formatMetricValueVerbose: function $_formatMetricValueVerbose(formatType, value) {
      if (formatType === 'PESOS') {
        return this.$_moneyNumeralFormatVerbose(value);
      } else if (formatType === 'UNITS') {
        return this.$_numberNumeralFormatVerbose(value);
      } else if (formatType === 'PERCENTAGE') {
        return this.$_percentageNumeralFormat(value);
      }
    }
  }
});

/* eslint-disable no-new */

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$eventHub = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]();
Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype, '$lodash', {
  value: __WEBPACK_IMPORTED_MODULE_16_lodash___default.a
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  setup: function setup() {
    Object(__WEBPACK_IMPORTED_MODULE_20__vue_composition_api__["k" /* provide */])('vuex-store', __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */]);
  },
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */]
  }
});

/***/ }),
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(416);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed6dad36_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(784)
  __webpack_require__(786)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed6dad36_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed6dad36_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 784 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 785 */,
/* 786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */
/***/ (function(module, exports) {

module.exports = {"_from":"axios@^0.21.0","_id":"axios@0.21.4","_inBundle":false,"_integrity":"sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==","_location":"/axios","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"axios@^0.21.0","name":"axios","escapedName":"axios","rawSpec":"^0.21.0","saveSpec":null,"fetchSpec":"^0.21.0"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/axios/-/axios-0.21.4.tgz","_shasum":"c67b90dc0568e5c1cf2b0b858c43ba28e2eda575","_spec":"axios@^0.21.0","_where":"/home/runner/work/er-desktop/er-desktop","author":{"name":"Matt Zabriskie"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"bugs":{"url":"https://github.com/axios/axios/issues"},"bundleDependencies":false,"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}],"dependencies":{"follow-redirects":"^1.14.0"},"deprecated":false,"description":"Promise based HTTP client for the browser and node.js","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"homepage":"https://axios-http.com","jsdelivr":"dist/axios.min.js","keywords":["xhr","http","ajax","promise","node"],"license":"MIT","main":"index.js","name":"axios","repository":{"type":"git","url":"git+https://github.com/axios/axios.git"},"scripts":{"build":"NODE_ENV=production grunt build","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","examples":"node ./examples/server.js","fix":"eslint --fix lib/**/*.js","postversion":"git push && git push --tags","preversion":"npm test","start":"node ./sandbox/server.js","test":"grunt test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"},"typings":"./index.d.ts","unpkg":"dist/axios.min.js","version":"0.21.4"}

/***/ }),
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImpersonationAlert_vue__ = __webpack_require__(430);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c879d69_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImpersonationAlert_vue__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(811)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c879d69"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImpersonationAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c879d69_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImpersonationAlert_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c879d69_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImpersonationAlert_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showAlert)?_c('div',{staticClass:"impersonation-alert-wrapper"},[_c('b-alert',{staticClass:"impersonation-alert mb-0",attrs:{"show":"","variant":"warning","dismissible":""},on:{"dismissed":_vm.stopImpersonation}},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('i',{staticClass:"fa fa-user-secret me-2"}),_vm._v(" "),_c('span',[_c('strong',[_vm._v("Suplantando a:")]),_vm._v(" "+_vm._s(_vm.impersonatedUser.name)+" ("+_vm._s(_vm.impersonatedUser.email)+")\n        ")])]),_vm._v(" "),_c('b-button',{attrs:{"variant":"outline-dark","size":"sm","disabled":_vm.processing},on:{"click":_vm.stopImpersonation}},[_c('i',{staticClass:"fa fa-sign-out-alt me-1"}),_vm._v("\n        "+_vm._s(_vm.processing ? 'Deteniendo...' : 'Detener Suplantación')+"\n      ")])],1)])],1):_vm._e()}
var staticRenderFns = []


/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('ImpersonationAlert'),_vm._v(" "),(_vm.showPermissionAlert)?_c('b-alert',{staticClass:"permission-alert-global",attrs:{"variant":"warning","dismissible":"","fade":"","show":""},on:{"dismissed":_vm.hidePermissionAlert}},[_c('h5',[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v(" Permisos Insuficientes")]),_vm._v(" "),_c('p',[_vm._v("No tienes permisos para "+_vm._s(_vm.permissionAction)+".")]),_vm._v(" "),(_vm.rootUsers && _vm.rootUsers.root_users && _vm.rootUsers.root_users.length > 0)?_c('div',[_c('p',[_c('strong',[_vm._v("Contacta a una de las siguientes personas para que te de acceso:")])]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.filteredRootUsers),function(user){return _c('li',{key:user.user_id,staticClass:"permission-user-item"},[_c('span',{staticClass:"user-info"},[_vm._v("\n              "+_vm._s(user.name)+_vm._s(user.surname ? ' ' + user.surname : '')+" \n              "),_c('i',{staticClass:"fa fa-copy copy-email-icon",attrs:{"title":("Copiar email: " + (user.email))},on:{"click":function($event){return _vm.copyEmail(user.email)}}}),_vm._v(_vm._s(user.email)+"\n            ")])])}),0)]):_c('div',[_c('p',[_vm._v("Contacta al administrador del sistema.")])])]):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('portal-target',{attrs:{"name":"menu-portal"}}),_vm._v(" "),_c('portal-target',{attrs:{"name":"chart-tooltip-portal"}}),_vm._v(" "),_c('portal-target',{attrs:{"name":"ag-grid-dropdown-portal"}}),_vm._v(" "),_c('portal-target',{attrs:{"name":"tabs-dropdown-portal"}}),_vm._v(" "),_c('portal-target',{attrs:{"name":"news-feed-portal"}}),_vm._v(" "),_c('portal-target',{attrs:{"name":"store-map-popup-portal"}}),_vm._v(" "),_c('portal-target',{attrs:{"name":"route-assign-portal"}}),_vm._v(" "),_c('portal-target',{attrs:{"name":"modal-select-portal"}})],1)}
var staticRenderFns = []


/***/ }),
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);


var ClientTermsModel = /*#__PURE__*/function () {
  function ClientTermsModel(data) {
    var _ref, _data$has_accepted;
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ClientTermsModel);
    this.accepted = (_ref = (_data$has_accepted = data === null || data === void 0 ? void 0 : data.has_accepted) !== null && _data$has_accepted !== void 0 ? _data$has_accepted : data === null || data === void 0 ? void 0 : data.accepted) !== null && _ref !== void 0 ? _ref : false;
    this.acceptedAt = (data === null || data === void 0 ? void 0 : data.accepted_at) || null;
    this.termsVersion = (data === null || data === void 0 ? void 0 : data.terms_version) || (data === null || data === void 0 ? void 0 : data.checked_version) || '1.0';
    this.userId = (data === null || data === void 0 ? void 0 : data.user_id) || null;
    this.clientId = (data === null || data === void 0 ? void 0 : data.client_id) || null;
  }
  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ClientTermsModel, [{
    key: "isAccepted",
    get: function get() {
      return this.accepted === true;
    }
  }, {
    key: "needsAcceptance",
    get: function get() {
      return !this.isAccepted;
    }
  }, {
    key: "formattedAcceptedDate",
    get: function get() {
      if (!this.acceptedAt) return null;
      return new Date(this.acceptedAt).toLocaleDateString('es-CL');
    }
  }]);
}();
/* harmony default export */ __webpack_exports__["a"] = (ClientTermsModel);

/***/ }),
/* 819 */,
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(434);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52586a58_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(821)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52586a58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52586a58_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52586a58_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 821 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 822 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pulse-loader',{staticClass:"text-center experto-retail-loader",attrs:{"sm":"12","color":_vm.color}})}
var staticRenderFns = []


/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseHeader_vue__ = __webpack_require__(436);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57cde5f2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseHeader_vue__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(825)
  __webpack_require__(826)
  __webpack_require__(827)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57cde5f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57cde5f2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseHeader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57cde5f2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseHeader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 825 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 826 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 827 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdownAccntCustom_vue__ = __webpack_require__(437);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8a4199e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdownAccntCustom_vue__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(829)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a8a4199e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdownAccntCustom_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8a4199e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdownAccntCustom_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8a4199e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdownAccntCustom_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 829 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 830 */,
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  store_id: '',
  base64: null,
  mobileFilters: {
    product_filters: {
      product_category_hlev1_id: [],
      product_map_id: [],
      product_id: [],
      product_category_hlev2_id: [],
      product_category_hlev3_id: [],
      product_category_hlev4_id: [],
      color_id: [],
      brand_id: [],
      attr_1_id: [],
      attr_2_id: [],
      attr_3_id: [],
      obsolete: []
    }
  }
};
var getters = {};
var mutations = {
  commit_store_id: function commit_store_id(state, id) {
    state.store_id = id;
  },
  commit_base64: function commit_base64(state, string) {
    state.base64 = string;
  },
  commit_newFilters: function commit_newFilters(state, obj) {
    state.mobileFilters = obj;
  }
};
var actions = {};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  factTable: '',
  dateRange: {
    movableDate: '',
    range: []
  },
  filters: {},
  requestedData: {},
  productDim: [],
  storeDim: [],
  dateDim: [],
  grain: '',
  movableDateOptions: {},
  fileName: {}
};
var getters = {};
var mutations = {
  setParameter: function setParameter(state, params) {
    var parameter = params.key;
    state[parameter] = params.value;
  },
  setDims: function setDims(state, dim, value) {
    state[dim] = value;
  },
  setGrain: function setGrain(state, grain) {
    state.grain = grain;
  },
  setDateRange: function setDateRange(state, params) {
    state.dateRange = {};
    state.dateRange.movableDate = params.movDateStatus;
    state.dateRange.range = params.dateRange;
  },
  setFilters: function setFilters(state, params) {
    state.filters = params;
  },
  setMovableDateOptions: function setMovableDateOptions(state, data) {
    state.movableDateOptions = data;
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  selectedView: 'CustomCards',
  factTable: 'dw_ytd_comparative',
  dateRange: ''
};
var getters = {};
var mutations = {
  commit_selected_view: function commit_selected_view(state, id) {
    state.selectedView = id;
  },
  commit_factTable: function commit_factTable(state, str) {
    state.factTable = str;
  },
  commit_dateRange: function commit_dateRange(state, str) {
    state.dateRange = str;
  },
  commit_initCleanStates: function commit_initCleanStates(state) {
    state.selectedView = 'CustomCards';
  }
};
var actions = {};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var initialState = function initialState() {
  return {
    selectedOption: {
      factTable: '',
      optionName: '',
      dateRange: {
        actual: '',
        previous: ''
      }
    },
    currentView: 'CardView',
    factTable: 'dw_last_week_comparative',
    selectedDimension: {
      card1: {
        store_dimensions: ['retail_name'],
        product_dimensions: []
      },
      card2: {
        store_dimensions: ['retail_name'],
        product_dimensions: []
      },
      card3: {
        store_dimensions: ['comuna'],
        product_dimensions: []
      },
      card4: {
        store_dimensions: ['store_type'],
        product_dimensions: []
      },
      card5: {
        store_dimensions: ['promoter_present'],
        product_dimensions: []
      }
    }
  };
};
var state = initialState();
var getters = {};
var mutations = {
  commit_accumulatedSalesView: function commit_accumulatedSalesView(state, currentView) {
    state.currentView = currentView;
  },
  commit_accumulatedSalesFactTable: function commit_accumulatedSalesFactTable(state, factTable) {
    state.factTable = factTable;
  },
  commit_selectedDimension: function commit_selectedDimension(state, arr) {
    state.selectedDimension[arr[1]] = arr[0];
  },
  commit_accumulatedSales_resetState: function commit_accumulatedSales_resetState(state) {
    var newState = initialState();
    Object.keys(newState).forEach(function (key) {
      state[key] = newState[key];
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  dimensionColumns: {
    dim_value: '',
    dim_key: ''
  },
  breadCrumbPath: [],
  breadCrumbInstance: [],
  grid: {
    mainDim: 'retail_name',
    specialFilters: {},
    parameters: {},
    metricColDefs: {},
    groupArray: [],
    modParameters: null
  },
  uiOptions: {
    backButton: false
  }
};
var getters = {};
var mutations = {
  commit_agGridPivotDimensionColumns: function commit_agGridPivotDimensionColumns(state, obj) {
    state.dimensionColumns = obj;
  },
  commit_AGridPivotMetricGroupingParameters: function commit_AGridPivotMetricGroupingParameters(state, Array) {
    // Array: parameters, colDefs, groupArray
    state.grid.parameters = Array[0];
    state.grid.metricColDefs = Array[1];
    state.grid.groupArray = Array[2];
  },
  commit_gridMainDim: function commit_gridMainDim(state, dim) {
    state.grid.mainDim = dim;
  },
  commit_specialFilters: function commit_specialFilters(state, obj) {
    state.grid.specialFilters = obj;
  },
  commit_gridUiOptionsBackButton: function commit_gridUiOptionsBackButton(state, bool) {
    state.uiOptions = {
      backButton: bool
    };
  },
  commit_gridModParameters: function commit_gridModParameters(state, modParameters) {
    state.grid.modParameters = modParameters;
  },
  commit_gridBreadCrumbInstance: function commit_gridBreadCrumbInstance(state, obj) {
    state.breadCrumbInstance.push(obj);
  },
  commit_gridClearBreadCrumbInstance: function commit_gridClearBreadCrumbInstance(state) {
    state.breadCrumbInstance = [];
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  listSelectionDetailMap: {
    coordinate: {
      lat: -33.433804,
      lng: -70.642358
    },
    storeId: null
  }
};
var getters = {};
var mutations = {
  commit_storeGrowthCenterMap: function commit_storeGrowthCenterMap(state, arr) {
    state.listSelectionDetailMap.coordinate = arr[1];
    state.listSelectionDetailMap.storeId = arr[0];
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  roleList: [],
  userListSize: 0,
  allowedUsers: 0
};
var getters = {
  roleList: function roleList(state) {
    return state.roleList;
  }
};
var mutations = {
  commit_usersAdminAllStates: function commit_usersAdminAllStates(state, obj) {
    state.roleList = obj['roleList'];
    state.userListSize = obj['userListSize'];
    state.allowedUsers = obj['allowedUsers'];
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  retailSelected: null,
  cellClicked: null,
  gridIsReady: false,
  dateList: [],
  dateRange: {
    dateStart: '',
    dateEnd: ''
  }
};
var getters = {};
var mutations = {
  commit_priceAudition_cellClicked: function commit_priceAudition_cellClicked(state, cellClicked) {
    state.cellClicked = cellClicked;
  },
  commit_priceAudition_dateRange: function commit_priceAudition_dateRange(state, dateRange) {
    state.dateRange = dateRange;
  },
  commit_priceAudition_dateList: function commit_priceAudition_dateList(state, dateList) {
    state.dateList = dateList;
  },
  commit_priceAudition_retailSelected: function commit_priceAudition_retailSelected(state, retailSelected) {
    state.retailSelected = retailSelected;
  },
  commit_priceAudition_gridIsReady: function commit_priceAudition_gridIsReady(state, gridIsReady) {
    state.gridIsReady = gridIsReady;
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  requestParameters: {},
  cellClicked: {},
  clientView: '',
  cellCondition: function cellCondition() {}
};
var getters = {};
var mutations = {
  commit_gridMetricSystemWideOneMetric_requestParams: function commit_gridMetricSystemWideOneMetric_requestParams(state, params) {
    state.requestParameters = params;
  },
  commit_gridMetricSystemWideOneMetric_cellClicked: function commit_gridMetricSystemWideOneMetric_cellClicked(state, cellClicked) {
    state.cellClicked = cellClicked;
  },
  commit_gridMetricSystemWideOneMetric_clientView: function commit_gridMetricSystemWideOneMetric_clientView(state, clientView) {
    state.clientView = clientView;
  },
  commit_gridMetricSystemWideOneMetric_cellCondition: function commit_gridMetricSystemWideOneMetric_cellCondition(state, condition) {
    state.cellCondition = condition;
  }
};
var actions = {};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  retailSelected: null,
  cellClicked: null,
  gridIsReady: false
};
var getters = {};
var mutations = {
  commit_productWm_cellClicked: function commit_productWm_cellClicked(state, cellClicked) {
    state.cellClicked = cellClicked;
  },
  commit_productWm_retailSelected: function commit_productWm_retailSelected(state, retailSelected) {
    state.retailSelected = retailSelected;
  },
  commit_productWm_gridIsReady: function commit_productWm_gridIsReady(state, gridIsReady) {
    state.gridIsReady = gridIsReady;
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  selectedDimIndex: {},
  indexList: [],
  selectedIndexItem: null
};
var getters = {};
var mutations = {
  commit_dimensionFilterQuickAccess_selectedDimIndex: function commit_dimensionFilterQuickAccess_selectedDimIndex(state, selectedDimIndex) {
    state.selectedDimIndex = selectedDimIndex;
  },
  commit_dimensionFilterQuickAccess_indexList: function commit_dimensionFilterQuickAccess_indexList(state, indexList) {
    state.indexList = indexList;
  },
  commit_dimensionFilterQuickAccess_selectedIndexItem: function commit_dimensionFilterQuickAccess_selectedIndexItem(state, selectedIndexItem) {
    state.selectedIndexItem = selectedIndexItem;
  }
};
var actions = {};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//TODO: Delete this one and replace it for the new one in @/app/shared/store/modules/...filterRequestObject

var initialState = function initialState() {
  return {
    asyncProductPool: [],
    selectedOptions: {
      store_filters: [],
      product_filters: []
    },
    isSelectedFilters: {
      store_filters: false,
      product_filters: false
    },
    activeFilterObjectInstance: {
      store_filters: {
        retail_id: [],
        store_id: [],
        comuna: [],
        region_id: [],
        store_type_id: [],
        mall_id: [],
        distribution_type_id: [],
        retail_type_id: [],
        store_is_active: []
      },
      product_filters: {
        product_category_hlev1_id: [],
        product_map_id: [],
        product_id: [],
        product_category_hlev2_id: [],
        product_category_hlev3_id: [],
        product_category_hlev4_id: [],
        color_id: [],
        brand_id: [],
        attr_1_id: [],
        attr_2_id: [],
        attr_3_id: [],
        attr_4_id: [],
        attr_5_id: [],
        attr_6_id: [],
        attr_7_id: [],
        attr_8_id: [],
        obsolete: []
      }
    }
  };
};
var state = initialState();
var mutations = {
  commit_filterRequestObject_isSelectedFilters: function commit_filterRequestObject_isSelectedFilters(state, payload) {
    state.isSelectedFilters[payload['filterType']] = payload['value'];
  },
  commit_filterRequestObject_activeFilterObjectInstance: function commit_filterRequestObject_activeFilterObjectInstance(state, activeFilterObjectInstance) {
    state.activeFilterObjectInstance = activeFilterObjectInstance;
  },
  commit_filterRequestObject_selectedOptions: function commit_filterRequestObject_selectedOptions(state, payload) {
    state.selectedOptions[payload['filterType']] = payload['filtersRenderObject'];
  },
  commit_filterPane_resetState: function commit_filterPane_resetState(state) {
    var newState = initialState();
    Object.keys(newState).forEach(function (key) {
      state[key] = newState[key];
    });
  },
  commit_async_product_pool: function commit_async_product_pool(state, payload) {
    state.asyncProductPool = payload;
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  mutations: mutations
});

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var initialState = function initialState() {
  return {
    selectedReport: '',
    reportParameters: {},
    selectedRetail: 0,
    retailListSelectorData: [],
    dimensionFilterData: [],
    gridData: [],
    selectedRetailBusinessParameters: {},
    productSelectorData: []
  };
};
var state = initialState();

// const state = {
//   selectedReport: null,
//   reportParameters: null,
//   selectedRetail: null,
//   retailListSelectorData: null,
//   dimensionFilterData: null,
//   gridData: null,
//   selectedRetailBusinessParameters: {}
// }

var getters = {};
var mutations = {
  commit_genKeyKpiAnalysis_selectedReport: function commit_genKeyKpiAnalysis_selectedReport(state, selectedReport) {
    state.selectedReport = selectedReport;
  },
  commit_genKeyKpiAnalysis_reportParameters: function commit_genKeyKpiAnalysis_reportParameters(state, reportParameters) {
    state.reportParameters = reportParameters;
  },
  commit_genKeyKpiAnalysis_selectedRetail: function commit_genKeyKpiAnalysis_selectedRetail(state, selectedRetail) {
    state.selectedRetail = selectedRetail;
  },
  commit_genKeyKpiAnalysis_retailListSelectorData: function commit_genKeyKpiAnalysis_retailListSelectorData(state, retailListSelectorData) {
    state.retailListSelectorData = retailListSelectorData;
  },
  commit_genKeyKpiAnalysis_selectedRetailBusinessParameters: function commit_genKeyKpiAnalysis_selectedRetailBusinessParameters(state, selectedRetailBusinessParameters) {
    state.selectedRetailBusinessParameters = selectedRetailBusinessParameters;
  },
  commit_genKeyKpiAnalysis_dimensionFilterData: function commit_genKeyKpiAnalysis_dimensionFilterData(state, dimensionFilterData) {
    state.dimensionFilterData = dimensionFilterData;
  },
  commit_genKeyKpiAnalysis_gridData: function commit_genKeyKpiAnalysis_gridData(state, gridData) {
    state.gridData = gridData;
  },
  commit_genKeyKpiAnalysis_productSelectorData: function commit_genKeyKpiAnalysis_productSelectorData(state, productSelectorData) {
    state.productSelectorData = productSelectorData;
  },
  commit_genKeyKpiAnalysis_resetState: function commit_genKeyKpiAnalysis_resetState(state) {
    var newState = initialState();
    Object.keys(newState).forEach(function (key) {
      state[key] = newState[key];
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var initialState = function initialState() {
  return {
    accumulatedSalesKpiData: [],
    chartData: [],
    storeGrowthData: [],
    loading: false,
    selectedMetricOption: {}
  };
};
var state = initialState();
var getters = {};
var mutations = {
  commit_sellOutDashboardCard_accumulatedSalesKpiData: function commit_sellOutDashboardCard_accumulatedSalesKpiData(state, accumulatedSalesKpiData) {
    state.accumulatedSalesKpiData = accumulatedSalesKpiData;
  },
  commit_sellOutDashboardCard_loading: function commit_sellOutDashboardCard_loading(state, loading) {
    state.loading = loading;
  },
  commit_sellOutDashboardCard_selectedMetricOption: function commit_sellOutDashboardCard_selectedMetricOption(state, selectedMetricOption) {
    state.selectedMetricOption = selectedMetricOption;
  },
  commit_sellOutDashboardCard_storeGrowthData: function commit_sellOutDashboardCard_storeGrowthData(state, storeGrowthData) {
    this.state.storeGrowthData = storeGrowthData;
  },
  commit_sellOutDashboardCard_resetState: function commit_sellOutDashboardCard_resetState(state) {
    var newState = initialState();
    Object.keys(newState).forEach(function (key) {
      state[key] = newState[key];
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return massiveDownloadPostParameters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return massiveDownloadSaveConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return massiveDownloadGetConfigList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return massiveDownloadGetJobList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_client_js__ = __webpack_require__(39);



var massiveDownloadSaveConfig = /*#__PURE__*/function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee(body) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/massive-download/user-config', body, {
            needTokenValidation: true
          });
        case 1:
          response = _context.sent;
          if (!(response.status !== 201)) {
            _context.next = 2;
            break;
          }
          throw new Error('Error al guardar la configuración');
        case 2:
          return _context.abrupt("return", response);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function massiveDownloadSaveConfig(_x) {
    return _ref.apply(this, arguments);
  };
}();
var massiveDownloadPostParameters = /*#__PURE__*/function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2(parameters) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].post('/massive-download', {
            parameters: parameters
          }, {
            needTokenValidation: true
          });
        case 1:
          response = _context2.sent;
          if (!(response.status !== 201)) {
            _context2.next = 2;
            break;
          }
          throw new Error('Error al procesar el trabajo de archivo');
        case 2:
          return _context2.abrupt("return", response);
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function massiveDownloadPostParameters(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var massiveDownloadGetConfigList = /*#__PURE__*/function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3() {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get('/md-get-user-config/');
        case 1:
          response = _context3.sent;
          if (!(response.status !== 200)) {
            _context3.next = 2;
            break;
          }
          throw new Error('Error al obtener las configuraciones');
        case 2:
          return _context3.abrupt("return", response.data);
        case 3:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function massiveDownloadGetConfigList() {
    return _ref3.apply(this, arguments);
  };
}();
var massiveDownloadGetJobList = /*#__PURE__*/function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee4() {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 1;
          return __WEBPACK_IMPORTED_MODULE_2__api_client_js__["c" /* ClientLambdaApi */].get('/massive-download-job-list/');
        case 1:
          response = _context4.sent;
          if (!(response.status !== 200)) {
            _context4.next = 2;
            break;
          }
          throw new Error('Error al obtener el listado de trabajos');
        case 2:
          return _context4.abrupt("return", response.data);
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function massiveDownloadGetJobList() {
    return _ref4.apply(this, arguments);
  };
}();


/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shared_models_Parameters__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);




var MassiveDownloadPost = /*#__PURE__*/function () {
  function MassiveDownloadPost(_ref) {
    var selectedGranularity = _ref.selectedGranularity,
      selectedDateFrom = _ref.selectedDateFrom,
      selectedDateTo = _ref.selectedDateTo,
      selectedProductDimensionIds = _ref.selectedProductDimensionIds,
      selectedStoreDimensionIds = _ref.selectedStoreDimensionIds,
      selectedProductFilters = _ref.selectedProductFilters,
      selectedStoreFilters = _ref.selectedStoreFilters,
      selectedStoreProductDimensionIds = _ref.selectedStoreProductDimensionIds,
      stock = _ref.stock;
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, MassiveDownloadPost);
    this.granularity = selectedGranularity;
    this.dateFrom = __WEBPACK_IMPORTED_MODULE_3_moment___default()(selectedDateFrom).format('YYYYMMDD');
    this.dateTo = __WEBPACK_IMPORTED_MODULE_3_moment___default()(selectedDateTo).format('YYYYMMDD');
    this.productDimensionIds = selectedProductDimensionIds;
    this.storeDimensionIds = selectedStoreDimensionIds;
    this.storeProductDimensionIds = selectedStoreProductDimensionIds;
    this.productFilters = selectedProductFilters;
    this.storeFilters = selectedStoreFilters;
    this.stock = stock;
  }
  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(MassiveDownloadPost, [{
    key: "parameters",
    get: function get() {
      var fixedMetricsNormal = ['quantity_sold', 'real_sales_cost', 'real_sales_amount', 'stock_quantity', 'real_margin', 'real_stock_pvp_amount', 'real_stock_cost_amount', 'transfer_quantity'];
      var dateDimensions = this.granularity.dateFromField ? ['date_from'] : [];
      return new __WEBPACK_IMPORTED_MODULE_2__app_shared_models_Parameters__["a" /* default */].ParametersBuilder().withStoreFilters(this.storeFilters).withProductFilters(this.productFilters).withStoreDimensions(this.storeDimensionIds).withProductDimensions(this.productDimensionIds).withStoreProductDimensions(this.storeProductDimensionIds).withDateDimensions(dateDimensions).withMetrics({
        normal: fixedMetricsNormal,
        "var": []
      }).withStock(this.stock).withFact({
        type: 'table',
        name: this.granularity.factTable
      }).withDateFilters({
        date: {
          operator: 'BT',
          value: [this.dateFrom, this.dateTo]
        }
      }).withSort({
        field: 'quantity_sold',
        dir: 'desc'
      }).withGranularity(this.granularity).build();
    }
  }]);
}();
/* harmony default export */ __webpack_exports__["a"] = (MassiveDownloadPost);

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);


var Parameters = /*#__PURE__*/function () {
  function Parameters(build) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Parameters);
    this.store_filters = build.storeFilters;
    this.product_filters = build.productFilters;
    this.store_dimensions = build.storeDimensions;
    this.product_dimensions = build.productDimensions;
    this.store_product_dimensions = build.storeProductDimensions;
    this.date_dimensions = build.dateDimensions;
    this.metrics = build.metrics;
    this.stock = build.stock;
    this.fact = build.fact;
    this.date_filters = build.dateFilters;
    this.sort = build.sort;
    this.limit = build.limit;
    this.offset = build.offset;
    this.granularity = build.granularity;
  }
  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Parameters, null, [{
    key: "ParametersBuilder",
    get: function get() {
      var ParametersBuilder = /*#__PURE__*/function () {
        function ParametersBuilder() {
          var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          var dateDimensions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
          __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ParametersBuilder);
          this.limit = limit;
          this.offset = offset;
          this.dateDimensions = dateDimensions;
        }
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ParametersBuilder, [{
          key: "withStoreFilters",
          value: function withStoreFilters(storeFilters) {
            this.storeFilters = storeFilters;
            return this;
          }
        }, {
          key: "withProductFilters",
          value: function withProductFilters(productFilters) {
            this.productFilters = productFilters;
            return this;
          }
        }, {
          key: "withStoreDimensions",
          value: function withStoreDimensions(storeDimensions) {
            this.storeDimensions = storeDimensions;
            return this;
          }
        }, {
          key: "withProductDimensions",
          value: function withProductDimensions(productDimensions) {
            this.productDimensions = productDimensions;
            return this;
          }
        }, {
          key: "withStoreProductDimensions",
          value: function withStoreProductDimensions(storeProductDimensions) {
            this.storeProductDimensions = storeProductDimensions;
            return this;
          }
        }, {
          key: "withDateDimensions",
          value: function withDateDimensions(dateDimensions) {
            this.dateDimensions = dateDimensions;
            return this;
          }
        }, {
          key: "withMetrics",
          value: function withMetrics(metrics) {
            this.metrics = metrics;
            return this;
          }
        }, {
          key: "withStock",
          value: function withStock(stock) {
            this.stock = stock;
            return this;
          }
        }, {
          key: "withFact",
          value: function withFact(fact) {
            this.fact = fact;
            return this;
          }
        }, {
          key: "withDateFilters",
          value: function withDateFilters(dateFilters) {
            this.dateFilters = dateFilters;
            return this;
          }
        }, {
          key: "withSort",
          value: function withSort(sort) {
            this.sort = sort;
            return this;
          }
        }, {
          key: "withGranularity",
          value: function withGranularity(granularity) {
            this.granularity = granularity.id;
            return this;
          }
        }, {
          key: "build",
          value: function build() {
            return new Parameters(this);
          }
        }]);
      }();
      return ParametersBuilder;
    }
  }]);
}();
/* harmony default export */ __webpack_exports__["a"] = (Parameters);

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 438,
	"./af.js": 438,
	"./ar": 439,
	"./ar-dz": 440,
	"./ar-dz.js": 440,
	"./ar-kw": 441,
	"./ar-kw.js": 441,
	"./ar-ly": 442,
	"./ar-ly.js": 442,
	"./ar-ma": 443,
	"./ar-ma.js": 443,
	"./ar-ps": 444,
	"./ar-ps.js": 444,
	"./ar-sa": 445,
	"./ar-sa.js": 445,
	"./ar-tn": 446,
	"./ar-tn.js": 446,
	"./ar.js": 439,
	"./az": 447,
	"./az.js": 447,
	"./be": 448,
	"./be.js": 448,
	"./bg": 449,
	"./bg.js": 449,
	"./bm": 450,
	"./bm.js": 450,
	"./bn": 451,
	"./bn-bd": 452,
	"./bn-bd.js": 452,
	"./bn.js": 451,
	"./bo": 453,
	"./bo.js": 453,
	"./br": 454,
	"./br.js": 454,
	"./bs": 455,
	"./bs.js": 455,
	"./ca": 456,
	"./ca.js": 456,
	"./cs": 457,
	"./cs.js": 457,
	"./cv": 458,
	"./cv.js": 458,
	"./cy": 459,
	"./cy.js": 459,
	"./da": 460,
	"./da.js": 460,
	"./de": 461,
	"./de-at": 462,
	"./de-at.js": 462,
	"./de-ch": 463,
	"./de-ch.js": 463,
	"./de.js": 461,
	"./dv": 464,
	"./dv.js": 464,
	"./el": 465,
	"./el.js": 465,
	"./en-au": 466,
	"./en-au.js": 466,
	"./en-ca": 467,
	"./en-ca.js": 467,
	"./en-gb": 468,
	"./en-gb.js": 468,
	"./en-ie": 469,
	"./en-ie.js": 469,
	"./en-il": 470,
	"./en-il.js": 470,
	"./en-in": 471,
	"./en-in.js": 471,
	"./en-nz": 472,
	"./en-nz.js": 472,
	"./en-sg": 473,
	"./en-sg.js": 473,
	"./eo": 474,
	"./eo.js": 474,
	"./es": 222,
	"./es-do": 475,
	"./es-do.js": 475,
	"./es-mx": 476,
	"./es-mx.js": 476,
	"./es-us": 477,
	"./es-us.js": 477,
	"./es.js": 222,
	"./et": 478,
	"./et.js": 478,
	"./eu": 479,
	"./eu.js": 479,
	"./fa": 480,
	"./fa.js": 480,
	"./fi": 481,
	"./fi.js": 481,
	"./fil": 482,
	"./fil.js": 482,
	"./fo": 483,
	"./fo.js": 483,
	"./fr": 484,
	"./fr-ca": 485,
	"./fr-ca.js": 485,
	"./fr-ch": 486,
	"./fr-ch.js": 486,
	"./fr.js": 484,
	"./fy": 487,
	"./fy.js": 487,
	"./ga": 488,
	"./ga.js": 488,
	"./gd": 489,
	"./gd.js": 489,
	"./gl": 490,
	"./gl.js": 490,
	"./gom-deva": 491,
	"./gom-deva.js": 491,
	"./gom-latn": 492,
	"./gom-latn.js": 492,
	"./gu": 493,
	"./gu.js": 493,
	"./he": 494,
	"./he.js": 494,
	"./hi": 495,
	"./hi.js": 495,
	"./hr": 496,
	"./hr.js": 496,
	"./hu": 497,
	"./hu.js": 497,
	"./hy-am": 498,
	"./hy-am.js": 498,
	"./id": 499,
	"./id.js": 499,
	"./is": 500,
	"./is.js": 500,
	"./it": 501,
	"./it-ch": 502,
	"./it-ch.js": 502,
	"./it.js": 501,
	"./ja": 503,
	"./ja.js": 503,
	"./jv": 504,
	"./jv.js": 504,
	"./ka": 505,
	"./ka.js": 505,
	"./kk": 506,
	"./kk.js": 506,
	"./km": 507,
	"./km.js": 507,
	"./kn": 508,
	"./kn.js": 508,
	"./ko": 509,
	"./ko.js": 509,
	"./ku": 510,
	"./ku-kmr": 511,
	"./ku-kmr.js": 511,
	"./ku.js": 510,
	"./ky": 512,
	"./ky.js": 512,
	"./lb": 513,
	"./lb.js": 513,
	"./lo": 514,
	"./lo.js": 514,
	"./lt": 515,
	"./lt.js": 515,
	"./lv": 516,
	"./lv.js": 516,
	"./me": 517,
	"./me.js": 517,
	"./mi": 518,
	"./mi.js": 518,
	"./mk": 519,
	"./mk.js": 519,
	"./ml": 520,
	"./ml.js": 520,
	"./mn": 521,
	"./mn.js": 521,
	"./mr": 522,
	"./mr.js": 522,
	"./ms": 523,
	"./ms-my": 524,
	"./ms-my.js": 524,
	"./ms.js": 523,
	"./mt": 525,
	"./mt.js": 525,
	"./my": 526,
	"./my.js": 526,
	"./nb": 527,
	"./nb.js": 527,
	"./ne": 528,
	"./ne.js": 528,
	"./nl": 529,
	"./nl-be": 530,
	"./nl-be.js": 530,
	"./nl.js": 529,
	"./nn": 531,
	"./nn.js": 531,
	"./oc-lnc": 532,
	"./oc-lnc.js": 532,
	"./pa-in": 533,
	"./pa-in.js": 533,
	"./pl": 534,
	"./pl.js": 534,
	"./pt": 535,
	"./pt-br": 536,
	"./pt-br.js": 536,
	"./pt.js": 535,
	"./ro": 537,
	"./ro.js": 537,
	"./ru": 538,
	"./ru.js": 538,
	"./sd": 539,
	"./sd.js": 539,
	"./se": 540,
	"./se.js": 540,
	"./si": 541,
	"./si.js": 541,
	"./sk": 542,
	"./sk.js": 542,
	"./sl": 543,
	"./sl.js": 543,
	"./sq": 544,
	"./sq.js": 544,
	"./sr": 545,
	"./sr-cyrl": 546,
	"./sr-cyrl.js": 546,
	"./sr.js": 545,
	"./ss": 547,
	"./ss.js": 547,
	"./sv": 548,
	"./sv.js": 548,
	"./sw": 549,
	"./sw.js": 549,
	"./ta": 550,
	"./ta.js": 550,
	"./te": 551,
	"./te.js": 551,
	"./tet": 552,
	"./tet.js": 552,
	"./tg": 553,
	"./tg.js": 553,
	"./th": 554,
	"./th.js": 554,
	"./tk": 555,
	"./tk.js": 555,
	"./tl-ph": 556,
	"./tl-ph.js": 556,
	"./tlh": 557,
	"./tlh.js": 557,
	"./tr": 558,
	"./tr.js": 558,
	"./tzl": 559,
	"./tzl.js": 559,
	"./tzm": 560,
	"./tzm-latn": 561,
	"./tzm-latn.js": 561,
	"./tzm.js": 560,
	"./ug-cn": 562,
	"./ug-cn.js": 562,
	"./uk": 563,
	"./uk.js": 563,
	"./ur": 564,
	"./ur.js": 564,
	"./uz": 565,
	"./uz-latn": 566,
	"./uz-latn.js": 566,
	"./uz.js": 565,
	"./vi": 567,
	"./vi.js": 567,
	"./x-pseudo": 568,
	"./x-pseudo.js": 568,
	"./yo": 569,
	"./yo.js": 569,
	"./zh-cn": 570,
	"./zh-cn.js": 570,
	"./zh-hk": 571,
	"./zh-hk.js": 571,
	"./zh-mo": 572,
	"./zh-mo.js": 572,
	"./zh-tw": 573,
	"./zh-tw.js": 573
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 848;

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);




function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MassiveDownloadPostSaveUserConfig = /*#__PURE__*/function () {
  function MassiveDownloadPostSaveUserConfig(_ref) {
    var selectedGranularity = _ref.selectedGranularity,
      dynamicDateMapId = _ref.dynamicDateMapId,
      selectedDateFrom = _ref.selectedDateFrom,
      selectedDateTo = _ref.selectedDateTo,
      selectedProductDimensionIds = _ref.selectedProductDimensionIds,
      selectedStoreDimensionIds = _ref.selectedStoreDimensionIds,
      reportName = _ref.reportName,
      reportDescription = _ref.reportDescription,
      defaultSelectionDeepCopy = _ref.defaultSelectionDeepCopy;
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, MassiveDownloadPostSaveUserConfig);
    this.granularity = selectedGranularity;
    this.dynamicDateMapId = dynamicDateMapId;
    this.dateFrom = new Date(selectedDateFrom).getTime();
    this.dateTo = new Date(selectedDateTo).getTime();
    this.productDimensionIds = selectedProductDimensionIds;
    this.storeDimensionIds = selectedStoreDimensionIds;
    this.reportName = reportName;
    this.reportDescription = reportDescription;
    this.defaultSelection = defaultSelectionDeepCopy;
  }
  return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(MassiveDownloadPostSaveUserConfig, [{
    key: "body",
    get: function get() {
      this.defaultSelection.requiredSelection.granularity.options = this.userConfigGranularityOptions;
      this.defaultSelection.requiredSelection.dateSelection.dynamicDate.options = this.userConfigDynamicDateOptions;
      this.defaultSelection.columnSelection.productDimensions.options = this.userConfigProductDimenionOptions;
      this.defaultSelection.columnSelection.storeDimensions.options = this.userConfigStoreDimenionOptions;
      this.defaultSelection.requiredSelection.dateSelection.customDate.from = this.dateFrom;
      this.defaultSelection.requiredSelection.dateSelection.customDate.to = this.dateTo;
      return {
        metadata: {
          name: this.reportName,
          description: this.reportDescription
        },
        parameters: _objectSpread({}, this.defaultSelection)
      };
    }
  }, {
    key: "userConfigGranularityOptions",
    get: function get() {
      var _this = this;
      return this.defaultSelection.requiredSelection.granularity.options.map(function (option) {
        return _this.changeSelectedOption(option, option.id === _this.granularity.id);
      });
    }
  }, {
    key: "userConfigDynamicDateOptions",
    get: function get() {
      var _this2 = this;
      return this.defaultSelection.requiredSelection.dateSelection.dynamicDate.options.map(function (option) {
        return _this2.changeSelectedOption(option, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(_this2.dynamicDateMapId.values()).includes(option.id));
      }).map(function (option) {
        return _objectSpread(_objectSpread({}, option), {}, {
          from: undefined,
          to: undefined
        });
      });
    }
  }, {
    key: "userConfigProductDimenionOptions",
    get: function get() {
      var _this3 = this;
      return this.defaultSelection.columnSelection.productDimensions.options.map(function (option) {
        return _this3.changeSelectedOption(option, _this3.productDimensionIds.includes(option.value));
      });
    }
  }, {
    key: "userConfigStoreDimenionOptions",
    get: function get() {
      var _this4 = this;
      return this.defaultSelection.columnSelection.storeDimensions.options.map(function (option) {
        return _this4.changeSelectedOption(option, _this4.storeDimensionIds.includes(option.value));
      });
    }
  }, {
    key: "changeSelectedOption",
    value: function changeSelectedOption(option, rule) {
      return rule ? _objectSpread(_objectSpread({}, option), {}, {
        selected: true
      }) : _objectSpread(_objectSpread({}, option), {}, {
        selected: false
      });
    }
  }]);
}();
/* harmony default export */ __webpack_exports__["a"] = (MassiveDownloadPostSaveUserConfig);

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_massive_download_models_MassiveDownload__ = __webpack_require__(574);



var MassiveDownloadConfig = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function MassiveDownloadConfig(_ref) {
  var id = _ref.id,
    userId = _ref.userId,
    config = _ref.config,
    createdAt = _ref.createdAt,
    name = _ref.name,
    description = _ref.description;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, MassiveDownloadConfig);
  this.id = id;
  this.userId = userId;
  this.parameters = new __WEBPACK_IMPORTED_MODULE_2__app_massive_download_models_MassiveDownload__["a" /* default */](config);
  this.createdAt = createdAt;
  this.name = name;
  this.description = description;
});
/* harmony default export */ __webpack_exports__["a"] = (MassiveDownloadConfig);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_massive_download_models_DateSelection__ = __webpack_require__(852);



var RequiredSelection = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function RequiredSelection(_ref) {
  var description = _ref.description,
    granularity = _ref.granularity,
    dateSelection = _ref.dateSelection;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, RequiredSelection);
  this.description = description;
  this.granularity = granularity;
  this.dateSelection = new __WEBPACK_IMPORTED_MODULE_2__app_massive_download_models_DateSelection__["a" /* default */](dateSelection);
});
/* harmony default export */ __webpack_exports__["a"] = (RequiredSelection);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);


var CustomDate = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function CustomDate(_ref) {
  var id = _ref.id,
    description = _ref.description,
    from = _ref.from,
    to = _ref.to;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, CustomDate);
  this.id = id;
  this.description = description;
  this.from = from ? new Date(from) : null;
  this.to = to ? new Date(to) : null;
});
var DynamicDateOption = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function DynamicDateOption(_ref2) {
  var id = _ref2.id,
    value = _ref2.value,
    from = _ref2.from,
    to = _ref2.to,
    selected = _ref2.selected,
    granularity = _ref2.granularity;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, DynamicDateOption);
  this.id = id;
  this.value = value;
  this.from = from ? new Date(from) : null;
  this.to = to ? new Date(to) : null;
  this.selected = selected;
  this.granularity = granularity;
});
var DynamicDate = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function DynamicDate(_ref3) {
  var id = _ref3.id,
    description = _ref3.description,
    selected = _ref3.selected,
    options = _ref3.options;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, DynamicDate);
  this.id = id;
  this.description = description;
  this.selected = selected;
  this.options = options.map(function (option) {
    return new DynamicDateOption(option);
  });
});
var DateSelection = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function DateSelection(_ref4) {
  var dynamicDate = _ref4.dynamicDate,
    customDate = _ref4.customDate;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, DateSelection);
  this.dynamicDate = new DynamicDate(dynamicDate);
  this.customDate = new CustomDate(customDate);
});
/* harmony default export */ __webpack_exports__["a"] = (DateSelection);

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);


/* eslint-disable camelcase */
var MassiveDownloadJob = /*#__PURE__*/function () {
  function MassiveDownloadJob(_ref) {
    var id = _ref.id,
      filename = _ref.filename,
      status = _ref.status,
      b_status = _ref.b_status,
      name = _ref.name,
      created_at = _ref.created_at,
      finished_at = _ref.finished_at,
      base_dir = _ref.base_dir,
      surname = _ref.surname;
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, MassiveDownloadJob);
    this.id = id;
    this.filename = filename;
    this.status = status;
    this.bStatus = b_status;
    this.name = name;
    this.createdAt = created_at;
    this.finishedAt = finished_at;
    this.baseDir = base_dir;
    this.surname = surname || '';
  }
  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(MassiveDownloadJob, [{
    key: "fullname",
    get: function get() {
      return "".concat(this.name, " ").concat(this.surname, " ");
    }
  }]);
}();
/* harmony default export */ __webpack_exports__["a"] = (MassiveDownloadJob);

/***/ }),
/* 854 */,
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InitConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LongGridInitConfig__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WideGridInitConfig__ = __webpack_require__(857);


/* eslint-disable camelcase */


// import Dimension from './Dimension'
var InitConfig = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function InitConfig(_ref) {
  var long_grid = _ref.long_grid,
    wide_grid = _ref.wide_grid,
    shared = _ref.shared;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, InitConfig);
  this.longGrid = new __WEBPACK_IMPORTED_MODULE_2__LongGridInitConfig__["a" /* default */](long_grid);
  this.wideGrid = new __WEBPACK_IMPORTED_MODULE_3__WideGridInitConfig__["a" /* default */](wide_grid);
  // this.dimensions = shared.dimensions.map((dimension) => new Dimension(dimension))
});


/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LongGridInitConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);


var LongGridInitConfig = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function LongGridInitConfig(_ref) {
  var defaultParameters = _ref.defaultParameters;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, LongGridInitConfig);
  this.defaultParameters = defaultParameters;
});


/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WideGridInitConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);


var WideGridInitConfig = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function WideGridInitConfig(_ref) {
  var defaultParameters = _ref.defaultParameters,
    metricOptions = _ref.metricOptions,
    defaultMetric = _ref.defaultMetric;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, WideGridInitConfig);
  this.defaultParameters = defaultParameters;
  this.metricOptions = metricOptions;
  this.defaultMetric = defaultMetric;
});


/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SalesAnalysisAgGrid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_sales_analysis_models_SalesAnalysisColumnDefinitionFactory__ = __webpack_require__(269);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable camelcase */

var SalesAnalysisAgGrid = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(function SalesAnalysisAgGrid(_ref) {
  var col_definition = _ref.col_definition,
    data = _ref.data,
    aggregation = _ref.aggregation;
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, SalesAnalysisAgGrid);
  this.columnDefs = col_definition.map(function (columnDef) {
    return __WEBPACK_IMPORTED_MODULE_3__app_sales_analysis_models_SalesAnalysisColumnDefinitionFactory__["a" /* default */].create(columnDef);
  });
  this.data = data;
  this.aggregation = [_objectSpread(_objectSpread({}, aggregation), {}, {
    pivot: ' '
  })];
});


/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OneDimensionStrategy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);


var OneDimensionStrategy = /*#__PURE__*/function () {
  function OneDimensionStrategy(dimension, filter) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, OneDimensionStrategy);
    this.dimension = dimension;
    this.filter = filter;
    this.storeFilters = {};
    this.productFilters = {};
  }
  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(OneDimensionStrategy, [{
    key: "_buildDimensions",
    value: function _buildDimensions() {
      var selectedDimensionIds = [this.dimension.id];
      if (this.dimension.type === 'store') this.storeDimensions = selectedDimensionIds;
      if (this.dimension.type === 'product') this.productDimensions = selectedDimensionIds;
    }
  }, {
    key: "_buildFilter",
    value: function _buildFilter() {
      var filterIds = this.filter.value;
      if (this.filter.keyFieldType === 'store') this.storeFilters[this.filter.keyField] = filterIds;
      if (this.filter.keyFieldType === 'product') this.productFilters[this.filter.keyField] = filterIds;
    }
  }, {
    key: "build",
    value: function build() {
      if (!('dimension' in this)) {
        throw new Error('Falta la dimensión');
      }
      if (this.filter) {
        this._buildFilter();
      }
      this._buildDimensions();
      return this;
    }
  }]);
}();


/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TwoDimensionStrategy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TwoDimensionStrategy = /*#__PURE__*/function () {
  function TwoDimensionStrategy(_ref) {
    var productStrategy = _ref.productStrategy,
      storeStrategy = _ref.storeStrategy;
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, TwoDimensionStrategy);
    this.productStrategy = productStrategy;
    this.storeStrategy = storeStrategy;
  }
  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(TwoDimensionStrategy, [{
    key: "build",
    value: function build() {
      var productStrategyPayloadParameters = this.productStrategy.build();
      var storeStrategyPayloadParameters = this.storeStrategy.build();
      delete productStrategyPayloadParameters.storeFilters;
      delete storeStrategyPayloadParameters.productFilters;
      var twoDimensionStrategy = _objectSpread(_objectSpread({}, productStrategyPayloadParameters), storeStrategyPayloadParameters);
      return twoDimensionStrategy;
    }
  }]);
}();


/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PayloadParametersBuilder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_sales_analysis_models_PayloadParameters__ = __webpack_require__(862);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var Fact = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(function Fact(factName) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'table';
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Fact);
  this.type = type;
  this.name = factName;
});
var PayloadParametersBuilder = /*#__PURE__*/function () {
  function PayloadParametersBuilder(_ref) {
    var metrics = _ref.metrics,
      factTableName = _ref.factTableName,
      filters = _ref.filters,
      _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? 0 : _ref$limit,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset;
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, PayloadParametersBuilder);
    this.limit = limit;
    this.offset = offset;
    this.fact = new Fact(factTableName);
    this.metrics = metrics;
    this.storeFilters = _objectSpread({}, filters.selectedStoreFilters);
    this.productFilters = _objectSpread({}, filters.selectedProductFilters);
  }
  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(PayloadParametersBuilder, [{
    key: "_buildSorting",
    value: function _buildSorting() {
      var defaultSortField = this.metrics.normal[0];
      this.sort = {
        field: defaultSortField,
        dir: 'DESC'
      };
    }
  }, {
    key: "_buildFilters",
    value: function _buildFilters(payloadParametersByStrategy) {
      var storeFilterField = Object.keys(payloadParametersByStrategy.storeFilters)[0];
      var productFilterField = Object.keys(payloadParametersByStrategy.productFilters)[0];
      this.storeFilters[storeFilterField] = payloadParametersByStrategy.storeFilters[storeFilterField];
      this.productFilters[productFilterField] = payloadParametersByStrategy.productFilters[productFilterField];
    }
  }, {
    key: "build",
    value: function build(strategyBuilder) {
      if (!('metrics' in this)) {
        throw new Error('Faltan las metricas');
      }
      this._buildSorting();
      var payloadParametersByStrategy = strategyBuilder.build();
      this._buildFilters(payloadParametersByStrategy);
      var payloadParameters = new __WEBPACK_IMPORTED_MODULE_3__app_sales_analysis_models_PayloadParameters__["a" /* default */](_objectSpread(_objectSpread({}, payloadParametersByStrategy), this));
      return payloadParameters;
    }
  }]);
}();


/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PayloadParameters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);


var PayloadParameters = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function PayloadParameters(_ref) {
  var storeFilters = _ref.storeFilters,
    productFilters = _ref.productFilters,
    productDimensions = _ref.productDimensions,
    storeDimensions = _ref.storeDimensions,
    metrics = _ref.metrics,
    fact = _ref.fact,
    sort = _ref.sort;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, PayloadParameters);
  this.store_filters = storeFilters;
  this.product_filters = productFilters;
  this.store_dimensions = storeDimensions;
  this.product_dimensions = productDimensions;
  this.metrics = metrics;
  this.fact = fact;
  this.sort = sort;
});


/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PivotParameters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);


var PivotParameters = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function PivotParameters(indexDims, column) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, PivotParameters);
  this.index_dim = [indexDims];
  this.column = column;
});


/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BreadCrumbItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);


// import OneDimensionStrategy from './OneDimensionStrategy'
var BreadCrumbItem = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function BreadCrumbItem(_ref) {
  var dimension = _ref.dimension,
    filter = _ref.filter,
    text = _ref.text;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, BreadCrumbItem);
  // if (oneDimensionStrategy.constructor !== OneDimensionStrategy) {
  //   throw new Error('oneDimensionParameters parametro no es una instancia de OneDimensionStrategy class')
  // }
  this.dimension = dimension;
  this.text = text;
  // this.oneDimensionStrategy = oneDimensionStrategy
  this.filter = filter;
});


/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AgGrid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_sales_analysis_models_SalesAnalysisColumnDefinitionFactory__ = __webpack_require__(269);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable camelcase */

var AgGrid = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(function AgGrid(_ref) {
  var col_definition = _ref.col_definition,
    data = _ref.data,
    aggregation = _ref.aggregation;
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, AgGrid);
  this.columnDefs = col_definition.map(function (columnDef) {
    return __WEBPACK_IMPORTED_MODULE_3__app_sales_analysis_models_SalesAnalysisColumnDefinitionFactory__["a" /* default */].create(columnDef);
  });
  this.data = data;
  this.aggregation = [_objectSpread({}, aggregation)];
});


/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getRetailList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return downloadStockBreakToXlsx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getBreakProductsByRetailId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getStockBreakGrid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getRetailStoreList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_client_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_stock_break_models_Grid__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_shared_Services_js__ = __webpack_require__(117);






var getRetailList = /*#__PURE__*/function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
    var stockBreakRetailSelector, retailList;
    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          stockBreakRetailSelector = {
            parameters: {
              store_dimensions: ['retail_name', 'retail_id'],
              metrics: {
                normal: ['stock_break_status'],
                "var": []
              },
              fact: {
                type: 'table',
                name: 'dw_stock_break'
              },
              sort: {
                field: 'stock_break_status',
                dir: 'DESC'
              },
              limit: 0,
              offset: 0
            }
          };
          _context.next = 1;
          return Object(__WEBPACK_IMPORTED_MODULE_5__app_shared_Services_js__["e" /* salesTwoRanges */])(stockBreakRetailSelector);
        case 1:
          retailList = _context.sent;
          return _context.abrupt("return", retailList.data);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getRetailList() {
    return _ref.apply(this, arguments);
  };
}();
var downloadStockBreakToXlsx = /*#__PURE__*/function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
    var stockBreakExcelParameters;
    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          stockBreakExcelParameters = {
            parameters: {
              store_filters: {
                retail_id: []
              },
              product_dimensions: ['vendor_product_code', 'vendor_product_description', 'retail_product_description', 'retail_product_code'],
              store_dimensions: ['retail_name', 'retail_store_code', 'retail_store_name'],
              metrics: {
                normal: ['week_1', 'week_2', 'week_3', 'week_4', 'week_avg', 'woi', 'transfer_quantity', 'stock_quantity', 'stock_break_status', 'first_suggested', 'final_suggested', 'retail_suggested_condition'],
                "var": []
              },
              fact: {
                type: 'table',
                name: 'dw_stock_break'
              },
              custom_response: 3,
              limit: 0,
              offset: 0
            }
          };
          _context2.next = 1;
          return Object(__WEBPACK_IMPORTED_MODULE_5__app_shared_Services_js__["b" /* downloadGridToXlsx */])(stockBreakExcelParameters);
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function downloadStockBreakToXlsx() {
    return _ref2.apply(this, arguments);
  };
}();
var getBreakProductsByRetailId = /*#__PURE__*/function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3(retailId, clientDimensionFilterKey) {
    var stockBreakDimensionFilterParameters, dimensionFilter;
    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          stockBreakDimensionFilterParameters = {
            store_filters: {
              retail_id: [retailId]
            },
            product_dimensions: [clientDimensionFilterKey],
            store_dimensions: [],
            metrics: {
              normal: ['stock_break_status'],
              "var": []
            },
            fact: {
              type: 'table',
              name: 'dw_stock_break'
            },
            sort: {
              field: 'stock_break_status',
              dir: 'desc'
            },
            limit: 0,
            offset: 0
          };
          _context3.next = 1;
          return __WEBPACK_IMPORTED_MODULE_3__api_client_js__["c" /* ClientLambdaApi */].post('/dimension-filter/', {
            parameters: stockBreakDimensionFilterParameters
          });
        case 1:
          dimensionFilter = _context3.sent;
          return _context3.abrupt("return", dimensionFilter.data);
        case 2:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getBreakProductsByRetailId(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();
var getStockBreakGrid = /*#__PURE__*/function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee4(retailId, productFilterFieldKey, productFilterFieldValue, storeIds) {
    var stockBreakGridParameters, stockBreakGrid;
    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          stockBreakGridParameters = {
            parameters: {
              store_filters: {
                retail_id: [retailId],
                store_id: storeIds
              },
              product_dimensions: ['vendor_product'],
              product_filters: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, productFilterFieldKey, [productFilterFieldValue]),
              store_dimensions: ['retail_store_name'],
              metrics: {
                normal: ['stock_break_status'],
                "var": []
              },
              fact: {
                type: 'table',
                name: 'dw_stock_break'
              },
              limit: 0,
              offset: 0
            },
            pivotParameters: {
              index_dim: ['vendor_product'],
              column: 'retail_store_name'
            }
          };
          _context4.next = 1;
          return Object(__WEBPACK_IMPORTED_MODULE_5__app_shared_Services_js__["d" /* pivotSales */])(stockBreakGridParameters);
        case 1:
          stockBreakGrid = _context4.sent;
          return _context4.abrupt("return", new __WEBPACK_IMPORTED_MODULE_4__app_stock_break_models_Grid__["a" /* default */](stockBreakGrid));
        case 2:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getStockBreakGrid(_x3, _x4, _x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();
var getRetailStoreList = /*#__PURE__*/function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee5(retailId) {
    var retailStorelistParameters, retailStoreList;
    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          retailStorelistParameters = {
            parameters: {
              store_dimensions: ['store_id', 'retail_name_store_name'],
              metrics: {
                normal: ['stock_break_status'],
                "var": []
              },
              fact: {
                type: 'table',
                name: 'dw_stock_break'
              },
              sort: {
                field: 'stock_break_status',
                dir: 'DESC'
              },
              limit: 0,
              offset: 0,
              store_filters: {
                retail_id: [retailId]
              }
            }
          };
          _context5.next = 1;
          return Object(__WEBPACK_IMPORTED_MODULE_5__app_shared_Services_js__["e" /* salesTwoRanges */])(retailStorelistParameters);
        case 1:
          retailStoreList = _context5.sent;
          return _context5.abrupt("return", retailStoreList.data);
        case 2:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function getRetailStoreList(_x7) {
    return _ref5.apply(this, arguments);
  };
}();


/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);


/* eslint-disable camelcase */
var Grid = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function Grid(_ref) {
  var aggregation = _ref.aggregation,
    column_definition = _ref.column_definition,
    data = _ref.data;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Grid);
  this.aggregation = aggregation;
  this.data = data;
  this.columnDefs = column_definition.map(function (colDef) {
    colDef.width = colDef.isColumn ? 38 : 220;
    colDef.pinned = colDef.isColumn ? null : 'left';
    colDef.sortable = false;
    colDef.cellStyle = function (params) {
      return params.value > 0 ? {
        color: 'white',
        backgroundColor: 'red'
      } : {
        color: 'black',
        backgroundColor: 'white'
      };
    };
    return colDef;
  });
});
/* harmony default export */ __webpack_exports__["a"] = (Grid);

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AgGrid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_models_ColumnDefinitionFactory__ = __webpack_require__(869);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable camelcase */

var AgGrid = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(function AgGrid(_ref) {
  var col_definition = _ref.col_definition,
    data = _ref.data,
    aggregation = _ref.aggregation;
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, AgGrid);
  this.columnDefs = col_definition.map(function (columnDef) {
    return __WEBPACK_IMPORTED_MODULE_3__app_shared_models_ColumnDefinitionFactory__["a" /* default */].create(columnDef);
  });
  this.data = data;
  this.aggregation = [_objectSpread(_objectSpread({}, aggregation), {}, {
    pivot: 'Total'
  })];
});


/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColumnDefinitionFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ColumnDefinitionFactory = /*#__PURE__*/function () {
  function ColumnDefinitionFactory() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ColumnDefinitionFactory);
  }
  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ColumnDefinitionFactory, null, [{
    key: "create",
    value: function create(columnDef) {
      if (columnDef.formatType) {
        return _objectSpread(_objectSpread({}, columnDef), {}, {
          cellRendererFramework: 'AgGridCellFormatter'
        });
      } else if (columnDef.children) {
        return _objectSpread(_objectSpread({}, columnDef), {}, {
          children: columnDef.children.map(function (child) {
            return ColumnDefinitionFactory.create(child);
          })
        });
      } else {
        return columnDef;
      }
    }
  }]);
}();


/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Types */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_weekly_sales_store_Index__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_Filters__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_BreadCrumb__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_weekly_sales_Services__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_shared_utils_NamespaceHelper__ = __webpack_require__(31);


var _actions;

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// import { NAMESPACE as ParentNamespace } from '@/app/weekly_sales/store/Index'


// import { Types as TypesDateGranularity } from '@/app/sales_analysis/store/DateGranularity'




var BREADCRUMB_MODULE_NAME = 'breadCrumb';
var NAMESPACE = 'weeklySales/weeklyComparative/';
var NAMESPACE_BREADCRUMB = NAMESPACE + BREADCRUMB_MODULE_NAME + '/';
var _types = {
  getters: {
    PIVOT_DIMENSIONS: 'GETTER_PIVOT_DIMENSIONS',
    DIMENSION_TO_FILTER: 'GETTER_DIMENSION_TO_FILTER',
    DEFAULT_DIMENSION: 'GETTER_DEFAULT_DIMENSION',
    PIVOTED_FILTERS: 'GETTER_PIVOTED_FILTERS',
    PIVOTED_FILTER_DIMENSION_IDS: 'GETTER_PIVOTED_FILTER_DIMENSION_IDS',
    HAS_SELECTED_FILTERS: 'GETTER_HAS_SELECTED_FILTERS',
    BASE_DIMENSION: 'BASE_DIMENSION',
    LAST_BREADCRUMB_ITEM: 'LAST_BREADCRUMB_ITEM',
    LAST_THREE_YEARS: 'LAST_THREE_YEARS',
    DATE_FILTERS: 'DATE_FILTERS'
  },
  actions: {
    INIT: 'INIT',
    INIT_BREADCRUMB: 'INIT_BREADCRUMB',
    INIT_FILTERS: 'INIT_FILTERS',
    INIT_DIMENSION: 'INIT_DIMENSION',
    INIT_YEAR: 'INIT_YEAR',
    INIT_WEEKLY_COMPARATIVE_GRID: 'INIT_WEEKLY_COMPARATIVE_GRID',
    FETCH_WEEKLY_COMPARATIVE_GRID: 'FETCH_WEEKLY_COMPARATIVE_GRID',
    PUSH_BREADCRUMB_ITEM: 'PUSH_BREADCRUMB_ITEM',
    POP_UNTIL_BREADCRUMB: 'POP_UNTIL_BREADCRUMB',
    CHANGE_PIVOT: 'CHANGE_PIVOT',
    CHANGE_BASE_DIMENSION: 'CHANGE_BASE_DIMENSION',
    APPLY_FILTERS: 'APPLY_FILTERS',
    DOWNLOAD_EXCEL: 'DOWNLOAD_EXCEL',
    RESET: 'RESET',
    CHANGE_YEAR: 'CHANGE_YEAR',
    CHANGE_METRIC: 'CHANGE_METRIC'
  },
  mutations: {
    SET_YEAR: 'SET_YEAR',
    SET_GRID: 'SET_GRID'
  }
};
var Types = Object(__WEBPACK_IMPORTED_MODULE_7__app_shared_utils_NamespaceHelper__["a" /* addNamespace */])(NAMESPACE, _types);
var WeeklyComparative = {
  namespaced: true,
  state: {
    grid: null,
    metrics: null,
    year: null
  },
  getters: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.getters.DEFAULT_DIMENSION, function (state, getters, rootState, rootGetters) {
    var dimensions = rootState.weeklySales.dimensions;
    return dimensions.find(function (dimension) {
      return dimension.selected;
    }) || dimensions[0];
    // return rootState.weeklySales.dimensions[0]
  }), _types.getters.PIVOT_DIMENSIONS, function (state, getters, rootState, rootGetters) {
    var dimensionIdsInBreadCrumb = rootGetters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_BreadCrumb__["a" /* Types */].getters.DIMENSION_IDS_IN_BREADCRUMB];
    var dimensionsToPivot = function dimensionsToPivot(dimension) {
      return !dimensionIdsInBreadCrumb.includes(dimension.id);
    };
    return rootState.weeklySales.dimensions.filter(dimensionsToPivot);
  }), _types.getters.PIVOTED_FILTERS, function (state) {
    return state.breadCrumb.items.filter(function (breadcrumbItem) {
      return breadcrumbItem.filter;
    }).map(function (breadcrumbItem) {
      return breadcrumbItem.filter;
    });
  }), _types.getters.PIVOTED_FILTER_DIMENSION_IDS, function (state, getters) {
    return getters[_types.getters.PIVOTED_FILTERS].map(function (pivotedFilter) {
      return pivotedFilter.keyField;
    });
  }), _types.getters.HAS_SELECTED_FILTERS, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_Filters__["a" /* Types */].getters.HAS_SELECTED_FILTERS];
  }), _types.getters.DIMENSION_TO_FILTER, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_BreadCrumb__["a" /* Types */].getters.DIMENSION_TO_FILTER];
  }), _types.getters.BASE_DIMENSION, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_BreadCrumb__["a" /* Types */].getters.FIRST_ITEM].dimension;
  }), _types.getters.LAST_BREADCRUMB_ITEM, function (state, getters, rootState, rootGetters) {
    return rootGetters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_BreadCrumb__["a" /* Types */].getters.LAST_ITEM];
  }), _types.getters.LAST_THREE_YEARS, function (_) {
    var currentYear = new Date().getFullYear();
    return [currentYear, currentYear - 1, currentYear - 2];
  }), _types.getters.DATE_FILTERS, function (state, getters, rootState, rootGetters) {
    return function (year) {
      var currentYear = new Date().getFullYear();
      var yearWeeklyTarget = null;
      if (year === currentYear) {
        yearWeeklyTarget = rootGetters.thisYearWeekly;
      } else if (year === currentYear - 1) {
        yearWeeklyTarget = rootGetters.lastYearWeekly;
      } else if (year === currentYear - 2) {
        yearWeeklyTarget = rootGetters.lastLastYearWeekly;
      }
      var _yearWeeklyTarget = yearWeeklyTarget,
        startDate = _yearWeeklyTarget.startDate,
        endDate = _yearWeeklyTarget.endDate;
      return {
        date: {
          operator: 'BT',
          value: [startDate, endDate]
        }
      };
    };
  }),
  actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_actions, _types.actions.INIT, function (_ref) {
    var commit = _ref.commit,
      dispatch = _ref.dispatch,
      getters = _ref.getters;
    dispatch(_types.actions.INIT_FILTERS);
    dispatch(_types.actions.INIT_YEAR);
    dispatch(_types.actions.INIT_BREADCRUMB, getters[_types.getters.DEFAULT_DIMENSION]);
    dispatch(_types.actions.INIT_WEEKLY_COMPARATIVE_GRID);
  }), _types.actions.INIT_FILTERS, function (_ref2) {
    var dispatch = _ref2.dispatch,
      rootState = _ref2.rootState;
    var storeFilters = _objectSpread({}, rootState.weeklySales.filters.selectedStoreFilters);
    var productFilters = _objectSpread({}, rootState.weeklySales.filters.selectedProductFilters);
    dispatch(NAMESPACE + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_Filters__["a" /* Types */].actions.SET_SELECTED_FILTERS, {
      storeFilters: storeFilters,
      productFilters: productFilters
    }, {
      root: true
    });
  }), _types.actions.INIT_YEAR, function (_ref3) {
    var commit = _ref3.commit;
    commit(_types.mutations.SET_YEAR, new Date().getFullYear());
  }), _types.actions.INIT_BREADCRUMB, function (_ref4, dimension) {
    var dispatch = _ref4.dispatch,
      commit = _ref4.commit,
      state = _ref4.state,
      getters = _ref4.getters;
    commit(NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_BreadCrumb__["a" /* Types */].mutations.RESET, null, {
      root: true
    });
    var breadCrumbItemText = dimension.value;
    commit(NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_BreadCrumb__["a" /* Types */].mutations.PUSH_ITEM, {
      dimension: dimension,
      filter: undefined,
      text: breadCrumbItemText
    }, {
      root: true
    });
  }), _types.actions.INIT_WEEKLY_COMPARATIVE_GRID, function (_ref5) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
      var state, dispatch, getters, rootState, dimension, dateFilters, normalMetric;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            state = _ref5.state, dispatch = _ref5.dispatch, getters = _ref5.getters, rootState = _ref5.rootState;
            dimension = getters[_types.getters.DEFAULT_DIMENSION];
            dateFilters = getters[_types.getters.DATE_FILTERS](state.year);
            normalMetric = rootState.weeklySales.metric;
            _context.next = 1;
            return dispatch(_types.actions.FETCH_WEEKLY_COMPARATIVE_GRID, {
              normalMetric: normalMetric,
              dimension: dimension,
              dateFilters: dateFilters
            });
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }), _types.actions.FETCH_WEEKLY_COMPARATIVE_GRID, function (_ref6, _ref7) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
      var rootState, commit, normalMetric, dimension, filter, dateFilters, filters, weeklyComparativeGrid;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            rootState = _ref6.rootState, commit = _ref6.commit;
            normalMetric = _ref7.normalMetric, dimension = _ref7.dimension, filter = _ref7.filter, dateFilters = _ref7.dateFilters;
            commit(_types.mutations.SET_GRID, null);
            filters = rootState.weeklySales.filters;
            _context2.next = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_6__app_weekly_sales_Services__["a" /* getWeeklyGrid */])({
              normalMetric: normalMetric,
              dimension: dimension,
              strategyFilter: filter,
              filters: filters,
              dateFilters: dateFilters,
              dateDimensions: ['calendarweek']
            });
          case 1:
            weeklyComparativeGrid = _context2.sent;
            commit(_types.mutations.SET_GRID, weeklyComparativeGrid);
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }), _types.actions.PUSH_BREADCRUMB_ITEM, function (_ref8, _ref9) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3() {
      var commit, dispatch, rootState, dimension, filter, breadCrumbItemText, dateFilter, normalMetric;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref8.commit, dispatch = _ref8.dispatch, rootState = _ref8.rootState;
            dimension = _ref9.dimension, filter = _ref9.filter, breadCrumbItemText = _ref9.breadCrumbItemText, dateFilter = _ref9.dateFilter;
            normalMetric = rootState.weeklySales.metric;
            _context3.next = 1;
            return dispatch(_types.actions.FETCH_WEEKLY_COMPARATIVE_GRID, {
              normalMetric: normalMetric,
              dimension: dimension,
              filter: filter,
              dateFilter: dateFilter
            });
          case 1:
            commit(NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_BreadCrumb__["a" /* Types */].mutations.PUSH_ITEM, {
              dimension: dimension,
              filter: filter,
              text: breadCrumbItemText
            }, {
              root: true
            });
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }), _types.actions.CHANGE_PIVOT, function (_ref0, _ref1) {
    var getters = _ref0.getters,
      dispatch = _ref0.dispatch,
      rootGetters = _ref0.rootGetters;
    var pivotedDimensionId = _ref1.pivotedDimensionId,
      pivotedDimensionCellValue = _ref1.pivotedDimensionCellValue,
      filter = _ref1.filter;
    var dimension = rootGetters[__WEBPACK_IMPORTED_MODULE_3__app_weekly_sales_store_Index__["b" /* Types */].getters.DIMENSION_BY_ID](pivotedDimensionId);
    var breadCrumbItemText = "".concat(dimension.value, " en ").concat(pivotedDimensionCellValue);
    dispatch(_types.actions.PUSH_BREADCRUMB_ITEM, {
      dimension: dimension,
      filter: filter,
      breadCrumbItemText: breadCrumbItemText
    });
  }), _types.actions.POP_UNTIL_BREADCRUMB, function (_ref10, breadCrumbItem) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee4() {
      var state, commit, dispatch, rootGetters, lastBreadCrumbItem;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            state = _ref10.state, commit = _ref10.commit, dispatch = _ref10.dispatch, rootGetters = _ref10.rootGetters;
            if (!(rootGetters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_BreadCrumb__["a" /* Types */].getters.LAST_ITEM] === breadCrumbItem)) {
              _context4.next = 1;
              break;
            }
            return _context4.abrupt("return");
          case 1:
            while (rootGetters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_BreadCrumb__["a" /* Types */].getters.LAST_ITEM] !== breadCrumbItem) {
              lastBreadCrumbItem = rootGetters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_BreadCrumb__["a" /* Types */].getters.LAST_ITEM];
              commit(NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_BreadCrumb__["a" /* Types */].mutations.REMOVE_ITEM, lastBreadCrumbItem, {
                root: true
              });
              dispatch(NAMESPACE + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_Filters__["a" /* Types */].actions.REMOVE_SELECTED_FILTER_IN_CASCADE, lastBreadCrumbItem.filter, {
                root: true
              });
            }
            _context4.next = 2;
            return dispatch(_types.actions.FETCH_WEEKLY_COMPARATIVE_GRID, breadCrumbItem);
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  }), _types.actions.CHANGE_BASE_DIMENSION, function (_ref11, dimensionId) {
    var state = _ref11.state,
      dispatch = _ref11.dispatch,
      rootGetters = _ref11.rootGetters,
      getters = _ref11.getters,
      rootState = _ref11.rootState;
    var dimension = rootGetters[__WEBPACK_IMPORTED_MODULE_3__app_weekly_sales_store_Index__["b" /* Types */].getters.DIMENSION_BY_ID](dimensionId);
    var pivotedFilters = getters[_types.getters.PIVOTED_FILTERS];
    var normalMetric = rootState.weeklySales.metric;
    var dateFilters = getters[_types.getters.DATE_FILTERS](state.year);
    pivotedFilters.forEach(function (pivotedFilter) {
      dispatch(NAMESPACE + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_Filters__["a" /* Types */].actions.REMOVE_SELECTED_FILTER_IN_CASCADE, pivotedFilter, {
        root: true
      });
    });
    dispatch(_types.actions.INIT_BREADCRUMB, dimension);
    dispatch(_types.actions.FETCH_WEEKLY_COMPARATIVE_GRID, {
      normalMetric: normalMetric,
      dimension: dimension,
      dateFilters: dateFilters
    });
  }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_actions, _types.actions.APPLY_FILTERS, function (_ref12) {
    var state = _ref12.state,
      dispatch = _ref12.dispatch,
      getters = _ref12.getters,
      rootGetters = _ref12.rootGetters,
      rootState = _ref12.rootState;
    var _rootGetters = rootGetters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_BreadCrumb__["a" /* Types */].getters.LAST_ITEM],
      dimension = _rootGetters.dimension,
      filter = _rootGetters.filter;
    var normalMetric = rootState.weeklySales.metric;
    var dateFilters = getters[_types.getters.DATE_FILTERS](state.year);
    dispatch(_types.actions.FETCH_WEEKLY_COMPARATIVE_GRID, {
      normalMetric: normalMetric,
      dimension: dimension,
      filter: filter,
      dateFilters: dateFilters
    });
  }), _types.actions.RESET, function (_ref13) {
    var commit = _ref13.commit;
    commit(NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_BreadCrumb__["a" /* Types */].mutations.RESET, null, {
      root: true
    });
    commit(_types.mutations.SET_GRID, null);
  }), _types.actions.CHANGE_YEAR, function (_ref14, year) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee5() {
      var commit, dispatch, getters, rootGetters, rootState, _rootGetters2, dimension, filter, dateFilters, normalMetric;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            commit = _ref14.commit, dispatch = _ref14.dispatch, getters = _ref14.getters, rootGetters = _ref14.rootGetters, rootState = _ref14.rootState;
            _rootGetters2 = rootGetters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_BreadCrumb__["a" /* Types */].getters.LAST_ITEM], dimension = _rootGetters2.dimension, filter = _rootGetters2.filter;
            dateFilters = getters[_types.getters.DATE_FILTERS](year);
            normalMetric = rootState.weeklySales.metric;
            _context5.next = 1;
            return dispatch(_types.actions.FETCH_WEEKLY_COMPARATIVE_GRID, {
              normalMetric: normalMetric,
              dimension: dimension,
              filter: filter,
              dateFilters: dateFilters
            });
          case 1:
            commit(_types.mutations.SET_YEAR, year);
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  }), _types.actions.CHANGE_METRIC, function (_ref15, normalMetric) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee6() {
      var state, commit, dispatch, getters, rootGetters, _rootGetters3, dimension, filter, dateFilters;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            state = _ref15.state, commit = _ref15.commit, dispatch = _ref15.dispatch, getters = _ref15.getters, rootGetters = _ref15.rootGetters;
            _rootGetters3 = rootGetters[NAMESPACE_BREADCRUMB + __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_BreadCrumb__["a" /* Types */].getters.LAST_ITEM], dimension = _rootGetters3.dimension, filter = _rootGetters3.filter;
            dateFilters = getters[_types.getters.DATE_FILTERS](state.year);
            _context6.next = 1;
            return dispatch(_types.actions.FETCH_WEEKLY_COMPARATIVE_GRID, {
              normalMetric: normalMetric,
              dimension: dimension,
              filter: filter,
              dateFilters: dateFilters
            });
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  })),
  mutations: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.mutations.SET_GRID, function (state, longGrid) {
    state.grid = longGrid;
  }), _types.mutations.SET_YEAR, function (state, year) {
    state.year = year;
  }),
  modules: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({
    filters: __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_Filters__["b" /* default */]
  }, BREADCRUMB_MODULE_NAME, __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_BreadCrumb__["b" /* default */])
};
/* harmony default export */ __webpack_exports__["a"] = (WeeklyComparative);

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BreadCrumbItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);


var BreadCrumbItem = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function BreadCrumbItem(_ref) {
  var dimension = _ref.dimension,
    filter = _ref.filter,
    text = _ref.text;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, BreadCrumbItem);
  this.dimension = dimension;
  this.text = text;
  this.filter = filter;
});


/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getWeeklyGrid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shared_Services_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_models_OneDimensionStrategy__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_models_PayloadParametersBuilder__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_WeeklyComparativeAgGrid_js__ = __webpack_require__(874);






var getWeeklyGrid = /*#__PURE__*/function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee(_ref) {
    var normalMetric, dimension, strategyFilter, filters, dateFilters, dateDimensions, weeklyGridPayload, weeklySalesComparativeGrid;
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          normalMetric = _ref.normalMetric, dimension = _ref.dimension, strategyFilter = _ref.strategyFilter, filters = _ref.filters, dateFilters = _ref.dateFilters, dateDimensions = _ref.dateDimensions;
          weeklyGridPayload = buildWeeklyGridParameters({
            normalMetric: normalMetric,
            dimension: dimension,
            strategyFilter: strategyFilter,
            filters: filters,
            dateFilters: dateFilters,
            dateDimensions: dateDimensions
          });
          _context.next = 1;
          return Object(__WEBPACK_IMPORTED_MODULE_2__app_shared_Services_js__["e" /* salesTwoRanges */])(weeklyGridPayload);
        case 1:
          weeklySalesComparativeGrid = _context.sent;
          return _context.abrupt("return", new __WEBPACK_IMPORTED_MODULE_5__models_WeeklyComparativeAgGrid_js__["a" /* default */](weeklySalesComparativeGrid, normalMetric));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getWeeklyGrid(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var buildWeeklyGridParameters = function buildWeeklyGridParameters(_ref3) {
  var normalMetric = _ref3.normalMetric,
    dimension = _ref3.dimension,
    strategyFilter = _ref3.strategyFilter,
    filters = _ref3.filters,
    dateFilters = _ref3.dateFilters,
    dateDimensions = _ref3.dateDimensions;
  var oneDimensionStrategy = new __WEBPACK_IMPORTED_MODULE_3__app_shared_models_OneDimensionStrategy__["a" /* default */](dimension, strategyFilter);
  var metrics = {
    normal: [normalMetric]
  };
  var payloadParametersBuilder = new __WEBPACK_IMPORTED_MODULE_4__app_shared_models_PayloadParametersBuilder__["a" /* default */]({
    metrics: metrics,
    factTableName: 'dw_weekly_sales',
    filters: filters,
    pivot: 'calendarweek',
    dateFilters: dateFilters,
    dateDimensions: dateDimensions
  });
  var parameters = payloadParametersBuilder.build(oneDimensionStrategy);
  // TODO: Find the way how to fix this, maybe it will need some backend as the long-grid that bring the retail_id as dimension
  // when it sends the retail_name
  if (dimension.type === 'store') {
    parameters.store_dimensions.push(dimension.key);
  } else {
    parameters.product_dimensions.push(dimension.key);
  }
  return {
    parameters: parameters
  };
};


/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PayloadParameters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);


var PayloadParameters = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function PayloadParameters(_ref) {
  var storeFilters = _ref.storeFilters,
    productFilters = _ref.productFilters,
    productDimensions = _ref.productDimensions,
    storeDimensions = _ref.storeDimensions,
    metrics = _ref.metrics,
    fact = _ref.fact,
    sort = _ref.sort,
    pivot = _ref.pivot,
    dateFilters = _ref.dateFilters,
    dateDimensions = _ref.dateDimensions;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, PayloadParameters);
  this.store_filters = storeFilters;
  this.product_filters = productFilters;
  this.store_dimensions = storeDimensions;
  this.product_dimensions = productDimensions;
  this.metrics = metrics;
  this.fact = fact;
  this.sort = sort;
  this.pivot = pivot;
  this.date_filters = dateFilters;
  this.date_dimensions = dateDimensions;
});


/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WeeklyComparativeAgGrid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable camelcase */
// import SalesAnalysisColumnDefinitionFactory from '@/app/sales_analysis/models/SalesAnalysisColumnDefinitionFactory'
var WeeklyComparativeAgGrid = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(function WeeklyComparativeAgGrid(weeklySalesComparativeGrid, normalMetric) {
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, WeeklyComparativeAgGrid);
  this.columnDefs = Object.keys(weeklySalesComparativeGrid.aggregation).map(function (columnName) {
    return {
      field: columnName,
      cellRendererFramework: 'AgGridCellFormatter',
      cellRendererParams: {
        formatType: normalMetric === 'quantity_sold' ? 'UNITS' : 'PESOS',
        infoFormatType: normalMetric === 'quantity_sold' ? 'UNITS_EXTENDED' : 'PESOS_EXTENDED'
      }
    };
  });
  this.data = weeklySalesComparativeGrid.data;
  this.aggregation = [_objectSpread({}, weeklySalesComparativeGrid.aggregation)];
});


/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Types */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_utils_NamespaceHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shared_store_modules_LongGrid__ = __webpack_require__(224);



var NAMESPACE = 'weeklySales/weeklyDetail/';
var metricsNormalCurrentYear = ['quantity_sold_2', 'quantity_sold_1', 'real_sales_amount_2', 'real_sales_amount_1', 'real_sales_cost_2', 'real_sales_cost_1'];
var buildWeeklyDetailDefaultParameters = function buildWeeklyDetailDefaultParameters(weekNumber) {
  return {
    calculatedField: ['COALESCE((SUM(real_sales_amount_1) - SUM(real_sales_cost_1)) / NULLIF(SUM(real_sales_amount_1),0), 0) as mg_1', 'COALESCE((SUM(real_sales_amount_2) - SUM(real_sales_cost_2)) / NULLIF(SUM(real_sales_amount_2),0), 0) as mg_2'],
    factTableName: 'dw_weekly_sales_comparative',
    metrics: {
      normal: metricsNormalCurrentYear,
      "var": ['quantity_sold', 'real_sales_amount', 'real_sales_cost']
    },
    dateFilters: {
      calendarweekstr: {
        operator: 'BT',
        value: [weekNumber, weekNumber]
      }
    }
  };
};
var _types = {
  getters: {
    BASE_DIMENSION: 'BASE_DIMENSION',
    PIVOT_DIMENSIONS: 'PIVOT_DIMENSIONS',
    PIVOTED_FILTER_DIMENSION_IDS: 'PIVOTED_FILTER_DIMENSION_IDS'
  },
  actions: {
    INIT: 'INIT',
    APPLY_FILTERS: 'APPLY_FILTERS',
    CHANGE_BASE_DIMENSION: 'CHANGE_BASE_DIMENSION',
    CHANGE_PIVOT: 'CHANGE_PIVOT',
    POP_UNTIL_BREADCRUMB: 'POP_UNTIL_BREADCRUMB',
    DOWNLOAD_GRID_TO_EXCEL: 'DOWNLOAD_GRID_TO_EXCEL',
    RESET: 'RESET'
  }
};
var Types = Object(__WEBPACK_IMPORTED_MODULE_1__app_shared_utils_NamespaceHelper__["a" /* addNamespace */])(NAMESPACE, _types);
var WeeklyDetail = {
  namespaced: true,
  state: {},
  getters: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, _types.getters.BASE_DIMENSION, function (state, getters) {
    return getters[__WEBPACK_IMPORTED_MODULE_2__app_shared_store_modules_LongGrid__["a" /* Types */].getters.BASE_DIMENSION];
  }), _types.getters.PIVOT_DIMENSIONS, function (state, getters) {
    return getters[__WEBPACK_IMPORTED_MODULE_2__app_shared_store_modules_LongGrid__["a" /* Types */].getters.PIVOT_DIMENSIONS];
  }), _types.getters.PIVOTED_FILTER_DIMENSION_IDS, function (state, getters) {
    return getters[__WEBPACK_IMPORTED_MODULE_2__app_shared_store_modules_LongGrid__["a" /* Types */].getters.PIVOTED_FILTER_DIMENSION_IDS];
  }),
  actions: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, _types.actions.INIT, function (_ref, _ref2) {
    var dispatch = _ref.dispatch,
      rootState = _ref.rootState;
    var week = _ref2.week,
      year = _ref2.year;
    var _rootState$weeklySale = rootState.weeklySales,
      dimensions = _rootState$weeklySale.dimensions,
      filters = _rootState$weeklySale.filters;
    var defaultDimension = dimensions[0];
    var weekDetailDefaultParameters = buildWeeklyDetailDefaultParameters(week, year);
    dispatch(__WEBPACK_IMPORTED_MODULE_2__app_shared_store_modules_LongGrid__["a" /* Types */].actions.INIT, {
      dimensions: dimensions,
      defaultDimension: defaultDimension,
      defaultParameters: weekDetailDefaultParameters,
      filters: filters
    });
  }), _types.actions.APPLY_FILTERS, function (_ref3, _ref4) {
    var dispatch = _ref3.dispatch;
    var storeFilters = _ref4.storeFilters,
      productFilters = _ref4.productFilters;
    dispatch(__WEBPACK_IMPORTED_MODULE_2__app_shared_store_modules_LongGrid__["a" /* Types */].actions.APPLY_FILTERS, {
      storeFilters: storeFilters,
      productFilters: productFilters
    });
  }), _types.actions.CHANGE_BASE_DIMENSION, function (_ref5, dimensionId) {
    var dispatch = _ref5.dispatch;
    dispatch(__WEBPACK_IMPORTED_MODULE_2__app_shared_store_modules_LongGrid__["a" /* Types */].actions.CHANGE_BASE_DIMENSION, dimensionId);
  }), _types.actions.CHANGE_PIVOT, function (_ref6, _ref7) {
    var dispatch = _ref6.dispatch,
      rootState = _ref6.rootState;
    var params = _ref7.params,
      option = _ref7.option;
    dispatch(__WEBPACK_IMPORTED_MODULE_2__app_shared_store_modules_LongGrid__["a" /* Types */].actions.CHANGE_PIVOT, {
      params: params,
      option: option
    });
  }), _types.actions.POP_UNTIL_BREADCRUMB, function (_ref8, breadCrumbItem) {
    var dispatch = _ref8.dispatch;
    dispatch(__WEBPACK_IMPORTED_MODULE_2__app_shared_store_modules_LongGrid__["a" /* Types */].actions.POP_UNTIL_BREADCRUMB, breadCrumbItem);
  }), _types.actions.DOWNLOAD_GRID_TO_EXCEL, function (_ref9) {
    var dispatch = _ref9.dispatch;
    dispatch(__WEBPACK_IMPORTED_MODULE_2__app_shared_store_modules_LongGrid__["a" /* Types */].actions.DOWNLOAD_GRID_TO_EXCEL);
  }), _types.actions.RESET, function (_ref0) {
    var dispatch = _ref0.dispatch;
    dispatch(__WEBPACK_IMPORTED_MODULE_2__app_shared_store_modules_LongGrid__["a" /* Types */].actions.RESET);
  }),
  modules: {
    longGrid: __WEBPACK_IMPORTED_MODULE_2__app_shared_store_modules_LongGrid__["b" /* default */]
  }
};
/* harmony default export */ __webpack_exports__["a"] = (WeeklyDetail);

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Filter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);


var Filter = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function Filter(_ref) {
  var type = _ref.type,
    key = _ref.key,
    value = _ref.value;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Filter);
  this.value = value;
  this.keyField = key;
  this.keyFieldType = type;
});


/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMESPACE; });
/* unused harmony export Types */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_utils_NamespaceHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_Filters__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_daily_sales_store_DailySalesDetail__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_shared_models_Dimension__ = __webpack_require__(225);







var NAMESPACE = 'dailySales';
var INTERNAL_NAMESPACE = NAMESPACE + '/';
var _types = {
  getters: {
    PIVOT_DIMENSIONS: 'GETTER_PIVOT_DIMENSIONS'
  },
  actions: {
    INIT: 'INIT',
    APPLY_FILTERS: 'APPLY_FILTERS',
    RESET: 'RESET'
  },
  mutations: {
    SET_DIMENSIONS: 'SET_DIMENSIONS',
    SET_METRIC: 'SET_METRIC'
  }
};
var Types = Object(__WEBPACK_IMPORTED_MODULE_3__app_shared_utils_NamespaceHelper__["a" /* addNamespace */])(INTERNAL_NAMESPACE, _types);
var Index = {
  namespaced: true,
  state: {
    dimensions: null,
    metric: null
  },
  getters: {},
  actions: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, _types.actions.INIT, function (_ref, _ref2) {
    var commit = _ref.commit;
    var dataDimensions = _ref2.dataDimensions,
      metric = _ref2.metric;
    commit(_types.mutations.SET_DIMENSIONS, dataDimensions.map(function (dimension) {
      return new __WEBPACK_IMPORTED_MODULE_6__app_shared_models_Dimension__["a" /* default */](dimension);
    }));
    commit(_types.mutations.SET_METRIC, metric);
  }), _types.actions.APPLY_FILTERS, function (_ref3, _ref4) {
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
      var dispatch, storeFilters, productFilters, asyncProductPool;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch = _ref3.dispatch;
            storeFilters = _ref4.storeFilters, productFilters = _ref4.productFilters, asyncProductPool = _ref4.asyncProductPool;
            _context.next = 1;
            return dispatch(INTERNAL_NAMESPACE + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_Filters__["a" /* Types */].actions.SET_SELECTED_FILTERS, {
              storeFilters: storeFilters,
              productFilters: productFilters,
              asyncProductPool: asyncProductPool
            }, {
              root: true
            });
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }), _types.actions.RESET, function (_ref5) {
    var dispatch = _ref5.dispatch;
    dispatch(INTERNAL_NAMESPACE + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_Filters__["a" /* Types */].actions.RESET_SELECTED_FILTERS, null, {
      root: true
    });
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, _types.mutations.SET_DIMENSIONS, function (state, dimensions) {
    state.dimensions = dimensions;
  }), _types.mutations.SET_METRIC, function (state, metric) {
    state.metric = metric;
  }),
  modules: {
    filters: __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_Filters__["b" /* default */],
    dailySalesDetail: __WEBPACK_IMPORTED_MODULE_5__app_daily_sales_store_DailySalesDetail__["a" /* default */]
  }
};
/* harmony default export */ __webpack_exports__["b"] = (Index);

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Types */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_utils_NamespaceHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_LongGrid__ = __webpack_require__(224);




function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var NAMESPACE = 'dailySales/dailySalesDetail/';
var builDailySalesDefaultParameters = function builDailySalesDefaultParameters(date) {
  return {
    factTableName: 'dw_daily_sales_v2',
    metrics: {
      normal: ['quantity_sold', 'real_sales_cost', 'real_sales_amount'],
      "var": []
    },
    dateFilters: {
      date: {
        operator: 'BT',
        value: [date, date]
      }
    }
  };
};
var _types = {
  getters: {
    BASE_DIMENSION: 'BASE_DIMENSION',
    PIVOT_DIMENSIONS: 'PIVOT_DIMENSIONS',
    PIVOTED_FILTER_DIMENSION_IDS: 'PIVOTED_FILTER_DIMENSION_IDS'
  },
  actions: {
    INIT: 'INIT',
    APPLY_FILTERS: 'APPLY_FILTERS',
    CHANGE_BASE_DIMENSION: 'CHANGE_BASE_DIMENSION',
    CHANGE_PIVOT: 'CHANGE_PIVOT',
    POP_UNTIL_BREADCRUMB: 'POP_UNTIL_BREADCRUMB',
    DOWNLOAD_GRID_TO_EXCEL: 'DOWNLOAD_GRID_TO_EXCEL',
    RESET: 'RESET'
  }
};
var Types = Object(__WEBPACK_IMPORTED_MODULE_4__app_shared_utils_NamespaceHelper__["a" /* addNamespace */])(NAMESPACE, _types);
var DailySalesDetail = {
  namespaced: true,
  state: {
    retailId: null
  },
  getters: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.getters.BASE_DIMENSION, function (state, getters) {
    return getters[__WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_LongGrid__["a" /* Types */].getters.BASE_DIMENSION];
  }), _types.getters.PIVOT_DIMENSIONS, function (state, getters) {
    return getters[__WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_LongGrid__["a" /* Types */].getters.PIVOT_DIMENSIONS];
  }), _types.getters.PIVOTED_FILTER_DIMENSION_IDS, function (state, getters) {
    return ['retail_id'].concat(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray___default()(getters[__WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_LongGrid__["a" /* Types */].getters.PIVOTED_FILTER_DIMENSION_IDS]));
  }),
  actions: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, _types.actions.INIT, function (_ref, _ref2) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee() {
      var dispatch, rootState, date, retailId, _rootState$dailySales, dimensions, filters, selectedStoreFilters, defaultDimension, dailySalesDefaultParameters;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch = _ref.dispatch, rootState = _ref.rootState;
            date = _ref2.date, retailId = _ref2.retailId;
            _rootState$dailySales = rootState.dailySales, dimensions = _rootState$dailySales.dimensions, filters = _rootState$dailySales.filters;
            selectedStoreFilters = _objectSpread(_objectSpread({}, filters.selectedStoreFilters), {}, {
              retail_id: [retailId]
            });
            defaultDimension = dimensions.find(function (dimension) {
              return dimension.id === 'vendor_product';
            });
            dailySalesDefaultParameters = builDailySalesDefaultParameters(date);
            _context.next = 1;
            return dispatch(__WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_LongGrid__["a" /* Types */].actions.INIT, {
              dimensions: dimensions,
              defaultDimension: defaultDimension,
              filters: {
                selectedStoreFilters: selectedStoreFilters,
                selectedProductFilters: filters.selectedProductFilters
              },
              defaultParameters: dailySalesDefaultParameters
            });
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }), _types.actions.APPLY_FILTERS, function (_ref3, _ref4) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee2() {
      var dispatch, storeFilters, productFilters;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dispatch = _ref3.dispatch;
            storeFilters = _ref4.storeFilters, productFilters = _ref4.productFilters;
            _context2.next = 1;
            return dispatch(__WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_LongGrid__["a" /* Types */].actions.APPLY_FILTERS, {
              storeFilters: storeFilters,
              productFilters: productFilters
            });
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }), _types.actions.CHANGE_BASE_DIMENSION, function (_ref5, dimensionId) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee3() {
      var dispatch;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            dispatch = _ref5.dispatch;
            _context3.next = 1;
            return dispatch(__WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_LongGrid__["a" /* Types */].actions.CHANGE_BASE_DIMENSION, dimensionId);
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }), _types.actions.CHANGE_PIVOT, function (_ref6, _ref7) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee4() {
      var dispatch, rootState, params, option;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            dispatch = _ref6.dispatch, rootState = _ref6.rootState;
            params = _ref7.params, option = _ref7.option;
            _context4.next = 1;
            return dispatch(__WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_LongGrid__["a" /* Types */].actions.CHANGE_PIVOT, {
              params: params,
              option: option
            });
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  }), _types.actions.POP_UNTIL_BREADCRUMB, function (_ref8, breadCrumbItem) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.mark(function _callee5() {
      var dispatch;
      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_regenerator___default.a.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            dispatch = _ref8.dispatch;
            _context5.next = 1;
            return dispatch(__WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_LongGrid__["a" /* Types */].actions.POP_UNTIL_BREADCRUMB, breadCrumbItem);
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  }), _types.actions.DOWNLOAD_GRID_TO_EXCEL, function (_ref9) {
    var dispatch = _ref9.dispatch;
    dispatch(__WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_LongGrid__["a" /* Types */].actions.DOWNLOAD_GRID_TO_EXCEL);
  }), _types.actions.RESET, function (_ref0) {
    var dispatch = _ref0.dispatch;
    dispatch(__WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_LongGrid__["a" /* Types */].actions.RESET);
  }),
  modules: {
    longGrid: __WEBPACK_IMPORTED_MODULE_5__app_shared_store_modules_LongGrid__["b" /* default */]
  }
};
/* harmony default export */ __webpack_exports__["a"] = (DailySalesDetail);

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMESPACE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Category__ = __webpack_require__(725);

var NAMESPACE = 'admin';
var Index = {
  namespaced: true,
  modules: {
    category: __WEBPACK_IMPORTED_MODULE_0__Category__["b" /* default */]
  }
};
/* harmony default export */ __webpack_exports__["b"] = (Index);

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientFileUpload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);


var TERMINAL_STATUSES = ['COMPLETED', 'FAILED'];
var UploadFile = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function UploadFile() {
  var raw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, UploadFile);
  this.filename = raw.filename || '';
  this.s3Key = raw.s3_key || '';
  this.presignedUrl = raw.presigned_url || '';
  this.status = raw.status || '';
});
var ClientFileUpload = /*#__PURE__*/function () {
  function ClientFileUpload() {
    var raw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ClientFileUpload);
    this.id = raw.id || raw.upload_id || '';
    this.type = raw.type || '';
    this.bucket = raw.bucket || '';
    this.s3Prefix = raw.s3_prefix || '';
    this.files = (raw.files || []).map(function (f) {
      return new UploadFile(f);
    });
    this.status = raw.status || '';
    this.progress = typeof raw.progress === 'number' && raw.progress >= 0 ? Math.min(Math.round(raw.progress), 100) : 0;
    this.result = raw.result || null;
    this.parameters = raw.parameters || {};
    this.clientId = raw.client_id || '';
    this.createdBy = raw.created_by || '';
    this.createdAt = raw.created_at || '';
    this.modifiedAt = raw.modified_at || '';
  }
  return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(ClientFileUpload, [{
    key: "isTerminal",
    get: function get() {
      return TERMINAL_STATUSES.includes(this.status);
    }
  }, {
    key: "isCompleted",
    get: function get() {
      return this.status === 'COMPLETED';
    }
  }, {
    key: "isFailed",
    get: function get() {
      return this.status === 'FAILED';
    }
  }, {
    key: "progressPercent",
    get: function get() {
      return this.progress;
    }
  }, {
    key: "progressLabel",
    get: function get() {
      if (this.isCompleted) return 'Completado';
      if (this.isFailed) return 'Error';
      if (this.progress >= 100) return 'Finalizando…';
      return "".concat(this.progress, "% completado");
    }
  }]);
}();


/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductMasterProcessStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);


/* eslint-disable camelcase */
var ProductMasterProcessStatus = /*#__PURE__*/function () {
  function ProductMasterProcessStatus(_ref) {
    var description = _ref.description,
      status = _ref.status,
      error = _ref.error,
      updated_at = _ref.updated_at;
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ProductMasterProcessStatus);
    this.description = description;
    this.status = status;
    this.statusError = error;
    this.updated_at = updated_at;
  }
  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ProductMasterProcessStatus, [{
    key: "icon",
    get: function get() {
      if (this.status === 'WORKING') return 'fa fa-spinner rotate-360';
      if (this.status === 'DONE') return 'fa fa-check-circle';
      if (this.status === 'DONE WITH WARNING') return 'fa fa-check-circle-o';
      if (this.status === 'ERROR') return 'fa fa-exclamation-circle';else return null;
    }
  }, {
    key: "error",
    get: function get() {
      try {
        return JSON.parse(this.statusError);
      } catch (e) {
        return this.statusError;
      }
    }
  }]);
}();


/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UsersManagement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_admin_models_User_js__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_admin_models_Role_js__ = __webpack_require__(581);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



/* eslint-disable camelcase */
var UsersManagement = /*#__PURE__*/function () {
  function UsersManagement(_ref) {
    var max_users = _ref.max_users,
      user_list = _ref.user_list,
      role_list = _ref.role_list;
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, UsersManagement);
    this.maxUsers = max_users || 0;
    this._users = user_list.map(function (rawUser) {
      return new __WEBPACK_IMPORTED_MODULE_3__app_admin_models_User_js__["a" /* default */](rawUser);
    });
    this._roles = role_list.map(function (rawRole) {
      return new __WEBPACK_IMPORTED_MODULE_4__app_admin_models_Role_js__["a" /* default */](rawRole);
    });
  }
  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(UsersManagement, [{
    key: "users",
    get: function get() {
      return this._users;
    }
  }, {
    key: "roles",
    get: function get() {
      return this._roles;
    }
  }, {
    key: "getUserIndexById",
    value: function getUserIndexById(userId) {
      return this._users.findIndex(function (user) {
        return user.userId === userId;
      });
    }
  }, {
    key: "getUserByIndex",
    value: function getUserByIndex(index) {
      return this._users[index];
    }
  }, {
    key: "getRoleById",
    value: function getRoleById(roleId) {
      return this._roles.find(function (role) {
        return role.id === roleId;
      });
    }
  }, {
    key: "removeUser",
    value: function removeUser(userId) {
      var userTargetIndex = this.getUserIndexById(userId);
      this._users.splice(userTargetIndex, 1);
    }
  }, {
    key: "updateUserRole",
    value: function updateUserRole(userId, roleId) {
      var userTargetIndex = this.getUserIndexById(userId);
      var targetUser = this.getUserByIndex(userTargetIndex);
      var _this$getRoleById = this.getRoleById(roleId),
        roleName = _this$getRoleById.name;
      this._users.splice(userTargetIndex, 1, _objectSpread(_objectSpread({}, targetUser), {}, {
        roleId: roleId,
        roleName: roleName
      }));
    }
  }]);
}();


/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return User; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);


/* eslint-disable camelcase */
var User = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function User(_ref) {
  var name = _ref.name,
    role_name = _ref.role_name,
    email = _ref.email,
    user_id = _ref.user_id,
    created_at = _ref.created_at,
    surname = _ref.surname,
    role_id = _ref.role_id;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, User);
  this.name = name || '';
  this.roleName = role_name || '';
  this.email = email || '';
  this.userId = user_id || '';
  this.createdAt = created_at || '';
  this.surname = surname || '';
  this.roleId = role_id || '';
});


/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadSequence; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);


/* eslint-disable camelcase */
var loadSequence = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function loadSequence(_ref) {
  var description = _ref.description,
    id = _ref.id,
    password = _ref.password,
    retail_id = _ref.retail_id,
    username = _ref.username;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, loadSequence);
  this.description = description;
  this.id = id;
  this.password = password;
  this.retailId = retail_id;
  this.username = username;
});


/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductMappingInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);


/* eslint-disable camelcase */
var ProductMappingInfo = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function ProductMappingInfo(_ref) {
  var description = _ref.description,
    not_mapped = _ref.not_mapped,
    quantity_sold = _ref.quantity_sold,
    stock_quantity = _ref.stock_quantity;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ProductMappingInfo);
  this.description = description || '';
  this.notMapped = not_mapped || 0;
  this.quantitySold = quantity_sold || 0;
  this.stockQuantity = stock_quantity || 0;
});


/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductMapUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);


/* eslint-disable camelcase */
var ProductMapUrl = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function ProductMapUrl(_ref) {
  var url = _ref.url,
    polling_interval_seconds = _ref.polling_interval_seconds;
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ProductMapUrl);
  if (!url) throw Error('Url is a required paramater and it can not be empty');
  this.pollingIntervalMiliSeconds = polling_interval_seconds * 1000 || 5000;
  this.url = url;
});


/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMESPACE; });
/* unused harmony export Types */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_shared_utils_NamespaceHelper__ = __webpack_require__(31);

var NAMESPACE = 'workspaces';
var INTERNAL_NAMESPACE = NAMESPACE + '/';
var _types = {
  getters: {},
  actions: {},
  mutations: {}
};
var Types = Object(__WEBPACK_IMPORTED_MODULE_0__app_shared_utils_NamespaceHelper__["a" /* addNamespace */])(INTERNAL_NAMESPACE, _types);
var Index = {
  namespaced: true,
  state: {
    workspace: null
  }
};
/* harmony default export */ __webpack_exports__["b"] = (Index);

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMESPACE; });
/* unused harmony export Types */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_utils_NamespaceHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_Filters__ = __webpack_require__(55);





var NAMESPACE = 'selloutDashboard';
var INTERNAL_NAMESPACE = NAMESPACE + '/';
var _types = {
  actions: {
    APPLY_FILTERS: 'APPLY_FILTERS',
    RESET: 'RESET'
  }
};
var Types = Object(__WEBPACK_IMPORTED_MODULE_3__app_shared_utils_NamespaceHelper__["a" /* addNamespace */])(INTERNAL_NAMESPACE, _types);
var Index = {
  namespaced: true,
  state: {},
  getters: {},
  actions: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, _types.actions.APPLY_FILTERS, function (_ref, _ref2) {
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
      var dispatch, storeFilters, productFilters, asyncProductPool;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch = _ref.dispatch;
            storeFilters = _ref2.storeFilters, productFilters = _ref2.productFilters, asyncProductPool = _ref2.asyncProductPool;
            _context.next = 1;
            return dispatch(INTERNAL_NAMESPACE + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_Filters__["a" /* Types */].actions.SET_SELECTED_FILTERS, {
              storeFilters: storeFilters,
              productFilters: productFilters,
              asyncProductPool: asyncProductPool
            }, {
              root: true
            });
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }), _types.actions.RESET, function (_ref3) {
    var dispatch = _ref3.dispatch;
    dispatch(INTERNAL_NAMESPACE + __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_Filters__["a" /* Types */].actions.RESET_SELECTED_FILTERS, null, {
      root: true
    });
  }),
  mutations: {},
  modules: {
    filters: __WEBPACK_IMPORTED_MODULE_4__app_shared_store_modules_Filters__["b" /* default */]
  }
};
/* harmony default export */ __webpack_exports__["b"] = (Index);

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_ExpertoRetail__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_services_rootUsersService__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sentry_vue__ = __webpack_require__(139);





/* harmony default export */ __webpack_exports__["a"] = ({
  fetchDesktopParameterConfig: function fetchDesktopParameterConfig(_ref) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
      var commit, response, rootUsers, _response$userInfo$id, _t, _t2;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            _context.prev = 1;
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_2__services_api_ExpertoRetail__["a" /* general */].getDesktopParameterConfig();
          case 2:
            response = _context.sent;
            _context.prev = 3;
            _context.next = 4;
            return Object(__WEBPACK_IMPORTED_MODULE_3__app_shared_services_rootUsersService__["a" /* getRootUsers */])();
          case 4:
            rootUsers = _context.sent;
            response.rootUsers = rootUsers;
            _context.next = 6;
            break;
          case 5:
            _context.prev = 5;
            _t = _context["catch"](3);
            console.warn('Could not fetch root users for permission system:', _t);
            response.rootUsers = [];
          case 6:
            commit('setDesktopParameterConfig', response);

            // Configurar usuario en Sentry para rastreo de errore
            if (response.userInfo) {
              __WEBPACK_IMPORTED_MODULE_4__sentry_vue__["setUser"]({
                id: ((_response$userInfo$id = response.userInfo.id) === null || _response$userInfo$id === void 0 ? void 0 : _response$userInfo$id.toString()) || 'unknown',
                email: response.userInfo.email || 'unknown',
                username: response.userInfo.username || response.userInfo.email || 'unknown'
              });
            }
            _context.next = 8;
            break;
          case 7:
            _context.prev = 7;
            _t2 = _context["catch"](1);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 7], [3, 5]]);
    }))();
  }
});

/***/ }),
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_vue__ = __webpack_require__(139);


/* harmony default export */ __webpack_exports__["a"] = ({
  commit_mainMetric: function commit_mainMetric(state, value) {
    state.metric = value;
  },
  commit_newFilters: function commit_newFilters(state, obj) {
    state.globalFilters = obj;
  },
  commit_initCleanStates: function commit_initCleanStates(state) {
    state.globalFilters = '';
    state.selectedView = '';
    state.selectedWeek = {};
  },
  commit_selectedWeek: function commit_selectedWeek(state, array) {
    state.selectedWeek.index = array[0];
    state.selectedWeek.category = array[1];
  },
  commit_selectedView: function commit_selectedView(state, view) {
    state.selectedView = view;
  },
  commit_selectedYear: function commit_selectedYear(state, year) {
    state.selectedWeek.year = year;
  },
  commit_selectedMetricOption: function commit_selectedMetricOption(state, id) {
    state.selectedMetricOption = id;
  },
  commit_appAvailableHeight: function commit_appAvailableHeight(state, value) {
    state.appAvailableHeight = value - 1;
  },
  reset_app: function reset_app(state) {
    var newState = Object(__WEBPACK_IMPORTED_MODULE_0__store__["b" /* initialState */])();
    Object.keys(newState).forEach(function (key) {
      state[key] = newState[key];
    });
    localStorage.removeItem('accessToken');
    // Limpiar usuario de Sentry al resetear la app
    __WEBPACK_IMPORTED_MODULE_1__sentry_vue__["setUser"](null);
  },
  setDesktopParameterConfig: function setDesktopParameterConfig(state, desktopParameterConfig) {
    state.desktopParameterConfig = desktopParameterConfig;
  },
  setActiveWorkspace: function setActiveWorkspace(state, workspace) {
    state.desktopParameterConfig.activeWorkspace = workspace;
  },
  setDashboardRangeOption: function setDashboardRangeOption(state, dashboardRangeOption) {
    state.selectedRangeOption = dashboardRangeOption;
  }
});

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServerIsDown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_wrapNativeSuper__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_wrapNativeSuper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_wrapNativeSuper__);






function _callSuper(t, o, e) { return o = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(o), __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ServerIsDown = /*#__PURE__*/function (_Error) {
  function ServerIsDown(message) {
    var _this;
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ServerIsDown);
    _this = _callSuper(this, ServerIsDown, [message]);
    _this.name = 'ServerIsDown';
    return _this;
  }
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(ServerIsDown, _Error);
  return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(ServerIsDown);
}(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_wrapNativeSuper___default()(Error));


/***/ }),
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{staticClass:"account-dropdown",attrs:{"right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('div',{staticClass:"account-button"},[_c('div',{staticClass:"user-avatar"},[_vm._v("\n        "+_vm._s(_vm.userInitials)+"\n      ")])])]),_vm._v(" "),(_vm.userInfo && _vm.userInfo.name)?_c('div',{staticClass:"current-user-info"},[_c('div',{staticClass:"user-name-display"},[_c('i',{staticClass:"fa fa-user me-1"}),_vm._v(" "),_c('div',{staticClass:"user-details"},[_c('div',{staticClass:"user-name"},[_c('strong',[_vm._v(_vm._s(_vm.userInfo.name))]),_vm._v(" "),(_vm.userInfo.surname)?_c('span',[_vm._v(_vm._s(_vm.userInfo.surname))]):_vm._e()]),_vm._v(" "),(_vm.userInfo.role || _vm.userInfo.user_role)?_c('div',{staticClass:"user-role"},[_vm._v("\n          "+_vm._s(_vm.userInfo.role || _vm.userInfo.user_role)+"\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"app-version"},[_vm._v("\n          "+_vm._s(_vm.appVersion)+"\n        ")])])]),_vm._v(" "),_c('b-dropdown-divider')],1):_vm._e(),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.navigateToApi()}}},[_c('i',{staticClass:"fa fa-code"}),_vm._v(" API\n  ")]),_vm._v(" "),_c('b-dropdown-divider'),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.logout()}}},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" Cerrar sesión\n  ")])],2)}
var staticRenderFns = []


/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdownTradeMarketing_vue__ = __webpack_require__(605);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a490fc0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdownTradeMarketing_vue__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdownTradeMarketing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a490fc0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdownTradeMarketing_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a490fc0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdownTradeMarketing_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DropdownTradeMarketing;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(26);

// import UserModulesModel from '@/app/nav_bar/models/Index'

function DropdownTradeMarketing(props, context) {
  // const userModules = props.data.map(rawUserModules => new UserModulesModel(rawUserModules))

  var filteredUserModules = props.data.filter(function (x) {
    return x.type === 'TRADE_MARKETING';
  });
  return {
    filteredUserModules: filteredUserModules
  };
}

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{attrs:{"no-caret":""}},[_c('template',{slot:"button-content"},[_c('span',{staticClass:"btn-text"},[_vm._v("Trade Marketing")])]),_vm._v(" "),_vm._l((_vm.filteredUserModules),function(module){return _c('b-dropdown-item',{key:module.id,attrs:{"disabled":!module.is_active},on:{"click":function($event){return _vm.$router.push({name: module.component_name})}}},[_vm._v("\n    "+_vm._s(module.description)+"\n  ")])})],2)}
var staticRenderFns = []


/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdownCommercial_vue__ = __webpack_require__(606);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_642efa2e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdownCommercial_vue__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdownCommercial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_642efa2e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdownCommercial_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_642efa2e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdownCommercial_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DropdownCommercial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(26);

function DropdownCommercial(props, context) {
  var filteredUserModules = props.data.filter(function (x) {
    return x.type === 'COMMERCIAL';
  });
  return {
    filteredUserModules: filteredUserModules
  };
}

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{attrs:{"no-caret":""}},[_c('template',{slot:"button-content"},[_c('span',{staticClass:"btn-text"},[_vm._v("Comercial")])]),_vm._v(" "),_vm._l((_vm.filteredUserModules),function(module){return _c('b-dropdown-item',{key:module.id,attrs:{"disabled":!module.is_active},on:{"click":function($event){return _vm.$router.push({name: module.component_name})}}},[_vm._v("\n    "+_vm._s(module.description)+"\n  ")])})],2)}
var staticRenderFns = []


/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DwStatusButton_vue__ = __webpack_require__(607);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fa37bce_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DwStatusButton_vue__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(946)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fa37bce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DwStatusButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fa37bce_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DwStatusButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fa37bce_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DwStatusButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 946 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"header-btn",attrs:{"title":_vm.dwStatusTooltip},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"fa fa-database"}),_vm._v(" "),_c('div',{staticClass:"text-container"},[_c('span',{staticClass:"btn-text"},[_vm._v("Estado de Carga")]),_vm._v(" "),(_vm.dwStatusDateText)?_c('span',{staticClass:"date-text"},[_vm._v(_vm._s(_vm.dwStatusDateText))]):_vm._e()]),_vm._v(" "),(_vm.dwJobLoading)?_c('span',{staticClass:"progress-mini"},[_vm._v("\n    "+_vm._s(_vm.dwJobProgress || 0)+"%\n  ")]):_vm._e()])}
var staticRenderFns = []


/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesStatusModal_vue__ = __webpack_require__(608);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_964a5cd8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesStatusModal_vue__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(949)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-964a5cd8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesStatusModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_964a5cd8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesStatusModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_964a5cd8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesStatusModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 949 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 950 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 951 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"title":_vm.title,"modal-class":"modern-modal","body-class":_vm.bodyClass || undefined,"size":_vm.size,"centered":_vm.centered,"hide-header-close":_vm.hideHeaderClose},on:{"hidden":_vm.onModalHidden},scopedSlots:_vm._u([(_vm.$slots.header)?{key:"modal-header",fn:function(){return [_vm._t("header")]},proxy:true}:null,{key:"modal-footer",fn:function(){return [_vm._t("footer",[_c('div',{staticClass:"w-100 d-flex justify-content-center"},[(_vm.showCancel)?_c('b-button',{staticClass:"mr-2",attrs:{"variant":"outline-secondary","disabled":_vm.processing},on:{"click":_vm.cancelAction}},[_vm._v("\n          "+_vm._s(_vm.cancelText)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.showConfirm)?_c('b-button',{attrs:{"variant":_vm.confirmVariant,"disabled":_vm.confirmDisabled || _vm.processing},on:{"click":_vm.confirmAction}},[(_vm.processing)?_c('b-spinner',{staticClass:"mr-2",attrs:{"small":""}}):_vm._e(),_vm._v("\n          "+_vm._s(_vm.processing ? _vm.processingText : _vm.confirmText)+"\n        ")],1):_vm._e()],1)])]},proxy:true}],null,true),model:{value:(_vm.modalVisible),callback:function ($$v) {_vm.modalVisible=$$v},expression:"modalVisible"}},[_vm._v(" "),_c('div',{staticClass:"modal-content-wrapper"},[_vm._t("default")],2)])}
var staticRenderFns = []


/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SalesStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);


/* eslint-disable camelcase */
var SalesStatus = /*#__PURE__*/function () {
  function SalesStatus(data) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, SalesStatus);
    this.id = data.id;
    this.retailName = data.retail_name;
    this.lastSales = data.last_sales;
    this.connectionStatus = this.getConnectionStatus(data.b_status);
    this.unmappedProductsCount = data.count_product_not_mapped;
    this.incidentDescription = data.incident_description;
  }
  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(SalesStatus, [{
    key: "getConnectionStatus",
    value: function getConnectionStatus(bStatus) {
      if (!bStatus) return 'OK';
      if (bStatus === 'Clave Bloqueada' || bStatus.includes('Token API expirado') || bStatus.includes('Token API inválido')) {
        return bStatus;
      }
      return 'OK';
    }
  }, {
    key: "isConnectionError",
    get: function get() {
      return this.connectionStatus !== 'OK';
    }
  }, {
    key: "connectionStatusClass",
    get: function get() {
      return this.isConnectionError ? 'text-danger' : 'text-success';
    }
  }, {
    key: "formattedLastSales",
    get: function get() {
      if (!this.lastSales) return 'Sin registro';
      return this.lastSales;
    }
  }], [{
    key: "fromArray",
    value: function fromArray(data) {
      return data.map(function (item) {
        return new SalesStatus(item);
      });
    }
  }]);
}();


/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseModal',{attrs:{"id":"sales-status-modal","show":_vm.show,"title":"Último Registro de Ventas","size":"xl","processing":_vm.salesStatusLoading,"show-cancel":false,"show-confirm":false},on:{"update:show":function (val) { _vm.$emit('update:show', val); if (!val) { _vm.$emit('hide') } },"hidden":_vm.resetModalData},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('div',{staticClass:"modern-card mb-4"},[_c('div',{staticClass:"modern-card-header"}),_vm._v(" "),_c('div',{staticClass:"modern-card-body table-container"},[_c('b-table',{staticClass:"modern-table",attrs:{"items":_vm.normalizedSalesStatus,"fields":_vm.salesStatusFields,"thead-class":"modern-thead","tbody-class":"modern-tbody","responsive":"","show-empty":"","empty-text":'Sin datos para mostrar',"busy":_vm.salesStatusLoading},scopedSlots:_vm._u([{key:"cell(connectionStatus)",fn:function(data){return [_c('b-badge',{attrs:{"variant":data.value === 'OK' ? 'success' : 'danger'}},[_vm._v("\n              "+_vm._s(data.value)+"\n            ")])]}},{key:"cell(incidentDescription)",fn:function(data){return [(data.value)?[_c('span',{staticClass:"incident-dot"}),_vm._v("\n              "+_vm._s(data.value)+"\n            ")]:_vm._e()]}},{key:"table-busy",fn:function(){return [_c('div',{staticClass:"skeleton-wrapper"},_vm._l((5),function(n){return _c('div',{key:n,staticClass:"skeleton-row"},_vm._l((_vm.salesStatusFields),function(field){return _c('div',{key:field.key,staticClass:"skeleton-cell"},[_c('div',{staticClass:"skeleton-content"})])}),0)}),0)]},proxy:true}])})],1)]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap gap-2"},[(_vm.isAdmin)?_c('b-button',{staticClass:"action-btn mb-2 mr-2",attrs:{"variant":"outline-primary"},on:{"click":_vm.goToB2BCredentials}},[_c('i',{staticClass:"fa fa-key mr-2"}),_vm._v("\n        Cambiar contraseñas b2b\n      ")]):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('b-button',{staticClass:"action-btn mb-2 mr-2",attrs:{"variant":"outline-primary"},on:{"click":_vm.goToProductMaster}},[_c('i',{staticClass:"fa fa-link mr-2"}),_vm._v("\n        Mapear Productos\n      ")]):_vm._e(),_vm._v(" "),(_vm.userRole !== 'Partner')?_c('b-button',{staticClass:"action-btn mb-2",attrs:{"variant":"outline-primary"},on:{"click":_vm.goToLoadStatus}},[_c('i',{staticClass:"fa fa-eye mr-2"}),_vm._v("\n        Ver estado de carga general\n      ")]):_vm._e()],1)]},proxy:true}])})}
var staticRenderFns = []


/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-wrapper"},[_c('header',{staticClass:"app-header navbar"},[_c('button',{staticClass:"navbar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_c('i',{staticClass:"fa fa-bars"})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('b-navbar-nav',{staticClass:"desktop-nav d-none d-lg-flex"},[_c('HeaderDropdownCommercial',{staticClass:"nav-link",attrs:{"data":_vm.userModules}}),_vm._v(" "),_c('HeaderDropdownTradeMarketing',{staticClass:"nav-link",attrs:{"data":_vm.userModules}})],1),_vm._v(" "),_c('b-collapse',{staticClass:"mobile-collapse",attrs:{"id":"nav-collapse"},model:{value:(_vm.isNavCollapsed),callback:function ($$v) {_vm.isNavCollapsed=$$v},expression:"isNavCollapsed"}},[_c('div',{staticClass:"mobile-menu"},[_c('HeaderDropdownCommercial',{attrs:{"data":_vm.userModules}}),_vm._v(" "),_c('HeaderDropdownTradeMarketing',{attrs:{"data":_vm.userModules}}),_vm._v(" "),_c('div',{staticClass:"mobile-menu-divider"}),_vm._v(" "),_c('div',{staticClass:"mobile-menu-item",on:{"click":function($event){_vm.$router.push('/workspaces'); _vm.isNavCollapsed = false}}},[_c('i',{staticClass:"mobile-menu-icon fa fa-cube"}),_vm._v(" "),_c('span',[_vm._v("Escenarios")]),_vm._v(" "),(_vm.workspaceLoaded)?_c('span',{staticClass:"status-dot success ml-1"}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mobile-menu-item",on:{"click":function($event){_vm.showSalesStatusModal = true; _vm.isNavCollapsed = false}}},[_c('i',{staticClass:"mobile-menu-icon fa fa-database"}),_vm._v(" "),_c('span',[_vm._v("Estado de Carga")])]),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticClass:"mobile-menu-item",on:{"click":function($event){_vm.$router.push('/admin'); _vm.isNavCollapsed = false}}},[_c('i',{staticClass:"mobile-menu-icon fa fa-cog"}),_vm._v(" "),_c('span',[_vm._v("Admin")])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"header-actions ml-auto d-none d-lg-flex"},[_c('DwStatusButton',{on:{"click":function($event){_vm.showSalesStatusModal = true}}}),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticClass:"header-btn admin",on:{"click":function($event){return _vm.$router.push('/admin')}}},[_c('i',{staticClass:"fa fa-cog"}),_vm._v(" "),_c('span',{staticClass:"btn-text"},[_vm._v("Admin")])]):_vm._e()],1),_vm._v(" "),_c('HeaderDropdownAccntCustom',{key:"main-account-dropdown",staticClass:"nav-link account-nav ml-auto",class:{ 'ml-0': false }})],1),_vm._v(" "),_c('SalesStatusModal',{attrs:{"show":_vm.showSalesStatusModal},on:{"update:show":function (val) { return _vm.showSalesStatusModal = val; },"hide":function($event){_vm.showSalesStatusModal = false},"reset":_vm.handleModalReset}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-brand"},[_c('img',{staticClass:"brand-logo",attrs:{"src":"/static/img/logo_final_3.png","alt":"Experto Retail"}})])}]


/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.initialDataLoading)?_c('div',{staticClass:"text-center"},[_c('Loader'),_vm._v(" "),_c('h6',{staticClass:"align-content-center align-content-center"},[_vm._v(" "+_vm._s(_vm.loadingText))])],1):_c('div',{staticClass:"app",staticStyle:{"background-color":"#fbfbfb"}},[_c('BaseHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('main',{staticClass:"main"},[_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)])])],1)}
var staticRenderFns = []


/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mobile_vue__ = __webpack_require__(610);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79c7189b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mobile_vue__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(958)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79c7189b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mobile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79c7189b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mobile_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79c7189b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mobile_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 958 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpertoRetailMobileDashboard_vue__ = __webpack_require__(611);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_055bb24e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpertoRetailMobileDashboard_vue__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(960)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-055bb24e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpertoRetailMobileDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_055bb24e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpertoRetailMobileDashboard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_055bb24e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpertoRetailMobileDashboard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 960 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpertoRetailMobileStoreList_vue__ = __webpack_require__(612);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d57ed890_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpertoRetailMobileStoreList_vue__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(962)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d57ed890"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpertoRetailMobileStoreList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d57ed890_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpertoRetailMobileStoreList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d57ed890_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpertoRetailMobileStoreList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 962 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-input',{staticClass:"mb-2",attrs:{"type":"text","placeholder":"Busca por tienda o cadena"},model:{value:(_vm.textFilter),callback:function ($$v) {_vm.textFilter=$$v},expression:"textFilter"}}),_vm._v(" "),(_vm.loading)?_c('Loader'):_c('b-list-group',{staticClass:"border-0"},_vm._l((_vm.filteredData),function(list){return _c('b-list-group-item',{key:list.store_id,staticClass:"pointer",attrs:{"list-group-item-action":""},on:{"click":function($event){return _vm.goToStore(list.store_id)}}},[_c('h6',[_vm._v(_vm._s(list.retail_name))]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(list.retail_store_name))])])}),1)],1)}
var staticRenderFns = []


/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"border-0"},[_c('StoreList',{attrs:{"data":_vm.storeList.data}})],1)],1)}
var staticRenderFns = []


/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Stores')],1)}
var staticRenderFns = []


/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpertoRetailMobileStoreDetail_vue__ = __webpack_require__(613);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_959b061e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpertoRetailMobileStoreDetail_vue__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(967)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-959b061e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpertoRetailMobileStoreDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_959b061e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpertoRetailMobileStoreDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_959b061e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpertoRetailMobileStoreDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 967 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeneralUtils_vue__ = __webpack_require__(614);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeneralUtils_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DimensionUtils_vue__ = __webpack_require__(615);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DimensionUtils_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeneralValidator_vue__ = __webpack_require__(616);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeneralValidator_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterObjectParameterBuilder_vue__ = __webpack_require__(617);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterObjectParameterBuilder_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileFilter_vue__ = __webpack_require__(618);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d18773b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileFilter_vue__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d18773b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileFilter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d18773b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileFilter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 973 */,
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parameters; });
/* unused harmony export filterObject */
var parameters = {
  store_filters: {
    retail_id: [],
    store_id: [],
    comuna: [],
    region_id: [],
    store_type_id: [],
    mall_id: [],
    distribution_type_id: [],
    retail_type_id: [],
    store_is_active: []
  },
  product_filters: {
    product_category_hlev1_id: [],
    product_map_id: [],
    product_id: [],
    product_category_hlev2_id: [],
    product_category_hlev3_id: [],
    product_category_hlev4_id: [],
    color_id: [],
    brand_id: [],
    attr_1_id: [],
    attr_2_id: [],
    attr_3_id: [],
    attr_4_id: [],
    attr_5_id: [],
    attr_6_id: [],
    attr_7_id: [],
    attr_8_id: [],
    obsolete: []
  },
  store_dimensions: [],
  product_dimensions: [],
  fact: {
    type: '',
    name: ''
  },
  sort: {
    field: '',
    dir: ''
  },
  necessary_stock_dimensions: [],
  new_stock_dimensions: [],
  metrics: {
    normal: [],
    "var": []
  }
};
var filterObject = {
  store_filters: {
    retail_id: [],
    store_id: [],
    comuna: [],
    region_id: [],
    store_type_id: [],
    mall_id: [],
    distribution_type_id: [],
    retail_type_id: [],
    store_is_active: []
  },
  product_filters: {
    product_category_hlev1_id: [],
    product_map_id: [],
    product_id: [],
    product_category_hlev2_id: [],
    product_category_hlev3_id: [],
    product_category_hlev4_id: [],
    color_id: [],
    brand_id: [],
    attr_1_id: [],
    attr_2_id: [],
    attr_3_id: [],
    attr_4_id: [],
    attr_5_id: [],
    attr_6_id: [],
    attr_7_id: [],
    attr_8_id: [],
    obsolete: []
  }
};


/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((this.groupFilters),function(groupFilter){return _c('b-card',{key:groupFilter.name,staticClass:"p-1 border-0 mb-1",attrs:{"no-body":"","md":"12"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(groupFilter.name))])]),_vm._v(" "),_c('b-row',_vm._l((groupFilter.filters),function(filter){return _c('b-col',{key:filter.id,attrs:{"md":"4"}},[(filter.visible)?_c('div',[((filter.id === 'product_category_hlev1_id'))?_c('b-input-group',[_c('v-select',{ref:filter.id,refInFor:true,attrs:{"multiple":"","options":filter.data,"label":"name","onChange":_vm.getProductCategory2},model:{value:(filter.selected),callback:function ($$v) {_vm.$set(filter, "selected", $$v)},expression:"filter.selected"}})],1):((filter.id === 'product_category_hlev2_id'))?_c('b-input-group',[_c('v-select',{ref:filter.id,refInFor:true,attrs:{"multiple":"","options":filter.data,"label":"name","onChange":_vm.getProductCategory3},model:{value:(filter.selected),callback:function ($$v) {_vm.$set(filter, "selected", $$v)},expression:"filter.selected"}})],1):((filter.type === 'select'))?_c('b-input-group',[_c('v-select',{ref:filter.id,refInFor:true,attrs:{"options":filter.data,"label":"name"},model:{value:(filter.selected),callback:function ($$v) {_vm.$set(filter, "selected", $$v)},expression:"filter.selected"}})],1):_c('b-input-group',[_c('v-select',{ref:filter.id,refInFor:true,attrs:{"multiple":"","options":filter.data,"label":"name"},model:{value:(filter.selected),callback:function ($$v) {_vm.$set(filter, "selected", $$v)},expression:"filter.selected"}})],1)],1):_vm._e()])}),1)],1)}),1)}
var staticRenderFns = []


/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('b-card',{staticClass:"bk-color rounded border-0"},[_c('b-card',{staticClass:"transparent text-white align-items-center text-center border-0",attrs:{"no-body":""}},[_c('h5',[_c('i',{directives:[{name:"b-modal",rawName:"v-b-modal.mobile-filters",modifiers:{"mobile-filters":true}}],staticClass:"fa fa-filter mr-1 fa-2x filter-icon"}),_vm._v(_vm._s(_vm.storeDetail.data.retail_name)+" "+_vm._s(_vm.storeDetail.data.retail_store_name))]),_vm._v(" "),_c('h6',[_vm._v("Cod. Tiend: "+_vm._s(_vm.storeDetail.data.retail_store_code))])]),_vm._v(" "),(_vm.loading)?_c('Loader'):_c('b-card',{staticClass:"text-center transparent text-white border-0"},[_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_vm._v("\n            Venta en unidades\n            "),_c('h5',[_vm._v("\n              "+_vm._s(_vm._f("number")(_vm.storeDetail.data.quantity_sold))+"\n            ")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_vm._v("\n            Stock en Unidades\n            "),_c('h5',[_vm._v("\n              "+_vm._s(_vm._f("number")(_vm.storeDetail.data.stock_quantity))+"\n            ")])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{attrs:{"cols":"6"}},[_vm._v("\n            Venta en $\n            "),_c('h5',[_vm._v(_vm._s(_vm._f("money")(_vm.storeDetail.data.real_sales_amount)))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_vm._v("\n            Stock en $ (PVP)\n            "),_c('h5',[_vm._v(_vm._s(_vm._f("money")(_vm.storeDetail.data.real_stock_pvp_amount)))])])],1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"border-0 m-0 text-center",attrs:{"no-body":""}},[(!_vm.checkingIn || !_vm.checkedIn)?_c('b-button',{staticClass:"mb-3 bk-color text-white m-0",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.getPosition()}}},[_vm._v("Check-In")]):_c('p',{staticClass:"mt-3 mb-3",staticStyle:{"width":"100%"}},[_vm._v("Chequeando en tienda...")]),_vm._v(" "),(_vm.checkedIn)?_c('b-button',{staticClass:"mb-3 bk-color text-white m-0",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.getPosition()}}},[_vm._v("Check-out")]):_vm._e()],1),_vm._v(" "),_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('b-row',{staticClass:"text-center text-dark"},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-card',{staticClass:"border-secondary h-100",staticStyle:{"border-radius":"25px"},on:{"click":function($event){return _vm.$router.push({name:'ProductDetail'})}}},[_c('h5',[_vm._v("Ventas & "),_c('br'),_vm._v(" Stock")]),_vm._v(" "),_c('i',{staticClass:"fa fa-4x fa-table mt-3",staticStyle:{"color":"#0d1052"}})])],1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"border-0"},[(_vm.activities)?_c('h4',[_vm._v("Actividades para esta tienda:")]):_c('h6',[_vm._v("No hay actividades para esta tienda")]),_vm._v(" "),_c('b-list-group',[(_vm.storeDetail.data.stock_quantity_wm > 0)?_c('b-list-group-item',{on:{"click":function($event){return _vm.goTo('WmProductList', _vm.store_id)}}},[_c('b-row',[_c('b-col',{attrs:{"cols":"10"}},[_vm._v("\n              Hay "),_c('strong',[_vm._v(_vm._s(_vm.storeDetail.data.stock_quantity_wm))]),_vm._v("\n              unidades en Stock que no se están vendiendo.\n              Entra al detalle y revisa los productos en la sala para verificarlos\n            ")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('i',{staticClass:"fa fa-chevron-right fa-2x mt-4",staticStyle:{"color":"#0d1052"},attrs:{"aria-hidden":"true"}})])],1)],1):_vm._e(),_vm._v(" "),(_vm.storeDetail.data.new_stock_delta_quantity > 0)?_c('b-list-group-item',{on:{"click":function($event){return _vm.$router.push({name:'NewStockProductList'})}}},[_c('b-row',[_c('b-col',{attrs:{"cols":"10"}},[_vm._v("\n              Hay "),_c('strong',[_vm._v(_vm._s(_vm.storeDetail.data.new_stock_delta_quantity))]),_vm._v(" unidades de stock ingresadas recientemente a\n              la tienda. Revisa que estén bien exhibidas y que las unidades correspondan a la cantidad de unidades físicas\n            ")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('i',{staticClass:"fa fa-chevron-right fa-2x mt-4",staticStyle:{"color":"#0d1052"},attrs:{"aria-hidden":"true"}})])],1)],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"FilterModalRef",attrs:{"id":"mobile-filters","hide-footer":"","title":"Filtro de Productos"}},[_c('MobileFilters'),_vm._v(" "),_c('b-button',{attrs:{"block":"","variant":"primary"},on:{"click":_vm.filterModal}},[_vm._v("Filtrar")])],1)],1)}
var staticRenderFns = []


/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpertoRetailMobileProductList_vue__ = __webpack_require__(619);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66daa886_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpertoRetailMobileProductList_vue__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(978)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66daa886"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpertoRetailMobileProductList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66daa886_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpertoRetailMobileProductList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66daa886_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpertoRetailMobileProductList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 978 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('b-form-input',{staticClass:"mb-1",attrs:{"type":"text","id":"store-input-search","placeholder":"Buscar Producto"},model:{value:(_vm.textFilter),callback:function ($$v) {_vm.textFilter=$$v},expression:"textFilter"}})],1),_vm._v(" "),(_vm.loading)?_c('Loader'):_c('b-list-group',_vm._l((_vm.filteredProducts),function(list){return _c('b-list-group-item',{key:list.product_map_id,staticClass:"pointer",attrs:{"list-group-item-action":""}},[_c('b-card',{staticClass:"border-0"},[_vm._v("\n        Información producto proveedor\n        "),_c('h6',[_vm._v(_vm._s(list.vendor_product_description))]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(list.vendor_product_code))]),_vm._v("\n        Información producto cadena\n        "),_c('h6',[_vm._v(_vm._s(list.retail_product_description))]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(list.retail_product_code))])]),_vm._v(" "),_c('b-card',{staticClass:"text-center border-0"},[_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_vm._v("\n            Venta en unidades\n            "),_c('h6',[_vm._v(_vm._s(_vm._f("number")(list.quantity_sold)))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_vm._v("\n            Stock en Unidades\n            "),_c('h6',[_vm._v(_vm._s(_vm._f("number")(list.stock_quantity)))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{attrs:{"cols":"6"}},[_vm._v("\n            Venta en $\n            "),_c('h6',[_vm._v(_vm._s(_vm._f("money")(list.real_sales_amount)))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_vm._v("\n            Stock en $ (PVP)\n            "),_c('h6',[_vm._v(_vm._s(_vm._f("money")(list.real_stock_pvp_amount)))])])],1)],1)],1)}),1)],1)}
var staticRenderFns = []


/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpertoRetailMobileWmProductList_vue__ = __webpack_require__(620);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0695d134_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpertoRetailMobileWmProductList_vue__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(981)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0695d134"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpertoRetailMobileWmProductList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0695d134_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpertoRetailMobileWmProductList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0695d134_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpertoRetailMobileWmProductList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 981 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("Productos sin movimiento")]),_vm._v(" "),_c('p',[_vm._v("Revisa los siguientes productos listados que en las últimas 4 semanas han tenido poca venta, pero tienen una elevada carga de stock.\n  El listado esta ordenado de tal manera que los mas afectados se listan primero.")]),_vm._v(" "),(_vm.loading)?_c('Loader'):_c('b-list-group',_vm._l((_vm.data),function(list){return _c('b-list-group-item',{key:list.product_map_id,staticClass:"pointer",attrs:{"list-group-item-action":""}},[_c('b-card',{staticClass:"border-0"},[_vm._v("\n        Información producto proveedor\n        "),_c('h6',[_vm._v(_vm._s(list.vendor_product_description))]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(list.vendor_product_code))]),_vm._v("\n        Información producto cadena\n        "),_c('h6',[_vm._v(_vm._s(list.retail_product_description))]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(list.retail_product_code))])]),_vm._v(" "),_c('b-card',{staticClass:"text-center border-0"},[_c('b-row',[_c('b-col',[_vm._v("\n            Unidades de Stock\n            "),_c('h1',[_vm._v(_vm._s(_vm._f("number")(list.stock_quantity)))])])],1)],1)],1)}),1)],1)}
var staticRenderFns = []


/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpertoRetailMobileNewStockProductList_vue__ = __webpack_require__(621);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e72cba7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpertoRetailMobileNewStockProductList_vue__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(984)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e72cba7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpertoRetailMobileNewStockProductList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e72cba7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpertoRetailMobileNewStockProductList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e72cba7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpertoRetailMobileNewStockProductList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 984 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("Productos Ingresados")]),_vm._v(" "),_c('p',[_vm._v("La plataforma ha detectado que los siguientes productos han ingresado a esta tienda. Revisa que el stock físico concuerde con el stock informado en este listado.")]),_vm._v(" "),(_vm.loading)?_c('Loader'):_c('b-list-group',_vm._l((_vm.productDetail.data),function(list){return _c('b-list-group-item',{key:list.product_map_id,staticClass:"pointer",attrs:{"list-group-item-action":""}},[_c('b-card',[_vm._v("\n        Información producto proveedor\n        "),_c('h6',[_vm._v(_vm._s(list.vendor_product_description))]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(list.vendor_product_code))]),_vm._v("\n        Información producto cadena\n        "),_c('h6',[_vm._v(_vm._s(list.retail_product_description))]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(list.retail_product_code))])]),_vm._v(" "),_c('b-card',{staticClass:"text-center"},[_c('b-row',[_c('b-col',[_vm._v("\n            Stock Ingresado\n            "),_c('h1',[_vm._v(_vm._s(_vm._f("number")(list.delta)))])])],1)],1)],1)}),1)],1)}
var staticRenderFns = []


/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_NewsFeed__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_UploadImagesFeed__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_ExecutionFocusList__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_CreateExecutionFocus__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_ExecutionFocusDashboard__ = __webpack_require__(1047);





/* harmony default export */ __webpack_exports__["a"] = ([{
  path: 'store_publication_content',
  name: 'StorePublicationContent',
  component: __WEBPACK_IMPORTED_MODULE_0__views_NewsFeed__["a" /* default */],
  props: true
}, {
  path: 'upload_images_feed',
  name: 'UploadImagesFeed',
  component: __WEBPACK_IMPORTED_MODULE_1__views_UploadImagesFeed__["a" /* default */],
  props: true
}, {
  path: 'execution_focus',
  name: 'ExecutionFocusList',
  component: __WEBPACK_IMPORTED_MODULE_2__views_ExecutionFocusList__["a" /* default */],
  props: true
}, {
  path: 'execution_focus_create',
  name: 'CreateExecutionFocus',
  component: __WEBPACK_IMPORTED_MODULE_3__views_CreateExecutionFocus__["a" /* default */],
  props: true
}, {
  path: 'execution_focus/:id/results',
  name: 'ExecutionFocusDashboard',
  component: __WEBPACK_IMPORTED_MODULE_4__views_ExecutionFocusDashboard__["a" /* default */],
  props: true
}]);

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsFeed_vue__ = __webpack_require__(622);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_410f7af5_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsFeed_vue__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(988)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-410f7af5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsFeed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_410f7af5_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsFeed_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_410f7af5_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsFeed_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 988 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewsFeedPost; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);


var NewsFeedPost = /*#__PURE__*/function () {
  function NewsFeedPost(raw) {
    var _raw$latitude, _raw$longitude, _raw$checked_in_at, _raw$check_in_id, _raw$retail_product, _raw$vendor_product;
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, NewsFeedPost);
    this.id = raw.id;
    this.post_type = raw.post_type || 'post';
    this.created_by = raw.created_by;
    this.store_id = raw.store_id;
    this.retail_name_store_name = raw.retail_name_store_name;
    this.created_at = raw.created_at;
    this.cat_description = raw.cat_description;
    this.name = raw.name;
    this.content = raw.content;
    this.is_deleted = raw.is_deleted;
    this.deleted_at = raw.deleted_at;
    this.deleted_by_name = raw.deleted_by_name;
    this.latest_comment_content = raw.latest_comment_content;
    this.latest_comment_author = raw.latest_comment_author;
    this.latest_comment_at = raw.latest_comment_at;
    this.hashtags = raw.hashtags || [];
    this.mentions = raw.mentions || [];
    this.latitude = (_raw$latitude = raw.latitude) !== null && _raw$latitude !== void 0 ? _raw$latitude : null;
    this.longitude = (_raw$longitude = raw.longitude) !== null && _raw$longitude !== void 0 ? _raw$longitude : null;
    this.checked_in_at = (_raw$checked_in_at = raw.checked_in_at) !== null && _raw$checked_in_at !== void 0 ? _raw$checked_in_at : null;
    this.check_in_id = (_raw$check_in_id = raw.check_in_id) !== null && _raw$check_in_id !== void 0 ? _raw$check_in_id : null;
    this.retail_product = (_raw$retail_product = raw.retail_product) !== null && _raw$retail_product !== void 0 ? _raw$retail_product : null;
    this.vendor_product = (_raw$vendor_product = raw.vendor_product) !== null && _raw$vendor_product !== void 0 ? _raw$vendor_product : null;
    this.total = raw.total;
    this.per_page = raw.per_page;
  }
  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(NewsFeedPost, [{
    key: "isCheckEvent",
    get: function get() {
      return this.post_type === 'check_in' || this.post_type === 'check_out';
    }
  }, {
    key: "isCheckIn",
    get: function get() {
      return this.post_type === 'check_in';
    }
  }, {
    key: "isCheckOut",
    get: function get() {
      return this.post_type === 'check_out';
    }
  }, {
    key: "hasCoordinates",
    get: function get() {
      return this.latitude !== null && this.longitude !== null;
    }
  }, {
    key: "visitDuration",
    get: function get() {
      if (!this.isCheckOut || !this.checked_in_at || !this.created_at) return null;
      var minutes = Math.round((this.created_at - this.checked_in_at) / 1000 / 60);
      if (minutes < 60) return "".concat(minutes, " min");
      var hours = Math.floor(minutes / 60);
      var remainingMinutes = minutes % 60;
      return remainingMinutes > 0 ? "".concat(hours, "h ").concat(remainingMinutes, "min") : "".concat(hours, "h");
    }
  }]);
}();


/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsCard_vue__ = __webpack_require__(623);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376f9c2e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsCard_vue__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(991)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-376f9c2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376f9c2e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376f9c2e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 991 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 992 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"feed-delete-wrapper"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"delete-btn",attrs:{"title":_vm.buttonTitle,"size":"sm","variant":"outline-danger","disabled":_vm.deleting},on:{"click":function($event){_vm.showModal = true}}},[(_vm.deleting)?_c('b-spinner',{attrs:{"small":""}}):_c('i',{staticClass:"fa fa-trash"})],1),_vm._v(" "),_c('BaseModal',{attrs:{"show":_vm.showModal,"title":_vm.modalTitle,"processing":_vm.deleting,"show-confirm":false,"show-cancel":false},on:{"update:show":function($event){_vm.showModal = $event}},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('div',{staticClass:"fdb-footer"},[(_vm.postType === 'check_out')?[_c('button',{staticClass:"fdb-action-btn fdb-action-partial",attrs:{"disabled":_vm.deleting},on:{"click":function($event){return _vm.confirm('check_out')}}},[_c('i',{staticClass:"fa fa-sign-out mr-2"}),_vm._v("Solo la salida\n          ")]),_vm._v(" "),_c('button',{staticClass:"fdb-action-btn fdb-action-full",attrs:{"disabled":_vm.deleting},on:{"click":function($event){return _vm.confirm('both')}}},[_c('i',{staticClass:"fa fa-trash mr-2"}),_vm._v("Entrada y salida\n          ")])]:[_c('button',{staticClass:"fdb-action-btn fdb-action-full",attrs:{"disabled":_vm.deleting},on:{"click":function($event){return _vm.confirm(_vm.postType === 'check_in' ? 'check_in' : 'post')}}},[_c('i',{staticClass:"fa fa-trash mr-2"}),_vm._v(_vm._s(_vm.confirmLabel)+"\n          ")])],_vm._v(" "),_c('button',{staticClass:"fdb-cancel-btn",attrs:{"disabled":_vm.deleting},on:{"click":function($event){_vm.showModal = false}}},[_vm._v("\n          Cancelar\n        ")])],2)]},proxy:true}])},[_c('p',{staticClass:"fdb-body-text"},[_vm._v("\n      "+_vm._s(_vm.bodyText)+"\n    ")])])],1)}
var staticRenderFns = []


/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostComments_vue__ = __webpack_require__(626);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f3aa299_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostComments_vue__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(995)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f3aa299"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostComments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f3aa299_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostComments_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f3aa299_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostComments_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 995 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MentionableUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);


var MentionableUser = /*#__PURE__*/function () {
  function MentionableUser(_ref) {
    var id = _ref.id,
      name = _ref.name,
      surname = _ref.surname;
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, MentionableUser);
    this.id = id;
    this.name = name || '';
    this.surname = surname || '';
  }
  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(MentionableUser, [{
    key: "fullName",
    get: function get() {
      return [this.name, this.surname].filter(Boolean).join(' ');
    }
  }, {
    key: "initials",
    get: function get() {
      return this.fullName.split(' ').map(function (n) {
        return n[0];
      }).join('').substring(0, 2).toUpperCase();
    }
  }]);
}();


/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-comments"},[(_vm.loading)?_c('div',{staticClass:"comments-spinner"},[_c('b-spinner',{attrs:{"small":"","variant":"secondary"}})],1):[(_vm.comments.length > 0)?_c('div',{staticClass:"comments-list"},[_vm._l((_vm.comments),function(comment){return _c('div',{key:comment.id,staticClass:"comment-row"},[(comment.is_deleted)?_c('div',{staticClass:"comment-deleted"},[_c('i',{staticClass:"fa fa-ban mr-1"}),_vm._v("\n          Comentario eliminado\n        ")]):[_c('b-avatar',{staticClass:"comment-avatar",attrs:{"size":"26","variant":"primary","text":_vm.getInitials(comment.author_name)}}),_vm._v(" "),_c('div',{staticClass:"comment-bubble"},[_c('div',{staticClass:"comment-author"},[_vm._v("\n              "+_vm._s(comment.author_name)+"\n            ")]),_vm._v(" "),(_vm.editingId === comment.id)?_c('div',{staticClass:"edit-form"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.editContent),expression:"editContent"}],ref:"editTextarea",refInFor:true,staticClass:"edit-textarea",attrs:{"rows":"2"},domProps:{"value":(_vm.editContent)},on:{"keydown":function($event){return _vm.onEditKeydown($event, comment)},"input":[function($event){if($event.target.composing){ return; }_vm.editContent=$event.target.value},_vm.onEditInput],"blur":_vm.onEditBlur}}),_vm._v(" "),(_vm.showEditMentionDropdown)?_c('div',{staticClass:"mention-dropdown mention-dropdown--edit"},[(_vm.editMentionLoading)?_c('div',{staticClass:"mention-loading-row"},[_c('b-spinner',{attrs:{"small":"","variant":"secondary"}})],1):[_vm._l((_vm.editMentionResults),function(user,idx){return _c('button',{key:user.id,class:['mention-item', { 'mention-item--active': _vm.editMentionHighlightIndex === idx }],on:{"mousedown":function($event){$event.preventDefault();return _vm.selectEditMention(user)}}},[_c('b-avatar',{staticClass:"mention-item-avatar",attrs:{"size":"18","variant":"primary","text":user.initials}}),_vm._v(" "),_c('span',{staticClass:"mention-item-name"},[_vm._v(_vm._s(user.fullName))])],1)}),_vm._v(" "),(_vm.editMentionResults.length === 0)?_c('div',{staticClass:"mention-empty"},[_vm._v("\n                    Sin resultados\n                  ")]):_vm._e()]],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"edit-actions"},[_c('button',{staticClass:"btn-link-save",attrs:{"disabled":_vm.savingEdit || !_vm.editContent.trim()},on:{"click":function($event){return _vm.confirmEdit(comment)}}},[(_vm.savingEdit)?_c('b-spinner',{attrs:{"small":""}}):_c('span',[_vm._v("Guardar")])],1),_vm._v(" "),_c('span',{staticClass:"dot-sep"},[_vm._v("·")]),_vm._v(" "),_c('button',{staticClass:"btn-link-cancel",on:{"click":_vm.cancelEdit}},[_vm._v("\n                  Cancelar\n                ")])])]):_c('p',{staticClass:"comment-text",domProps:{"innerHTML":_vm._s(_vm.renderMentions(comment.content))}}),_vm._v(" "),(_vm.editingId !== comment.id)?_c('div',{staticClass:"comment-footer"},[_c('span',{staticClass:"comment-time"},[_vm._v(_vm._s(_vm.formatTime(comment.created_at)))]),_vm._v(" "),(comment.edited_at)?_c('span',{staticClass:"comment-edited"},[_vm._v("· editado")]):_vm._e(),_vm._v(" "),(_vm.canManage(comment))?[_c('span',{staticClass:"dot-sep"},[_vm._v("·")]),_vm._v(" "),_c('button',{staticClass:"btn-comment-action",on:{"click":function($event){return _vm.startEdit(comment)}}},[_vm._v("\n                  Editar\n                ")]),_vm._v(" "),_c('span',{staticClass:"dot-sep"},[_vm._v("·")]),_vm._v(" "),_c('button',{staticClass:"btn-comment-action danger",on:{"click":function($event){return _vm.handleDelete(comment)}}},[_vm._v("\n                  Eliminar\n                ")])]:_vm._e()],2):_vm._e()])]],2)}),_vm._v(" "),(_vm.loadingMore)?_c('div',{staticClass:"comments-spinner mt-2"},[_c('b-spinner',{attrs:{"small":"","variant":"secondary"}})],1):_vm._e(),_vm._v(" "),(_vm.hasMore && !_vm.loadingMore)?_c('button',{staticClass:"load-more-btn",on:{"click":_vm.loadMore}},[_vm._v("\n        Ver más comentarios\n      ")]):_vm._e()],2):_c('p',{staticClass:"no-comments"},[_vm._v("\n      Sé el primero en comentar\n    ")]),_vm._v(" "),_c('div',{staticClass:"new-comment-row"},[_c('b-avatar',{staticClass:"flex-shrink-0",attrs:{"size":"26","variant":"primary","text":_vm.currentUserInitials}}),_vm._v(" "),_c('div',{staticClass:"input-wrapper"},[_c('div',{staticClass:"mention-wrapper"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.newCommentText),expression:"newCommentText"}],ref:"commentInput",staticClass:"comment-input",attrs:{"placeholder":"Escribe un comentario...","rows":"1"},domProps:{"value":(_vm.newCommentText)},on:{"keydown":_vm.onNewCommentKeydown,"input":[function($event){if($event.target.composing){ return; }_vm.newCommentText=$event.target.value},_vm.onNewCommentInput],"blur":_vm.onNewCommentBlur}}),_vm._v(" "),(_vm.showMentionDropdown)?_c('div',{staticClass:"mention-dropdown mention-dropdown--new"},[(_vm.mentionLoading)?_c('div',{staticClass:"mention-loading-row"},[_c('b-spinner',{attrs:{"small":"","variant":"secondary"}})],1):[_vm._l((_vm.mentionResults),function(user,idx){return _c('button',{key:user.id,class:['mention-item', { 'mention-item--active': _vm.mentionHighlightIndex === idx }],on:{"mousedown":function($event){$event.preventDefault();return _vm.selectMention(user)}}},[_c('b-avatar',{staticClass:"mention-item-avatar",attrs:{"size":"18","variant":"primary","text":user.initials}}),_vm._v(" "),_c('span',{staticClass:"mention-item-name"},[_vm._v(_vm._s(user.fullName))])],1)}),_vm._v(" "),(_vm.mentionResults.length === 0)?_c('div',{staticClass:"mention-empty"},[_vm._v("\n                Sin resultados\n              ")]):_vm._e()]],2):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"send-btn",attrs:{"disabled":!_vm.newCommentText.trim() || _vm.submitting},on:{"click":_vm.submitComment}},[(_vm.submitting)?_c('b-spinner',{attrs:{"small":""}}):_c('i',{staticClass:"fa fa-paper-plane"})],1)])],1)]],2)}
var staticRenderFns = []


/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostHashtags_vue__ = __webpack_require__(627);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0a109d0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostHashtags_vue__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(999)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d0a109d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostHashtags_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0a109d0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostHashtags_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0a109d0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostHashtags_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 999 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"post-hashtags"},[_c('div',{staticClass:"tags-row"},[_vm._l((_vm.content.hashtags),function(tag){return _c('span',{key:tag.id,staticClass:"hashtag-badge",style:(_vm.badgeStyle(tag.color))},[_vm._v("\n      #"+_vm._s(tag.label)+"\n      "),_c('button',{staticClass:"remove-tag-btn",style:({ color: tag.color }),on:{"click":function($event){return _vm.removeTag(tag)}}},[_c('i',{staticClass:"fa fa-times"})])])}),_vm._v(" "),_c('button',{staticClass:"add-tag-btn",on:{"click":_vm.openPicker}},[_c('i',{staticClass:"fa fa-tag mr-1"}),_vm._v("\n      Etiquetar\n    ")])],2),_vm._v(" "),_c('portal',{attrs:{"to":"news-feed-portal"}},[(_vm.showPicker)?_c('div',{staticClass:"tag-picker",style:(_vm.pickerStyle)},[_c('div',{staticClass:"picker-search-wrapper"},[_c('i',{staticClass:"fa fa-search picker-search-icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],ref:"searchInput",staticClass:"picker-search",attrs:{"placeholder":"Buscar etiqueta..."},domProps:{"value":(_vm.searchText)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value},_vm.onSearchInput]}})]),_vm._v(" "),_c('div',{staticClass:"picker-list"},[(_vm.loadingTags)?_c('div',{staticClass:"picker-spinner"},[_c('b-spinner',{attrs:{"small":"","variant":"secondary"}})],1):[_vm._l((_vm.filteredAvailable),function(tag){return _c('button',{key:tag.id,staticClass:"picker-item",on:{"click":function($event){return _vm.addTag(tag)}}},[_c('span',{staticClass:"picker-dot",style:({ background: tag.color })}),_vm._v(" "),_c('span',{staticClass:"picker-label"},[_vm._v(_vm._s(tag.label))])])}),_vm._v(" "),(_vm.filteredAvailable.length === 0)?_c('p',{staticClass:"picker-empty"},[_vm._v("\n            Sin resultados\n          ")]):_vm._e()]],2)]):_vm._e()])],1)}
var staticRenderFns = []


/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"modern-card mb-3",class:{ 'row-card': _vm.isRowMode },attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"modern-card-body"},[(_vm.content.is_deleted)?_c('div',{staticClass:"tombstone"},[_c('i',{staticClass:"fa fa-trash mr-2"}),_vm._v("\n      Esta publicación fue eliminada por "),_c('strong',[_vm._v(_vm._s(_vm.content.deleted_by_name))])]):[_c('div',{class:['card-header-row', _vm.isRowMode ? 'mb-1' : 'mb-3']},[_c('div',{staticClass:"post-meta"},[_c('b-avatar',{staticClass:"mr-3",attrs:{"variant":"primary","text":_vm.getAvatarText}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"post-author"},[_vm._v("\n              "+_vm._s(_vm.content.name)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"post-store"},[_vm._v("\n              "+_vm._s(_vm.content.retail_name_store_name)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"post-date"},[_vm._v("\n              "+_vm._s(_vm.formattedDate)+"\n            ")])])],1),_vm._v(" "),(_vm.canDelete)?_c('feed-delete-button',{attrs:{"deleting":_vm.deleting},on:{"delete":_vm.handleDelete}}):_vm._e()],1),_vm._v(" "),_c('div',{class:['card-body-content', _vm.isRowMode ? 'body-row' : 'body-list']},[_c('div',{staticClass:"text-side"},[(_vm.captionSegments.length)?_c('p',{staticClass:"post-caption"},[_vm._l((_vm.captionSegments),function(seg,i){return [(seg.type === 'text')?_c('span',{key:'t' + i},[_vm._v(_vm._s(seg.value))]):(seg.type === 'hashtag')?_c('span',{key:'h' + i,staticClass:"caption-ht",style:({
                  background: seg.hashtag.color + '22',
                  color: seg.hashtag.color,
                  borderColor: seg.hashtag.color + '55'
                })},[_vm._v(_vm._s(seg.raw))]):_c('span',{key:'m' + i,staticClass:"caption-mention"},[_vm._v("@"+_vm._s(seg.name))])]})],2):_vm._e(),_vm._v(" "),(_vm.content.retail_product || _vm.content.vendor_product)?_c('div',{staticClass:"product-info"},[(_vm.content.retail_product)?_c('div',{staticClass:"product-tag"},[_c('i',{staticClass:"fa fa-tag mr-1"}),_vm._v(" "),_c('span',{staticClass:"product-label"},[_vm._v("Retail:")]),_vm._v(" "+_vm._s(_vm.content.retail_product)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.content.vendor_product)?_c('div',{staticClass:"product-tag"},[_c('i',{staticClass:"fa fa-tag mr-1"}),_vm._v(" "),_c('span',{staticClass:"product-label"},[_vm._v("Proveedor:")]),_vm._v(" "+_vm._s(_vm.content.vendor_product)+"\n            ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('post-hashtags',{attrs:{"content":_vm.content},on:{"hashtag-added":function($event){return _vm.$emit('hashtag-added')}}}),_vm._v(" "),_c('div',{staticClass:"comments-area"},[(_vm.content.latest_comment_content && !_vm.showComments && !_vm.isRowMode)?_c('div',{staticClass:"latest-comment-preview"},[_c('b-avatar',{staticClass:"mr-1 flex-shrink-0",attrs:{"size":"18","variant":"secondary","text":_vm.latestCommentInitials}}),_vm._v(" "),_c('span',{staticClass:"preview-text"},[_c('strong',[_vm._v(_vm._s(_vm.content.latest_comment_author))]),_vm._v("\n                "+_vm._s(_vm.content.latest_comment_content)+"\n              ")])],1):_vm._e(),_vm._v(" "),_c('button',{staticClass:"toggle-comments-btn",on:{"click":_vm.toggleComments}},[_c('i',{staticClass:"mr-1",class:_vm.showComments ? 'fa fa-chevron-up' : 'fa fa-comment-o'}),_vm._v("\n              "+_vm._s(_vm.showComments ? 'Ocultar comentarios' : (_vm.content.latest_comment_content ? 'Ver comentarios' : 'Comentar'))+"\n            ")]),_vm._v(" "),(_vm.showComments)?_c('post-comments',{attrs:{"post-id":_vm.content.id}}):_vm._e()],1)],1),_vm._v(" "),(_vm.hasImages || !_vm.isRowMode)?_c('viewer',{ref:"viewer",staticClass:"viewer media-side",attrs:{"images":_vm.imgList},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"carousel-wrap"},[_vm._l((scope.images),function(src,i){return _c('img',{key:src,class:['post-image', { 'car-hidden': i !== _vm.carouselIndex }],attrs:{"src":src,"alt":"Imagen publicación"}})}),_vm._v(" "),(scope.images.length > 1)?[_c('button',{staticClass:"car-btn car-prev",on:{"click":function($event){$event.stopPropagation();return _vm.prevImage(scope.images.length)}}},[_c('i',{staticClass:"fa fa-chevron-left"})]),_vm._v(" "),_c('button',{staticClass:"car-btn car-next",on:{"click":function($event){$event.stopPropagation();return _vm.nextImage(scope.images.length)}}},[_c('i',{staticClass:"fa fa-chevron-right"})]),_vm._v(" "),_c('span',{staticClass:"car-counter"},[_vm._v(_vm._s(_vm.carouselIndex + 1)+"/"+_vm._s(scope.images.length))])]:_vm._e()],2)]}}],null,false,146947085)}):_vm._e()],1)]],2)],1)}
var staticRenderFns = []


/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckEventCard_vue__ = __webpack_require__(628);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca6cafa6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckEventCard_vue__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1003)
  __webpack_require__(1004)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ca6cafa6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckEventCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca6cafa6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckEventCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca6cafa6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckEventCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1003 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"modern-card event-card mb-3",class:_vm.cardClass,attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"modern-card-body"},[(_vm.content.is_deleted || _vm.localDeleted)?_c('div',{staticClass:"tombstone"},[_c('i',{staticClass:"fa fa-trash mr-2"}),_vm._v(" "),(_vm.content.is_deleted)?_c('span',[_vm._v("\n        Esta publicación fue eliminada por "),_c('strong',[_vm._v(_vm._s(_vm.content.deleted_by_name))])]):_c('span',[_vm._v("Esta publicación fue eliminada")])]):[_c('div',{staticClass:"card-header-row mb-3"},[_c('div',{staticClass:"post-meta"},[_c('b-avatar',{staticClass:"mr-3",attrs:{"variant":_vm.content.isCheckIn ? 'success' : 'primary',"text":_vm.avatarText}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"post-author"},[_vm._v("\n              "+_vm._s(_vm.content.name)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"post-store"},[_vm._v("\n              "+_vm._s(_vm.content.retail_name_store_name || 'Tienda sin nombre')+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"post-date"},[_vm._v("\n              "+_vm._s(_vm.formattedDate)+"\n            ")])])],1),_vm._v(" "),_c('div',{staticClass:"event-right"},[_c('div',{staticClass:"event-right-header"},[_c('span',{staticClass:"event-badge",class:_vm.badgeClass},[_c('i',{staticClass:"mr-1",class:_vm.badgeIcon}),_vm._v("\n              "+_vm._s(_vm.badgeLabel)+"\n            ")]),_vm._v(" "),_c('feed-delete-button',{attrs:{"post-type":_vm.content.post_type,"store-name":_vm.content.retail_name_store_name,"deleting":_vm.deleting},on:{"delete":_vm.handleDelete}})],1),_vm._v(" "),(_vm.content.checked_in_at)?_c('div',{staticClass:"event-meta"},[_c('span',{staticClass:"event-meta-item"},[_c('i',{staticClass:"fa fa-clock-o mr-1"}),_vm._v("\n              Llegó "+_vm._s(_vm.checkedInTime)+"\n            ")]),_vm._v(" "),(_vm.content.visitDuration)?_c('span',{staticClass:"event-meta-item duration-badge"},[_c('i',{staticClass:"fa fa-hourglass-half mr-1"}),_vm._v("\n              "+_vm._s(_vm.content.visitDuration)+" en tienda\n            ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),(_vm.isMounted && _vm.content.hasCoordinates)?_c('div',{staticClass:"map-container"},[_c('GmapMap',{staticClass:"event-map",attrs:{"center":_vm.mapCenter,"zoom":15,"options":_vm.mapOptions}},[_c('GmapMarker',{attrs:{"position":_vm.mapCenter}})],1),_vm._v(" "),_c('button',{staticClass:"expand-map-btn",on:{"click":function($event){_vm.showFullscreen = true}}},[_c('i',{staticClass:"fa fa-expand"})])],1):(!_vm.content.hasCoordinates)?_c('div',{staticClass:"map-placeholder"},[_c('i',{staticClass:"fa fa-map-marker fa-lg mr-2"}),_vm._v(" "),_c('span',[_vm._v("Ubicación no disponible")])]):_vm._e()]],2),_vm._v(" "),_c('b-modal',{attrs:{"size":"xl","hide-footer":"","title":((_vm.content.name) + " · " + (_vm.content.retail_name_store_name || 'Tienda sin nombre')),"body-class":"p-0","modal-class":"map-fullscreen-modal"},model:{value:(_vm.showFullscreen),callback:function ($$v) {_vm.showFullscreen=$$v},expression:"showFullscreen"}},[(_vm.showFullscreen)?_c('GmapMap',{staticClass:"fullscreen-map",attrs:{"center":_vm.mapCenter,"zoom":15,"options":_vm.mapOptionsFullscreen}},[_c('GmapMarker',{attrs:{"position":_vm.mapCenter}})],1):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExportablePpt_vue__ = __webpack_require__(629);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_999df75a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExportablePpt_vue__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1007)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-999df75a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExportablePpt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_999df75a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExportablePpt_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_999df75a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExportablePpt_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1007 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"executor-float-slide"}},[(_vm.visible)?_c('div',{staticClass:"executor-float",on:{"click":function($event){return _vm.$emit('expand')}}},[_c('div',{staticClass:"executor-float-header"},[_c('span',{staticClass:"executor-float-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('span',{staticClass:"executor-float-pct"},[_vm._v(_vm._s(_vm.pct)+"%")])]),_vm._v(" "),_c('b-progress',{staticClass:"executor-float-bar",attrs:{"value":_vm.pct,"max":100,"animated":_vm.running,"variant":_vm.variant}}),_vm._v(" "),_c('div',{staticClass:"executor-float-footer"},[_c('span',{staticClass:"executor-float-hint"},[_vm._v("Clic para ver detalle")]),_vm._v(" "),_c('span',{staticClass:"executor-float-cancel",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('cancel')}}},[_vm._v("Cancelar")])])],1):_vm._e()])}
var staticRenderFns = []


/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('button',{staticClass:"executor-icon-btn",attrs:{"disabled":_vm.isRunning,"title":_vm.tooltip},on:{"click":function($event){$event.stopPropagation();return _vm.handleClick($event)}}},[(_vm.isRunning)?_c('b-spinner',{attrs:{"small":""}}):_c('i',{class:("fa " + _vm.icon)})],1),_vm._v(" "),_c('executor-progress-float',{attrs:{"visible":_vm.isRunning && !_vm.showModal,"title":_vm.floatTitle,"pct":_vm.overallPct,"running":_vm.isRunning},on:{"expand":function($event){_vm.showModal = true},"cancel":_vm.cancelRun}}),_vm._v(" "),_c('base-modal',{attrs:{"show":_vm.showModal,"title":"Progreso de ejecución","hide-header-close":false,"show-cancel":false,"show-confirm":false},on:{"update:show":function($event){_vm.showModal = $event},"hidden":_vm.handleModalHidden},scopedSlots:_vm._u([(!_vm.isRunning)?{key:"footer",fn:function(){return [_c('div',{staticClass:"w-100 text-center"},[_c('b-button',{staticClass:"action-btn",attrs:{"variant":"outline-secondary"},on:{"click":function($event){_vm.showModal = false}}},[_vm._v("\n          Cerrar\n        ")])],1)]},proxy:true}:{key:"footer",fn:function(){return [_c('span')]},proxy:true}],null,true)},[(_vm.status === 'pending')?_c('div',{staticClass:"executor-waiting"},[_c('b-spinner',{staticClass:"mr-2",attrs:{"small":"","variant":"secondary"}}),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("En cola, esperando turno...")])],1):(_vm.status === 'working' && _vm.stages.length === 0)?_c('div',{staticClass:"executor-waiting"},[_c('b-spinner',{staticClass:"mr-2",attrs:{"small":"","variant":"primary"}}),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("Iniciando...")])],1):_vm._e(),_vm._v(" "),(_vm.stages.length > 0)?_c('div',{staticClass:"executor-overall mb-4"},[_c('div',{staticClass:"executor-overall-header"},[_c('span',{staticClass:"executor-overall-label"},[_vm._v("Progreso general")]),_vm._v(" "),_c('span',{staticClass:"executor-overall-pct"},[_vm._v(_vm._s(_vm.overallPct)+"%")])]),_vm._v(" "),_c('b-progress',{staticClass:"executor-overall-bar",attrs:{"value":_vm.overallPct,"max":100,"animated":_vm.isRunning,"variant":"primary"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"executor-stages"},_vm._l((_vm.stages),function(stage){return _c('div',{key:stage.stage,staticClass:"executor-stage"},[_c('div',{staticClass:"stage-row"},[_c('span',{staticClass:"stage-icon-wrap"},[(_vm.isStageActive(stage))?_c('b-spinner',{attrs:{"small":"","variant":"primary"}}):_c('i',{class:_vm.stageIcon(stage)})],1),_vm._v(" "),_c('span',{staticClass:"stage-name"},[_vm._v(_vm._s(stage.stage_name))]),_vm._v(" "),(stage.start_ts)?_c('span',{staticClass:"stage-elapsed"},[_vm._v("\n            "+_vm._s(_vm.elapsed(stage))+"\n          ")]):_vm._e()]),_vm._v(" "),(_vm.isStageActive(stage))?_c('b-progress',{staticClass:"stage-progress",attrs:{"value":stage.pct,"max":100,"animated":"","variant":"primary"}}):_vm._e()],1)}),0),_vm._v(" "),(_vm.status === 'done')?_c('div',{staticClass:"executor-result executor-result--done mt-3"},[_c('div',{staticClass:"executor-result__header"},[_c('i',{staticClass:"fa fa-check-circle mr-2"}),_vm._v("\n        Completado. La descarga comenzó automáticamente.\n      ")]),_vm._v(" "),_c('div',{staticClass:"executor-countdown mt-2"},[_c('b-progress',{staticClass:"executor-countdown-bar",attrs:{"value":_vm.countdown,"max":10,"variant":"success"}}),_vm._v(" "),_c('span',{staticClass:"executor-countdown-text"},[_vm._v("Cerrando en "+_vm._s(_vm.countdown)+"s...")])],1)]):_vm._e(),_vm._v(" "),(_vm.status === 'error')?_c('div',{staticClass:"executor-result executor-result--error mt-3"},[_c('i',{staticClass:"fa fa-exclamation-triangle mr-2"}),_vm._v("\n      "+_vm._s(_vm.errorMessage)+"\n    ")]):_vm._e()])],1)}
var staticRenderFns = []


/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"ppt-btn",on:{"click":function($event){_vm.showDateRangeModal = true}}},[_c('i',{staticClass:"fa fa-file-powerpoint-o mr-2"}),_vm._v("\n    PPTX\n  ")]),_vm._v(" "),_c('BaseModal',{attrs:{"show":_vm.showDateRangeModal,"title":"Selecciona un Rango de Tiempo","confirm-text":"Generar","confirm-variant":"primary"},on:{"confirm":_vm.onDatesConfirmed,"update:show":function($event){_vm.showDateRangeModal = $event}}},[_c('div',{staticClass:"export-type-selector"},[_c('button',{class:['export-type-btn', _vm.exportType === 'pptx' ? 'active' : ''],attrs:{"type":"button"},on:{"click":function($event){_vm.exportType = 'pptx'}}},[_c('i',{staticClass:"fa fa-file-powerpoint-o mr-1"}),_vm._v("PPTX\n      ")]),_vm._v(" "),_c('button',{class:['export-type-btn', _vm.exportType === 'xlsx' ? 'active' : ''],attrs:{"type":"button"},on:{"click":function($event){_vm.exportType = 'xlsx'}}},[_c('i',{staticClass:"fa fa-file-excel-o mr-1"}),_vm._v("XLSX\n      ")])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Ordenar por:"}},[_c('b-form-select',{attrs:{"options":_vm.sortOrderOptions},model:{value:(_vm.selectedOrder),callback:function ($$v) {_vm.selectedOrder=$$v},expression:"selectedOrder"}})],1),_vm._v(" "),_c('div',{staticClass:"date-range-row"},[_c('div',{staticClass:"date-group"},[_c('div',{staticClass:"date-group-label"},[_vm._v("\n          Desde\n        ")]),_vm._v(" "),_c('div',{staticClass:"date-inputs-group"},[_c('div',{staticClass:"input-group-item"},[_c('label',{staticClass:"input-label",attrs:{"for":"from-year"}},[_vm._v("Año")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fromYear),expression:"fromYear"}],staticClass:"modern-select date-input",attrs:{"id":"from-year"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.fromYear=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.years),function(y){return _c('option',{key:y,domProps:{"value":y}},[_vm._v("\n                "+_vm._s(y)+"\n              ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"input-group-item"},[_c('label',{staticClass:"input-label",attrs:{"for":"from-month"}},[_vm._v("Mes")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fromMonth),expression:"fromMonth"}],staticClass:"modern-select date-input",attrs:{"id":"from-month"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.fromMonth=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.months),function(m){return _c('option',{key:m.value,domProps:{"value":m.value}},[_vm._v("\n                "+_vm._s(m.label)+"\n              ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"input-group-item"},[_c('label',{staticClass:"input-label",attrs:{"for":"from-day"}},[_vm._v("Día")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fromDay),expression:"fromDay"}],staticClass:"modern-select date-input",attrs:{"id":"from-day"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.fromDay=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.fromDaysInMonth),function(d){return _c('option',{key:d,domProps:{"value":d}},[_vm._v("\n                "+_vm._s(d)+"\n              ")])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"date-range-sep"},[_c('i',{staticClass:"fa fa-long-arrow-right"})]),_vm._v(" "),_c('div',{staticClass:"date-group"},[_c('div',{staticClass:"date-group-label"},[_vm._v("\n          Hasta\n        ")]),_vm._v(" "),_c('div',{staticClass:"date-inputs-group"},[_c('div',{staticClass:"input-group-item"},[_c('label',{staticClass:"input-label",attrs:{"for":"to-year"}},[_vm._v("Año")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.toYear),expression:"toYear"}],staticClass:"modern-select date-input",attrs:{"id":"to-year"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.toYear=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.years),function(y){return _c('option',{key:y,domProps:{"value":y}},[_vm._v("\n                "+_vm._s(y)+"\n              ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"input-group-item"},[_c('label',{staticClass:"input-label",attrs:{"for":"to-month"}},[_vm._v("Mes")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.toMonth),expression:"toMonth"}],staticClass:"modern-select date-input",attrs:{"id":"to-month"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.toMonth=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.months),function(m){return _c('option',{key:m.value,domProps:{"value":m.value}},[_vm._v("\n                "+_vm._s(m.label)+"\n              ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"input-group-item"},[_c('label',{staticClass:"input-label",attrs:{"for":"to-day"}},[_vm._v("Día")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.toDay),expression:"toDay"}],staticClass:"modern-select date-input",attrs:{"id":"to-day"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.toDay=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.toDaysInMonth),function(d){return _c('option',{key:d,domProps:{"value":d}},[_vm._v("\n                "+_vm._s(d)+"\n              ")])}),0)])])])]),_vm._v(" "),(_vm.dateError)?_c('div',{staticClass:"date-error"},[_c('i',{staticClass:"fa fa-exclamation-circle mr-1"}),_vm._v(_vm._s(_vm.dateError)+"\n    ")]):_vm._e()],1),_vm._v(" "),_c('executor-run-button',{ref:"executorBtn",staticClass:"d-none",attrs:{"executor-name":"NEWS_FEED_PPTX_DOWNLOAD","request-payload":_vm.pptPayload,"icon":"fa-file-powerpoint-o","tooltip":"Generar PPTX"}}),_vm._v(" "),_c('executor-run-button',{ref:"executorXlsxBtn",staticClass:"d-none",attrs:{"executor-name":"NEWS_FEED_XLSX_DOWNLOAD","request-payload":_vm.pptPayload,"icon":"fa-file-excel-o","tooltip":"Generar XLSX"}})],1)}
var staticRenderFns = []


/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FieldInsightsPanel_vue__ = __webpack_require__(632);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6abc2492_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FieldInsightsPanel_vue__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1014)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6abc2492"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FieldInsightsPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6abc2492_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FieldInsightsPanel_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6abc2492_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FieldInsightsPanel_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1014 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useFieldInsights;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_composition_api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mockFieldUserInsights__ = __webpack_require__(1016);





function useFieldInsights() {
  var users = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])([]);
  var selectedUserId = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(null);
  var loadingUsers = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(false);
  var errorUsers = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["n" /* ref */])(null);
  var selectedUser = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
    var _users$value$find;
    return (_users$value$find = users.value.find(function (u) {
      return u.id === selectedUserId.value;
    })) !== null && _users$value$find !== void 0 ? _users$value$find : null;
  });
  var selectedInsights = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
    if (selectedUserId.value == null) return null;
    return Object(__WEBPACK_IMPORTED_MODULE_4__utils_mockFieldUserInsights__["a" /* buildMockFieldUserInsights */])(selectedUserId.value);
  });
  function fetchUsers() {
    return _fetchUsers.apply(this, arguments);
  }
  function _fetchUsers() {
    _fetchUsers = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
      var _data$created_by_coun, data, _t;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            loadingUsers.value = true;
            errorUsers.value = null;
            _context.prev = 1;
            _context.next = 2;
            return Object(__WEBPACK_IMPORTED_MODULE_3__Services__["t" /* newsFeedMetrics */])();
          case 2:
            data = _context.sent;
            users.value = ((_data$created_by_coun = data.created_by_count) !== null && _data$created_by_coun !== void 0 ? _data$created_by_coun : []).map(function (item) {
              return {
                id: item.created_by,
                name: item.concat,
                occurrences: item.occurrences
              };
            });
            _context.next = 4;
            break;
          case 3:
            _context.prev = 3;
            _t = _context["catch"](1);
            errorUsers.value = _t.message;
          case 4:
            _context.prev = 4;
            loadingUsers.value = false;
            return _context.finish(4);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 3, 4, 5]]);
    }));
    return _fetchUsers.apply(this, arguments);
  }
  function selectUser(userId) {
    selectedUserId.value = userId;
  }
  function clearSelection() {
    selectedUserId.value = null;
  }
  return {
    users: users,
    selectedUserId: selectedUserId,
    selectedUser: selectedUser,
    selectedInsights: selectedInsights,
    loadingUsers: loadingUsers,
    errorUsers: errorUsers,
    fetchUsers: fetchUsers,
    selectUser: selectUser,
    clearSelection: clearSelection
  };
}

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildMockFieldUserInsights;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Datos simulados determinísticos por userId (solo UI hasta tener API).
 */
var CHAINS = ['Falabella', 'Lider', 'Jumbo', 'Tottus', 'SISA', 'Unimarc', 'Cencosud', 'SMU'];
function prng(seed) {
  var s = Math.abs(seed) % 2147483646 || 1;
  return function () {
    s = s * 16807 % 2147483647;
    return (s - 1) / 2147483646;
  };
}
function formatStay(minutes) {
  if (minutes < 60) return "".concat(minutes, " min");
  var h = Math.floor(minutes / 60);
  var m = minutes % 60;
  return m > 0 ? "".concat(h, "h ").concat(m, "min") : "".concat(h, "h");
}
function storeName(rand, idx) {
  var chain = CHAINS[Math.floor(rand() * CHAINS.length)];
  var num = 1800 + Math.floor(rand() * 900) + idx * 17;
  return "".concat(chain, " - ").concat(num);
}

/** Coordenadas simuladas en zona Santiago (determinísticas). */
function storeLatLng(userId, dayOffset, storeIdx) {
  var s = (Number(userId) * 7919 + dayOffset * 13 + storeIdx * 17) % 2147483646 || 1;
  var n = function n() {
    s = s * 16807 % 2147483647;
    return (s - 1) / 2147483646;
  };
  return {
    latitude: -33.42 + n() * 0.12,
    longitude: -70.72 + n() * 0.1
  };
}
function buildMockFieldUserInsights(userId) {
  var r = prng(Number(userId) || 1);
  var monthlyGoal = 55 + Math.floor(r() * 50);
  var visitedThisMonth = Math.max(0, Math.min(monthlyGoal + 12, monthlyGoal - 15 + Math.floor(r() * 35)));
  var storesVisitedToday = 1 + Math.floor(r() * 6);
  var avgStoresPerDay = Math.round((25 + r() * 35) / 10) / 10 + 2;
  var avgStayMinutes = 28 + Math.floor(r() * 52);
  var countDay1 = 3 + Math.floor(r() * 4);
  var countDay2 = 2 + Math.floor(r() * 5);
  var storesDay1 = Array.from({
    length: countDay1
  }, function (_, i) {
    return _objectSpread({
      id: "".concat(userId, "-d1-").concat(i),
      name: storeName(r, i)
    }, storeLatLng(userId, 1, i));
  });
  var storesDay2 = Array.from({
    length: countDay2
  }, function (_, i) {
    return _objectSpread({
      id: "".concat(userId, "-d2-").concat(i),
      name: storeName(r, i + 10)
    }, storeLatLng(userId, 2, i));
  });
  return {
    monthlyGoal: monthlyGoal,
    visitedThisMonth: Math.max(0, visitedThisMonth),
    storesVisitedToday: storesVisitedToday,
    avgStoresPerDay: avgStoresPerDay,
    avgStayInStore: formatStay(avgStayMinutes),
    avgStayMinutes: avgStayMinutes,
    routes: [{
      offset: 1,
      stores: storesDay1
    }, {
      offset: 2,
      stores: storesDay2
    }]
  };
}

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-insights-panel"},[(!_vm.selectedUser)?[_vm._m(0),_vm._v(" "),(!_vm.loadingUsers && !_vm.errorUsers && _vm.users.length)?_c('div',{staticClass:"search-wrap"},[_c('i',{staticClass:"fa fa-search search-icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userSearchQuery),expression:"userSearchQuery"}],staticClass:"user-search-input",attrs:{"type":"search","placeholder":"Buscar usuario…","autocomplete":"off"},domProps:{"value":(_vm.userSearchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userSearchQuery=$event.target.value}}}),_vm._v(" "),(_vm.userSearchQuery)?_c('button',{staticClass:"search-clear",attrs:{"type":"button","aria-label":"Limpiar búsqueda"},on:{"click":function($event){_vm.userSearchQuery = ''}}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"panel-body"},[(_vm.loadingUsers)?_c('div',{staticClass:"user-list-skeleton"},_vm._l((6),function(i){return _c('div',{key:i,staticClass:"user-row-skeleton shimmer"})}),0):(_vm.errorUsers)?_c('div',{staticClass:"list-error"},[_c('i',{staticClass:"fa fa-exclamation-circle mr-1"}),_vm._v("\n        "+_vm._s(_vm.errorUsers)+"\n      ")]):(!_vm.users.length)?_c('div',{staticClass:"list-empty"},[_vm._v("\n        Sin actividad registrada\n      ")]):(!_vm.filteredUsers.length)?_c('div',{staticClass:"list-empty"},[_vm._v("\n        Ningún usuario coincide con la búsqueda\n      ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.filteredUsers),function(user){return _c('div',{key:user.id,staticClass:"user-row"},[_c('div',{staticClass:"user-avatar",style:(_vm.avatarStyle(user.name))},[_vm._v("\n          "+_vm._s(_vm.initials(user.name))+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"user-name"},[_vm._v(_vm._s(user.name))]),_vm._v(" "),_c('span',{staticClass:"user-count"},[_vm._v(_vm._s(user.occurrences))])])})],2)]:[_c('div',{staticClass:"panel-header detail-header"},[_c('button',{staticClass:"back-btn",attrs:{"type":"button","aria-label":"Volver a la lista"},on:{"click":_vm.clearSelection}},[_c('i',{staticClass:"fa fa-arrow-left"})]),_vm._v(" "),_c('div',{staticClass:"detail-header-text"},[_c('span',{staticClass:"panel-title"},[_vm._v(_vm._s(_vm.selectedUser.name))]),_vm._v(" "),_c('span',{staticClass:"panel-subtitle"},[_vm._v("Indicadores (demo)")])])]),_vm._v(" "),(_vm.selectedInsights)?_c('div',{staticClass:"detail-body"},[_c('section',{staticClass:"insight-section"},[_c('h4',{staticClass:"insight-section-title"},[_vm._v("\n          Meta del mes\n        ")]),_vm._v(" "),_c('div',{staticClass:"insight-hero"},[_vm._v("\n          "+_vm._s(_vm.selectedInsights.visitedThisMonth)+"\n          "),_c('span',{staticClass:"insight-hero-sep"},[_vm._v("/")]),_vm._v("\n          "+_vm._s(_vm.selectedInsights.monthlyGoal)+"\n          "),_c('span',{staticClass:"insight-hero-unit"},[_vm._v("tiendas")])]),_vm._v(" "),_c('div',{staticClass:"insight-progress-track"},[_c('div',{staticClass:"insight-progress-fill",class:_vm.monthProgressClass,style:({ width: _vm.monthProgressPct + '%' })})]),_vm._v(" "),_c('p',{staticClass:"insight-hint"},[_vm._v("\n          Mes en curso · objetivo de visitas\n        ")])]),_vm._v(" "),_c('section',{staticClass:"insight-grid"},[_c('div',{staticClass:"insight-tile"},[_c('i',{staticClass:"fa fa-map-marker tile-icon"}),_vm._v(" "),_c('div',{staticClass:"tile-value"},[_vm._v("\n            "+_vm._s(_vm.selectedInsights.storesVisitedToday)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"tile-label"},[_vm._v("\n            Visitadas hoy\n          ")])]),_vm._v(" "),_c('div',{staticClass:"insight-tile"},[_c('i',{staticClass:"fa fa-line-chart tile-icon"}),_vm._v(" "),_c('div',{staticClass:"tile-value"},[_vm._v("\n            "+_vm._s(_vm.selectedInsights.avgStoresPerDay)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"tile-label"},[_vm._v("\n            Promedio / día\n          ")])]),_vm._v(" "),_c('div',{staticClass:"insight-tile insight-tile--wide"},[_c('i',{staticClass:"fa fa-clock-o tile-icon"}),_vm._v(" "),_c('div',{staticClass:"tile-value"},[_vm._v("\n            "+_vm._s(_vm.selectedInsights.avgStayInStore)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"tile-label"},[_vm._v("\n            Permanencia promedio en tienda\n          ")])])]),_vm._v(" "),_c('section',{staticClass:"insight-section route-section"},[_c('h4',{staticClass:"insight-section-title"},[_vm._v("\n          Ruta sugerida\n        ")]),_vm._v(" "),_c('p',{staticClass:"route-intro"},[_vm._v("\n          Próximos 2 días\n        ")]),_vm._v(" "),_vm._l((_vm.routeDaysWithLabels),function(day,idx){return _c('div',{key:idx,staticClass:"route-day-card"},[_c('div',{staticClass:"route-day-title"},[_c('span',{staticClass:"route-day-title-text"},[_vm._v(_vm._s(day.label))]),_vm._v(" "),_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"route-map-btn",attrs:{"type":"button","title":"Ver ruta en mapa"},on:{"click":function($event){return _vm.openRouteMap(day)}}},[_c('i',{staticClass:"fa fa-map"})])]),_vm._v(" "),_c('ol',{staticClass:"route-store-list"},_vm._l((day.stores),function(store){return _c('li',{key:store.id,staticClass:"route-store-item"},[_vm._v("\n              "+_vm._s(store.name)+"\n            ")])}),0)])})],2)]):_vm._e()],_vm._v(" "),_c('BaseModal',{attrs:{"show":_vm.showRouteMapModal,"title":_vm.routeMapModalTitle,"size":"lg","show-confirm":false,"cancel-text":"Cerrar"},on:{"update:show":function($event){_vm.showRouteMapModal = $event}}},[_c('p',{staticClass:"route-map-caption mb-2"},[_vm._v("\n      Tiendas planificadas para este día\n    ")]),_vm._v(" "),(_vm.routeMapMounted && _vm.routeMapStores.length)?_c('div',{staticClass:"route-map-container"},[_c('GmapMap',{staticClass:"route-gmap",attrs:{"center":_vm.routeMapCenter,"zoom":_vm.routeMapZoom,"options":_vm.routeMapOptions}},_vm._l((_vm.routeMapStores),function(store){return _c('GmapMarker',{key:store.id,attrs:{"position":{ lat: store.latitude, lng: store.longitude },"title":store.name}})}),1)],1):(_vm.routeMapMounted && !_vm.routeMapStores.length)?_c('p',{staticClass:"text-center text-muted py-4 mb-0"},[_vm._v("\n      No hay tiendas para este día\n    ")]):_vm._e()])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-header"},[_c('span',{staticClass:"panel-title"},[_vm._v("Usuarios")]),_vm._v(" "),_c('span',{staticClass:"panel-subtitle"},[_vm._v("Últimos 45 días")])])}]


/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HashtagsDashboard_vue__ = __webpack_require__(633);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_918fd6ae_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HashtagsDashboard_vue__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1019)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-918fd6ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HashtagsDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_918fd6ae_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HashtagsDashboard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_918fd6ae_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HashtagsDashboard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1019 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HashtagDashboardItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HashtagDashboard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);


var HashtagDashboardItem = /*#__PURE__*/function () {
  function HashtagDashboardItem(raw) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, HashtagDashboardItem);
    this.id = raw.id;
    this.name = raw.name;
    this.label = raw.label || raw.name;
    this.color = raw.color || '#4299e1';
    this.totalOccurrences = raw.total_occurrences || 0;
    this.trend = raw.trend || [];
  }
  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(HashtagDashboardItem, [{
    key: "trendData",
    get: function get() {
      return this.trend.map(function (t) {
        return t.occurrences;
      });
    }
  }, {
    key: "trendCategories",
    get: function get() {
      return this.trend.map(function (t) {
        return t.day;
      });
    }
  }, {
    key: "hasTrend",
    get: function get() {
      return this.trend.length > 0;
    }
  }]);
}();
var HashtagDashboard = /*#__PURE__*/function () {
  function HashtagDashboard(raw) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, HashtagDashboard);
    this.startDate = raw.start_date;
    this.endDate = raw.end_date;
    this.hashtags = (raw.hashtags || []).map(function (h) {
      return new HashtagDashboardItem(h);
    });
  }
  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(HashtagDashboard, [{
    key: "hasData",
    get: function get() {
      return this.hashtags.some(function (h) {
        return h.totalOccurrences > 0;
      });
    }
  }, {
    key: "activeHashtags",
    get: function get() {
      return this.hashtags.filter(function (h) {
        return h.totalOccurrences > 0;
      });
    }
  }]);
}();


/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hashtags-dashboard"},[_c('div',{staticClass:"dashboard-header",on:{"click":_vm.toggleExpanded}},[_c('div',{staticClass:"header-left"},[_c('i',{staticClass:"fa fa-hashtag header-icon"}),_vm._v(" "),_c('span',{staticClass:"header-title"},[_vm._v("Actividad por hashtag")]),_vm._v(" "),(_vm.dashboard)?_c('span',{staticClass:"header-period"},[_vm._v("\n        "+_vm._s(_vm.formattedPeriod)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"header-right"},[(_vm.loading)?_c('b-spinner',{staticClass:"mr-2",attrs:{"small":"","variant":"secondary"}}):_vm._e(),_vm._v(" "),_c('i',{class:['fa', _vm.expanded ? 'fa-chevron-up' : 'fa-chevron-down', 'toggle-icon']})],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"slide"}},[(_vm.expanded)?_c('div',{staticClass:"dashboard-body"},[(_vm.loading)?[_c('div',{staticClass:"hashtag-scroll"},_vm._l((5),function(n){return _c('div',{key:n,staticClass:"hashtag-card-skeleton shimmer"})}),0)]:(!_vm.dashboard || _vm.dashboard.hashtags.length === 0)?_c('div',{staticClass:"empty-state"},[_c('i',{staticClass:"fa fa-hashtag mr-1"}),_vm._v("\n        Sin hashtags registrados en el período\n      ")]):_c('div',{staticClass:"hashtag-scroll"},_vm._l((_vm.dashboard.hashtags),function(hashtag){return _c('div',{key:hashtag.id,class:['hashtag-card', { 'is-selected': hashtag.id === _vm.selectedHashtagId }],style:({
            '--tag-color': hashtag.color,
            '--tag-bg': hashtag.color + '18',
            borderLeftColor: hashtag.color
          }),on:{"click":function($event){return _vm.selectHashtag(hashtag)}}},[_c('div',{staticClass:"card-top"},[_c('span',{staticClass:"card-count",style:({ color: hashtag.color })},[_vm._v(_vm._s(hashtag.totalOccurrences))]),_vm._v(" "),_c('span',{staticClass:"card-label"},[_vm._v("#"+_vm._s(hashtag.label))])]),_vm._v(" "),(hashtag.hasTrend)?_c('div',{staticClass:"card-chart"},[_c('apexchart',{attrs:{"type":"area","height":38,"options":_vm.getChartOptions(hashtag),"series":[{ name: hashtag.label, data: hashtag.trendData }]}})],1):_c('div',{staticClass:"card-no-trend"})])}),0)],2):_vm._e()])],1)}
var staticRenderFns = []


/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modern-container"},[_c('aside',{staticClass:"insights-aside"},[_c('field-insights-panel')],1),_vm._v(" "),_c('div',{staticClass:"feed-wrapper",class:{ 'feed-wrapper--row': _vm.viewMode === 'row' }},[_c('div',{staticClass:"page-header"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"header-search"},[_c('div',{staticClass:"search-input-wrapper"},[_c('i',{staticClass:"fa fa-search search-icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Buscar por caption, usuario, tienda o categoría..."},domProps:{"value":(_vm.searchQuery)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value},_vm.onSearch]}}),_vm._v(" "),(_vm.searchQuery)?_c('button',{staticClass:"search-clear",on:{"click":_vm.clearSearch}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"header-actions"},[_c('div',{staticClass:"view-toggle"},[_c('button',{class:['view-btn', { active: _vm.viewMode === 'list' }],attrs:{"title":"Vista lista"},on:{"click":function($event){_vm.viewMode = 'list'}}},[_c('i',{staticClass:"fa fa-list"})]),_vm._v(" "),_c('button',{class:['view-btn', { active: _vm.viewMode === 'row' }],attrs:{"title":"Vista fila"},on:{"click":function($event){_vm.viewMode = 'row'}}},[_c('i',{staticClass:"fa fa-th-list"})])]),_vm._v(" "),_c('exportable-ppt'),_vm._v(" "),_c('button',{staticClass:"hdr-btn hdr-btn--icon",attrs:{"disabled":_vm.loading},on:{"click":_vm.refreshList}},[_c('i',{staticClass:"fa fa-refresh",class:{'fa-spin': _vm.loading}})]),_vm._v(" "),_c('button',{staticClass:"hdr-btn hdr-btn--primary",on:{"click":_vm.goToUpload}},[_c('i',{staticClass:"fa fa-upload mr-1"}),_vm._v("\n          Subir\n        ")])],1)]),_vm._v(" "),_c('hashtags-dashboard',{attrs:{"selected-hashtag-id":_vm.activeHashtag ? _vm.activeHashtag.id : null,"refresh-trigger":_vm.dashboardRefreshKey},on:{"filter":_vm.onHashtagFilter}}),_vm._v(" "),_c('transition',{attrs:{"name":"chip-fade"}},[(_vm.activeHashtag)?_c('div',{staticClass:"filter-chip",style:({ '--chip-color': _vm.activeHashtag.color, '--chip-bg': _vm.activeHashtag.color + '18' })},[_c('span',{staticClass:"chip-dot",style:({ background: _vm.activeHashtag.color })}),_vm._v(" "),_c('span',{staticClass:"chip-text"},[_vm._v("\n          Filtrando por "),_c('strong',[_vm._v("#"+_vm._s(_vm.activeHashtag.label))])]),_vm._v(" "),_c('button',{staticClass:"chip-clear",on:{"click":_vm.clearHashtagFilter}},[_c('i',{staticClass:"fa fa-times"})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"feed-column"},[(_vm.loading && _vm.newsFeedList.length === 0)?_vm._l((3),function(n){return _c('div',{key:n,staticClass:"skeleton-card mb-2"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"skeleton-item shimmer"})])}):(_vm.newsFeedList.length > 0)?[_vm._l((_vm.newsFeedList),function(post){return _c(post.isCheckEvent ? 'check-event-card' : 'news-card',{key:post.id,tag:"component",staticClass:"mb-2",attrs:{"content":post,"view-mode":_vm.viewMode},on:{"deleted":_vm.onPostDeleted,"check-in-deleted":_vm.onCheckInDeleted,"hashtag-added":_vm.onHashtagAdded}})}),_vm._v(" "),_c('div',{ref:"sentinel"}),_vm._v(" "),(_vm.loadingMore)?_c('div',{staticClass:"loading-more"},[_c('b-spinner',{attrs:{"small":"","variant":"secondary"}})],1):_vm._e(),_vm._v(" "),(!_vm.hasMore && !_vm.loadingMore)?_c('p',{staticClass:"end-of-feed"},[_vm._v("\n          · · ·\n        ")]):_vm._e()]:_c('div',{staticClass:"empty-state"},[_c('i',{class:['fa', 'fa-2x', 'mb-2', _vm.activeHashtag ? 'fa-hashtag' : 'fa-image']}),_vm._v(" "),_c('p',{staticClass:"empty-title"},[_vm._v("\n          Sin publicaciones\n        ")]),_vm._v(" "),_c('p',{staticClass:"empty-subtitle"},[_vm._v("\n          "+_vm._s(_vm.activeHashtag
            ? ("No hay publicaciones con #" + (_vm.activeHashtag.label) + " en el período seleccionado.")
            : 'El equipo en ruta aún no ha realizado publicaciones.')+"\n        ")]),_vm._v(" "),(_vm.activeHashtag)?_c('button',{staticClass:"empty-clear-btn",on:{"click":_vm.clearHashtagFilter}},[_c('i',{staticClass:"fa fa-times mr-1"}),_vm._v("\n          Quitar filtro\n        ")]):_vm._e()])],2)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-content"},[_c('h2',{staticClass:"page-title"},[_vm._v("\n          Publicaciones en ruta\n        ")]),_vm._v(" "),_c('p',{staticClass:"page-subtitle"},[_vm._v("\n          Publicaciones del equipo en terreno\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('div',{staticClass:"skeleton-avatar shimmer mr-2"}),_vm._v(" "),_c('div',[_c('div',{staticClass:"skeleton-text medium shimmer mb-1"}),_vm._v(" "),_c('div',{staticClass:"skeleton-text short shimmer"})])])}]


/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadImagesFeed_vue__ = __webpack_require__(634);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_975e3dba_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadImagesFeed_vue__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1027)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-975e3dba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadImagesFeed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_975e3dba_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadImagesFeed_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_975e3dba_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadImagesFeed_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1027 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav',{staticClass:"p-0 my-0"},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"py-0 font-weight-bold",attrs:{"cols":"auto"}},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('b-col',{staticClass:"px-0",attrs:{"cols":"auto"}},[_c('i',{staticClass:"fa fa-custom-x fa-info-circle text-info",attrs:{"id":"popover-header-info"}}),_vm._v(" "),_c('b-popover',{attrs:{"target":"popover-header-info","placement":_vm.popOverPlacement,"title":_vm.title,"triggers":"hover focus"}},[_vm._t("default")],2)],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadImages_vue__ = __webpack_require__(636);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1415ba06_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadImages_vue__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1031)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1415ba06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadImages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1415ba06_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadImages_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1415ba06_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadImages_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1031 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-images-container"},[_c('b-form',{staticClass:"modern-form"},[_c('b-form-group',{staticClass:"form-group-modern",attrs:{"label":"Comentario","label-for":"caption-input"}},[_c('b-form-textarea',{staticClass:"modern-input",attrs:{"id":"caption-input","rows":4,"placeholder":"Escribe un comentario sobre las imágenes..."},model:{value:(_vm.caption),callback:function ($$v) {_vm.caption=$$v},expression:"caption"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"form-group-modern",attrs:{"label":"Imágenes","label-for":"images-input"}},[_c('div',{staticClass:"upload-area"},[_c('input',{ref:"fileInput",staticClass:"file-input",attrs:{"id":"images-input","type":"file","multiple":"","accept":"image/*"},on:{"change":_vm.handleFileSelect}}),_vm._v(" "),(_vm.images.length === 0)?_c('div',{staticClass:"upload-placeholder",on:{"click":_vm.triggerFileInput}},[_c('i',{staticClass:"fa fa-cloud-upload fa-3x mb-3"}),_vm._v(" "),_c('p',{staticClass:"upload-text"},[_vm._v("\n            Haz clic para seleccionar imágenes\n          ")]),_vm._v(" "),_c('p',{staticClass:"upload-hint"},[_vm._v("\n            Puedes seleccionar múltiples imágenes\n          ")])]):_c('div',{staticClass:"images-preview"},[_vm._l((_vm.images),function(image,index){return _c('div',{key:index,staticClass:"image-preview-item"},[_c('img',{staticClass:"preview-image",attrs:{"src":image.preview,"alt":"Preview"}}),_vm._v(" "),_c('button',{staticClass:"remove-image-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeImage(index)}}},[_c('i',{staticClass:"fa fa-times"})])])}),_vm._v(" "),_c('div',{staticClass:"add-more-btn",on:{"click":_vm.triggerFileInput}},[_c('i',{staticClass:"fa fa-plus fa-2x"}),_vm._v(" "),_c('p',[_vm._v("Agregar más")])])],2)])]),_vm._v(" "),(_vm.errorMessage)?_c('div',{staticClass:"error-message"},[_c('i',{staticClass:"fa fa-exclamation-circle mr-2"}),_vm._v("\n      "+_vm._s(_vm.errorMessage)+"\n    ")]):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoreSelector_vue__ = __webpack_require__(637);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eb5d8b4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoreSelector_vue__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1034)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2eb5d8b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoreSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eb5d8b4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoreSelector_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eb5d8b4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoreSelector_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1034 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{staticClass:"form-group-modern",attrs:{"label":_vm.label,"label-for":_vm.inputId}},[_c('multiselect',{staticClass:"modern-multiselect",attrs:{"id":_vm.inputId,"options":_vm.storeOptions,"searchable":true,"allow-empty":false,"show-labels":false,"placeholder":"Buscar tienda...","label":"name","track-by":"id"},on:{"input":_vm.handleStoreChange},model:{value:(_vm.selectedStore),callback:function ($$v) {_vm.selectedStore=$$v},expression:"selectedStore"}},[_c('template',{slot:"noResult"},[_c('span',[_vm._v("No se encontraron tiendas")])]),_vm._v(" "),_c('template',{slot:"noOptions"},[_c('span',[_vm._v("Cargando tiendas...")])])],2)],1)}
var staticRenderFns = []


/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategorySelector_vue__ = __webpack_require__(638);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc20880a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategorySelector_vue__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1037)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fc20880a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategorySelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc20880a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategorySelector_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc20880a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategorySelector_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1037 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{staticClass:"form-group-modern",attrs:{"label":_vm.label,"label-for":_vm.inputId}},[_c('multiselect',{staticClass:"modern-multiselect",attrs:{"id":_vm.inputId,"options":_vm.categoryOptions,"searchable":true,"allow-empty":false,"show-labels":false,"placeholder":"Buscar categoría...","label":"description","track-by":"id"},on:{"input":_vm.handleCategoryChange},model:{value:(_vm.selectedCategory),callback:function ($$v) {_vm.selectedCategory=$$v},expression:"selectedCategory"}},[_c('template',{slot:"noResult"},[_c('span',[_vm._v("No se encontraron categorías")])]),_vm._v(" "),_c('template',{slot:"noOptions"},[_c('span',[_vm._v("Cargando categorías...")])])],2)],1)}
var staticRenderFns = []


/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modern-container"},[_c('PageHeader',{staticClass:"mb-4",attrs:{"title":"Subir imágenes al feed"}}),_vm._v(" "),_c('b-card',{staticClass:"modern-card",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"modern-card-body"},[_c('b-form',{staticClass:"modern-form"},[(!_vm.storeIdFromRoute)?_c('store-selector',{attrs:{"label":"Tienda:","input-id":"store-selector"},model:{value:(_vm.storeId),callback:function ($$v) {_vm.storeId=$$v},expression:"storeId"}}):_vm._e(),_vm._v(" "),(!_vm.categoryIdFromRoute)?_c('category-selector',{attrs:{"label":"ID de Categoría:","input-id":"category-selector"},model:{value:(_vm.categoryId),callback:function ($$v) {_vm.categoryId=$$v},expression:"categoryId"}}):_vm._e()],1),_vm._v(" "),_c('upload-images',{model:{value:(_vm.uploadData),callback:function ($$v) {_vm.uploadData=$$v},expression:"uploadData"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"action-buttons"},[_c('b-button',{staticClass:"modern-btn",attrs:{"variant":"outline-secondary"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"fa fa-arrow-left mr-2"}),_vm._v("\n      Volver\n    ")]),_vm._v(" "),_c('b-button',{staticClass:"modern-btn",attrs:{"variant":"primary","disabled":!_vm.canSubmit || _vm.processing},on:{"click":_vm.handleSubmit}},[(_vm.processing)?_c('b-spinner',{staticClass:"mr-2",attrs:{"small":""}}):_c('i',{staticClass:"fa fa-upload mr-2"}),_vm._v("\n      "+_vm._s(_vm.processing ? 'Subiendo...' : 'Subir imágenes')+"\n    ")],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExecutionFocusList_vue__ = __webpack_require__(639);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f77be24c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExecutionFocusList_vue__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1041)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f77be24c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExecutionFocusList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f77be24c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExecutionFocusList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f77be24c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExecutionFocusList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1041 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modern-container"},[_c('div',{staticClass:"page-header"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"header-actions"},[_c('b-button',{staticClass:"action-btn",attrs:{"variant":"outline-secondary"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"fa fa-arrow-left mr-2"}),_vm._v("\n        Volver\n      ")]),_vm._v(" "),_c('b-button',{staticClass:"action-btn",attrs:{"variant":"primary"},on:{"click":_vm.goToCreate}},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v("\n        Nueva Ejecución\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"filters-bar"},[_c('div',{staticClass:"filter-group"},[_c('label',{staticClass:"filter-label"},[_vm._v("Estado")]),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"filter-btn",class:{ active: _vm.filters.active === null },on:{"click":function($event){return _vm.setActiveFilter(null)}}},[_vm._v("\n          Todos\n        ")]),_vm._v(" "),_c('button',{staticClass:"filter-btn",class:{ active: _vm.filters.active === true },on:{"click":function($event){return _vm.setActiveFilter(true)}}},[_vm._v("\n          Activos\n        ")]),_vm._v(" "),_c('button',{staticClass:"filter-btn",class:{ active: _vm.filters.active === false },on:{"click":function($event){return _vm.setActiveFilter(false)}}},[_vm._v("\n          Inactivos\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"filter-group"},[_c('label',{staticClass:"filter-label"},[_vm._v("Desde")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.start_date),expression:"filters.start_date"}],staticClass:"filter-date",attrs:{"type":"date"},domProps:{"value":(_vm.filters.start_date)},on:{"change":_vm.load,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "start_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"filter-group"},[_c('label',{staticClass:"filter-label"},[_vm._v("Hasta")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.end_date),expression:"filters.end_date"}],staticClass:"filter-date",attrs:{"type":"date"},domProps:{"value":(_vm.filters.end_date)},on:{"change":_vm.load,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "end_date", $event.target.value)}}})]),_vm._v(" "),(_vm.hasActiveFilters)?_c('button',{staticClass:"clear-filters-btn",on:{"click":_vm.clearFilters}},[_c('i',{staticClass:"fa fa-times mr-1"}),_vm._v("\n      Limpiar filtros\n    ")]):_vm._e()]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"modern-card"},[_c('div',{staticClass:"skeleton-rows"},_vm._l((5),function(n){return _c('div',{key:n,staticClass:"skeleton-row"},[_c('div',{staticClass:"skeleton-text long shimmer"}),_vm._v(" "),_c('div',{staticClass:"skeleton-text medium shimmer"}),_vm._v(" "),_c('div',{staticClass:"skeleton-text short shimmer"}),_vm._v(" "),_c('div',{staticClass:"skeleton-text short shimmer"}),_vm._v(" "),_c('div',{staticClass:"skeleton-badge shimmer"})])}),0)]):_c('div',{staticClass:"modern-card"},[_c('b-table',{staticClass:"modern-table",attrs:{"items":_vm.items,"fields":_vm.fields,"thead-class":"modern-thead","tbody-class":"modern-tbody","responsive":"","show-empty":"","empty-text":"No hay ejecuciones que coincidan con los filtros."},scopedSlots:_vm._u([{key:"cell(active)",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"status-badge",class:item.active ? 'badge-active' : 'badge-inactive'},[_vm._v("\n          "+_vm._s(item.active ? 'Activa' : 'Inactiva')+"\n        ")])]}},{key:"cell(start_date)",fn:function(ref){
var item = ref.item;
return [_vm._v("\n        "+_vm._s(_vm.formatDate(item.start_date))+"\n      ")]}},{key:"cell(end_date)",fn:function(ref){
var item = ref.item;
return [_vm._v("\n        "+_vm._s(item.end_date ? _vm.formatDate(item.end_date) : '—')+"\n      ")]}},{key:"cell(actions)",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"table-actions"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"table-action-btn",attrs:{"title":"Ver resultados","size":"sm","variant":"outline-secondary"},on:{"click":function($event){return _vm.goToResults(item.id)}}},[_c('i',{staticClass:"fa fa-bar-chart"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"table-action-btn",attrs:{"title":"Eliminar definitivamente","size":"sm","variant":"outline-danger","disabled":_vm.actionBusy},on:{"click":function($event){return _vm.openDeleteModal(item)}}},[_c('i',{staticClass:"fa fa-trash"})])],1)]}}])})],1),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"error-alert"},[_c('i',{staticClass:"fa fa-exclamation-circle mr-2"}),_vm._v("\n    "+_vm._s(_vm.error)+"\n    "),_c('button',{staticClass:"retry-btn",on:{"click":_vm.load}},[_vm._v("\n      Reintentar\n    ")])]):_vm._e(),_vm._v(" "),_c('BaseModal',{attrs:{"show":_vm.showDeactivateModal,"title":"Desactivar ejecución","confirm-text":"Desactivar","confirm-variant":"warning","processing":_vm.deactivating,"processing-text":"Desactivando..."},on:{"confirm":_vm.handleDeactivate,"update:show":function($event){_vm.showDeactivateModal = $event},"hidden":function($event){_vm.focusToDeactivate = null}}},[_c('p',{staticClass:"mb-0"},[_vm._v("\n      ¿Deseas desactivar\n      "),(_vm.focusToDeactivate)?_c('strong',[_vm._v("\n        "+_vm._s(_vm.focusToDeactivate.name)+"\n      ")]):[_vm._v("\n        esta ejecución\n      ")],_vm._v("\n      ?\n      Quedará como inactiva y podrás verla con el filtro «Inactivos».\n    ")],2)]),_vm._v(" "),_c('BaseModal',{attrs:{"show":_vm.showDeleteModal,"title":"Eliminar ejecución","confirm-text":"Eliminar","confirm-variant":"danger","processing":_vm.deleting,"processing-text":"Eliminando..."},on:{"confirm":_vm.handleDelete,"update:show":function($event){_vm.showDeleteModal = $event},"hidden":function($event){_vm.focusToDelete = null}}},[_c('p',{staticClass:"mb-0"},[_vm._v("\n      ¿Eliminar de forma permanente\n      "),(_vm.focusToDelete)?_c('strong',[_vm._v("\n        "+_vm._s(_vm.focusToDelete.name)+"\n      ")]):[_vm._v("\n        esta ejecución\n      ")],_vm._v("\n      ?\n      Esta acción no se puede deshacer.\n    ")],2)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-content"},[_c('h2',{staticClass:"page-title"},[_vm._v("\n        Ejecuciones en Tiendas\n      ")]),_vm._v(" "),_c('p',{staticClass:"page-subtitle"},[_vm._v("\n        Gestiona los focos de ejecución para el equipo de campo\n      ")])])}]


/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateExecutionFocus_vue__ = __webpack_require__(640);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb822202_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateExecutionFocus_vue__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1044)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cb822202"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateExecutionFocus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb822202_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateExecutionFocus_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb822202_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateExecutionFocus_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1044 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExecutionFocusRuleType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);


var ExecutionFocusRuleType = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function ExecutionFocusRuleType(raw) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ExecutionFocusRuleType);
  this.id = raw.id;
  this.name = raw.name;
  this.inputType = raw.input_type;
  this.description = raw.description || null;
});


/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ef-wrapper"},[_c('div',{staticClass:"ef-topbar"},[_c('button',{staticClass:"ef-back-btn",attrs:{"disabled":_vm.processing},on:{"click":_vm.goBack}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" "),_c('span',[_vm._v("Volver")])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"ef-stepper"},_vm._l((_vm.steps),function(step,i){return _c('div',{key:i,staticClass:"ef-step",class:{ active: _vm.currentStep === i, done: _vm.currentStep > i },on:{"click":function($event){_vm.currentStep > i && _vm.goToStep(i)}}},[_c('div',{staticClass:"ef-step-bubble"},[(_vm.currentStep > i)?_c('i',{staticClass:"fa fa-check"}):_c('span',[_vm._v(_vm._s(i + 1))])]),_vm._v(" "),_c('div',{staticClass:"ef-step-info"},[_c('span',{staticClass:"ef-step-num"},[_vm._v("Paso "+_vm._s(i + 1))]),_vm._v(" "),_c('span',{staticClass:"ef-step-label"},[_vm._v(_vm._s(step.label))])]),_vm._v(" "),(i < _vm.steps.length - 1)?_c('div',{staticClass:"ef-step-line",class:{ filled: _vm.currentStep > i }}):_vm._e()])}),0),_vm._v(" "),_c('div',{staticClass:"ef-card"},[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[(_vm.currentStep === 0)?_c('div',{key:"s0"},[_c('div',{staticClass:"ef-card-header"},[_c('div',{staticClass:"ef-card-icon",staticStyle:{"background":"#ebf8ff","color":"#3182ce"}},[_c('i',{staticClass:"fa fa-info-circle"})]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"ef-card-title"},[_vm._v("\n              Información General\n            ")]),_vm._v(" "),_c('p',{staticClass:"ef-card-sub"},[_vm._v("\n              Define nombre, vigencia y estado de la ejecución\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"ef-card-body"},[_c('div',{staticClass:"ef-field"},[_c('label',{staticClass:"ef-label"},[_vm._v("Nombre "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"ef-input",class:{ 'ef-input--error': _vm.submitted0 && !_vm.form.name.trim() },attrs:{"placeholder":"Ej: Campaña verano 2026","type":"text"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}}),_vm._v(" "),(_vm.submitted0 && !_vm.form.name.trim())?_c('p',{staticClass:"ef-error"},[_vm._v("\n              El nombre es obligatorio\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"ef-field"},[_c('label',{staticClass:"ef-label"},[_vm._v("Descripción "),_c('span',{staticClass:"ef-optional"},[_vm._v("(opcional)")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description),expression:"form.description"}],staticClass:"ef-input ef-textarea",attrs:{"placeholder":"Describe el objetivo de esta ejecución","rows":"3"},domProps:{"value":(_vm.form.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"ef-row"},[_c('div',{staticClass:"ef-field ef-field--half"},[_c('label',{staticClass:"ef-label"},[_vm._v("Fecha inicio "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.start_date),expression:"form.start_date"}],staticClass:"ef-input",class:{ 'ef-input--error': _vm.submitted0 && !_vm.form.start_date },attrs:{"type":"date"},domProps:{"value":(_vm.form.start_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "start_date", $event.target.value)}}}),_vm._v(" "),(_vm.submitted0 && !_vm.form.start_date)?_c('p',{staticClass:"ef-error"},[_vm._v("\n                La fecha de inicio es obligatoria\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"ef-field ef-field--half"},[_c('label',{staticClass:"ef-label"},[_vm._v("Fecha fin "),_c('span',{staticClass:"ef-optional"},[_vm._v("(opcional)")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.end_date),expression:"form.end_date"}],staticClass:"ef-input",class:{ 'ef-input--error': _vm.endDateError },attrs:{"type":"date","min":_vm.form.start_date || undefined},domProps:{"value":(_vm.form.end_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "end_date", $event.target.value)}}}),_vm._v(" "),(_vm.endDateError)?_c('p',{staticClass:"ef-error"},[_vm._v("\n                Debe ser posterior a la fecha de inicio\n              ")]):_vm._e()])])])]):(_vm.currentStep === 1)?_c('div',{key:"s1"},[_c('div',{staticClass:"ef-card-header"},[_c('div',{staticClass:"ef-card-icon",staticStyle:{"background":"#f0fff4","color":"#276749"}},[_c('i',{staticClass:"fa fa-store"})]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"ef-card-title"},[_vm._v("\n              Tiendas\n            ")]),_vm._v(" "),_c('p',{staticClass:"ef-card-sub"},[_vm._v("\n              Agrega las tiendas donde se aplicará esta ejecución "),_c('span',{staticClass:"ef-optional"},[_vm._v("(opcional)")])])])]),_vm._v(" "),_c('div',{staticClass:"ef-card-body"},[_c('div',{staticClass:"ef-store-row"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.storeIdInput),expression:"storeIdInput",modifiers:{"number":true}}],staticClass:"ef-input ef-store-input",attrs:{"type":"number","placeholder":"ID de tienda"},domProps:{"value":(_vm.storeIdInput)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.addStoreId($event)},"input":function($event){if($event.target.composing){ return; }_vm.storeIdInput=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('button',{staticClass:"ef-add-btn",attrs:{"disabled":!_vm.storeIdInput},on:{"click":_vm.addStoreId}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n              Agregar\n            ")])]),_vm._v(" "),(_vm.storeDuplicateError)?_c('p',{staticClass:"ef-error"},[_vm._v("\n            Esa tienda ya está en la lista\n          ")]):_vm._e(),_vm._v(" "),(_vm.form.store_ids.length)?_c('div',{staticClass:"ef-tags"},_vm._l((_vm.form.store_ids),function(id){return _c('span',{key:id,staticClass:"ef-tag"},[_c('i',{staticClass:"fa fa-store ef-tag-icon"}),_vm._v("\n              "+_vm._s(id)+"\n              "),_c('button',{staticClass:"ef-tag-remove",on:{"click":function($event){return _vm.removeStoreId(id)}}},[_c('i',{staticClass:"fa fa-times"})])])}),0):_c('div',{staticClass:"ef-empty-state"},[_c('i',{staticClass:"fa fa-store ef-empty-icon"}),_vm._v(" "),_c('p',[_vm._v("Sin tiendas asignadas")]),_vm._v(" "),_c('span',[_vm._v("Si no agregas tiendas, aplica para todas")])])])]):(_vm.currentStep === 2)?_c('div',{key:"s2"},[_c('div',{staticClass:"ef-card-header"},[_c('div',{staticClass:"ef-card-icon",staticStyle:{"background":"#faf5ff","color":"#6b46c1"}},[_c('i',{staticClass:"fa fa-box"})]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"ef-card-title"},[_vm._v("\n              Productos & Reglas\n            ")]),_vm._v(" "),_c('p',{staticClass:"ef-card-sub"},[_vm._v("\n              Busca productos y define qué debe verificar el supervisor "),_c('span',{staticClass:"ef-optional"},[_vm._v("(opcional)")])])])]),_vm._v(" "),_c('div',{staticClass:"ef-card-body"},[_c('div',{staticClass:"ef-product-search"},[_c('i',{staticClass:"fa ef-search-icon",class:_vm.globalSearchLoading ? 'fa-circle-o-notch ef-search-icon--spin' : 'fa-search'}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.globalSearchQuery),expression:"globalSearchQuery"}],staticClass:"ef-input ef-search-input",class:{ 'ef-search-input--active': _vm.dropdownOpen && _vm.globalSearchQuery.length >= 2 },attrs:{"placeholder":"Buscar producto por nombre o SKU..."},domProps:{"value":(_vm.globalSearchQuery)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.globalSearchQuery=$event.target.value},_vm.onProductSearchInput],"blur":_vm.closeDropdownSoon}}),_vm._v(" "),(_vm.dropdownOpen && _vm.globalSearchQuery.length >= 2)?_c('div',{staticClass:"ef-dropdown"},[(_vm.globalSearchLoading)?_c('div',{staticClass:"ef-dropdown-loading"},[_c('div',{staticClass:"ef-skeleton-row"}),_vm._v(" "),_c('div',{staticClass:"ef-skeleton-row ef-skeleton-row--sm"}),_vm._v(" "),_c('div',{staticClass:"ef-skeleton-row"}),_vm._v(" "),_c('div',{staticClass:"ef-skeleton-row ef-skeleton-row--sm"})]):(!_vm.globalSearchResults.length)?_c('div',{staticClass:"ef-dropdown-empty"},[_c('i',{staticClass:"fa fa-search-minus"}),_vm._v("\n                Sin resultados para \""+_vm._s(_vm.globalSearchQuery)+"\"\n              ")]):_vm._l((_vm.globalSearchResults),function(prod){return _c('button',{key:prod.product_id,staticClass:"ef-dropdown-item",class:{ added: _vm.form.products.some(function (p) { return p.product_id === prod.product_id; }) },on:{"mousedown":function($event){$event.preventDefault();return _vm.addProduct(prod)}}},[_c('div',{staticClass:"ef-dropdown-name"},[_vm._v("\n                    "+_vm._s(prod.description || prod.business_key)+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"ef-dropdown-meta"},[_c('span',[_vm._v(_vm._s(prod.business_key))]),_vm._v(" "),_c('span',{staticClass:"ef-dot"},[_vm._v("·")]),_vm._v(" "),_c('span',[_vm._v("ID "+_vm._s(prod.product_id))]),_vm._v(" "),(_vm.form.products.some(function (p) { return p.product_id === prod.product_id; }))?_c('span',{staticClass:"ef-already-badge"},[_vm._v("Agregado")]):_vm._e()])])})],2):_vm._e()]),_vm._v(" "),(!_vm.form.products.length)?_c('div',{staticClass:"ef-empty-state"},[_c('i',{staticClass:"fa fa-box ef-empty-icon"}),_vm._v(" "),_c('p',[_vm._v("Sin productos asignados")]),_vm._v(" "),_c('span',[_vm._v("Busca y agrega productos usando el campo de arriba")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.form.products),function(product,pIdx){return _c('div',{key:product.product_id,staticClass:"ef-product"},[_c('div',{staticClass:"ef-product-head"},[_c('div',{staticClass:"ef-product-avatar"},[_c('i',{staticClass:"fa fa-box"})]),_vm._v(" "),_c('div',{staticClass:"ef-product-info"},[_c('span',{staticClass:"ef-product-name"},[_vm._v(_vm._s(product.product_name))]),_vm._v(" "),_c('span',{staticClass:"ef-product-id"},[_vm._v("ID "+_vm._s(product.product_id))])]),_vm._v(" "),_c('button',{staticClass:"ef-icon-btn ef-icon-btn--danger",attrs:{"title":"Quitar producto"},on:{"click":function($event){return _vm.removeProduct(pIdx)}}},[_c('i',{staticClass:"fa fa-trash"})])]),_vm._v(" "),_c('div',{staticClass:"ef-rules"},[_c('div',{staticClass:"ef-rules-title"},[_c('span',[_vm._v("Reglas de verificación")]),_vm._v(" "),_c('button',{staticClass:"ef-ghost-btn",on:{"click":function($event){return _vm.addRule(pIdx)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                  Agregar regla\n                ")])]),_vm._v(" "),(!product.rules.length)?_c('div',{staticClass:"ef-rules-empty"},[_vm._v("\n                Sin reglas definidas — la ejecución sólo registrará la visita\n              ")]):_vm._e(),_vm._v(" "),_vm._l((product.rules),function(rule,rIdx){return _c('div',{key:rIdx,staticClass:"ef-rule"},[_c('div',{staticClass:"ef-rule-head"},[_c('span',{staticClass:"ef-rule-num"},[_vm._v("Regla "+_vm._s(rIdx + 1))]),_vm._v(" "),_c('button',{staticClass:"ef-icon-btn ef-icon-btn--ghost",on:{"click":function($event){return _vm.removeRule(pIdx, rIdx)}}},[_c('i',{staticClass:"fa fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"ef-rule-body"},[_c('div',{staticClass:"ef-field"},[_c('label',{staticClass:"ef-label"},[_vm._v("Tipo de verificación "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(rule.rule_type_id),expression:"rule.rule_type_id"}],staticClass:"ef-select",class:{ 'ef-input--error': _vm.submitted2 && !rule.rule_type_id },attrs:{"disabled":_vm.ruleTypesLoading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(rule, "rule_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.onRuleTypeChange(pIdx, rIdx)}]}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("\n                        "+_vm._s(_vm.ruleTypesLoading ? 'Cargando tipos...' : '-- Selecciona un tipo --')+"\n                      ")]),_vm._v(" "),_vm._l((_vm.ruleCodeOptions),function(opt){return _c('option',{key:opt.value,attrs:{"disabled":product.rules.filter(function (r, i) { return i !== rIdx; }).some(function (r) { return r.rule_type_id === opt.value; })},domProps:{"value":opt.value}},[_vm._v("\n                        "+_vm._s(opt.text)+"\n                      ")])})],2),_vm._v(" "),(_vm.submitted2 && !rule.rule_type_id)?_c('p',{staticClass:"ef-error"},[_vm._v("\n                      Selecciona un tipo\n                    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"ef-field"},[_c('label',{staticClass:"ef-label"},[_vm._v("Pregunta para el supervisor "),_c('span',{staticClass:"ef-optional"},[_vm._v("(opcional)")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(rule.question_label),expression:"rule.question_label"}],staticClass:"ef-input ef-textarea ef-textarea--sm",attrs:{"placeholder":"Ej: ¿El producto está en el exhibidor principal?","rows":"2","maxlength":"255"},domProps:{"value":(rule.question_label)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(rule, "question_label", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"ef-char-count"},[_vm._v(_vm._s(rule.question_label ? rule.question_label.length : 0)+"/255")])]),_vm._v(" "),_c('div',{staticClass:"ef-rule-checks"},[_c('label',{staticClass:"ef-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(rule.is_required),expression:"rule.is_required"}],staticClass:"ef-check",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(rule.is_required)?_vm._i(rule.is_required,null)>-1:(rule.is_required)},on:{"change":function($event){var $$a=rule.is_required,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(rule, "is_required", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(rule, "is_required", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(rule, "is_required", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Obligatoria")])]),_vm._v(" "),_c('label',{staticClass:"ef-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(rule.allow_comment),expression:"rule.allow_comment"}],staticClass:"ef-check",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(rule.allow_comment)?_vm._i(rule.allow_comment,null)>-1:(rule.allow_comment)},on:{"change":function($event){var $$a=rule.allow_comment,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(rule, "allow_comment", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(rule, "allow_comment", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(rule, "allow_comment", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Permitir comentario")])])])])])}),_vm._v(" "),(_vm.productDuplicateRuleError(pIdx))?_c('p',{staticClass:"ef-error mt-1"},[_c('i',{staticClass:"fa fa-exclamation-circle"}),_vm._v(" Hay reglas con tipo duplicado en este producto\n              ")]):_vm._e()],2)])}),_vm._v(" "),(_vm.productDuplicateIdError)?_c('p',{staticClass:"ef-error"},[_c('i',{staticClass:"fa fa-exclamation-circle"}),_vm._v(" Hay productos duplicados\n          ")]):_vm._e()],2)]):_c('div',{key:"s3"},[_c('div',{staticClass:"ef-card-header"},[_c('div',{staticClass:"ef-card-icon",staticStyle:{"background":"#fffaf0","color":"#c05621"}},[_c('i',{staticClass:"fa fa-clipboard-check"})]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"ef-card-title"},[_vm._v("\n              Revisión Final\n            ")]),_vm._v(" "),_c('p',{staticClass:"ef-card-sub"},[_vm._v("\n              Confirma los datos antes de crear la ejecución\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"ef-card-body"},[_c('div',{staticClass:"ef-review-section"},[_c('div',{staticClass:"ef-review-section-head",on:{"click":function($event){return _vm.goToStep(0)}}},[_c('span',[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" Información General")]),_vm._v(" "),_c('span',{staticClass:"ef-review-edit"},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Editar")])]),_vm._v(" "),_c('div',{staticClass:"ef-review-grid"},[_c('div',{staticClass:"ef-review-field"},[_c('span',{staticClass:"ef-review-key"},[_vm._v("Nombre")]),_vm._v(" "),_c('span',{staticClass:"ef-review-val"},[_vm._v(_vm._s(_vm.form.name))])]),_vm._v(" "),_c('div',{staticClass:"ef-review-field"},[_c('span',{staticClass:"ef-review-key"},[_vm._v("Fecha inicio")]),_vm._v(" "),_c('span',{staticClass:"ef-review-val"},[_vm._v(_vm._s(_vm.formatDate(_vm.form.start_date)))])]),_vm._v(" "),_c('div',{staticClass:"ef-review-field"},[_c('span',{staticClass:"ef-review-key"},[_vm._v("Fecha fin")]),_vm._v(" "),_c('span',{staticClass:"ef-review-val"},[_vm._v(_vm._s(_vm.form.end_date ? _vm.formatDate(_vm.form.end_date) : '—'))])]),_vm._v(" "),(_vm.form.description)?_c('div',{staticClass:"ef-review-field ef-review-field--full"},[_c('span',{staticClass:"ef-review-key"},[_vm._v("Descripción")]),_vm._v(" "),_c('span',{staticClass:"ef-review-val"},[_vm._v(_vm._s(_vm.form.description))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"ef-review-section"},[_c('div',{staticClass:"ef-review-section-head",on:{"click":function($event){return _vm.goToStep(1)}}},[_c('span',[_c('i',{staticClass:"fa fa-store"}),_vm._v(" Tiendas ("+_vm._s(_vm.form.store_ids.length)+")")]),_vm._v(" "),_c('span',{staticClass:"ef-review-edit"},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Editar")])]),_vm._v(" "),(_vm.form.store_ids.length)?_c('div',{staticClass:"ef-tags ef-tags--compact"},_vm._l((_vm.form.store_ids),function(id){return _c('span',{key:id,staticClass:"ef-tag"},[_vm._v(_vm._s(id))])}),0):_c('p',{staticClass:"ef-review-empty"},[_vm._v("\n              Sin tiendas — aplica para todas\n            ")])]),_vm._v(" "),_c('div',{staticClass:"ef-review-section"},[_c('div',{staticClass:"ef-review-section-head",on:{"click":function($event){return _vm.goToStep(2)}}},[_c('span',[_c('i',{staticClass:"fa fa-box"}),_vm._v(" Productos ("+_vm._s(_vm.form.products.length)+")")]),_vm._v(" "),_c('span',{staticClass:"ef-review-edit"},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Editar")])]),_vm._v(" "),(_vm.form.products.length)?_c('div',_vm._l((_vm.form.products),function(p){return _c('div',{key:p.product_id,staticClass:"ef-review-product"},[_c('div',{staticClass:"ef-review-product-name"},[_c('i',{staticClass:"fa fa-box",staticStyle:{"color":"#805ad5","margin-right":"6px"}}),_vm._v("\n                  "+_vm._s(p.product_name)+"\n                  "),_c('span',{staticClass:"ef-product-id"},[_vm._v("ID "+_vm._s(p.product_id))])]),_vm._v(" "),(p.rules.length)?_c('div',{staticClass:"ef-review-rules"},_vm._l((p.rules),function(r){return _c('span',{key:r.rule_type_id,staticClass:"ef-rule-chip"},[_vm._v("\n                    "+_vm._s(_vm.ruleLabel(r.rule_type_id))+"\n                    "),(r.is_required)?_c('span',{staticClass:"ef-rule-req"},[_vm._v("!")]):_vm._e()])}),0):_c('p',{staticClass:"ef-rules-empty"},[_vm._v("\n                  Sin reglas\n                ")])])}),0):_c('p',{staticClass:"ef-review-empty"},[_vm._v("\n              Sin productos asignados\n            ")])]),_vm._v(" "),_c('button',{staticClass:"ef-create-btn",attrs:{"disabled":_vm.processing},on:{"click":_vm.handleSubmit}},[(_vm.processing)?_c('b-spinner',{staticStyle:{"margin-right":"8px"},attrs:{"small":""}}):_c('i',{staticClass:"fa fa-rocket",staticStyle:{"margin-right":"8px"}}),_vm._v("\n            "+_vm._s(_vm.processing ? 'Creando ejecución...' : 'Crear Ejecución')+"\n          ")],1)])])])],1),_vm._v(" "),_c('div',{staticClass:"ef-nav"},[(_vm.currentStep > 0)?_c('button',{staticClass:"ef-nav-btn ef-nav-btn--secondary",on:{"click":_vm.prevStep}},[_c('i',{staticClass:"fa fa-chevron-left"}),_vm._v("\n      Anterior\n    ")]):_c('div'),_vm._v(" "),(_vm.currentStep < 3)?_c('button',{staticClass:"ef-nav-btn ef-nav-btn--primary",on:{"click":_vm.nextStep}},[_vm._v("\n      Siguiente\n      "),_c('i',{staticClass:"fa fa-chevron-right"})]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ef-topbar-title"},[_c('h2',[_vm._v("Nueva Ejecución en Tienda")]),_vm._v(" "),_c('p',[_vm._v("Define el foco para que los supervisores respondan desde la app")])])}]


/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExecutionFocusDashboard_vue__ = __webpack_require__(641);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_589bd5c8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExecutionFocusDashboard_vue__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1048)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-589bd5c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExecutionFocusDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_589bd5c8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExecutionFocusDashboard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_589bd5c8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExecutionFocusDashboard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1048 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExecutionFocusVisit; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);


var ExecutionFocusVisit = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function ExecutionFocusVisit(raw) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ExecutionFocusVisit);
  this.visitId = raw.visit_id;
  this.storeId = raw.store_id;
  this.storeName = raw.store_name;
  this.storeCode = raw.store_code;
  this.userId = raw.user_id;
  this.userName = raw.user_name;
  this.productId = raw.product_id;
  this.productName = raw.product_name;
  this.submittedAt = raw.submitted_at;
});


/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ExecutionFocusVisitRule */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExecutionFocusVisitDetail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);


var ExecutionFocusVisitRule = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function ExecutionFocusVisitRule(raw) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ExecutionFocusVisitRule);
  this.ruleTypeId = raw.rule_type_id;
  this.value = raw.value;
  this.comment = raw.comment;
  this.photoUrl = raw.photo_url;
});
var ExecutionFocusVisitDetail = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_createClass___default()(function ExecutionFocusVisitDetail(raw) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ExecutionFocusVisitDetail);
  this.visitId = raw.visit_id;
  this.executionFocusId = raw.execution_focus_id;
  this.storeId = raw.store_id;
  this.productId = raw.product_id;
  this.submittedAt = raw.submitted_at;
  this.rules = Array.isArray(raw.rules) ? raw.rules.map(function (r) {
    return new ExecutionFocusVisitRule(r);
  }) : [];
});


/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"efd-wrapper"},[_c('div',{staticClass:"efd-topbar"},[_c('button',{staticClass:"efd-back-btn",on:{"click":_vm.goBack}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" "),_c('span',[_vm._v("Volver")])]),_vm._v(" "),_c('div',{staticClass:"efd-topbar-title"},[_c('h2',[_vm._v(_vm._s(_vm.focusName || 'Resultados de Ejecución'))]),_vm._v(" "),_c('p',[_vm._v("Visitas registradas por el equipo de campo")])])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"efd-card"},[_c('div',{staticClass:"efd-skeleton-rows"},_vm._l((6),function(n){return _c('div',{key:n,staticClass:"efd-skeleton-row"},[_c('div',{staticClass:"efd-skel efd-skel--long shimmer"}),_vm._v(" "),_c('div',{staticClass:"efd-skel efd-skel--med shimmer"}),_vm._v(" "),_c('div',{staticClass:"efd-skel efd-skel--med shimmer"}),_vm._v(" "),_c('div',{staticClass:"efd-skel efd-skel--short shimmer"})])}),0)]):(_vm.error)?_c('div',{staticClass:"efd-error"},[_c('i',{staticClass:"fa fa-exclamation-circle"}),_vm._v("\n    "+_vm._s(_vm.error)+"\n    "),_c('button',{staticClass:"efd-retry-btn",on:{"click":_vm.load}},[_vm._v("\n      Reintentar\n    ")])]):_c('div',{staticClass:"efd-card"},[_c('b-table',{staticClass:"efd-table",attrs:{"items":_vm.visits,"fields":_vm.fields,"thead-class":"efd-thead","tbody-class":"efd-tbody","responsive":"","hover":"","show-empty":"","empty-text":"No hay visitas registradas para este foco."},on:{"row-clicked":_vm.openVisit},scopedSlots:_vm._u([{key:"cell(submitted_at)",fn:function(ref){
var item = ref.item;
return [_vm._v("\n        "+_vm._s(_vm.formatDatetime(item.submittedAt))+"\n      ")]}},{key:"cell(store)",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"efd-store-name"},[_vm._v(_vm._s(item.storeName))]),_vm._v(" "),(item.storeCode)?_c('span',{staticClass:"efd-store-code"},[_vm._v(_vm._s(item.storeCode))]):_vm._e()]}},{key:"cell(user)",fn:function(ref){
var item = ref.item;
return [_vm._v("\n        "+_vm._s(item.userName)+"\n      ")]}},{key:"cell(product)",fn:function(ref){
var item = ref.item;
return [_vm._v("\n        "+_vm._s(item.productName)+"\n      ")]}},{key:"cell(detail)",fn:function(){return [_c('span',{staticClass:"efd-detail-hint"},[_c('i',{staticClass:"fa fa-chevron-right"})])]},proxy:true}])})],1),_vm._v(" "),_c('transition',{attrs:{"name":"efd-slide"}},[(_vm.selectedVisit)?_c('div',{staticClass:"efd-panel-overlay",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.closePanel($event)}}},[_c('div',{staticClass:"efd-panel"},[_c('div',{staticClass:"efd-panel-header"},[_c('div',[_c('h3',{staticClass:"efd-panel-title"},[_vm._v("\n              Detalle de visita\n            ")]),_vm._v(" "),_c('p',{staticClass:"efd-panel-sub"},[_vm._v("\n              "+_vm._s(_vm.selectedVisit.productName)+" ·\n              "+_vm._s(_vm.selectedVisit.storeName)+" ·\n              "+_vm._s(_vm.formatDatetime(_vm.selectedVisit.submittedAt))+"\n            ")])]),_vm._v(" "),_c('button',{staticClass:"efd-panel-close",on:{"click":_vm.closePanel}},[_c('i',{staticClass:"fa fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"efd-panel-body"},[(_vm.detailLoading)?_c('div',{staticClass:"efd-detail-loading"},_vm._l((4),function(n){return _c('div',{key:n,staticClass:"efd-skel efd-skel--full shimmer",staticStyle:{"margin-bottom":"12px","height":"56px","border-radius":"8px"}})}),0):(_vm.detail)?[(!_vm.detail.rules.length)?_c('div',{staticClass:"efd-no-rules"},[_vm._v("\n              Sin respuestas registradas\n            ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.detail.rules),function(rule){return _c('div',{key:rule.ruleTypeId,staticClass:"efd-rule-row"},[_c('div',{staticClass:"efd-rule-info"},[_c('span',{staticClass:"efd-rule-name"},[_vm._v(_vm._s(_vm.ruleMeta(rule.ruleTypeId).name))]),_vm._v(" "),_c('span',{staticClass:"efd-rule-type-badge"},[_vm._v(_vm._s(_vm.ruleMeta(rule.ruleTypeId).inputType))])]),_vm._v(" "),(_vm.ruleMeta(rule.ruleTypeId).inputType === 'boolean')?[(rule.value === 'true')?_c('span',{staticClass:"efd-bool efd-bool--yes"},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Sí\n                ")]):(rule.value === 'false')?_c('span',{staticClass:"efd-bool efd-bool--no"},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" No\n                ")]):_c('span',{staticClass:"efd-null"},[_vm._v("—")])]:(_vm.ruleMeta(rule.ruleTypeId).inputType === 'photo')?[(rule.photoUrl !== null)?_c('div',{staticClass:"efd-photo-area"},[(_vm.photoUrls[rule.ruleTypeId])?_c('img',{staticClass:"efd-photo-img",attrs:{"src":_vm.photoUrls[rule.ruleTypeId],"alt":"foto"}}):_c('button',{staticClass:"efd-photo-btn",attrs:{"disabled":_vm.photoLoading[rule.ruleTypeId]},on:{"click":function($event){return _vm.loadPhoto(rule.ruleTypeId)}}},[_c('i',{staticClass:"fa",class:_vm.photoLoading[rule.ruleTypeId] ? 'fa-circle-o-notch fa-spin' : 'fa-camera'}),_vm._v("\n                    Ver foto\n                  ")])]):_c('span',{staticClass:"efd-null"},[_vm._v("Sin foto")])]:[(rule.value !== null && rule.value !== undefined)?_c('span',{staticClass:"efd-value"},[_vm._v(_vm._s(rule.value))]):_c('span',{staticClass:"efd-null"},[_vm._v("—")])],_vm._v(" "),(rule.comment)?_c('div',{staticClass:"efd-comment"},[_c('i',{staticClass:"fa fa-comment-o"}),_vm._v("\n                "+_vm._s(rule.comment)+"\n              ")]):_vm._e()],2)})]:_vm._e()],2)])]):_vm._e()])],1)}
var staticRenderFns = []


/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeneralKeyKpiAnalysis_vue__ = __webpack_require__(642);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54239a12_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeneralKeyKpiAnalysis_vue__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1053)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54239a12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeneralKeyKpiAnalysis_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54239a12_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeneralKeyKpiAnalysis_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54239a12_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeneralKeyKpiAnalysis_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1053 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridMetricSystemWideOneMetric_vue__ = __webpack_require__(643);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ae68320_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridMetricSystemWideOneMetric_vue__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1055)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ae68320"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridMetricSystemWideOneMetric_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ae68320_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridMetricSystemWideOneMetric_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ae68320_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridMetricSystemWideOneMetric_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1055 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('ag-grid-vue',{class:_vm.gridClass + ' animated fadeIn',style:(("width: 100%; height: " + _vm.gridHeight + "px")),attrs:{"gridOptions":_vm.gridOptions,"headerHeight":_vm.headerHeight,"frameworkComponents":_vm.gridOptions.frameworkComponents},on:{"gridReady":_vm.gridIsReady,"cellDoubleClicked":_vm.onCellDoubleClicked}})],1)])}
var staticRenderFns = []


/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DimensionFilterQuickAccess_vue__ = __webpack_require__(644);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e9152d3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DimensionFilterQuickAccess_vue__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DimensionFilterQuickAccess_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e9152d3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DimensionFilterQuickAccess_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e9152d3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DimensionFilterQuickAccess_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexFilter_vue__ = __webpack_require__(645);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b88a93e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexFilter_vue__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1066)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b88a93e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b88a93e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexFilter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b88a93e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexFilter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1066 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexFilterChip_vue__ = __webpack_require__(646);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cb29805_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexFilterChip_vue__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1068)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5cb29805"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexFilterChip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cb29805_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexFilterChip_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cb29805_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexFilterChip_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1068 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"index-chip pointer mt-1",class:_vm.id === _vm.vuexSelectedIndexItem ? _vm.dynClass : '',attrs:{"id":_vm.id.toString()}},[_c('div',[_c('div',{staticClass:"text-center index-chip-left"},[_vm._v(_vm._s(_vm.description))]),_vm._v(" "),_c('div',{staticClass:"text-center index-chip-right"},[_vm._v("\n        "+_vm._s(_vm._f("numberAbb")(_vm.metric))+"\n      ")]),_vm._v(" "),_c('b-tooltip',{attrs:{"target":_vm.id.toString(),"triggers":"hover"}},[_c('h6',[_vm._v(_vm._s(_vm.tooltipMsg))])])],1)])])}
var staticRenderFns = []


/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('b-container',{staticClass:"p-2",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('b-container',{staticClass:"m-0 p-0",attrs:{"fluid":""}},[_c('b-row',_vm._l((_vm.filterList),function(item){return _c('b-col',{key:item.metricName,attrs:{"cols":"auto"},on:{"click":function($event){return _vm.commitSelectedItem(item.metadata, item)}}},[_c('IndexFilterChip',{attrs:{"id":item.id,"description":item.description,"metric":item.metric,"metric-name":item.metricName,"selectedItem":_vm.selectedItem}})],1)}),1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []


/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"b-toggle",rawName:"v-b-toggle.dim-filter-index-collapse",modifiers:{"dim-filter-index-collapse":true}}],staticClass:"m-1 ml-2 index-chip pointer bg-primary",attrs:{"id":"dim-filter-collapse"}},[_c('div',{staticClass:"text-center index-chip-left"},[_vm._v(_vm._s(_vm.indexDescription))]),_vm._v(" "),_c('div',{staticClass:"text-center index-chip-right"},[_vm._v("\n      "+_vm._s(_vm._f("numberAbb")(_vm.indexMetric))+"\n    ")])]),_vm._v(" "),_c('b-tooltip',{attrs:{"target":"dim-filter-collapse","triggers":"hover"}},[_c('h6',[_vm._v(" "+_vm._s(_vm.tooltipMsg))])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"dim-filter-index-collapse"}},[_c('IndexFilter',{attrs:{"filter-list":_vm.dimensionFilterData}})],1)],1)}
var staticRenderFns = []


/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RetailListSelector_vue__ = __webpack_require__(647);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfb7324e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RetailListSelector_vue__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RetailListSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfb7324e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RetailListSelector_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfb7324e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RetailListSelector_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductWmRetailList_vue__ = __webpack_require__(648);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6393713c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductWmRetailList_vue__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1074)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6393713c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductWmRetailList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6393713c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductWmRetailList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6393713c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductWmRetailList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1074 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.style)},[_c('b-card',{staticClass:"border-0",attrs:{"no-body":""}},[_c('b-list-group',_vm._l((_vm.listData),function(item){return _c('b-list-group-item',{key:item.retail_id,staticClass:"pointer",attrs:{"list-group-item-action":"","active":item.retail_id === _vm.activeListItem},on:{"click":function($event){return _vm.getIdFilter(item.retail_id)}}},[_c('strong',[_vm._v(_vm._s(item.retail_name))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h6',[_vm._v("Productos sin movimiento "+_vm._s(item.product_count))])])}),1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockBreakRetailList_vue__ = __webpack_require__(649);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d315e6ea_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockBreakRetailList_vue__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockBreakRetailList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d315e6ea_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockBreakRetailList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d315e6ea_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockBreakRetailList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.style)},[_c('b-card',{staticClass:"border-0",attrs:{"no-body":""}},[_c('b-list-group',_vm._l((_vm.listData),function(item){return _c('b-list-group-item',{key:item.retail_id,staticClass:"pointer",attrs:{"list-group-item-action":"","active":item.retail_id === _vm.activeListItem},on:{"click":function($event){return _vm.getIdFilter(item.retail_id)}}},[_c('strong',[_vm._v(_vm._s(item.retail_name))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h6',[_vm._v("Productos con quiebre "+_vm._s(item.stock_break_status))])])}),1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceAuditionRetailList_vue__ = __webpack_require__(650);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24e1538b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceAuditionRetailList_vue__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1079)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24e1538b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceAuditionRetailList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24e1538b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceAuditionRetailList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24e1538b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceAuditionRetailList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1079 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.style)},[_c('b-card',{staticClass:"border-0",attrs:{"no-body":""}},[_c('b-list-group',_vm._l((_vm.listData),function(item){return _c('b-list-group-item',{key:item.retail_id,staticClass:"pointer",attrs:{"list-group-item-action":"","active":item.retail_id === _vm.activeListItem},on:{"click":function($event){return _vm.getIdFilter(item.retail_id)}}},[_c('strong',[_vm._v(_vm._s(item.retail_name))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h6',[_vm._v("Precios no respetados "+_vm._s(item.not_ok_vs_b2b))])])}),1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.retailListComponent,{tag:"component",attrs:{"active-item":_vm.vuexSelectedRetail,"list-data":_vm.vuexRetailListData}})],1)}
var staticRenderFns = []


/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductWmHeader_vue__ = __webpack_require__(651);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11689975_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductWmHeader_vue__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1083)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11689975"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductWmHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11689975_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductWmHeader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11689975_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductWmHeader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1083 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"float-left"},[_c('h4',{staticClass:"mb-1"},[_vm._v("Productos sin Movimiento")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.headerInfo))])]),_vm._v(" "),_c('div',{staticClass:"float-right"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.filter-pane-collapse",modifiers:{"filter-pane-collapse":true}}],staticClass:"mt-2",attrs:{"variant":"info"}},[_vm._v("Buscar")])],1)])}
var staticRenderFns = []


/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceAuditionHeader_vue__ = __webpack_require__(652);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab85e3c8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceAuditionHeader_vue__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1086)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ab85e3c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceAuditionHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab85e3c8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceAuditionHeader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab85e3c8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceAuditionHeader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1086 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"mb-1"},[_vm._v("Productos sin Movimiento")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.headerInfo))])])}
var staticRenderFns = []


/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterPane_vue__ = __webpack_require__(653);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df2c1560_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterPane_vue__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1089)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-df2c1560"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterPane_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df2c1560_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterPane_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df2c1560_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterPane_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1089 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterSelectorLogic_vue__ = __webpack_require__(654);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f79c8e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterSelectorLogic_vue__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1091)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17f79c8e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterSelectorLogic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f79c8e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterSelectorLogic_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f79c8e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterSelectorLogic_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1091 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.filterTypeName))]),_vm._v(" "),_vm._l((_vm.filtersRenderObject),function(classItem){return _c('div',{key:classItem.class,staticClass:"mt-2 align-content-center"},[_c('h6',{staticStyle:{"border-bottom":"1px solid #251e63"}},[_vm._v(_vm._s(classItem.class))]),_vm._v(" "),_c('b-container',{staticClass:"m-0"},[_c('b-row',_vm._l((classItem.levelList),function(selectItem){return _c('b-col',{key:selectItem.description,ref:selectItem.id,refInFor:true,attrs:{"cols":"auto"}},[_c('MultiSelect',{staticStyle:{"margin-top":"3px"},attrs:{"options":selectItem.options,"multiple":true,"close-on-select":true,"clear-on-select":false,"preserve-search":false,"placeholder":selectItem.description,"label":"name","track-by":"name","maxHeight":150,"preselect-first":true,"hide-selected":true,"show-labels":false},on:{"select":_vm.setOptions,"remove":_vm.removeChildOptions,"close":_vm.dropdownClose},model:{value:(selectItem.selectedValue),callback:function ($$v) {_vm.$set(selectItem, "selectedValue", $$v)},expression:"selectItem.selectedValue"}})],1)}),1)],1)],1)})],2)}
var staticRenderFns = []


/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-collapse',{staticClass:"m-2",attrs:{"id":"filter-pane-collapse"},on:{"hidden":_vm.emitReloadData}},[_c('div',{staticClass:"border bg-white",style:(_vm.style)},[_c('b-card',{staticClass:"border-0"},[_c('div',[_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"ml-auto"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.filter-pane-collapse",modifiers:{"filter-pane-collapse":true}}],attrs:{"variant":"info"}},[_vm._v("\n                Filtrar\n              ")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"warning"},on:{"click":_vm.resetFilters}},[_vm._v("\n                Limpiar Filtros\n              ")])],1)])]),_vm._v(" "),_c('b-container',{staticClass:"m-0",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('FilterSelectorLogic',{ref:"filterSelectorLogicP",attrs:{"filter-data":_vm.originalProductFilters,"filter-type":"product_filters","filter-type-name":"Filtro atributos de productos"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('FilterSelectorLogic',{ref:"filterSelectorLogicS",attrs:{"filter-data":_vm.originalStoreFilters,"filter-type":"store_filters","filter-type-name":"Filtro de Tiendas"}})],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"height":"10px"}})],1)],1)])],1)}
var staticRenderFns = []


/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(655);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd492b56_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1095)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dd492b56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd492b56_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd492b56_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1095 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServerDataToExcel_vue__ = __webpack_require__(656);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_819257d4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServerDataToExcel_vue__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1097)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-819257d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServerDataToExcel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_819257d4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServerDataToExcel_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_819257d4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServerDataToExcel_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1097 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{on:{"click":_vm.downloadFile}},[_vm._v("Excel")])],1)}
var staticRenderFns = []


/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"p-2"},[_c('b-col',{staticClass:"mr-auto",attrs:{"cols":"auto"}},[_c('h4',{staticClass:"mb-0 mt-1"},[_vm._v(_vm._s(_vm.propsHeaderTitle))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.propsHeaderInfo))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"auto"}},[_c('div',{staticClass:"d-inline-flex"},[_c('ServerDataToExcel',{attrs:{"parameters":_vm.propsExcelParameters}})],1)])],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loading',{attrs:{"active":_vm.isLoading,"loader":"dots","color":"blue","opacity":0.6,"is-full-page":true},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('FilterPane',{attrs:{"height":_vm.vuexAvailableHeight - 190}}),_vm._v(" "),_c('b-card',{staticClass:"mb-0",attrs:{"border-variant":"light","no-body":""}},[_c('Header',{attrs:{"header-info":_vm.headerInfo,"header-title":_vm.childHeaderTitle,"excel-parameters":_vm.childExcelParameters}}),_vm._v(" "),_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"cols":"2"}},[_c('RetailListSelector')],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"10"}},[_c('DimensionFilter'),_vm._v(" "),_c('GridMetricSystemWideOneMetric',{attrs:{"grid-height":_vm.vuexAvailableHeight}})],1)],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal-gkka","ok-only":true},on:{"ok":_vm.openFilterPaneForUser}},[_c('div',{staticClass:"d-block"},[_vm._v("No existen datos")])])],1)],1)}
var staticRenderFns = []


/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var MassiveDownloadRoutes = [{
  path: '/massive-download',
  name: 'MassiveDownload',
  component: function component() {
    return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 1319));
  },
  redirect: '/massive-download/',
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 1320));
    }
  }, {
    path: 'new-report',
    name: 'newReport',
    component: function component() {
      return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1321));
    }
  }, {
    path: 'favourites',
    name: 'favouriteConfigList',
    component: function component() {
      return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 1322));
    }
  }]
}];
/* harmony default export */ __webpack_exports__["a"] = (MassiveDownloadRoutes);

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Routes = [{
  path: '/sales-analysis',
  name: 'salesAnalysis',
  component: function component() {
    return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 1323));
  },
  redirect: '/sales-analysis/',
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 1324));
    },
    name: 'index',
    redirect: '/sales-analysis/long-grid/',
    children: [{
      path: 'long-grid',
      name: 'long-grid',
      component: function component() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1325));
      }
    }, {
      path: 'wide-grid',
      name: 'wide-grid',
      component: function component() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1326));
      }
    }]
  }, {
    path: 'dates-granularity',
    component: function component() {
      return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 1327));
    },
    name: 'datesGranularity',
    redirect: '/sales-analysis/dates-granularity/daily/',
    children: [{
      path: 'daily',
      name: 'datesGranularityDaily',
      component: function component() {
        return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 1328));
      },
      redirect: '/sales-analysis/dates-granularity/daily/weekly-aggregation',
      children: [{
        path: 'weekly-aggregation',
        name: 'datesGranularityDailyWeeklyAggregation',
        component: function component() {
          return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1329));
        }
      }, {
        path: 'extended',
        name: 'datesGranularityDailyExtended',
        component: function component() {
          return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1330));
        }
      }]
    }]
  }]
}];
/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Routes = [{
  path: '/store-growth',
  name: 'storeGrowth',
  component: function component() {
    return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 1331));
  },
  redirect: '/store-growth/stores-without-growth',
  meta: {
    requiresAuth: true
  },
  children: [{
    path: 'stores-without-growth',
    component: function component() {
      return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1332));
    },
    name: 'storesWithoutGrowth'
  }, {
    path: 'stores-without-growth/:storeId',
    component: function component() {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1333));
    },
    name: 'storesWithoutGrowthDetail',
    props: function props(route) {
      return _objectSpread(_objectSpread({}, route.params), {}, {
        storeId: parseInt(route.params.storeId)
      });
    }
  }]
}];
/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Routes = [{
  path: '/stock-break',
  name: 'stockBreak',
  component: function component() {
    return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 1334));
  },
  redirect: '/stock-break/',
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '/',
    component: function component() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1335));
    },
    name: 'stockBreakIndex'
  }]
}];
/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Routes = [{
  path: '/weekly-sales',
  name: 'WeeklySales',
  component: function component() {
    return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1336));
  },
  redirect: '/weekly-sales/',
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '/weekly-sales/',
    component: function component() {
      return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1337));
    },
    name: 'Index',
    redirect: '/weekly-sales/annual-comparative',
    children: [{
      path: 'annual-comparative',
      component: function component() {
        return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1338));
      },
      name: 'AnnualComparative'
    }, {
      path: 'weekly-comparative',
      component: function component() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1339));
      },
      name: 'WeeklyComparative'
    }]
  }, {
    path: 'annual-comparative/week/:year/:week',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1340));
    },
    name: 'WeeklyDetailGrid',
    props: function props(route) {
      return {
        week: route.params.week,
        year: parseInt(route.params.year)
      };
    }
  }]
}];
/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Routes = [{
  path: '/admin',
  name: 'admin',
  component: function component() {
    return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, 1341));
  },
  redirect: '/admin/',
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 1342));
    }
  }, {
    path: 'load-status',
    name: 'loadStatus',
    component: function component() {
      return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1343));
    }
  }, {
    path: 'material-management',
    name: 'materialManagement',
    component: function component() {
      return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 1344));
    },
    children: [{
      path: 'default',
      name: 'MaterialManagementDefault',
      component: function component() {
        return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 1345));
      }
    }, {
      path: 'legacy',
      name: 'materialManagementLegacy',
      component: function component() {
        return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 739));
      }
    }]
  }, {
    path: 'users-management',
    name: 'usersManagement',
    component: {
      name: 'usersManagement',
      render: function render(c) {
        return c('router-view');
      }
    },
    redirect: '/admin/users-management/',
    children: [{
      path: '',
      component: function component() {
        return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1346));
      }
    }, {
      path: 'user/:id',
      name: 'UserDetail',
      component: function component() {
        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 740));
      },
      props: true
    }, {
      path: 'create',
      name: 'UserCreate',
      component: function component() {
        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 740));
      },
      props: {
        id: 'new'
      }
    }]
  }, {
    path: 'security-policies',
    name: 'securityPolicies',
    component: function component() {
      return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1318));
    },
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  }, {
    path: 'categories-management',
    name: 'categoriesManagement',
    component: function component() {
      return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 1347));
    }
  }, {
    path: 'b2b-credential-update',
    name: 'B2BCredentialUpdate',
    component: function component() {
      return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 1348));
    }
  }, {
    path: 'price-master',
    name: 'PriceMaster',
    component: function component() {
      return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 1349));
    },
    props: true
  }, {
    path: 'client-dynamic-master',
    name: 'clientDynamicMaster',
    component: function component() {
      return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1350));
    },
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  }, {
    path: 'global-custom-metric-name',
    name: 'globalCustomMetricName',
    component: function component() {
      return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 1351));
    },
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  }, {
    path: 'api-bridge',
    name: 'apiBridge',
    component: function component() {
      return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 1352));
    },
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  }, {
    path: 'security-policies-documentation',
    name: 'securityPoliciesDocumentation',
    component: function component() {
      return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 1353));
    },
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  }, {
    path: 'user-activity-log',
    name: 'userActivityLog',
    component: function component() {
      return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 1354));
    },
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  }, {
    path: 'sso-config',
    name: 'ssoConfig',
    component: function component() {
      return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 1355));
    },
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  }, {
    path: 'terms-acceptance',
    name: 'clientTermsAcceptance',
    component: function component() {
      return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 1356));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'mobile-app-config',
    name: 'mobileAppConfig',
    component: function component() {
      return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1357));
    },
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  }, {
    path: 'mercadolibre-integration',
    name: 'mercadolibreIntegration',
    component: function component() {
      return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 1358));
    },
    meta: {
      requiresAuth: true
    }
  }]
}];
/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Routes = [{
  path: '/login',
  name: 'Login',
  meta: {
    noNeedDefaultData: true
  },
  component: {
    render: function render(c) {
      return c('router-view');
    }
  },
  redirect: '/login/',
  children: [{
    path: '/',
    name: 'login',
    component: function component() {
      return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1359));
    }
  }, {
    path: 'saml',
    name: 'samlLogin',
    meta: {
      noNeedDefaultData: true
    },
    component: function component() {
      return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 1360));
    }
  }]
}, {
  path: '/auth',
  name: 'Authentication',
  meta: {
    noNeedDefaultData: true
  },
  component: {
    render: function render(c) {
      return c('router-view');
    }
  },
  children: [{
    path: 'reset-password/:token',
    name: 'resetPassword',
    component: function component() {
      return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1361));
    },
    props: true
  }, {
    path: 'request-new-password',
    name: 'requestNewPassword',
    component: function component() {
      return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 1362));
    }
  }, {
    path: 'region-selection',
    name: 'regionSelection',
    component: function component() {
      return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 1363));
    },
    props: true
  }, {
    path: 'google-callback',
    name: 'googleCallback',
    meta: {
      noNeedDefaultData: true
    },
    component: function component() {
      return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 741));
    }
  }, {
    path: 'microsoft-callback',
    name: 'microsoftCallback',
    meta: {
      noNeedDefaultData: true
    },
    component: function component() {
      return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 741));
    }
  }]
}, {
  path: '/saml-callback',
  name: 'samlCallback',
  meta: {
    noNeedDefaultData: true
  },
  component: function component() {
    return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 1364));
  }
}];
/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Routes = [{
  path: '/monthly-sales',
  name: 'MonthlySales',
  component: function component() {
    return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 1365));
  },
  redirect: '/monthly-sales/',
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1366));
    }
  }]
}];
/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Routes = [{
  path: '/daily-sales',
  name: 'DailySales',
  component: function component() {
    return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 1367));
  },
  redirect: {
    name: 'DailyTrend'
  },
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '',
    name: 'DailySalesIndex',
    component: function component() {
      return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1368));
    },
    redirect: {
      name: 'DailyTrend'
    },
    children: [{
      path: 'daily-trend',
      name: 'DailyTrend',
      component: function component() {
        return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1369));
      }
    }]
  }, {
    path: 'day/:date',
    name: 'DailyDetailGrid',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1370));
    },
    props: true
  }]
}];
/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Routes = [{
  path: '/workspaces',
  name: 'workspaces',
  component: function component() {
    return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 1371));
  },
  redirect: '/workspaces/',
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1372));
    }
  }, {
    path: 'new',
    name: 'newWorkspace',
    component: function component() {
      return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1373));
    }
  }, {
    path: ':workspaceId',
    name: 'updateWorkspace',
    component: function component() {
      return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1374));
    },
    props: true
  }]
}];
/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Routes = [{
  path: '/activations',
  name: 'Activations',
  component: function component() {
    return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, 1375));
  },
  redirect: '/activations/',
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1376));
    }
  }, {
    path: 'new',
    name: 'NewActivation',
    component: function component() {
      return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1377));
    }
  }, {
    path: ':activationId',
    name: 'ActivationDetail',
    component: function component() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1378));
    },
    props: true
  }]
}];
/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Routes = [{
  path: '/purchase_orders',
  name: 'PurchaseOrders',
  component: function component() {
    return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 1379));
  },
  redirect: '/purchase_orders/',
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1380));
    }
  }]
}, {
  path: '/comercionet_purchase_orders',
  name: 'ComercionetPurchaseOrders',
  component: function component() {
    return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1381));
  }
}];
/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Routes = [{
  path: '/product-follow-up',
  name: 'ProductFollowUp',
  component: function component() {
    return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 1382));
  },
  redirect: '/product-follow-up/',
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1383));
    }
  }]
}];
/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Routes = [{
  path: '/merchants',
  name: 'Merchants',
  component: function component() {
    return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, 1384));
  },
  redirect: '/merchants/',
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1385));
    }
  }, {
    path: 'merchant',
    name: 'Merchant',
    component: function component() {
      return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 1386));
    }
  }]
}];
/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Routes = [{
  path: '/sell_in_proposal',
  name: 'SellInProposal',
  component: function component() {
    return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 1387));
  },
  redirect: '/sell_in_proposal/',
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 1388));
    }
  }]
}];
/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Routes = [{
  path: '/sellout_dashboard',
  name: 'SelloutDashboard',
  component: function component() {
    return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 1389));
  },
  redirect: '/sellout_dashboard/',
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1390));
    }
  }]
}];
/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"v-spinner text-center mt-half"},[_c('div',{staticClass:"v-pulse v-pulse1",style:([_vm.spinnerStyle,_vm.spinnerDelay1])}),_vm._v(" "),_c('div',{staticClass:"v-pulse v-pulse2",style:([_vm.spinnerStyle,_vm.spinnerDelay2])}),_vm._v(" "),_c('div',{staticClass:"v-pulse v-pulse3",style:([_vm.spinnerStyle,_vm.spinnerDelay3])})])}
var staticRenderFns = []


/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Routes = [{
  path: '/product-master',
  name: 'ProductMaster',
  component: function component() {
    return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 1391));
  },
  redirect: '/product-master/',
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1392));
    }
  }, {
    path: 'legacy',
    name: 'materialManagementLegacy',
    component: function component() {
      return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 739));
    }
  }, {
    path: 'create',
    name: 'createProducts',
    component: function component() {
      return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 1393));
    }
  }]
}];
/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Routes = [{
  path: '/user-api',
  name: 'UserApi',
  component: function component() {
    return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 1394));
  },
  redirect: '/user-api/',
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 1395));
    },
    name: 'UserApiIndex'
  }]
}];
/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Routes = [{
  path: '/price-campaigns',
  name: 'PriceCampaigns',
  component: function component() {
    return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1396));
  },
  meta: {
    requiresAuth: true
  }
}];
/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Routes = [{
  path: '/physical-stock-counts',
  name: 'PhysicalStockCounts',
  component: function component() {
    return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1397));
  },
  meta: {
    requiresAuth: true
  }
}];
/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Routes = [{
  path: '/route-planning',
  name: 'RoutePlanning',
  component: function component() {
    return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 1398));
  },
  redirect: '/route-planning/',
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1399));
    }
  }]
}];
/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__ = __webpack_require__(658);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af2ddc22_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af2ddc22_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af2ddc22_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"clearfix"},[_c('h1',{staticClass:"float-left display-3 mr-4"},[_vm._v("404")]),_vm._v(" "),_c('h4',{staticClass:"pt-3"},[_vm._v("Oops! You're lost.")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("The page you are looking for was not found.")])]),_vm._v(" "),_c('b-input-group',[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-search"})])]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"prependedInput","size":"16","type":"text","placeholder":"What are you looking for?"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-button',{attrs:{"variant":"info"}},[_vm._v("Search")])],1)])],1)],1)],1)])}
var staticRenderFns = []


/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnderMaintenance_vue__ = __webpack_require__(659);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_414d8835_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnderMaintenance_vue__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnderMaintenance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_414d8835_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnderMaintenance_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_414d8835_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnderMaintenance_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"md":"2"}},[_c('b-img',{attrs:{"src":"/static/img/tools.png","fluid":""}})],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"clearfix"},[_c('h4',{staticClass:"pt-3"},[_vm._v("En mantenimiento")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Nuestros sistemas se encontrarán disponibles en las próximas horas")])])])],1)],1)])}
var staticRenderFns = []


/***/ }),
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PulseLoader_vue__ = __webpack_require__(662);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7dc0198c_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_PulseLoader_vue__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1149)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PulseLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7dc0198c_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_PulseLoader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7dc0198c_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_PulseLoader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"v-spinner"},[_c('div',{staticClass:"v-pulse v-pulse1",style:([_vm.spinnerStyle,_vm.spinnerDelay1])}),_c('div',{staticClass:"v-pulse v-pulse2",style:([_vm.spinnerStyle,_vm.spinnerDelay2])}),_c('div',{staticClass:"v-pulse v-pulse3",style:([_vm.spinnerStyle,_vm.spinnerDelay3])})])}
var staticRenderFns = []


/***/ }),
/* 1151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1152 */,
/* 1153 */,
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export filterUnits */
/* unused harmony export filterUnitsExtended */
/* unused harmony export filterPesos */
/* unused harmony export filterPesosExtended */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugin_CustomNumeral__ = __webpack_require__(663);


var filterUnits = function filterUnits(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__plugin_CustomNumeral__["a" /* default */])(value).format('0,00 a');
};
var filterUnitsExtended = function filterUnitsExtended(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__plugin_CustomNumeral__["a" /* default */])(value).format('0,00');
};
var filterPesos = function filterPesos(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__plugin_CustomNumeral__["a" /* default */])(value).format('$0,00 a');
};
var filterPesosExtended = function filterPesosExtended(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__plugin_CustomNumeral__["a" /* default */])(value).format('$0,00');
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('money', function (value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__plugin_CustomNumeral__["a" /* default */])(value).format('$ 0.00 a');
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('number', function (value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__plugin_CustomNumeral__["a" /* default */])(value).format('0,0');
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('numberAbb', function (value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__plugin_CustomNumeral__["a" /* default */])(value).format('0.0a');
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('percentage', function (value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__plugin_CustomNumeral__["a" /* default */])(value).format('0%');
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('decimalMoney', function (value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__plugin_CustomNumeral__["a" /* default */])(value).format('$0,00');
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('numberFormat', function (value, formatType) {
  if (formatType === 'PESOS') {
    return Object(__WEBPACK_IMPORTED_MODULE_1__plugin_CustomNumeral__["a" /* default */])(value).format('$0,00 a');
  } else if (formatType === 'UNITS') {
    return Object(__WEBPACK_IMPORTED_MODULE_1__plugin_CustomNumeral__["a" /* default */])(value).format(' 0');
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('units', filterUnits);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('pesos', filterPesos);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('pesos_extended', filterPesosExtended);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('units_extended', filterUnitsExtended);

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_miragejs__ = __webpack_require__(1156);

/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  var environment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'test';
  return new __WEBPACK_IMPORTED_MODULE_0_miragejs__["b" /* Server */]({
    serializers: {
      application: __WEBPACK_IMPORTED_MODULE_0_miragejs__["a" /* Serializer */].extend({
        root: false,
        embed: true
      })
    },
    environment: environment,
    models: {},
    factories: {},
    seeds: function seeds() {},
    routes: function routes() {
      this.urlPrefix = Object({"NODE_ENV":"production","API_LAMBDA_URL":"https://api.expertoretail.com/v1","API_ER_ADMIN_DATA_URL":"https://4xjrts6rn8.execute-api.sa-east-1.amazonaws.com/production/v1","API_BACKGROUND_TASKS_URL":"https://backgroundtasks.expertoretail.com/v1","APP_VERSION":"v3.55.0","GOOGLE_MAPS_API_KEY":"AIzaSyAmPsVI3zfFXbyVcoB1qDSpXGg6lBHGUZM","MAPBOX_ACCESS_TOKEN":"pk.eyJ1IjoiZXItZGF2aWQtZGV2IiwiYSI6ImNtbjlqNHZxbzA5YjcycW9seHZlenp2MHgifQ.kAgFyWPE1EzOZjD4bN42DA"}).API_URL;
      this.passthrough();
    }
  });
});

/***/ }),
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []


/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1303)
}
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []


/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
function injectStyle (context) {
  __webpack_require__(1306)
}
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []


/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(7);
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1311 */,
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []


/***/ }),
/* 1313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1316 */,
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(711)(true);
// imports


// module
exports.push([module.i, "fieldset[disabled] .multiselect{pointer-events:none}.multiselect__spinner{position:absolute;right:1px;top:1px;width:48px;height:35px;background:#fff;display:block}.multiselect__spinner:after,.multiselect__spinner:before{position:absolute;content:\"\";top:50%;left:50%;margin:-8px 0 0 -8px;width:16px;height:16px;border-radius:100%;border-color:#41b883 transparent transparent;border-style:solid;border-width:2px;box-shadow:0 0 0 1px transparent}.multiselect__spinner:before{animation:a 2.4s cubic-bezier(.41,.26,.2,.62);animation-iteration-count:infinite}.multiselect__spinner:after{animation:a 2.4s cubic-bezier(.51,.09,.21,.8);animation-iteration-count:infinite}.multiselect__loading-enter-active,.multiselect__loading-leave-active{transition:opacity .4s ease-in-out;opacity:1}.multiselect__loading-enter,.multiselect__loading-leave-active{opacity:0}.multiselect,.multiselect__input,.multiselect__single{font-family:inherit;font-size:14px;-ms-touch-action:manipulation;touch-action:manipulation}.multiselect{box-sizing:content-box;display:block;position:relative;width:100%;min-height:40px;text-align:left;color:#35495e}.multiselect *{box-sizing:border-box}.multiselect:focus{outline:none}.multiselect--disabled{opacity:.6}.multiselect--active{z-index:1}.multiselect--active:not(.multiselect--above) .multiselect__current,.multiselect--active:not(.multiselect--above) .multiselect__input,.multiselect--active:not(.multiselect--above) .multiselect__tags{border-bottom-left-radius:0;border-bottom-right-radius:0}.multiselect--active .multiselect__select{transform:rotate(180deg)}.multiselect--above.multiselect--active .multiselect__current,.multiselect--above.multiselect--active .multiselect__input,.multiselect--above.multiselect--active .multiselect__tags{border-top-left-radius:0;border-top-right-radius:0}.multiselect__input,.multiselect__single{position:relative;display:inline-block;min-height:20px;line-height:20px;border:none;border-radius:5px;background:#fff;padding:0 0 0 5px;width:100%;transition:border .1s ease;box-sizing:border-box;margin-bottom:8px;vertical-align:top}.multiselect__tag~.multiselect__input,.multiselect__tag~.multiselect__single{width:auto}.multiselect__input:hover,.multiselect__single:hover{border-color:#cfcfcf}.multiselect__input:focus,.multiselect__single:focus{border-color:#a8a8a8;outline:none}.multiselect__single{padding-left:6px;margin-bottom:8px}.multiselect__tags-wrap{display:inline}.multiselect__tags{min-height:40px;display:block;padding:8px 40px 0 8px;border-radius:5px;border:1px solid #e8e8e8;background:#fff}.multiselect__tag{position:relative;display:inline-block;padding:4px 26px 4px 10px;border-radius:5px;margin-right:10px;color:#fff;line-height:1;background:#41b883;margin-bottom:5px;white-space:nowrap;overflow:hidden;max-width:100%;text-overflow:ellipsis}.multiselect__tag-icon{cursor:pointer;margin-left:7px;position:absolute;right:0;top:0;bottom:0;font-weight:700;font-style:normal;width:22px;text-align:center;line-height:22px;transition:all .2s ease;border-radius:5px}.multiselect__tag-icon:after{content:\"\\D7\";color:#266d4d;font-size:14px}.multiselect__tag-icon:focus,.multiselect__tag-icon:hover{background:#369a6e}.multiselect__tag-icon:focus:after,.multiselect__tag-icon:hover:after{color:#fff}.multiselect__current{min-height:40px;overflow:hidden;padding:8px 12px 0;padding-right:30px;white-space:nowrap;border-radius:5px;border:1px solid #e8e8e8}.multiselect__current,.multiselect__select{line-height:16px;box-sizing:border-box;display:block;margin:0;text-decoration:none;cursor:pointer}.multiselect__select{position:absolute;width:40px;height:38px;right:1px;top:1px;padding:4px 8px;text-align:center;transition:transform .2s ease}.multiselect__select:before{position:relative;right:0;top:65%;color:#999;margin-top:4px;border-style:solid;border-width:5px 5px 0;border-color:#999 transparent transparent;content:\"\"}.multiselect__placeholder{color:#adadad;display:inline-block;margin-bottom:10px;padding-top:2px}.multiselect--active .multiselect__placeholder{display:none}.multiselect__content-wrapper{position:absolute;display:block;background:#fff;width:100%;max-height:240px;overflow:auto;border:1px solid #e8e8e8;border-top:none;border-bottom-left-radius:5px;border-bottom-right-radius:5px;z-index:1;-webkit-overflow-scrolling:touch}.multiselect__content{list-style:none;display:inline-block;padding:0;margin:0;min-width:100%;vertical-align:top}.multiselect--above .multiselect__content-wrapper{bottom:100%;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:5px;border-top-right-radius:5px;border-bottom:none;border-top:1px solid #e8e8e8}.multiselect__content::webkit-scrollbar{display:none}.multiselect__element{display:block}.multiselect__option{display:block;padding:12px;min-height:40px;line-height:16px;text-decoration:none;text-transform:none;vertical-align:middle;position:relative;cursor:pointer;white-space:nowrap}.multiselect__option:after{top:0;right:0;position:absolute;line-height:40px;padding-right:12px;padding-left:20px}.multiselect__option--highlight{background:#41b883;outline:none;color:#fff}.multiselect__option--highlight:after{content:attr(data-select);background:#41b883;color:#fff}.multiselect__option--selected{background:#f3f3f3;color:#35495e;font-weight:700}.multiselect__option--selected:after{content:attr(data-selected);color:silver}.multiselect__option--selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect--disabled{background:#ededed;pointer-events:none}.multiselect--disabled .multiselect__current,.multiselect--disabled .multiselect__select,.multiselect__option--disabled{background:#ededed;color:#a6a6a6}.multiselect__option--disabled{cursor:text;pointer-events:none}.multiselect__option--disabled.multiselect__option--highlight{background:#dedede!important}.multiselect-enter-active,.multiselect-leave-active{transition:all .15s ease}.multiselect-enter,.multiselect-leave-active{opacity:0}.multiselect__strong{margin-bottom:8px;line-height:20px;display:inline-block;vertical-align:top}[dir=rtl] .multiselect{text-align:right}[dir=rtl] .multiselect__select{right:auto;left:1px}[dir=rtl] .multiselect__tags{padding:8px 8px 0 40px}[dir=rtl] .multiselect__content{text-align:right}[dir=rtl] .multiselect__option:after{right:auto;left:0}[dir=rtl] .multiselect__clear{right:auto;left:12px}[dir=rtl] .multiselect__spinner{right:auto;left:1px}@keyframes a{0%{transform:rotate(0)}to{transform:rotate(2turn)}}", "", {"version":3,"sources":["/home/runner/work/er-desktop/er-desktop/node_modules/vue-multiselect/dist/vue-multiselect.min.css"],"names":[],"mappings":"AAAA,gCAAgC,mBAAmB,CAAC,sBAAsB,kBAAkB,UAAU,QAAQ,WAAW,YAAY,gBAAgB,aAAa,CAAC,yDAAyD,kBAAkB,WAAW,QAAQ,SAAS,qBAAqB,WAAW,YAAY,mBAAmB,6CAA6C,mBAAmB,iBAAiB,gCAAgC,CAAC,6BAA6B,8CAA8C,kCAAkC,CAAC,4BAA4B,8CAA8C,kCAAkC,CAAC,sEAAsE,mCAAmC,SAAS,CAAC,+DAA+D,SAAS,CAAC,sDAAsD,oBAAoB,eAAe,8BAA8B,yBAAyB,CAAC,aAAa,uBAAuB,cAAc,kBAAkB,WAAW,gBAAgB,gBAAgB,aAAa,CAAC,eAAe,qBAAqB,CAAC,mBAAmB,YAAY,CAAC,uBAAuB,UAAU,CAAC,qBAAqB,SAAS,CAAC,uMAAuM,4BAA4B,4BAA4B,CAAC,0CAA0C,wBAAwB,CAAC,qLAAqL,yBAAyB,yBAAyB,CAAC,yCAAyC,kBAAkB,qBAAqB,gBAAgB,iBAAiB,YAAY,kBAAkB,gBAAgB,kBAAkB,WAAW,2BAA2B,sBAAsB,kBAAkB,kBAAkB,CAAC,6EAA6E,UAAU,CAAC,qDAAqD,oBAAoB,CAAC,qDAAqD,qBAAqB,YAAY,CAAC,qBAAqB,iBAAiB,iBAAiB,CAAC,wBAAwB,cAAc,CAAC,mBAAmB,gBAAgB,cAAc,uBAAuB,kBAAkB,yBAAyB,eAAe,CAAC,kBAAkB,kBAAkB,qBAAqB,0BAA0B,kBAAkB,kBAAkB,WAAW,cAAc,mBAAmB,kBAAkB,mBAAmB,gBAAgB,eAAe,sBAAsB,CAAC,uBAAuB,eAAe,gBAAgB,kBAAkB,QAAQ,MAAM,SAAS,gBAAgB,kBAAkB,WAAW,kBAAkB,iBAAiB,wBAAwB,iBAAiB,CAAC,6BAA6B,cAAc,cAAc,cAAc,CAAC,0DAA0D,kBAAkB,CAAC,sEAAsE,UAAU,CAAC,sBAAsB,gBAAgB,gBAAgB,mBAAmB,mBAAmB,mBAAmB,kBAAkB,wBAAwB,CAAC,2CAA2C,iBAAiB,sBAAsB,cAAc,SAAS,qBAAqB,cAAc,CAAC,qBAAqB,kBAAkB,WAAW,YAAY,UAAU,QAAQ,gBAAgB,kBAAkB,6BAA6B,CAAC,4BAA4B,kBAAkB,QAAQ,QAAQ,WAAW,eAAe,mBAAmB,uBAAuB,0CAA0C,UAAU,CAAC,0BAA0B,cAAc,qBAAqB,mBAAmB,eAAe,CAAC,+CAA+C,YAAY,CAAC,8BAA8B,kBAAkB,cAAc,gBAAgB,WAAW,iBAAiB,cAAc,yBAAyB,gBAAgB,8BAA8B,+BAA+B,UAAU,gCAAgC,CAAC,sBAAsB,gBAAgB,qBAAqB,UAAU,SAAS,eAAe,kBAAkB,CAAC,kDAAkD,YAAY,4BAA4B,6BAA6B,2BAA2B,4BAA4B,mBAAmB,4BAA4B,CAAC,wCAAwC,YAAY,CAAC,sBAAsB,aAAa,CAAC,qBAAqB,cAAc,aAAa,gBAAgB,iBAAiB,qBAAqB,oBAAoB,sBAAsB,kBAAkB,eAAe,kBAAkB,CAAC,2BAA2B,MAAM,QAAQ,kBAAkB,iBAAiB,mBAAmB,iBAAiB,CAAC,gCAAgC,mBAAmB,aAAa,UAAU,CAAC,sCAAsC,0BAA0B,mBAAmB,UAAU,CAAC,+BAA+B,mBAAmB,cAAc,eAAe,CAAC,qCAAqC,4BAA4B,YAAY,CAAC,8DAA8D,mBAAmB,UAAU,CAAC,oEAAoE,mBAAmB,4BAA4B,UAAU,CAAC,uBAAuB,mBAAmB,mBAAmB,CAAC,wHAAwH,mBAAmB,aAAa,CAAC,+BAA+B,YAAY,mBAAmB,CAAC,8DAA8D,4BAA4B,CAAC,oDAAoD,wBAAwB,CAAC,6CAA6C,SAAS,CAAC,qBAAqB,kBAAkB,iBAAiB,qBAAqB,kBAAkB,CAAC,uBAAuB,gBAAgB,CAAC,+BAA+B,WAAW,QAAQ,CAAC,6BAA6B,sBAAsB,CAAC,gCAAgC,gBAAgB,CAAC,qCAAqC,WAAW,MAAM,CAAC,8BAA8B,WAAW,SAAS,CAAC,gCAAgC,WAAW,QAAQ,CAAC,aAAa,GAAG,mBAAmB,CAAC,GAAG,uBAAuB,CAAC,CAAC","file":"vue-multiselect.min.css","sourcesContent":["fieldset[disabled] .multiselect{pointer-events:none}.multiselect__spinner{position:absolute;right:1px;top:1px;width:48px;height:35px;background:#fff;display:block}.multiselect__spinner:after,.multiselect__spinner:before{position:absolute;content:\"\";top:50%;left:50%;margin:-8px 0 0 -8px;width:16px;height:16px;border-radius:100%;border-color:#41b883 transparent transparent;border-style:solid;border-width:2px;box-shadow:0 0 0 1px transparent}.multiselect__spinner:before{animation:a 2.4s cubic-bezier(.41,.26,.2,.62);animation-iteration-count:infinite}.multiselect__spinner:after{animation:a 2.4s cubic-bezier(.51,.09,.21,.8);animation-iteration-count:infinite}.multiselect__loading-enter-active,.multiselect__loading-leave-active{transition:opacity .4s ease-in-out;opacity:1}.multiselect__loading-enter,.multiselect__loading-leave-active{opacity:0}.multiselect,.multiselect__input,.multiselect__single{font-family:inherit;font-size:14px;-ms-touch-action:manipulation;touch-action:manipulation}.multiselect{box-sizing:content-box;display:block;position:relative;width:100%;min-height:40px;text-align:left;color:#35495e}.multiselect *{box-sizing:border-box}.multiselect:focus{outline:none}.multiselect--disabled{opacity:.6}.multiselect--active{z-index:1}.multiselect--active:not(.multiselect--above) .multiselect__current,.multiselect--active:not(.multiselect--above) .multiselect__input,.multiselect--active:not(.multiselect--above) .multiselect__tags{border-bottom-left-radius:0;border-bottom-right-radius:0}.multiselect--active .multiselect__select{transform:rotate(180deg)}.multiselect--above.multiselect--active .multiselect__current,.multiselect--above.multiselect--active .multiselect__input,.multiselect--above.multiselect--active .multiselect__tags{border-top-left-radius:0;border-top-right-radius:0}.multiselect__input,.multiselect__single{position:relative;display:inline-block;min-height:20px;line-height:20px;border:none;border-radius:5px;background:#fff;padding:0 0 0 5px;width:100%;transition:border .1s ease;box-sizing:border-box;margin-bottom:8px;vertical-align:top}.multiselect__tag~.multiselect__input,.multiselect__tag~.multiselect__single{width:auto}.multiselect__input:hover,.multiselect__single:hover{border-color:#cfcfcf}.multiselect__input:focus,.multiselect__single:focus{border-color:#a8a8a8;outline:none}.multiselect__single{padding-left:6px;margin-bottom:8px}.multiselect__tags-wrap{display:inline}.multiselect__tags{min-height:40px;display:block;padding:8px 40px 0 8px;border-radius:5px;border:1px solid #e8e8e8;background:#fff}.multiselect__tag{position:relative;display:inline-block;padding:4px 26px 4px 10px;border-radius:5px;margin-right:10px;color:#fff;line-height:1;background:#41b883;margin-bottom:5px;white-space:nowrap;overflow:hidden;max-width:100%;text-overflow:ellipsis}.multiselect__tag-icon{cursor:pointer;margin-left:7px;position:absolute;right:0;top:0;bottom:0;font-weight:700;font-style:normal;width:22px;text-align:center;line-height:22px;transition:all .2s ease;border-radius:5px}.multiselect__tag-icon:after{content:\"\\D7\";color:#266d4d;font-size:14px}.multiselect__tag-icon:focus,.multiselect__tag-icon:hover{background:#369a6e}.multiselect__tag-icon:focus:after,.multiselect__tag-icon:hover:after{color:#fff}.multiselect__current{min-height:40px;overflow:hidden;padding:8px 12px 0;padding-right:30px;white-space:nowrap;border-radius:5px;border:1px solid #e8e8e8}.multiselect__current,.multiselect__select{line-height:16px;box-sizing:border-box;display:block;margin:0;text-decoration:none;cursor:pointer}.multiselect__select{position:absolute;width:40px;height:38px;right:1px;top:1px;padding:4px 8px;text-align:center;transition:transform .2s ease}.multiselect__select:before{position:relative;right:0;top:65%;color:#999;margin-top:4px;border-style:solid;border-width:5px 5px 0;border-color:#999 transparent transparent;content:\"\"}.multiselect__placeholder{color:#adadad;display:inline-block;margin-bottom:10px;padding-top:2px}.multiselect--active .multiselect__placeholder{display:none}.multiselect__content-wrapper{position:absolute;display:block;background:#fff;width:100%;max-height:240px;overflow:auto;border:1px solid #e8e8e8;border-top:none;border-bottom-left-radius:5px;border-bottom-right-radius:5px;z-index:1;-webkit-overflow-scrolling:touch}.multiselect__content{list-style:none;display:inline-block;padding:0;margin:0;min-width:100%;vertical-align:top}.multiselect--above .multiselect__content-wrapper{bottom:100%;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:5px;border-top-right-radius:5px;border-bottom:none;border-top:1px solid #e8e8e8}.multiselect__content::webkit-scrollbar{display:none}.multiselect__element{display:block}.multiselect__option{display:block;padding:12px;min-height:40px;line-height:16px;text-decoration:none;text-transform:none;vertical-align:middle;position:relative;cursor:pointer;white-space:nowrap}.multiselect__option:after{top:0;right:0;position:absolute;line-height:40px;padding-right:12px;padding-left:20px}.multiselect__option--highlight{background:#41b883;outline:none;color:#fff}.multiselect__option--highlight:after{content:attr(data-select);background:#41b883;color:#fff}.multiselect__option--selected{background:#f3f3f3;color:#35495e;font-weight:700}.multiselect__option--selected:after{content:attr(data-selected);color:silver}.multiselect__option--selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect--disabled{background:#ededed;pointer-events:none}.multiselect--disabled .multiselect__current,.multiselect--disabled .multiselect__select,.multiselect__option--disabled{background:#ededed;color:#a6a6a6}.multiselect__option--disabled{cursor:text;pointer-events:none}.multiselect__option--disabled.multiselect__option--highlight{background:#dedede!important}.multiselect-enter-active,.multiselect-leave-active{transition:all .15s ease}.multiselect-enter,.multiselect-leave-active{opacity:0}.multiselect__strong{margin-bottom:8px;line-height:20px;display:inline-block;vertical-align:top}[dir=rtl] .multiselect{text-align:right}[dir=rtl] .multiselect__select{right:auto;left:1px}[dir=rtl] .multiselect__tags{padding:8px 8px 0 40px}[dir=rtl] .multiselect__content{text-align:right}[dir=rtl] .multiselect__option:after{right:auto;left:0}[dir=rtl] .multiselect__clear{right:auto;left:12px}[dir=rtl] .multiselect__spinner{right:auto;left:1px}@keyframes a{0%{transform:rotate(0)}to{transform:rotate(2turn)}}"],"sourceRoot":""}]);

// exports


/***/ })
]),[743]);


// WEBPACK FOOTER //
// static/js/app.2a4d8994c4ea7834d848.js